/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
import {
  GrpcMessage,
  RecursivePartial,
  ToProtobufJSONOptions
} from '@ngx-grpc/common';
import { BinaryReader, BinaryWriter, ByteSource } from 'google-protobuf';
import * as googleProtobuf000 from '@ngx-grpc/well-known-types';
import * as googleProtobuf001 from '@ngx-grpc/well-known-types';
import * as googleApi002 from './google/api/http.pb';
import * as googleProtobuf003 from '@ngx-grpc/well-known-types';
import * as googleProtobuf004 from '@ngx-grpc/well-known-types';
import * as googleProtobuf005 from '@ngx-grpc/well-known-types';
import * as googleProtobuf006 from '@ngx-grpc/well-known-types';
import * as googleProtobuf007 from '@ngx-grpc/well-known-types';
import * as googleProtobuf008 from '@ngx-grpc/well-known-types';
import * as googleType009 from './google/type/latlng.pb';
import * as googleType010 from './google/type/date.pb';
import * as googleRpc011 from './google/rpc/status.pb';
import * as googleRpc012 from './google/rpc/error-details.pb';
import * as googleApi013 from './google/api/annotations.pb';
import * as googleApi014 from './google/api/field-behavior.pb';
export enum PictureItemType {
  PICTURE_ITEM_UNKNOWN = 0,
  PICTURE_ITEM_CONTENT = 1,
  PICTURE_ITEM_AUTHOR = 2,
  PICTURE_ITEM_COPYRIGHTS = 3
}
export enum ItemType {
  ITEM_TYPE_UNKNOWN = 0,
  ITEM_TYPE_VEHICLE = 1,
  ITEM_TYPE_ENGINE = 2,
  ITEM_TYPE_CATEGORY = 3,
  ITEM_TYPE_TWINS = 4,
  ITEM_TYPE_BRAND = 5,
  ITEM_TYPE_FACTORY = 6,
  ITEM_TYPE_MUSEUM = 7,
  ITEM_TYPE_PERSON = 8,
  ITEM_TYPE_COPYRIGHT = 9
}
export enum ItemParentType {
  ITEM_TYPE_DEFAULT = 0,
  ITEM_TYPE_TUNING = 1,
  ITEM_TYPE_SPORT = 2,
  ITEM_TYPE_DESIGN = 3
}
export enum PictureStatus {
  PICTURE_STATUS_UNKNOWN = 0,
  PICTURE_STATUS_ACCEPTED = 1,
  PICTURE_STATUS_REMOVING = 2,
  PICTURE_STATUS_REMOVED = 3,
  PICTURE_STATUS_INBOX = 4
}
export enum CommentsType {
  UNKNOWN = 0,
  PICTURES_TYPE_ID = 1,
  ITEM_TYPE_ID = 2,
  VOTINGS_TYPE_ID = 3,
  ARTICLES_TYPE_ID = 4,
  FORUMS_TYPE_ID = 5
}
export enum ModeratorAttention {
  NONE = 0,
  REQUIRED = 1,
  COMPLETE = 2
}
/**
 * Message implementation for goautowp.ChartDataRequest
 */
export class ChartDataRequest implements GrpcMessage {
  static id = 'goautowp.ChartDataRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ChartDataRequest();
    ChartDataRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ChartDataRequest) {
    _instance.id = _instance.id || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ChartDataRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    ChartDataRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ChartDataRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
  }

  private _id: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ChartDataRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<ChartDataRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    ChartDataRequest.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ChartDataRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ChartDataRequest.AsObject {
    return {
      id: this.id
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ChartDataRequest.AsProtobufJSON {
    return {
      id: this.id
    };
  }
}
export module ChartDataRequest {
  /**
   * Standard JavaScript object representation for ChartDataRequest
   */
  export interface AsObject {
    id: string;
  }

  /**
   * Protobuf JSON representation for ChartDataRequest
   */
  export interface AsProtobufJSON {
    id: string;
  }
}

/**
 * Message implementation for goautowp.ChartDataDataset
 */
export class ChartDataDataset implements GrpcMessage {
  static id = 'goautowp.ChartDataDataset';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ChartDataDataset();
    ChartDataDataset.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ChartDataDataset) {
    _instance.name = _instance.name || '';
    _instance.values = _instance.values || {};
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ChartDataDataset,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.name = _reader.readString();
          break;
        case 3:
          const msg_3 = {} as any;
          _reader.readMessage(
            msg_3,
            ChartDataDataset.ValuesEntry.deserializeBinaryFromReader
          );
          _instance.values = _instance.values || {};
          _instance.values[Number(msg_3.key)] = msg_3.value;
          break;
        default:
          _reader.skipField();
      }
    }

    ChartDataDataset.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ChartDataDataset,
    _writer: BinaryWriter
  ) {
    if (_instance.name) {
      _writer.writeString(1, _instance.name);
    }
    if (!!_instance.values) {
      const keys_3 = Object.keys(_instance.values as any);

      if (keys_3.length) {
        const repeated_3 = keys_3
          .map(key => ({
            key: Number(key),
            value: (_instance.values as any)[key]
          }))
          .reduce((r, v) => [...r, v], [] as any[]);

        _writer.writeRepeatedMessage(
          3,
          repeated_3,
          ChartDataDataset.ValuesEntry.serializeBinaryToWriter
        );
      }
    }
  }

  private _name: string;
  private _values: { [prop: number]: AttrValueValue };

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ChartDataDataset to deeply clone from
   */
  constructor(_value?: RecursivePartial<ChartDataDataset.AsObject>) {
    _value = _value || {};
    this.name = _value.name;
    (this.values = _value!.values
      ? Object.keys(_value!.values).reduce(
          (r, k) => ({
            ...r,
            [k]: _value!.values![k]
              ? new AttrValueValue(_value!.values![k])
              : undefined
          }),
          {}
        )
      : {}),
      ChartDataDataset.refineValues(this);
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get values(): { [prop: number]: AttrValueValue } {
    return this._values;
  }
  set values(value: { [prop: number]: AttrValueValue }) {
    this._values = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ChartDataDataset.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ChartDataDataset.AsObject {
    return {
      name: this.name,
      values: this.values
        ? Object.keys(this.values).reduce(
            (r, k) => ({
              ...r,
              [k]: this.values![k] ? this.values![k].toObject() : undefined
            }),
            {}
          )
        : {}
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ChartDataDataset.AsProtobufJSON {
    return {
      name: this.name,
      values: this.values
        ? Object.keys(this.values).reduce(
            (r, k) => ({
              ...r,
              [k]: this.values![k] ? this.values![k].toJSON() : null
            }),
            {}
          )
        : {}
    };
  }
}
export module ChartDataDataset {
  /**
   * Standard JavaScript object representation for ChartDataDataset
   */
  export interface AsObject {
    name: string;
    values: { [prop: number]: AttrValueValue };
  }

  /**
   * Protobuf JSON representation for ChartDataDataset
   */
  export interface AsProtobufJSON {
    name: string;
    values: { [prop: number]: AttrValueValue };
  }

  /**
   * Message implementation for goautowp.ChartDataDataset.ValuesEntry
   */
  export class ValuesEntry implements GrpcMessage {
    static id = 'goautowp.ChartDataDataset.ValuesEntry';

    /**
     * Deserialize binary data to message
     * @param instance message instance
     */
    static deserializeBinary(bytes: ByteSource) {
      const instance = new ValuesEntry();
      ValuesEntry.deserializeBinaryFromReader(
        instance,
        new BinaryReader(bytes)
      );
      return instance;
    }

    /**
     * Check all the properties and set default protobuf values if necessary
     * @param _instance message instance
     */
    static refineValues(_instance: ValuesEntry) {
      _instance.key = _instance.key || 0;
      _instance.value = _instance.value || undefined;
    }

    /**
     * Deserializes / reads binary message into message instance using provided binary reader
     * @param _instance message instance
     * @param _reader binary reader instance
     */
    static deserializeBinaryFromReader(
      _instance: ValuesEntry,
      _reader: BinaryReader
    ) {
      while (_reader.nextField()) {
        if (_reader.isEndGroup()) break;

        switch (_reader.getFieldNumber()) {
          case 1:
            _instance.key = _reader.readInt32();
            break;
          case 2:
            _instance.value = new AttrValueValue();
            _reader.readMessage(
              _instance.value,
              AttrValueValue.deserializeBinaryFromReader
            );
            break;
          default:
            _reader.skipField();
        }
      }

      ValuesEntry.refineValues(_instance);
    }

    /**
     * Serializes a message to binary format using provided binary reader
     * @param _instance message instance
     * @param _writer binary writer instance
     */
    static serializeBinaryToWriter(
      _instance: ValuesEntry,
      _writer: BinaryWriter
    ) {
      if (_instance.key) {
        _writer.writeInt32(1, _instance.key);
      }
      if (_instance.value) {
        _writer.writeMessage(
          2,
          _instance.value as any,
          AttrValueValue.serializeBinaryToWriter
        );
      }
    }

    private _key: number;
    private _value?: AttrValueValue;

    /**
     * Message constructor. Initializes the properties and applies default Protobuf values if necessary
     * @param _value initial values object or instance of ValuesEntry to deeply clone from
     */
    constructor(_value?: RecursivePartial<ValuesEntry.AsObject>) {
      _value = _value || {};
      this.key = _value.key;
      this.value = _value.value ? new AttrValueValue(_value.value) : undefined;
      ValuesEntry.refineValues(this);
    }
    get key(): number {
      return this._key;
    }
    set key(value: number) {
      this._key = value;
    }
    get value(): AttrValueValue | undefined {
      return this._value;
    }
    set value(value: AttrValueValue | undefined) {
      this._value = value;
    }

    /**
     * Serialize message to binary data
     * @param instance message instance
     */
    serializeBinary() {
      const writer = new BinaryWriter();
      ValuesEntry.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    }

    /**
     * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
     */
    toObject(): ValuesEntry.AsObject {
      return {
        key: this.key,
        value: this.value ? this.value.toObject() : undefined
      };
    }

    /**
     * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
     */
    toJSON() {
      return this.toObject();
    }

    /**
     * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
     * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
     * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
     */
    toProtobufJSON(
      // @ts-ignore
      options?: ToProtobufJSONOptions
    ): ValuesEntry.AsProtobufJSON {
      return {
        key: this.key,
        value: this.value ? this.value.toProtobufJSON(options) : null
      };
    }
  }
  export module ValuesEntry {
    /**
     * Standard JavaScript object representation for ValuesEntry
     */
    export interface AsObject {
      key: number;
      value?: AttrValueValue.AsObject;
    }

    /**
     * Protobuf JSON representation for ValuesEntry
     */
    export interface AsProtobufJSON {
      key: number;
      value: AttrValueValue.AsProtobufJSON | null;
    }
  }
}

/**
 * Message implementation for goautowp.ChartData
 */
export class ChartData implements GrpcMessage {
  static id = 'goautowp.ChartData';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ChartData();
    ChartData.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ChartData) {
    _instance.datasets = _instance.datasets || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ChartData,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new ChartDataDataset();
          _reader.readMessage(
            messageInitializer1,
            ChartDataDataset.deserializeBinaryFromReader
          );
          (_instance.datasets = _instance.datasets || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    ChartData.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: ChartData, _writer: BinaryWriter) {
    if (_instance.datasets && _instance.datasets.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.datasets as any,
        ChartDataDataset.serializeBinaryToWriter
      );
    }
  }

  private _datasets?: ChartDataDataset[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ChartData to deeply clone from
   */
  constructor(_value?: RecursivePartial<ChartData.AsObject>) {
    _value = _value || {};
    this.datasets = (_value.datasets || []).map(m => new ChartDataDataset(m));
    ChartData.refineValues(this);
  }
  get datasets(): ChartDataDataset[] | undefined {
    return this._datasets;
  }
  set datasets(value: ChartDataDataset[] | undefined) {
    this._datasets = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ChartData.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ChartData.AsObject {
    return {
      datasets: (this.datasets || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ChartData.AsProtobufJSON {
    return {
      datasets: (this.datasets || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module ChartData {
  /**
   * Standard JavaScript object representation for ChartData
   */
  export interface AsObject {
    datasets?: ChartDataDataset.AsObject[];
  }

  /**
   * Protobuf JSON representation for ChartData
   */
  export interface AsProtobufJSON {
    datasets: ChartDataDataset.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.ChartParameter
 */
export class ChartParameter implements GrpcMessage {
  static id = 'goautowp.ChartParameter';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ChartParameter();
    ChartParameter.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ChartParameter) {
    _instance.id = _instance.id || '0';
    _instance.name = _instance.name || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ChartParameter,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    ChartParameter.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ChartParameter,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
  }

  private _id: string;
  private _name: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ChartParameter to deeply clone from
   */
  constructor(_value?: RecursivePartial<ChartParameter.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.name = _value.name;
    ChartParameter.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ChartParameter.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ChartParameter.AsObject {
    return {
      id: this.id,
      name: this.name
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ChartParameter.AsProtobufJSON {
    return {
      id: this.id,
      name: this.name
    };
  }
}
export module ChartParameter {
  /**
   * Standard JavaScript object representation for ChartParameter
   */
  export interface AsObject {
    id: string;
    name: string;
  }

  /**
   * Protobuf JSON representation for ChartParameter
   */
  export interface AsProtobufJSON {
    id: string;
    name: string;
  }
}

/**
 * Message implementation for goautowp.ChartParameters
 */
export class ChartParameters implements GrpcMessage {
  static id = 'goautowp.ChartParameters';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ChartParameters();
    ChartParameters.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ChartParameters) {
    _instance.parameters = _instance.parameters || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ChartParameters,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new ChartParameter();
          _reader.readMessage(
            messageInitializer1,
            ChartParameter.deserializeBinaryFromReader
          );
          (_instance.parameters = _instance.parameters || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    ChartParameters.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ChartParameters,
    _writer: BinaryWriter
  ) {
    if (_instance.parameters && _instance.parameters.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.parameters as any,
        ChartParameter.serializeBinaryToWriter
      );
    }
  }

  private _parameters?: ChartParameter[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ChartParameters to deeply clone from
   */
  constructor(_value?: RecursivePartial<ChartParameters.AsObject>) {
    _value = _value || {};
    this.parameters = (_value.parameters || []).map(m => new ChartParameter(m));
    ChartParameters.refineValues(this);
  }
  get parameters(): ChartParameter[] | undefined {
    return this._parameters;
  }
  set parameters(value: ChartParameter[] | undefined) {
    this._parameters = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ChartParameters.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ChartParameters.AsObject {
    return {
      parameters: (this.parameters || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ChartParameters.AsProtobufJSON {
    return {
      parameters: (this.parameters || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module ChartParameters {
  /**
   * Standard JavaScript object representation for ChartParameters
   */
  export interface AsObject {
    parameters?: ChartParameter.AsObject[];
  }

  /**
   * Protobuf JSON representation for ChartParameters
   */
  export interface AsProtobufJSON {
    parameters: ChartParameter.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.CreateVoteRequest
 */
export class CreateVoteRequest implements GrpcMessage {
  static id = 'goautowp.CreateVoteRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CreateVoteRequest();
    CreateVoteRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CreateVoteRequest) {
    _instance.vote = _instance.vote || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CreateVoteRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.vote = new Vote();
          _reader.readMessage(_instance.vote, Vote.deserializeBinaryFromReader);
          break;
        default:
          _reader.skipField();
      }
    }

    CreateVoteRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CreateVoteRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.vote) {
      _writer.writeMessage(
        1,
        _instance.vote as any,
        Vote.serializeBinaryToWriter
      );
    }
  }

  private _vote?: Vote;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CreateVoteRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<CreateVoteRequest.AsObject>) {
    _value = _value || {};
    this.vote = _value.vote ? new Vote(_value.vote) : undefined;
    CreateVoteRequest.refineValues(this);
  }
  get vote(): Vote | undefined {
    return this._vote;
  }
  set vote(value: Vote | undefined) {
    this._vote = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CreateVoteRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CreateVoteRequest.AsObject {
    return {
      vote: this.vote ? this.vote.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CreateVoteRequest.AsProtobufJSON {
    return {
      vote: this.vote ? this.vote.toProtobufJSON(options) : null
    };
  }
}
export module CreateVoteRequest {
  /**
   * Standard JavaScript object representation for CreateVoteRequest
   */
  export interface AsObject {
    vote?: Vote.AsObject;
  }

  /**
   * Protobuf JSON representation for CreateVoteRequest
   */
  export interface AsProtobufJSON {
    vote: Vote.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.Vote
 */
export class Vote implements GrpcMessage {
  static id = 'goautowp.Vote';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Vote();
    Vote.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Vote) {
    _instance.id = _instance.id || 0;
    _instance.votingVariantVoteIds = _instance.votingVariantVoteIds || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(_instance: Vote, _reader: BinaryReader) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          (_instance.votingVariantVoteIds =
            _instance.votingVariantVoteIds || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        default:
          _reader.skipField();
      }
    }

    Vote.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Vote, _writer: BinaryWriter) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (
      _instance.votingVariantVoteIds &&
      _instance.votingVariantVoteIds.length
    ) {
      _writer.writePackedInt32(2, _instance.votingVariantVoteIds);
    }
  }

  private _id: number;
  private _votingVariantVoteIds: number[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Vote to deeply clone from
   */
  constructor(_value?: RecursivePartial<Vote.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.votingVariantVoteIds = (_value.votingVariantVoteIds || []).slice();
    Vote.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get votingVariantVoteIds(): number[] {
    return this._votingVariantVoteIds;
  }
  set votingVariantVoteIds(value: number[]) {
    this._votingVariantVoteIds = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Vote.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Vote.AsObject {
    return {
      id: this.id,
      votingVariantVoteIds: (this.votingVariantVoteIds || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Vote.AsProtobufJSON {
    return {
      id: this.id,
      votingVariantVoteIds: (this.votingVariantVoteIds || []).slice()
    };
  }
}
export module Vote {
  /**
   * Standard JavaScript object representation for Vote
   */
  export interface AsObject {
    id: number;
    votingVariantVoteIds: number[];
  }

  /**
   * Protobuf JSON representation for Vote
   */
  export interface AsProtobufJSON {
    id: number;
    votingVariantVoteIds: number[];
  }
}

/**
 * Message implementation for goautowp.VotingRequest
 */
export class VotingRequest implements GrpcMessage {
  static id = 'goautowp.VotingRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new VotingRequest();
    VotingRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: VotingRequest) {
    _instance.id = _instance.id || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: VotingRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    VotingRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: VotingRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
  }

  private _id: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of VotingRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<VotingRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    VotingRequest.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    VotingRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): VotingRequest.AsObject {
    return {
      id: this.id
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): VotingRequest.AsProtobufJSON {
    return {
      id: this.id
    };
  }
}
export module VotingRequest {
  /**
   * Standard JavaScript object representation for VotingRequest
   */
  export interface AsObject {
    id: number;
  }

  /**
   * Protobuf JSON representation for VotingRequest
   */
  export interface AsProtobufJSON {
    id: number;
  }
}

/**
 * Message implementation for goautowp.Voting
 */
export class Voting implements GrpcMessage {
  static id = 'goautowp.Voting';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Voting();
    Voting.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Voting) {
    _instance.id = _instance.id || 0;
    _instance.beginDate = _instance.beginDate || undefined;
    _instance.endDate = _instance.endDate || undefined;
    _instance.canVote = _instance.canVote || false;
    _instance.multivariant = _instance.multivariant || false;
    _instance.name = _instance.name || '';
    _instance.text = _instance.text || '';
    _instance.variants = _instance.variants || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(_instance: Voting, _reader: BinaryReader) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.beginDate = new googleProtobuf006.Timestamp();
          _reader.readMessage(
            _instance.beginDate,
            googleProtobuf006.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.endDate = new googleProtobuf006.Timestamp();
          _reader.readMessage(
            _instance.endDate,
            googleProtobuf006.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.canVote = _reader.readBool();
          break;
        case 5:
          _instance.multivariant = _reader.readBool();
          break;
        case 6:
          _instance.name = _reader.readString();
          break;
        case 7:
          _instance.text = _reader.readString();
          break;
        case 8:
          const messageInitializer8 = new VotingVariant();
          _reader.readMessage(
            messageInitializer8,
            VotingVariant.deserializeBinaryFromReader
          );
          (_instance.variants = _instance.variants || []).push(
            messageInitializer8
          );
          break;
        default:
          _reader.skipField();
      }
    }

    Voting.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Voting, _writer: BinaryWriter) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.beginDate) {
      _writer.writeMessage(
        2,
        _instance.beginDate as any,
        googleProtobuf006.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.endDate) {
      _writer.writeMessage(
        3,
        _instance.endDate as any,
        googleProtobuf006.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.canVote) {
      _writer.writeBool(4, _instance.canVote);
    }
    if (_instance.multivariant) {
      _writer.writeBool(5, _instance.multivariant);
    }
    if (_instance.name) {
      _writer.writeString(6, _instance.name);
    }
    if (_instance.text) {
      _writer.writeString(7, _instance.text);
    }
    if (_instance.variants && _instance.variants.length) {
      _writer.writeRepeatedMessage(
        8,
        _instance.variants as any,
        VotingVariant.serializeBinaryToWriter
      );
    }
  }

  private _id: number;
  private _beginDate?: googleProtobuf006.Timestamp;
  private _endDate?: googleProtobuf006.Timestamp;
  private _canVote: boolean;
  private _multivariant: boolean;
  private _name: string;
  private _text: string;
  private _variants?: VotingVariant[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Voting to deeply clone from
   */
  constructor(_value?: RecursivePartial<Voting.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.beginDate = _value.beginDate
      ? new googleProtobuf006.Timestamp(_value.beginDate)
      : undefined;
    this.endDate = _value.endDate
      ? new googleProtobuf006.Timestamp(_value.endDate)
      : undefined;
    this.canVote = _value.canVote;
    this.multivariant = _value.multivariant;
    this.name = _value.name;
    this.text = _value.text;
    this.variants = (_value.variants || []).map(m => new VotingVariant(m));
    Voting.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get beginDate(): googleProtobuf006.Timestamp | undefined {
    return this._beginDate;
  }
  set beginDate(value: googleProtobuf006.Timestamp | undefined) {
    this._beginDate = value;
  }
  get endDate(): googleProtobuf006.Timestamp | undefined {
    return this._endDate;
  }
  set endDate(value: googleProtobuf006.Timestamp | undefined) {
    this._endDate = value;
  }
  get canVote(): boolean {
    return this._canVote;
  }
  set canVote(value: boolean) {
    this._canVote = value;
  }
  get multivariant(): boolean {
    return this._multivariant;
  }
  set multivariant(value: boolean) {
    this._multivariant = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get text(): string {
    return this._text;
  }
  set text(value: string) {
    this._text = value;
  }
  get variants(): VotingVariant[] | undefined {
    return this._variants;
  }
  set variants(value: VotingVariant[] | undefined) {
    this._variants = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Voting.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Voting.AsObject {
    return {
      id: this.id,
      beginDate: this.beginDate ? this.beginDate.toObject() : undefined,
      endDate: this.endDate ? this.endDate.toObject() : undefined,
      canVote: this.canVote,
      multivariant: this.multivariant,
      name: this.name,
      text: this.text,
      variants: (this.variants || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Voting.AsProtobufJSON {
    return {
      id: this.id,
      beginDate: this.beginDate ? this.beginDate.toProtobufJSON(options) : null,
      endDate: this.endDate ? this.endDate.toProtobufJSON(options) : null,
      canVote: this.canVote,
      multivariant: this.multivariant,
      name: this.name,
      text: this.text,
      variants: (this.variants || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module Voting {
  /**
   * Standard JavaScript object representation for Voting
   */
  export interface AsObject {
    id: number;
    beginDate?: googleProtobuf006.Timestamp.AsObject;
    endDate?: googleProtobuf006.Timestamp.AsObject;
    canVote: boolean;
    multivariant: boolean;
    name: string;
    text: string;
    variants?: VotingVariant.AsObject[];
  }

  /**
   * Protobuf JSON representation for Voting
   */
  export interface AsProtobufJSON {
    id: number;
    beginDate: googleProtobuf006.Timestamp.AsProtobufJSON | null;
    endDate: googleProtobuf006.Timestamp.AsProtobufJSON | null;
    canVote: boolean;
    multivariant: boolean;
    name: string;
    text: string;
    variants: VotingVariant.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.VotingVariant
 */
export class VotingVariant implements GrpcMessage {
  static id = 'goautowp.VotingVariant';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new VotingVariant();
    VotingVariant.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: VotingVariant) {
    _instance.id = _instance.id || 0;
    _instance.isMax = _instance.isMax || false;
    _instance.isMin = _instance.isMin || false;
    _instance.name = _instance.name || '';
    _instance.percent = _instance.percent || 0;
    _instance.text = _instance.text || '';
    _instance.votes = _instance.votes || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: VotingVariant,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.isMax = _reader.readBool();
          break;
        case 3:
          _instance.isMin = _reader.readBool();
          break;
        case 4:
          _instance.name = _reader.readString();
          break;
        case 5:
          _instance.percent = _reader.readFloat();
          break;
        case 6:
          _instance.text = _reader.readString();
          break;
        case 7:
          _instance.votes = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    VotingVariant.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: VotingVariant,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.isMax) {
      _writer.writeBool(2, _instance.isMax);
    }
    if (_instance.isMin) {
      _writer.writeBool(3, _instance.isMin);
    }
    if (_instance.name) {
      _writer.writeString(4, _instance.name);
    }
    if (_instance.percent) {
      _writer.writeFloat(5, _instance.percent);
    }
    if (_instance.text) {
      _writer.writeString(6, _instance.text);
    }
    if (_instance.votes) {
      _writer.writeInt32(7, _instance.votes);
    }
  }

  private _id: number;
  private _isMax: boolean;
  private _isMin: boolean;
  private _name: string;
  private _percent: number;
  private _text: string;
  private _votes: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of VotingVariant to deeply clone from
   */
  constructor(_value?: RecursivePartial<VotingVariant.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.isMax = _value.isMax;
    this.isMin = _value.isMin;
    this.name = _value.name;
    this.percent = _value.percent;
    this.text = _value.text;
    this.votes = _value.votes;
    VotingVariant.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get isMax(): boolean {
    return this._isMax;
  }
  set isMax(value: boolean) {
    this._isMax = value;
  }
  get isMin(): boolean {
    return this._isMin;
  }
  set isMin(value: boolean) {
    this._isMin = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get percent(): number {
    return this._percent;
  }
  set percent(value: number) {
    this._percent = value;
  }
  get text(): string {
    return this._text;
  }
  set text(value: string) {
    this._text = value;
  }
  get votes(): number {
    return this._votes;
  }
  set votes(value: number) {
    this._votes = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    VotingVariant.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): VotingVariant.AsObject {
    return {
      id: this.id,
      isMax: this.isMax,
      isMin: this.isMin,
      name: this.name,
      percent: this.percent,
      text: this.text,
      votes: this.votes
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): VotingVariant.AsProtobufJSON {
    return {
      id: this.id,
      isMax: this.isMax,
      isMin: this.isMin,
      name: this.name,
      percent: this.percent,
      text: this.text,
      votes: this.votes
    };
  }
}
export module VotingVariant {
  /**
   * Standard JavaScript object representation for VotingVariant
   */
  export interface AsObject {
    id: number;
    isMax: boolean;
    isMin: boolean;
    name: string;
    percent: number;
    text: string;
    votes: number;
  }

  /**
   * Protobuf JSON representation for VotingVariant
   */
  export interface AsProtobufJSON {
    id: number;
    isMax: boolean;
    isMin: boolean;
    name: string;
    percent: number;
    text: string;
    votes: number;
  }
}

/**
 * Message implementation for goautowp.VotingVariantVotes
 */
export class VotingVariantVotes implements GrpcMessage {
  static id = 'goautowp.VotingVariantVotes';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new VotingVariantVotes();
    VotingVariantVotes.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: VotingVariantVotes) {
    _instance.userIds = _instance.userIds || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: VotingVariantVotes,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          (_instance.userIds = _instance.userIds || []).push(
            ...(_reader.readPackedInt64String() || [])
          );
          break;
        default:
          _reader.skipField();
      }
    }

    VotingVariantVotes.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: VotingVariantVotes,
    _writer: BinaryWriter
  ) {
    if (_instance.userIds && _instance.userIds.length) {
      _writer.writePackedInt64String(1, _instance.userIds);
    }
  }

  private _userIds: string[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of VotingVariantVotes to deeply clone from
   */
  constructor(_value?: RecursivePartial<VotingVariantVotes.AsObject>) {
    _value = _value || {};
    this.userIds = (_value.userIds || []).slice();
    VotingVariantVotes.refineValues(this);
  }
  get userIds(): string[] {
    return this._userIds;
  }
  set userIds(value: string[]) {
    this._userIds = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    VotingVariantVotes.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): VotingVariantVotes.AsObject {
    return {
      userIds: (this.userIds || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): VotingVariantVotes.AsProtobufJSON {
    return {
      userIds: (this.userIds || []).slice()
    };
  }
}
export module VotingVariantVotes {
  /**
   * Standard JavaScript object representation for VotingVariantVotes
   */
  export interface AsObject {
    userIds: string[];
  }

  /**
   * Protobuf JSON representation for VotingVariantVotes
   */
  export interface AsProtobufJSON {
    userIds: string[];
  }
}

/**
 * Message implementation for goautowp.ErrorDetails
 */
export class ErrorDetails implements GrpcMessage {
  static id = 'goautowp.ErrorDetails';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ErrorDetails();
    ErrorDetails.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ErrorDetails) {
    _instance.retryInfo = _instance.retryInfo || undefined;
    _instance.debugInfo = _instance.debugInfo || undefined;
    _instance.quotaFailure = _instance.quotaFailure || undefined;
    _instance.preconditionFailure = _instance.preconditionFailure || undefined;
    _instance.badRequest = _instance.badRequest || undefined;
    _instance.requestInfo = _instance.requestInfo || undefined;
    _instance.help = _instance.help || undefined;
    _instance.localizedMessage = _instance.localizedMessage || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ErrorDetails,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.retryInfo = new googleRpc012.RetryInfo();
          _reader.readMessage(
            _instance.retryInfo,
            googleRpc012.RetryInfo.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.debugInfo = new googleRpc012.DebugInfo();
          _reader.readMessage(
            _instance.debugInfo,
            googleRpc012.DebugInfo.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.quotaFailure = new googleRpc012.QuotaFailure();
          _reader.readMessage(
            _instance.quotaFailure,
            googleRpc012.QuotaFailure.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.preconditionFailure = new googleRpc012.PreconditionFailure();
          _reader.readMessage(
            _instance.preconditionFailure,
            googleRpc012.PreconditionFailure.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.badRequest = new googleRpc012.BadRequest();
          _reader.readMessage(
            _instance.badRequest,
            googleRpc012.BadRequest.deserializeBinaryFromReader
          );
          break;
        case 6:
          _instance.requestInfo = new googleRpc012.RequestInfo();
          _reader.readMessage(
            _instance.requestInfo,
            googleRpc012.RequestInfo.deserializeBinaryFromReader
          );
          break;
        case 7:
          _instance.help = new googleRpc012.Help();
          _reader.readMessage(
            _instance.help,
            googleRpc012.Help.deserializeBinaryFromReader
          );
          break;
        case 8:
          _instance.localizedMessage = new googleRpc012.LocalizedMessage();
          _reader.readMessage(
            _instance.localizedMessage,
            googleRpc012.LocalizedMessage.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    ErrorDetails.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ErrorDetails,
    _writer: BinaryWriter
  ) {
    if (_instance.retryInfo) {
      _writer.writeMessage(
        1,
        _instance.retryInfo as any,
        googleRpc012.RetryInfo.serializeBinaryToWriter
      );
    }
    if (_instance.debugInfo) {
      _writer.writeMessage(
        2,
        _instance.debugInfo as any,
        googleRpc012.DebugInfo.serializeBinaryToWriter
      );
    }
    if (_instance.quotaFailure) {
      _writer.writeMessage(
        3,
        _instance.quotaFailure as any,
        googleRpc012.QuotaFailure.serializeBinaryToWriter
      );
    }
    if (_instance.preconditionFailure) {
      _writer.writeMessage(
        4,
        _instance.preconditionFailure as any,
        googleRpc012.PreconditionFailure.serializeBinaryToWriter
      );
    }
    if (_instance.badRequest) {
      _writer.writeMessage(
        5,
        _instance.badRequest as any,
        googleRpc012.BadRequest.serializeBinaryToWriter
      );
    }
    if (_instance.requestInfo) {
      _writer.writeMessage(
        6,
        _instance.requestInfo as any,
        googleRpc012.RequestInfo.serializeBinaryToWriter
      );
    }
    if (_instance.help) {
      _writer.writeMessage(
        7,
        _instance.help as any,
        googleRpc012.Help.serializeBinaryToWriter
      );
    }
    if (_instance.localizedMessage) {
      _writer.writeMessage(
        8,
        _instance.localizedMessage as any,
        googleRpc012.LocalizedMessage.serializeBinaryToWriter
      );
    }
  }

  private _retryInfo?: googleRpc012.RetryInfo;
  private _debugInfo?: googleRpc012.DebugInfo;
  private _quotaFailure?: googleRpc012.QuotaFailure;
  private _preconditionFailure?: googleRpc012.PreconditionFailure;
  private _badRequest?: googleRpc012.BadRequest;
  private _requestInfo?: googleRpc012.RequestInfo;
  private _help?: googleRpc012.Help;
  private _localizedMessage?: googleRpc012.LocalizedMessage;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ErrorDetails to deeply clone from
   */
  constructor(_value?: RecursivePartial<ErrorDetails.AsObject>) {
    _value = _value || {};
    this.retryInfo = _value.retryInfo
      ? new googleRpc012.RetryInfo(_value.retryInfo)
      : undefined;
    this.debugInfo = _value.debugInfo
      ? new googleRpc012.DebugInfo(_value.debugInfo)
      : undefined;
    this.quotaFailure = _value.quotaFailure
      ? new googleRpc012.QuotaFailure(_value.quotaFailure)
      : undefined;
    this.preconditionFailure = _value.preconditionFailure
      ? new googleRpc012.PreconditionFailure(_value.preconditionFailure)
      : undefined;
    this.badRequest = _value.badRequest
      ? new googleRpc012.BadRequest(_value.badRequest)
      : undefined;
    this.requestInfo = _value.requestInfo
      ? new googleRpc012.RequestInfo(_value.requestInfo)
      : undefined;
    this.help = _value.help ? new googleRpc012.Help(_value.help) : undefined;
    this.localizedMessage = _value.localizedMessage
      ? new googleRpc012.LocalizedMessage(_value.localizedMessage)
      : undefined;
    ErrorDetails.refineValues(this);
  }
  get retryInfo(): googleRpc012.RetryInfo | undefined {
    return this._retryInfo;
  }
  set retryInfo(value: googleRpc012.RetryInfo | undefined) {
    this._retryInfo = value;
  }
  get debugInfo(): googleRpc012.DebugInfo | undefined {
    return this._debugInfo;
  }
  set debugInfo(value: googleRpc012.DebugInfo | undefined) {
    this._debugInfo = value;
  }
  get quotaFailure(): googleRpc012.QuotaFailure | undefined {
    return this._quotaFailure;
  }
  set quotaFailure(value: googleRpc012.QuotaFailure | undefined) {
    this._quotaFailure = value;
  }
  get preconditionFailure(): googleRpc012.PreconditionFailure | undefined {
    return this._preconditionFailure;
  }
  set preconditionFailure(value: googleRpc012.PreconditionFailure | undefined) {
    this._preconditionFailure = value;
  }
  get badRequest(): googleRpc012.BadRequest | undefined {
    return this._badRequest;
  }
  set badRequest(value: googleRpc012.BadRequest | undefined) {
    this._badRequest = value;
  }
  get requestInfo(): googleRpc012.RequestInfo | undefined {
    return this._requestInfo;
  }
  set requestInfo(value: googleRpc012.RequestInfo | undefined) {
    this._requestInfo = value;
  }
  get help(): googleRpc012.Help | undefined {
    return this._help;
  }
  set help(value: googleRpc012.Help | undefined) {
    this._help = value;
  }
  get localizedMessage(): googleRpc012.LocalizedMessage | undefined {
    return this._localizedMessage;
  }
  set localizedMessage(value: googleRpc012.LocalizedMessage | undefined) {
    this._localizedMessage = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ErrorDetails.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ErrorDetails.AsObject {
    return {
      retryInfo: this.retryInfo ? this.retryInfo.toObject() : undefined,
      debugInfo: this.debugInfo ? this.debugInfo.toObject() : undefined,
      quotaFailure: this.quotaFailure
        ? this.quotaFailure.toObject()
        : undefined,
      preconditionFailure: this.preconditionFailure
        ? this.preconditionFailure.toObject()
        : undefined,
      badRequest: this.badRequest ? this.badRequest.toObject() : undefined,
      requestInfo: this.requestInfo ? this.requestInfo.toObject() : undefined,
      help: this.help ? this.help.toObject() : undefined,
      localizedMessage: this.localizedMessage
        ? this.localizedMessage.toObject()
        : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ErrorDetails.AsProtobufJSON {
    return {
      retryInfo: this.retryInfo ? this.retryInfo.toProtobufJSON(options) : null,
      debugInfo: this.debugInfo ? this.debugInfo.toProtobufJSON(options) : null,
      quotaFailure: this.quotaFailure
        ? this.quotaFailure.toProtobufJSON(options)
        : null,
      preconditionFailure: this.preconditionFailure
        ? this.preconditionFailure.toProtobufJSON(options)
        : null,
      badRequest: this.badRequest
        ? this.badRequest.toProtobufJSON(options)
        : null,
      requestInfo: this.requestInfo
        ? this.requestInfo.toProtobufJSON(options)
        : null,
      help: this.help ? this.help.toProtobufJSON(options) : null,
      localizedMessage: this.localizedMessage
        ? this.localizedMessage.toProtobufJSON(options)
        : null
    };
  }
}
export module ErrorDetails {
  /**
   * Standard JavaScript object representation for ErrorDetails
   */
  export interface AsObject {
    retryInfo?: googleRpc012.RetryInfo.AsObject;
    debugInfo?: googleRpc012.DebugInfo.AsObject;
    quotaFailure?: googleRpc012.QuotaFailure.AsObject;
    preconditionFailure?: googleRpc012.PreconditionFailure.AsObject;
    badRequest?: googleRpc012.BadRequest.AsObject;
    requestInfo?: googleRpc012.RequestInfo.AsObject;
    help?: googleRpc012.Help.AsObject;
    localizedMessage?: googleRpc012.LocalizedMessage.AsObject;
  }

  /**
   * Protobuf JSON representation for ErrorDetails
   */
  export interface AsProtobufJSON {
    retryInfo: googleRpc012.RetryInfo.AsProtobufJSON | null;
    debugInfo: googleRpc012.DebugInfo.AsProtobufJSON | null;
    quotaFailure: googleRpc012.QuotaFailure.AsProtobufJSON | null;
    preconditionFailure: googleRpc012.PreconditionFailure.AsProtobufJSON | null;
    badRequest: googleRpc012.BadRequest.AsProtobufJSON | null;
    requestInfo: googleRpc012.RequestInfo.AsProtobufJSON | null;
    help: googleRpc012.Help.AsProtobufJSON | null;
    localizedMessage: googleRpc012.LocalizedMessage.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.AttrAttributeID
 */
export class AttrAttributeID implements GrpcMessage {
  static id = 'goautowp.AttrAttributeID';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrAttributeID();
    AttrAttributeID.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrAttributeID) {
    _instance.id = _instance.id || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrAttributeID,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    AttrAttributeID.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrAttributeID,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
  }

  private _id: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrAttributeID to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrAttributeID.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    AttrAttributeID.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrAttributeID.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrAttributeID.AsObject {
    return {
      id: this.id
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrAttributeID.AsProtobufJSON {
    return {
      id: this.id
    };
  }
}
export module AttrAttributeID {
  /**
   * Standard JavaScript object representation for AttrAttributeID
   */
  export interface AsObject {
    id: string;
  }

  /**
   * Protobuf JSON representation for AttrAttributeID
   */
  export interface AsProtobufJSON {
    id: string;
  }
}

/**
 * Message implementation for goautowp.AttrAttributesRequest
 */
export class AttrAttributesRequest implements GrpcMessage {
  static id = 'goautowp.AttrAttributesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrAttributesRequest();
    AttrAttributesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrAttributesRequest) {
    _instance.zoneId = _instance.zoneId || '0';
    _instance.parentId = _instance.parentId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrAttributesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.zoneId = _reader.readInt64String();
          break;
        case 2:
          _instance.parentId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    AttrAttributesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrAttributesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.zoneId) {
      _writer.writeInt64String(1, _instance.zoneId);
    }
    if (_instance.parentId) {
      _writer.writeInt64String(2, _instance.parentId);
    }
  }

  private _zoneId: string;
  private _parentId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrAttributesRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrAttributesRequest.AsObject>) {
    _value = _value || {};
    this.zoneId = _value.zoneId;
    this.parentId = _value.parentId;
    AttrAttributesRequest.refineValues(this);
  }
  get zoneId(): string {
    return this._zoneId;
  }
  set zoneId(value: string) {
    this._zoneId = value;
  }
  get parentId(): string {
    return this._parentId;
  }
  set parentId(value: string) {
    this._parentId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrAttributesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrAttributesRequest.AsObject {
    return {
      zoneId: this.zoneId,
      parentId: this.parentId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrAttributesRequest.AsProtobufJSON {
    return {
      zoneId: this.zoneId,
      parentId: this.parentId
    };
  }
}
export module AttrAttributesRequest {
  /**
   * Standard JavaScript object representation for AttrAttributesRequest
   */
  export interface AsObject {
    zoneId: string;
    parentId: string;
  }

  /**
   * Protobuf JSON representation for AttrAttributesRequest
   */
  export interface AsProtobufJSON {
    zoneId: string;
    parentId: string;
  }
}

/**
 * Message implementation for goautowp.AttrAttributesResponse
 */
export class AttrAttributesResponse implements GrpcMessage {
  static id = 'goautowp.AttrAttributesResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrAttributesResponse();
    AttrAttributesResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrAttributesResponse) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrAttributesResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new AttrAttribute();
          _reader.readMessage(
            messageInitializer1,
            AttrAttribute.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    AttrAttributesResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrAttributesResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        AttrAttribute.serializeBinaryToWriter
      );
    }
  }

  private _items?: AttrAttribute[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrAttributesResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrAttributesResponse.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new AttrAttribute(m));
    AttrAttributesResponse.refineValues(this);
  }
  get items(): AttrAttribute[] | undefined {
    return this._items;
  }
  set items(value: AttrAttribute[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrAttributesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrAttributesResponse.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrAttributesResponse.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module AttrAttributesResponse {
  /**
   * Standard JavaScript object representation for AttrAttributesResponse
   */
  export interface AsObject {
    items?: AttrAttribute.AsObject[];
  }

  /**
   * Protobuf JSON representation for AttrAttributesResponse
   */
  export interface AsProtobufJSON {
    items: AttrAttribute.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.AttrAttribute
 */
export class AttrAttribute implements GrpcMessage {
  static id = 'goautowp.AttrAttribute';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrAttribute();
    AttrAttribute.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrAttribute) {
    _instance.id = _instance.id || '0';
    _instance.parentId = _instance.parentId || '0';
    _instance.name = _instance.name || '';
    _instance.description = _instance.description || '';
    _instance.typeId = _instance.typeId || 0;
    _instance.unitId = _instance.unitId || '0';
    _instance.isMultiple = _instance.isMultiple || false;
    _instance.precision = _instance.precision || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrAttribute,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.parentId = _reader.readInt64String();
          break;
        case 3:
          _instance.name = _reader.readString();
          break;
        case 4:
          _instance.description = _reader.readString();
          break;
        case 5:
          _instance.typeId = _reader.readEnum();
          break;
        case 6:
          _instance.unitId = _reader.readInt64String();
          break;
        case 7:
          _instance.isMultiple = _reader.readBool();
          break;
        case 8:
          _instance.precision = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    AttrAttribute.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrAttribute,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.parentId) {
      _writer.writeInt64String(2, _instance.parentId);
    }
    if (_instance.name) {
      _writer.writeString(3, _instance.name);
    }
    if (_instance.description) {
      _writer.writeString(4, _instance.description);
    }
    if (_instance.typeId) {
      _writer.writeEnum(5, _instance.typeId);
    }
    if (_instance.unitId) {
      _writer.writeInt64String(6, _instance.unitId);
    }
    if (_instance.isMultiple) {
      _writer.writeBool(7, _instance.isMultiple);
    }
    if (_instance.precision) {
      _writer.writeInt32(8, _instance.precision);
    }
  }

  private _id: string;
  private _parentId: string;
  private _name: string;
  private _description: string;
  private _typeId: AttrAttributeType.ID;
  private _unitId: string;
  private _isMultiple: boolean;
  private _precision: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrAttribute to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrAttribute.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.parentId = _value.parentId;
    this.name = _value.name;
    this.description = _value.description;
    this.typeId = _value.typeId;
    this.unitId = _value.unitId;
    this.isMultiple = _value.isMultiple;
    this.precision = _value.precision;
    AttrAttribute.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get parentId(): string {
    return this._parentId;
  }
  set parentId(value: string) {
    this._parentId = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get description(): string {
    return this._description;
  }
  set description(value: string) {
    this._description = value;
  }
  get typeId(): AttrAttributeType.ID {
    return this._typeId;
  }
  set typeId(value: AttrAttributeType.ID) {
    this._typeId = value;
  }
  get unitId(): string {
    return this._unitId;
  }
  set unitId(value: string) {
    this._unitId = value;
  }
  get isMultiple(): boolean {
    return this._isMultiple;
  }
  set isMultiple(value: boolean) {
    this._isMultiple = value;
  }
  get precision(): number {
    return this._precision;
  }
  set precision(value: number) {
    this._precision = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrAttribute.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrAttribute.AsObject {
    return {
      id: this.id,
      parentId: this.parentId,
      name: this.name,
      description: this.description,
      typeId: this.typeId,
      unitId: this.unitId,
      isMultiple: this.isMultiple,
      precision: this.precision
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrAttribute.AsProtobufJSON {
    return {
      id: this.id,
      parentId: this.parentId,
      name: this.name,
      description: this.description,
      typeId:
        AttrAttributeType.ID[
          this.typeId === null || this.typeId === undefined ? 0 : this.typeId
        ],
      unitId: this.unitId,
      isMultiple: this.isMultiple,
      precision: this.precision
    };
  }
}
export module AttrAttribute {
  /**
   * Standard JavaScript object representation for AttrAttribute
   */
  export interface AsObject {
    id: string;
    parentId: string;
    name: string;
    description: string;
    typeId: AttrAttributeType.ID;
    unitId: string;
    isMultiple: boolean;
    precision: number;
  }

  /**
   * Protobuf JSON representation for AttrAttribute
   */
  export interface AsProtobufJSON {
    id: string;
    parentId: string;
    name: string;
    description: string;
    typeId: string;
    unitId: string;
    isMultiple: boolean;
    precision: number;
  }
}

/**
 * Message implementation for goautowp.AttrListOptionsRequest
 */
export class AttrListOptionsRequest implements GrpcMessage {
  static id = 'goautowp.AttrListOptionsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrListOptionsRequest();
    AttrListOptionsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrListOptionsRequest) {
    _instance.attributeId = _instance.attributeId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrListOptionsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.attributeId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    AttrListOptionsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrListOptionsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.attributeId) {
      _writer.writeInt64String(1, _instance.attributeId);
    }
  }

  private _attributeId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrListOptionsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrListOptionsRequest.AsObject>) {
    _value = _value || {};
    this.attributeId = _value.attributeId;
    AttrListOptionsRequest.refineValues(this);
  }
  get attributeId(): string {
    return this._attributeId;
  }
  set attributeId(value: string) {
    this._attributeId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrListOptionsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrListOptionsRequest.AsObject {
    return {
      attributeId: this.attributeId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrListOptionsRequest.AsProtobufJSON {
    return {
      attributeId: this.attributeId
    };
  }
}
export module AttrListOptionsRequest {
  /**
   * Standard JavaScript object representation for AttrListOptionsRequest
   */
  export interface AsObject {
    attributeId: string;
  }

  /**
   * Protobuf JSON representation for AttrListOptionsRequest
   */
  export interface AsProtobufJSON {
    attributeId: string;
  }
}

/**
 * Message implementation for goautowp.AttrListOptionsResponse
 */
export class AttrListOptionsResponse implements GrpcMessage {
  static id = 'goautowp.AttrListOptionsResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrListOptionsResponse();
    AttrListOptionsResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrListOptionsResponse) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrListOptionsResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new AttrListOption();
          _reader.readMessage(
            messageInitializer1,
            AttrListOption.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    AttrListOptionsResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrListOptionsResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        AttrListOption.serializeBinaryToWriter
      );
    }
  }

  private _items?: AttrListOption[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrListOptionsResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrListOptionsResponse.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new AttrListOption(m));
    AttrListOptionsResponse.refineValues(this);
  }
  get items(): AttrListOption[] | undefined {
    return this._items;
  }
  set items(value: AttrListOption[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrListOptionsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrListOptionsResponse.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrListOptionsResponse.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module AttrListOptionsResponse {
  /**
   * Standard JavaScript object representation for AttrListOptionsResponse
   */
  export interface AsObject {
    items?: AttrListOption.AsObject[];
  }

  /**
   * Protobuf JSON representation for AttrListOptionsResponse
   */
  export interface AsProtobufJSON {
    items: AttrListOption.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.AttrListOption
 */
export class AttrListOption implements GrpcMessage {
  static id = 'goautowp.AttrListOption';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrListOption();
    AttrListOption.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrListOption) {
    _instance.id = _instance.id || '0';
    _instance.name = _instance.name || '';
    _instance.attributeId = _instance.attributeId || '0';
    _instance.parentId = _instance.parentId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrListOption,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        case 3:
          _instance.attributeId = _reader.readInt64String();
          break;
        case 4:
          _instance.parentId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    AttrListOption.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrListOption,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
    if (_instance.attributeId) {
      _writer.writeInt64String(3, _instance.attributeId);
    }
    if (_instance.parentId) {
      _writer.writeInt64String(4, _instance.parentId);
    }
  }

  private _id: string;
  private _name: string;
  private _attributeId: string;
  private _parentId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrListOption to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrListOption.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.name = _value.name;
    this.attributeId = _value.attributeId;
    this.parentId = _value.parentId;
    AttrListOption.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get attributeId(): string {
    return this._attributeId;
  }
  set attributeId(value: string) {
    this._attributeId = value;
  }
  get parentId(): string {
    return this._parentId;
  }
  set parentId(value: string) {
    this._parentId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrListOption.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrListOption.AsObject {
    return {
      id: this.id,
      name: this.name,
      attributeId: this.attributeId,
      parentId: this.parentId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrListOption.AsProtobufJSON {
    return {
      id: this.id,
      name: this.name,
      attributeId: this.attributeId,
      parentId: this.parentId
    };
  }
}
export module AttrListOption {
  /**
   * Standard JavaScript object representation for AttrListOption
   */
  export interface AsObject {
    id: string;
    name: string;
    attributeId: string;
    parentId: string;
  }

  /**
   * Protobuf JSON representation for AttrListOption
   */
  export interface AsProtobufJSON {
    id: string;
    name: string;
    attributeId: string;
    parentId: string;
  }
}

/**
 * Message implementation for goautowp.AttrZoneAttributesRequest
 */
export class AttrZoneAttributesRequest implements GrpcMessage {
  static id = 'goautowp.AttrZoneAttributesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrZoneAttributesRequest();
    AttrZoneAttributesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrZoneAttributesRequest) {
    _instance.zoneId = _instance.zoneId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrZoneAttributesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.zoneId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    AttrZoneAttributesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrZoneAttributesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.zoneId) {
      _writer.writeInt64String(1, _instance.zoneId);
    }
  }

  private _zoneId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrZoneAttributesRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrZoneAttributesRequest.AsObject>) {
    _value = _value || {};
    this.zoneId = _value.zoneId;
    AttrZoneAttributesRequest.refineValues(this);
  }
  get zoneId(): string {
    return this._zoneId;
  }
  set zoneId(value: string) {
    this._zoneId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrZoneAttributesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrZoneAttributesRequest.AsObject {
    return {
      zoneId: this.zoneId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrZoneAttributesRequest.AsProtobufJSON {
    return {
      zoneId: this.zoneId
    };
  }
}
export module AttrZoneAttributesRequest {
  /**
   * Standard JavaScript object representation for AttrZoneAttributesRequest
   */
  export interface AsObject {
    zoneId: string;
  }

  /**
   * Protobuf JSON representation for AttrZoneAttributesRequest
   */
  export interface AsProtobufJSON {
    zoneId: string;
  }
}

/**
 * Message implementation for goautowp.AttrZoneAttributesResponse
 */
export class AttrZoneAttributesResponse implements GrpcMessage {
  static id = 'goautowp.AttrZoneAttributesResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrZoneAttributesResponse();
    AttrZoneAttributesResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrZoneAttributesResponse) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrZoneAttributesResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new AttrZoneAttribute();
          _reader.readMessage(
            messageInitializer1,
            AttrZoneAttribute.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    AttrZoneAttributesResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrZoneAttributesResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        AttrZoneAttribute.serializeBinaryToWriter
      );
    }
  }

  private _items?: AttrZoneAttribute[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrZoneAttributesResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrZoneAttributesResponse.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new AttrZoneAttribute(m));
    AttrZoneAttributesResponse.refineValues(this);
  }
  get items(): AttrZoneAttribute[] | undefined {
    return this._items;
  }
  set items(value: AttrZoneAttribute[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrZoneAttributesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrZoneAttributesResponse.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrZoneAttributesResponse.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module AttrZoneAttributesResponse {
  /**
   * Standard JavaScript object representation for AttrZoneAttributesResponse
   */
  export interface AsObject {
    items?: AttrZoneAttribute.AsObject[];
  }

  /**
   * Protobuf JSON representation for AttrZoneAttributesResponse
   */
  export interface AsProtobufJSON {
    items: AttrZoneAttribute.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.AttrZoneAttribute
 */
export class AttrZoneAttribute implements GrpcMessage {
  static id = 'goautowp.AttrZoneAttribute';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrZoneAttribute();
    AttrZoneAttribute.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrZoneAttribute) {
    _instance.zoneId = _instance.zoneId || '0';
    _instance.attributeId = _instance.attributeId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrZoneAttribute,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.zoneId = _reader.readInt64String();
          break;
        case 2:
          _instance.attributeId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    AttrZoneAttribute.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrZoneAttribute,
    _writer: BinaryWriter
  ) {
    if (_instance.zoneId) {
      _writer.writeInt64String(1, _instance.zoneId);
    }
    if (_instance.attributeId) {
      _writer.writeInt64String(2, _instance.attributeId);
    }
  }

  private _zoneId: string;
  private _attributeId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrZoneAttribute to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrZoneAttribute.AsObject>) {
    _value = _value || {};
    this.zoneId = _value.zoneId;
    this.attributeId = _value.attributeId;
    AttrZoneAttribute.refineValues(this);
  }
  get zoneId(): string {
    return this._zoneId;
  }
  set zoneId(value: string) {
    this._zoneId = value;
  }
  get attributeId(): string {
    return this._attributeId;
  }
  set attributeId(value: string) {
    this._attributeId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrZoneAttribute.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrZoneAttribute.AsObject {
    return {
      zoneId: this.zoneId,
      attributeId: this.attributeId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrZoneAttribute.AsProtobufJSON {
    return {
      zoneId: this.zoneId,
      attributeId: this.attributeId
    };
  }
}
export module AttrZoneAttribute {
  /**
   * Standard JavaScript object representation for AttrZoneAttribute
   */
  export interface AsObject {
    zoneId: string;
    attributeId: string;
  }

  /**
   * Protobuf JSON representation for AttrZoneAttribute
   */
  export interface AsProtobufJSON {
    zoneId: string;
    attributeId: string;
  }
}

/**
 * Message implementation for goautowp.AttrAttributeTypesResponse
 */
export class AttrAttributeTypesResponse implements GrpcMessage {
  static id = 'goautowp.AttrAttributeTypesResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrAttributeTypesResponse();
    AttrAttributeTypesResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrAttributeTypesResponse) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrAttributeTypesResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new AttrAttributeType();
          _reader.readMessage(
            messageInitializer1,
            AttrAttributeType.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    AttrAttributeTypesResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrAttributeTypesResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        AttrAttributeType.serializeBinaryToWriter
      );
    }
  }

  private _items?: AttrAttributeType[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrAttributeTypesResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrAttributeTypesResponse.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new AttrAttributeType(m));
    AttrAttributeTypesResponse.refineValues(this);
  }
  get items(): AttrAttributeType[] | undefined {
    return this._items;
  }
  set items(value: AttrAttributeType[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrAttributeTypesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrAttributeTypesResponse.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrAttributeTypesResponse.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module AttrAttributeTypesResponse {
  /**
   * Standard JavaScript object representation for AttrAttributeTypesResponse
   */
  export interface AsObject {
    items?: AttrAttributeType.AsObject[];
  }

  /**
   * Protobuf JSON representation for AttrAttributeTypesResponse
   */
  export interface AsProtobufJSON {
    items: AttrAttributeType.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.AttrAttributeType
 */
export class AttrAttributeType implements GrpcMessage {
  static id = 'goautowp.AttrAttributeType';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrAttributeType();
    AttrAttributeType.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrAttributeType) {
    _instance.id = _instance.id || 0;
    _instance.name = _instance.name || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrAttributeType,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readEnum();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    AttrAttributeType.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrAttributeType,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeEnum(1, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
  }

  private _id: AttrAttributeType.ID;
  private _name: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrAttributeType to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrAttributeType.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.name = _value.name;
    AttrAttributeType.refineValues(this);
  }
  get id(): AttrAttributeType.ID {
    return this._id;
  }
  set id(value: AttrAttributeType.ID) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrAttributeType.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrAttributeType.AsObject {
    return {
      id: this.id,
      name: this.name
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrAttributeType.AsProtobufJSON {
    return {
      id:
        AttrAttributeType.ID[
          this.id === null || this.id === undefined ? 0 : this.id
        ],
      name: this.name
    };
  }
}
export module AttrAttributeType {
  /**
   * Standard JavaScript object representation for AttrAttributeType
   */
  export interface AsObject {
    id: AttrAttributeType.ID;
    name: string;
  }

  /**
   * Protobuf JSON representation for AttrAttributeType
   */
  export interface AsProtobufJSON {
    id: string;
    name: string;
  }
  export enum Id {
    UNKNOWN = 0,
    STRING = 1,
    INTEGER = 2,
    FLOAT = 3,
    TEXT = 4,
    BOOLEAN = 5,
    LIST = 6,
    TREE = 7
  }
}

/**
 * Message implementation for goautowp.AttrUnitsResponse
 */
export class AttrUnitsResponse implements GrpcMessage {
  static id = 'goautowp.AttrUnitsResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrUnitsResponse();
    AttrUnitsResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrUnitsResponse) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrUnitsResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new AttrUnit();
          _reader.readMessage(
            messageInitializer1,
            AttrUnit.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    AttrUnitsResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrUnitsResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        AttrUnit.serializeBinaryToWriter
      );
    }
  }

  private _items?: AttrUnit[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrUnitsResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrUnitsResponse.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new AttrUnit(m));
    AttrUnitsResponse.refineValues(this);
  }
  get items(): AttrUnit[] | undefined {
    return this._items;
  }
  set items(value: AttrUnit[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrUnitsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrUnitsResponse.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrUnitsResponse.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module AttrUnitsResponse {
  /**
   * Standard JavaScript object representation for AttrUnitsResponse
   */
  export interface AsObject {
    items?: AttrUnit.AsObject[];
  }

  /**
   * Protobuf JSON representation for AttrUnitsResponse
   */
  export interface AsProtobufJSON {
    items: AttrUnit.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.AttrUnit
 */
export class AttrUnit implements GrpcMessage {
  static id = 'goautowp.AttrUnit';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrUnit();
    AttrUnit.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrUnit) {
    _instance.id = _instance.id || '0';
    _instance.name = _instance.name || '';
    _instance.abbr = _instance.abbr || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrUnit,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        case 3:
          _instance.abbr = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    AttrUnit.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: AttrUnit, _writer: BinaryWriter) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
    if (_instance.abbr) {
      _writer.writeString(3, _instance.abbr);
    }
  }

  private _id: string;
  private _name: string;
  private _abbr: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrUnit to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrUnit.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.name = _value.name;
    this.abbr = _value.abbr;
    AttrUnit.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get abbr(): string {
    return this._abbr;
  }
  set abbr(value: string) {
    this._abbr = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrUnit.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrUnit.AsObject {
    return {
      id: this.id,
      name: this.name,
      abbr: this.abbr
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrUnit.AsProtobufJSON {
    return {
      id: this.id,
      name: this.name,
      abbr: this.abbr
    };
  }
}
export module AttrUnit {
  /**
   * Standard JavaScript object representation for AttrUnit
   */
  export interface AsObject {
    id: string;
    name: string;
    abbr: string;
  }

  /**
   * Protobuf JSON representation for AttrUnit
   */
  export interface AsProtobufJSON {
    id: string;
    name: string;
    abbr: string;
  }
}

/**
 * Message implementation for goautowp.AttrZonesResponse
 */
export class AttrZonesResponse implements GrpcMessage {
  static id = 'goautowp.AttrZonesResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrZonesResponse();
    AttrZonesResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrZonesResponse) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrZonesResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new AttrZone();
          _reader.readMessage(
            messageInitializer1,
            AttrZone.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    AttrZonesResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrZonesResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        AttrZone.serializeBinaryToWriter
      );
    }
  }

  private _items?: AttrZone[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrZonesResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrZonesResponse.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new AttrZone(m));
    AttrZonesResponse.refineValues(this);
  }
  get items(): AttrZone[] | undefined {
    return this._items;
  }
  set items(value: AttrZone[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrZonesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrZonesResponse.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrZonesResponse.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module AttrZonesResponse {
  /**
   * Standard JavaScript object representation for AttrZonesResponse
   */
  export interface AsObject {
    items?: AttrZone.AsObject[];
  }

  /**
   * Protobuf JSON representation for AttrZonesResponse
   */
  export interface AsProtobufJSON {
    items: AttrZone.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.AttrZone
 */
export class AttrZone implements GrpcMessage {
  static id = 'goautowp.AttrZone';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrZone();
    AttrZone.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrZone) {
    _instance.id = _instance.id || '0';
    _instance.name = _instance.name || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrZone,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    AttrZone.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: AttrZone, _writer: BinaryWriter) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
  }

  private _id: string;
  private _name: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrZone to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrZone.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.name = _value.name;
    AttrZone.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrZone.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrZone.AsObject {
    return {
      id: this.id,
      name: this.name
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrZone.AsProtobufJSON {
    return {
      id: this.id,
      name: this.name
    };
  }
}
export module AttrZone {
  /**
   * Standard JavaScript object representation for AttrZone
   */
  export interface AsObject {
    id: string;
    name: string;
  }

  /**
   * Protobuf JSON representation for AttrZone
   */
  export interface AsProtobufJSON {
    id: string;
    name: string;
  }
}

/**
 * Message implementation for goautowp.MoveAttrUserValuesRequest
 */
export class MoveAttrUserValuesRequest implements GrpcMessage {
  static id = 'goautowp.MoveAttrUserValuesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new MoveAttrUserValuesRequest();
    MoveAttrUserValuesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: MoveAttrUserValuesRequest) {
    _instance.srcItemId = _instance.srcItemId || '0';
    _instance.destItemId = _instance.destItemId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: MoveAttrUserValuesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.srcItemId = _reader.readInt64String();
          break;
        case 2:
          _instance.destItemId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    MoveAttrUserValuesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: MoveAttrUserValuesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.srcItemId) {
      _writer.writeInt64String(1, _instance.srcItemId);
    }
    if (_instance.destItemId) {
      _writer.writeInt64String(2, _instance.destItemId);
    }
  }

  private _srcItemId: string;
  private _destItemId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of MoveAttrUserValuesRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<MoveAttrUserValuesRequest.AsObject>) {
    _value = _value || {};
    this.srcItemId = _value.srcItemId;
    this.destItemId = _value.destItemId;
    MoveAttrUserValuesRequest.refineValues(this);
  }
  get srcItemId(): string {
    return this._srcItemId;
  }
  set srcItemId(value: string) {
    this._srcItemId = value;
  }
  get destItemId(): string {
    return this._destItemId;
  }
  set destItemId(value: string) {
    this._destItemId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    MoveAttrUserValuesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): MoveAttrUserValuesRequest.AsObject {
    return {
      srcItemId: this.srcItemId,
      destItemId: this.destItemId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): MoveAttrUserValuesRequest.AsProtobufJSON {
    return {
      srcItemId: this.srcItemId,
      destItemId: this.destItemId
    };
  }
}
export module MoveAttrUserValuesRequest {
  /**
   * Standard JavaScript object representation for MoveAttrUserValuesRequest
   */
  export interface AsObject {
    srcItemId: string;
    destItemId: string;
  }

  /**
   * Protobuf JSON representation for MoveAttrUserValuesRequest
   */
  export interface AsProtobufJSON {
    srcItemId: string;
    destItemId: string;
  }
}

/**
 * Message implementation for goautowp.DeleteAttrUserValuesRequest
 */
export class DeleteAttrUserValuesRequest implements GrpcMessage {
  static id = 'goautowp.DeleteAttrUserValuesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new DeleteAttrUserValuesRequest();
    DeleteAttrUserValuesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: DeleteAttrUserValuesRequest) {
    _instance.attributeId = _instance.attributeId || '0';
    _instance.itemId = _instance.itemId || '0';
    _instance.userId = _instance.userId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: DeleteAttrUserValuesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.attributeId = _reader.readInt64String();
          break;
        case 2:
          _instance.itemId = _reader.readInt64String();
          break;
        case 3:
          _instance.userId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    DeleteAttrUserValuesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: DeleteAttrUserValuesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.attributeId) {
      _writer.writeInt64String(1, _instance.attributeId);
    }
    if (_instance.itemId) {
      _writer.writeInt64String(2, _instance.itemId);
    }
    if (_instance.userId) {
      _writer.writeInt64String(3, _instance.userId);
    }
  }

  private _attributeId: string;
  private _itemId: string;
  private _userId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of DeleteAttrUserValuesRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<DeleteAttrUserValuesRequest.AsObject>) {
    _value = _value || {};
    this.attributeId = _value.attributeId;
    this.itemId = _value.itemId;
    this.userId = _value.userId;
    DeleteAttrUserValuesRequest.refineValues(this);
  }
  get attributeId(): string {
    return this._attributeId;
  }
  set attributeId(value: string) {
    this._attributeId = value;
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    DeleteAttrUserValuesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): DeleteAttrUserValuesRequest.AsObject {
    return {
      attributeId: this.attributeId,
      itemId: this.itemId,
      userId: this.userId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): DeleteAttrUserValuesRequest.AsProtobufJSON {
    return {
      attributeId: this.attributeId,
      itemId: this.itemId,
      userId: this.userId
    };
  }
}
export module DeleteAttrUserValuesRequest {
  /**
   * Standard JavaScript object representation for DeleteAttrUserValuesRequest
   */
  export interface AsObject {
    attributeId: string;
    itemId: string;
    userId: string;
  }

  /**
   * Protobuf JSON representation for DeleteAttrUserValuesRequest
   */
  export interface AsProtobufJSON {
    attributeId: string;
    itemId: string;
    userId: string;
  }
}

/**
 * Message implementation for goautowp.AttrUserValuesFields
 */
export class AttrUserValuesFields implements GrpcMessage {
  static id = 'goautowp.AttrUserValuesFields';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrUserValuesFields();
    AttrUserValuesFields.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrUserValuesFields) {
    _instance.valueText = _instance.valueText || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrUserValuesFields,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.valueText = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    AttrUserValuesFields.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrUserValuesFields,
    _writer: BinaryWriter
  ) {
    if (_instance.valueText) {
      _writer.writeBool(1, _instance.valueText);
    }
  }

  private _valueText: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrUserValuesFields to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrUserValuesFields.AsObject>) {
    _value = _value || {};
    this.valueText = _value.valueText;
    AttrUserValuesFields.refineValues(this);
  }
  get valueText(): boolean {
    return this._valueText;
  }
  set valueText(value: boolean) {
    this._valueText = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrUserValuesFields.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrUserValuesFields.AsObject {
    return {
      valueText: this.valueText
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrUserValuesFields.AsProtobufJSON {
    return {
      valueText: this.valueText
    };
  }
}
export module AttrUserValuesFields {
  /**
   * Standard JavaScript object representation for AttrUserValuesFields
   */
  export interface AsObject {
    valueText: boolean;
  }

  /**
   * Protobuf JSON representation for AttrUserValuesFields
   */
  export interface AsProtobufJSON {
    valueText: boolean;
  }
}

/**
 * Message implementation for goautowp.AttrUserValuesRequest
 */
export class AttrUserValuesRequest implements GrpcMessage {
  static id = 'goautowp.AttrUserValuesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrUserValuesRequest();
    AttrUserValuesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrUserValuesRequest) {
    _instance.zoneId = _instance.zoneId || '0';
    _instance.userId = _instance.userId || '0';
    _instance.excludeUserId = _instance.excludeUserId || '0';
    _instance.itemId = _instance.itemId || '0';
    _instance.language = _instance.language || '';
    _instance.fields = _instance.fields || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrUserValuesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.zoneId = _reader.readInt64String();
          break;
        case 2:
          _instance.userId = _reader.readInt64String();
          break;
        case 3:
          _instance.excludeUserId = _reader.readInt64String();
          break;
        case 4:
          _instance.itemId = _reader.readInt64String();
          break;
        case 5:
          _instance.language = _reader.readString();
          break;
        case 6:
          _instance.fields = new AttrUserValuesFields();
          _reader.readMessage(
            _instance.fields,
            AttrUserValuesFields.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    AttrUserValuesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrUserValuesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.zoneId) {
      _writer.writeInt64String(1, _instance.zoneId);
    }
    if (_instance.userId) {
      _writer.writeInt64String(2, _instance.userId);
    }
    if (_instance.excludeUserId) {
      _writer.writeInt64String(3, _instance.excludeUserId);
    }
    if (_instance.itemId) {
      _writer.writeInt64String(4, _instance.itemId);
    }
    if (_instance.language) {
      _writer.writeString(5, _instance.language);
    }
    if (_instance.fields) {
      _writer.writeMessage(
        6,
        _instance.fields as any,
        AttrUserValuesFields.serializeBinaryToWriter
      );
    }
  }

  private _zoneId: string;
  private _userId: string;
  private _excludeUserId: string;
  private _itemId: string;
  private _language: string;
  private _fields?: AttrUserValuesFields;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrUserValuesRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrUserValuesRequest.AsObject>) {
    _value = _value || {};
    this.zoneId = _value.zoneId;
    this.userId = _value.userId;
    this.excludeUserId = _value.excludeUserId;
    this.itemId = _value.itemId;
    this.language = _value.language;
    this.fields = _value.fields
      ? new AttrUserValuesFields(_value.fields)
      : undefined;
    AttrUserValuesRequest.refineValues(this);
  }
  get zoneId(): string {
    return this._zoneId;
  }
  set zoneId(value: string) {
    this._zoneId = value;
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }
  get excludeUserId(): string {
    return this._excludeUserId;
  }
  set excludeUserId(value: string) {
    this._excludeUserId = value;
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }
  get fields(): AttrUserValuesFields | undefined {
    return this._fields;
  }
  set fields(value: AttrUserValuesFields | undefined) {
    this._fields = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrUserValuesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrUserValuesRequest.AsObject {
    return {
      zoneId: this.zoneId,
      userId: this.userId,
      excludeUserId: this.excludeUserId,
      itemId: this.itemId,
      language: this.language,
      fields: this.fields ? this.fields.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrUserValuesRequest.AsProtobufJSON {
    return {
      zoneId: this.zoneId,
      userId: this.userId,
      excludeUserId: this.excludeUserId,
      itemId: this.itemId,
      language: this.language,
      fields: this.fields ? this.fields.toProtobufJSON(options) : null
    };
  }
}
export module AttrUserValuesRequest {
  /**
   * Standard JavaScript object representation for AttrUserValuesRequest
   */
  export interface AsObject {
    zoneId: string;
    userId: string;
    excludeUserId: string;
    itemId: string;
    language: string;
    fields?: AttrUserValuesFields.AsObject;
  }

  /**
   * Protobuf JSON representation for AttrUserValuesRequest
   */
  export interface AsProtobufJSON {
    zoneId: string;
    userId: string;
    excludeUserId: string;
    itemId: string;
    language: string;
    fields: AttrUserValuesFields.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.AttrSetUserValuesRequest
 */
export class AttrSetUserValuesRequest implements GrpcMessage {
  static id = 'goautowp.AttrSetUserValuesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrSetUserValuesRequest();
    AttrSetUserValuesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrSetUserValuesRequest) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrSetUserValuesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new AttrUserValue();
          _reader.readMessage(
            messageInitializer1,
            AttrUserValue.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    AttrSetUserValuesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrSetUserValuesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        AttrUserValue.serializeBinaryToWriter
      );
    }
  }

  private _items?: AttrUserValue[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrSetUserValuesRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrSetUserValuesRequest.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new AttrUserValue(m));
    AttrSetUserValuesRequest.refineValues(this);
  }
  get items(): AttrUserValue[] | undefined {
    return this._items;
  }
  set items(value: AttrUserValue[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrSetUserValuesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrSetUserValuesRequest.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrSetUserValuesRequest.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module AttrSetUserValuesRequest {
  /**
   * Standard JavaScript object representation for AttrSetUserValuesRequest
   */
  export interface AsObject {
    items?: AttrUserValue.AsObject[];
  }

  /**
   * Protobuf JSON representation for AttrSetUserValuesRequest
   */
  export interface AsProtobufJSON {
    items: AttrUserValue.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.AttrConflictsRequest
 */
export class AttrConflictsRequest implements GrpcMessage {
  static id = 'goautowp.AttrConflictsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrConflictsRequest();
    AttrConflictsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrConflictsRequest) {
    _instance.filter = _instance.filter || 0;
    _instance.page = _instance.page || 0;
    _instance.language = _instance.language || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrConflictsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.filter = _reader.readEnum();
          break;
        case 2:
          _instance.page = _reader.readInt32();
          break;
        case 3:
          _instance.language = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    AttrConflictsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrConflictsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.filter) {
      _writer.writeEnum(1, _instance.filter);
    }
    if (_instance.page) {
      _writer.writeInt32(2, _instance.page);
    }
    if (_instance.language) {
      _writer.writeString(3, _instance.language);
    }
  }

  private _filter: AttrConflictsRequest.Filter;
  private _page: number;
  private _language: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrConflictsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrConflictsRequest.AsObject>) {
    _value = _value || {};
    this.filter = _value.filter;
    this.page = _value.page;
    this.language = _value.language;
    AttrConflictsRequest.refineValues(this);
  }
  get filter(): AttrConflictsRequest.Filter {
    return this._filter;
  }
  set filter(value: AttrConflictsRequest.Filter) {
    this._filter = value;
  }
  get page(): number {
    return this._page;
  }
  set page(value: number) {
    this._page = value;
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrConflictsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrConflictsRequest.AsObject {
    return {
      filter: this.filter,
      page: this.page,
      language: this.language
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrConflictsRequest.AsProtobufJSON {
    return {
      filter:
        AttrConflictsRequest.Filter[
          this.filter === null || this.filter === undefined ? 0 : this.filter
        ],
      page: this.page,
      language: this.language
    };
  }
}
export module AttrConflictsRequest {
  /**
   * Standard JavaScript object representation for AttrConflictsRequest
   */
  export interface AsObject {
    filter: AttrConflictsRequest.Filter;
    page: number;
    language: string;
  }

  /**
   * Protobuf JSON representation for AttrConflictsRequest
   */
  export interface AsProtobufJSON {
    filter: string;
    page: number;
    language: string;
  }
  export enum Filter {
    ALL = 0,
    DO_NOT_AGREE_WITH_ME = 1,
    I_DISAGREE = 2,
    MINUS_WEIGHT = 3
  }
}

/**
 * Message implementation for goautowp.AttrConflictValue
 */
export class AttrConflictValue implements GrpcMessage {
  static id = 'goautowp.AttrConflictValue';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrConflictValue();
    AttrConflictValue.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrConflictValue) {
    _instance.value = _instance.value || '';
    _instance.valueIsEmpty = _instance.valueIsEmpty || false;
    _instance.userId = _instance.userId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrConflictValue,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.value = _reader.readString();
          break;
        case 2:
          _instance.valueIsEmpty = _reader.readBool();
          break;
        case 3:
          _instance.userId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    AttrConflictValue.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrConflictValue,
    _writer: BinaryWriter
  ) {
    if (_instance.value) {
      _writer.writeString(1, _instance.value);
    }
    if (_instance.valueIsEmpty) {
      _writer.writeBool(2, _instance.valueIsEmpty);
    }
    if (_instance.userId) {
      _writer.writeInt64String(3, _instance.userId);
    }
  }

  private _value: string;
  private _valueIsEmpty: boolean;
  private _userId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrConflictValue to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrConflictValue.AsObject>) {
    _value = _value || {};
    this.value = _value.value;
    this.valueIsEmpty = _value.valueIsEmpty;
    this.userId = _value.userId;
    AttrConflictValue.refineValues(this);
  }
  get value(): string {
    return this._value;
  }
  set value(value: string) {
    this._value = value;
  }
  get valueIsEmpty(): boolean {
    return this._valueIsEmpty;
  }
  set valueIsEmpty(value: boolean) {
    this._valueIsEmpty = value;
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrConflictValue.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrConflictValue.AsObject {
    return {
      value: this.value,
      valueIsEmpty: this.valueIsEmpty,
      userId: this.userId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrConflictValue.AsProtobufJSON {
    return {
      value: this.value,
      valueIsEmpty: this.valueIsEmpty,
      userId: this.userId
    };
  }
}
export module AttrConflictValue {
  /**
   * Standard JavaScript object representation for AttrConflictValue
   */
  export interface AsObject {
    value: string;
    valueIsEmpty: boolean;
    userId: string;
  }

  /**
   * Protobuf JSON representation for AttrConflictValue
   */
  export interface AsProtobufJSON {
    value: string;
    valueIsEmpty: boolean;
    userId: string;
  }
}

/**
 * Message implementation for goautowp.AttrConflict
 */
export class AttrConflict implements GrpcMessage {
  static id = 'goautowp.AttrConflict';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrConflict();
    AttrConflict.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrConflict) {
    _instance.itemId = _instance.itemId || '0';
    _instance.attributeId = _instance.attributeId || '0';
    _instance.values = _instance.values || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrConflict,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.itemId = _reader.readInt64String();
          break;
        case 2:
          _instance.attributeId = _reader.readInt64String();
          break;
        case 5:
          const messageInitializer5 = new AttrConflictValue();
          _reader.readMessage(
            messageInitializer5,
            AttrConflictValue.deserializeBinaryFromReader
          );
          (_instance.values = _instance.values || []).push(messageInitializer5);
          break;
        default:
          _reader.skipField();
      }
    }

    AttrConflict.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrConflict,
    _writer: BinaryWriter
  ) {
    if (_instance.itemId) {
      _writer.writeInt64String(1, _instance.itemId);
    }
    if (_instance.attributeId) {
      _writer.writeInt64String(2, _instance.attributeId);
    }
    if (_instance.values && _instance.values.length) {
      _writer.writeRepeatedMessage(
        5,
        _instance.values as any,
        AttrConflictValue.serializeBinaryToWriter
      );
    }
  }

  private _itemId: string;
  private _attributeId: string;
  private _values?: AttrConflictValue[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrConflict to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrConflict.AsObject>) {
    _value = _value || {};
    this.itemId = _value.itemId;
    this.attributeId = _value.attributeId;
    this.values = (_value.values || []).map(m => new AttrConflictValue(m));
    AttrConflict.refineValues(this);
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get attributeId(): string {
    return this._attributeId;
  }
  set attributeId(value: string) {
    this._attributeId = value;
  }
  get values(): AttrConflictValue[] | undefined {
    return this._values;
  }
  set values(value: AttrConflictValue[] | undefined) {
    this._values = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrConflict.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrConflict.AsObject {
    return {
      itemId: this.itemId,
      attributeId: this.attributeId,
      values: (this.values || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrConflict.AsProtobufJSON {
    return {
      itemId: this.itemId,
      attributeId: this.attributeId,
      values: (this.values || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module AttrConflict {
  /**
   * Standard JavaScript object representation for AttrConflict
   */
  export interface AsObject {
    itemId: string;
    attributeId: string;
    values?: AttrConflictValue.AsObject[];
  }

  /**
   * Protobuf JSON representation for AttrConflict
   */
  export interface AsProtobufJSON {
    itemId: string;
    attributeId: string;
    values: AttrConflictValue.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.AttrConflictsResponse
 */
export class AttrConflictsResponse implements GrpcMessage {
  static id = 'goautowp.AttrConflictsResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrConflictsResponse();
    AttrConflictsResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrConflictsResponse) {
    _instance.items = _instance.items || [];
    _instance.paginator = _instance.paginator || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrConflictsResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new AttrConflict();
          _reader.readMessage(
            messageInitializer1,
            AttrConflict.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        case 2:
          _instance.paginator = new Pages();
          _reader.readMessage(
            _instance.paginator,
            Pages.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    AttrConflictsResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrConflictsResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        AttrConflict.serializeBinaryToWriter
      );
    }
    if (_instance.paginator) {
      _writer.writeMessage(
        2,
        _instance.paginator as any,
        Pages.serializeBinaryToWriter
      );
    }
  }

  private _items?: AttrConflict[];
  private _paginator?: Pages;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrConflictsResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrConflictsResponse.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new AttrConflict(m));
    this.paginator = _value.paginator ? new Pages(_value.paginator) : undefined;
    AttrConflictsResponse.refineValues(this);
  }
  get items(): AttrConflict[] | undefined {
    return this._items;
  }
  set items(value: AttrConflict[] | undefined) {
    this._items = value;
  }
  get paginator(): Pages | undefined {
    return this._paginator;
  }
  set paginator(value: Pages | undefined) {
    this._paginator = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrConflictsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrConflictsResponse.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject()),
      paginator: this.paginator ? this.paginator.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrConflictsResponse.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options)),
      paginator: this.paginator ? this.paginator.toProtobufJSON(options) : null
    };
  }
}
export module AttrConflictsResponse {
  /**
   * Standard JavaScript object representation for AttrConflictsResponse
   */
  export interface AsObject {
    items?: AttrConflict.AsObject[];
    paginator?: Pages.AsObject;
  }

  /**
   * Protobuf JSON representation for AttrConflictsResponse
   */
  export interface AsProtobufJSON {
    items: AttrConflict.AsProtobufJSON[] | null;
    paginator: Pages.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.GetSpecificationsRequest
 */
export class GetSpecificationsRequest implements GrpcMessage {
  static id = 'goautowp.GetSpecificationsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetSpecificationsRequest();
    GetSpecificationsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetSpecificationsRequest) {
    _instance.itemId = _instance.itemId || '0';
    _instance.language = _instance.language || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetSpecificationsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.itemId = _reader.readInt64String();
          break;
        case 2:
          _instance.language = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    GetSpecificationsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetSpecificationsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.itemId) {
      _writer.writeInt64String(1, _instance.itemId);
    }
    if (_instance.language) {
      _writer.writeString(2, _instance.language);
    }
  }

  private _itemId: string;
  private _language: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetSpecificationsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetSpecificationsRequest.AsObject>) {
    _value = _value || {};
    this.itemId = _value.itemId;
    this.language = _value.language;
    GetSpecificationsRequest.refineValues(this);
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetSpecificationsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetSpecificationsRequest.AsObject {
    return {
      itemId: this.itemId,
      language: this.language
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetSpecificationsRequest.AsProtobufJSON {
    return {
      itemId: this.itemId,
      language: this.language
    };
  }
}
export module GetSpecificationsRequest {
  /**
   * Standard JavaScript object representation for GetSpecificationsRequest
   */
  export interface AsObject {
    itemId: string;
    language: string;
  }

  /**
   * Protobuf JSON representation for GetSpecificationsRequest
   */
  export interface AsProtobufJSON {
    itemId: string;
    language: string;
  }
}

/**
 * Message implementation for goautowp.GetSpecificationsResponse
 */
export class GetSpecificationsResponse implements GrpcMessage {
  static id = 'goautowp.GetSpecificationsResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetSpecificationsResponse();
    GetSpecificationsResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetSpecificationsResponse) {
    _instance.html = _instance.html || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetSpecificationsResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.html = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    GetSpecificationsResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetSpecificationsResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.html) {
      _writer.writeString(1, _instance.html);
    }
  }

  private _html: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetSpecificationsResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetSpecificationsResponse.AsObject>) {
    _value = _value || {};
    this.html = _value.html;
    GetSpecificationsResponse.refineValues(this);
  }
  get html(): string {
    return this._html;
  }
  set html(value: string) {
    this._html = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetSpecificationsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetSpecificationsResponse.AsObject {
    return {
      html: this.html
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetSpecificationsResponse.AsProtobufJSON {
    return {
      html: this.html
    };
  }
}
export module GetSpecificationsResponse {
  /**
   * Standard JavaScript object representation for GetSpecificationsResponse
   */
  export interface AsObject {
    html: string;
  }

  /**
   * Protobuf JSON representation for GetSpecificationsResponse
   */
  export interface AsProtobufJSON {
    html: string;
  }
}

/**
 * Message implementation for goautowp.AttrUserValue
 */
export class AttrUserValue implements GrpcMessage {
  static id = 'goautowp.AttrUserValue';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrUserValue();
    AttrUserValue.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrUserValue) {
    _instance.attributeId = _instance.attributeId || '0';
    _instance.itemId = _instance.itemId || '0';
    _instance.userId = _instance.userId || '0';
    _instance.value = _instance.value || undefined;
    _instance.valueText = _instance.valueText || '';
    _instance.updateDate = _instance.updateDate || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrUserValue,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.attributeId = _reader.readInt64String();
          break;
        case 2:
          _instance.itemId = _reader.readInt64String();
          break;
        case 3:
          _instance.userId = _reader.readInt64String();
          break;
        case 4:
          _instance.value = new AttrValueValue();
          _reader.readMessage(
            _instance.value,
            AttrValueValue.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.valueText = _reader.readString();
          break;
        case 6:
          _instance.updateDate = new googleProtobuf006.Timestamp();
          _reader.readMessage(
            _instance.updateDate,
            googleProtobuf006.Timestamp.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    AttrUserValue.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrUserValue,
    _writer: BinaryWriter
  ) {
    if (_instance.attributeId) {
      _writer.writeInt64String(1, _instance.attributeId);
    }
    if (_instance.itemId) {
      _writer.writeInt64String(2, _instance.itemId);
    }
    if (_instance.userId) {
      _writer.writeInt64String(3, _instance.userId);
    }
    if (_instance.value) {
      _writer.writeMessage(
        4,
        _instance.value as any,
        AttrValueValue.serializeBinaryToWriter
      );
    }
    if (_instance.valueText) {
      _writer.writeString(5, _instance.valueText);
    }
    if (_instance.updateDate) {
      _writer.writeMessage(
        6,
        _instance.updateDate as any,
        googleProtobuf006.Timestamp.serializeBinaryToWriter
      );
    }
  }

  private _attributeId: string;
  private _itemId: string;
  private _userId: string;
  private _value?: AttrValueValue;
  private _valueText: string;
  private _updateDate?: googleProtobuf006.Timestamp;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrUserValue to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrUserValue.AsObject>) {
    _value = _value || {};
    this.attributeId = _value.attributeId;
    this.itemId = _value.itemId;
    this.userId = _value.userId;
    this.value = _value.value ? new AttrValueValue(_value.value) : undefined;
    this.valueText = _value.valueText;
    this.updateDate = _value.updateDate
      ? new googleProtobuf006.Timestamp(_value.updateDate)
      : undefined;
    AttrUserValue.refineValues(this);
  }
  get attributeId(): string {
    return this._attributeId;
  }
  set attributeId(value: string) {
    this._attributeId = value;
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }
  get value(): AttrValueValue | undefined {
    return this._value;
  }
  set value(value: AttrValueValue | undefined) {
    this._value = value;
  }
  get valueText(): string {
    return this._valueText;
  }
  set valueText(value: string) {
    this._valueText = value;
  }
  get updateDate(): googleProtobuf006.Timestamp | undefined {
    return this._updateDate;
  }
  set updateDate(value: googleProtobuf006.Timestamp | undefined) {
    this._updateDate = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrUserValue.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrUserValue.AsObject {
    return {
      attributeId: this.attributeId,
      itemId: this.itemId,
      userId: this.userId,
      value: this.value ? this.value.toObject() : undefined,
      valueText: this.valueText,
      updateDate: this.updateDate ? this.updateDate.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrUserValue.AsProtobufJSON {
    return {
      attributeId: this.attributeId,
      itemId: this.itemId,
      userId: this.userId,
      value: this.value ? this.value.toProtobufJSON(options) : null,
      valueText: this.valueText,
      updateDate: this.updateDate
        ? this.updateDate.toProtobufJSON(options)
        : null
    };
  }
}
export module AttrUserValue {
  /**
   * Standard JavaScript object representation for AttrUserValue
   */
  export interface AsObject {
    attributeId: string;
    itemId: string;
    userId: string;
    value?: AttrValueValue.AsObject;
    valueText: string;
    updateDate?: googleProtobuf006.Timestamp.AsObject;
  }

  /**
   * Protobuf JSON representation for AttrUserValue
   */
  export interface AsProtobufJSON {
    attributeId: string;
    itemId: string;
    userId: string;
    value: AttrValueValue.AsProtobufJSON | null;
    valueText: string;
    updateDate: googleProtobuf006.Timestamp.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.AttrUserValuesResponse
 */
export class AttrUserValuesResponse implements GrpcMessage {
  static id = 'goautowp.AttrUserValuesResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrUserValuesResponse();
    AttrUserValuesResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrUserValuesResponse) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrUserValuesResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new AttrUserValue();
          _reader.readMessage(
            messageInitializer1,
            AttrUserValue.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    AttrUserValuesResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrUserValuesResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        AttrUserValue.serializeBinaryToWriter
      );
    }
  }

  private _items?: AttrUserValue[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrUserValuesResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrUserValuesResponse.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new AttrUserValue(m));
    AttrUserValuesResponse.refineValues(this);
  }
  get items(): AttrUserValue[] | undefined {
    return this._items;
  }
  set items(value: AttrUserValue[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrUserValuesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrUserValuesResponse.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrUserValuesResponse.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module AttrUserValuesResponse {
  /**
   * Standard JavaScript object representation for AttrUserValuesResponse
   */
  export interface AsObject {
    items?: AttrUserValue.AsObject[];
  }

  /**
   * Protobuf JSON representation for AttrUserValuesResponse
   */
  export interface AsProtobufJSON {
    items: AttrUserValue.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.AttrValuesRequest
 */
export class AttrValuesRequest implements GrpcMessage {
  static id = 'goautowp.AttrValuesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrValuesRequest();
    AttrValuesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrValuesRequest) {
    _instance.zoneId = _instance.zoneId || '0';
    _instance.itemId = _instance.itemId || '0';
    _instance.language = _instance.language || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrValuesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.zoneId = _reader.readInt64String();
          break;
        case 2:
          _instance.itemId = _reader.readInt64String();
          break;
        case 5:
          _instance.language = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    AttrValuesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrValuesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.zoneId) {
      _writer.writeInt64String(1, _instance.zoneId);
    }
    if (_instance.itemId) {
      _writer.writeInt64String(2, _instance.itemId);
    }
    if (_instance.language) {
      _writer.writeString(5, _instance.language);
    }
  }

  private _zoneId: string;
  private _itemId: string;
  private _language: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrValuesRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrValuesRequest.AsObject>) {
    _value = _value || {};
    this.zoneId = _value.zoneId;
    this.itemId = _value.itemId;
    this.language = _value.language;
    AttrValuesRequest.refineValues(this);
  }
  get zoneId(): string {
    return this._zoneId;
  }
  set zoneId(value: string) {
    this._zoneId = value;
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrValuesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrValuesRequest.AsObject {
    return {
      zoneId: this.zoneId,
      itemId: this.itemId,
      language: this.language
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrValuesRequest.AsProtobufJSON {
    return {
      zoneId: this.zoneId,
      itemId: this.itemId,
      language: this.language
    };
  }
}
export module AttrValuesRequest {
  /**
   * Standard JavaScript object representation for AttrValuesRequest
   */
  export interface AsObject {
    zoneId: string;
    itemId: string;
    language: string;
  }

  /**
   * Protobuf JSON representation for AttrValuesRequest
   */
  export interface AsProtobufJSON {
    zoneId: string;
    itemId: string;
    language: string;
  }
}

/**
 * Message implementation for goautowp.AttrValuesResponse
 */
export class AttrValuesResponse implements GrpcMessage {
  static id = 'goautowp.AttrValuesResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrValuesResponse();
    AttrValuesResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrValuesResponse) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrValuesResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new AttrValue();
          _reader.readMessage(
            messageInitializer1,
            AttrValue.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    AttrValuesResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrValuesResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        AttrValue.serializeBinaryToWriter
      );
    }
  }

  private _items?: AttrValue[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrValuesResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrValuesResponse.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new AttrValue(m));
    AttrValuesResponse.refineValues(this);
  }
  get items(): AttrValue[] | undefined {
    return this._items;
  }
  set items(value: AttrValue[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrValuesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrValuesResponse.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrValuesResponse.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module AttrValuesResponse {
  /**
   * Standard JavaScript object representation for AttrValuesResponse
   */
  export interface AsObject {
    items?: AttrValue.AsObject[];
  }

  /**
   * Protobuf JSON representation for AttrValuesResponse
   */
  export interface AsProtobufJSON {
    items: AttrValue.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.AttrValueValue
 */
export class AttrValueValue implements GrpcMessage {
  static id = 'goautowp.AttrValueValue';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrValueValue();
    AttrValueValue.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrValueValue) {
    _instance.valid = _instance.valid || false;
    _instance.intValue = _instance.intValue || 0;
    _instance.floatValue = _instance.floatValue || 0;
    _instance.stringValue = _instance.stringValue || '';
    _instance.boolValue = _instance.boolValue || false;
    _instance.listValue = _instance.listValue || [];
    _instance.type = _instance.type || 0;
    _instance.isEmpty = _instance.isEmpty || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrValueValue,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.valid = _reader.readBool();
          break;
        case 2:
          _instance.intValue = _reader.readInt32();
          break;
        case 3:
          _instance.floatValue = _reader.readDouble();
          break;
        case 4:
          _instance.stringValue = _reader.readString();
          break;
        case 5:
          _instance.boolValue = _reader.readBool();
          break;
        case 6:
          (_instance.listValue = _instance.listValue || []).push(
            ...(_reader.readPackedInt64String() || [])
          );
          break;
        case 7:
          _instance.type = _reader.readEnum();
          break;
        case 8:
          _instance.isEmpty = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    AttrValueValue.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AttrValueValue,
    _writer: BinaryWriter
  ) {
    if (_instance.valid) {
      _writer.writeBool(1, _instance.valid);
    }
    if (_instance.intValue) {
      _writer.writeInt32(2, _instance.intValue);
    }
    if (_instance.floatValue) {
      _writer.writeDouble(3, _instance.floatValue);
    }
    if (_instance.stringValue) {
      _writer.writeString(4, _instance.stringValue);
    }
    if (_instance.boolValue) {
      _writer.writeBool(5, _instance.boolValue);
    }
    if (_instance.listValue && _instance.listValue.length) {
      _writer.writePackedInt64String(6, _instance.listValue);
    }
    if (_instance.type) {
      _writer.writeEnum(7, _instance.type);
    }
    if (_instance.isEmpty) {
      _writer.writeBool(8, _instance.isEmpty);
    }
  }

  private _valid: boolean;
  private _intValue: number;
  private _floatValue: number;
  private _stringValue: string;
  private _boolValue: boolean;
  private _listValue: string[];
  private _type: AttrAttributeType.ID;
  private _isEmpty: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrValueValue to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrValueValue.AsObject>) {
    _value = _value || {};
    this.valid = _value.valid;
    this.intValue = _value.intValue;
    this.floatValue = _value.floatValue;
    this.stringValue = _value.stringValue;
    this.boolValue = _value.boolValue;
    this.listValue = (_value.listValue || []).slice();
    this.type = _value.type;
    this.isEmpty = _value.isEmpty;
    AttrValueValue.refineValues(this);
  }
  get valid(): boolean {
    return this._valid;
  }
  set valid(value: boolean) {
    this._valid = value;
  }
  get intValue(): number {
    return this._intValue;
  }
  set intValue(value: number) {
    this._intValue = value;
  }
  get floatValue(): number {
    return this._floatValue;
  }
  set floatValue(value: number) {
    this._floatValue = value;
  }
  get stringValue(): string {
    return this._stringValue;
  }
  set stringValue(value: string) {
    this._stringValue = value;
  }
  get boolValue(): boolean {
    return this._boolValue;
  }
  set boolValue(value: boolean) {
    this._boolValue = value;
  }
  get listValue(): string[] {
    return this._listValue;
  }
  set listValue(value: string[]) {
    this._listValue = value;
  }
  get type(): AttrAttributeType.ID {
    return this._type;
  }
  set type(value: AttrAttributeType.ID) {
    this._type = value;
  }
  get isEmpty(): boolean {
    return this._isEmpty;
  }
  set isEmpty(value: boolean) {
    this._isEmpty = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrValueValue.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrValueValue.AsObject {
    return {
      valid: this.valid,
      intValue: this.intValue,
      floatValue: this.floatValue,
      stringValue: this.stringValue,
      boolValue: this.boolValue,
      listValue: (this.listValue || []).slice(),
      type: this.type,
      isEmpty: this.isEmpty
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrValueValue.AsProtobufJSON {
    return {
      valid: this.valid,
      intValue: this.intValue,
      floatValue: this.floatValue,
      stringValue: this.stringValue,
      boolValue: this.boolValue,
      listValue: (this.listValue || []).slice(),
      type:
        AttrAttributeType.ID[
          this.type === null || this.type === undefined ? 0 : this.type
        ],
      isEmpty: this.isEmpty
    };
  }
}
export module AttrValueValue {
  /**
   * Standard JavaScript object representation for AttrValueValue
   */
  export interface AsObject {
    valid: boolean;
    intValue: number;
    floatValue: number;
    stringValue: string;
    boolValue: boolean;
    listValue: string[];
    type: AttrAttributeType.ID;
    isEmpty: boolean;
  }

  /**
   * Protobuf JSON representation for AttrValueValue
   */
  export interface AsProtobufJSON {
    valid: boolean;
    intValue: number;
    floatValue: number;
    stringValue: string;
    boolValue: boolean;
    listValue: string[];
    type: string;
    isEmpty: boolean;
  }
}

/**
 * Message implementation for goautowp.AttrValue
 */
export class AttrValue implements GrpcMessage {
  static id = 'goautowp.AttrValue';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AttrValue();
    AttrValue.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AttrValue) {
    _instance.attributeId = _instance.attributeId || '0';
    _instance.itemId = _instance.itemId || '0';
    _instance.value = _instance.value || undefined;
    _instance.valueText = _instance.valueText || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AttrValue,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.attributeId = _reader.readInt64String();
          break;
        case 2:
          _instance.itemId = _reader.readInt64String();
          break;
        case 3:
          _instance.value = new AttrValueValue();
          _reader.readMessage(
            _instance.value,
            AttrValueValue.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.valueText = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    AttrValue.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: AttrValue, _writer: BinaryWriter) {
    if (_instance.attributeId) {
      _writer.writeInt64String(1, _instance.attributeId);
    }
    if (_instance.itemId) {
      _writer.writeInt64String(2, _instance.itemId);
    }
    if (_instance.value) {
      _writer.writeMessage(
        3,
        _instance.value as any,
        AttrValueValue.serializeBinaryToWriter
      );
    }
    if (_instance.valueText) {
      _writer.writeString(4, _instance.valueText);
    }
  }

  private _attributeId: string;
  private _itemId: string;
  private _value?: AttrValueValue;
  private _valueText: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AttrValue to deeply clone from
   */
  constructor(_value?: RecursivePartial<AttrValue.AsObject>) {
    _value = _value || {};
    this.attributeId = _value.attributeId;
    this.itemId = _value.itemId;
    this.value = _value.value ? new AttrValueValue(_value.value) : undefined;
    this.valueText = _value.valueText;
    AttrValue.refineValues(this);
  }
  get attributeId(): string {
    return this._attributeId;
  }
  set attributeId(value: string) {
    this._attributeId = value;
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get value(): AttrValueValue | undefined {
    return this._value;
  }
  set value(value: AttrValueValue | undefined) {
    this._value = value;
  }
  get valueText(): string {
    return this._valueText;
  }
  set valueText(value: string) {
    this._valueText = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AttrValue.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AttrValue.AsObject {
    return {
      attributeId: this.attributeId,
      itemId: this.itemId,
      value: this.value ? this.value.toObject() : undefined,
      valueText: this.valueText
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AttrValue.AsProtobufJSON {
    return {
      attributeId: this.attributeId,
      itemId: this.itemId,
      value: this.value ? this.value.toProtobufJSON(options) : null,
      valueText: this.valueText
    };
  }
}
export module AttrValue {
  /**
   * Standard JavaScript object representation for AttrValue
   */
  export interface AsObject {
    attributeId: string;
    itemId: string;
    value?: AttrValueValue.AsObject;
    valueText: string;
  }

  /**
   * Protobuf JSON representation for AttrValue
   */
  export interface AsProtobufJSON {
    attributeId: string;
    itemId: string;
    value: AttrValueValue.AsProtobufJSON | null;
    valueText: string;
  }
}

/**
 * Message implementation for goautowp.PulseRequest
 */
export class PulseRequest implements GrpcMessage {
  static id = 'goautowp.PulseRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PulseRequest();
    PulseRequest.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PulseRequest) {
    _instance.period = _instance.period || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PulseRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.period = _reader.readEnum();
          break;
        default:
          _reader.skipField();
      }
    }

    PulseRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PulseRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.period) {
      _writer.writeEnum(1, _instance.period);
    }
  }

  private _period: PulseRequest.Period;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PulseRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<PulseRequest.AsObject>) {
    _value = _value || {};
    this.period = _value.period;
    PulseRequest.refineValues(this);
  }
  get period(): PulseRequest.Period {
    return this._period;
  }
  set period(value: PulseRequest.Period) {
    this._period = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PulseRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PulseRequest.AsObject {
    return {
      period: this.period
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PulseRequest.AsProtobufJSON {
    return {
      period:
        PulseRequest.Period[
          this.period === null || this.period === undefined ? 0 : this.period
        ]
    };
  }
}
export module PulseRequest {
  /**
   * Standard JavaScript object representation for PulseRequest
   */
  export interface AsObject {
    period: PulseRequest.Period;
  }

  /**
   * Protobuf JSON representation for PulseRequest
   */
  export interface AsProtobufJSON {
    period: string;
  }
  export enum Period {
    DEFAULT = 0,
    YEAR = 1,
    MONTH = 2
  }
}

/**
 * Message implementation for goautowp.PulseGrid
 */
export class PulseGrid implements GrpcMessage {
  static id = 'goautowp.PulseGrid';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PulseGrid();
    PulseGrid.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PulseGrid) {
    _instance.line = _instance.line || [];
    _instance.color = _instance.color || '';
    _instance.userId = _instance.userId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PulseGrid,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          (_instance.line = _instance.line || []).push(
            ...(_reader.readPackedFloat() || [])
          );
          break;
        case 2:
          _instance.color = _reader.readString();
          break;
        case 3:
          _instance.userId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    PulseGrid.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: PulseGrid, _writer: BinaryWriter) {
    if (_instance.line && _instance.line.length) {
      _writer.writePackedFloat(1, _instance.line);
    }
    if (_instance.color) {
      _writer.writeString(2, _instance.color);
    }
    if (_instance.userId) {
      _writer.writeInt64String(3, _instance.userId);
    }
  }

  private _line: number[];
  private _color: string;
  private _userId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PulseGrid to deeply clone from
   */
  constructor(_value?: RecursivePartial<PulseGrid.AsObject>) {
    _value = _value || {};
    this.line = (_value.line || []).slice();
    this.color = _value.color;
    this.userId = _value.userId;
    PulseGrid.refineValues(this);
  }
  get line(): number[] {
    return this._line;
  }
  set line(value: number[]) {
    this._line = value;
  }
  get color(): string {
    return this._color;
  }
  set color(value: string) {
    this._color = value;
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PulseGrid.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PulseGrid.AsObject {
    return {
      line: (this.line || []).slice(),
      color: this.color,
      userId: this.userId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PulseGrid.AsProtobufJSON {
    return {
      line: (this.line || []).slice(),
      color: this.color,
      userId: this.userId
    };
  }
}
export module PulseGrid {
  /**
   * Standard JavaScript object representation for PulseGrid
   */
  export interface AsObject {
    line: number[];
    color: string;
    userId: string;
  }

  /**
   * Protobuf JSON representation for PulseGrid
   */
  export interface AsProtobufJSON {
    line: number[];
    color: string;
    userId: string;
  }
}

/**
 * Message implementation for goautowp.PulseLegend
 */
export class PulseLegend implements GrpcMessage {
  static id = 'goautowp.PulseLegend';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PulseLegend();
    PulseLegend.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PulseLegend) {
    _instance.userId = _instance.userId || '0';
    _instance.color = _instance.color || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PulseLegend,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.userId = _reader.readInt64String();
          break;
        case 2:
          _instance.color = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    PulseLegend.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PulseLegend,
    _writer: BinaryWriter
  ) {
    if (_instance.userId) {
      _writer.writeInt64String(1, _instance.userId);
    }
    if (_instance.color) {
      _writer.writeString(2, _instance.color);
    }
  }

  private _userId: string;
  private _color: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PulseLegend to deeply clone from
   */
  constructor(_value?: RecursivePartial<PulseLegend.AsObject>) {
    _value = _value || {};
    this.userId = _value.userId;
    this.color = _value.color;
    PulseLegend.refineValues(this);
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }
  get color(): string {
    return this._color;
  }
  set color(value: string) {
    this._color = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PulseLegend.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PulseLegend.AsObject {
    return {
      userId: this.userId,
      color: this.color
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PulseLegend.AsProtobufJSON {
    return {
      userId: this.userId,
      color: this.color
    };
  }
}
export module PulseLegend {
  /**
   * Standard JavaScript object representation for PulseLegend
   */
  export interface AsObject {
    userId: string;
    color: string;
  }

  /**
   * Protobuf JSON representation for PulseLegend
   */
  export interface AsProtobufJSON {
    userId: string;
    color: string;
  }
}

/**
 * Message implementation for goautowp.PulseResponse
 */
export class PulseResponse implements GrpcMessage {
  static id = 'goautowp.PulseResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PulseResponse();
    PulseResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PulseResponse) {
    _instance.grid = _instance.grid || [];
    _instance.legend = _instance.legend || [];
    _instance.labels = _instance.labels || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PulseResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new PulseGrid();
          _reader.readMessage(
            messageInitializer1,
            PulseGrid.deserializeBinaryFromReader
          );
          (_instance.grid = _instance.grid || []).push(messageInitializer1);
          break;
        case 2:
          const messageInitializer2 = new PulseLegend();
          _reader.readMessage(
            messageInitializer2,
            PulseLegend.deserializeBinaryFromReader
          );
          (_instance.legend = _instance.legend || []).push(messageInitializer2);
          break;
        case 3:
          (_instance.labels = _instance.labels || []).push(
            _reader.readString()
          );
          break;
        default:
          _reader.skipField();
      }
    }

    PulseResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PulseResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.grid && _instance.grid.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.grid as any,
        PulseGrid.serializeBinaryToWriter
      );
    }
    if (_instance.legend && _instance.legend.length) {
      _writer.writeRepeatedMessage(
        2,
        _instance.legend as any,
        PulseLegend.serializeBinaryToWriter
      );
    }
    if (_instance.labels && _instance.labels.length) {
      _writer.writeRepeatedString(3, _instance.labels);
    }
  }

  private _grid?: PulseGrid[];
  private _legend?: PulseLegend[];
  private _labels: string[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PulseResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<PulseResponse.AsObject>) {
    _value = _value || {};
    this.grid = (_value.grid || []).map(m => new PulseGrid(m));
    this.legend = (_value.legend || []).map(m => new PulseLegend(m));
    this.labels = (_value.labels || []).slice();
    PulseResponse.refineValues(this);
  }
  get grid(): PulseGrid[] | undefined {
    return this._grid;
  }
  set grid(value: PulseGrid[] | undefined) {
    this._grid = value;
  }
  get legend(): PulseLegend[] | undefined {
    return this._legend;
  }
  set legend(value: PulseLegend[] | undefined) {
    this._legend = value;
  }
  get labels(): string[] {
    return this._labels;
  }
  set labels(value: string[]) {
    this._labels = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PulseResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PulseResponse.AsObject {
    return {
      grid: (this.grid || []).map(m => m.toObject()),
      legend: (this.legend || []).map(m => m.toObject()),
      labels: (this.labels || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PulseResponse.AsProtobufJSON {
    return {
      grid: (this.grid || []).map(m => m.toProtobufJSON(options)),
      legend: (this.legend || []).map(m => m.toProtobufJSON(options)),
      labels: (this.labels || []).slice()
    };
  }
}
export module PulseResponse {
  /**
   * Standard JavaScript object representation for PulseResponse
   */
  export interface AsObject {
    grid?: PulseGrid.AsObject[];
    legend?: PulseLegend.AsObject[];
    labels: string[];
  }

  /**
   * Protobuf JSON representation for PulseResponse
   */
  export interface AsProtobufJSON {
    grid: PulseGrid.AsProtobufJSON[] | null;
    legend: PulseLegend.AsProtobufJSON[] | null;
    labels: string[];
  }
}

/**
 * Message implementation for goautowp.Spec
 */
export class Spec implements GrpcMessage {
  static id = 'goautowp.Spec';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Spec();
    Spec.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Spec) {
    _instance.id = _instance.id || 0;
    _instance.name = _instance.name || '';
    _instance.shortName = _instance.shortName || '';
    _instance.childs = _instance.childs || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(_instance: Spec, _reader: BinaryReader) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        case 3:
          _instance.shortName = _reader.readString();
          break;
        case 4:
          const messageInitializer4 = new Spec();
          _reader.readMessage(
            messageInitializer4,
            Spec.deserializeBinaryFromReader
          );
          (_instance.childs = _instance.childs || []).push(messageInitializer4);
          break;
        default:
          _reader.skipField();
      }
    }

    Spec.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Spec, _writer: BinaryWriter) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
    if (_instance.shortName) {
      _writer.writeString(3, _instance.shortName);
    }
    if (_instance.childs && _instance.childs.length) {
      _writer.writeRepeatedMessage(
        4,
        _instance.childs as any,
        Spec.serializeBinaryToWriter
      );
    }
  }

  private _id: number;
  private _name: string;
  private _shortName: string;
  private _childs?: Spec[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Spec to deeply clone from
   */
  constructor(_value?: RecursivePartial<Spec.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.name = _value.name;
    this.shortName = _value.shortName;
    this.childs = (_value.childs || []).map(m => new Spec(m));
    Spec.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get shortName(): string {
    return this._shortName;
  }
  set shortName(value: string) {
    this._shortName = value;
  }
  get childs(): Spec[] | undefined {
    return this._childs;
  }
  set childs(value: Spec[] | undefined) {
    this._childs = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Spec.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Spec.AsObject {
    return {
      id: this.id,
      name: this.name,
      shortName: this.shortName,
      childs: (this.childs || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Spec.AsProtobufJSON {
    return {
      id: this.id,
      name: this.name,
      shortName: this.shortName,
      childs: (this.childs || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module Spec {
  /**
   * Standard JavaScript object representation for Spec
   */
  export interface AsObject {
    id: number;
    name: string;
    shortName: string;
    childs?: Spec.AsObject[];
  }

  /**
   * Protobuf JSON representation for Spec
   */
  export interface AsProtobufJSON {
    id: number;
    name: string;
    shortName: string;
    childs: Spec.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.SpecsItems
 */
export class SpecsItems implements GrpcMessage {
  static id = 'goautowp.SpecsItems';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SpecsItems();
    SpecsItems.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SpecsItems) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SpecsItems,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new Spec();
          _reader.readMessage(
            messageInitializer1,
            Spec.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    SpecsItems.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: SpecsItems, _writer: BinaryWriter) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        Spec.serializeBinaryToWriter
      );
    }
  }

  private _items?: Spec[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SpecsItems to deeply clone from
   */
  constructor(_value?: RecursivePartial<SpecsItems.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new Spec(m));
    SpecsItems.refineValues(this);
  }
  get items(): Spec[] | undefined {
    return this._items;
  }
  set items(value: Spec[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SpecsItems.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SpecsItems.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SpecsItems.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module SpecsItems {
  /**
   * Standard JavaScript object representation for SpecsItems
   */
  export interface AsObject {
    items?: Spec.AsObject[];
  }

  /**
   * Protobuf JSON representation for SpecsItems
   */
  export interface AsProtobufJSON {
    items: Spec.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.Perspective
 */
export class Perspective implements GrpcMessage {
  static id = 'goautowp.Perspective';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Perspective();
    Perspective.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Perspective) {
    _instance.id = _instance.id || 0;
    _instance.name = _instance.name || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: Perspective,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    Perspective.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: Perspective,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
  }

  private _id: number;
  private _name: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Perspective to deeply clone from
   */
  constructor(_value?: RecursivePartial<Perspective.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.name = _value.name;
    Perspective.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Perspective.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Perspective.AsObject {
    return {
      id: this.id,
      name: this.name
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Perspective.AsProtobufJSON {
    return {
      id: this.id,
      name: this.name
    };
  }
}
export module Perspective {
  /**
   * Standard JavaScript object representation for Perspective
   */
  export interface AsObject {
    id: number;
    name: string;
  }

  /**
   * Protobuf JSON representation for Perspective
   */
  export interface AsProtobufJSON {
    id: number;
    name: string;
  }
}

/**
 * Message implementation for goautowp.PerspectivesItems
 */
export class PerspectivesItems implements GrpcMessage {
  static id = 'goautowp.PerspectivesItems';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PerspectivesItems();
    PerspectivesItems.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PerspectivesItems) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PerspectivesItems,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new Perspective();
          _reader.readMessage(
            messageInitializer1,
            Perspective.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    PerspectivesItems.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PerspectivesItems,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        Perspective.serializeBinaryToWriter
      );
    }
  }

  private _items?: Perspective[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PerspectivesItems to deeply clone from
   */
  constructor(_value?: RecursivePartial<PerspectivesItems.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new Perspective(m));
    PerspectivesItems.refineValues(this);
  }
  get items(): Perspective[] | undefined {
    return this._items;
  }
  set items(value: Perspective[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PerspectivesItems.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PerspectivesItems.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PerspectivesItems.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module PerspectivesItems {
  /**
   * Standard JavaScript object representation for PerspectivesItems
   */
  export interface AsObject {
    items?: Perspective.AsObject[];
  }

  /**
   * Protobuf JSON representation for PerspectivesItems
   */
  export interface AsProtobufJSON {
    items: Perspective.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.PerspectiveGroup
 */
export class PerspectiveGroup implements GrpcMessage {
  static id = 'goautowp.PerspectiveGroup';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PerspectiveGroup();
    PerspectiveGroup.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PerspectiveGroup) {
    _instance.id = _instance.id || 0;
    _instance.name = _instance.name || '';
    _instance.perspectives = _instance.perspectives || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PerspectiveGroup,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        case 3:
          const messageInitializer3 = new Perspective();
          _reader.readMessage(
            messageInitializer3,
            Perspective.deserializeBinaryFromReader
          );
          (_instance.perspectives = _instance.perspectives || []).push(
            messageInitializer3
          );
          break;
        default:
          _reader.skipField();
      }
    }

    PerspectiveGroup.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PerspectiveGroup,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
    if (_instance.perspectives && _instance.perspectives.length) {
      _writer.writeRepeatedMessage(
        3,
        _instance.perspectives as any,
        Perspective.serializeBinaryToWriter
      );
    }
  }

  private _id: number;
  private _name: string;
  private _perspectives?: Perspective[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PerspectiveGroup to deeply clone from
   */
  constructor(_value?: RecursivePartial<PerspectiveGroup.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.name = _value.name;
    this.perspectives = (_value.perspectives || []).map(
      m => new Perspective(m)
    );
    PerspectiveGroup.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get perspectives(): Perspective[] | undefined {
    return this._perspectives;
  }
  set perspectives(value: Perspective[] | undefined) {
    this._perspectives = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PerspectiveGroup.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PerspectiveGroup.AsObject {
    return {
      id: this.id,
      name: this.name,
      perspectives: (this.perspectives || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PerspectiveGroup.AsProtobufJSON {
    return {
      id: this.id,
      name: this.name,
      perspectives: (this.perspectives || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module PerspectiveGroup {
  /**
   * Standard JavaScript object representation for PerspectiveGroup
   */
  export interface AsObject {
    id: number;
    name: string;
    perspectives?: Perspective.AsObject[];
  }

  /**
   * Protobuf JSON representation for PerspectiveGroup
   */
  export interface AsProtobufJSON {
    id: number;
    name: string;
    perspectives: Perspective.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.PerspectivePage
 */
export class PerspectivePage implements GrpcMessage {
  static id = 'goautowp.PerspectivePage';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PerspectivePage();
    PerspectivePage.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PerspectivePage) {
    _instance.id = _instance.id || 0;
    _instance.name = _instance.name || '';
    _instance.groups = _instance.groups || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PerspectivePage,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        case 3:
          const messageInitializer3 = new PerspectiveGroup();
          _reader.readMessage(
            messageInitializer3,
            PerspectiveGroup.deserializeBinaryFromReader
          );
          (_instance.groups = _instance.groups || []).push(messageInitializer3);
          break;
        default:
          _reader.skipField();
      }
    }

    PerspectivePage.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PerspectivePage,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
    if (_instance.groups && _instance.groups.length) {
      _writer.writeRepeatedMessage(
        3,
        _instance.groups as any,
        PerspectiveGroup.serializeBinaryToWriter
      );
    }
  }

  private _id: number;
  private _name: string;
  private _groups?: PerspectiveGroup[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PerspectivePage to deeply clone from
   */
  constructor(_value?: RecursivePartial<PerspectivePage.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.name = _value.name;
    this.groups = (_value.groups || []).map(m => new PerspectiveGroup(m));
    PerspectivePage.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get groups(): PerspectiveGroup[] | undefined {
    return this._groups;
  }
  set groups(value: PerspectiveGroup[] | undefined) {
    this._groups = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PerspectivePage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PerspectivePage.AsObject {
    return {
      id: this.id,
      name: this.name,
      groups: (this.groups || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PerspectivePage.AsProtobufJSON {
    return {
      id: this.id,
      name: this.name,
      groups: (this.groups || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module PerspectivePage {
  /**
   * Standard JavaScript object representation for PerspectivePage
   */
  export interface AsObject {
    id: number;
    name: string;
    groups?: PerspectiveGroup.AsObject[];
  }

  /**
   * Protobuf JSON representation for PerspectivePage
   */
  export interface AsProtobufJSON {
    id: number;
    name: string;
    groups: PerspectiveGroup.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.PerspectivePagesItems
 */
export class PerspectivePagesItems implements GrpcMessage {
  static id = 'goautowp.PerspectivePagesItems';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PerspectivePagesItems();
    PerspectivePagesItems.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PerspectivePagesItems) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PerspectivePagesItems,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new PerspectivePage();
          _reader.readMessage(
            messageInitializer1,
            PerspectivePage.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    PerspectivePagesItems.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PerspectivePagesItems,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        PerspectivePage.serializeBinaryToWriter
      );
    }
  }

  private _items?: PerspectivePage[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PerspectivePagesItems to deeply clone from
   */
  constructor(_value?: RecursivePartial<PerspectivePagesItems.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new PerspectivePage(m));
    PerspectivePagesItems.refineValues(this);
  }
  get items(): PerspectivePage[] | undefined {
    return this._items;
  }
  set items(value: PerspectivePage[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PerspectivePagesItems.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PerspectivePagesItems.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PerspectivePagesItems.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module PerspectivePagesItems {
  /**
   * Standard JavaScript object representation for PerspectivePagesItems
   */
  export interface AsObject {
    items?: PerspectivePage.AsObject[];
  }

  /**
   * Protobuf JSON representation for PerspectivePagesItems
   */
  export interface AsProtobufJSON {
    items: PerspectivePage.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.ReCaptchaConfig
 */
export class ReCaptchaConfig implements GrpcMessage {
  static id = 'goautowp.ReCaptchaConfig';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ReCaptchaConfig();
    ReCaptchaConfig.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ReCaptchaConfig) {
    _instance.publicKey = _instance.publicKey || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ReCaptchaConfig,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.publicKey = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    ReCaptchaConfig.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ReCaptchaConfig,
    _writer: BinaryWriter
  ) {
    if (_instance.publicKey) {
      _writer.writeString(1, _instance.publicKey);
    }
  }

  private _publicKey: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ReCaptchaConfig to deeply clone from
   */
  constructor(_value?: RecursivePartial<ReCaptchaConfig.AsObject>) {
    _value = _value || {};
    this.publicKey = _value.publicKey;
    ReCaptchaConfig.refineValues(this);
  }
  get publicKey(): string {
    return this._publicKey;
  }
  set publicKey(value: string) {
    this._publicKey = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ReCaptchaConfig.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ReCaptchaConfig.AsObject {
    return {
      publicKey: this.publicKey
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ReCaptchaConfig.AsProtobufJSON {
    return {
      publicKey: this.publicKey
    };
  }
}
export module ReCaptchaConfig {
  /**
   * Standard JavaScript object representation for ReCaptchaConfig
   */
  export interface AsObject {
    publicKey: string;
  }

  /**
   * Protobuf JSON representation for ReCaptchaConfig
   */
  export interface AsProtobufJSON {
    publicKey: string;
  }
}

/**
 * Message implementation for goautowp.BrandIcons
 */
export class BrandIcons implements GrpcMessage {
  static id = 'goautowp.BrandIcons';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new BrandIcons();
    BrandIcons.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: BrandIcons) {
    _instance.image = _instance.image || '';
    _instance.css = _instance.css || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: BrandIcons,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.image = _reader.readString();
          break;
        case 2:
          _instance.css = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    BrandIcons.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: BrandIcons, _writer: BinaryWriter) {
    if (_instance.image) {
      _writer.writeString(1, _instance.image);
    }
    if (_instance.css) {
      _writer.writeString(2, _instance.css);
    }
  }

  private _image: string;
  private _css: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of BrandIcons to deeply clone from
   */
  constructor(_value?: RecursivePartial<BrandIcons.AsObject>) {
    _value = _value || {};
    this.image = _value.image;
    this.css = _value.css;
    BrandIcons.refineValues(this);
  }
  get image(): string {
    return this._image;
  }
  set image(value: string) {
    this._image = value;
  }
  get css(): string {
    return this._css;
  }
  set css(value: string) {
    this._css = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    BrandIcons.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): BrandIcons.AsObject {
    return {
      image: this.image,
      css: this.css
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): BrandIcons.AsProtobufJSON {
    return {
      image: this.image,
      css: this.css
    };
  }
}
export module BrandIcons {
  /**
   * Standard JavaScript object representation for BrandIcons
   */
  export interface AsObject {
    image: string;
    css: string;
  }

  /**
   * Protobuf JSON representation for BrandIcons
   */
  export interface AsProtobufJSON {
    image: string;
    css: string;
  }
}

/**
 * Message implementation for goautowp.VehicleType
 */
export class VehicleType implements GrpcMessage {
  static id = 'goautowp.VehicleType';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new VehicleType();
    VehicleType.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: VehicleType) {
    _instance.id = _instance.id || '0';
    _instance.name = _instance.name || '';
    _instance.childs = _instance.childs || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: VehicleType,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        case 4:
          const messageInitializer4 = new VehicleType();
          _reader.readMessage(
            messageInitializer4,
            VehicleType.deserializeBinaryFromReader
          );
          (_instance.childs = _instance.childs || []).push(messageInitializer4);
          break;
        default:
          _reader.skipField();
      }
    }

    VehicleType.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: VehicleType,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
    if (_instance.childs && _instance.childs.length) {
      _writer.writeRepeatedMessage(
        4,
        _instance.childs as any,
        VehicleType.serializeBinaryToWriter
      );
    }
  }

  private _id: string;
  private _name: string;
  private _childs?: VehicleType[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of VehicleType to deeply clone from
   */
  constructor(_value?: RecursivePartial<VehicleType.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.name = _value.name;
    this.childs = (_value.childs || []).map(m => new VehicleType(m));
    VehicleType.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get childs(): VehicleType[] | undefined {
    return this._childs;
  }
  set childs(value: VehicleType[] | undefined) {
    this._childs = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    VehicleType.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): VehicleType.AsObject {
    return {
      id: this.id,
      name: this.name,
      childs: (this.childs || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): VehicleType.AsProtobufJSON {
    return {
      id: this.id,
      name: this.name,
      childs: (this.childs || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module VehicleType {
  /**
   * Standard JavaScript object representation for VehicleType
   */
  export interface AsObject {
    id: string;
    name: string;
    childs?: VehicleType.AsObject[];
  }

  /**
   * Protobuf JSON representation for VehicleType
   */
  export interface AsProtobufJSON {
    id: string;
    name: string;
    childs: VehicleType.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.VehicleTypeItems
 */
export class VehicleTypeItems implements GrpcMessage {
  static id = 'goautowp.VehicleTypeItems';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new VehicleTypeItems();
    VehicleTypeItems.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: VehicleTypeItems) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: VehicleTypeItems,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new VehicleType();
          _reader.readMessage(
            messageInitializer1,
            VehicleType.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    VehicleTypeItems.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: VehicleTypeItems,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        VehicleType.serializeBinaryToWriter
      );
    }
  }

  private _items?: VehicleType[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of VehicleTypeItems to deeply clone from
   */
  constructor(_value?: RecursivePartial<VehicleTypeItems.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new VehicleType(m));
    VehicleTypeItems.refineValues(this);
  }
  get items(): VehicleType[] | undefined {
    return this._items;
  }
  set items(value: VehicleType[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    VehicleTypeItems.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): VehicleTypeItems.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): VehicleTypeItems.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module VehicleTypeItems {
  /**
   * Standard JavaScript object representation for VehicleTypeItems
   */
  export interface AsObject {
    items?: VehicleType.AsObject[];
  }

  /**
   * Protobuf JSON representation for VehicleTypeItems
   */
  export interface AsProtobufJSON {
    items: VehicleType.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.Timezones
 */
export class Timezones implements GrpcMessage {
  static id = 'goautowp.Timezones';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Timezones();
    Timezones.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Timezones) {
    _instance.timezones = _instance.timezones || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: Timezones,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          (_instance.timezones = _instance.timezones || []).push(
            _reader.readString()
          );
          break;
        default:
          _reader.skipField();
      }
    }

    Timezones.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Timezones, _writer: BinaryWriter) {
    if (_instance.timezones && _instance.timezones.length) {
      _writer.writeRepeatedString(1, _instance.timezones);
    }
  }

  private _timezones: string[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Timezones to deeply clone from
   */
  constructor(_value?: RecursivePartial<Timezones.AsObject>) {
    _value = _value || {};
    this.timezones = (_value.timezones || []).slice();
    Timezones.refineValues(this);
  }
  get timezones(): string[] {
    return this._timezones;
  }
  set timezones(value: string[]) {
    this._timezones = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Timezones.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Timezones.AsObject {
    return {
      timezones: (this.timezones || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Timezones.AsProtobufJSON {
    return {
      timezones: (this.timezones || []).slice()
    };
  }
}
export module Timezones {
  /**
   * Standard JavaScript object representation for Timezones
   */
  export interface AsObject {
    timezones: string[];
  }

  /**
   * Protobuf JSON representation for Timezones
   */
  export interface AsProtobufJSON {
    timezones: string[];
  }
}

/**
 * Message implementation for goautowp.GetBrandVehicleTypesRequest
 */
export class GetBrandVehicleTypesRequest implements GrpcMessage {
  static id = 'goautowp.GetBrandVehicleTypesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetBrandVehicleTypesRequest();
    GetBrandVehicleTypesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetBrandVehicleTypesRequest) {
    _instance.brandId = _instance.brandId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetBrandVehicleTypesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.brandId = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    GetBrandVehicleTypesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetBrandVehicleTypesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.brandId) {
      _writer.writeInt32(1, _instance.brandId);
    }
  }

  private _brandId: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetBrandVehicleTypesRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetBrandVehicleTypesRequest.AsObject>) {
    _value = _value || {};
    this.brandId = _value.brandId;
    GetBrandVehicleTypesRequest.refineValues(this);
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetBrandVehicleTypesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetBrandVehicleTypesRequest.AsObject {
    return {
      brandId: this.brandId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetBrandVehicleTypesRequest.AsProtobufJSON {
    return {
      brandId: this.brandId
    };
  }
}
export module GetBrandVehicleTypesRequest {
  /**
   * Standard JavaScript object representation for GetBrandVehicleTypesRequest
   */
  export interface AsObject {
    brandId: number;
  }

  /**
   * Protobuf JSON representation for GetBrandVehicleTypesRequest
   */
  export interface AsProtobufJSON {
    brandId: number;
  }
}

/**
 * Message implementation for goautowp.BrandVehicleTypeItems
 */
export class BrandVehicleTypeItems implements GrpcMessage {
  static id = 'goautowp.BrandVehicleTypeItems';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new BrandVehicleTypeItems();
    BrandVehicleTypeItems.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: BrandVehicleTypeItems) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: BrandVehicleTypeItems,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new BrandVehicleType();
          _reader.readMessage(
            messageInitializer1,
            BrandVehicleType.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    BrandVehicleTypeItems.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: BrandVehicleTypeItems,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        BrandVehicleType.serializeBinaryToWriter
      );
    }
  }

  private _items?: BrandVehicleType[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of BrandVehicleTypeItems to deeply clone from
   */
  constructor(_value?: RecursivePartial<BrandVehicleTypeItems.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new BrandVehicleType(m));
    BrandVehicleTypeItems.refineValues(this);
  }
  get items(): BrandVehicleType[] | undefined {
    return this._items;
  }
  set items(value: BrandVehicleType[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    BrandVehicleTypeItems.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): BrandVehicleTypeItems.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): BrandVehicleTypeItems.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module BrandVehicleTypeItems {
  /**
   * Standard JavaScript object representation for BrandVehicleTypeItems
   */
  export interface AsObject {
    items?: BrandVehicleType.AsObject[];
  }

  /**
   * Protobuf JSON representation for BrandVehicleTypeItems
   */
  export interface AsProtobufJSON {
    items: BrandVehicleType.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.BrandVehicleType
 */
export class BrandVehicleType implements GrpcMessage {
  static id = 'goautowp.BrandVehicleType';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new BrandVehicleType();
    BrandVehicleType.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: BrandVehicleType) {
    _instance.id = _instance.id || 0;
    _instance.name = _instance.name || '';
    _instance.catname = _instance.catname || '';
    _instance.itemsCount = _instance.itemsCount || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: BrandVehicleType,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        case 3:
          _instance.catname = _reader.readString();
          break;
        case 4:
          _instance.itemsCount = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    BrandVehicleType.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: BrandVehicleType,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
    if (_instance.catname) {
      _writer.writeString(3, _instance.catname);
    }
    if (_instance.itemsCount) {
      _writer.writeString(4, _instance.itemsCount);
    }
  }

  private _id: number;
  private _name: string;
  private _catname: string;
  private _itemsCount: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of BrandVehicleType to deeply clone from
   */
  constructor(_value?: RecursivePartial<BrandVehicleType.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.name = _value.name;
    this.catname = _value.catname;
    this.itemsCount = _value.itemsCount;
    BrandVehicleType.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get catname(): string {
    return this._catname;
  }
  set catname(value: string) {
    this._catname = value;
  }
  get itemsCount(): string {
    return this._itemsCount;
  }
  set itemsCount(value: string) {
    this._itemsCount = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    BrandVehicleType.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): BrandVehicleType.AsObject {
    return {
      id: this.id,
      name: this.name,
      catname: this.catname,
      itemsCount: this.itemsCount
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): BrandVehicleType.AsProtobufJSON {
    return {
      id: this.id,
      name: this.name,
      catname: this.catname,
      itemsCount: this.itemsCount
    };
  }
}
export module BrandVehicleType {
  /**
   * Standard JavaScript object representation for BrandVehicleType
   */
  export interface AsObject {
    id: number;
    name: string;
    catname: string;
    itemsCount: string;
  }

  /**
   * Protobuf JSON representation for BrandVehicleType
   */
  export interface AsProtobufJSON {
    id: number;
    name: string;
    catname: string;
    itemsCount: string;
  }
}

/**
 * Message implementation for goautowp.CreateContactRequest
 */
export class CreateContactRequest implements GrpcMessage {
  static id = 'goautowp.CreateContactRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CreateContactRequest();
    CreateContactRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CreateContactRequest) {
    _instance.userId = _instance.userId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CreateContactRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.userId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    CreateContactRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CreateContactRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.userId) {
      _writer.writeInt64String(1, _instance.userId);
    }
  }

  private _userId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CreateContactRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<CreateContactRequest.AsObject>) {
    _value = _value || {};
    this.userId = _value.userId;
    CreateContactRequest.refineValues(this);
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CreateContactRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CreateContactRequest.AsObject {
    return {
      userId: this.userId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CreateContactRequest.AsProtobufJSON {
    return {
      userId: this.userId
    };
  }
}
export module CreateContactRequest {
  /**
   * Standard JavaScript object representation for CreateContactRequest
   */
  export interface AsObject {
    userId: string;
  }

  /**
   * Protobuf JSON representation for CreateContactRequest
   */
  export interface AsProtobufJSON {
    userId: string;
  }
}

/**
 * Message implementation for goautowp.DeleteContactRequest
 */
export class DeleteContactRequest implements GrpcMessage {
  static id = 'goautowp.DeleteContactRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new DeleteContactRequest();
    DeleteContactRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: DeleteContactRequest) {
    _instance.userId = _instance.userId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: DeleteContactRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.userId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    DeleteContactRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: DeleteContactRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.userId) {
      _writer.writeInt64String(1, _instance.userId);
    }
  }

  private _userId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of DeleteContactRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<DeleteContactRequest.AsObject>) {
    _value = _value || {};
    this.userId = _value.userId;
    DeleteContactRequest.refineValues(this);
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    DeleteContactRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): DeleteContactRequest.AsObject {
    return {
      userId: this.userId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): DeleteContactRequest.AsProtobufJSON {
    return {
      userId: this.userId
    };
  }
}
export module DeleteContactRequest {
  /**
   * Standard JavaScript object representation for DeleteContactRequest
   */
  export interface AsObject {
    userId: string;
  }

  /**
   * Protobuf JSON representation for DeleteContactRequest
   */
  export interface AsProtobufJSON {
    userId: string;
  }
}

/**
 * Message implementation for goautowp.GetContactRequest
 */
export class GetContactRequest implements GrpcMessage {
  static id = 'goautowp.GetContactRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetContactRequest();
    GetContactRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetContactRequest) {
    _instance.userId = _instance.userId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetContactRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.userId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    GetContactRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetContactRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.userId) {
      _writer.writeInt64String(1, _instance.userId);
    }
  }

  private _userId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetContactRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetContactRequest.AsObject>) {
    _value = _value || {};
    this.userId = _value.userId;
    GetContactRequest.refineValues(this);
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetContactRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetContactRequest.AsObject {
    return {
      userId: this.userId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetContactRequest.AsProtobufJSON {
    return {
      userId: this.userId
    };
  }
}
export module GetContactRequest {
  /**
   * Standard JavaScript object representation for GetContactRequest
   */
  export interface AsObject {
    userId: string;
  }

  /**
   * Protobuf JSON representation for GetContactRequest
   */
  export interface AsProtobufJSON {
    userId: string;
  }
}

/**
 * Message implementation for goautowp.APIImage
 */
export class APIImage implements GrpcMessage {
  static id = 'goautowp.APIImage';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIImage();
    APIImage.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIImage) {
    _instance.id = _instance.id || 0;
    _instance.src = _instance.src || '';
    _instance.width = _instance.width || 0;
    _instance.height = _instance.height || 0;
    _instance.filesize = _instance.filesize || 0;
    _instance.cropLeft = _instance.cropLeft || 0;
    _instance.cropTop = _instance.cropTop || 0;
    _instance.cropWidth = _instance.cropWidth || 0;
    _instance.cropHeight = _instance.cropHeight || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIImage,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.src = _reader.readString();
          break;
        case 3:
          _instance.width = _reader.readInt32();
          break;
        case 4:
          _instance.height = _reader.readInt32();
          break;
        case 5:
          _instance.filesize = _reader.readInt32();
          break;
        case 6:
          _instance.cropLeft = _reader.readInt32();
          break;
        case 7:
          _instance.cropTop = _reader.readInt32();
          break;
        case 8:
          _instance.cropWidth = _reader.readInt32();
          break;
        case 9:
          _instance.cropHeight = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    APIImage.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: APIImage, _writer: BinaryWriter) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.src) {
      _writer.writeString(2, _instance.src);
    }
    if (_instance.width) {
      _writer.writeInt32(3, _instance.width);
    }
    if (_instance.height) {
      _writer.writeInt32(4, _instance.height);
    }
    if (_instance.filesize) {
      _writer.writeInt32(5, _instance.filesize);
    }
    if (_instance.cropLeft) {
      _writer.writeInt32(6, _instance.cropLeft);
    }
    if (_instance.cropTop) {
      _writer.writeInt32(7, _instance.cropTop);
    }
    if (_instance.cropWidth) {
      _writer.writeInt32(8, _instance.cropWidth);
    }
    if (_instance.cropHeight) {
      _writer.writeInt32(9, _instance.cropHeight);
    }
  }

  private _id: number;
  private _src: string;
  private _width: number;
  private _height: number;
  private _filesize: number;
  private _cropLeft: number;
  private _cropTop: number;
  private _cropWidth: number;
  private _cropHeight: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIImage to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIImage.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.src = _value.src;
    this.width = _value.width;
    this.height = _value.height;
    this.filesize = _value.filesize;
    this.cropLeft = _value.cropLeft;
    this.cropTop = _value.cropTop;
    this.cropWidth = _value.cropWidth;
    this.cropHeight = _value.cropHeight;
    APIImage.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get src(): string {
    return this._src;
  }
  set src(value: string) {
    this._src = value;
  }
  get width(): number {
    return this._width;
  }
  set width(value: number) {
    this._width = value;
  }
  get height(): number {
    return this._height;
  }
  set height(value: number) {
    this._height = value;
  }
  get filesize(): number {
    return this._filesize;
  }
  set filesize(value: number) {
    this._filesize = value;
  }
  get cropLeft(): number {
    return this._cropLeft;
  }
  set cropLeft(value: number) {
    this._cropLeft = value;
  }
  get cropTop(): number {
    return this._cropTop;
  }
  set cropTop(value: number) {
    this._cropTop = value;
  }
  get cropWidth(): number {
    return this._cropWidth;
  }
  set cropWidth(value: number) {
    this._cropWidth = value;
  }
  get cropHeight(): number {
    return this._cropHeight;
  }
  set cropHeight(value: number) {
    this._cropHeight = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIImage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIImage.AsObject {
    return {
      id: this.id,
      src: this.src,
      width: this.width,
      height: this.height,
      filesize: this.filesize,
      cropLeft: this.cropLeft,
      cropTop: this.cropTop,
      cropWidth: this.cropWidth,
      cropHeight: this.cropHeight
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIImage.AsProtobufJSON {
    return {
      id: this.id,
      src: this.src,
      width: this.width,
      height: this.height,
      filesize: this.filesize,
      cropLeft: this.cropLeft,
      cropTop: this.cropTop,
      cropWidth: this.cropWidth,
      cropHeight: this.cropHeight
    };
  }
}
export module APIImage {
  /**
   * Standard JavaScript object representation for APIImage
   */
  export interface AsObject {
    id: number;
    src: string;
    width: number;
    height: number;
    filesize: number;
    cropLeft: number;
    cropTop: number;
    cropWidth: number;
    cropHeight: number;
  }

  /**
   * Protobuf JSON representation for APIImage
   */
  export interface AsProtobufJSON {
    id: number;
    src: string;
    width: number;
    height: number;
    filesize: number;
    cropLeft: number;
    cropTop: number;
    cropWidth: number;
    cropHeight: number;
  }
}

/**
 * Message implementation for goautowp.APIUser
 */
export class APIUser implements GrpcMessage {
  static id = 'goautowp.APIUser';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIUser();
    APIUser.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIUser) {
    _instance.id = _instance.id || '0';
    _instance.name = _instance.name || '';
    _instance.deleted = _instance.deleted || false;
    _instance.longAway = _instance.longAway || false;
    _instance.green = _instance.green || false;
    _instance.route = _instance.route || [];
    _instance.identity = _instance.identity || '';
    _instance.avatar = _instance.avatar || undefined;
    _instance.gravatar = _instance.gravatar || '';
    _instance.lastOnline = _instance.lastOnline || undefined;
    _instance.specsWeight = _instance.specsWeight || 0;
    _instance.email = _instance.email || '';
    _instance.timezone = _instance.timezone || '';
    _instance.language = _instance.language || '';
    _instance.votesPerDay = _instance.votesPerDay || '0';
    _instance.votesLeft = _instance.votesLeft || '0';
    _instance.img = _instance.img || undefined;
    _instance.gravatarLarge = _instance.gravatarLarge || '';
    _instance.photo = _instance.photo || undefined;
    _instance.regDate = _instance.regDate || undefined;
    _instance.picturesAdded = _instance.picturesAdded || 0;
    _instance.picturesAcceptedCount = _instance.picturesAcceptedCount || 0;
    _instance.lastIp = _instance.lastIp || '';
    _instance.login = _instance.login || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIUser,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        case 3:
          _instance.deleted = _reader.readBool();
          break;
        case 4:
          _instance.longAway = _reader.readBool();
          break;
        case 5:
          _instance.green = _reader.readBool();
          break;
        case 6:
          (_instance.route = _instance.route || []).push(_reader.readString());
          break;
        case 7:
          _instance.identity = _reader.readString();
          break;
        case 8:
          _instance.avatar = new APIImage();
          _reader.readMessage(
            _instance.avatar,
            APIImage.deserializeBinaryFromReader
          );
          break;
        case 9:
          _instance.gravatar = _reader.readString();
          break;
        case 10:
          _instance.lastOnline = new googleProtobuf006.Timestamp();
          _reader.readMessage(
            _instance.lastOnline,
            googleProtobuf006.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 11:
          _instance.specsWeight = _reader.readDouble();
          break;
        case 12:
          _instance.email = _reader.readString();
          break;
        case 13:
          _instance.timezone = _reader.readString();
          break;
        case 14:
          _instance.language = _reader.readString();
          break;
        case 15:
          _instance.votesPerDay = _reader.readInt64String();
          break;
        case 16:
          _instance.votesLeft = _reader.readInt64String();
          break;
        case 17:
          _instance.img = new APIImage();
          _reader.readMessage(
            _instance.img,
            APIImage.deserializeBinaryFromReader
          );
          break;
        case 18:
          _instance.gravatarLarge = _reader.readString();
          break;
        case 19:
          _instance.photo = new APIImage();
          _reader.readMessage(
            _instance.photo,
            APIImage.deserializeBinaryFromReader
          );
          break;
        case 21:
          _instance.regDate = new googleProtobuf006.Timestamp();
          _reader.readMessage(
            _instance.regDate,
            googleProtobuf006.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 23:
          _instance.picturesAdded = _reader.readInt32();
          break;
        case 24:
          _instance.picturesAcceptedCount = _reader.readInt32();
          break;
        case 25:
          _instance.lastIp = _reader.readString();
          break;
        case 26:
          _instance.login = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    APIUser.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: APIUser, _writer: BinaryWriter) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
    if (_instance.deleted) {
      _writer.writeBool(3, _instance.deleted);
    }
    if (_instance.longAway) {
      _writer.writeBool(4, _instance.longAway);
    }
    if (_instance.green) {
      _writer.writeBool(5, _instance.green);
    }
    if (_instance.route && _instance.route.length) {
      _writer.writeRepeatedString(6, _instance.route);
    }
    if (_instance.identity) {
      _writer.writeString(7, _instance.identity);
    }
    if (_instance.avatar) {
      _writer.writeMessage(
        8,
        _instance.avatar as any,
        APIImage.serializeBinaryToWriter
      );
    }
    if (_instance.gravatar) {
      _writer.writeString(9, _instance.gravatar);
    }
    if (_instance.lastOnline) {
      _writer.writeMessage(
        10,
        _instance.lastOnline as any,
        googleProtobuf006.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.specsWeight) {
      _writer.writeDouble(11, _instance.specsWeight);
    }
    if (_instance.email) {
      _writer.writeString(12, _instance.email);
    }
    if (_instance.timezone) {
      _writer.writeString(13, _instance.timezone);
    }
    if (_instance.language) {
      _writer.writeString(14, _instance.language);
    }
    if (_instance.votesPerDay) {
      _writer.writeInt64String(15, _instance.votesPerDay);
    }
    if (_instance.votesLeft) {
      _writer.writeInt64String(16, _instance.votesLeft);
    }
    if (_instance.img) {
      _writer.writeMessage(
        17,
        _instance.img as any,
        APIImage.serializeBinaryToWriter
      );
    }
    if (_instance.gravatarLarge) {
      _writer.writeString(18, _instance.gravatarLarge);
    }
    if (_instance.photo) {
      _writer.writeMessage(
        19,
        _instance.photo as any,
        APIImage.serializeBinaryToWriter
      );
    }
    if (_instance.regDate) {
      _writer.writeMessage(
        21,
        _instance.regDate as any,
        googleProtobuf006.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.picturesAdded) {
      _writer.writeInt32(23, _instance.picturesAdded);
    }
    if (_instance.picturesAcceptedCount) {
      _writer.writeInt32(24, _instance.picturesAcceptedCount);
    }
    if (_instance.lastIp) {
      _writer.writeString(25, _instance.lastIp);
    }
    if (_instance.login) {
      _writer.writeString(26, _instance.login);
    }
  }

  private _id: string;
  private _name: string;
  private _deleted: boolean;
  private _longAway: boolean;
  private _green: boolean;
  private _route: string[];
  private _identity: string;
  private _avatar?: APIImage;
  private _gravatar: string;
  private _lastOnline?: googleProtobuf006.Timestamp;
  private _specsWeight: number;
  private _email: string;
  private _timezone: string;
  private _language: string;
  private _votesPerDay: string;
  private _votesLeft: string;
  private _img?: APIImage;
  private _gravatarLarge: string;
  private _photo?: APIImage;
  private _regDate?: googleProtobuf006.Timestamp;
  private _picturesAdded: number;
  private _picturesAcceptedCount: number;
  private _lastIp: string;
  private _login: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIUser to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIUser.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.name = _value.name;
    this.deleted = _value.deleted;
    this.longAway = _value.longAway;
    this.green = _value.green;
    this.route = (_value.route || []).slice();
    this.identity = _value.identity;
    this.avatar = _value.avatar ? new APIImage(_value.avatar) : undefined;
    this.gravatar = _value.gravatar;
    this.lastOnline = _value.lastOnline
      ? new googleProtobuf006.Timestamp(_value.lastOnline)
      : undefined;
    this.specsWeight = _value.specsWeight;
    this.email = _value.email;
    this.timezone = _value.timezone;
    this.language = _value.language;
    this.votesPerDay = _value.votesPerDay;
    this.votesLeft = _value.votesLeft;
    this.img = _value.img ? new APIImage(_value.img) : undefined;
    this.gravatarLarge = _value.gravatarLarge;
    this.photo = _value.photo ? new APIImage(_value.photo) : undefined;
    this.regDate = _value.regDate
      ? new googleProtobuf006.Timestamp(_value.regDate)
      : undefined;
    this.picturesAdded = _value.picturesAdded;
    this.picturesAcceptedCount = _value.picturesAcceptedCount;
    this.lastIp = _value.lastIp;
    this.login = _value.login;
    APIUser.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get deleted(): boolean {
    return this._deleted;
  }
  set deleted(value: boolean) {
    this._deleted = value;
  }
  get longAway(): boolean {
    return this._longAway;
  }
  set longAway(value: boolean) {
    this._longAway = value;
  }
  get green(): boolean {
    return this._green;
  }
  set green(value: boolean) {
    this._green = value;
  }
  get route(): string[] {
    return this._route;
  }
  set route(value: string[]) {
    this._route = value;
  }
  get identity(): string {
    return this._identity;
  }
  set identity(value: string) {
    this._identity = value;
  }
  get avatar(): APIImage | undefined {
    return this._avatar;
  }
  set avatar(value: APIImage | undefined) {
    this._avatar = value;
  }
  get gravatar(): string {
    return this._gravatar;
  }
  set gravatar(value: string) {
    this._gravatar = value;
  }
  get lastOnline(): googleProtobuf006.Timestamp | undefined {
    return this._lastOnline;
  }
  set lastOnline(value: googleProtobuf006.Timestamp | undefined) {
    this._lastOnline = value;
  }
  get specsWeight(): number {
    return this._specsWeight;
  }
  set specsWeight(value: number) {
    this._specsWeight = value;
  }
  get email(): string {
    return this._email;
  }
  set email(value: string) {
    this._email = value;
  }
  get timezone(): string {
    return this._timezone;
  }
  set timezone(value: string) {
    this._timezone = value;
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }
  get votesPerDay(): string {
    return this._votesPerDay;
  }
  set votesPerDay(value: string) {
    this._votesPerDay = value;
  }
  get votesLeft(): string {
    return this._votesLeft;
  }
  set votesLeft(value: string) {
    this._votesLeft = value;
  }
  get img(): APIImage | undefined {
    return this._img;
  }
  set img(value: APIImage | undefined) {
    this._img = value;
  }
  get gravatarLarge(): string {
    return this._gravatarLarge;
  }
  set gravatarLarge(value: string) {
    this._gravatarLarge = value;
  }
  get photo(): APIImage | undefined {
    return this._photo;
  }
  set photo(value: APIImage | undefined) {
    this._photo = value;
  }
  get regDate(): googleProtobuf006.Timestamp | undefined {
    return this._regDate;
  }
  set regDate(value: googleProtobuf006.Timestamp | undefined) {
    this._regDate = value;
  }
  get picturesAdded(): number {
    return this._picturesAdded;
  }
  set picturesAdded(value: number) {
    this._picturesAdded = value;
  }
  get picturesAcceptedCount(): number {
    return this._picturesAcceptedCount;
  }
  set picturesAcceptedCount(value: number) {
    this._picturesAcceptedCount = value;
  }
  get lastIp(): string {
    return this._lastIp;
  }
  set lastIp(value: string) {
    this._lastIp = value;
  }
  get login(): string {
    return this._login;
  }
  set login(value: string) {
    this._login = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIUser.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIUser.AsObject {
    return {
      id: this.id,
      name: this.name,
      deleted: this.deleted,
      longAway: this.longAway,
      green: this.green,
      route: (this.route || []).slice(),
      identity: this.identity,
      avatar: this.avatar ? this.avatar.toObject() : undefined,
      gravatar: this.gravatar,
      lastOnline: this.lastOnline ? this.lastOnline.toObject() : undefined,
      specsWeight: this.specsWeight,
      email: this.email,
      timezone: this.timezone,
      language: this.language,
      votesPerDay: this.votesPerDay,
      votesLeft: this.votesLeft,
      img: this.img ? this.img.toObject() : undefined,
      gravatarLarge: this.gravatarLarge,
      photo: this.photo ? this.photo.toObject() : undefined,
      regDate: this.regDate ? this.regDate.toObject() : undefined,
      picturesAdded: this.picturesAdded,
      picturesAcceptedCount: this.picturesAcceptedCount,
      lastIp: this.lastIp,
      login: this.login
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIUser.AsProtobufJSON {
    return {
      id: this.id,
      name: this.name,
      deleted: this.deleted,
      longAway: this.longAway,
      green: this.green,
      route: (this.route || []).slice(),
      identity: this.identity,
      avatar: this.avatar ? this.avatar.toProtobufJSON(options) : null,
      gravatar: this.gravatar,
      lastOnline: this.lastOnline
        ? this.lastOnline.toProtobufJSON(options)
        : null,
      specsWeight: this.specsWeight,
      email: this.email,
      timezone: this.timezone,
      language: this.language,
      votesPerDay: this.votesPerDay,
      votesLeft: this.votesLeft,
      img: this.img ? this.img.toProtobufJSON(options) : null,
      gravatarLarge: this.gravatarLarge,
      photo: this.photo ? this.photo.toProtobufJSON(options) : null,
      regDate: this.regDate ? this.regDate.toProtobufJSON(options) : null,
      picturesAdded: this.picturesAdded,
      picturesAcceptedCount: this.picturesAcceptedCount,
      lastIp: this.lastIp,
      login: this.login
    };
  }
}
export module APIUser {
  /**
   * Standard JavaScript object representation for APIUser
   */
  export interface AsObject {
    id: string;
    name: string;
    deleted: boolean;
    longAway: boolean;
    green: boolean;
    route: string[];
    identity: string;
    avatar?: APIImage.AsObject;
    gravatar: string;
    lastOnline?: googleProtobuf006.Timestamp.AsObject;
    specsWeight: number;
    email: string;
    timezone: string;
    language: string;
    votesPerDay: string;
    votesLeft: string;
    img?: APIImage.AsObject;
    gravatarLarge: string;
    photo?: APIImage.AsObject;
    regDate?: googleProtobuf006.Timestamp.AsObject;
    picturesAdded: number;
    picturesAcceptedCount: number;
    lastIp: string;
    login: string;
  }

  /**
   * Protobuf JSON representation for APIUser
   */
  export interface AsProtobufJSON {
    id: string;
    name: string;
    deleted: boolean;
    longAway: boolean;
    green: boolean;
    route: string[];
    identity: string;
    avatar: APIImage.AsProtobufJSON | null;
    gravatar: string;
    lastOnline: googleProtobuf006.Timestamp.AsProtobufJSON | null;
    specsWeight: number;
    email: string;
    timezone: string;
    language: string;
    votesPerDay: string;
    votesLeft: string;
    img: APIImage.AsProtobufJSON | null;
    gravatarLarge: string;
    photo: APIImage.AsProtobufJSON | null;
    regDate: googleProtobuf006.Timestamp.AsProtobufJSON | null;
    picturesAdded: number;
    picturesAcceptedCount: number;
    lastIp: string;
    login: string;
  }
}

/**
 * Message implementation for goautowp.Contact
 */
export class Contact implements GrpcMessage {
  static id = 'goautowp.Contact';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Contact();
    Contact.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Contact) {
    _instance.contactUserId = _instance.contactUserId || '0';
    _instance.user = _instance.user || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: Contact,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.contactUserId = _reader.readInt64String();
          break;
        case 2:
          _instance.user = new APIUser();
          _reader.readMessage(
            _instance.user,
            APIUser.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    Contact.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Contact, _writer: BinaryWriter) {
    if (_instance.contactUserId) {
      _writer.writeInt64String(1, _instance.contactUserId);
    }
    if (_instance.user) {
      _writer.writeMessage(
        2,
        _instance.user as any,
        APIUser.serializeBinaryToWriter
      );
    }
  }

  private _contactUserId: string;
  private _user?: APIUser;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Contact to deeply clone from
   */
  constructor(_value?: RecursivePartial<Contact.AsObject>) {
    _value = _value || {};
    this.contactUserId = _value.contactUserId;
    this.user = _value.user ? new APIUser(_value.user) : undefined;
    Contact.refineValues(this);
  }
  get contactUserId(): string {
    return this._contactUserId;
  }
  set contactUserId(value: string) {
    this._contactUserId = value;
  }
  get user(): APIUser | undefined {
    return this._user;
  }
  set user(value: APIUser | undefined) {
    this._user = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Contact.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Contact.AsObject {
    return {
      contactUserId: this.contactUserId,
      user: this.user ? this.user.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Contact.AsProtobufJSON {
    return {
      contactUserId: this.contactUserId,
      user: this.user ? this.user.toProtobufJSON(options) : null
    };
  }
}
export module Contact {
  /**
   * Standard JavaScript object representation for Contact
   */
  export interface AsObject {
    contactUserId: string;
    user?: APIUser.AsObject;
  }

  /**
   * Protobuf JSON representation for Contact
   */
  export interface AsProtobufJSON {
    contactUserId: string;
    user: APIUser.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.ContactItems
 */
export class ContactItems implements GrpcMessage {
  static id = 'goautowp.ContactItems';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ContactItems();
    ContactItems.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ContactItems) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ContactItems,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new Contact();
          _reader.readMessage(
            messageInitializer1,
            Contact.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    ContactItems.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ContactItems,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        Contact.serializeBinaryToWriter
      );
    }
  }

  private _items?: Contact[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ContactItems to deeply clone from
   */
  constructor(_value?: RecursivePartial<ContactItems.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new Contact(m));
    ContactItems.refineValues(this);
  }
  get items(): Contact[] | undefined {
    return this._items;
  }
  set items(value: Contact[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ContactItems.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ContactItems.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ContactItems.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module ContactItems {
  /**
   * Standard JavaScript object representation for ContactItems
   */
  export interface AsObject {
    items?: Contact.AsObject[];
  }

  /**
   * Protobuf JSON representation for ContactItems
   */
  export interface AsProtobufJSON {
    items: Contact.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.GetContactsRequest
 */
export class GetContactsRequest implements GrpcMessage {
  static id = 'goautowp.GetContactsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetContactsRequest();
    GetContactsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetContactsRequest) {}

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetContactsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        default:
          _reader.skipField();
      }
    }

    GetContactsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetContactsRequest,
    _writer: BinaryWriter
  ) {}

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetContactsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetContactsRequest.AsObject>) {
    _value = _value || {};
    GetContactsRequest.refineValues(this);
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetContactsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetContactsRequest.AsObject {
    return {};
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetContactsRequest.AsProtobufJSON {
    return {};
  }
}
export module GetContactsRequest {
  /**
   * Standard JavaScript object representation for GetContactsRequest
   */
  export interface AsObject {}

  /**
   * Protobuf JSON representation for GetContactsRequest
   */
  export interface AsProtobufJSON {}
}

/**
 * Message implementation for goautowp.CommentVoteItems
 */
export class CommentVoteItems implements GrpcMessage {
  static id = 'goautowp.CommentVoteItems';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CommentVoteItems();
    CommentVoteItems.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CommentVoteItems) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CommentVoteItems,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new CommentVote();
          _reader.readMessage(
            messageInitializer1,
            CommentVote.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    CommentVoteItems.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CommentVoteItems,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        CommentVote.serializeBinaryToWriter
      );
    }
  }

  private _items?: CommentVote[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CommentVoteItems to deeply clone from
   */
  constructor(_value?: RecursivePartial<CommentVoteItems.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new CommentVote(m));
    CommentVoteItems.refineValues(this);
  }
  get items(): CommentVote[] | undefined {
    return this._items;
  }
  set items(value: CommentVote[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CommentVoteItems.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CommentVoteItems.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CommentVoteItems.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module CommentVoteItems {
  /**
   * Standard JavaScript object representation for CommentVoteItems
   */
  export interface AsObject {
    items?: CommentVote.AsObject[];
  }

  /**
   * Protobuf JSON representation for CommentVoteItems
   */
  export interface AsProtobufJSON {
    items: CommentVote.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.CommentVote
 */
export class CommentVote implements GrpcMessage {
  static id = 'goautowp.CommentVote';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CommentVote();
    CommentVote.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CommentVote) {
    _instance.value = _instance.value || 0;
    _instance.user = _instance.user || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CommentVote,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.value = _reader.readEnum();
          break;
        case 2:
          _instance.user = new APIUser();
          _reader.readMessage(
            _instance.user,
            APIUser.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    CommentVote.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CommentVote,
    _writer: BinaryWriter
  ) {
    if (_instance.value) {
      _writer.writeEnum(1, _instance.value);
    }
    if (_instance.user) {
      _writer.writeMessage(
        2,
        _instance.user as any,
        APIUser.serializeBinaryToWriter
      );
    }
  }

  private _value: CommentVote.VoteValue;
  private _user?: APIUser;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CommentVote to deeply clone from
   */
  constructor(_value?: RecursivePartial<CommentVote.AsObject>) {
    _value = _value || {};
    this.value = _value.value;
    this.user = _value.user ? new APIUser(_value.user) : undefined;
    CommentVote.refineValues(this);
  }
  get value(): CommentVote.VoteValue {
    return this._value;
  }
  set value(value: CommentVote.VoteValue) {
    this._value = value;
  }
  get user(): APIUser | undefined {
    return this._user;
  }
  set user(value: APIUser | undefined) {
    this._user = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CommentVote.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CommentVote.AsObject {
    return {
      value: this.value,
      user: this.user ? this.user.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CommentVote.AsProtobufJSON {
    return {
      value:
        CommentVote.VoteValue[
          this.value === null || this.value === undefined ? 0 : this.value
        ],
      user: this.user ? this.user.toProtobufJSON(options) : null
    };
  }
}
export module CommentVote {
  /**
   * Standard JavaScript object representation for CommentVote
   */
  export interface AsObject {
    value: CommentVote.VoteValue;
    user?: APIUser.AsObject;
  }

  /**
   * Protobuf JSON representation for CommentVote
   */
  export interface AsProtobufJSON {
    value: string;
    user: APIUser.AsProtobufJSON | null;
  }
  export enum VoteValue {
    UNKNOWN = 0,
    POSITIVE = -1,
    NEGATIVE = 1
  }
}

/**
 * Message implementation for goautowp.APIBanItem
 */
export class APIBanItem implements GrpcMessage {
  static id = 'goautowp.APIBanItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIBanItem();
    APIBanItem.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIBanItem) {
    _instance.until = _instance.until || undefined;
    _instance.byUserId = _instance.byUserId || '0';
    _instance.byUser = _instance.byUser || undefined;
    _instance.reason = _instance.reason || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIBanItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.until = new googleProtobuf006.Timestamp();
          _reader.readMessage(
            _instance.until,
            googleProtobuf006.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.byUserId = _reader.readInt64String();
          break;
        case 3:
          _instance.byUser = new APIUser();
          _reader.readMessage(
            _instance.byUser,
            APIUser.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.reason = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    APIBanItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: APIBanItem, _writer: BinaryWriter) {
    if (_instance.until) {
      _writer.writeMessage(
        1,
        _instance.until as any,
        googleProtobuf006.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.byUserId) {
      _writer.writeInt64String(2, _instance.byUserId);
    }
    if (_instance.byUser) {
      _writer.writeMessage(
        3,
        _instance.byUser as any,
        APIUser.serializeBinaryToWriter
      );
    }
    if (_instance.reason) {
      _writer.writeString(4, _instance.reason);
    }
  }

  private _until?: googleProtobuf006.Timestamp;
  private _byUserId: string;
  private _byUser?: APIUser;
  private _reason: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIBanItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIBanItem.AsObject>) {
    _value = _value || {};
    this.until = _value.until
      ? new googleProtobuf006.Timestamp(_value.until)
      : undefined;
    this.byUserId = _value.byUserId;
    this.byUser = _value.byUser ? new APIUser(_value.byUser) : undefined;
    this.reason = _value.reason;
    APIBanItem.refineValues(this);
  }
  get until(): googleProtobuf006.Timestamp | undefined {
    return this._until;
  }
  set until(value: googleProtobuf006.Timestamp | undefined) {
    this._until = value;
  }
  get byUserId(): string {
    return this._byUserId;
  }
  set byUserId(value: string) {
    this._byUserId = value;
  }
  get byUser(): APIUser | undefined {
    return this._byUser;
  }
  set byUser(value: APIUser | undefined) {
    this._byUser = value;
  }
  get reason(): string {
    return this._reason;
  }
  set reason(value: string) {
    this._reason = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIBanItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIBanItem.AsObject {
    return {
      until: this.until ? this.until.toObject() : undefined,
      byUserId: this.byUserId,
      byUser: this.byUser ? this.byUser.toObject() : undefined,
      reason: this.reason
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIBanItem.AsProtobufJSON {
    return {
      until: this.until ? this.until.toProtobufJSON(options) : null,
      byUserId: this.byUserId,
      byUser: this.byUser ? this.byUser.toProtobufJSON(options) : null,
      reason: this.reason
    };
  }
}
export module APIBanItem {
  /**
   * Standard JavaScript object representation for APIBanItem
   */
  export interface AsObject {
    until?: googleProtobuf006.Timestamp.AsObject;
    byUserId: string;
    byUser?: APIUser.AsObject;
    reason: string;
  }

  /**
   * Protobuf JSON representation for APIBanItem
   */
  export interface AsProtobufJSON {
    until: googleProtobuf006.Timestamp.AsProtobufJSON | null;
    byUserId: string;
    byUser: APIUser.AsProtobufJSON | null;
    reason: string;
  }
}

/**
 * Message implementation for goautowp.APITrafficTopItem
 */
export class APITrafficTopItem implements GrpcMessage {
  static id = 'goautowp.APITrafficTopItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APITrafficTopItem();
    APITrafficTopItem.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APITrafficTopItem) {
    _instance.ip = _instance.ip || '';
    _instance.count = _instance.count || 0;
    _instance.ban = _instance.ban || undefined;
    _instance.inWhitelist = _instance.inWhitelist || false;
    _instance.whoisUrl = _instance.whoisUrl || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APITrafficTopItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.ip = _reader.readString();
          break;
        case 2:
          _instance.count = _reader.readInt32();
          break;
        case 3:
          _instance.ban = new APIBanItem();
          _reader.readMessage(
            _instance.ban,
            APIBanItem.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.inWhitelist = _reader.readBool();
          break;
        case 5:
          _instance.whoisUrl = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    APITrafficTopItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APITrafficTopItem,
    _writer: BinaryWriter
  ) {
    if (_instance.ip) {
      _writer.writeString(1, _instance.ip);
    }
    if (_instance.count) {
      _writer.writeInt32(2, _instance.count);
    }
    if (_instance.ban) {
      _writer.writeMessage(
        3,
        _instance.ban as any,
        APIBanItem.serializeBinaryToWriter
      );
    }
    if (_instance.inWhitelist) {
      _writer.writeBool(4, _instance.inWhitelist);
    }
    if (_instance.whoisUrl) {
      _writer.writeString(5, _instance.whoisUrl);
    }
  }

  private _ip: string;
  private _count: number;
  private _ban?: APIBanItem;
  private _inWhitelist: boolean;
  private _whoisUrl: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APITrafficTopItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<APITrafficTopItem.AsObject>) {
    _value = _value || {};
    this.ip = _value.ip;
    this.count = _value.count;
    this.ban = _value.ban ? new APIBanItem(_value.ban) : undefined;
    this.inWhitelist = _value.inWhitelist;
    this.whoisUrl = _value.whoisUrl;
    APITrafficTopItem.refineValues(this);
  }
  get ip(): string {
    return this._ip;
  }
  set ip(value: string) {
    this._ip = value;
  }
  get count(): number {
    return this._count;
  }
  set count(value: number) {
    this._count = value;
  }
  get ban(): APIBanItem | undefined {
    return this._ban;
  }
  set ban(value: APIBanItem | undefined) {
    this._ban = value;
  }
  get inWhitelist(): boolean {
    return this._inWhitelist;
  }
  set inWhitelist(value: boolean) {
    this._inWhitelist = value;
  }
  get whoisUrl(): string {
    return this._whoisUrl;
  }
  set whoisUrl(value: string) {
    this._whoisUrl = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APITrafficTopItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APITrafficTopItem.AsObject {
    return {
      ip: this.ip,
      count: this.count,
      ban: this.ban ? this.ban.toObject() : undefined,
      inWhitelist: this.inWhitelist,
      whoisUrl: this.whoisUrl
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APITrafficTopItem.AsProtobufJSON {
    return {
      ip: this.ip,
      count: this.count,
      ban: this.ban ? this.ban.toProtobufJSON(options) : null,
      inWhitelist: this.inWhitelist,
      whoisUrl: this.whoisUrl
    };
  }
}
export module APITrafficTopItem {
  /**
   * Standard JavaScript object representation for APITrafficTopItem
   */
  export interface AsObject {
    ip: string;
    count: number;
    ban?: APIBanItem.AsObject;
    inWhitelist: boolean;
    whoisUrl: string;
  }

  /**
   * Protobuf JSON representation for APITrafficTopItem
   */
  export interface AsProtobufJSON {
    ip: string;
    count: number;
    ban: APIBanItem.AsProtobufJSON | null;
    inWhitelist: boolean;
    whoisUrl: string;
  }
}

/**
 * Message implementation for goautowp.APITrafficTopResponse
 */
export class APITrafficTopResponse implements GrpcMessage {
  static id = 'goautowp.APITrafficTopResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APITrafficTopResponse();
    APITrafficTopResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APITrafficTopResponse) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APITrafficTopResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new APITrafficTopItem();
          _reader.readMessage(
            messageInitializer1,
            APITrafficTopItem.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    APITrafficTopResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APITrafficTopResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        APITrafficTopItem.serializeBinaryToWriter
      );
    }
  }

  private _items?: APITrafficTopItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APITrafficTopResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<APITrafficTopResponse.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new APITrafficTopItem(m));
    APITrafficTopResponse.refineValues(this);
  }
  get items(): APITrafficTopItem[] | undefined {
    return this._items;
  }
  set items(value: APITrafficTopItem[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APITrafficTopResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APITrafficTopResponse.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APITrafficTopResponse.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module APITrafficTopResponse {
  /**
   * Standard JavaScript object representation for APITrafficTopResponse
   */
  export interface AsObject {
    items?: APITrafficTopItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for APITrafficTopResponse
   */
  export interface AsProtobufJSON {
    items: APITrafficTopItem.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.GetIPRequest
 */
export class GetIPRequest implements GrpcMessage {
  static id = 'goautowp.GetIPRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetIPRequest();
    GetIPRequest.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetIPRequest) {
    _instance.ip = _instance.ip || '';
    _instance.fields = _instance.fields || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetIPRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.ip = _reader.readString();
          break;
        case 2:
          (_instance.fields = _instance.fields || []).push(
            _reader.readString()
          );
          break;
        default:
          _reader.skipField();
      }
    }

    GetIPRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetIPRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.ip) {
      _writer.writeString(1, _instance.ip);
    }
    if (_instance.fields && _instance.fields.length) {
      _writer.writeRepeatedString(2, _instance.fields);
    }
  }

  private _ip: string;
  private _fields: string[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetIPRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetIPRequest.AsObject>) {
    _value = _value || {};
    this.ip = _value.ip;
    this.fields = (_value.fields || []).slice();
    GetIPRequest.refineValues(this);
  }
  get ip(): string {
    return this._ip;
  }
  set ip(value: string) {
    this._ip = value;
  }
  get fields(): string[] {
    return this._fields;
  }
  set fields(value: string[]) {
    this._fields = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetIPRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetIPRequest.AsObject {
    return {
      ip: this.ip,
      fields: (this.fields || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetIPRequest.AsProtobufJSON {
    return {
      ip: this.ip,
      fields: (this.fields || []).slice()
    };
  }
}
export module GetIPRequest {
  /**
   * Standard JavaScript object representation for GetIPRequest
   */
  export interface AsObject {
    ip: string;
    fields: string[];
  }

  /**
   * Protobuf JSON representation for GetIPRequest
   */
  export interface AsProtobufJSON {
    ip: string;
    fields: string[];
  }
}

/**
 * Message implementation for goautowp.APIIPRights
 */
export class APIIPRights implements GrpcMessage {
  static id = 'goautowp.APIIPRights';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIIPRights();
    APIIPRights.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIIPRights) {
    _instance.addToBlacklist = _instance.addToBlacklist || false;
    _instance.removeFromBlacklist = _instance.removeFromBlacklist || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIIPRights,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.addToBlacklist = _reader.readBool();
          break;
        case 2:
          _instance.removeFromBlacklist = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    APIIPRights.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIIPRights,
    _writer: BinaryWriter
  ) {
    if (_instance.addToBlacklist) {
      _writer.writeBool(1, _instance.addToBlacklist);
    }
    if (_instance.removeFromBlacklist) {
      _writer.writeBool(2, _instance.removeFromBlacklist);
    }
  }

  private _addToBlacklist: boolean;
  private _removeFromBlacklist: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIIPRights to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIIPRights.AsObject>) {
    _value = _value || {};
    this.addToBlacklist = _value.addToBlacklist;
    this.removeFromBlacklist = _value.removeFromBlacklist;
    APIIPRights.refineValues(this);
  }
  get addToBlacklist(): boolean {
    return this._addToBlacklist;
  }
  set addToBlacklist(value: boolean) {
    this._addToBlacklist = value;
  }
  get removeFromBlacklist(): boolean {
    return this._removeFromBlacklist;
  }
  set removeFromBlacklist(value: boolean) {
    this._removeFromBlacklist = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIIPRights.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIIPRights.AsObject {
    return {
      addToBlacklist: this.addToBlacklist,
      removeFromBlacklist: this.removeFromBlacklist
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIIPRights.AsProtobufJSON {
    return {
      addToBlacklist: this.addToBlacklist,
      removeFromBlacklist: this.removeFromBlacklist
    };
  }
}
export module APIIPRights {
  /**
   * Standard JavaScript object representation for APIIPRights
   */
  export interface AsObject {
    addToBlacklist: boolean;
    removeFromBlacklist: boolean;
  }

  /**
   * Protobuf JSON representation for APIIPRights
   */
  export interface AsProtobufJSON {
    addToBlacklist: boolean;
    removeFromBlacklist: boolean;
  }
}

/**
 * Message implementation for goautowp.IP
 */
export class IP implements GrpcMessage {
  static id = 'goautowp.IP';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new IP();
    IP.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: IP) {
    _instance.address = _instance.address || '';
    _instance.hostname = _instance.hostname || '';
    _instance.blacklist = _instance.blacklist || undefined;
    _instance.rights = _instance.rights || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(_instance: IP, _reader: BinaryReader) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.address = _reader.readString();
          break;
        case 2:
          _instance.hostname = _reader.readString();
          break;
        case 3:
          _instance.blacklist = new APIBanItem();
          _reader.readMessage(
            _instance.blacklist,
            APIBanItem.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.rights = new APIIPRights();
          _reader.readMessage(
            _instance.rights,
            APIIPRights.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    IP.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: IP, _writer: BinaryWriter) {
    if (_instance.address) {
      _writer.writeString(1, _instance.address);
    }
    if (_instance.hostname) {
      _writer.writeString(2, _instance.hostname);
    }
    if (_instance.blacklist) {
      _writer.writeMessage(
        3,
        _instance.blacklist as any,
        APIBanItem.serializeBinaryToWriter
      );
    }
    if (_instance.rights) {
      _writer.writeMessage(
        4,
        _instance.rights as any,
        APIIPRights.serializeBinaryToWriter
      );
    }
  }

  private _address: string;
  private _hostname: string;
  private _blacklist?: APIBanItem;
  private _rights?: APIIPRights;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of IP to deeply clone from
   */
  constructor(_value?: RecursivePartial<IP.AsObject>) {
    _value = _value || {};
    this.address = _value.address;
    this.hostname = _value.hostname;
    this.blacklist = _value.blacklist
      ? new APIBanItem(_value.blacklist)
      : undefined;
    this.rights = _value.rights ? new APIIPRights(_value.rights) : undefined;
    IP.refineValues(this);
  }
  get address(): string {
    return this._address;
  }
  set address(value: string) {
    this._address = value;
  }
  get hostname(): string {
    return this._hostname;
  }
  set hostname(value: string) {
    this._hostname = value;
  }
  get blacklist(): APIBanItem | undefined {
    return this._blacklist;
  }
  set blacklist(value: APIBanItem | undefined) {
    this._blacklist = value;
  }
  get rights(): APIIPRights | undefined {
    return this._rights;
  }
  set rights(value: APIIPRights | undefined) {
    this._rights = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    IP.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): IP.AsObject {
    return {
      address: this.address,
      hostname: this.hostname,
      blacklist: this.blacklist ? this.blacklist.toObject() : undefined,
      rights: this.rights ? this.rights.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): IP.AsProtobufJSON {
    return {
      address: this.address,
      hostname: this.hostname,
      blacklist: this.blacklist ? this.blacklist.toProtobufJSON(options) : null,
      rights: this.rights ? this.rights.toProtobufJSON(options) : null
    };
  }
}
export module IP {
  /**
   * Standard JavaScript object representation for IP
   */
  export interface AsObject {
    address: string;
    hostname: string;
    blacklist?: APIBanItem.AsObject;
    rights?: APIIPRights.AsObject;
  }

  /**
   * Protobuf JSON representation for IP
   */
  export interface AsProtobufJSON {
    address: string;
    hostname: string;
    blacklist: APIBanItem.AsProtobufJSON | null;
    rights: APIIPRights.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.CreateFeedbackRequest
 */
export class CreateFeedbackRequest implements GrpcMessage {
  static id = 'goautowp.CreateFeedbackRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CreateFeedbackRequest();
    CreateFeedbackRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CreateFeedbackRequest) {
    _instance.feedback = _instance.feedback || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CreateFeedbackRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.feedback = new Feedback();
          _reader.readMessage(
            _instance.feedback,
            Feedback.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    CreateFeedbackRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CreateFeedbackRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.feedback) {
      _writer.writeMessage(
        1,
        _instance.feedback as any,
        Feedback.serializeBinaryToWriter
      );
    }
  }

  private _feedback?: Feedback;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CreateFeedbackRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<CreateFeedbackRequest.AsObject>) {
    _value = _value || {};
    this.feedback = _value.feedback ? new Feedback(_value.feedback) : undefined;
    CreateFeedbackRequest.refineValues(this);
  }
  get feedback(): Feedback | undefined {
    return this._feedback;
  }
  set feedback(value: Feedback | undefined) {
    this._feedback = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CreateFeedbackRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CreateFeedbackRequest.AsObject {
    return {
      feedback: this.feedback ? this.feedback.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CreateFeedbackRequest.AsProtobufJSON {
    return {
      feedback: this.feedback ? this.feedback.toProtobufJSON(options) : null
    };
  }
}
export module CreateFeedbackRequest {
  /**
   * Standard JavaScript object representation for CreateFeedbackRequest
   */
  export interface AsObject {
    feedback?: Feedback.AsObject;
  }

  /**
   * Protobuf JSON representation for CreateFeedbackRequest
   */
  export interface AsProtobufJSON {
    feedback: Feedback.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.Feedback
 */
export class Feedback implements GrpcMessage {
  static id = 'goautowp.Feedback';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Feedback();
    Feedback.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Feedback) {
    _instance.name = _instance.name || '';
    _instance.email = _instance.email || '';
    _instance.message = _instance.message || '';
    _instance.captcha = _instance.captcha || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: Feedback,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.name = _reader.readString();
          break;
        case 2:
          _instance.email = _reader.readString();
          break;
        case 3:
          _instance.message = _reader.readString();
          break;
        case 4:
          _instance.captcha = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    Feedback.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Feedback, _writer: BinaryWriter) {
    if (_instance.name) {
      _writer.writeString(1, _instance.name);
    }
    if (_instance.email) {
      _writer.writeString(2, _instance.email);
    }
    if (_instance.message) {
      _writer.writeString(3, _instance.message);
    }
    if (_instance.captcha) {
      _writer.writeString(4, _instance.captcha);
    }
  }

  private _name: string;
  private _email: string;
  private _message: string;
  private _captcha: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Feedback to deeply clone from
   */
  constructor(_value?: RecursivePartial<Feedback.AsObject>) {
    _value = _value || {};
    this.name = _value.name;
    this.email = _value.email;
    this.message = _value.message;
    this.captcha = _value.captcha;
    Feedback.refineValues(this);
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get email(): string {
    return this._email;
  }
  set email(value: string) {
    this._email = value;
  }
  get message(): string {
    return this._message;
  }
  set message(value: string) {
    this._message = value;
  }
  get captcha(): string {
    return this._captcha;
  }
  set captcha(value: string) {
    this._captcha = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Feedback.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Feedback.AsObject {
    return {
      name: this.name,
      email: this.email,
      message: this.message,
      captcha: this.captcha
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Feedback.AsProtobufJSON {
    return {
      name: this.name,
      email: this.email,
      message: this.message,
      captcha: this.captcha
    };
  }
}
export module Feedback {
  /**
   * Standard JavaScript object representation for Feedback
   */
  export interface AsObject {
    name: string;
    email: string;
    message: string;
    captcha: string;
  }

  /**
   * Protobuf JSON representation for Feedback
   */
  export interface AsProtobufJSON {
    name: string;
    email: string;
    message: string;
    captcha: string;
  }
}

/**
 * Message implementation for goautowp.DeleteFromTrafficWhitelistRequest
 */
export class DeleteFromTrafficWhitelistRequest implements GrpcMessage {
  static id = 'goautowp.DeleteFromTrafficWhitelistRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new DeleteFromTrafficWhitelistRequest();
    DeleteFromTrafficWhitelistRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: DeleteFromTrafficWhitelistRequest) {
    _instance.ip = _instance.ip || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: DeleteFromTrafficWhitelistRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.ip = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    DeleteFromTrafficWhitelistRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: DeleteFromTrafficWhitelistRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.ip) {
      _writer.writeString(1, _instance.ip);
    }
  }

  private _ip: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of DeleteFromTrafficWhitelistRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<DeleteFromTrafficWhitelistRequest.AsObject>
  ) {
    _value = _value || {};
    this.ip = _value.ip;
    DeleteFromTrafficWhitelistRequest.refineValues(this);
  }
  get ip(): string {
    return this._ip;
  }
  set ip(value: string) {
    this._ip = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    DeleteFromTrafficWhitelistRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): DeleteFromTrafficWhitelistRequest.AsObject {
    return {
      ip: this.ip
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): DeleteFromTrafficWhitelistRequest.AsProtobufJSON {
    return {
      ip: this.ip
    };
  }
}
export module DeleteFromTrafficWhitelistRequest {
  /**
   * Standard JavaScript object representation for DeleteFromTrafficWhitelistRequest
   */
  export interface AsObject {
    ip: string;
  }

  /**
   * Protobuf JSON representation for DeleteFromTrafficWhitelistRequest
   */
  export interface AsProtobufJSON {
    ip: string;
  }
}

/**
 * Message implementation for goautowp.DeleteFromTrafficBlacklistRequest
 */
export class DeleteFromTrafficBlacklistRequest implements GrpcMessage {
  static id = 'goautowp.DeleteFromTrafficBlacklistRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new DeleteFromTrafficBlacklistRequest();
    DeleteFromTrafficBlacklistRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: DeleteFromTrafficBlacklistRequest) {
    _instance.ip = _instance.ip || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: DeleteFromTrafficBlacklistRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.ip = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    DeleteFromTrafficBlacklistRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: DeleteFromTrafficBlacklistRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.ip) {
      _writer.writeString(1, _instance.ip);
    }
  }

  private _ip: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of DeleteFromTrafficBlacklistRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<DeleteFromTrafficBlacklistRequest.AsObject>
  ) {
    _value = _value || {};
    this.ip = _value.ip;
    DeleteFromTrafficBlacklistRequest.refineValues(this);
  }
  get ip(): string {
    return this._ip;
  }
  set ip(value: string) {
    this._ip = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    DeleteFromTrafficBlacklistRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): DeleteFromTrafficBlacklistRequest.AsObject {
    return {
      ip: this.ip
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): DeleteFromTrafficBlacklistRequest.AsProtobufJSON {
    return {
      ip: this.ip
    };
  }
}
export module DeleteFromTrafficBlacklistRequest {
  /**
   * Standard JavaScript object representation for DeleteFromTrafficBlacklistRequest
   */
  export interface AsObject {
    ip: string;
  }

  /**
   * Protobuf JSON representation for DeleteFromTrafficBlacklistRequest
   */
  export interface AsProtobufJSON {
    ip: string;
  }
}

/**
 * Message implementation for goautowp.AddToTrafficBlacklistRequest
 */
export class AddToTrafficBlacklistRequest implements GrpcMessage {
  static id = 'goautowp.AddToTrafficBlacklistRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AddToTrafficBlacklistRequest();
    AddToTrafficBlacklistRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AddToTrafficBlacklistRequest) {
    _instance.ip = _instance.ip || '';
    _instance.period = _instance.period || 0;
    _instance.reason = _instance.reason || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AddToTrafficBlacklistRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.ip = _reader.readString();
          break;
        case 2:
          _instance.period = _reader.readInt32();
          break;
        case 3:
          _instance.reason = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    AddToTrafficBlacklistRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AddToTrafficBlacklistRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.ip) {
      _writer.writeString(1, _instance.ip);
    }
    if (_instance.period) {
      _writer.writeInt32(2, _instance.period);
    }
    if (_instance.reason) {
      _writer.writeString(3, _instance.reason);
    }
  }

  private _ip: string;
  private _period: number;
  private _reason: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AddToTrafficBlacklistRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<AddToTrafficBlacklistRequest.AsObject>
  ) {
    _value = _value || {};
    this.ip = _value.ip;
    this.period = _value.period;
    this.reason = _value.reason;
    AddToTrafficBlacklistRequest.refineValues(this);
  }
  get ip(): string {
    return this._ip;
  }
  set ip(value: string) {
    this._ip = value;
  }
  get period(): number {
    return this._period;
  }
  set period(value: number) {
    this._period = value;
  }
  get reason(): string {
    return this._reason;
  }
  set reason(value: string) {
    this._reason = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AddToTrafficBlacklistRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AddToTrafficBlacklistRequest.AsObject {
    return {
      ip: this.ip,
      period: this.period,
      reason: this.reason
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AddToTrafficBlacklistRequest.AsProtobufJSON {
    return {
      ip: this.ip,
      period: this.period,
      reason: this.reason
    };
  }
}
export module AddToTrafficBlacklistRequest {
  /**
   * Standard JavaScript object representation for AddToTrafficBlacklistRequest
   */
  export interface AsObject {
    ip: string;
    period: number;
    reason: string;
  }

  /**
   * Protobuf JSON representation for AddToTrafficBlacklistRequest
   */
  export interface AsProtobufJSON {
    ip: string;
    period: number;
    reason: string;
  }
}

/**
 * Message implementation for goautowp.AddToTrafficWhitelistRequest
 */
export class AddToTrafficWhitelistRequest implements GrpcMessage {
  static id = 'goautowp.AddToTrafficWhitelistRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AddToTrafficWhitelistRequest();
    AddToTrafficWhitelistRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AddToTrafficWhitelistRequest) {
    _instance.ip = _instance.ip || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AddToTrafficWhitelistRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.ip = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    AddToTrafficWhitelistRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AddToTrafficWhitelistRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.ip) {
      _writer.writeString(1, _instance.ip);
    }
  }

  private _ip: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AddToTrafficWhitelistRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<AddToTrafficWhitelistRequest.AsObject>
  ) {
    _value = _value || {};
    this.ip = _value.ip;
    AddToTrafficWhitelistRequest.refineValues(this);
  }
  get ip(): string {
    return this._ip;
  }
  set ip(value: string) {
    this._ip = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AddToTrafficWhitelistRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AddToTrafficWhitelistRequest.AsObject {
    return {
      ip: this.ip
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AddToTrafficWhitelistRequest.AsProtobufJSON {
    return {
      ip: this.ip
    };
  }
}
export module AddToTrafficWhitelistRequest {
  /**
   * Standard JavaScript object representation for AddToTrafficWhitelistRequest
   */
  export interface AsObject {
    ip: string;
  }

  /**
   * Protobuf JSON representation for AddToTrafficWhitelistRequest
   */
  export interface AsProtobufJSON {
    ip: string;
  }
}

/**
 * Message implementation for goautowp.APITrafficWhitelistItem
 */
export class APITrafficWhitelistItem implements GrpcMessage {
  static id = 'goautowp.APITrafficWhitelistItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APITrafficWhitelistItem();
    APITrafficWhitelistItem.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APITrafficWhitelistItem) {
    _instance.ip = _instance.ip || '';
    _instance.description = _instance.description || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APITrafficWhitelistItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.ip = _reader.readString();
          break;
        case 2:
          _instance.description = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    APITrafficWhitelistItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APITrafficWhitelistItem,
    _writer: BinaryWriter
  ) {
    if (_instance.ip) {
      _writer.writeString(1, _instance.ip);
    }
    if (_instance.description) {
      _writer.writeString(2, _instance.description);
    }
  }

  private _ip: string;
  private _description: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APITrafficWhitelistItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<APITrafficWhitelistItem.AsObject>) {
    _value = _value || {};
    this.ip = _value.ip;
    this.description = _value.description;
    APITrafficWhitelistItem.refineValues(this);
  }
  get ip(): string {
    return this._ip;
  }
  set ip(value: string) {
    this._ip = value;
  }
  get description(): string {
    return this._description;
  }
  set description(value: string) {
    this._description = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APITrafficWhitelistItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APITrafficWhitelistItem.AsObject {
    return {
      ip: this.ip,
      description: this.description
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APITrafficWhitelistItem.AsProtobufJSON {
    return {
      ip: this.ip,
      description: this.description
    };
  }
}
export module APITrafficWhitelistItem {
  /**
   * Standard JavaScript object representation for APITrafficWhitelistItem
   */
  export interface AsObject {
    ip: string;
    description: string;
  }

  /**
   * Protobuf JSON representation for APITrafficWhitelistItem
   */
  export interface AsProtobufJSON {
    ip: string;
    description: string;
  }
}

/**
 * Message implementation for goautowp.APITrafficWhitelistItems
 */
export class APITrafficWhitelistItems implements GrpcMessage {
  static id = 'goautowp.APITrafficWhitelistItems';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APITrafficWhitelistItems();
    APITrafficWhitelistItems.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APITrafficWhitelistItems) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APITrafficWhitelistItems,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new APITrafficWhitelistItem();
          _reader.readMessage(
            messageInitializer1,
            APITrafficWhitelistItem.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    APITrafficWhitelistItems.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APITrafficWhitelistItems,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        APITrafficWhitelistItem.serializeBinaryToWriter
      );
    }
  }

  private _items?: APITrafficWhitelistItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APITrafficWhitelistItems to deeply clone from
   */
  constructor(_value?: RecursivePartial<APITrafficWhitelistItems.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new APITrafficWhitelistItem(m));
    APITrafficWhitelistItems.refineValues(this);
  }
  get items(): APITrafficWhitelistItem[] | undefined {
    return this._items;
  }
  set items(value: APITrafficWhitelistItem[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APITrafficWhitelistItems.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APITrafficWhitelistItems.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APITrafficWhitelistItems.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module APITrafficWhitelistItems {
  /**
   * Standard JavaScript object representation for APITrafficWhitelistItems
   */
  export interface AsObject {
    items?: APITrafficWhitelistItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for APITrafficWhitelistItems
   */
  export interface AsProtobufJSON {
    items: APITrafficWhitelistItem.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.APIForumsUserSummary
 */
export class APIForumsUserSummary implements GrpcMessage {
  static id = 'goautowp.APIForumsUserSummary';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIForumsUserSummary();
    APIForumsUserSummary.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIForumsUserSummary) {
    _instance.subscriptionsCount = _instance.subscriptionsCount || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIForumsUserSummary,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.subscriptionsCount = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    APIForumsUserSummary.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIForumsUserSummary,
    _writer: BinaryWriter
  ) {
    if (_instance.subscriptionsCount) {
      _writer.writeInt32(1, _instance.subscriptionsCount);
    }
  }

  private _subscriptionsCount: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIForumsUserSummary to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIForumsUserSummary.AsObject>) {
    _value = _value || {};
    this.subscriptionsCount = _value.subscriptionsCount;
    APIForumsUserSummary.refineValues(this);
  }
  get subscriptionsCount(): number {
    return this._subscriptionsCount;
  }
  set subscriptionsCount(value: number) {
    this._subscriptionsCount = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIForumsUserSummary.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIForumsUserSummary.AsObject {
    return {
      subscriptionsCount: this.subscriptionsCount
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIForumsUserSummary.AsProtobufJSON {
    return {
      subscriptionsCount: this.subscriptionsCount
    };
  }
}
export module APIForumsUserSummary {
  /**
   * Standard JavaScript object representation for APIForumsUserSummary
   */
  export interface AsObject {
    subscriptionsCount: number;
  }

  /**
   * Protobuf JSON representation for APIForumsUserSummary
   */
  export interface AsProtobufJSON {
    subscriptionsCount: number;
  }
}

/**
 * Message implementation for goautowp.APIGetForumsThemeRequest
 */
export class APIGetForumsThemeRequest implements GrpcMessage {
  static id = 'goautowp.APIGetForumsThemeRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIGetForumsThemeRequest();
    APIGetForumsThemeRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIGetForumsThemeRequest) {
    _instance.id = _instance.id || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIGetForumsThemeRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    APIGetForumsThemeRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIGetForumsThemeRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
  }

  private _id: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIGetForumsThemeRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIGetForumsThemeRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    APIGetForumsThemeRequest.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIGetForumsThemeRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIGetForumsThemeRequest.AsObject {
    return {
      id: this.id
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIGetForumsThemeRequest.AsProtobufJSON {
    return {
      id: this.id
    };
  }
}
export module APIGetForumsThemeRequest {
  /**
   * Standard JavaScript object representation for APIGetForumsThemeRequest
   */
  export interface AsObject {
    id: string;
  }

  /**
   * Protobuf JSON representation for APIGetForumsThemeRequest
   */
  export interface AsProtobufJSON {
    id: string;
  }
}

/**
 * Message implementation for goautowp.APIGetForumsTopicsRequest
 */
export class APIGetForumsTopicsRequest implements GrpcMessage {
  static id = 'goautowp.APIGetForumsTopicsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIGetForumsTopicsRequest();
    APIGetForumsTopicsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIGetForumsTopicsRequest) {
    _instance.themeId = _instance.themeId || '0';
    _instance.page = _instance.page || 0;
    _instance.subscription = _instance.subscription || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIGetForumsTopicsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.themeId = _reader.readInt64String();
          break;
        case 2:
          _instance.page = _reader.readInt32();
          break;
        case 3:
          _instance.subscription = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    APIGetForumsTopicsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIGetForumsTopicsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.themeId) {
      _writer.writeInt64String(1, _instance.themeId);
    }
    if (_instance.page) {
      _writer.writeInt32(2, _instance.page);
    }
    if (_instance.subscription) {
      _writer.writeBool(3, _instance.subscription);
    }
  }

  private _themeId: string;
  private _page: number;
  private _subscription: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIGetForumsTopicsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIGetForumsTopicsRequest.AsObject>) {
    _value = _value || {};
    this.themeId = _value.themeId;
    this.page = _value.page;
    this.subscription = _value.subscription;
    APIGetForumsTopicsRequest.refineValues(this);
  }
  get themeId(): string {
    return this._themeId;
  }
  set themeId(value: string) {
    this._themeId = value;
  }
  get page(): number {
    return this._page;
  }
  set page(value: number) {
    this._page = value;
  }
  get subscription(): boolean {
    return this._subscription;
  }
  set subscription(value: boolean) {
    this._subscription = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIGetForumsTopicsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIGetForumsTopicsRequest.AsObject {
    return {
      themeId: this.themeId,
      page: this.page,
      subscription: this.subscription
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIGetForumsTopicsRequest.AsProtobufJSON {
    return {
      themeId: this.themeId,
      page: this.page,
      subscription: this.subscription
    };
  }
}
export module APIGetForumsTopicsRequest {
  /**
   * Standard JavaScript object representation for APIGetForumsTopicsRequest
   */
  export interface AsObject {
    themeId: string;
    page: number;
    subscription: boolean;
  }

  /**
   * Protobuf JSON representation for APIGetForumsTopicsRequest
   */
  export interface AsProtobufJSON {
    themeId: string;
    page: number;
    subscription: boolean;
  }
}

/**
 * Message implementation for goautowp.APIGetForumsTopicRequest
 */
export class APIGetForumsTopicRequest implements GrpcMessage {
  static id = 'goautowp.APIGetForumsTopicRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIGetForumsTopicRequest();
    APIGetForumsTopicRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIGetForumsTopicRequest) {
    _instance.id = _instance.id || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIGetForumsTopicRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    APIGetForumsTopicRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIGetForumsTopicRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
  }

  private _id: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIGetForumsTopicRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIGetForumsTopicRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    APIGetForumsTopicRequest.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIGetForumsTopicRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIGetForumsTopicRequest.AsObject {
    return {
      id: this.id
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIGetForumsTopicRequest.AsProtobufJSON {
    return {
      id: this.id
    };
  }
}
export module APIGetForumsTopicRequest {
  /**
   * Standard JavaScript object representation for APIGetForumsTopicRequest
   */
  export interface AsObject {
    id: string;
  }

  /**
   * Protobuf JSON representation for APIGetForumsTopicRequest
   */
  export interface AsProtobufJSON {
    id: string;
  }
}

/**
 * Message implementation for goautowp.APIGetForumsThemesRequest
 */
export class APIGetForumsThemesRequest implements GrpcMessage {
  static id = 'goautowp.APIGetForumsThemesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIGetForumsThemesRequest();
    APIGetForumsThemesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIGetForumsThemesRequest) {
    _instance.themeId = _instance.themeId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIGetForumsThemesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.themeId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    APIGetForumsThemesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIGetForumsThemesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.themeId) {
      _writer.writeInt64String(1, _instance.themeId);
    }
  }

  private _themeId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIGetForumsThemesRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIGetForumsThemesRequest.AsObject>) {
    _value = _value || {};
    this.themeId = _value.themeId;
    APIGetForumsThemesRequest.refineValues(this);
  }
  get themeId(): string {
    return this._themeId;
  }
  set themeId(value: string) {
    this._themeId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIGetForumsThemesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIGetForumsThemesRequest.AsObject {
    return {
      themeId: this.themeId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIGetForumsThemesRequest.AsProtobufJSON {
    return {
      themeId: this.themeId
    };
  }
}
export module APIGetForumsThemesRequest {
  /**
   * Standard JavaScript object representation for APIGetForumsThemesRequest
   */
  export interface AsObject {
    themeId: string;
  }

  /**
   * Protobuf JSON representation for APIGetForumsThemesRequest
   */
  export interface AsProtobufJSON {
    themeId: string;
  }
}

/**
 * Message implementation for goautowp.APIForumsTheme
 */
export class APIForumsTheme implements GrpcMessage {
  static id = 'goautowp.APIForumsTheme';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIForumsTheme();
    APIForumsTheme.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIForumsTheme) {
    _instance.id = _instance.id || '0';
    _instance.name = _instance.name || '';
    _instance.topicsCount = _instance.topicsCount || 0;
    _instance.messagesCount = _instance.messagesCount || 0;
    _instance.disableTopics = _instance.disableTopics || false;
    _instance.description = _instance.description || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIForumsTheme,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        case 3:
          _instance.topicsCount = _reader.readInt32();
          break;
        case 4:
          _instance.messagesCount = _reader.readInt32();
          break;
        case 5:
          _instance.disableTopics = _reader.readBool();
          break;
        case 6:
          _instance.description = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    APIForumsTheme.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIForumsTheme,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
    if (_instance.topicsCount) {
      _writer.writeInt32(3, _instance.topicsCount);
    }
    if (_instance.messagesCount) {
      _writer.writeInt32(4, _instance.messagesCount);
    }
    if (_instance.disableTopics) {
      _writer.writeBool(5, _instance.disableTopics);
    }
    if (_instance.description) {
      _writer.writeString(6, _instance.description);
    }
  }

  private _id: string;
  private _name: string;
  private _topicsCount: number;
  private _messagesCount: number;
  private _disableTopics: boolean;
  private _description: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIForumsTheme to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIForumsTheme.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.name = _value.name;
    this.topicsCount = _value.topicsCount;
    this.messagesCount = _value.messagesCount;
    this.disableTopics = _value.disableTopics;
    this.description = _value.description;
    APIForumsTheme.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get topicsCount(): number {
    return this._topicsCount;
  }
  set topicsCount(value: number) {
    this._topicsCount = value;
  }
  get messagesCount(): number {
    return this._messagesCount;
  }
  set messagesCount(value: number) {
    this._messagesCount = value;
  }
  get disableTopics(): boolean {
    return this._disableTopics;
  }
  set disableTopics(value: boolean) {
    this._disableTopics = value;
  }
  get description(): string {
    return this._description;
  }
  set description(value: string) {
    this._description = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIForumsTheme.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIForumsTheme.AsObject {
    return {
      id: this.id,
      name: this.name,
      topicsCount: this.topicsCount,
      messagesCount: this.messagesCount,
      disableTopics: this.disableTopics,
      description: this.description
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIForumsTheme.AsProtobufJSON {
    return {
      id: this.id,
      name: this.name,
      topicsCount: this.topicsCount,
      messagesCount: this.messagesCount,
      disableTopics: this.disableTopics,
      description: this.description
    };
  }
}
export module APIForumsTheme {
  /**
   * Standard JavaScript object representation for APIForumsTheme
   */
  export interface AsObject {
    id: string;
    name: string;
    topicsCount: number;
    messagesCount: number;
    disableTopics: boolean;
    description: string;
  }

  /**
   * Protobuf JSON representation for APIForumsTheme
   */
  export interface AsProtobufJSON {
    id: string;
    name: string;
    topicsCount: number;
    messagesCount: number;
    disableTopics: boolean;
    description: string;
  }
}

/**
 * Message implementation for goautowp.APIForumsThemes
 */
export class APIForumsThemes implements GrpcMessage {
  static id = 'goautowp.APIForumsThemes';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIForumsThemes();
    APIForumsThemes.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIForumsThemes) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIForumsThemes,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new APIForumsTheme();
          _reader.readMessage(
            messageInitializer1,
            APIForumsTheme.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    APIForumsThemes.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIForumsThemes,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        APIForumsTheme.serializeBinaryToWriter
      );
    }
  }

  private _items?: APIForumsTheme[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIForumsThemes to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIForumsThemes.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new APIForumsTheme(m));
    APIForumsThemes.refineValues(this);
  }
  get items(): APIForumsTheme[] | undefined {
    return this._items;
  }
  set items(value: APIForumsTheme[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIForumsThemes.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIForumsThemes.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIForumsThemes.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module APIForumsThemes {
  /**
   * Standard JavaScript object representation for APIForumsThemes
   */
  export interface AsObject {
    items?: APIForumsTheme.AsObject[];
  }

  /**
   * Protobuf JSON representation for APIForumsThemes
   */
  export interface AsProtobufJSON {
    items: APIForumsTheme.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.APIForumsTopic
 */
export class APIForumsTopic implements GrpcMessage {
  static id = 'goautowp.APIForumsTopic';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIForumsTopic();
    APIForumsTopic.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIForumsTopic) {
    _instance.id = _instance.id || '0';
    _instance.name = _instance.name || '';
    _instance.status = _instance.status || '';
    _instance.oldMessages = _instance.oldMessages || 0;
    _instance.newMessages = _instance.newMessages || 0;
    _instance.createdAt = _instance.createdAt || undefined;
    _instance.userId = _instance.userId || '0';
    _instance.themeId = _instance.themeId || '0';
    _instance.subscription = _instance.subscription || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIForumsTopic,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        case 3:
          _instance.status = _reader.readString();
          break;
        case 4:
          _instance.oldMessages = _reader.readInt32();
          break;
        case 5:
          _instance.newMessages = _reader.readInt32();
          break;
        case 6:
          _instance.createdAt = new googleProtobuf006.Timestamp();
          _reader.readMessage(
            _instance.createdAt,
            googleProtobuf006.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 7:
          _instance.userId = _reader.readInt64String();
          break;
        case 8:
          _instance.themeId = _reader.readInt64String();
          break;
        case 9:
          _instance.subscription = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    APIForumsTopic.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIForumsTopic,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
    if (_instance.status) {
      _writer.writeString(3, _instance.status);
    }
    if (_instance.oldMessages) {
      _writer.writeInt32(4, _instance.oldMessages);
    }
    if (_instance.newMessages) {
      _writer.writeInt32(5, _instance.newMessages);
    }
    if (_instance.createdAt) {
      _writer.writeMessage(
        6,
        _instance.createdAt as any,
        googleProtobuf006.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.userId) {
      _writer.writeInt64String(7, _instance.userId);
    }
    if (_instance.themeId) {
      _writer.writeInt64String(8, _instance.themeId);
    }
    if (_instance.subscription) {
      _writer.writeBool(9, _instance.subscription);
    }
  }

  private _id: string;
  private _name: string;
  private _status: string;
  private _oldMessages: number;
  private _newMessages: number;
  private _createdAt?: googleProtobuf006.Timestamp;
  private _userId: string;
  private _themeId: string;
  private _subscription: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIForumsTopic to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIForumsTopic.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.name = _value.name;
    this.status = _value.status;
    this.oldMessages = _value.oldMessages;
    this.newMessages = _value.newMessages;
    this.createdAt = _value.createdAt
      ? new googleProtobuf006.Timestamp(_value.createdAt)
      : undefined;
    this.userId = _value.userId;
    this.themeId = _value.themeId;
    this.subscription = _value.subscription;
    APIForumsTopic.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get status(): string {
    return this._status;
  }
  set status(value: string) {
    this._status = value;
  }
  get oldMessages(): number {
    return this._oldMessages;
  }
  set oldMessages(value: number) {
    this._oldMessages = value;
  }
  get newMessages(): number {
    return this._newMessages;
  }
  set newMessages(value: number) {
    this._newMessages = value;
  }
  get createdAt(): googleProtobuf006.Timestamp | undefined {
    return this._createdAt;
  }
  set createdAt(value: googleProtobuf006.Timestamp | undefined) {
    this._createdAt = value;
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }
  get themeId(): string {
    return this._themeId;
  }
  set themeId(value: string) {
    this._themeId = value;
  }
  get subscription(): boolean {
    return this._subscription;
  }
  set subscription(value: boolean) {
    this._subscription = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIForumsTopic.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIForumsTopic.AsObject {
    return {
      id: this.id,
      name: this.name,
      status: this.status,
      oldMessages: this.oldMessages,
      newMessages: this.newMessages,
      createdAt: this.createdAt ? this.createdAt.toObject() : undefined,
      userId: this.userId,
      themeId: this.themeId,
      subscription: this.subscription
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIForumsTopic.AsProtobufJSON {
    return {
      id: this.id,
      name: this.name,
      status: this.status,
      oldMessages: this.oldMessages,
      newMessages: this.newMessages,
      createdAt: this.createdAt ? this.createdAt.toProtobufJSON(options) : null,
      userId: this.userId,
      themeId: this.themeId,
      subscription: this.subscription
    };
  }
}
export module APIForumsTopic {
  /**
   * Standard JavaScript object representation for APIForumsTopic
   */
  export interface AsObject {
    id: string;
    name: string;
    status: string;
    oldMessages: number;
    newMessages: number;
    createdAt?: googleProtobuf006.Timestamp.AsObject;
    userId: string;
    themeId: string;
    subscription: boolean;
  }

  /**
   * Protobuf JSON representation for APIForumsTopic
   */
  export interface AsProtobufJSON {
    id: string;
    name: string;
    status: string;
    oldMessages: number;
    newMessages: number;
    createdAt: googleProtobuf006.Timestamp.AsProtobufJSON | null;
    userId: string;
    themeId: string;
    subscription: boolean;
  }
}

/**
 * Message implementation for goautowp.APIForumsTopics
 */
export class APIForumsTopics implements GrpcMessage {
  static id = 'goautowp.APIForumsTopics';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIForumsTopics();
    APIForumsTopics.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIForumsTopics) {
    _instance.items = _instance.items || [];
    _instance.paginator = _instance.paginator || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIForumsTopics,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new APIForumsTopic();
          _reader.readMessage(
            messageInitializer1,
            APIForumsTopic.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        case 2:
          _instance.paginator = new Pages();
          _reader.readMessage(
            _instance.paginator,
            Pages.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    APIForumsTopics.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIForumsTopics,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        APIForumsTopic.serializeBinaryToWriter
      );
    }
    if (_instance.paginator) {
      _writer.writeMessage(
        2,
        _instance.paginator as any,
        Pages.serializeBinaryToWriter
      );
    }
  }

  private _items?: APIForumsTopic[];
  private _paginator?: Pages;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIForumsTopics to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIForumsTopics.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new APIForumsTopic(m));
    this.paginator = _value.paginator ? new Pages(_value.paginator) : undefined;
    APIForumsTopics.refineValues(this);
  }
  get items(): APIForumsTopic[] | undefined {
    return this._items;
  }
  set items(value: APIForumsTopic[] | undefined) {
    this._items = value;
  }
  get paginator(): Pages | undefined {
    return this._paginator;
  }
  set paginator(value: Pages | undefined) {
    this._paginator = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIForumsTopics.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIForumsTopics.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject()),
      paginator: this.paginator ? this.paginator.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIForumsTopics.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options)),
      paginator: this.paginator ? this.paginator.toProtobufJSON(options) : null
    };
  }
}
export module APIForumsTopics {
  /**
   * Standard JavaScript object representation for APIForumsTopics
   */
  export interface AsObject {
    items?: APIForumsTopic.AsObject[];
    paginator?: Pages.AsObject;
  }

  /**
   * Protobuf JSON representation for APIForumsTopics
   */
  export interface AsProtobufJSON {
    items: APIForumsTopic.AsProtobufJSON[] | null;
    paginator: Pages.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.APICommentMessage
 */
export class APICommentMessage implements GrpcMessage {
  static id = 'goautowp.APICommentMessage';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APICommentMessage();
    APICommentMessage.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APICommentMessage) {
    _instance.id = _instance.id || '0';
    _instance.createdAt = _instance.createdAt || undefined;
    _instance.userId = _instance.userId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APICommentMessage,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.createdAt = new googleProtobuf006.Timestamp();
          _reader.readMessage(
            _instance.createdAt,
            googleProtobuf006.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.userId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    APICommentMessage.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APICommentMessage,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.createdAt) {
      _writer.writeMessage(
        2,
        _instance.createdAt as any,
        googleProtobuf006.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.userId) {
      _writer.writeInt64String(3, _instance.userId);
    }
  }

  private _id: string;
  private _createdAt?: googleProtobuf006.Timestamp;
  private _userId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APICommentMessage to deeply clone from
   */
  constructor(_value?: RecursivePartial<APICommentMessage.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.createdAt = _value.createdAt
      ? new googleProtobuf006.Timestamp(_value.createdAt)
      : undefined;
    this.userId = _value.userId;
    APICommentMessage.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get createdAt(): googleProtobuf006.Timestamp | undefined {
    return this._createdAt;
  }
  set createdAt(value: googleProtobuf006.Timestamp | undefined) {
    this._createdAt = value;
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APICommentMessage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APICommentMessage.AsObject {
    return {
      id: this.id,
      createdAt: this.createdAt ? this.createdAt.toObject() : undefined,
      userId: this.userId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APICommentMessage.AsProtobufJSON {
    return {
      id: this.id,
      createdAt: this.createdAt ? this.createdAt.toProtobufJSON(options) : null,
      userId: this.userId
    };
  }
}
export module APICommentMessage {
  /**
   * Standard JavaScript object representation for APICommentMessage
   */
  export interface AsObject {
    id: string;
    createdAt?: googleProtobuf006.Timestamp.AsObject;
    userId: string;
  }

  /**
   * Protobuf JSON representation for APICommentMessage
   */
  export interface AsProtobufJSON {
    id: string;
    createdAt: googleProtobuf006.Timestamp.AsProtobufJSON | null;
    userId: string;
  }
}

/**
 * Message implementation for goautowp.APICreateTopicRequest
 */
export class APICreateTopicRequest implements GrpcMessage {
  static id = 'goautowp.APICreateTopicRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APICreateTopicRequest();
    APICreateTopicRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APICreateTopicRequest) {
    _instance.themeId = _instance.themeId || '0';
    _instance.name = _instance.name || '';
    _instance.message = _instance.message || '';
    _instance.moderatorAttention = _instance.moderatorAttention || false;
    _instance.subscription = _instance.subscription || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APICreateTopicRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.themeId = _reader.readInt64String();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        case 3:
          _instance.message = _reader.readString();
          break;
        case 4:
          _instance.moderatorAttention = _reader.readBool();
          break;
        case 5:
          _instance.subscription = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    APICreateTopicRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APICreateTopicRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.themeId) {
      _writer.writeInt64String(1, _instance.themeId);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
    if (_instance.message) {
      _writer.writeString(3, _instance.message);
    }
    if (_instance.moderatorAttention) {
      _writer.writeBool(4, _instance.moderatorAttention);
    }
    if (_instance.subscription) {
      _writer.writeBool(5, _instance.subscription);
    }
  }

  private _themeId: string;
  private _name: string;
  private _message: string;
  private _moderatorAttention: boolean;
  private _subscription: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APICreateTopicRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<APICreateTopicRequest.AsObject>) {
    _value = _value || {};
    this.themeId = _value.themeId;
    this.name = _value.name;
    this.message = _value.message;
    this.moderatorAttention = _value.moderatorAttention;
    this.subscription = _value.subscription;
    APICreateTopicRequest.refineValues(this);
  }
  get themeId(): string {
    return this._themeId;
  }
  set themeId(value: string) {
    this._themeId = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get message(): string {
    return this._message;
  }
  set message(value: string) {
    this._message = value;
  }
  get moderatorAttention(): boolean {
    return this._moderatorAttention;
  }
  set moderatorAttention(value: boolean) {
    this._moderatorAttention = value;
  }
  get subscription(): boolean {
    return this._subscription;
  }
  set subscription(value: boolean) {
    this._subscription = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APICreateTopicRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APICreateTopicRequest.AsObject {
    return {
      themeId: this.themeId,
      name: this.name,
      message: this.message,
      moderatorAttention: this.moderatorAttention,
      subscription: this.subscription
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APICreateTopicRequest.AsProtobufJSON {
    return {
      themeId: this.themeId,
      name: this.name,
      message: this.message,
      moderatorAttention: this.moderatorAttention,
      subscription: this.subscription
    };
  }
}
export module APICreateTopicRequest {
  /**
   * Standard JavaScript object representation for APICreateTopicRequest
   */
  export interface AsObject {
    themeId: string;
    name: string;
    message: string;
    moderatorAttention: boolean;
    subscription: boolean;
  }

  /**
   * Protobuf JSON representation for APICreateTopicRequest
   */
  export interface AsProtobufJSON {
    themeId: string;
    name: string;
    message: string;
    moderatorAttention: boolean;
    subscription: boolean;
  }
}

/**
 * Message implementation for goautowp.APICreateTopicResponse
 */
export class APICreateTopicResponse implements GrpcMessage {
  static id = 'goautowp.APICreateTopicResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APICreateTopicResponse();
    APICreateTopicResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APICreateTopicResponse) {
    _instance.id = _instance.id || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APICreateTopicResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    APICreateTopicResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APICreateTopicResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
  }

  private _id: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APICreateTopicResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<APICreateTopicResponse.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    APICreateTopicResponse.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APICreateTopicResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APICreateTopicResponse.AsObject {
    return {
      id: this.id
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APICreateTopicResponse.AsProtobufJSON {
    return {
      id: this.id
    };
  }
}
export module APICreateTopicResponse {
  /**
   * Standard JavaScript object representation for APICreateTopicResponse
   */
  export interface AsObject {
    id: string;
  }

  /**
   * Protobuf JSON representation for APICreateTopicResponse
   */
  export interface AsProtobufJSON {
    id: string;
  }
}

/**
 * Message implementation for goautowp.APISetTopicStatusRequest
 */
export class APISetTopicStatusRequest implements GrpcMessage {
  static id = 'goautowp.APISetTopicStatusRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APISetTopicStatusRequest();
    APISetTopicStatusRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APISetTopicStatusRequest) {
    _instance.id = _instance.id || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APISetTopicStatusRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    APISetTopicStatusRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APISetTopicStatusRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
  }

  private _id: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APISetTopicStatusRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<APISetTopicStatusRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    APISetTopicStatusRequest.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APISetTopicStatusRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APISetTopicStatusRequest.AsObject {
    return {
      id: this.id
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APISetTopicStatusRequest.AsProtobufJSON {
    return {
      id: this.id
    };
  }
}
export module APISetTopicStatusRequest {
  /**
   * Standard JavaScript object representation for APISetTopicStatusRequest
   */
  export interface AsObject {
    id: string;
  }

  /**
   * Protobuf JSON representation for APISetTopicStatusRequest
   */
  export interface AsProtobufJSON {
    id: string;
  }
}

/**
 * Message implementation for goautowp.APIMoveTopicRequest
 */
export class APIMoveTopicRequest implements GrpcMessage {
  static id = 'goautowp.APIMoveTopicRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIMoveTopicRequest();
    APIMoveTopicRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIMoveTopicRequest) {
    _instance.id = _instance.id || '0';
    _instance.themeId = _instance.themeId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIMoveTopicRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.themeId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    APIMoveTopicRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIMoveTopicRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.themeId) {
      _writer.writeInt64String(2, _instance.themeId);
    }
  }

  private _id: string;
  private _themeId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIMoveTopicRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIMoveTopicRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.themeId = _value.themeId;
    APIMoveTopicRequest.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get themeId(): string {
    return this._themeId;
  }
  set themeId(value: string) {
    this._themeId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIMoveTopicRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIMoveTopicRequest.AsObject {
    return {
      id: this.id,
      themeId: this.themeId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIMoveTopicRequest.AsProtobufJSON {
    return {
      id: this.id,
      themeId: this.themeId
    };
  }
}
export module APIMoveTopicRequest {
  /**
   * Standard JavaScript object representation for APIMoveTopicRequest
   */
  export interface AsObject {
    id: string;
    themeId: string;
  }

  /**
   * Protobuf JSON representation for APIMoveTopicRequest
   */
  export interface AsProtobufJSON {
    id: string;
    themeId: string;
  }
}

/**
 * Message implementation for goautowp.APIMessageNewCount
 */
export class APIMessageNewCount implements GrpcMessage {
  static id = 'goautowp.APIMessageNewCount';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIMessageNewCount();
    APIMessageNewCount.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIMessageNewCount) {
    _instance.count = _instance.count || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIMessageNewCount,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.count = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    APIMessageNewCount.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIMessageNewCount,
    _writer: BinaryWriter
  ) {
    if (_instance.count) {
      _writer.writeInt32(1, _instance.count);
    }
  }

  private _count: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIMessageNewCount to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIMessageNewCount.AsObject>) {
    _value = _value || {};
    this.count = _value.count;
    APIMessageNewCount.refineValues(this);
  }
  get count(): number {
    return this._count;
  }
  set count(value: number) {
    this._count = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIMessageNewCount.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIMessageNewCount.AsObject {
    return {
      count: this.count
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIMessageNewCount.AsProtobufJSON {
    return {
      count: this.count
    };
  }
}
export module APIMessageNewCount {
  /**
   * Standard JavaScript object representation for APIMessageNewCount
   */
  export interface AsObject {
    count: number;
  }

  /**
   * Protobuf JSON representation for APIMessageNewCount
   */
  export interface AsProtobufJSON {
    count: number;
  }
}

/**
 * Message implementation for goautowp.APIMessageSummary
 */
export class APIMessageSummary implements GrpcMessage {
  static id = 'goautowp.APIMessageSummary';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIMessageSummary();
    APIMessageSummary.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIMessageSummary) {
    _instance.inboxCount = _instance.inboxCount || 0;
    _instance.inboxNewCount = _instance.inboxNewCount || 0;
    _instance.sentCount = _instance.sentCount || 0;
    _instance.systemCount = _instance.systemCount || 0;
    _instance.systemNewCount = _instance.systemNewCount || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIMessageSummary,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.inboxCount = _reader.readInt32();
          break;
        case 2:
          _instance.inboxNewCount = _reader.readInt32();
          break;
        case 3:
          _instance.sentCount = _reader.readInt32();
          break;
        case 4:
          _instance.systemCount = _reader.readInt32();
          break;
        case 5:
          _instance.systemNewCount = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    APIMessageSummary.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIMessageSummary,
    _writer: BinaryWriter
  ) {
    if (_instance.inboxCount) {
      _writer.writeInt32(1, _instance.inboxCount);
    }
    if (_instance.inboxNewCount) {
      _writer.writeInt32(2, _instance.inboxNewCount);
    }
    if (_instance.sentCount) {
      _writer.writeInt32(3, _instance.sentCount);
    }
    if (_instance.systemCount) {
      _writer.writeInt32(4, _instance.systemCount);
    }
    if (_instance.systemNewCount) {
      _writer.writeInt32(5, _instance.systemNewCount);
    }
  }

  private _inboxCount: number;
  private _inboxNewCount: number;
  private _sentCount: number;
  private _systemCount: number;
  private _systemNewCount: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIMessageSummary to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIMessageSummary.AsObject>) {
    _value = _value || {};
    this.inboxCount = _value.inboxCount;
    this.inboxNewCount = _value.inboxNewCount;
    this.sentCount = _value.sentCount;
    this.systemCount = _value.systemCount;
    this.systemNewCount = _value.systemNewCount;
    APIMessageSummary.refineValues(this);
  }
  get inboxCount(): number {
    return this._inboxCount;
  }
  set inboxCount(value: number) {
    this._inboxCount = value;
  }
  get inboxNewCount(): number {
    return this._inboxNewCount;
  }
  set inboxNewCount(value: number) {
    this._inboxNewCount = value;
  }
  get sentCount(): number {
    return this._sentCount;
  }
  set sentCount(value: number) {
    this._sentCount = value;
  }
  get systemCount(): number {
    return this._systemCount;
  }
  set systemCount(value: number) {
    this._systemCount = value;
  }
  get systemNewCount(): number {
    return this._systemNewCount;
  }
  set systemNewCount(value: number) {
    this._systemNewCount = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIMessageSummary.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIMessageSummary.AsObject {
    return {
      inboxCount: this.inboxCount,
      inboxNewCount: this.inboxNewCount,
      sentCount: this.sentCount,
      systemCount: this.systemCount,
      systemNewCount: this.systemNewCount
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIMessageSummary.AsProtobufJSON {
    return {
      inboxCount: this.inboxCount,
      inboxNewCount: this.inboxNewCount,
      sentCount: this.sentCount,
      systemCount: this.systemCount,
      systemNewCount: this.systemNewCount
    };
  }
}
export module APIMessageSummary {
  /**
   * Standard JavaScript object representation for APIMessageSummary
   */
  export interface AsObject {
    inboxCount: number;
    inboxNewCount: number;
    sentCount: number;
    systemCount: number;
    systemNewCount: number;
  }

  /**
   * Protobuf JSON representation for APIMessageSummary
   */
  export interface AsProtobufJSON {
    inboxCount: number;
    inboxNewCount: number;
    sentCount: number;
    systemCount: number;
    systemNewCount: number;
  }
}

/**
 * Message implementation for goautowp.APIDeleteUserRequest
 */
export class APIDeleteUserRequest implements GrpcMessage {
  static id = 'goautowp.APIDeleteUserRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIDeleteUserRequest();
    APIDeleteUserRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIDeleteUserRequest) {
    _instance.userId = _instance.userId || '0';
    _instance.password = _instance.password || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIDeleteUserRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.userId = _reader.readInt64String();
          break;
        case 2:
          _instance.password = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    APIDeleteUserRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIDeleteUserRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.userId) {
      _writer.writeInt64String(1, _instance.userId);
    }
    if (_instance.password) {
      _writer.writeString(2, _instance.password);
    }
  }

  private _userId: string;
  private _password: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIDeleteUserRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIDeleteUserRequest.AsObject>) {
    _value = _value || {};
    this.userId = _value.userId;
    this.password = _value.password;
    APIDeleteUserRequest.refineValues(this);
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }
  get password(): string {
    return this._password;
  }
  set password(value: string) {
    this._password = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIDeleteUserRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIDeleteUserRequest.AsObject {
    return {
      userId: this.userId,
      password: this.password
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIDeleteUserRequest.AsProtobufJSON {
    return {
      userId: this.userId,
      password: this.password
    };
  }
}
export module APIDeleteUserRequest {
  /**
   * Standard JavaScript object representation for APIDeleteUserRequest
   */
  export interface AsObject {
    userId: string;
    password: string;
  }

  /**
   * Protobuf JSON representation for APIDeleteUserRequest
   */
  export interface AsProtobufJSON {
    userId: string;
    password: string;
  }
}

/**
 * Message implementation for goautowp.UpdateUserRequest
 */
export class UpdateUserRequest implements GrpcMessage {
  static id = 'goautowp.UpdateUserRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UpdateUserRequest();
    UpdateUserRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UpdateUserRequest) {
    _instance.user = _instance.user || undefined;
    _instance.updateMask = _instance.updateMask || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UpdateUserRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.user = new APIUser();
          _reader.readMessage(
            _instance.user,
            APIUser.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.updateMask = new googleProtobuf008.FieldMask();
          _reader.readMessage(
            _instance.updateMask,
            googleProtobuf008.FieldMask.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    UpdateUserRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: UpdateUserRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.user) {
      _writer.writeMessage(
        1,
        _instance.user as any,
        APIUser.serializeBinaryToWriter
      );
    }
    if (_instance.updateMask) {
      _writer.writeMessage(
        2,
        _instance.updateMask as any,
        googleProtobuf008.FieldMask.serializeBinaryToWriter
      );
    }
  }

  private _user?: APIUser;
  private _updateMask?: googleProtobuf008.FieldMask;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UpdateUserRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<UpdateUserRequest.AsObject>) {
    _value = _value || {};
    this.user = _value.user ? new APIUser(_value.user) : undefined;
    this.updateMask = _value.updateMask
      ? new googleProtobuf008.FieldMask(_value.updateMask)
      : undefined;
    UpdateUserRequest.refineValues(this);
  }
  get user(): APIUser | undefined {
    return this._user;
  }
  set user(value: APIUser | undefined) {
    this._user = value;
  }
  get updateMask(): googleProtobuf008.FieldMask | undefined {
    return this._updateMask;
  }
  set updateMask(value: googleProtobuf008.FieldMask | undefined) {
    this._updateMask = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UpdateUserRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UpdateUserRequest.AsObject {
    return {
      user: this.user ? this.user.toObject() : undefined,
      updateMask: this.updateMask ? this.updateMask.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UpdateUserRequest.AsProtobufJSON {
    return {
      user: this.user ? this.user.toProtobufJSON(options) : null,
      updateMask: this.updateMask
        ? this.updateMask.toProtobufJSON(options)
        : null
    };
  }
}
export module UpdateUserRequest {
  /**
   * Standard JavaScript object representation for UpdateUserRequest
   */
  export interface AsObject {
    user?: APIUser.AsObject;
    updateMask?: googleProtobuf008.FieldMask.AsObject;
  }

  /**
   * Protobuf JSON representation for UpdateUserRequest
   */
  export interface AsProtobufJSON {
    user: APIUser.AsProtobufJSON | null;
    updateMask: googleProtobuf008.FieldMask.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.APIMeRequest
 */
export class APIMeRequest implements GrpcMessage {
  static id = 'goautowp.APIMeRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIMeRequest();
    APIMeRequest.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIMeRequest) {
    _instance.fields = _instance.fields || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIMeRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.fields = new UserFields();
          _reader.readMessage(
            _instance.fields,
            UserFields.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    APIMeRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIMeRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.fields) {
      _writer.writeMessage(
        1,
        _instance.fields as any,
        UserFields.serializeBinaryToWriter
      );
    }
  }

  private _fields?: UserFields;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIMeRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIMeRequest.AsObject>) {
    _value = _value || {};
    this.fields = _value.fields ? new UserFields(_value.fields) : undefined;
    APIMeRequest.refineValues(this);
  }
  get fields(): UserFields | undefined {
    return this._fields;
  }
  set fields(value: UserFields | undefined) {
    this._fields = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIMeRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIMeRequest.AsObject {
    return {
      fields: this.fields ? this.fields.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIMeRequest.AsProtobufJSON {
    return {
      fields: this.fields ? this.fields.toProtobufJSON(options) : null
    };
  }
}
export module APIMeRequest {
  /**
   * Standard JavaScript object representation for APIMeRequest
   */
  export interface AsObject {
    fields?: UserFields.AsObject;
  }

  /**
   * Protobuf JSON representation for APIMeRequest
   */
  export interface AsProtobufJSON {
    fields: UserFields.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.APIGetUserRequest
 */
export class APIGetUserRequest implements GrpcMessage {
  static id = 'goautowp.APIGetUserRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIGetUserRequest();
    APIGetUserRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIGetUserRequest) {
    _instance.userId = _instance.userId || '0';
    _instance.identity = _instance.identity || '';
    _instance.fields = _instance.fields || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIGetUserRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.userId = _reader.readInt64String();
          break;
        case 3:
          _instance.identity = _reader.readString();
          break;
        case 2:
          _instance.fields = new UserFields();
          _reader.readMessage(
            _instance.fields,
            UserFields.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    APIGetUserRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIGetUserRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.userId) {
      _writer.writeInt64String(1, _instance.userId);
    }
    if (_instance.identity) {
      _writer.writeString(3, _instance.identity);
    }
    if (_instance.fields) {
      _writer.writeMessage(
        2,
        _instance.fields as any,
        UserFields.serializeBinaryToWriter
      );
    }
  }

  private _userId: string;
  private _identity: string;
  private _fields?: UserFields;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIGetUserRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIGetUserRequest.AsObject>) {
    _value = _value || {};
    this.userId = _value.userId;
    this.identity = _value.identity;
    this.fields = _value.fields ? new UserFields(_value.fields) : undefined;
    APIGetUserRequest.refineValues(this);
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }
  get identity(): string {
    return this._identity;
  }
  set identity(value: string) {
    this._identity = value;
  }
  get fields(): UserFields | undefined {
    return this._fields;
  }
  set fields(value: UserFields | undefined) {
    this._fields = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIGetUserRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIGetUserRequest.AsObject {
    return {
      userId: this.userId,
      identity: this.identity,
      fields: this.fields ? this.fields.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIGetUserRequest.AsProtobufJSON {
    return {
      userId: this.userId,
      identity: this.identity,
      fields: this.fields ? this.fields.toProtobufJSON(options) : null
    };
  }
}
export module APIGetUserRequest {
  /**
   * Standard JavaScript object representation for APIGetUserRequest
   */
  export interface AsObject {
    userId: string;
    identity: string;
    fields?: UserFields.AsObject;
  }

  /**
   * Protobuf JSON representation for APIGetUserRequest
   */
  export interface AsProtobufJSON {
    userId: string;
    identity: string;
    fields: UserFields.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.UserFields
 */
export class UserFields implements GrpcMessage {
  static id = 'goautowp.UserFields';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UserFields();
    UserFields.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UserFields) {
    _instance.email = _instance.email || false;
    _instance.timezone = _instance.timezone || false;
    _instance.language = _instance.language || false;
    _instance.votesPerDay = _instance.votesPerDay || false;
    _instance.votesLeft = _instance.votesLeft || false;
    _instance.img = _instance.img || false;
    _instance.gravatarLarge = _instance.gravatarLarge || false;
    _instance.photo = _instance.photo || false;
    _instance.regDate = _instance.regDate || false;
    _instance.picturesAdded = _instance.picturesAdded || false;
    _instance.picturesAcceptedCount = _instance.picturesAcceptedCount || false;
    _instance.lastIp = _instance.lastIp || false;
    _instance.lastOnline = _instance.lastOnline || false;
    _instance.login = _instance.login || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UserFields,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.email = _reader.readBool();
          break;
        case 3:
          _instance.timezone = _reader.readBool();
          break;
        case 4:
          _instance.language = _reader.readBool();
          break;
        case 5:
          _instance.votesPerDay = _reader.readBool();
          break;
        case 6:
          _instance.votesLeft = _reader.readBool();
          break;
        case 7:
          _instance.img = _reader.readBool();
          break;
        case 8:
          _instance.gravatarLarge = _reader.readBool();
          break;
        case 9:
          _instance.photo = _reader.readBool();
          break;
        case 11:
          _instance.regDate = _reader.readBool();
          break;
        case 14:
          _instance.picturesAdded = _reader.readBool();
          break;
        case 15:
          _instance.picturesAcceptedCount = _reader.readBool();
          break;
        case 16:
          _instance.lastIp = _reader.readBool();
          break;
        case 17:
          _instance.lastOnline = _reader.readBool();
          break;
        case 18:
          _instance.login = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    UserFields.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: UserFields, _writer: BinaryWriter) {
    if (_instance.email) {
      _writer.writeBool(1, _instance.email);
    }
    if (_instance.timezone) {
      _writer.writeBool(3, _instance.timezone);
    }
    if (_instance.language) {
      _writer.writeBool(4, _instance.language);
    }
    if (_instance.votesPerDay) {
      _writer.writeBool(5, _instance.votesPerDay);
    }
    if (_instance.votesLeft) {
      _writer.writeBool(6, _instance.votesLeft);
    }
    if (_instance.img) {
      _writer.writeBool(7, _instance.img);
    }
    if (_instance.gravatarLarge) {
      _writer.writeBool(8, _instance.gravatarLarge);
    }
    if (_instance.photo) {
      _writer.writeBool(9, _instance.photo);
    }
    if (_instance.regDate) {
      _writer.writeBool(11, _instance.regDate);
    }
    if (_instance.picturesAdded) {
      _writer.writeBool(14, _instance.picturesAdded);
    }
    if (_instance.picturesAcceptedCount) {
      _writer.writeBool(15, _instance.picturesAcceptedCount);
    }
    if (_instance.lastIp) {
      _writer.writeBool(16, _instance.lastIp);
    }
    if (_instance.lastOnline) {
      _writer.writeBool(17, _instance.lastOnline);
    }
    if (_instance.login) {
      _writer.writeBool(18, _instance.login);
    }
  }

  private _email: boolean;
  private _timezone: boolean;
  private _language: boolean;
  private _votesPerDay: boolean;
  private _votesLeft: boolean;
  private _img: boolean;
  private _gravatarLarge: boolean;
  private _photo: boolean;
  private _regDate: boolean;
  private _picturesAdded: boolean;
  private _picturesAcceptedCount: boolean;
  private _lastIp: boolean;
  private _lastOnline: boolean;
  private _login: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UserFields to deeply clone from
   */
  constructor(_value?: RecursivePartial<UserFields.AsObject>) {
    _value = _value || {};
    this.email = _value.email;
    this.timezone = _value.timezone;
    this.language = _value.language;
    this.votesPerDay = _value.votesPerDay;
    this.votesLeft = _value.votesLeft;
    this.img = _value.img;
    this.gravatarLarge = _value.gravatarLarge;
    this.photo = _value.photo;
    this.regDate = _value.regDate;
    this.picturesAdded = _value.picturesAdded;
    this.picturesAcceptedCount = _value.picturesAcceptedCount;
    this.lastIp = _value.lastIp;
    this.lastOnline = _value.lastOnline;
    this.login = _value.login;
    UserFields.refineValues(this);
  }
  get email(): boolean {
    return this._email;
  }
  set email(value: boolean) {
    this._email = value;
  }
  get timezone(): boolean {
    return this._timezone;
  }
  set timezone(value: boolean) {
    this._timezone = value;
  }
  get language(): boolean {
    return this._language;
  }
  set language(value: boolean) {
    this._language = value;
  }
  get votesPerDay(): boolean {
    return this._votesPerDay;
  }
  set votesPerDay(value: boolean) {
    this._votesPerDay = value;
  }
  get votesLeft(): boolean {
    return this._votesLeft;
  }
  set votesLeft(value: boolean) {
    this._votesLeft = value;
  }
  get img(): boolean {
    return this._img;
  }
  set img(value: boolean) {
    this._img = value;
  }
  get gravatarLarge(): boolean {
    return this._gravatarLarge;
  }
  set gravatarLarge(value: boolean) {
    this._gravatarLarge = value;
  }
  get photo(): boolean {
    return this._photo;
  }
  set photo(value: boolean) {
    this._photo = value;
  }
  get regDate(): boolean {
    return this._regDate;
  }
  set regDate(value: boolean) {
    this._regDate = value;
  }
  get picturesAdded(): boolean {
    return this._picturesAdded;
  }
  set picturesAdded(value: boolean) {
    this._picturesAdded = value;
  }
  get picturesAcceptedCount(): boolean {
    return this._picturesAcceptedCount;
  }
  set picturesAcceptedCount(value: boolean) {
    this._picturesAcceptedCount = value;
  }
  get lastIp(): boolean {
    return this._lastIp;
  }
  set lastIp(value: boolean) {
    this._lastIp = value;
  }
  get lastOnline(): boolean {
    return this._lastOnline;
  }
  set lastOnline(value: boolean) {
    this._lastOnline = value;
  }
  get login(): boolean {
    return this._login;
  }
  set login(value: boolean) {
    this._login = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UserFields.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UserFields.AsObject {
    return {
      email: this.email,
      timezone: this.timezone,
      language: this.language,
      votesPerDay: this.votesPerDay,
      votesLeft: this.votesLeft,
      img: this.img,
      gravatarLarge: this.gravatarLarge,
      photo: this.photo,
      regDate: this.regDate,
      picturesAdded: this.picturesAdded,
      picturesAcceptedCount: this.picturesAcceptedCount,
      lastIp: this.lastIp,
      lastOnline: this.lastOnline,
      login: this.login
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UserFields.AsProtobufJSON {
    return {
      email: this.email,
      timezone: this.timezone,
      language: this.language,
      votesPerDay: this.votesPerDay,
      votesLeft: this.votesLeft,
      img: this.img,
      gravatarLarge: this.gravatarLarge,
      photo: this.photo,
      regDate: this.regDate,
      picturesAdded: this.picturesAdded,
      picturesAcceptedCount: this.picturesAcceptedCount,
      lastIp: this.lastIp,
      lastOnline: this.lastOnline,
      login: this.login
    };
  }
}
export module UserFields {
  /**
   * Standard JavaScript object representation for UserFields
   */
  export interface AsObject {
    email: boolean;
    timezone: boolean;
    language: boolean;
    votesPerDay: boolean;
    votesLeft: boolean;
    img: boolean;
    gravatarLarge: boolean;
    photo: boolean;
    regDate: boolean;
    picturesAdded: boolean;
    picturesAcceptedCount: boolean;
    lastIp: boolean;
    lastOnline: boolean;
    login: boolean;
  }

  /**
   * Protobuf JSON representation for UserFields
   */
  export interface AsProtobufJSON {
    email: boolean;
    timezone: boolean;
    language: boolean;
    votesPerDay: boolean;
    votesLeft: boolean;
    img: boolean;
    gravatarLarge: boolean;
    photo: boolean;
    regDate: boolean;
    picturesAdded: boolean;
    picturesAcceptedCount: boolean;
    lastIp: boolean;
    lastOnline: boolean;
    login: boolean;
  }
}

/**
 * Message implementation for goautowp.APIBrandSection
 */
export class APIBrandSection implements GrpcMessage {
  static id = 'goautowp.APIBrandSection';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIBrandSection();
    APIBrandSection.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIBrandSection) {
    _instance.name = _instance.name || '';
    _instance.routerLink = _instance.routerLink || [];
    _instance.count = _instance.count || 0;
    _instance.groups = _instance.groups || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIBrandSection,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.name = _reader.readString();
          break;
        case 3:
          (_instance.routerLink = _instance.routerLink || []).push(
            _reader.readString()
          );
          break;
        case 4:
          _instance.count = _reader.readInt32();
          break;
        case 5:
          const messageInitializer5 = new APIBrandSection();
          _reader.readMessage(
            messageInitializer5,
            APIBrandSection.deserializeBinaryFromReader
          );
          (_instance.groups = _instance.groups || []).push(messageInitializer5);
          break;
        default:
          _reader.skipField();
      }
    }

    APIBrandSection.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIBrandSection,
    _writer: BinaryWriter
  ) {
    if (_instance.name) {
      _writer.writeString(1, _instance.name);
    }
    if (_instance.routerLink && _instance.routerLink.length) {
      _writer.writeRepeatedString(3, _instance.routerLink);
    }
    if (_instance.count) {
      _writer.writeInt32(4, _instance.count);
    }
    if (_instance.groups && _instance.groups.length) {
      _writer.writeRepeatedMessage(
        5,
        _instance.groups as any,
        APIBrandSection.serializeBinaryToWriter
      );
    }
  }

  private _name: string;
  private _routerLink: string[];
  private _count: number;
  private _groups?: APIBrandSection[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIBrandSection to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIBrandSection.AsObject>) {
    _value = _value || {};
    this.name = _value.name;
    this.routerLink = (_value.routerLink || []).slice();
    this.count = _value.count;
    this.groups = (_value.groups || []).map(m => new APIBrandSection(m));
    APIBrandSection.refineValues(this);
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get routerLink(): string[] {
    return this._routerLink;
  }
  set routerLink(value: string[]) {
    this._routerLink = value;
  }
  get count(): number {
    return this._count;
  }
  set count(value: number) {
    this._count = value;
  }
  get groups(): APIBrandSection[] | undefined {
    return this._groups;
  }
  set groups(value: APIBrandSection[] | undefined) {
    this._groups = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIBrandSection.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIBrandSection.AsObject {
    return {
      name: this.name,
      routerLink: (this.routerLink || []).slice(),
      count: this.count,
      groups: (this.groups || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIBrandSection.AsProtobufJSON {
    return {
      name: this.name,
      routerLink: (this.routerLink || []).slice(),
      count: this.count,
      groups: (this.groups || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module APIBrandSection {
  /**
   * Standard JavaScript object representation for APIBrandSection
   */
  export interface AsObject {
    name: string;
    routerLink: string[];
    count: number;
    groups?: APIBrandSection.AsObject[];
  }

  /**
   * Protobuf JSON representation for APIBrandSection
   */
  export interface AsProtobufJSON {
    name: string;
    routerLink: string[];
    count: number;
    groups: APIBrandSection.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.APIBrandSections
 */
export class APIBrandSections implements GrpcMessage {
  static id = 'goautowp.APIBrandSections';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIBrandSections();
    APIBrandSections.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIBrandSections) {
    _instance.sections = _instance.sections || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIBrandSections,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new APIBrandSection();
          _reader.readMessage(
            messageInitializer1,
            APIBrandSection.deserializeBinaryFromReader
          );
          (_instance.sections = _instance.sections || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    APIBrandSections.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIBrandSections,
    _writer: BinaryWriter
  ) {
    if (_instance.sections && _instance.sections.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.sections as any,
        APIBrandSection.serializeBinaryToWriter
      );
    }
  }

  private _sections?: APIBrandSection[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIBrandSections to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIBrandSections.AsObject>) {
    _value = _value || {};
    this.sections = (_value.sections || []).map(m => new APIBrandSection(m));
    APIBrandSections.refineValues(this);
  }
  get sections(): APIBrandSection[] | undefined {
    return this._sections;
  }
  set sections(value: APIBrandSection[] | undefined) {
    this._sections = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIBrandSections.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIBrandSections.AsObject {
    return {
      sections: (this.sections || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIBrandSections.AsProtobufJSON {
    return {
      sections: (this.sections || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module APIBrandSections {
  /**
   * Standard JavaScript object representation for APIBrandSections
   */
  export interface AsObject {
    sections?: APIBrandSection.AsObject[];
  }

  /**
   * Protobuf JSON representation for APIBrandSections
   */
  export interface AsProtobufJSON {
    sections: APIBrandSection.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.GetBrandSectionsRequest
 */
export class GetBrandSectionsRequest implements GrpcMessage {
  static id = 'goautowp.GetBrandSectionsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetBrandSectionsRequest();
    GetBrandSectionsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetBrandSectionsRequest) {
    _instance.itemId = _instance.itemId || '0';
    _instance.language = _instance.language || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetBrandSectionsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.itemId = _reader.readInt64String();
          break;
        case 2:
          _instance.language = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    GetBrandSectionsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetBrandSectionsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.itemId) {
      _writer.writeInt64String(1, _instance.itemId);
    }
    if (_instance.language) {
      _writer.writeString(2, _instance.language);
    }
  }

  private _itemId: string;
  private _language: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetBrandSectionsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetBrandSectionsRequest.AsObject>) {
    _value = _value || {};
    this.itemId = _value.itemId;
    this.language = _value.language;
    GetBrandSectionsRequest.refineValues(this);
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetBrandSectionsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetBrandSectionsRequest.AsObject {
    return {
      itemId: this.itemId,
      language: this.language
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetBrandSectionsRequest.AsProtobufJSON {
    return {
      itemId: this.itemId,
      language: this.language
    };
  }
}
export module GetBrandSectionsRequest {
  /**
   * Standard JavaScript object representation for GetBrandSectionsRequest
   */
  export interface AsObject {
    itemId: string;
    language: string;
  }

  /**
   * Protobuf JSON representation for GetBrandSectionsRequest
   */
  export interface AsProtobufJSON {
    itemId: string;
    language: string;
  }
}

/**
 * Message implementation for goautowp.GetTopBrandsListRequest
 */
export class GetTopBrandsListRequest implements GrpcMessage {
  static id = 'goautowp.GetTopBrandsListRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetTopBrandsListRequest();
    GetTopBrandsListRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetTopBrandsListRequest) {
    _instance.language = _instance.language || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetTopBrandsListRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.language = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    GetTopBrandsListRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetTopBrandsListRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.language) {
      _writer.writeString(1, _instance.language);
    }
  }

  private _language: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetTopBrandsListRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetTopBrandsListRequest.AsObject>) {
    _value = _value || {};
    this.language = _value.language;
    GetTopBrandsListRequest.refineValues(this);
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetTopBrandsListRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetTopBrandsListRequest.AsObject {
    return {
      language: this.language
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetTopBrandsListRequest.AsProtobufJSON {
    return {
      language: this.language
    };
  }
}
export module GetTopBrandsListRequest {
  /**
   * Standard JavaScript object representation for GetTopBrandsListRequest
   */
  export interface AsObject {
    language: string;
  }

  /**
   * Protobuf JSON representation for GetTopBrandsListRequest
   */
  export interface AsProtobufJSON {
    language: string;
  }
}

/**
 * Message implementation for goautowp.GetBrandsRequest
 */
export class GetBrandsRequest implements GrpcMessage {
  static id = 'goautowp.GetBrandsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetBrandsRequest();
    GetBrandsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetBrandsRequest) {
    _instance.language = _instance.language || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetBrandsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.language = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    GetBrandsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetBrandsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.language) {
      _writer.writeString(1, _instance.language);
    }
  }

  private _language: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetBrandsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetBrandsRequest.AsObject>) {
    _value = _value || {};
    this.language = _value.language;
    GetBrandsRequest.refineValues(this);
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetBrandsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetBrandsRequest.AsObject {
    return {
      language: this.language
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetBrandsRequest.AsProtobufJSON {
    return {
      language: this.language
    };
  }
}
export module GetBrandsRequest {
  /**
   * Standard JavaScript object representation for GetBrandsRequest
   */
  export interface AsObject {
    language: string;
  }

  /**
   * Protobuf JSON representation for GetBrandsRequest
   */
  export interface AsProtobufJSON {
    language: string;
  }
}

/**
 * Message implementation for goautowp.APIBrandsListItem
 */
export class APIBrandsListItem implements GrpcMessage {
  static id = 'goautowp.APIBrandsListItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIBrandsListItem();
    APIBrandsListItem.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIBrandsListItem) {
    _instance.id = _instance.id || '0';
    _instance.catname = _instance.catname || '';
    _instance.name = _instance.name || '';
    _instance.itemsCount = _instance.itemsCount || 0;
    _instance.newItemsCount = _instance.newItemsCount || 0;
    _instance.acceptedPicturesCount = _instance.acceptedPicturesCount || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIBrandsListItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.catname = _reader.readString();
          break;
        case 3:
          _instance.name = _reader.readString();
          break;
        case 4:
          _instance.itemsCount = _reader.readInt32();
          break;
        case 5:
          _instance.newItemsCount = _reader.readInt32();
          break;
        case 6:
          _instance.acceptedPicturesCount = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    APIBrandsListItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIBrandsListItem,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.catname) {
      _writer.writeString(2, _instance.catname);
    }
    if (_instance.name) {
      _writer.writeString(3, _instance.name);
    }
    if (_instance.itemsCount) {
      _writer.writeInt32(4, _instance.itemsCount);
    }
    if (_instance.newItemsCount) {
      _writer.writeInt32(5, _instance.newItemsCount);
    }
    if (_instance.acceptedPicturesCount) {
      _writer.writeInt32(6, _instance.acceptedPicturesCount);
    }
  }

  private _id: string;
  private _catname: string;
  private _name: string;
  private _itemsCount: number;
  private _newItemsCount: number;
  private _acceptedPicturesCount: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIBrandsListItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIBrandsListItem.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.catname = _value.catname;
    this.name = _value.name;
    this.itemsCount = _value.itemsCount;
    this.newItemsCount = _value.newItemsCount;
    this.acceptedPicturesCount = _value.acceptedPicturesCount;
    APIBrandsListItem.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get catname(): string {
    return this._catname;
  }
  set catname(value: string) {
    this._catname = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get itemsCount(): number {
    return this._itemsCount;
  }
  set itemsCount(value: number) {
    this._itemsCount = value;
  }
  get newItemsCount(): number {
    return this._newItemsCount;
  }
  set newItemsCount(value: number) {
    this._newItemsCount = value;
  }
  get acceptedPicturesCount(): number {
    return this._acceptedPicturesCount;
  }
  set acceptedPicturesCount(value: number) {
    this._acceptedPicturesCount = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIBrandsListItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIBrandsListItem.AsObject {
    return {
      id: this.id,
      catname: this.catname,
      name: this.name,
      itemsCount: this.itemsCount,
      newItemsCount: this.newItemsCount,
      acceptedPicturesCount: this.acceptedPicturesCount
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIBrandsListItem.AsProtobufJSON {
    return {
      id: this.id,
      catname: this.catname,
      name: this.name,
      itemsCount: this.itemsCount,
      newItemsCount: this.newItemsCount,
      acceptedPicturesCount: this.acceptedPicturesCount
    };
  }
}
export module APIBrandsListItem {
  /**
   * Standard JavaScript object representation for APIBrandsListItem
   */
  export interface AsObject {
    id: string;
    catname: string;
    name: string;
    itemsCount: number;
    newItemsCount: number;
    acceptedPicturesCount: number;
  }

  /**
   * Protobuf JSON representation for APIBrandsListItem
   */
  export interface AsProtobufJSON {
    id: string;
    catname: string;
    name: string;
    itemsCount: number;
    newItemsCount: number;
    acceptedPicturesCount: number;
  }
}

/**
 * Message implementation for goautowp.APIBrandsListCharacter
 */
export class APIBrandsListCharacter implements GrpcMessage {
  static id = 'goautowp.APIBrandsListCharacter';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIBrandsListCharacter();
    APIBrandsListCharacter.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIBrandsListCharacter) {
    _instance.character = _instance.character || '';
    _instance.id = _instance.id || '';
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIBrandsListCharacter,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.character = _reader.readString();
          break;
        case 2:
          _instance.id = _reader.readString();
          break;
        case 3:
          const messageInitializer3 = new APIBrandsListItem();
          _reader.readMessage(
            messageInitializer3,
            APIBrandsListItem.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer3);
          break;
        default:
          _reader.skipField();
      }
    }

    APIBrandsListCharacter.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIBrandsListCharacter,
    _writer: BinaryWriter
  ) {
    if (_instance.character) {
      _writer.writeString(1, _instance.character);
    }
    if (_instance.id) {
      _writer.writeString(2, _instance.id);
    }
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        3,
        _instance.items as any,
        APIBrandsListItem.serializeBinaryToWriter
      );
    }
  }

  private _character: string;
  private _id: string;
  private _items?: APIBrandsListItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIBrandsListCharacter to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIBrandsListCharacter.AsObject>) {
    _value = _value || {};
    this.character = _value.character;
    this.id = _value.id;
    this.items = (_value.items || []).map(m => new APIBrandsListItem(m));
    APIBrandsListCharacter.refineValues(this);
  }
  get character(): string {
    return this._character;
  }
  set character(value: string) {
    this._character = value;
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get items(): APIBrandsListItem[] | undefined {
    return this._items;
  }
  set items(value: APIBrandsListItem[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIBrandsListCharacter.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIBrandsListCharacter.AsObject {
    return {
      character: this.character,
      id: this.id,
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIBrandsListCharacter.AsProtobufJSON {
    return {
      character: this.character,
      id: this.id,
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module APIBrandsListCharacter {
  /**
   * Standard JavaScript object representation for APIBrandsListCharacter
   */
  export interface AsObject {
    character: string;
    id: string;
    items?: APIBrandsListItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for APIBrandsListCharacter
   */
  export interface AsProtobufJSON {
    character: string;
    id: string;
    items: APIBrandsListItem.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.APIBrandsListLine
 */
export class APIBrandsListLine implements GrpcMessage {
  static id = 'goautowp.APIBrandsListLine';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIBrandsListLine();
    APIBrandsListLine.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIBrandsListLine) {
    _instance.category = _instance.category || 0;
    _instance.characters = _instance.characters || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIBrandsListLine,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.category = _reader.readEnum();
          break;
        case 2:
          const messageInitializer2 = new APIBrandsListCharacter();
          _reader.readMessage(
            messageInitializer2,
            APIBrandsListCharacter.deserializeBinaryFromReader
          );
          (_instance.characters = _instance.characters || []).push(
            messageInitializer2
          );
          break;
        default:
          _reader.skipField();
      }
    }

    APIBrandsListLine.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIBrandsListLine,
    _writer: BinaryWriter
  ) {
    if (_instance.category) {
      _writer.writeEnum(1, _instance.category);
    }
    if (_instance.characters && _instance.characters.length) {
      _writer.writeRepeatedMessage(
        2,
        _instance.characters as any,
        APIBrandsListCharacter.serializeBinaryToWriter
      );
    }
  }

  private _category: APIBrandsListLine.Category;
  private _characters?: APIBrandsListCharacter[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIBrandsListLine to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIBrandsListLine.AsObject>) {
    _value = _value || {};
    this.category = _value.category;
    this.characters = (_value.characters || []).map(
      m => new APIBrandsListCharacter(m)
    );
    APIBrandsListLine.refineValues(this);
  }
  get category(): APIBrandsListLine.Category {
    return this._category;
  }
  set category(value: APIBrandsListLine.Category) {
    this._category = value;
  }
  get characters(): APIBrandsListCharacter[] | undefined {
    return this._characters;
  }
  set characters(value: APIBrandsListCharacter[] | undefined) {
    this._characters = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIBrandsListLine.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIBrandsListLine.AsObject {
    return {
      category: this.category,
      characters: (this.characters || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIBrandsListLine.AsProtobufJSON {
    return {
      category:
        APIBrandsListLine.Category[
          this.category === null || this.category === undefined
            ? 0
            : this.category
        ],
      characters: (this.characters || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module APIBrandsListLine {
  /**
   * Standard JavaScript object representation for APIBrandsListLine
   */
  export interface AsObject {
    category: APIBrandsListLine.Category;
    characters?: APIBrandsListCharacter.AsObject[];
  }

  /**
   * Protobuf JSON representation for APIBrandsListLine
   */
  export interface AsProtobufJSON {
    category: string;
    characters: APIBrandsListCharacter.AsProtobufJSON[] | null;
  }
  export enum Category {
    DEFAULT = 0,
    NUMBER = 1,
    CYRILLIC = 2,
    LATIN = 3
  }
}

/**
 * Message implementation for goautowp.APIBrandsList
 */
export class APIBrandsList implements GrpcMessage {
  static id = 'goautowp.APIBrandsList';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIBrandsList();
    APIBrandsList.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIBrandsList) {
    _instance.lines = _instance.lines || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIBrandsList,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new APIBrandsListLine();
          _reader.readMessage(
            messageInitializer1,
            APIBrandsListLine.deserializeBinaryFromReader
          );
          (_instance.lines = _instance.lines || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    APIBrandsList.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIBrandsList,
    _writer: BinaryWriter
  ) {
    if (_instance.lines && _instance.lines.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.lines as any,
        APIBrandsListLine.serializeBinaryToWriter
      );
    }
  }

  private _lines?: APIBrandsListLine[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIBrandsList to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIBrandsList.AsObject>) {
    _value = _value || {};
    this.lines = (_value.lines || []).map(m => new APIBrandsListLine(m));
    APIBrandsList.refineValues(this);
  }
  get lines(): APIBrandsListLine[] | undefined {
    return this._lines;
  }
  set lines(value: APIBrandsListLine[] | undefined) {
    this._lines = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIBrandsList.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIBrandsList.AsObject {
    return {
      lines: (this.lines || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIBrandsList.AsProtobufJSON {
    return {
      lines: (this.lines || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module APIBrandsList {
  /**
   * Standard JavaScript object representation for APIBrandsList
   */
  export interface AsObject {
    lines?: APIBrandsListLine.AsObject[];
  }

  /**
   * Protobuf JSON representation for APIBrandsList
   */
  export interface AsProtobufJSON {
    lines: APIBrandsListLine.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.APITopBrandsList
 */
export class APITopBrandsList implements GrpcMessage {
  static id = 'goautowp.APITopBrandsList';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APITopBrandsList();
    APITopBrandsList.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APITopBrandsList) {
    _instance.brands = _instance.brands || [];
    _instance.total = _instance.total || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APITopBrandsList,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new APITopBrandsListItem();
          _reader.readMessage(
            messageInitializer1,
            APITopBrandsListItem.deserializeBinaryFromReader
          );
          (_instance.brands = _instance.brands || []).push(messageInitializer1);
          break;
        case 2:
          _instance.total = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    APITopBrandsList.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APITopBrandsList,
    _writer: BinaryWriter
  ) {
    if (_instance.brands && _instance.brands.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.brands as any,
        APITopBrandsListItem.serializeBinaryToWriter
      );
    }
    if (_instance.total) {
      _writer.writeInt32(2, _instance.total);
    }
  }

  private _brands?: APITopBrandsListItem[];
  private _total: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APITopBrandsList to deeply clone from
   */
  constructor(_value?: RecursivePartial<APITopBrandsList.AsObject>) {
    _value = _value || {};
    this.brands = (_value.brands || []).map(m => new APITopBrandsListItem(m));
    this.total = _value.total;
    APITopBrandsList.refineValues(this);
  }
  get brands(): APITopBrandsListItem[] | undefined {
    return this._brands;
  }
  set brands(value: APITopBrandsListItem[] | undefined) {
    this._brands = value;
  }
  get total(): number {
    return this._total;
  }
  set total(value: number) {
    this._total = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APITopBrandsList.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APITopBrandsList.AsObject {
    return {
      brands: (this.brands || []).map(m => m.toObject()),
      total: this.total
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APITopBrandsList.AsProtobufJSON {
    return {
      brands: (this.brands || []).map(m => m.toProtobufJSON(options)),
      total: this.total
    };
  }
}
export module APITopBrandsList {
  /**
   * Standard JavaScript object representation for APITopBrandsList
   */
  export interface AsObject {
    brands?: APITopBrandsListItem.AsObject[];
    total: number;
  }

  /**
   * Protobuf JSON representation for APITopBrandsList
   */
  export interface AsProtobufJSON {
    brands: APITopBrandsListItem.AsProtobufJSON[] | null;
    total: number;
  }
}

/**
 * Message implementation for goautowp.APITopBrandsListItem
 */
export class APITopBrandsListItem implements GrpcMessage {
  static id = 'goautowp.APITopBrandsListItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APITopBrandsListItem();
    APITopBrandsListItem.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APITopBrandsListItem) {
    _instance.id = _instance.id || '0';
    _instance.catname = _instance.catname || '';
    _instance.name = _instance.name || '';
    _instance.itemsCount = _instance.itemsCount || 0;
    _instance.newItemsCount = _instance.newItemsCount || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APITopBrandsListItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.catname = _reader.readString();
          break;
        case 3:
          _instance.name = _reader.readString();
          break;
        case 4:
          _instance.itemsCount = _reader.readInt32();
          break;
        case 5:
          _instance.newItemsCount = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    APITopBrandsListItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APITopBrandsListItem,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.catname) {
      _writer.writeString(2, _instance.catname);
    }
    if (_instance.name) {
      _writer.writeString(3, _instance.name);
    }
    if (_instance.itemsCount) {
      _writer.writeInt32(4, _instance.itemsCount);
    }
    if (_instance.newItemsCount) {
      _writer.writeInt32(5, _instance.newItemsCount);
    }
  }

  private _id: string;
  private _catname: string;
  private _name: string;
  private _itemsCount: number;
  private _newItemsCount: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APITopBrandsListItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<APITopBrandsListItem.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.catname = _value.catname;
    this.name = _value.name;
    this.itemsCount = _value.itemsCount;
    this.newItemsCount = _value.newItemsCount;
    APITopBrandsListItem.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get catname(): string {
    return this._catname;
  }
  set catname(value: string) {
    this._catname = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get itemsCount(): number {
    return this._itemsCount;
  }
  set itemsCount(value: number) {
    this._itemsCount = value;
  }
  get newItemsCount(): number {
    return this._newItemsCount;
  }
  set newItemsCount(value: number) {
    this._newItemsCount = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APITopBrandsListItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APITopBrandsListItem.AsObject {
    return {
      id: this.id,
      catname: this.catname,
      name: this.name,
      itemsCount: this.itemsCount,
      newItemsCount: this.newItemsCount
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APITopBrandsListItem.AsProtobufJSON {
    return {
      id: this.id,
      catname: this.catname,
      name: this.name,
      itemsCount: this.itemsCount,
      newItemsCount: this.newItemsCount
    };
  }
}
export module APITopBrandsListItem {
  /**
   * Standard JavaScript object representation for APITopBrandsListItem
   */
  export interface AsObject {
    id: string;
    catname: string;
    name: string;
    itemsCount: number;
    newItemsCount: number;
  }

  /**
   * Protobuf JSON representation for APITopBrandsListItem
   */
  export interface AsProtobufJSON {
    id: string;
    catname: string;
    name: string;
    itemsCount: number;
    newItemsCount: number;
  }
}

/**
 * Message implementation for goautowp.GetTopPersonsListRequest
 */
export class GetTopPersonsListRequest implements GrpcMessage {
  static id = 'goautowp.GetTopPersonsListRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetTopPersonsListRequest();
    GetTopPersonsListRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetTopPersonsListRequest) {
    _instance.language = _instance.language || '';
    _instance.pictureItemType = _instance.pictureItemType || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetTopPersonsListRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.language = _reader.readString();
          break;
        case 2:
          _instance.pictureItemType = _reader.readEnum();
          break;
        default:
          _reader.skipField();
      }
    }

    GetTopPersonsListRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetTopPersonsListRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.language) {
      _writer.writeString(1, _instance.language);
    }
    if (_instance.pictureItemType) {
      _writer.writeEnum(2, _instance.pictureItemType);
    }
  }

  private _language: string;
  private _pictureItemType: PictureItemType;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetTopPersonsListRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetTopPersonsListRequest.AsObject>) {
    _value = _value || {};
    this.language = _value.language;
    this.pictureItemType = _value.pictureItemType;
    GetTopPersonsListRequest.refineValues(this);
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }
  get pictureItemType(): PictureItemType {
    return this._pictureItemType;
  }
  set pictureItemType(value: PictureItemType) {
    this._pictureItemType = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetTopPersonsListRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetTopPersonsListRequest.AsObject {
    return {
      language: this.language,
      pictureItemType: this.pictureItemType
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetTopPersonsListRequest.AsProtobufJSON {
    return {
      language: this.language,
      pictureItemType:
        PictureItemType[
          this.pictureItemType === null || this.pictureItemType === undefined
            ? 0
            : this.pictureItemType
        ]
    };
  }
}
export module GetTopPersonsListRequest {
  /**
   * Standard JavaScript object representation for GetTopPersonsListRequest
   */
  export interface AsObject {
    language: string;
    pictureItemType: PictureItemType;
  }

  /**
   * Protobuf JSON representation for GetTopPersonsListRequest
   */
  export interface AsProtobufJSON {
    language: string;
    pictureItemType: string;
  }
}

/**
 * Message implementation for goautowp.GetTwinsBrandsListRequest
 */
export class GetTwinsBrandsListRequest implements GrpcMessage {
  static id = 'goautowp.GetTwinsBrandsListRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetTwinsBrandsListRequest();
    GetTwinsBrandsListRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetTwinsBrandsListRequest) {
    _instance.language = _instance.language || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetTwinsBrandsListRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.language = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    GetTwinsBrandsListRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetTwinsBrandsListRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.language) {
      _writer.writeString(1, _instance.language);
    }
  }

  private _language: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetTwinsBrandsListRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetTwinsBrandsListRequest.AsObject>) {
    _value = _value || {};
    this.language = _value.language;
    GetTwinsBrandsListRequest.refineValues(this);
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetTwinsBrandsListRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetTwinsBrandsListRequest.AsObject {
    return {
      language: this.language
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetTwinsBrandsListRequest.AsProtobufJSON {
    return {
      language: this.language
    };
  }
}
export module GetTwinsBrandsListRequest {
  /**
   * Standard JavaScript object representation for GetTwinsBrandsListRequest
   */
  export interface AsObject {
    language: string;
  }

  /**
   * Protobuf JSON representation for GetTwinsBrandsListRequest
   */
  export interface AsProtobufJSON {
    language: string;
  }
}

/**
 * Message implementation for goautowp.GetTopTwinsBrandsListRequest
 */
export class GetTopTwinsBrandsListRequest implements GrpcMessage {
  static id = 'goautowp.GetTopTwinsBrandsListRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetTopTwinsBrandsListRequest();
    GetTopTwinsBrandsListRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetTopTwinsBrandsListRequest) {
    _instance.language = _instance.language || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetTopTwinsBrandsListRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.language = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    GetTopTwinsBrandsListRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetTopTwinsBrandsListRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.language) {
      _writer.writeString(1, _instance.language);
    }
  }

  private _language: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetTopTwinsBrandsListRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<GetTopTwinsBrandsListRequest.AsObject>
  ) {
    _value = _value || {};
    this.language = _value.language;
    GetTopTwinsBrandsListRequest.refineValues(this);
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetTopTwinsBrandsListRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetTopTwinsBrandsListRequest.AsObject {
    return {
      language: this.language
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetTopTwinsBrandsListRequest.AsProtobufJSON {
    return {
      language: this.language
    };
  }
}
export module GetTopTwinsBrandsListRequest {
  /**
   * Standard JavaScript object representation for GetTopTwinsBrandsListRequest
   */
  export interface AsObject {
    language: string;
  }

  /**
   * Protobuf JSON representation for GetTopTwinsBrandsListRequest
   */
  export interface AsProtobufJSON {
    language: string;
  }
}

/**
 * Message implementation for goautowp.TopSpecsContributionsRequest
 */
export class TopSpecsContributionsRequest implements GrpcMessage {
  static id = 'goautowp.TopSpecsContributionsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new TopSpecsContributionsRequest();
    TopSpecsContributionsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: TopSpecsContributionsRequest) {
    _instance.language = _instance.language || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: TopSpecsContributionsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.language = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    TopSpecsContributionsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: TopSpecsContributionsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.language) {
      _writer.writeString(1, _instance.language);
    }
  }

  private _language: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of TopSpecsContributionsRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<TopSpecsContributionsRequest.AsObject>
  ) {
    _value = _value || {};
    this.language = _value.language;
    TopSpecsContributionsRequest.refineValues(this);
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    TopSpecsContributionsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): TopSpecsContributionsRequest.AsObject {
    return {
      language: this.language
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): TopSpecsContributionsRequest.AsProtobufJSON {
    return {
      language: this.language
    };
  }
}
export module TopSpecsContributionsRequest {
  /**
   * Standard JavaScript object representation for TopSpecsContributionsRequest
   */
  export interface AsObject {
    language: string;
  }

  /**
   * Protobuf JSON representation for TopSpecsContributionsRequest
   */
  export interface AsProtobufJSON {
    language: string;
  }
}

/**
 * Message implementation for goautowp.TopSpecsContributions
 */
export class TopSpecsContributions implements GrpcMessage {
  static id = 'goautowp.TopSpecsContributions';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new TopSpecsContributions();
    TopSpecsContributions.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: TopSpecsContributions) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: TopSpecsContributions,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new APIItem();
          _reader.readMessage(
            messageInitializer1,
            APIItem.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    TopSpecsContributions.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: TopSpecsContributions,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        APIItem.serializeBinaryToWriter
      );
    }
  }

  private _items?: APIItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of TopSpecsContributions to deeply clone from
   */
  constructor(_value?: RecursivePartial<TopSpecsContributions.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new APIItem(m));
    TopSpecsContributions.refineValues(this);
  }
  get items(): APIItem[] | undefined {
    return this._items;
  }
  set items(value: APIItem[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    TopSpecsContributions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): TopSpecsContributions.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): TopSpecsContributions.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module TopSpecsContributions {
  /**
   * Standard JavaScript object representation for TopSpecsContributions
   */
  export interface AsObject {
    items?: APIItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for TopSpecsContributions
   */
  export interface AsProtobufJSON {
    items: APIItem.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.GetTopCategoriesListRequest
 */
export class GetTopCategoriesListRequest implements GrpcMessage {
  static id = 'goautowp.GetTopCategoriesListRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetTopCategoriesListRequest();
    GetTopCategoriesListRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetTopCategoriesListRequest) {
    _instance.language = _instance.language || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetTopCategoriesListRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.language = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    GetTopCategoriesListRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetTopCategoriesListRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.language) {
      _writer.writeString(1, _instance.language);
    }
  }

  private _language: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetTopCategoriesListRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetTopCategoriesListRequest.AsObject>) {
    _value = _value || {};
    this.language = _value.language;
    GetTopCategoriesListRequest.refineValues(this);
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetTopCategoriesListRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetTopCategoriesListRequest.AsObject {
    return {
      language: this.language
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetTopCategoriesListRequest.AsProtobufJSON {
    return {
      language: this.language
    };
  }
}
export module GetTopCategoriesListRequest {
  /**
   * Standard JavaScript object representation for GetTopCategoriesListRequest
   */
  export interface AsObject {
    language: string;
  }

  /**
   * Protobuf JSON representation for GetTopCategoriesListRequest
   */
  export interface AsProtobufJSON {
    language: string;
  }
}

/**
 * Message implementation for goautowp.GetTopFactoriesListRequest
 */
export class GetTopFactoriesListRequest implements GrpcMessage {
  static id = 'goautowp.GetTopFactoriesListRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetTopFactoriesListRequest();
    GetTopFactoriesListRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetTopFactoriesListRequest) {
    _instance.language = _instance.language || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetTopFactoriesListRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.language = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    GetTopFactoriesListRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetTopFactoriesListRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.language) {
      _writer.writeString(1, _instance.language);
    }
  }

  private _language: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetTopFactoriesListRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetTopFactoriesListRequest.AsObject>) {
    _value = _value || {};
    this.language = _value.language;
    GetTopFactoriesListRequest.refineValues(this);
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetTopFactoriesListRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetTopFactoriesListRequest.AsObject {
    return {
      language: this.language
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetTopFactoriesListRequest.AsProtobufJSON {
    return {
      language: this.language
    };
  }
}
export module GetTopFactoriesListRequest {
  /**
   * Standard JavaScript object representation for GetTopFactoriesListRequest
   */
  export interface AsObject {
    language: string;
  }

  /**
   * Protobuf JSON representation for GetTopFactoriesListRequest
   */
  export interface AsProtobufJSON {
    language: string;
  }
}

/**
 * Message implementation for goautowp.APITopPersonsList
 */
export class APITopPersonsList implements GrpcMessage {
  static id = 'goautowp.APITopPersonsList';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APITopPersonsList();
    APITopPersonsList.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APITopPersonsList) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APITopPersonsList,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new APITopPersonsListItem();
          _reader.readMessage(
            messageInitializer1,
            APITopPersonsListItem.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    APITopPersonsList.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APITopPersonsList,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        APITopPersonsListItem.serializeBinaryToWriter
      );
    }
  }

  private _items?: APITopPersonsListItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APITopPersonsList to deeply clone from
   */
  constructor(_value?: RecursivePartial<APITopPersonsList.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new APITopPersonsListItem(m));
    APITopPersonsList.refineValues(this);
  }
  get items(): APITopPersonsListItem[] | undefined {
    return this._items;
  }
  set items(value: APITopPersonsListItem[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APITopPersonsList.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APITopPersonsList.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APITopPersonsList.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module APITopPersonsList {
  /**
   * Standard JavaScript object representation for APITopPersonsList
   */
  export interface AsObject {
    items?: APITopPersonsListItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for APITopPersonsList
   */
  export interface AsProtobufJSON {
    items: APITopPersonsListItem.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.APITopPersonsListItem
 */
export class APITopPersonsListItem implements GrpcMessage {
  static id = 'goautowp.APITopPersonsListItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APITopPersonsListItem();
    APITopPersonsListItem.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APITopPersonsListItem) {
    _instance.id = _instance.id || '0';
    _instance.name = _instance.name || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APITopPersonsListItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 3:
          _instance.name = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    APITopPersonsListItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APITopPersonsListItem,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(3, _instance.name);
    }
  }

  private _id: string;
  private _name: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APITopPersonsListItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<APITopPersonsListItem.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.name = _value.name;
    APITopPersonsListItem.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APITopPersonsListItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APITopPersonsListItem.AsObject {
    return {
      id: this.id,
      name: this.name
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APITopPersonsListItem.AsProtobufJSON {
    return {
      id: this.id,
      name: this.name
    };
  }
}
export module APITopPersonsListItem {
  /**
   * Standard JavaScript object representation for APITopPersonsListItem
   */
  export interface AsObject {
    id: string;
    name: string;
  }

  /**
   * Protobuf JSON representation for APITopPersonsListItem
   */
  export interface AsProtobufJSON {
    id: string;
    name: string;
  }
}

/**
 * Message implementation for goautowp.APITwinsBrandsListItem
 */
export class APITwinsBrandsListItem implements GrpcMessage {
  static id = 'goautowp.APITwinsBrandsListItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APITwinsBrandsListItem();
    APITwinsBrandsListItem.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APITwinsBrandsListItem) {
    _instance.id = _instance.id || '0';
    _instance.name = _instance.name || '';
    _instance.catname = _instance.catname || '';
    _instance.count = _instance.count || 0;
    _instance.newCount = _instance.newCount || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APITwinsBrandsListItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        case 3:
          _instance.catname = _reader.readString();
          break;
        case 4:
          _instance.count = _reader.readInt32();
          break;
        case 5:
          _instance.newCount = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    APITwinsBrandsListItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APITwinsBrandsListItem,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
    if (_instance.catname) {
      _writer.writeString(3, _instance.catname);
    }
    if (_instance.count) {
      _writer.writeInt32(4, _instance.count);
    }
    if (_instance.newCount) {
      _writer.writeInt32(5, _instance.newCount);
    }
  }

  private _id: string;
  private _name: string;
  private _catname: string;
  private _count: number;
  private _newCount: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APITwinsBrandsListItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<APITwinsBrandsListItem.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.name = _value.name;
    this.catname = _value.catname;
    this.count = _value.count;
    this.newCount = _value.newCount;
    APITwinsBrandsListItem.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get catname(): string {
    return this._catname;
  }
  set catname(value: string) {
    this._catname = value;
  }
  get count(): number {
    return this._count;
  }
  set count(value: number) {
    this._count = value;
  }
  get newCount(): number {
    return this._newCount;
  }
  set newCount(value: number) {
    this._newCount = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APITwinsBrandsListItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APITwinsBrandsListItem.AsObject {
    return {
      id: this.id,
      name: this.name,
      catname: this.catname,
      count: this.count,
      newCount: this.newCount
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APITwinsBrandsListItem.AsProtobufJSON {
    return {
      id: this.id,
      name: this.name,
      catname: this.catname,
      count: this.count,
      newCount: this.newCount
    };
  }
}
export module APITwinsBrandsListItem {
  /**
   * Standard JavaScript object representation for APITwinsBrandsListItem
   */
  export interface AsObject {
    id: string;
    name: string;
    catname: string;
    count: number;
    newCount: number;
  }

  /**
   * Protobuf JSON representation for APITwinsBrandsListItem
   */
  export interface AsProtobufJSON {
    id: string;
    name: string;
    catname: string;
    count: number;
    newCount: number;
  }
}

/**
 * Message implementation for goautowp.APITwinsBrandsList
 */
export class APITwinsBrandsList implements GrpcMessage {
  static id = 'goautowp.APITwinsBrandsList';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APITwinsBrandsList();
    APITwinsBrandsList.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APITwinsBrandsList) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APITwinsBrandsList,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new APITwinsBrandsListItem();
          _reader.readMessage(
            messageInitializer1,
            APITwinsBrandsListItem.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    APITwinsBrandsList.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APITwinsBrandsList,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        APITwinsBrandsListItem.serializeBinaryToWriter
      );
    }
  }

  private _items?: APITwinsBrandsListItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APITwinsBrandsList to deeply clone from
   */
  constructor(_value?: RecursivePartial<APITwinsBrandsList.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new APITwinsBrandsListItem(m));
    APITwinsBrandsList.refineValues(this);
  }
  get items(): APITwinsBrandsListItem[] | undefined {
    return this._items;
  }
  set items(value: APITwinsBrandsListItem[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APITwinsBrandsList.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APITwinsBrandsList.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APITwinsBrandsList.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module APITwinsBrandsList {
  /**
   * Standard JavaScript object representation for APITwinsBrandsList
   */
  export interface AsObject {
    items?: APITwinsBrandsListItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for APITwinsBrandsList
   */
  export interface AsProtobufJSON {
    items: APITwinsBrandsListItem.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.APITopTwinsBrandsList
 */
export class APITopTwinsBrandsList implements GrpcMessage {
  static id = 'goautowp.APITopTwinsBrandsList';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APITopTwinsBrandsList();
    APITopTwinsBrandsList.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APITopTwinsBrandsList) {
    _instance.items = _instance.items || [];
    _instance.count = _instance.count || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APITopTwinsBrandsList,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new APITwinsBrandsListItem();
          _reader.readMessage(
            messageInitializer1,
            APITwinsBrandsListItem.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        case 2:
          _instance.count = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    APITopTwinsBrandsList.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APITopTwinsBrandsList,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        APITwinsBrandsListItem.serializeBinaryToWriter
      );
    }
    if (_instance.count) {
      _writer.writeInt32(2, _instance.count);
    }
  }

  private _items?: APITwinsBrandsListItem[];
  private _count: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APITopTwinsBrandsList to deeply clone from
   */
  constructor(_value?: RecursivePartial<APITopTwinsBrandsList.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new APITwinsBrandsListItem(m));
    this.count = _value.count;
    APITopTwinsBrandsList.refineValues(this);
  }
  get items(): APITwinsBrandsListItem[] | undefined {
    return this._items;
  }
  set items(value: APITwinsBrandsListItem[] | undefined) {
    this._items = value;
  }
  get count(): number {
    return this._count;
  }
  set count(value: number) {
    this._count = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APITopTwinsBrandsList.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APITopTwinsBrandsList.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject()),
      count: this.count
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APITopTwinsBrandsList.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options)),
      count: this.count
    };
  }
}
export module APITopTwinsBrandsList {
  /**
   * Standard JavaScript object representation for APITopTwinsBrandsList
   */
  export interface AsObject {
    items?: APITwinsBrandsListItem.AsObject[];
    count: number;
  }

  /**
   * Protobuf JSON representation for APITopTwinsBrandsList
   */
  export interface AsProtobufJSON {
    items: APITwinsBrandsListItem.AsProtobufJSON[] | null;
    count: number;
  }
}

/**
 * Message implementation for goautowp.APITopCategoriesList
 */
export class APITopCategoriesList implements GrpcMessage {
  static id = 'goautowp.APITopCategoriesList';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APITopCategoriesList();
    APITopCategoriesList.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APITopCategoriesList) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APITopCategoriesList,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new APITopCategoriesListItem();
          _reader.readMessage(
            messageInitializer1,
            APITopCategoriesListItem.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    APITopCategoriesList.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APITopCategoriesList,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        APITopCategoriesListItem.serializeBinaryToWriter
      );
    }
  }

  private _items?: APITopCategoriesListItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APITopCategoriesList to deeply clone from
   */
  constructor(_value?: RecursivePartial<APITopCategoriesList.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new APITopCategoriesListItem(m));
    APITopCategoriesList.refineValues(this);
  }
  get items(): APITopCategoriesListItem[] | undefined {
    return this._items;
  }
  set items(value: APITopCategoriesListItem[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APITopCategoriesList.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APITopCategoriesList.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APITopCategoriesList.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module APITopCategoriesList {
  /**
   * Standard JavaScript object representation for APITopCategoriesList
   */
  export interface AsObject {
    items?: APITopCategoriesListItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for APITopCategoriesList
   */
  export interface AsProtobufJSON {
    items: APITopCategoriesListItem.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.APITopCategoriesListItem
 */
export class APITopCategoriesListItem implements GrpcMessage {
  static id = 'goautowp.APITopCategoriesListItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APITopCategoriesListItem();
    APITopCategoriesListItem.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APITopCategoriesListItem) {
    _instance.id = _instance.id || '0';
    _instance.name = _instance.name || '';
    _instance.catname = _instance.catname || '';
    _instance.count = _instance.count || 0;
    _instance.newCount = _instance.newCount || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APITopCategoriesListItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        case 3:
          _instance.catname = _reader.readString();
          break;
        case 4:
          _instance.count = _reader.readInt32();
          break;
        case 5:
          _instance.newCount = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    APITopCategoriesListItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APITopCategoriesListItem,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
    if (_instance.catname) {
      _writer.writeString(3, _instance.catname);
    }
    if (_instance.count) {
      _writer.writeInt32(4, _instance.count);
    }
    if (_instance.newCount) {
      _writer.writeInt32(5, _instance.newCount);
    }
  }

  private _id: string;
  private _name: string;
  private _catname: string;
  private _count: number;
  private _newCount: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APITopCategoriesListItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<APITopCategoriesListItem.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.name = _value.name;
    this.catname = _value.catname;
    this.count = _value.count;
    this.newCount = _value.newCount;
    APITopCategoriesListItem.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get catname(): string {
    return this._catname;
  }
  set catname(value: string) {
    this._catname = value;
  }
  get count(): number {
    return this._count;
  }
  set count(value: number) {
    this._count = value;
  }
  get newCount(): number {
    return this._newCount;
  }
  set newCount(value: number) {
    this._newCount = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APITopCategoriesListItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APITopCategoriesListItem.AsObject {
    return {
      id: this.id,
      name: this.name,
      catname: this.catname,
      count: this.count,
      newCount: this.newCount
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APITopCategoriesListItem.AsProtobufJSON {
    return {
      id: this.id,
      name: this.name,
      catname: this.catname,
      count: this.count,
      newCount: this.newCount
    };
  }
}
export module APITopCategoriesListItem {
  /**
   * Standard JavaScript object representation for APITopCategoriesListItem
   */
  export interface AsObject {
    id: string;
    name: string;
    catname: string;
    count: number;
    newCount: number;
  }

  /**
   * Protobuf JSON representation for APITopCategoriesListItem
   */
  export interface AsProtobufJSON {
    id: string;
    name: string;
    catname: string;
    count: number;
    newCount: number;
  }
}

/**
 * Message implementation for goautowp.APITopFactoriesList
 */
export class APITopFactoriesList implements GrpcMessage {
  static id = 'goautowp.APITopFactoriesList';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APITopFactoriesList();
    APITopFactoriesList.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APITopFactoriesList) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APITopFactoriesList,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new APITopFactoriesListItem();
          _reader.readMessage(
            messageInitializer1,
            APITopFactoriesListItem.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    APITopFactoriesList.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APITopFactoriesList,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        APITopFactoriesListItem.serializeBinaryToWriter
      );
    }
  }

  private _items?: APITopFactoriesListItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APITopFactoriesList to deeply clone from
   */
  constructor(_value?: RecursivePartial<APITopFactoriesList.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new APITopFactoriesListItem(m));
    APITopFactoriesList.refineValues(this);
  }
  get items(): APITopFactoriesListItem[] | undefined {
    return this._items;
  }
  set items(value: APITopFactoriesListItem[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APITopFactoriesList.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APITopFactoriesList.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APITopFactoriesList.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module APITopFactoriesList {
  /**
   * Standard JavaScript object representation for APITopFactoriesList
   */
  export interface AsObject {
    items?: APITopFactoriesListItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for APITopFactoriesList
   */
  export interface AsProtobufJSON {
    items: APITopFactoriesListItem.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.APITopFactoriesListItem
 */
export class APITopFactoriesListItem implements GrpcMessage {
  static id = 'goautowp.APITopFactoriesListItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APITopFactoriesListItem();
    APITopFactoriesListItem.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APITopFactoriesListItem) {
    _instance.id = _instance.id || '0';
    _instance.name = _instance.name || '';
    _instance.count = _instance.count || 0;
    _instance.newCount = _instance.newCount || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APITopFactoriesListItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        case 3:
          _instance.count = _reader.readInt32();
          break;
        case 4:
          _instance.newCount = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    APITopFactoriesListItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APITopFactoriesListItem,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
    if (_instance.count) {
      _writer.writeInt32(3, _instance.count);
    }
    if (_instance.newCount) {
      _writer.writeInt32(4, _instance.newCount);
    }
  }

  private _id: string;
  private _name: string;
  private _count: number;
  private _newCount: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APITopFactoriesListItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<APITopFactoriesListItem.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.name = _value.name;
    this.count = _value.count;
    this.newCount = _value.newCount;
    APITopFactoriesListItem.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get count(): number {
    return this._count;
  }
  set count(value: number) {
    this._count = value;
  }
  get newCount(): number {
    return this._newCount;
  }
  set newCount(value: number) {
    this._newCount = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APITopFactoriesListItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APITopFactoriesListItem.AsObject {
    return {
      id: this.id,
      name: this.name,
      count: this.count,
      newCount: this.newCount
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APITopFactoriesListItem.AsProtobufJSON {
    return {
      id: this.id,
      name: this.name,
      count: this.count,
      newCount: this.newCount
    };
  }
}
export module APITopFactoriesListItem {
  /**
   * Standard JavaScript object representation for APITopFactoriesListItem
   */
  export interface AsObject {
    id: string;
    name: string;
    count: number;
    newCount: number;
  }

  /**
   * Protobuf JSON representation for APITopFactoriesListItem
   */
  export interface AsProtobufJSON {
    id: string;
    name: string;
    count: number;
    newCount: number;
  }
}

/**
 * Message implementation for goautowp.PictureListOptions
 */
export class PictureListOptions implements GrpcMessage {
  static id = 'goautowp.PictureListOptions';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PictureListOptions();
    PictureListOptions.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PictureListOptions) {
    _instance.id = _instance.id || '0';
    _instance.identity = _instance.identity || '';
    _instance.status = _instance.status || 0;
    _instance.statuses = _instance.statuses || [];
    _instance.pictureItem = _instance.pictureItem || undefined;
    _instance.ownerId = _instance.ownerId || '0';
    _instance.acceptedInDays = _instance.acceptedInDays || 0;
    _instance.addDate = _instance.addDate || undefined;
    _instance.acceptDate = _instance.acceptDate || undefined;
    _instance.addedFrom = _instance.addedFrom || undefined;
    _instance.commentTopic = _instance.commentTopic || undefined;
    _instance.hasNoComments = _instance.hasNoComments || false;
    _instance.hasPoint = _instance.hasPoint || false;
    _instance.hasNoPoint = _instance.hasNoPoint || false;
    _instance.hasNoPictureItem = _instance.hasNoPictureItem || false;
    _instance.replacePicture = _instance.replacePicture || undefined;
    _instance.hasNoReplacePicture = _instance.hasNoReplacePicture || false;
    _instance.pictureModerVote = _instance.pictureModerVote || undefined;
    _instance.hasNoPictureModerVote = _instance.hasNoPictureModerVote || false;
    _instance.dfDistance = _instance.dfDistance || undefined;
    _instance.hasSpecialName = _instance.hasSpecialName || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PictureListOptions,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 4:
          _instance.id = _reader.readInt64String();
          break;
        case 8:
          _instance.identity = _reader.readString();
          break;
        case 1:
          _instance.status = _reader.readEnum();
          break;
        case 9:
          (_instance.statuses = _instance.statuses || []).push(
            ...(_reader.readPackedEnum() || [])
          );
          break;
        case 2:
          _instance.pictureItem = new PictureItemListOptions();
          _reader.readMessage(
            _instance.pictureItem,
            PictureItemListOptions.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.ownerId = _reader.readInt64String();
          break;
        case 5:
          _instance.acceptedInDays = _reader.readInt32();
          break;
        case 6:
          _instance.addDate = new googleType010.Date();
          _reader.readMessage(
            _instance.addDate,
            googleType010.Date.deserializeBinaryFromReader
          );
          break;
        case 7:
          _instance.acceptDate = new googleType010.Date();
          _reader.readMessage(
            _instance.acceptDate,
            googleType010.Date.deserializeBinaryFromReader
          );
          break;
        case 10:
          _instance.addedFrom = new googleType010.Date();
          _reader.readMessage(
            _instance.addedFrom,
            googleType010.Date.deserializeBinaryFromReader
          );
          break;
        case 11:
          _instance.commentTopic = new CommentTopicListOptions();
          _reader.readMessage(
            _instance.commentTopic,
            CommentTopicListOptions.deserializeBinaryFromReader
          );
          break;
        case 12:
          _instance.hasNoComments = _reader.readBool();
          break;
        case 13:
          _instance.hasPoint = _reader.readBool();
          break;
        case 14:
          _instance.hasNoPoint = _reader.readBool();
          break;
        case 15:
          _instance.hasNoPictureItem = _reader.readBool();
          break;
        case 16:
          _instance.replacePicture = new PictureListOptions();
          _reader.readMessage(
            _instance.replacePicture,
            PictureListOptions.deserializeBinaryFromReader
          );
          break;
        case 17:
          _instance.hasNoReplacePicture = _reader.readBool();
          break;
        case 18:
          _instance.pictureModerVote = new PictureModerVoteListOptions();
          _reader.readMessage(
            _instance.pictureModerVote,
            PictureModerVoteListOptions.deserializeBinaryFromReader
          );
          break;
        case 19:
          _instance.hasNoPictureModerVote = _reader.readBool();
          break;
        case 20:
          _instance.dfDistance = new DfDistanceListOptions();
          _reader.readMessage(
            _instance.dfDistance,
            DfDistanceListOptions.deserializeBinaryFromReader
          );
          break;
        case 21:
          _instance.hasSpecialName = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    PictureListOptions.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PictureListOptions,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(4, _instance.id);
    }
    if (_instance.identity) {
      _writer.writeString(8, _instance.identity);
    }
    if (_instance.status) {
      _writer.writeEnum(1, _instance.status);
    }
    if (_instance.statuses && _instance.statuses.length) {
      _writer.writePackedEnum(9, _instance.statuses);
    }
    if (_instance.pictureItem) {
      _writer.writeMessage(
        2,
        _instance.pictureItem as any,
        PictureItemListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.ownerId) {
      _writer.writeInt64String(3, _instance.ownerId);
    }
    if (_instance.acceptedInDays) {
      _writer.writeInt32(5, _instance.acceptedInDays);
    }
    if (_instance.addDate) {
      _writer.writeMessage(
        6,
        _instance.addDate as any,
        googleType010.Date.serializeBinaryToWriter
      );
    }
    if (_instance.acceptDate) {
      _writer.writeMessage(
        7,
        _instance.acceptDate as any,
        googleType010.Date.serializeBinaryToWriter
      );
    }
    if (_instance.addedFrom) {
      _writer.writeMessage(
        10,
        _instance.addedFrom as any,
        googleType010.Date.serializeBinaryToWriter
      );
    }
    if (_instance.commentTopic) {
      _writer.writeMessage(
        11,
        _instance.commentTopic as any,
        CommentTopicListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.hasNoComments) {
      _writer.writeBool(12, _instance.hasNoComments);
    }
    if (_instance.hasPoint) {
      _writer.writeBool(13, _instance.hasPoint);
    }
    if (_instance.hasNoPoint) {
      _writer.writeBool(14, _instance.hasNoPoint);
    }
    if (_instance.hasNoPictureItem) {
      _writer.writeBool(15, _instance.hasNoPictureItem);
    }
    if (_instance.replacePicture) {
      _writer.writeMessage(
        16,
        _instance.replacePicture as any,
        PictureListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.hasNoReplacePicture) {
      _writer.writeBool(17, _instance.hasNoReplacePicture);
    }
    if (_instance.pictureModerVote) {
      _writer.writeMessage(
        18,
        _instance.pictureModerVote as any,
        PictureModerVoteListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.hasNoPictureModerVote) {
      _writer.writeBool(19, _instance.hasNoPictureModerVote);
    }
    if (_instance.dfDistance) {
      _writer.writeMessage(
        20,
        _instance.dfDistance as any,
        DfDistanceListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.hasSpecialName) {
      _writer.writeBool(21, _instance.hasSpecialName);
    }
  }

  private _id: string;
  private _identity: string;
  private _status: PictureStatus;
  private _statuses: PictureStatus[];
  private _pictureItem?: PictureItemListOptions;
  private _ownerId: string;
  private _acceptedInDays: number;
  private _addDate?: googleType010.Date;
  private _acceptDate?: googleType010.Date;
  private _addedFrom?: googleType010.Date;
  private _commentTopic?: CommentTopicListOptions;
  private _hasNoComments: boolean;
  private _hasPoint: boolean;
  private _hasNoPoint: boolean;
  private _hasNoPictureItem: boolean;
  private _replacePicture?: PictureListOptions;
  private _hasNoReplacePicture: boolean;
  private _pictureModerVote?: PictureModerVoteListOptions;
  private _hasNoPictureModerVote: boolean;
  private _dfDistance?: DfDistanceListOptions;
  private _hasSpecialName: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PictureListOptions to deeply clone from
   */
  constructor(_value?: RecursivePartial<PictureListOptions.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.identity = _value.identity;
    this.status = _value.status;
    this.statuses = (_value.statuses || []).slice();
    this.pictureItem = _value.pictureItem
      ? new PictureItemListOptions(_value.pictureItem)
      : undefined;
    this.ownerId = _value.ownerId;
    this.acceptedInDays = _value.acceptedInDays;
    this.addDate = _value.addDate
      ? new googleType010.Date(_value.addDate)
      : undefined;
    this.acceptDate = _value.acceptDate
      ? new googleType010.Date(_value.acceptDate)
      : undefined;
    this.addedFrom = _value.addedFrom
      ? new googleType010.Date(_value.addedFrom)
      : undefined;
    this.commentTopic = _value.commentTopic
      ? new CommentTopicListOptions(_value.commentTopic)
      : undefined;
    this.hasNoComments = _value.hasNoComments;
    this.hasPoint = _value.hasPoint;
    this.hasNoPoint = _value.hasNoPoint;
    this.hasNoPictureItem = _value.hasNoPictureItem;
    this.replacePicture = _value.replacePicture
      ? new PictureListOptions(_value.replacePicture)
      : undefined;
    this.hasNoReplacePicture = _value.hasNoReplacePicture;
    this.pictureModerVote = _value.pictureModerVote
      ? new PictureModerVoteListOptions(_value.pictureModerVote)
      : undefined;
    this.hasNoPictureModerVote = _value.hasNoPictureModerVote;
    this.dfDistance = _value.dfDistance
      ? new DfDistanceListOptions(_value.dfDistance)
      : undefined;
    this.hasSpecialName = _value.hasSpecialName;
    PictureListOptions.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get identity(): string {
    return this._identity;
  }
  set identity(value: string) {
    this._identity = value;
  }
  get status(): PictureStatus {
    return this._status;
  }
  set status(value: PictureStatus) {
    this._status = value;
  }
  get statuses(): PictureStatus[] {
    return this._statuses;
  }
  set statuses(value: PictureStatus[]) {
    this._statuses = value;
  }
  get pictureItem(): PictureItemListOptions | undefined {
    return this._pictureItem;
  }
  set pictureItem(value: PictureItemListOptions | undefined) {
    this._pictureItem = value;
  }
  get ownerId(): string {
    return this._ownerId;
  }
  set ownerId(value: string) {
    this._ownerId = value;
  }
  get acceptedInDays(): number {
    return this._acceptedInDays;
  }
  set acceptedInDays(value: number) {
    this._acceptedInDays = value;
  }
  get addDate(): googleType010.Date | undefined {
    return this._addDate;
  }
  set addDate(value: googleType010.Date | undefined) {
    this._addDate = value;
  }
  get acceptDate(): googleType010.Date | undefined {
    return this._acceptDate;
  }
  set acceptDate(value: googleType010.Date | undefined) {
    this._acceptDate = value;
  }
  get addedFrom(): googleType010.Date | undefined {
    return this._addedFrom;
  }
  set addedFrom(value: googleType010.Date | undefined) {
    this._addedFrom = value;
  }
  get commentTopic(): CommentTopicListOptions | undefined {
    return this._commentTopic;
  }
  set commentTopic(value: CommentTopicListOptions | undefined) {
    this._commentTopic = value;
  }
  get hasNoComments(): boolean {
    return this._hasNoComments;
  }
  set hasNoComments(value: boolean) {
    this._hasNoComments = value;
  }
  get hasPoint(): boolean {
    return this._hasPoint;
  }
  set hasPoint(value: boolean) {
    this._hasPoint = value;
  }
  get hasNoPoint(): boolean {
    return this._hasNoPoint;
  }
  set hasNoPoint(value: boolean) {
    this._hasNoPoint = value;
  }
  get hasNoPictureItem(): boolean {
    return this._hasNoPictureItem;
  }
  set hasNoPictureItem(value: boolean) {
    this._hasNoPictureItem = value;
  }
  get replacePicture(): PictureListOptions | undefined {
    return this._replacePicture;
  }
  set replacePicture(value: PictureListOptions | undefined) {
    this._replacePicture = value;
  }
  get hasNoReplacePicture(): boolean {
    return this._hasNoReplacePicture;
  }
  set hasNoReplacePicture(value: boolean) {
    this._hasNoReplacePicture = value;
  }
  get pictureModerVote(): PictureModerVoteListOptions | undefined {
    return this._pictureModerVote;
  }
  set pictureModerVote(value: PictureModerVoteListOptions | undefined) {
    this._pictureModerVote = value;
  }
  get hasNoPictureModerVote(): boolean {
    return this._hasNoPictureModerVote;
  }
  set hasNoPictureModerVote(value: boolean) {
    this._hasNoPictureModerVote = value;
  }
  get dfDistance(): DfDistanceListOptions | undefined {
    return this._dfDistance;
  }
  set dfDistance(value: DfDistanceListOptions | undefined) {
    this._dfDistance = value;
  }
  get hasSpecialName(): boolean {
    return this._hasSpecialName;
  }
  set hasSpecialName(value: boolean) {
    this._hasSpecialName = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PictureListOptions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PictureListOptions.AsObject {
    return {
      id: this.id,
      identity: this.identity,
      status: this.status,
      statuses: (this.statuses || []).slice(),
      pictureItem: this.pictureItem ? this.pictureItem.toObject() : undefined,
      ownerId: this.ownerId,
      acceptedInDays: this.acceptedInDays,
      addDate: this.addDate ? this.addDate.toObject() : undefined,
      acceptDate: this.acceptDate ? this.acceptDate.toObject() : undefined,
      addedFrom: this.addedFrom ? this.addedFrom.toObject() : undefined,
      commentTopic: this.commentTopic
        ? this.commentTopic.toObject()
        : undefined,
      hasNoComments: this.hasNoComments,
      hasPoint: this.hasPoint,
      hasNoPoint: this.hasNoPoint,
      hasNoPictureItem: this.hasNoPictureItem,
      replacePicture: this.replacePicture
        ? this.replacePicture.toObject()
        : undefined,
      hasNoReplacePicture: this.hasNoReplacePicture,
      pictureModerVote: this.pictureModerVote
        ? this.pictureModerVote.toObject()
        : undefined,
      hasNoPictureModerVote: this.hasNoPictureModerVote,
      dfDistance: this.dfDistance ? this.dfDistance.toObject() : undefined,
      hasSpecialName: this.hasSpecialName
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PictureListOptions.AsProtobufJSON {
    return {
      id: this.id,
      identity: this.identity,
      status:
        PictureStatus[
          this.status === null || this.status === undefined ? 0 : this.status
        ],
      statuses: (this.statuses || []).map(v => PictureStatus[v]),
      pictureItem: this.pictureItem
        ? this.pictureItem.toProtobufJSON(options)
        : null,
      ownerId: this.ownerId,
      acceptedInDays: this.acceptedInDays,
      addDate: this.addDate ? this.addDate.toProtobufJSON(options) : null,
      acceptDate: this.acceptDate
        ? this.acceptDate.toProtobufJSON(options)
        : null,
      addedFrom: this.addedFrom ? this.addedFrom.toProtobufJSON(options) : null,
      commentTopic: this.commentTopic
        ? this.commentTopic.toProtobufJSON(options)
        : null,
      hasNoComments: this.hasNoComments,
      hasPoint: this.hasPoint,
      hasNoPoint: this.hasNoPoint,
      hasNoPictureItem: this.hasNoPictureItem,
      replacePicture: this.replacePicture
        ? this.replacePicture.toProtobufJSON(options)
        : null,
      hasNoReplacePicture: this.hasNoReplacePicture,
      pictureModerVote: this.pictureModerVote
        ? this.pictureModerVote.toProtobufJSON(options)
        : null,
      hasNoPictureModerVote: this.hasNoPictureModerVote,
      dfDistance: this.dfDistance
        ? this.dfDistance.toProtobufJSON(options)
        : null,
      hasSpecialName: this.hasSpecialName
    };
  }
}
export module PictureListOptions {
  /**
   * Standard JavaScript object representation for PictureListOptions
   */
  export interface AsObject {
    id: string;
    identity: string;
    status: PictureStatus;
    statuses: PictureStatus[];
    pictureItem?: PictureItemListOptions.AsObject;
    ownerId: string;
    acceptedInDays: number;
    addDate?: googleType010.Date.AsObject;
    acceptDate?: googleType010.Date.AsObject;
    addedFrom?: googleType010.Date.AsObject;
    commentTopic?: CommentTopicListOptions.AsObject;
    hasNoComments: boolean;
    hasPoint: boolean;
    hasNoPoint: boolean;
    hasNoPictureItem: boolean;
    replacePicture?: PictureListOptions.AsObject;
    hasNoReplacePicture: boolean;
    pictureModerVote?: PictureModerVoteListOptions.AsObject;
    hasNoPictureModerVote: boolean;
    dfDistance?: DfDistanceListOptions.AsObject;
    hasSpecialName: boolean;
  }

  /**
   * Protobuf JSON representation for PictureListOptions
   */
  export interface AsProtobufJSON {
    id: string;
    identity: string;
    status: string;
    statuses: string[];
    pictureItem: PictureItemListOptions.AsProtobufJSON | null;
    ownerId: string;
    acceptedInDays: number;
    addDate: googleType010.Date.AsProtobufJSON | null;
    acceptDate: googleType010.Date.AsProtobufJSON | null;
    addedFrom: googleType010.Date.AsProtobufJSON | null;
    commentTopic: CommentTopicListOptions.AsProtobufJSON | null;
    hasNoComments: boolean;
    hasPoint: boolean;
    hasNoPoint: boolean;
    hasNoPictureItem: boolean;
    replacePicture: PictureListOptions.AsProtobufJSON | null;
    hasNoReplacePicture: boolean;
    pictureModerVote: PictureModerVoteListOptions.AsProtobufJSON | null;
    hasNoPictureModerVote: boolean;
    dfDistance: DfDistanceListOptions.AsProtobufJSON | null;
    hasSpecialName: boolean;
  }
}

/**
 * Message implementation for goautowp.DfDistanceListOptions
 */
export class DfDistanceListOptions implements GrpcMessage {
  static id = 'goautowp.DfDistanceListOptions';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new DfDistanceListOptions();
    DfDistanceListOptions.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: DfDistanceListOptions) {
    _instance.dstPicture = _instance.dstPicture || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: DfDistanceListOptions,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.dstPicture = new PictureListOptions();
          _reader.readMessage(
            _instance.dstPicture,
            PictureListOptions.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    DfDistanceListOptions.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: DfDistanceListOptions,
    _writer: BinaryWriter
  ) {
    if (_instance.dstPicture) {
      _writer.writeMessage(
        1,
        _instance.dstPicture as any,
        PictureListOptions.serializeBinaryToWriter
      );
    }
  }

  private _dstPicture?: PictureListOptions;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of DfDistanceListOptions to deeply clone from
   */
  constructor(_value?: RecursivePartial<DfDistanceListOptions.AsObject>) {
    _value = _value || {};
    this.dstPicture = _value.dstPicture
      ? new PictureListOptions(_value.dstPicture)
      : undefined;
    DfDistanceListOptions.refineValues(this);
  }
  get dstPicture(): PictureListOptions | undefined {
    return this._dstPicture;
  }
  set dstPicture(value: PictureListOptions | undefined) {
    this._dstPicture = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    DfDistanceListOptions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): DfDistanceListOptions.AsObject {
    return {
      dstPicture: this.dstPicture ? this.dstPicture.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): DfDistanceListOptions.AsProtobufJSON {
    return {
      dstPicture: this.dstPicture
        ? this.dstPicture.toProtobufJSON(options)
        : null
    };
  }
}
export module DfDistanceListOptions {
  /**
   * Standard JavaScript object representation for DfDistanceListOptions
   */
  export interface AsObject {
    dstPicture?: PictureListOptions.AsObject;
  }

  /**
   * Protobuf JSON representation for DfDistanceListOptions
   */
  export interface AsProtobufJSON {
    dstPicture: PictureListOptions.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.PictureModerVoteListOptions
 */
export class PictureModerVoteListOptions implements GrpcMessage {
  static id = 'goautowp.PictureModerVoteListOptions';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PictureModerVoteListOptions();
    PictureModerVoteListOptions.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PictureModerVoteListOptions) {
    _instance.voteGtZero = _instance.voteGtZero || false;
    _instance.voteLteZero = _instance.voteLteZero || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PictureModerVoteListOptions,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.voteGtZero = _reader.readBool();
          break;
        case 2:
          _instance.voteLteZero = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    PictureModerVoteListOptions.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PictureModerVoteListOptions,
    _writer: BinaryWriter
  ) {
    if (_instance.voteGtZero) {
      _writer.writeBool(1, _instance.voteGtZero);
    }
    if (_instance.voteLteZero) {
      _writer.writeBool(2, _instance.voteLteZero);
    }
  }

  private _voteGtZero: boolean;
  private _voteLteZero: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PictureModerVoteListOptions to deeply clone from
   */
  constructor(_value?: RecursivePartial<PictureModerVoteListOptions.AsObject>) {
    _value = _value || {};
    this.voteGtZero = _value.voteGtZero;
    this.voteLteZero = _value.voteLteZero;
    PictureModerVoteListOptions.refineValues(this);
  }
  get voteGtZero(): boolean {
    return this._voteGtZero;
  }
  set voteGtZero(value: boolean) {
    this._voteGtZero = value;
  }
  get voteLteZero(): boolean {
    return this._voteLteZero;
  }
  set voteLteZero(value: boolean) {
    this._voteLteZero = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PictureModerVoteListOptions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PictureModerVoteListOptions.AsObject {
    return {
      voteGtZero: this.voteGtZero,
      voteLteZero: this.voteLteZero
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PictureModerVoteListOptions.AsProtobufJSON {
    return {
      voteGtZero: this.voteGtZero,
      voteLteZero: this.voteLteZero
    };
  }
}
export module PictureModerVoteListOptions {
  /**
   * Standard JavaScript object representation for PictureModerVoteListOptions
   */
  export interface AsObject {
    voteGtZero: boolean;
    voteLteZero: boolean;
  }

  /**
   * Protobuf JSON representation for PictureModerVoteListOptions
   */
  export interface AsProtobufJSON {
    voteGtZero: boolean;
    voteLteZero: boolean;
  }
}

/**
 * Message implementation for goautowp.PathTreeItem
 */
export class PathTreeItem implements GrpcMessage {
  static id = 'goautowp.PathTreeItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PathTreeItem();
    PathTreeItem.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PathTreeItem) {
    _instance.catname = _instance.catname || '';
    _instance.itemTypeId = _instance.itemTypeId || 0;
    _instance.parents = _instance.parents || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PathTreeItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.catname = _reader.readString();
          break;
        case 2:
          _instance.itemTypeId = _reader.readEnum();
          break;
        case 3:
          const messageInitializer3 = new PathTreeItemParent();
          _reader.readMessage(
            messageInitializer3,
            PathTreeItemParent.deserializeBinaryFromReader
          );
          (_instance.parents = _instance.parents || []).push(
            messageInitializer3
          );
          break;
        default:
          _reader.skipField();
      }
    }

    PathTreeItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PathTreeItem,
    _writer: BinaryWriter
  ) {
    if (_instance.catname) {
      _writer.writeString(1, _instance.catname);
    }
    if (_instance.itemTypeId) {
      _writer.writeEnum(2, _instance.itemTypeId);
    }
    if (_instance.parents && _instance.parents.length) {
      _writer.writeRepeatedMessage(
        3,
        _instance.parents as any,
        PathTreeItemParent.serializeBinaryToWriter
      );
    }
  }

  private _catname: string;
  private _itemTypeId: ItemType;
  private _parents?: PathTreeItemParent[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PathTreeItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<PathTreeItem.AsObject>) {
    _value = _value || {};
    this.catname = _value.catname;
    this.itemTypeId = _value.itemTypeId;
    this.parents = (_value.parents || []).map(m => new PathTreeItemParent(m));
    PathTreeItem.refineValues(this);
  }
  get catname(): string {
    return this._catname;
  }
  set catname(value: string) {
    this._catname = value;
  }
  get itemTypeId(): ItemType {
    return this._itemTypeId;
  }
  set itemTypeId(value: ItemType) {
    this._itemTypeId = value;
  }
  get parents(): PathTreeItemParent[] | undefined {
    return this._parents;
  }
  set parents(value: PathTreeItemParent[] | undefined) {
    this._parents = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PathTreeItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PathTreeItem.AsObject {
    return {
      catname: this.catname,
      itemTypeId: this.itemTypeId,
      parents: (this.parents || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PathTreeItem.AsProtobufJSON {
    return {
      catname: this.catname,
      itemTypeId:
        ItemType[
          this.itemTypeId === null || this.itemTypeId === undefined
            ? 0
            : this.itemTypeId
        ],
      parents: (this.parents || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module PathTreeItem {
  /**
   * Standard JavaScript object representation for PathTreeItem
   */
  export interface AsObject {
    catname: string;
    itemTypeId: ItemType;
    parents?: PathTreeItemParent.AsObject[];
  }

  /**
   * Protobuf JSON representation for PathTreeItem
   */
  export interface AsProtobufJSON {
    catname: string;
    itemTypeId: string;
    parents: PathTreeItemParent.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.PathTreeItemParent
 */
export class PathTreeItemParent implements GrpcMessage {
  static id = 'goautowp.PathTreeItemParent';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PathTreeItemParent();
    PathTreeItemParent.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PathTreeItemParent) {
    _instance.catname = _instance.catname || '';
    _instance.item = _instance.item || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PathTreeItemParent,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.catname = _reader.readString();
          break;
        case 2:
          _instance.item = new PathTreeItem();
          _reader.readMessage(
            _instance.item,
            PathTreeItem.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    PathTreeItemParent.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PathTreeItemParent,
    _writer: BinaryWriter
  ) {
    if (_instance.catname) {
      _writer.writeString(1, _instance.catname);
    }
    if (_instance.item) {
      _writer.writeMessage(
        2,
        _instance.item as any,
        PathTreeItem.serializeBinaryToWriter
      );
    }
  }

  private _catname: string;
  private _item?: PathTreeItem;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PathTreeItemParent to deeply clone from
   */
  constructor(_value?: RecursivePartial<PathTreeItemParent.AsObject>) {
    _value = _value || {};
    this.catname = _value.catname;
    this.item = _value.item ? new PathTreeItem(_value.item) : undefined;
    PathTreeItemParent.refineValues(this);
  }
  get catname(): string {
    return this._catname;
  }
  set catname(value: string) {
    this._catname = value;
  }
  get item(): PathTreeItem | undefined {
    return this._item;
  }
  set item(value: PathTreeItem | undefined) {
    this._item = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PathTreeItemParent.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PathTreeItemParent.AsObject {
    return {
      catname: this.catname,
      item: this.item ? this.item.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PathTreeItemParent.AsProtobufJSON {
    return {
      catname: this.catname,
      item: this.item ? this.item.toProtobufJSON(options) : null
    };
  }
}
export module PathTreeItemParent {
  /**
   * Standard JavaScript object representation for PathTreeItemParent
   */
  export interface AsObject {
    catname: string;
    item?: PathTreeItem.AsObject;
  }

  /**
   * Protobuf JSON representation for PathTreeItemParent
   */
  export interface AsProtobufJSON {
    catname: string;
    item: PathTreeItem.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.PathTreePictureItem
 */
export class PathTreePictureItem implements GrpcMessage {
  static id = 'goautowp.PathTreePictureItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PathTreePictureItem();
    PathTreePictureItem.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PathTreePictureItem) {
    _instance.item = _instance.item || undefined;
    _instance.perspectiveId = _instance.perspectiveId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PathTreePictureItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.item = new PathTreeItem();
          _reader.readMessage(
            _instance.item,
            PathTreeItem.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.perspectiveId = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    PathTreePictureItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PathTreePictureItem,
    _writer: BinaryWriter
  ) {
    if (_instance.item) {
      _writer.writeMessage(
        1,
        _instance.item as any,
        PathTreeItem.serializeBinaryToWriter
      );
    }
    if (_instance.perspectiveId) {
      _writer.writeInt32(2, _instance.perspectiveId);
    }
  }

  private _item?: PathTreeItem;
  private _perspectiveId: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PathTreePictureItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<PathTreePictureItem.AsObject>) {
    _value = _value || {};
    this.item = _value.item ? new PathTreeItem(_value.item) : undefined;
    this.perspectiveId = _value.perspectiveId;
    PathTreePictureItem.refineValues(this);
  }
  get item(): PathTreeItem | undefined {
    return this._item;
  }
  set item(value: PathTreeItem | undefined) {
    this._item = value;
  }
  get perspectiveId(): number {
    return this._perspectiveId;
  }
  set perspectiveId(value: number) {
    this._perspectiveId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PathTreePictureItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PathTreePictureItem.AsObject {
    return {
      item: this.item ? this.item.toObject() : undefined,
      perspectiveId: this.perspectiveId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PathTreePictureItem.AsProtobufJSON {
    return {
      item: this.item ? this.item.toProtobufJSON(options) : null,
      perspectiveId: this.perspectiveId
    };
  }
}
export module PathTreePictureItem {
  /**
   * Standard JavaScript object representation for PathTreePictureItem
   */
  export interface AsObject {
    item?: PathTreeItem.AsObject;
    perspectiveId: number;
  }

  /**
   * Protobuf JSON representation for PathTreePictureItem
   */
  export interface AsProtobufJSON {
    item: PathTreeItem.AsProtobufJSON | null;
    perspectiveId: number;
  }
}

/**
 * Message implementation for goautowp.PictureFields
 */
export class PictureFields implements GrpcMessage {
  static id = 'goautowp.PictureFields';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PictureFields();
    PictureFields.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PictureFields) {
    _instance.nameText = _instance.nameText || false;
    _instance.nameHtml = _instance.nameHtml || false;
    _instance.image = _instance.image || false;
    _instance.thumbMedium = _instance.thumbMedium || false;
    _instance.thumbLarge = _instance.thumbLarge || false;
    _instance.views = _instance.views || false;
    _instance.votes = _instance.votes || false;
    _instance.commentsCount = _instance.commentsCount || false;
    _instance.moderVote = _instance.moderVote || false;
    _instance.path = _instance.path || undefined;
    _instance.pictureItem = _instance.pictureItem || undefined;
    _instance.imageGalleryFull = _instance.imageGalleryFull || false;
    _instance.imageGallery = _instance.imageGallery || false;
    _instance.dfDistance = _instance.dfDistance || undefined;
    _instance.acceptedCount = _instance.acceptedCount || false;
    _instance.copyrights = _instance.copyrights || false;
    _instance.exif = _instance.exif || false;
    _instance.isLast = _instance.isLast || false;
    _instance.moderVoted = _instance.moderVoted || false;
    _instance.pictureModerVotes = _instance.pictureModerVotes || undefined;
    _instance.replaceable = _instance.replaceable || undefined;
    _instance.rights = _instance.rights || false;
    _instance.siblings = _instance.siblings || undefined;
    _instance.specialName = _instance.specialName || false;
    _instance.taken = _instance.taken || false;
    _instance.previewLarge = _instance.previewLarge || false;
    _instance.subscribed = _instance.subscribed || false;
    _instance.paginator = _instance.paginator || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PictureFields,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.nameText = _reader.readBool();
          break;
        case 4:
          _instance.nameHtml = _reader.readBool();
          break;
        case 2:
          _instance.image = _reader.readBool();
          break;
        case 3:
          _instance.thumbMedium = _reader.readBool();
          break;
        case 28:
          _instance.thumbLarge = _reader.readBool();
          break;
        case 5:
          _instance.views = _reader.readBool();
          break;
        case 6:
          _instance.votes = _reader.readBool();
          break;
        case 7:
          _instance.commentsCount = _reader.readBool();
          break;
        case 8:
          _instance.moderVote = _reader.readBool();
          break;
        case 10:
          _instance.path = new PicturePathRequest();
          _reader.readMessage(
            _instance.path,
            PicturePathRequest.deserializeBinaryFromReader
          );
          break;
        case 11:
          _instance.pictureItem = new PictureItemsRequest();
          _reader.readMessage(
            _instance.pictureItem,
            PictureItemsRequest.deserializeBinaryFromReader
          );
          break;
        case 12:
          _instance.imageGalleryFull = _reader.readBool();
          break;
        case 29:
          _instance.imageGallery = _reader.readBool();
          break;
        case 13:
          _instance.dfDistance = new DfDistanceRequest();
          _reader.readMessage(
            _instance.dfDistance,
            DfDistanceRequest.deserializeBinaryFromReader
          );
          break;
        case 14:
          _instance.acceptedCount = _reader.readBool();
          break;
        case 15:
          _instance.copyrights = _reader.readBool();
          break;
        case 16:
          _instance.exif = _reader.readBool();
          break;
        case 17:
          _instance.isLast = _reader.readBool();
          break;
        case 18:
          _instance.moderVoted = _reader.readBool();
          break;
        case 19:
          _instance.pictureModerVotes = new PictureModerVoteRequest();
          _reader.readMessage(
            _instance.pictureModerVotes,
            PictureModerVoteRequest.deserializeBinaryFromReader
          );
          break;
        case 20:
          _instance.replaceable = new PicturesRequest();
          _reader.readMessage(
            _instance.replaceable,
            PicturesRequest.deserializeBinaryFromReader
          );
          break;
        case 21:
          _instance.rights = _reader.readBool();
          break;
        case 22:
          _instance.siblings = new PicturesRequest();
          _reader.readMessage(
            _instance.siblings,
            PicturesRequest.deserializeBinaryFromReader
          );
          break;
        case 23:
          _instance.specialName = _reader.readBool();
          break;
        case 24:
          _instance.taken = _reader.readBool();
          break;
        case 25:
          _instance.previewLarge = _reader.readBool();
          break;
        case 26:
          _instance.subscribed = _reader.readBool();
          break;
        case 27:
          _instance.paginator = new PicturesRequest();
          _reader.readMessage(
            _instance.paginator,
            PicturesRequest.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    PictureFields.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PictureFields,
    _writer: BinaryWriter
  ) {
    if (_instance.nameText) {
      _writer.writeBool(1, _instance.nameText);
    }
    if (_instance.nameHtml) {
      _writer.writeBool(4, _instance.nameHtml);
    }
    if (_instance.image) {
      _writer.writeBool(2, _instance.image);
    }
    if (_instance.thumbMedium) {
      _writer.writeBool(3, _instance.thumbMedium);
    }
    if (_instance.thumbLarge) {
      _writer.writeBool(28, _instance.thumbLarge);
    }
    if (_instance.views) {
      _writer.writeBool(5, _instance.views);
    }
    if (_instance.votes) {
      _writer.writeBool(6, _instance.votes);
    }
    if (_instance.commentsCount) {
      _writer.writeBool(7, _instance.commentsCount);
    }
    if (_instance.moderVote) {
      _writer.writeBool(8, _instance.moderVote);
    }
    if (_instance.path) {
      _writer.writeMessage(
        10,
        _instance.path as any,
        PicturePathRequest.serializeBinaryToWriter
      );
    }
    if (_instance.pictureItem) {
      _writer.writeMessage(
        11,
        _instance.pictureItem as any,
        PictureItemsRequest.serializeBinaryToWriter
      );
    }
    if (_instance.imageGalleryFull) {
      _writer.writeBool(12, _instance.imageGalleryFull);
    }
    if (_instance.imageGallery) {
      _writer.writeBool(29, _instance.imageGallery);
    }
    if (_instance.dfDistance) {
      _writer.writeMessage(
        13,
        _instance.dfDistance as any,
        DfDistanceRequest.serializeBinaryToWriter
      );
    }
    if (_instance.acceptedCount) {
      _writer.writeBool(14, _instance.acceptedCount);
    }
    if (_instance.copyrights) {
      _writer.writeBool(15, _instance.copyrights);
    }
    if (_instance.exif) {
      _writer.writeBool(16, _instance.exif);
    }
    if (_instance.isLast) {
      _writer.writeBool(17, _instance.isLast);
    }
    if (_instance.moderVoted) {
      _writer.writeBool(18, _instance.moderVoted);
    }
    if (_instance.pictureModerVotes) {
      _writer.writeMessage(
        19,
        _instance.pictureModerVotes as any,
        PictureModerVoteRequest.serializeBinaryToWriter
      );
    }
    if (_instance.replaceable) {
      _writer.writeMessage(
        20,
        _instance.replaceable as any,
        PicturesRequest.serializeBinaryToWriter
      );
    }
    if (_instance.rights) {
      _writer.writeBool(21, _instance.rights);
    }
    if (_instance.siblings) {
      _writer.writeMessage(
        22,
        _instance.siblings as any,
        PicturesRequest.serializeBinaryToWriter
      );
    }
    if (_instance.specialName) {
      _writer.writeBool(23, _instance.specialName);
    }
    if (_instance.taken) {
      _writer.writeBool(24, _instance.taken);
    }
    if (_instance.previewLarge) {
      _writer.writeBool(25, _instance.previewLarge);
    }
    if (_instance.subscribed) {
      _writer.writeBool(26, _instance.subscribed);
    }
    if (_instance.paginator) {
      _writer.writeMessage(
        27,
        _instance.paginator as any,
        PicturesRequest.serializeBinaryToWriter
      );
    }
  }

  private _nameText: boolean;
  private _nameHtml: boolean;
  private _image: boolean;
  private _thumbMedium: boolean;
  private _thumbLarge: boolean;
  private _views: boolean;
  private _votes: boolean;
  private _commentsCount: boolean;
  private _moderVote: boolean;
  private _path?: PicturePathRequest;
  private _pictureItem?: PictureItemsRequest;
  private _imageGalleryFull: boolean;
  private _imageGallery: boolean;
  private _dfDistance?: DfDistanceRequest;
  private _acceptedCount: boolean;
  private _copyrights: boolean;
  private _exif: boolean;
  private _isLast: boolean;
  private _moderVoted: boolean;
  private _pictureModerVotes?: PictureModerVoteRequest;
  private _replaceable?: PicturesRequest;
  private _rights: boolean;
  private _siblings?: PicturesRequest;
  private _specialName: boolean;
  private _taken: boolean;
  private _previewLarge: boolean;
  private _subscribed: boolean;
  private _paginator?: PicturesRequest;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PictureFields to deeply clone from
   */
  constructor(_value?: RecursivePartial<PictureFields.AsObject>) {
    _value = _value || {};
    this.nameText = _value.nameText;
    this.nameHtml = _value.nameHtml;
    this.image = _value.image;
    this.thumbMedium = _value.thumbMedium;
    this.thumbLarge = _value.thumbLarge;
    this.views = _value.views;
    this.votes = _value.votes;
    this.commentsCount = _value.commentsCount;
    this.moderVote = _value.moderVote;
    this.path = _value.path ? new PicturePathRequest(_value.path) : undefined;
    this.pictureItem = _value.pictureItem
      ? new PictureItemsRequest(_value.pictureItem)
      : undefined;
    this.imageGalleryFull = _value.imageGalleryFull;
    this.imageGallery = _value.imageGallery;
    this.dfDistance = _value.dfDistance
      ? new DfDistanceRequest(_value.dfDistance)
      : undefined;
    this.acceptedCount = _value.acceptedCount;
    this.copyrights = _value.copyrights;
    this.exif = _value.exif;
    this.isLast = _value.isLast;
    this.moderVoted = _value.moderVoted;
    this.pictureModerVotes = _value.pictureModerVotes
      ? new PictureModerVoteRequest(_value.pictureModerVotes)
      : undefined;
    this.replaceable = _value.replaceable
      ? new PicturesRequest(_value.replaceable)
      : undefined;
    this.rights = _value.rights;
    this.siblings = _value.siblings
      ? new PicturesRequest(_value.siblings)
      : undefined;
    this.specialName = _value.specialName;
    this.taken = _value.taken;
    this.previewLarge = _value.previewLarge;
    this.subscribed = _value.subscribed;
    this.paginator = _value.paginator
      ? new PicturesRequest(_value.paginator)
      : undefined;
    PictureFields.refineValues(this);
  }
  get nameText(): boolean {
    return this._nameText;
  }
  set nameText(value: boolean) {
    this._nameText = value;
  }
  get nameHtml(): boolean {
    return this._nameHtml;
  }
  set nameHtml(value: boolean) {
    this._nameHtml = value;
  }
  get image(): boolean {
    return this._image;
  }
  set image(value: boolean) {
    this._image = value;
  }
  get thumbMedium(): boolean {
    return this._thumbMedium;
  }
  set thumbMedium(value: boolean) {
    this._thumbMedium = value;
  }
  get thumbLarge(): boolean {
    return this._thumbLarge;
  }
  set thumbLarge(value: boolean) {
    this._thumbLarge = value;
  }
  get views(): boolean {
    return this._views;
  }
  set views(value: boolean) {
    this._views = value;
  }
  get votes(): boolean {
    return this._votes;
  }
  set votes(value: boolean) {
    this._votes = value;
  }
  get commentsCount(): boolean {
    return this._commentsCount;
  }
  set commentsCount(value: boolean) {
    this._commentsCount = value;
  }
  get moderVote(): boolean {
    return this._moderVote;
  }
  set moderVote(value: boolean) {
    this._moderVote = value;
  }
  get path(): PicturePathRequest | undefined {
    return this._path;
  }
  set path(value: PicturePathRequest | undefined) {
    this._path = value;
  }
  get pictureItem(): PictureItemsRequest | undefined {
    return this._pictureItem;
  }
  set pictureItem(value: PictureItemsRequest | undefined) {
    this._pictureItem = value;
  }
  get imageGalleryFull(): boolean {
    return this._imageGalleryFull;
  }
  set imageGalleryFull(value: boolean) {
    this._imageGalleryFull = value;
  }
  get imageGallery(): boolean {
    return this._imageGallery;
  }
  set imageGallery(value: boolean) {
    this._imageGallery = value;
  }
  get dfDistance(): DfDistanceRequest | undefined {
    return this._dfDistance;
  }
  set dfDistance(value: DfDistanceRequest | undefined) {
    this._dfDistance = value;
  }
  get acceptedCount(): boolean {
    return this._acceptedCount;
  }
  set acceptedCount(value: boolean) {
    this._acceptedCount = value;
  }
  get copyrights(): boolean {
    return this._copyrights;
  }
  set copyrights(value: boolean) {
    this._copyrights = value;
  }
  get exif(): boolean {
    return this._exif;
  }
  set exif(value: boolean) {
    this._exif = value;
  }
  get isLast(): boolean {
    return this._isLast;
  }
  set isLast(value: boolean) {
    this._isLast = value;
  }
  get moderVoted(): boolean {
    return this._moderVoted;
  }
  set moderVoted(value: boolean) {
    this._moderVoted = value;
  }
  get pictureModerVotes(): PictureModerVoteRequest | undefined {
    return this._pictureModerVotes;
  }
  set pictureModerVotes(value: PictureModerVoteRequest | undefined) {
    this._pictureModerVotes = value;
  }
  get replaceable(): PicturesRequest | undefined {
    return this._replaceable;
  }
  set replaceable(value: PicturesRequest | undefined) {
    this._replaceable = value;
  }
  get rights(): boolean {
    return this._rights;
  }
  set rights(value: boolean) {
    this._rights = value;
  }
  get siblings(): PicturesRequest | undefined {
    return this._siblings;
  }
  set siblings(value: PicturesRequest | undefined) {
    this._siblings = value;
  }
  get specialName(): boolean {
    return this._specialName;
  }
  set specialName(value: boolean) {
    this._specialName = value;
  }
  get taken(): boolean {
    return this._taken;
  }
  set taken(value: boolean) {
    this._taken = value;
  }
  get previewLarge(): boolean {
    return this._previewLarge;
  }
  set previewLarge(value: boolean) {
    this._previewLarge = value;
  }
  get subscribed(): boolean {
    return this._subscribed;
  }
  set subscribed(value: boolean) {
    this._subscribed = value;
  }
  get paginator(): PicturesRequest | undefined {
    return this._paginator;
  }
  set paginator(value: PicturesRequest | undefined) {
    this._paginator = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PictureFields.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PictureFields.AsObject {
    return {
      nameText: this.nameText,
      nameHtml: this.nameHtml,
      image: this.image,
      thumbMedium: this.thumbMedium,
      thumbLarge: this.thumbLarge,
      views: this.views,
      votes: this.votes,
      commentsCount: this.commentsCount,
      moderVote: this.moderVote,
      path: this.path ? this.path.toObject() : undefined,
      pictureItem: this.pictureItem ? this.pictureItem.toObject() : undefined,
      imageGalleryFull: this.imageGalleryFull,
      imageGallery: this.imageGallery,
      dfDistance: this.dfDistance ? this.dfDistance.toObject() : undefined,
      acceptedCount: this.acceptedCount,
      copyrights: this.copyrights,
      exif: this.exif,
      isLast: this.isLast,
      moderVoted: this.moderVoted,
      pictureModerVotes: this.pictureModerVotes
        ? this.pictureModerVotes.toObject()
        : undefined,
      replaceable: this.replaceable ? this.replaceable.toObject() : undefined,
      rights: this.rights,
      siblings: this.siblings ? this.siblings.toObject() : undefined,
      specialName: this.specialName,
      taken: this.taken,
      previewLarge: this.previewLarge,
      subscribed: this.subscribed,
      paginator: this.paginator ? this.paginator.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PictureFields.AsProtobufJSON {
    return {
      nameText: this.nameText,
      nameHtml: this.nameHtml,
      image: this.image,
      thumbMedium: this.thumbMedium,
      thumbLarge: this.thumbLarge,
      views: this.views,
      votes: this.votes,
      commentsCount: this.commentsCount,
      moderVote: this.moderVote,
      path: this.path ? this.path.toProtobufJSON(options) : null,
      pictureItem: this.pictureItem
        ? this.pictureItem.toProtobufJSON(options)
        : null,
      imageGalleryFull: this.imageGalleryFull,
      imageGallery: this.imageGallery,
      dfDistance: this.dfDistance
        ? this.dfDistance.toProtobufJSON(options)
        : null,
      acceptedCount: this.acceptedCount,
      copyrights: this.copyrights,
      exif: this.exif,
      isLast: this.isLast,
      moderVoted: this.moderVoted,
      pictureModerVotes: this.pictureModerVotes
        ? this.pictureModerVotes.toProtobufJSON(options)
        : null,
      replaceable: this.replaceable
        ? this.replaceable.toProtobufJSON(options)
        : null,
      rights: this.rights,
      siblings: this.siblings ? this.siblings.toProtobufJSON(options) : null,
      specialName: this.specialName,
      taken: this.taken,
      previewLarge: this.previewLarge,
      subscribed: this.subscribed,
      paginator: this.paginator ? this.paginator.toProtobufJSON(options) : null
    };
  }
}
export module PictureFields {
  /**
   * Standard JavaScript object representation for PictureFields
   */
  export interface AsObject {
    nameText: boolean;
    nameHtml: boolean;
    image: boolean;
    thumbMedium: boolean;
    thumbLarge: boolean;
    views: boolean;
    votes: boolean;
    commentsCount: boolean;
    moderVote: boolean;
    path?: PicturePathRequest.AsObject;
    pictureItem?: PictureItemsRequest.AsObject;
    imageGalleryFull: boolean;
    imageGallery: boolean;
    dfDistance?: DfDistanceRequest.AsObject;
    acceptedCount: boolean;
    copyrights: boolean;
    exif: boolean;
    isLast: boolean;
    moderVoted: boolean;
    pictureModerVotes?: PictureModerVoteRequest.AsObject;
    replaceable?: PicturesRequest.AsObject;
    rights: boolean;
    siblings?: PicturesRequest.AsObject;
    specialName: boolean;
    taken: boolean;
    previewLarge: boolean;
    subscribed: boolean;
    paginator?: PicturesRequest.AsObject;
  }

  /**
   * Protobuf JSON representation for PictureFields
   */
  export interface AsProtobufJSON {
    nameText: boolean;
    nameHtml: boolean;
    image: boolean;
    thumbMedium: boolean;
    thumbLarge: boolean;
    views: boolean;
    votes: boolean;
    commentsCount: boolean;
    moderVote: boolean;
    path: PicturePathRequest.AsProtobufJSON | null;
    pictureItem: PictureItemsRequest.AsProtobufJSON | null;
    imageGalleryFull: boolean;
    imageGallery: boolean;
    dfDistance: DfDistanceRequest.AsProtobufJSON | null;
    acceptedCount: boolean;
    copyrights: boolean;
    exif: boolean;
    isLast: boolean;
    moderVoted: boolean;
    pictureModerVotes: PictureModerVoteRequest.AsProtobufJSON | null;
    replaceable: PicturesRequest.AsProtobufJSON | null;
    rights: boolean;
    siblings: PicturesRequest.AsProtobufJSON | null;
    specialName: boolean;
    taken: boolean;
    previewLarge: boolean;
    subscribed: boolean;
    paginator: PicturesRequest.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.PictureSiblings
 */
export class PictureSiblings implements GrpcMessage {
  static id = 'goautowp.PictureSiblings';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PictureSiblings();
    PictureSiblings.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PictureSiblings) {
    _instance.prev = _instance.prev || undefined;
    _instance.next = _instance.next || undefined;
    _instance.prevNew = _instance.prevNew || undefined;
    _instance.nextNew = _instance.nextNew || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PictureSiblings,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.prev = new Picture();
          _reader.readMessage(
            _instance.prev,
            Picture.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.next = new Picture();
          _reader.readMessage(
            _instance.next,
            Picture.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.prevNew = new Picture();
          _reader.readMessage(
            _instance.prevNew,
            Picture.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.nextNew = new Picture();
          _reader.readMessage(
            _instance.nextNew,
            Picture.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    PictureSiblings.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PictureSiblings,
    _writer: BinaryWriter
  ) {
    if (_instance.prev) {
      _writer.writeMessage(
        1,
        _instance.prev as any,
        Picture.serializeBinaryToWriter
      );
    }
    if (_instance.next) {
      _writer.writeMessage(
        2,
        _instance.next as any,
        Picture.serializeBinaryToWriter
      );
    }
    if (_instance.prevNew) {
      _writer.writeMessage(
        3,
        _instance.prevNew as any,
        Picture.serializeBinaryToWriter
      );
    }
    if (_instance.nextNew) {
      _writer.writeMessage(
        4,
        _instance.nextNew as any,
        Picture.serializeBinaryToWriter
      );
    }
  }

  private _prev?: Picture;
  private _next?: Picture;
  private _prevNew?: Picture;
  private _nextNew?: Picture;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PictureSiblings to deeply clone from
   */
  constructor(_value?: RecursivePartial<PictureSiblings.AsObject>) {
    _value = _value || {};
    this.prev = _value.prev ? new Picture(_value.prev) : undefined;
    this.next = _value.next ? new Picture(_value.next) : undefined;
    this.prevNew = _value.prevNew ? new Picture(_value.prevNew) : undefined;
    this.nextNew = _value.nextNew ? new Picture(_value.nextNew) : undefined;
    PictureSiblings.refineValues(this);
  }
  get prev(): Picture | undefined {
    return this._prev;
  }
  set prev(value: Picture | undefined) {
    this._prev = value;
  }
  get next(): Picture | undefined {
    return this._next;
  }
  set next(value: Picture | undefined) {
    this._next = value;
  }
  get prevNew(): Picture | undefined {
    return this._prevNew;
  }
  set prevNew(value: Picture | undefined) {
    this._prevNew = value;
  }
  get nextNew(): Picture | undefined {
    return this._nextNew;
  }
  set nextNew(value: Picture | undefined) {
    this._nextNew = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PictureSiblings.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PictureSiblings.AsObject {
    return {
      prev: this.prev ? this.prev.toObject() : undefined,
      next: this.next ? this.next.toObject() : undefined,
      prevNew: this.prevNew ? this.prevNew.toObject() : undefined,
      nextNew: this.nextNew ? this.nextNew.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PictureSiblings.AsProtobufJSON {
    return {
      prev: this.prev ? this.prev.toProtobufJSON(options) : null,
      next: this.next ? this.next.toProtobufJSON(options) : null,
      prevNew: this.prevNew ? this.prevNew.toProtobufJSON(options) : null,
      nextNew: this.nextNew ? this.nextNew.toProtobufJSON(options) : null
    };
  }
}
export module PictureSiblings {
  /**
   * Standard JavaScript object representation for PictureSiblings
   */
  export interface AsObject {
    prev?: Picture.AsObject;
    next?: Picture.AsObject;
    prevNew?: Picture.AsObject;
    nextNew?: Picture.AsObject;
  }

  /**
   * Protobuf JSON representation for PictureSiblings
   */
  export interface AsProtobufJSON {
    prev: Picture.AsProtobufJSON | null;
    next: Picture.AsProtobufJSON | null;
    prevNew: Picture.AsProtobufJSON | null;
    nextNew: Picture.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.PictureModerVote
 */
export class PictureModerVote implements GrpcMessage {
  static id = 'goautowp.PictureModerVote';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PictureModerVote();
    PictureModerVote.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PictureModerVote) {
    _instance.pictureId = _instance.pictureId || '0';
    _instance.userId = _instance.userId || '0';
    _instance.vote = _instance.vote || 0;
    _instance.reason = _instance.reason || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PictureModerVote,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.pictureId = _reader.readInt64String();
          break;
        case 2:
          _instance.userId = _reader.readInt64String();
          break;
        case 3:
          _instance.vote = _reader.readInt32();
          break;
        case 4:
          _instance.reason = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    PictureModerVote.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PictureModerVote,
    _writer: BinaryWriter
  ) {
    if (_instance.pictureId) {
      _writer.writeInt64String(1, _instance.pictureId);
    }
    if (_instance.userId) {
      _writer.writeInt64String(2, _instance.userId);
    }
    if (_instance.vote) {
      _writer.writeInt32(3, _instance.vote);
    }
    if (_instance.reason) {
      _writer.writeString(4, _instance.reason);
    }
  }

  private _pictureId: string;
  private _userId: string;
  private _vote: number;
  private _reason: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PictureModerVote to deeply clone from
   */
  constructor(_value?: RecursivePartial<PictureModerVote.AsObject>) {
    _value = _value || {};
    this.pictureId = _value.pictureId;
    this.userId = _value.userId;
    this.vote = _value.vote;
    this.reason = _value.reason;
    PictureModerVote.refineValues(this);
  }
  get pictureId(): string {
    return this._pictureId;
  }
  set pictureId(value: string) {
    this._pictureId = value;
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }
  get vote(): number {
    return this._vote;
  }
  set vote(value: number) {
    this._vote = value;
  }
  get reason(): string {
    return this._reason;
  }
  set reason(value: string) {
    this._reason = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PictureModerVote.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PictureModerVote.AsObject {
    return {
      pictureId: this.pictureId,
      userId: this.userId,
      vote: this.vote,
      reason: this.reason
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PictureModerVote.AsProtobufJSON {
    return {
      pictureId: this.pictureId,
      userId: this.userId,
      vote: this.vote,
      reason: this.reason
    };
  }
}
export module PictureModerVote {
  /**
   * Standard JavaScript object representation for PictureModerVote
   */
  export interface AsObject {
    pictureId: string;
    userId: string;
    vote: number;
    reason: string;
  }

  /**
   * Protobuf JSON representation for PictureModerVote
   */
  export interface AsProtobufJSON {
    pictureId: string;
    userId: string;
    vote: number;
    reason: string;
  }
}

/**
 * Message implementation for goautowp.PictureModerVotes
 */
export class PictureModerVotes implements GrpcMessage {
  static id = 'goautowp.PictureModerVotes';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PictureModerVotes();
    PictureModerVotes.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PictureModerVotes) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PictureModerVotes,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new PictureModerVote();
          _reader.readMessage(
            messageInitializer1,
            PictureModerVote.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    PictureModerVotes.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PictureModerVotes,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        PictureModerVote.serializeBinaryToWriter
      );
    }
  }

  private _items?: PictureModerVote[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PictureModerVotes to deeply clone from
   */
  constructor(_value?: RecursivePartial<PictureModerVotes.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new PictureModerVote(m));
    PictureModerVotes.refineValues(this);
  }
  get items(): PictureModerVote[] | undefined {
    return this._items;
  }
  set items(value: PictureModerVote[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PictureModerVotes.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PictureModerVotes.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PictureModerVotes.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module PictureModerVotes {
  /**
   * Standard JavaScript object representation for PictureModerVotes
   */
  export interface AsObject {
    items?: PictureModerVote.AsObject[];
  }

  /**
   * Protobuf JSON representation for PictureModerVotes
   */
  export interface AsProtobufJSON {
    items: PictureModerVote.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.PictureModerVoteRequest
 */
export class PictureModerVoteRequest implements GrpcMessage {
  static id = 'goautowp.PictureModerVoteRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PictureModerVoteRequest();
    PictureModerVoteRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PictureModerVoteRequest) {
    _instance.options = _instance.options || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PictureModerVoteRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.options = new PictureModerVoteListOptions();
          _reader.readMessage(
            _instance.options,
            PictureModerVoteListOptions.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    PictureModerVoteRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PictureModerVoteRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.options) {
      _writer.writeMessage(
        1,
        _instance.options as any,
        PictureModerVoteListOptions.serializeBinaryToWriter
      );
    }
  }

  private _options?: PictureModerVoteListOptions;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PictureModerVoteRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<PictureModerVoteRequest.AsObject>) {
    _value = _value || {};
    this.options = _value.options
      ? new PictureModerVoteListOptions(_value.options)
      : undefined;
    PictureModerVoteRequest.refineValues(this);
  }
  get options(): PictureModerVoteListOptions | undefined {
    return this._options;
  }
  set options(value: PictureModerVoteListOptions | undefined) {
    this._options = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PictureModerVoteRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PictureModerVoteRequest.AsObject {
    return {
      options: this.options ? this.options.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PictureModerVoteRequest.AsProtobufJSON {
    return {
      options: this.options ? this.options.toProtobufJSON(options) : null
    };
  }
}
export module PictureModerVoteRequest {
  /**
   * Standard JavaScript object representation for PictureModerVoteRequest
   */
  export interface AsObject {
    options?: PictureModerVoteListOptions.AsObject;
  }

  /**
   * Protobuf JSON representation for PictureModerVoteRequest
   */
  export interface AsProtobufJSON {
    options: PictureModerVoteListOptions.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.DfDistanceFields
 */
export class DfDistanceFields implements GrpcMessage {
  static id = 'goautowp.DfDistanceFields';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new DfDistanceFields();
    DfDistanceFields.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: DfDistanceFields) {
    _instance.dstPicture = _instance.dstPicture || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: DfDistanceFields,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.dstPicture = new PicturesRequest();
          _reader.readMessage(
            _instance.dstPicture,
            PicturesRequest.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    DfDistanceFields.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: DfDistanceFields,
    _writer: BinaryWriter
  ) {
    if (_instance.dstPicture) {
      _writer.writeMessage(
        1,
        _instance.dstPicture as any,
        PicturesRequest.serializeBinaryToWriter
      );
    }
  }

  private _dstPicture?: PicturesRequest;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of DfDistanceFields to deeply clone from
   */
  constructor(_value?: RecursivePartial<DfDistanceFields.AsObject>) {
    _value = _value || {};
    this.dstPicture = _value.dstPicture
      ? new PicturesRequest(_value.dstPicture)
      : undefined;
    DfDistanceFields.refineValues(this);
  }
  get dstPicture(): PicturesRequest | undefined {
    return this._dstPicture;
  }
  set dstPicture(value: PicturesRequest | undefined) {
    this._dstPicture = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    DfDistanceFields.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): DfDistanceFields.AsObject {
    return {
      dstPicture: this.dstPicture ? this.dstPicture.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): DfDistanceFields.AsProtobufJSON {
    return {
      dstPicture: this.dstPicture
        ? this.dstPicture.toProtobufJSON(options)
        : null
    };
  }
}
export module DfDistanceFields {
  /**
   * Standard JavaScript object representation for DfDistanceFields
   */
  export interface AsObject {
    dstPicture?: PicturesRequest.AsObject;
  }

  /**
   * Protobuf JSON representation for DfDistanceFields
   */
  export interface AsProtobufJSON {
    dstPicture: PicturesRequest.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.DfDistanceRequest
 */
export class DfDistanceRequest implements GrpcMessage {
  static id = 'goautowp.DfDistanceRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new DfDistanceRequest();
    DfDistanceRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: DfDistanceRequest) {
    _instance.limit = _instance.limit || 0;
    _instance.options = _instance.options || undefined;
    _instance.fields = _instance.fields || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: DfDistanceRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.limit = _reader.readUint32();
          break;
        case 2:
          _instance.options = new DfDistanceListOptions();
          _reader.readMessage(
            _instance.options,
            DfDistanceListOptions.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.fields = new DfDistanceFields();
          _reader.readMessage(
            _instance.fields,
            DfDistanceFields.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    DfDistanceRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: DfDistanceRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.limit) {
      _writer.writeUint32(1, _instance.limit);
    }
    if (_instance.options) {
      _writer.writeMessage(
        2,
        _instance.options as any,
        DfDistanceListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.fields) {
      _writer.writeMessage(
        3,
        _instance.fields as any,
        DfDistanceFields.serializeBinaryToWriter
      );
    }
  }

  private _limit: number;
  private _options?: DfDistanceListOptions;
  private _fields?: DfDistanceFields;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of DfDistanceRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<DfDistanceRequest.AsObject>) {
    _value = _value || {};
    this.limit = _value.limit;
    this.options = _value.options
      ? new DfDistanceListOptions(_value.options)
      : undefined;
    this.fields = _value.fields
      ? new DfDistanceFields(_value.fields)
      : undefined;
    DfDistanceRequest.refineValues(this);
  }
  get limit(): number {
    return this._limit;
  }
  set limit(value: number) {
    this._limit = value;
  }
  get options(): DfDistanceListOptions | undefined {
    return this._options;
  }
  set options(value: DfDistanceListOptions | undefined) {
    this._options = value;
  }
  get fields(): DfDistanceFields | undefined {
    return this._fields;
  }
  set fields(value: DfDistanceFields | undefined) {
    this._fields = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    DfDistanceRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): DfDistanceRequest.AsObject {
    return {
      limit: this.limit,
      options: this.options ? this.options.toObject() : undefined,
      fields: this.fields ? this.fields.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): DfDistanceRequest.AsProtobufJSON {
    return {
      limit: this.limit,
      options: this.options ? this.options.toProtobufJSON(options) : null,
      fields: this.fields ? this.fields.toProtobufJSON(options) : null
    };
  }
}
export module DfDistanceRequest {
  /**
   * Standard JavaScript object representation for DfDistanceRequest
   */
  export interface AsObject {
    limit: number;
    options?: DfDistanceListOptions.AsObject;
    fields?: DfDistanceFields.AsObject;
  }

  /**
   * Protobuf JSON representation for DfDistanceRequest
   */
  export interface AsProtobufJSON {
    limit: number;
    options: DfDistanceListOptions.AsProtobufJSON | null;
    fields: DfDistanceFields.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.PicturePathRequest
 */
export class PicturePathRequest implements GrpcMessage {
  static id = 'goautowp.PicturePathRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PicturePathRequest();
    PicturePathRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PicturePathRequest) {
    _instance.parentId = _instance.parentId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PicturePathRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.parentId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    PicturePathRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PicturePathRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.parentId) {
      _writer.writeInt64String(1, _instance.parentId);
    }
  }

  private _parentId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PicturePathRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<PicturePathRequest.AsObject>) {
    _value = _value || {};
    this.parentId = _value.parentId;
    PicturePathRequest.refineValues(this);
  }
  get parentId(): string {
    return this._parentId;
  }
  set parentId(value: string) {
    this._parentId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PicturePathRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PicturePathRequest.AsObject {
    return {
      parentId: this.parentId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PicturePathRequest.AsProtobufJSON {
    return {
      parentId: this.parentId
    };
  }
}
export module PicturePathRequest {
  /**
   * Standard JavaScript object representation for PicturePathRequest
   */
  export interface AsObject {
    parentId: string;
  }

  /**
   * Protobuf JSON representation for PicturePathRequest
   */
  export interface AsProtobufJSON {
    parentId: string;
  }
}

/**
 * Message implementation for goautowp.PreviewPicturesRequest
 */
export class PreviewPicturesRequest implements GrpcMessage {
  static id = 'goautowp.PreviewPicturesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PreviewPicturesRequest();
    PreviewPicturesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PreviewPicturesRequest) {
    _instance.perspectivePageId = _instance.perspectivePageId || 0;
    _instance.pictures = _instance.pictures || undefined;
    _instance.onlyExactlyPictures = _instance.onlyExactlyPictures || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PreviewPicturesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 4:
          _instance.perspectivePageId = _reader.readInt32();
          break;
        case 7:
          _instance.pictures = new PicturesRequest();
          _reader.readMessage(
            _instance.pictures,
            PicturesRequest.deserializeBinaryFromReader
          );
          break;
        case 8:
          _instance.onlyExactlyPictures = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    PreviewPicturesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PreviewPicturesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.perspectivePageId) {
      _writer.writeInt32(4, _instance.perspectivePageId);
    }
    if (_instance.pictures) {
      _writer.writeMessage(
        7,
        _instance.pictures as any,
        PicturesRequest.serializeBinaryToWriter
      );
    }
    if (_instance.onlyExactlyPictures) {
      _writer.writeBool(8, _instance.onlyExactlyPictures);
    }
  }

  private _perspectivePageId: number;
  private _pictures?: PicturesRequest;
  private _onlyExactlyPictures: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PreviewPicturesRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<PreviewPicturesRequest.AsObject>) {
    _value = _value || {};
    this.perspectivePageId = _value.perspectivePageId;
    this.pictures = _value.pictures
      ? new PicturesRequest(_value.pictures)
      : undefined;
    this.onlyExactlyPictures = _value.onlyExactlyPictures;
    PreviewPicturesRequest.refineValues(this);
  }
  get perspectivePageId(): number {
    return this._perspectivePageId;
  }
  set perspectivePageId(value: number) {
    this._perspectivePageId = value;
  }
  get pictures(): PicturesRequest | undefined {
    return this._pictures;
  }
  set pictures(value: PicturesRequest | undefined) {
    this._pictures = value;
  }
  get onlyExactlyPictures(): boolean {
    return this._onlyExactlyPictures;
  }
  set onlyExactlyPictures(value: boolean) {
    this._onlyExactlyPictures = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PreviewPicturesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PreviewPicturesRequest.AsObject {
    return {
      perspectivePageId: this.perspectivePageId,
      pictures: this.pictures ? this.pictures.toObject() : undefined,
      onlyExactlyPictures: this.onlyExactlyPictures
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PreviewPicturesRequest.AsProtobufJSON {
    return {
      perspectivePageId: this.perspectivePageId,
      pictures: this.pictures ? this.pictures.toProtobufJSON(options) : null,
      onlyExactlyPictures: this.onlyExactlyPictures
    };
  }
}
export module PreviewPicturesRequest {
  /**
   * Standard JavaScript object representation for PreviewPicturesRequest
   */
  export interface AsObject {
    perspectivePageId: number;
    pictures?: PicturesRequest.AsObject;
    onlyExactlyPictures: boolean;
  }

  /**
   * Protobuf JSON representation for PreviewPicturesRequest
   */
  export interface AsProtobufJSON {
    perspectivePageId: number;
    pictures: PicturesRequest.AsProtobufJSON | null;
    onlyExactlyPictures: boolean;
  }
}

/**
 * Message implementation for goautowp.ItemFields
 */
export class ItemFields implements GrpcMessage {
  static id = 'goautowp.ItemFields';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemFields();
    ItemFields.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemFields) {
    _instance.nameOnly = _instance.nameOnly || false;
    _instance.nameDefault = _instance.nameDefault || false;
    _instance.nameHtml = _instance.nameHtml || false;
    _instance.nameText = _instance.nameText || false;
    _instance.description = _instance.description || false;
    _instance.fullText = _instance.fullText || false;
    _instance.hasText = _instance.hasText || false;
    _instance.previewPictures = _instance.previewPictures || undefined;
    _instance.descendantsCount = _instance.descendantsCount || false;
    _instance.descendantPicturesCount =
      _instance.descendantPicturesCount || false;
    _instance.childsCount = _instance.childsCount || false;
    _instance.descendantTwinsGroupsCount =
      _instance.descendantTwinsGroupsCount || false;
    _instance.inboxPicturesCount = _instance.inboxPicturesCount || false;
    _instance.fullName = _instance.fullName || false;
    _instance.logo120 = _instance.logo120 || false;
    _instance.mostsActive = _instance.mostsActive || false;
    _instance.commentsAttentionsCount =
      _instance.commentsAttentionsCount || false;
    _instance.isCompilesItemOfDay = _instance.isCompilesItemOfDay || false;
    _instance.brandicon = _instance.brandicon || false;
    _instance.attrZoneId = _instance.attrZoneId || false;
    _instance.location = _instance.location || false;
    _instance.acceptedPicturesCount = _instance.acceptedPicturesCount || false;
    _instance.hasChildSpecs = _instance.hasChildSpecs || false;
    _instance.hasSpecs = _instance.hasSpecs || false;
    _instance.otherNames = _instance.otherNames || false;
    _instance.design = _instance.design || false;
    _instance.specsRoute = _instance.specsRoute || false;
    _instance.childsCounts = _instance.childsCounts || false;
    _instance.publicRoutes = _instance.publicRoutes || false;
    _instance.pictureItems = _instance.pictureItems || undefined;
    _instance.altNames = _instance.altNames || false;
    _instance.route = _instance.route || false;
    _instance.links = _instance.links || undefined;
    _instance.categories = _instance.categories || undefined;
    _instance.twins = _instance.twins || undefined;
    _instance.canEditSpecs = _instance.canEditSpecs || false;
    _instance.itemParentChilds = _instance.itemParentChilds || undefined;
    _instance.commentsCount = _instance.commentsCount || false;
    _instance.engineVehicles = _instance.engineVehicles || undefined;
    _instance.routeBrandId = _instance.routeBrandId || '0';
    _instance.relatedGroupPictures = _instance.relatedGroupPictures || false;
    _instance.itemOfDayPictures = _instance.itemOfDayPictures || false;
    _instance.meta = _instance.meta || false;
    _instance.engineVehiclesCount = _instance.engineVehiclesCount || false;
    _instance.itemLanguageCount = _instance.itemLanguageCount || false;
    _instance.linksCount = _instance.linksCount || false;
    _instance.logo = _instance.logo || false;
    _instance.parentsCount = _instance.parentsCount || false;
    _instance.exactPicturesCount = _instance.exactPicturesCount || false;
    _instance.specificationsCount = _instance.specificationsCount || false;
    _instance.subscription = _instance.subscription || false;
    _instance.specsContributors = _instance.specsContributors || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemFields,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.nameOnly = _reader.readBool();
          break;
        case 2:
          _instance.nameDefault = _reader.readBool();
          break;
        case 3:
          _instance.nameHtml = _reader.readBool();
          break;
        case 4:
          _instance.nameText = _reader.readBool();
          break;
        case 5:
          _instance.description = _reader.readBool();
          break;
        case 25:
          _instance.fullText = _reader.readBool();
          break;
        case 6:
          _instance.hasText = _reader.readBool();
          break;
        case 7:
          _instance.previewPictures = new PreviewPicturesRequest();
          _reader.readMessage(
            _instance.previewPictures,
            PreviewPicturesRequest.deserializeBinaryFromReader
          );
          break;
        case 9:
          _instance.descendantsCount = _reader.readBool();
          break;
        case 10:
          _instance.descendantPicturesCount = _reader.readBool();
          break;
        case 11:
          _instance.childsCount = _reader.readBool();
          break;
        case 12:
          _instance.descendantTwinsGroupsCount = _reader.readBool();
          break;
        case 13:
          _instance.inboxPicturesCount = _reader.readBool();
          break;
        case 14:
          _instance.fullName = _reader.readBool();
          break;
        case 15:
          _instance.logo120 = _reader.readBool();
          break;
        case 16:
          _instance.mostsActive = _reader.readBool();
          break;
        case 17:
          _instance.commentsAttentionsCount = _reader.readBool();
          break;
        case 18:
          _instance.isCompilesItemOfDay = _reader.readBool();
          break;
        case 19:
          _instance.brandicon = _reader.readBool();
          break;
        case 20:
          _instance.attrZoneId = _reader.readBool();
          break;
        case 21:
          _instance.location = _reader.readBool();
          break;
        case 22:
          _instance.acceptedPicturesCount = _reader.readBool();
          break;
        case 23:
          _instance.hasChildSpecs = _reader.readBool();
          break;
        case 24:
          _instance.hasSpecs = _reader.readBool();
          break;
        case 26:
          _instance.otherNames = _reader.readBool();
          break;
        case 27:
          _instance.design = _reader.readBool();
          break;
        case 28:
          _instance.specsRoute = _reader.readBool();
          break;
        case 29:
          _instance.childsCounts = _reader.readBool();
          break;
        case 30:
          _instance.publicRoutes = _reader.readBool();
          break;
        case 31:
          _instance.pictureItems = new PictureItemsRequest();
          _reader.readMessage(
            _instance.pictureItems,
            PictureItemsRequest.deserializeBinaryFromReader
          );
          break;
        case 32:
          _instance.altNames = _reader.readBool();
          break;
        case 33:
          _instance.route = _reader.readBool();
          break;
        case 34:
          _instance.links = new ItemLinksRequest();
          _reader.readMessage(
            _instance.links,
            ItemLinksRequest.deserializeBinaryFromReader
          );
          break;
        case 35:
          _instance.categories = new ItemsRequest();
          _reader.readMessage(
            _instance.categories,
            ItemsRequest.deserializeBinaryFromReader
          );
          break;
        case 36:
          _instance.twins = new ItemsRequest();
          _reader.readMessage(
            _instance.twins,
            ItemsRequest.deserializeBinaryFromReader
          );
          break;
        case 37:
          _instance.canEditSpecs = _reader.readBool();
          break;
        case 38:
          _instance.itemParentChilds = new ItemParentsRequest();
          _reader.readMessage(
            _instance.itemParentChilds,
            ItemParentsRequest.deserializeBinaryFromReader
          );
          break;
        case 39:
          _instance.commentsCount = _reader.readBool();
          break;
        case 40:
          _instance.engineVehicles = new ItemsRequest();
          _reader.readMessage(
            _instance.engineVehicles,
            ItemsRequest.deserializeBinaryFromReader
          );
          break;
        case 41:
          _instance.routeBrandId = _reader.readInt64String();
          break;
        case 42:
          _instance.relatedGroupPictures = _reader.readBool();
          break;
        case 43:
          _instance.itemOfDayPictures = _reader.readBool();
          break;
        case 44:
          _instance.meta = _reader.readBool();
          break;
        case 45:
          _instance.engineVehiclesCount = _reader.readBool();
          break;
        case 46:
          _instance.itemLanguageCount = _reader.readBool();
          break;
        case 47:
          _instance.linksCount = _reader.readBool();
          break;
        case 48:
          _instance.logo = _reader.readBool();
          break;
        case 49:
          _instance.parentsCount = _reader.readBool();
          break;
        case 50:
          _instance.exactPicturesCount = _reader.readBool();
          break;
        case 51:
          _instance.specificationsCount = _reader.readBool();
          break;
        case 52:
          _instance.subscription = _reader.readBool();
          break;
        case 53:
          _instance.specsContributors = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    ItemFields.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: ItemFields, _writer: BinaryWriter) {
    if (_instance.nameOnly) {
      _writer.writeBool(1, _instance.nameOnly);
    }
    if (_instance.nameDefault) {
      _writer.writeBool(2, _instance.nameDefault);
    }
    if (_instance.nameHtml) {
      _writer.writeBool(3, _instance.nameHtml);
    }
    if (_instance.nameText) {
      _writer.writeBool(4, _instance.nameText);
    }
    if (_instance.description) {
      _writer.writeBool(5, _instance.description);
    }
    if (_instance.fullText) {
      _writer.writeBool(25, _instance.fullText);
    }
    if (_instance.hasText) {
      _writer.writeBool(6, _instance.hasText);
    }
    if (_instance.previewPictures) {
      _writer.writeMessage(
        7,
        _instance.previewPictures as any,
        PreviewPicturesRequest.serializeBinaryToWriter
      );
    }
    if (_instance.descendantsCount) {
      _writer.writeBool(9, _instance.descendantsCount);
    }
    if (_instance.descendantPicturesCount) {
      _writer.writeBool(10, _instance.descendantPicturesCount);
    }
    if (_instance.childsCount) {
      _writer.writeBool(11, _instance.childsCount);
    }
    if (_instance.descendantTwinsGroupsCount) {
      _writer.writeBool(12, _instance.descendantTwinsGroupsCount);
    }
    if (_instance.inboxPicturesCount) {
      _writer.writeBool(13, _instance.inboxPicturesCount);
    }
    if (_instance.fullName) {
      _writer.writeBool(14, _instance.fullName);
    }
    if (_instance.logo120) {
      _writer.writeBool(15, _instance.logo120);
    }
    if (_instance.mostsActive) {
      _writer.writeBool(16, _instance.mostsActive);
    }
    if (_instance.commentsAttentionsCount) {
      _writer.writeBool(17, _instance.commentsAttentionsCount);
    }
    if (_instance.isCompilesItemOfDay) {
      _writer.writeBool(18, _instance.isCompilesItemOfDay);
    }
    if (_instance.brandicon) {
      _writer.writeBool(19, _instance.brandicon);
    }
    if (_instance.attrZoneId) {
      _writer.writeBool(20, _instance.attrZoneId);
    }
    if (_instance.location) {
      _writer.writeBool(21, _instance.location);
    }
    if (_instance.acceptedPicturesCount) {
      _writer.writeBool(22, _instance.acceptedPicturesCount);
    }
    if (_instance.hasChildSpecs) {
      _writer.writeBool(23, _instance.hasChildSpecs);
    }
    if (_instance.hasSpecs) {
      _writer.writeBool(24, _instance.hasSpecs);
    }
    if (_instance.otherNames) {
      _writer.writeBool(26, _instance.otherNames);
    }
    if (_instance.design) {
      _writer.writeBool(27, _instance.design);
    }
    if (_instance.specsRoute) {
      _writer.writeBool(28, _instance.specsRoute);
    }
    if (_instance.childsCounts) {
      _writer.writeBool(29, _instance.childsCounts);
    }
    if (_instance.publicRoutes) {
      _writer.writeBool(30, _instance.publicRoutes);
    }
    if (_instance.pictureItems) {
      _writer.writeMessage(
        31,
        _instance.pictureItems as any,
        PictureItemsRequest.serializeBinaryToWriter
      );
    }
    if (_instance.altNames) {
      _writer.writeBool(32, _instance.altNames);
    }
    if (_instance.route) {
      _writer.writeBool(33, _instance.route);
    }
    if (_instance.links) {
      _writer.writeMessage(
        34,
        _instance.links as any,
        ItemLinksRequest.serializeBinaryToWriter
      );
    }
    if (_instance.categories) {
      _writer.writeMessage(
        35,
        _instance.categories as any,
        ItemsRequest.serializeBinaryToWriter
      );
    }
    if (_instance.twins) {
      _writer.writeMessage(
        36,
        _instance.twins as any,
        ItemsRequest.serializeBinaryToWriter
      );
    }
    if (_instance.canEditSpecs) {
      _writer.writeBool(37, _instance.canEditSpecs);
    }
    if (_instance.itemParentChilds) {
      _writer.writeMessage(
        38,
        _instance.itemParentChilds as any,
        ItemParentsRequest.serializeBinaryToWriter
      );
    }
    if (_instance.commentsCount) {
      _writer.writeBool(39, _instance.commentsCount);
    }
    if (_instance.engineVehicles) {
      _writer.writeMessage(
        40,
        _instance.engineVehicles as any,
        ItemsRequest.serializeBinaryToWriter
      );
    }
    if (_instance.routeBrandId) {
      _writer.writeInt64String(41, _instance.routeBrandId);
    }
    if (_instance.relatedGroupPictures) {
      _writer.writeBool(42, _instance.relatedGroupPictures);
    }
    if (_instance.itemOfDayPictures) {
      _writer.writeBool(43, _instance.itemOfDayPictures);
    }
    if (_instance.meta) {
      _writer.writeBool(44, _instance.meta);
    }
    if (_instance.engineVehiclesCount) {
      _writer.writeBool(45, _instance.engineVehiclesCount);
    }
    if (_instance.itemLanguageCount) {
      _writer.writeBool(46, _instance.itemLanguageCount);
    }
    if (_instance.linksCount) {
      _writer.writeBool(47, _instance.linksCount);
    }
    if (_instance.logo) {
      _writer.writeBool(48, _instance.logo);
    }
    if (_instance.parentsCount) {
      _writer.writeBool(49, _instance.parentsCount);
    }
    if (_instance.exactPicturesCount) {
      _writer.writeBool(50, _instance.exactPicturesCount);
    }
    if (_instance.specificationsCount) {
      _writer.writeBool(51, _instance.specificationsCount);
    }
    if (_instance.subscription) {
      _writer.writeBool(52, _instance.subscription);
    }
    if (_instance.specsContributors) {
      _writer.writeBool(53, _instance.specsContributors);
    }
  }

  private _nameOnly: boolean;
  private _nameDefault: boolean;
  private _nameHtml: boolean;
  private _nameText: boolean;
  private _description: boolean;
  private _fullText: boolean;
  private _hasText: boolean;
  private _previewPictures?: PreviewPicturesRequest;
  private _descendantsCount: boolean;
  private _descendantPicturesCount: boolean;
  private _childsCount: boolean;
  private _descendantTwinsGroupsCount: boolean;
  private _inboxPicturesCount: boolean;
  private _fullName: boolean;
  private _logo120: boolean;
  private _mostsActive: boolean;
  private _commentsAttentionsCount: boolean;
  private _isCompilesItemOfDay: boolean;
  private _brandicon: boolean;
  private _attrZoneId: boolean;
  private _location: boolean;
  private _acceptedPicturesCount: boolean;
  private _hasChildSpecs: boolean;
  private _hasSpecs: boolean;
  private _otherNames: boolean;
  private _design: boolean;
  private _specsRoute: boolean;
  private _childsCounts: boolean;
  private _publicRoutes: boolean;
  private _pictureItems?: PictureItemsRequest;
  private _altNames: boolean;
  private _route: boolean;
  private _links?: ItemLinksRequest;
  private _categories?: ItemsRequest;
  private _twins?: ItemsRequest;
  private _canEditSpecs: boolean;
  private _itemParentChilds?: ItemParentsRequest;
  private _commentsCount: boolean;
  private _engineVehicles?: ItemsRequest;
  private _routeBrandId: string;
  private _relatedGroupPictures: boolean;
  private _itemOfDayPictures: boolean;
  private _meta: boolean;
  private _engineVehiclesCount: boolean;
  private _itemLanguageCount: boolean;
  private _linksCount: boolean;
  private _logo: boolean;
  private _parentsCount: boolean;
  private _exactPicturesCount: boolean;
  private _specificationsCount: boolean;
  private _subscription: boolean;
  private _specsContributors: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemFields to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemFields.AsObject>) {
    _value = _value || {};
    this.nameOnly = _value.nameOnly;
    this.nameDefault = _value.nameDefault;
    this.nameHtml = _value.nameHtml;
    this.nameText = _value.nameText;
    this.description = _value.description;
    this.fullText = _value.fullText;
    this.hasText = _value.hasText;
    this.previewPictures = _value.previewPictures
      ? new PreviewPicturesRequest(_value.previewPictures)
      : undefined;
    this.descendantsCount = _value.descendantsCount;
    this.descendantPicturesCount = _value.descendantPicturesCount;
    this.childsCount = _value.childsCount;
    this.descendantTwinsGroupsCount = _value.descendantTwinsGroupsCount;
    this.inboxPicturesCount = _value.inboxPicturesCount;
    this.fullName = _value.fullName;
    this.logo120 = _value.logo120;
    this.mostsActive = _value.mostsActive;
    this.commentsAttentionsCount = _value.commentsAttentionsCount;
    this.isCompilesItemOfDay = _value.isCompilesItemOfDay;
    this.brandicon = _value.brandicon;
    this.attrZoneId = _value.attrZoneId;
    this.location = _value.location;
    this.acceptedPicturesCount = _value.acceptedPicturesCount;
    this.hasChildSpecs = _value.hasChildSpecs;
    this.hasSpecs = _value.hasSpecs;
    this.otherNames = _value.otherNames;
    this.design = _value.design;
    this.specsRoute = _value.specsRoute;
    this.childsCounts = _value.childsCounts;
    this.publicRoutes = _value.publicRoutes;
    this.pictureItems = _value.pictureItems
      ? new PictureItemsRequest(_value.pictureItems)
      : undefined;
    this.altNames = _value.altNames;
    this.route = _value.route;
    this.links = _value.links ? new ItemLinksRequest(_value.links) : undefined;
    this.categories = _value.categories
      ? new ItemsRequest(_value.categories)
      : undefined;
    this.twins = _value.twins ? new ItemsRequest(_value.twins) : undefined;
    this.canEditSpecs = _value.canEditSpecs;
    this.itemParentChilds = _value.itemParentChilds
      ? new ItemParentsRequest(_value.itemParentChilds)
      : undefined;
    this.commentsCount = _value.commentsCount;
    this.engineVehicles = _value.engineVehicles
      ? new ItemsRequest(_value.engineVehicles)
      : undefined;
    this.routeBrandId = _value.routeBrandId;
    this.relatedGroupPictures = _value.relatedGroupPictures;
    this.itemOfDayPictures = _value.itemOfDayPictures;
    this.meta = _value.meta;
    this.engineVehiclesCount = _value.engineVehiclesCount;
    this.itemLanguageCount = _value.itemLanguageCount;
    this.linksCount = _value.linksCount;
    this.logo = _value.logo;
    this.parentsCount = _value.parentsCount;
    this.exactPicturesCount = _value.exactPicturesCount;
    this.specificationsCount = _value.specificationsCount;
    this.subscription = _value.subscription;
    this.specsContributors = _value.specsContributors;
    ItemFields.refineValues(this);
  }
  get nameOnly(): boolean {
    return this._nameOnly;
  }
  set nameOnly(value: boolean) {
    this._nameOnly = value;
  }
  get nameDefault(): boolean {
    return this._nameDefault;
  }
  set nameDefault(value: boolean) {
    this._nameDefault = value;
  }
  get nameHtml(): boolean {
    return this._nameHtml;
  }
  set nameHtml(value: boolean) {
    this._nameHtml = value;
  }
  get nameText(): boolean {
    return this._nameText;
  }
  set nameText(value: boolean) {
    this._nameText = value;
  }
  get description(): boolean {
    return this._description;
  }
  set description(value: boolean) {
    this._description = value;
  }
  get fullText(): boolean {
    return this._fullText;
  }
  set fullText(value: boolean) {
    this._fullText = value;
  }
  get hasText(): boolean {
    return this._hasText;
  }
  set hasText(value: boolean) {
    this._hasText = value;
  }
  get previewPictures(): PreviewPicturesRequest | undefined {
    return this._previewPictures;
  }
  set previewPictures(value: PreviewPicturesRequest | undefined) {
    this._previewPictures = value;
  }
  get descendantsCount(): boolean {
    return this._descendantsCount;
  }
  set descendantsCount(value: boolean) {
    this._descendantsCount = value;
  }
  get descendantPicturesCount(): boolean {
    return this._descendantPicturesCount;
  }
  set descendantPicturesCount(value: boolean) {
    this._descendantPicturesCount = value;
  }
  get childsCount(): boolean {
    return this._childsCount;
  }
  set childsCount(value: boolean) {
    this._childsCount = value;
  }
  get descendantTwinsGroupsCount(): boolean {
    return this._descendantTwinsGroupsCount;
  }
  set descendantTwinsGroupsCount(value: boolean) {
    this._descendantTwinsGroupsCount = value;
  }
  get inboxPicturesCount(): boolean {
    return this._inboxPicturesCount;
  }
  set inboxPicturesCount(value: boolean) {
    this._inboxPicturesCount = value;
  }
  get fullName(): boolean {
    return this._fullName;
  }
  set fullName(value: boolean) {
    this._fullName = value;
  }
  get logo120(): boolean {
    return this._logo120;
  }
  set logo120(value: boolean) {
    this._logo120 = value;
  }
  get mostsActive(): boolean {
    return this._mostsActive;
  }
  set mostsActive(value: boolean) {
    this._mostsActive = value;
  }
  get commentsAttentionsCount(): boolean {
    return this._commentsAttentionsCount;
  }
  set commentsAttentionsCount(value: boolean) {
    this._commentsAttentionsCount = value;
  }
  get isCompilesItemOfDay(): boolean {
    return this._isCompilesItemOfDay;
  }
  set isCompilesItemOfDay(value: boolean) {
    this._isCompilesItemOfDay = value;
  }
  get brandicon(): boolean {
    return this._brandicon;
  }
  set brandicon(value: boolean) {
    this._brandicon = value;
  }
  get attrZoneId(): boolean {
    return this._attrZoneId;
  }
  set attrZoneId(value: boolean) {
    this._attrZoneId = value;
  }
  get location(): boolean {
    return this._location;
  }
  set location(value: boolean) {
    this._location = value;
  }
  get acceptedPicturesCount(): boolean {
    return this._acceptedPicturesCount;
  }
  set acceptedPicturesCount(value: boolean) {
    this._acceptedPicturesCount = value;
  }
  get hasChildSpecs(): boolean {
    return this._hasChildSpecs;
  }
  set hasChildSpecs(value: boolean) {
    this._hasChildSpecs = value;
  }
  get hasSpecs(): boolean {
    return this._hasSpecs;
  }
  set hasSpecs(value: boolean) {
    this._hasSpecs = value;
  }
  get otherNames(): boolean {
    return this._otherNames;
  }
  set otherNames(value: boolean) {
    this._otherNames = value;
  }
  get design(): boolean {
    return this._design;
  }
  set design(value: boolean) {
    this._design = value;
  }
  get specsRoute(): boolean {
    return this._specsRoute;
  }
  set specsRoute(value: boolean) {
    this._specsRoute = value;
  }
  get childsCounts(): boolean {
    return this._childsCounts;
  }
  set childsCounts(value: boolean) {
    this._childsCounts = value;
  }
  get publicRoutes(): boolean {
    return this._publicRoutes;
  }
  set publicRoutes(value: boolean) {
    this._publicRoutes = value;
  }
  get pictureItems(): PictureItemsRequest | undefined {
    return this._pictureItems;
  }
  set pictureItems(value: PictureItemsRequest | undefined) {
    this._pictureItems = value;
  }
  get altNames(): boolean {
    return this._altNames;
  }
  set altNames(value: boolean) {
    this._altNames = value;
  }
  get route(): boolean {
    return this._route;
  }
  set route(value: boolean) {
    this._route = value;
  }
  get links(): ItemLinksRequest | undefined {
    return this._links;
  }
  set links(value: ItemLinksRequest | undefined) {
    this._links = value;
  }
  get categories(): ItemsRequest | undefined {
    return this._categories;
  }
  set categories(value: ItemsRequest | undefined) {
    this._categories = value;
  }
  get twins(): ItemsRequest | undefined {
    return this._twins;
  }
  set twins(value: ItemsRequest | undefined) {
    this._twins = value;
  }
  get canEditSpecs(): boolean {
    return this._canEditSpecs;
  }
  set canEditSpecs(value: boolean) {
    this._canEditSpecs = value;
  }
  get itemParentChilds(): ItemParentsRequest | undefined {
    return this._itemParentChilds;
  }
  set itemParentChilds(value: ItemParentsRequest | undefined) {
    this._itemParentChilds = value;
  }
  get commentsCount(): boolean {
    return this._commentsCount;
  }
  set commentsCount(value: boolean) {
    this._commentsCount = value;
  }
  get engineVehicles(): ItemsRequest | undefined {
    return this._engineVehicles;
  }
  set engineVehicles(value: ItemsRequest | undefined) {
    this._engineVehicles = value;
  }
  get routeBrandId(): string {
    return this._routeBrandId;
  }
  set routeBrandId(value: string) {
    this._routeBrandId = value;
  }
  get relatedGroupPictures(): boolean {
    return this._relatedGroupPictures;
  }
  set relatedGroupPictures(value: boolean) {
    this._relatedGroupPictures = value;
  }
  get itemOfDayPictures(): boolean {
    return this._itemOfDayPictures;
  }
  set itemOfDayPictures(value: boolean) {
    this._itemOfDayPictures = value;
  }
  get meta(): boolean {
    return this._meta;
  }
  set meta(value: boolean) {
    this._meta = value;
  }
  get engineVehiclesCount(): boolean {
    return this._engineVehiclesCount;
  }
  set engineVehiclesCount(value: boolean) {
    this._engineVehiclesCount = value;
  }
  get itemLanguageCount(): boolean {
    return this._itemLanguageCount;
  }
  set itemLanguageCount(value: boolean) {
    this._itemLanguageCount = value;
  }
  get linksCount(): boolean {
    return this._linksCount;
  }
  set linksCount(value: boolean) {
    this._linksCount = value;
  }
  get logo(): boolean {
    return this._logo;
  }
  set logo(value: boolean) {
    this._logo = value;
  }
  get parentsCount(): boolean {
    return this._parentsCount;
  }
  set parentsCount(value: boolean) {
    this._parentsCount = value;
  }
  get exactPicturesCount(): boolean {
    return this._exactPicturesCount;
  }
  set exactPicturesCount(value: boolean) {
    this._exactPicturesCount = value;
  }
  get specificationsCount(): boolean {
    return this._specificationsCount;
  }
  set specificationsCount(value: boolean) {
    this._specificationsCount = value;
  }
  get subscription(): boolean {
    return this._subscription;
  }
  set subscription(value: boolean) {
    this._subscription = value;
  }
  get specsContributors(): boolean {
    return this._specsContributors;
  }
  set specsContributors(value: boolean) {
    this._specsContributors = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemFields.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemFields.AsObject {
    return {
      nameOnly: this.nameOnly,
      nameDefault: this.nameDefault,
      nameHtml: this.nameHtml,
      nameText: this.nameText,
      description: this.description,
      fullText: this.fullText,
      hasText: this.hasText,
      previewPictures: this.previewPictures
        ? this.previewPictures.toObject()
        : undefined,
      descendantsCount: this.descendantsCount,
      descendantPicturesCount: this.descendantPicturesCount,
      childsCount: this.childsCount,
      descendantTwinsGroupsCount: this.descendantTwinsGroupsCount,
      inboxPicturesCount: this.inboxPicturesCount,
      fullName: this.fullName,
      logo120: this.logo120,
      mostsActive: this.mostsActive,
      commentsAttentionsCount: this.commentsAttentionsCount,
      isCompilesItemOfDay: this.isCompilesItemOfDay,
      brandicon: this.brandicon,
      attrZoneId: this.attrZoneId,
      location: this.location,
      acceptedPicturesCount: this.acceptedPicturesCount,
      hasChildSpecs: this.hasChildSpecs,
      hasSpecs: this.hasSpecs,
      otherNames: this.otherNames,
      design: this.design,
      specsRoute: this.specsRoute,
      childsCounts: this.childsCounts,
      publicRoutes: this.publicRoutes,
      pictureItems: this.pictureItems
        ? this.pictureItems.toObject()
        : undefined,
      altNames: this.altNames,
      route: this.route,
      links: this.links ? this.links.toObject() : undefined,
      categories: this.categories ? this.categories.toObject() : undefined,
      twins: this.twins ? this.twins.toObject() : undefined,
      canEditSpecs: this.canEditSpecs,
      itemParentChilds: this.itemParentChilds
        ? this.itemParentChilds.toObject()
        : undefined,
      commentsCount: this.commentsCount,
      engineVehicles: this.engineVehicles
        ? this.engineVehicles.toObject()
        : undefined,
      routeBrandId: this.routeBrandId,
      relatedGroupPictures: this.relatedGroupPictures,
      itemOfDayPictures: this.itemOfDayPictures,
      meta: this.meta,
      engineVehiclesCount: this.engineVehiclesCount,
      itemLanguageCount: this.itemLanguageCount,
      linksCount: this.linksCount,
      logo: this.logo,
      parentsCount: this.parentsCount,
      exactPicturesCount: this.exactPicturesCount,
      specificationsCount: this.specificationsCount,
      subscription: this.subscription,
      specsContributors: this.specsContributors
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemFields.AsProtobufJSON {
    return {
      nameOnly: this.nameOnly,
      nameDefault: this.nameDefault,
      nameHtml: this.nameHtml,
      nameText: this.nameText,
      description: this.description,
      fullText: this.fullText,
      hasText: this.hasText,
      previewPictures: this.previewPictures
        ? this.previewPictures.toProtobufJSON(options)
        : null,
      descendantsCount: this.descendantsCount,
      descendantPicturesCount: this.descendantPicturesCount,
      childsCount: this.childsCount,
      descendantTwinsGroupsCount: this.descendantTwinsGroupsCount,
      inboxPicturesCount: this.inboxPicturesCount,
      fullName: this.fullName,
      logo120: this.logo120,
      mostsActive: this.mostsActive,
      commentsAttentionsCount: this.commentsAttentionsCount,
      isCompilesItemOfDay: this.isCompilesItemOfDay,
      brandicon: this.brandicon,
      attrZoneId: this.attrZoneId,
      location: this.location,
      acceptedPicturesCount: this.acceptedPicturesCount,
      hasChildSpecs: this.hasChildSpecs,
      hasSpecs: this.hasSpecs,
      otherNames: this.otherNames,
      design: this.design,
      specsRoute: this.specsRoute,
      childsCounts: this.childsCounts,
      publicRoutes: this.publicRoutes,
      pictureItems: this.pictureItems
        ? this.pictureItems.toProtobufJSON(options)
        : null,
      altNames: this.altNames,
      route: this.route,
      links: this.links ? this.links.toProtobufJSON(options) : null,
      categories: this.categories
        ? this.categories.toProtobufJSON(options)
        : null,
      twins: this.twins ? this.twins.toProtobufJSON(options) : null,
      canEditSpecs: this.canEditSpecs,
      itemParentChilds: this.itemParentChilds
        ? this.itemParentChilds.toProtobufJSON(options)
        : null,
      commentsCount: this.commentsCount,
      engineVehicles: this.engineVehicles
        ? this.engineVehicles.toProtobufJSON(options)
        : null,
      routeBrandId: this.routeBrandId,
      relatedGroupPictures: this.relatedGroupPictures,
      itemOfDayPictures: this.itemOfDayPictures,
      meta: this.meta,
      engineVehiclesCount: this.engineVehiclesCount,
      itemLanguageCount: this.itemLanguageCount,
      linksCount: this.linksCount,
      logo: this.logo,
      parentsCount: this.parentsCount,
      exactPicturesCount: this.exactPicturesCount,
      specificationsCount: this.specificationsCount,
      subscription: this.subscription,
      specsContributors: this.specsContributors
    };
  }
}
export module ItemFields {
  /**
   * Standard JavaScript object representation for ItemFields
   */
  export interface AsObject {
    nameOnly: boolean;
    nameDefault: boolean;
    nameHtml: boolean;
    nameText: boolean;
    description: boolean;
    fullText: boolean;
    hasText: boolean;
    previewPictures?: PreviewPicturesRequest.AsObject;
    descendantsCount: boolean;
    descendantPicturesCount: boolean;
    childsCount: boolean;
    descendantTwinsGroupsCount: boolean;
    inboxPicturesCount: boolean;
    fullName: boolean;
    logo120: boolean;
    mostsActive: boolean;
    commentsAttentionsCount: boolean;
    isCompilesItemOfDay: boolean;
    brandicon: boolean;
    attrZoneId: boolean;
    location: boolean;
    acceptedPicturesCount: boolean;
    hasChildSpecs: boolean;
    hasSpecs: boolean;
    otherNames: boolean;
    design: boolean;
    specsRoute: boolean;
    childsCounts: boolean;
    publicRoutes: boolean;
    pictureItems?: PictureItemsRequest.AsObject;
    altNames: boolean;
    route: boolean;
    links?: ItemLinksRequest.AsObject;
    categories?: ItemsRequest.AsObject;
    twins?: ItemsRequest.AsObject;
    canEditSpecs: boolean;
    itemParentChilds?: ItemParentsRequest.AsObject;
    commentsCount: boolean;
    engineVehicles?: ItemsRequest.AsObject;
    routeBrandId: string;
    relatedGroupPictures: boolean;
    itemOfDayPictures: boolean;
    meta: boolean;
    engineVehiclesCount: boolean;
    itemLanguageCount: boolean;
    linksCount: boolean;
    logo: boolean;
    parentsCount: boolean;
    exactPicturesCount: boolean;
    specificationsCount: boolean;
    subscription: boolean;
    specsContributors: boolean;
  }

  /**
   * Protobuf JSON representation for ItemFields
   */
  export interface AsProtobufJSON {
    nameOnly: boolean;
    nameDefault: boolean;
    nameHtml: boolean;
    nameText: boolean;
    description: boolean;
    fullText: boolean;
    hasText: boolean;
    previewPictures: PreviewPicturesRequest.AsProtobufJSON | null;
    descendantsCount: boolean;
    descendantPicturesCount: boolean;
    childsCount: boolean;
    descendantTwinsGroupsCount: boolean;
    inboxPicturesCount: boolean;
    fullName: boolean;
    logo120: boolean;
    mostsActive: boolean;
    commentsAttentionsCount: boolean;
    isCompilesItemOfDay: boolean;
    brandicon: boolean;
    attrZoneId: boolean;
    location: boolean;
    acceptedPicturesCount: boolean;
    hasChildSpecs: boolean;
    hasSpecs: boolean;
    otherNames: boolean;
    design: boolean;
    specsRoute: boolean;
    childsCounts: boolean;
    publicRoutes: boolean;
    pictureItems: PictureItemsRequest.AsProtobufJSON | null;
    altNames: boolean;
    route: boolean;
    links: ItemLinksRequest.AsProtobufJSON | null;
    categories: ItemsRequest.AsProtobufJSON | null;
    twins: ItemsRequest.AsProtobufJSON | null;
    canEditSpecs: boolean;
    itemParentChilds: ItemParentsRequest.AsProtobufJSON | null;
    commentsCount: boolean;
    engineVehicles: ItemsRequest.AsProtobufJSON | null;
    routeBrandId: string;
    relatedGroupPictures: boolean;
    itemOfDayPictures: boolean;
    meta: boolean;
    engineVehiclesCount: boolean;
    itemLanguageCount: boolean;
    linksCount: boolean;
    logo: boolean;
    parentsCount: boolean;
    exactPicturesCount: boolean;
    specificationsCount: boolean;
    subscription: boolean;
    specsContributors: boolean;
  }
}

/**
 * Message implementation for goautowp.AltName
 */
export class AltName implements GrpcMessage {
  static id = 'goautowp.AltName';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AltName();
    AltName.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AltName) {
    _instance.languages = _instance.languages || [];
    _instance.name = _instance.name || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AltName,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          (_instance.languages = _instance.languages || []).push(
            _reader.readString()
          );
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    AltName.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: AltName, _writer: BinaryWriter) {
    if (_instance.languages && _instance.languages.length) {
      _writer.writeRepeatedString(1, _instance.languages);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
  }

  private _languages: string[];
  private _name: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AltName to deeply clone from
   */
  constructor(_value?: RecursivePartial<AltName.AsObject>) {
    _value = _value || {};
    this.languages = (_value.languages || []).slice();
    this.name = _value.name;
    AltName.refineValues(this);
  }
  get languages(): string[] {
    return this._languages;
  }
  set languages(value: string[]) {
    this._languages = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AltName.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AltName.AsObject {
    return {
      languages: (this.languages || []).slice(),
      name: this.name
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AltName.AsProtobufJSON {
    return {
      languages: (this.languages || []).slice(),
      name: this.name
    };
  }
}
export module AltName {
  /**
   * Standard JavaScript object representation for AltName
   */
  export interface AsObject {
    languages: string[];
    name: string;
  }

  /**
   * Protobuf JSON representation for AltName
   */
  export interface AsProtobufJSON {
    languages: string[];
    name: string;
  }
}

/**
 * Message implementation for goautowp.ItemID
 */
export class ItemID implements GrpcMessage {
  static id = 'goautowp.ItemID';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemID();
    ItemID.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemID) {
    _instance.id = _instance.id || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(_instance: ItemID, _reader: BinaryReader) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    ItemID.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: ItemID, _writer: BinaryWriter) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
  }

  private _id: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemID to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemID.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    ItemID.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemID.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemID.AsObject {
    return {
      id: this.id
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemID.AsProtobufJSON {
    return {
      id: this.id
    };
  }
}
export module ItemID {
  /**
   * Standard JavaScript object representation for ItemID
   */
  export interface AsObject {
    id: string;
  }

  /**
   * Protobuf JSON representation for ItemID
   */
  export interface AsProtobufJSON {
    id: string;
  }
}

/**
 * Message implementation for goautowp.UpdateItemRequest
 */
export class UpdateItemRequest implements GrpcMessage {
  static id = 'goautowp.UpdateItemRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UpdateItemRequest();
    UpdateItemRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UpdateItemRequest) {
    _instance.item = _instance.item || undefined;
    _instance.updateMask = _instance.updateMask || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UpdateItemRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.item = new APIItem();
          _reader.readMessage(
            _instance.item,
            APIItem.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.updateMask = new googleProtobuf008.FieldMask();
          _reader.readMessage(
            _instance.updateMask,
            googleProtobuf008.FieldMask.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    UpdateItemRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: UpdateItemRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.item) {
      _writer.writeMessage(
        1,
        _instance.item as any,
        APIItem.serializeBinaryToWriter
      );
    }
    if (_instance.updateMask) {
      _writer.writeMessage(
        2,
        _instance.updateMask as any,
        googleProtobuf008.FieldMask.serializeBinaryToWriter
      );
    }
  }

  private _item?: APIItem;
  private _updateMask?: googleProtobuf008.FieldMask;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UpdateItemRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<UpdateItemRequest.AsObject>) {
    _value = _value || {};
    this.item = _value.item ? new APIItem(_value.item) : undefined;
    this.updateMask = _value.updateMask
      ? new googleProtobuf008.FieldMask(_value.updateMask)
      : undefined;
    UpdateItemRequest.refineValues(this);
  }
  get item(): APIItem | undefined {
    return this._item;
  }
  set item(value: APIItem | undefined) {
    this._item = value;
  }
  get updateMask(): googleProtobuf008.FieldMask | undefined {
    return this._updateMask;
  }
  set updateMask(value: googleProtobuf008.FieldMask | undefined) {
    this._updateMask = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UpdateItemRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UpdateItemRequest.AsObject {
    return {
      item: this.item ? this.item.toObject() : undefined,
      updateMask: this.updateMask ? this.updateMask.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UpdateItemRequest.AsProtobufJSON {
    return {
      item: this.item ? this.item.toProtobufJSON(options) : null,
      updateMask: this.updateMask
        ? this.updateMask.toProtobufJSON(options)
        : null
    };
  }
}
export module UpdateItemRequest {
  /**
   * Standard JavaScript object representation for UpdateItemRequest
   */
  export interface AsObject {
    item?: APIItem.AsObject;
    updateMask?: googleProtobuf008.FieldMask.AsObject;
  }

  /**
   * Protobuf JSON representation for UpdateItemRequest
   */
  export interface AsProtobufJSON {
    item: APIItem.AsProtobufJSON | null;
    updateMask: googleProtobuf008.FieldMask.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.ItemRequest
 */
export class ItemRequest implements GrpcMessage {
  static id = 'goautowp.ItemRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemRequest();
    ItemRequest.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemRequest) {
    _instance.language = _instance.language || '';
    _instance.id = _instance.id || '0';
    _instance.fields = _instance.fields || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.language = _reader.readString();
          break;
        case 2:
          _instance.id = _reader.readInt64String();
          break;
        case 3:
          _instance.fields = new ItemFields();
          _reader.readMessage(
            _instance.fields,
            ItemFields.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    ItemRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItemRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.language) {
      _writer.writeString(1, _instance.language);
    }
    if (_instance.id) {
      _writer.writeInt64String(2, _instance.id);
    }
    if (_instance.fields) {
      _writer.writeMessage(
        3,
        _instance.fields as any,
        ItemFields.serializeBinaryToWriter
      );
    }
  }

  private _language: string;
  private _id: string;
  private _fields?: ItemFields;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemRequest.AsObject>) {
    _value = _value || {};
    this.language = _value.language;
    this.id = _value.id;
    this.fields = _value.fields ? new ItemFields(_value.fields) : undefined;
    ItemRequest.refineValues(this);
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get fields(): ItemFields | undefined {
    return this._fields;
  }
  set fields(value: ItemFields | undefined) {
    this._fields = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemRequest.AsObject {
    return {
      language: this.language,
      id: this.id,
      fields: this.fields ? this.fields.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemRequest.AsProtobufJSON {
    return {
      language: this.language,
      id: this.id,
      fields: this.fields ? this.fields.toProtobufJSON(options) : null
    };
  }
}
export module ItemRequest {
  /**
   * Standard JavaScript object representation for ItemRequest
   */
  export interface AsObject {
    language: string;
    id: string;
    fields?: ItemFields.AsObject;
  }

  /**
   * Protobuf JSON representation for ItemRequest
   */
  export interface AsProtobufJSON {
    language: string;
    id: string;
    fields: ItemFields.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.ItemsRequest
 */
export class ItemsRequest implements GrpcMessage {
  static id = 'goautowp.ItemsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemsRequest();
    ItemsRequest.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemsRequest) {
    _instance.language = _instance.language || '';
    _instance.fields = _instance.fields || undefined;
    _instance.options = _instance.options || undefined;
    _instance.limit = _instance.limit || 0;
    _instance.order = _instance.order || 0;
    _instance.page = _instance.page || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.language = _reader.readString();
          break;
        case 2:
          _instance.fields = new ItemFields();
          _reader.readMessage(
            _instance.fields,
            ItemFields.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.options = new ItemListOptions();
          _reader.readMessage(
            _instance.options,
            ItemListOptions.deserializeBinaryFromReader
          );
          break;
        case 6:
          _instance.limit = _reader.readUint32();
          break;
        case 9:
          _instance.order = _reader.readEnum();
          break;
        case 11:
          _instance.page = _reader.readUint32();
          break;
        default:
          _reader.skipField();
      }
    }

    ItemsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItemsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.language) {
      _writer.writeString(1, _instance.language);
    }
    if (_instance.fields) {
      _writer.writeMessage(
        2,
        _instance.fields as any,
        ItemFields.serializeBinaryToWriter
      );
    }
    if (_instance.options) {
      _writer.writeMessage(
        3,
        _instance.options as any,
        ItemListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.limit) {
      _writer.writeUint32(6, _instance.limit);
    }
    if (_instance.order) {
      _writer.writeEnum(9, _instance.order);
    }
    if (_instance.page) {
      _writer.writeUint32(11, _instance.page);
    }
  }

  private _language: string;
  private _fields?: ItemFields;
  private _options?: ItemListOptions;
  private _limit: number;
  private _order: ItemsRequest.Order;
  private _page: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemsRequest.AsObject>) {
    _value = _value || {};
    this.language = _value.language;
    this.fields = _value.fields ? new ItemFields(_value.fields) : undefined;
    this.options = _value.options
      ? new ItemListOptions(_value.options)
      : undefined;
    this.limit = _value.limit;
    this.order = _value.order;
    this.page = _value.page;
    ItemsRequest.refineValues(this);
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }
  get fields(): ItemFields | undefined {
    return this._fields;
  }
  set fields(value: ItemFields | undefined) {
    this._fields = value;
  }
  get options(): ItemListOptions | undefined {
    return this._options;
  }
  set options(value: ItemListOptions | undefined) {
    this._options = value;
  }
  get limit(): number {
    return this._limit;
  }
  set limit(value: number) {
    this._limit = value;
  }
  get order(): ItemsRequest.Order {
    return this._order;
  }
  set order(value: ItemsRequest.Order) {
    this._order = value;
  }
  get page(): number {
    return this._page;
  }
  set page(value: number) {
    this._page = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemsRequest.AsObject {
    return {
      language: this.language,
      fields: this.fields ? this.fields.toObject() : undefined,
      options: this.options ? this.options.toObject() : undefined,
      limit: this.limit,
      order: this.order,
      page: this.page
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemsRequest.AsProtobufJSON {
    return {
      language: this.language,
      fields: this.fields ? this.fields.toProtobufJSON(options) : null,
      options: this.options ? this.options.toProtobufJSON(options) : null,
      limit: this.limit,
      order:
        ItemsRequest.Order[
          this.order === null || this.order === undefined ? 0 : this.order
        ],
      page: this.page
    };
  }
}
export module ItemsRequest {
  /**
   * Standard JavaScript object representation for ItemsRequest
   */
  export interface AsObject {
    language: string;
    fields?: ItemFields.AsObject;
    options?: ItemListOptions.AsObject;
    limit: number;
    order: ItemsRequest.Order;
    page: number;
  }

  /**
   * Protobuf JSON representation for ItemsRequest
   */
  export interface AsProtobufJSON {
    language: string;
    fields: ItemFields.AsProtobufJSON | null;
    options: ItemListOptions.AsProtobufJSON | null;
    limit: number;
    order: string;
    page: number;
  }
  export enum Order {
    DEFAULT = 0,
    NAME_NAT = 1,
    NAME = 2,
    CHILDS_COUNT = 3,
    AGE = 4,
    ID_DESC = 5,
    ID_ASC = 6
  }
}

/**
 * Message implementation for goautowp.PictureItemListOptions
 */
export class PictureItemListOptions implements GrpcMessage {
  static id = 'goautowp.PictureItemListOptions';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PictureItemListOptions();
    PictureItemListOptions.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PictureItemListOptions) {
    _instance.pictureId = _instance.pictureId || '0';
    _instance.itemId = _instance.itemId || '0';
    _instance.typeId = _instance.typeId || 0;
    _instance.pictures = _instance.pictures || undefined;
    _instance.perspectiveId = _instance.perspectiveId || 0;
    _instance.excludePerspectiveId = _instance.excludePerspectiveId || [];
    _instance.excludeAncestorOrSelfId =
      _instance.excludeAncestorOrSelfId || '0';
    _instance.item = _instance.item || undefined;
    _instance.itemParentCacheAncestor =
      _instance.itemParentCacheAncestor || undefined;
    _instance.itemVehicleType = _instance.itemVehicleType || undefined;
    _instance.hasNoPerspectiveId = _instance.hasNoPerspectiveId || false;
    _instance.pictureItemByPictureId =
      _instance.pictureItemByPictureId || undefined;
    _instance.hasArea = _instance.hasArea || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PictureItemListOptions,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 7:
          _instance.pictureId = _reader.readInt64String();
          break;
        case 4:
          _instance.itemId = _reader.readInt64String();
          break;
        case 1:
          _instance.typeId = _reader.readEnum();
          break;
        case 2:
          _instance.pictures = new PictureListOptions();
          _reader.readMessage(
            _instance.pictures,
            PictureListOptions.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.perspectiveId = _reader.readInt32();
          break;
        case 6:
          (_instance.excludePerspectiveId =
            _instance.excludePerspectiveId || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        case 10:
          _instance.excludeAncestorOrSelfId = _reader.readInt64String();
          break;
        case 8:
          _instance.item = new ItemListOptions();
          _reader.readMessage(
            _instance.item,
            ItemListOptions.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.itemParentCacheAncestor = new ItemParentCacheListOptions();
          _reader.readMessage(
            _instance.itemParentCacheAncestor,
            ItemParentCacheListOptions.deserializeBinaryFromReader
          );
          break;
        case 9:
          _instance.itemVehicleType = new ItemVehicleTypeListOptions();
          _reader.readMessage(
            _instance.itemVehicleType,
            ItemVehicleTypeListOptions.deserializeBinaryFromReader
          );
          break;
        case 11:
          _instance.hasNoPerspectiveId = _reader.readBool();
          break;
        case 12:
          _instance.pictureItemByPictureId = new PictureItemListOptions();
          _reader.readMessage(
            _instance.pictureItemByPictureId,
            PictureItemListOptions.deserializeBinaryFromReader
          );
          break;
        case 13:
          _instance.hasArea = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    PictureItemListOptions.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PictureItemListOptions,
    _writer: BinaryWriter
  ) {
    if (_instance.pictureId) {
      _writer.writeInt64String(7, _instance.pictureId);
    }
    if (_instance.itemId) {
      _writer.writeInt64String(4, _instance.itemId);
    }
    if (_instance.typeId) {
      _writer.writeEnum(1, _instance.typeId);
    }
    if (_instance.pictures) {
      _writer.writeMessage(
        2,
        _instance.pictures as any,
        PictureListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.perspectiveId) {
      _writer.writeInt32(3, _instance.perspectiveId);
    }
    if (
      _instance.excludePerspectiveId &&
      _instance.excludePerspectiveId.length
    ) {
      _writer.writePackedInt32(6, _instance.excludePerspectiveId);
    }
    if (_instance.excludeAncestorOrSelfId) {
      _writer.writeInt64String(10, _instance.excludeAncestorOrSelfId);
    }
    if (_instance.item) {
      _writer.writeMessage(
        8,
        _instance.item as any,
        ItemListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.itemParentCacheAncestor) {
      _writer.writeMessage(
        5,
        _instance.itemParentCacheAncestor as any,
        ItemParentCacheListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.itemVehicleType) {
      _writer.writeMessage(
        9,
        _instance.itemVehicleType as any,
        ItemVehicleTypeListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.hasNoPerspectiveId) {
      _writer.writeBool(11, _instance.hasNoPerspectiveId);
    }
    if (_instance.pictureItemByPictureId) {
      _writer.writeMessage(
        12,
        _instance.pictureItemByPictureId as any,
        PictureItemListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.hasArea) {
      _writer.writeBool(13, _instance.hasArea);
    }
  }

  private _pictureId: string;
  private _itemId: string;
  private _typeId: PictureItemType;
  private _pictures?: PictureListOptions;
  private _perspectiveId: number;
  private _excludePerspectiveId: number[];
  private _excludeAncestorOrSelfId: string;
  private _item?: ItemListOptions;
  private _itemParentCacheAncestor?: ItemParentCacheListOptions;
  private _itemVehicleType?: ItemVehicleTypeListOptions;
  private _hasNoPerspectiveId: boolean;
  private _pictureItemByPictureId?: PictureItemListOptions;
  private _hasArea: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PictureItemListOptions to deeply clone from
   */
  constructor(_value?: RecursivePartial<PictureItemListOptions.AsObject>) {
    _value = _value || {};
    this.pictureId = _value.pictureId;
    this.itemId = _value.itemId;
    this.typeId = _value.typeId;
    this.pictures = _value.pictures
      ? new PictureListOptions(_value.pictures)
      : undefined;
    this.perspectiveId = _value.perspectiveId;
    this.excludePerspectiveId = (_value.excludePerspectiveId || []).slice();
    this.excludeAncestorOrSelfId = _value.excludeAncestorOrSelfId;
    this.item = _value.item ? new ItemListOptions(_value.item) : undefined;
    this.itemParentCacheAncestor = _value.itemParentCacheAncestor
      ? new ItemParentCacheListOptions(_value.itemParentCacheAncestor)
      : undefined;
    this.itemVehicleType = _value.itemVehicleType
      ? new ItemVehicleTypeListOptions(_value.itemVehicleType)
      : undefined;
    this.hasNoPerspectiveId = _value.hasNoPerspectiveId;
    this.pictureItemByPictureId = _value.pictureItemByPictureId
      ? new PictureItemListOptions(_value.pictureItemByPictureId)
      : undefined;
    this.hasArea = _value.hasArea;
    PictureItemListOptions.refineValues(this);
  }
  get pictureId(): string {
    return this._pictureId;
  }
  set pictureId(value: string) {
    this._pictureId = value;
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get typeId(): PictureItemType {
    return this._typeId;
  }
  set typeId(value: PictureItemType) {
    this._typeId = value;
  }
  get pictures(): PictureListOptions | undefined {
    return this._pictures;
  }
  set pictures(value: PictureListOptions | undefined) {
    this._pictures = value;
  }
  get perspectiveId(): number {
    return this._perspectiveId;
  }
  set perspectiveId(value: number) {
    this._perspectiveId = value;
  }
  get excludePerspectiveId(): number[] {
    return this._excludePerspectiveId;
  }
  set excludePerspectiveId(value: number[]) {
    this._excludePerspectiveId = value;
  }
  get excludeAncestorOrSelfId(): string {
    return this._excludeAncestorOrSelfId;
  }
  set excludeAncestorOrSelfId(value: string) {
    this._excludeAncestorOrSelfId = value;
  }
  get item(): ItemListOptions | undefined {
    return this._item;
  }
  set item(value: ItemListOptions | undefined) {
    this._item = value;
  }
  get itemParentCacheAncestor(): ItemParentCacheListOptions | undefined {
    return this._itemParentCacheAncestor;
  }
  set itemParentCacheAncestor(value: ItemParentCacheListOptions | undefined) {
    this._itemParentCacheAncestor = value;
  }
  get itemVehicleType(): ItemVehicleTypeListOptions | undefined {
    return this._itemVehicleType;
  }
  set itemVehicleType(value: ItemVehicleTypeListOptions | undefined) {
    this._itemVehicleType = value;
  }
  get hasNoPerspectiveId(): boolean {
    return this._hasNoPerspectiveId;
  }
  set hasNoPerspectiveId(value: boolean) {
    this._hasNoPerspectiveId = value;
  }
  get pictureItemByPictureId(): PictureItemListOptions | undefined {
    return this._pictureItemByPictureId;
  }
  set pictureItemByPictureId(value: PictureItemListOptions | undefined) {
    this._pictureItemByPictureId = value;
  }
  get hasArea(): boolean {
    return this._hasArea;
  }
  set hasArea(value: boolean) {
    this._hasArea = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PictureItemListOptions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PictureItemListOptions.AsObject {
    return {
      pictureId: this.pictureId,
      itemId: this.itemId,
      typeId: this.typeId,
      pictures: this.pictures ? this.pictures.toObject() : undefined,
      perspectiveId: this.perspectiveId,
      excludePerspectiveId: (this.excludePerspectiveId || []).slice(),
      excludeAncestorOrSelfId: this.excludeAncestorOrSelfId,
      item: this.item ? this.item.toObject() : undefined,
      itemParentCacheAncestor: this.itemParentCacheAncestor
        ? this.itemParentCacheAncestor.toObject()
        : undefined,
      itemVehicleType: this.itemVehicleType
        ? this.itemVehicleType.toObject()
        : undefined,
      hasNoPerspectiveId: this.hasNoPerspectiveId,
      pictureItemByPictureId: this.pictureItemByPictureId
        ? this.pictureItemByPictureId.toObject()
        : undefined,
      hasArea: this.hasArea
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PictureItemListOptions.AsProtobufJSON {
    return {
      pictureId: this.pictureId,
      itemId: this.itemId,
      typeId:
        PictureItemType[
          this.typeId === null || this.typeId === undefined ? 0 : this.typeId
        ],
      pictures: this.pictures ? this.pictures.toProtobufJSON(options) : null,
      perspectiveId: this.perspectiveId,
      excludePerspectiveId: (this.excludePerspectiveId || []).slice(),
      excludeAncestorOrSelfId: this.excludeAncestorOrSelfId,
      item: this.item ? this.item.toProtobufJSON(options) : null,
      itemParentCacheAncestor: this.itemParentCacheAncestor
        ? this.itemParentCacheAncestor.toProtobufJSON(options)
        : null,
      itemVehicleType: this.itemVehicleType
        ? this.itemVehicleType.toProtobufJSON(options)
        : null,
      hasNoPerspectiveId: this.hasNoPerspectiveId,
      pictureItemByPictureId: this.pictureItemByPictureId
        ? this.pictureItemByPictureId.toProtobufJSON(options)
        : null,
      hasArea: this.hasArea
    };
  }
}
export module PictureItemListOptions {
  /**
   * Standard JavaScript object representation for PictureItemListOptions
   */
  export interface AsObject {
    pictureId: string;
    itemId: string;
    typeId: PictureItemType;
    pictures?: PictureListOptions.AsObject;
    perspectiveId: number;
    excludePerspectiveId: number[];
    excludeAncestorOrSelfId: string;
    item?: ItemListOptions.AsObject;
    itemParentCacheAncestor?: ItemParentCacheListOptions.AsObject;
    itemVehicleType?: ItemVehicleTypeListOptions.AsObject;
    hasNoPerspectiveId: boolean;
    pictureItemByPictureId?: PictureItemListOptions.AsObject;
    hasArea: boolean;
  }

  /**
   * Protobuf JSON representation for PictureItemListOptions
   */
  export interface AsProtobufJSON {
    pictureId: string;
    itemId: string;
    typeId: string;
    pictures: PictureListOptions.AsProtobufJSON | null;
    perspectiveId: number;
    excludePerspectiveId: number[];
    excludeAncestorOrSelfId: string;
    item: ItemListOptions.AsProtobufJSON | null;
    itemParentCacheAncestor: ItemParentCacheListOptions.AsProtobufJSON | null;
    itemVehicleType: ItemVehicleTypeListOptions.AsProtobufJSON | null;
    hasNoPerspectiveId: boolean;
    pictureItemByPictureId: PictureItemListOptions.AsProtobufJSON | null;
    hasArea: boolean;
  }
}

/**
 * Message implementation for goautowp.CommentTopicListOptions
 */
export class CommentTopicListOptions implements GrpcMessage {
  static id = 'goautowp.CommentTopicListOptions';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CommentTopicListOptions();
    CommentTopicListOptions.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CommentTopicListOptions) {
    _instance.messagesGtZero = _instance.messagesGtZero || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CommentTopicListOptions,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.messagesGtZero = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    CommentTopicListOptions.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CommentTopicListOptions,
    _writer: BinaryWriter
  ) {
    if (_instance.messagesGtZero) {
      _writer.writeBool(1, _instance.messagesGtZero);
    }
  }

  private _messagesGtZero: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CommentTopicListOptions to deeply clone from
   */
  constructor(_value?: RecursivePartial<CommentTopicListOptions.AsObject>) {
    _value = _value || {};
    this.messagesGtZero = _value.messagesGtZero;
    CommentTopicListOptions.refineValues(this);
  }
  get messagesGtZero(): boolean {
    return this._messagesGtZero;
  }
  set messagesGtZero(value: boolean) {
    this._messagesGtZero = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CommentTopicListOptions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CommentTopicListOptions.AsObject {
    return {
      messagesGtZero: this.messagesGtZero
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CommentTopicListOptions.AsProtobufJSON {
    return {
      messagesGtZero: this.messagesGtZero
    };
  }
}
export module CommentTopicListOptions {
  /**
   * Standard JavaScript object representation for CommentTopicListOptions
   */
  export interface AsObject {
    messagesGtZero: boolean;
  }

  /**
   * Protobuf JSON representation for CommentTopicListOptions
   */
  export interface AsProtobufJSON {
    messagesGtZero: boolean;
  }
}

/**
 * Message implementation for goautowp.ItemParentListOptions
 */
export class ItemParentListOptions implements GrpcMessage {
  static id = 'goautowp.ItemParentListOptions';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemParentListOptions();
    ItemParentListOptions.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemParentListOptions) {
    _instance.parentId = _instance.parentId || '0';
    _instance.parent = _instance.parent || undefined;
    _instance.itemParentParentByChild =
      _instance.itemParentParentByChild || undefined;
    _instance.itemId = _instance.itemId || '0';
    _instance.type = _instance.type || 0;
    _instance.strictType = _instance.strictType || false;
    _instance.item = _instance.item || undefined;
    _instance.itemParentCacheItemByChild =
      _instance.itemParentCacheItemByChild || undefined;
    _instance.catname = _instance.catname || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemParentListOptions,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.parentId = _reader.readInt64String();
          break;
        case 2:
          _instance.parent = new ItemListOptions();
          _reader.readMessage(
            _instance.parent,
            ItemListOptions.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.itemParentParentByChild = new ItemParentListOptions();
          _reader.readMessage(
            _instance.itemParentParentByChild,
            ItemParentListOptions.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.itemId = _reader.readInt64String();
          break;
        case 5:
          _instance.type = _reader.readEnum();
          break;
        case 9:
          _instance.strictType = _reader.readBool();
          break;
        case 6:
          _instance.item = new ItemListOptions();
          _reader.readMessage(
            _instance.item,
            ItemListOptions.deserializeBinaryFromReader
          );
          break;
        case 7:
          _instance.itemParentCacheItemByChild = new ItemParentCacheListOptions();
          _reader.readMessage(
            _instance.itemParentCacheItemByChild,
            ItemParentCacheListOptions.deserializeBinaryFromReader
          );
          break;
        case 8:
          _instance.catname = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    ItemParentListOptions.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItemParentListOptions,
    _writer: BinaryWriter
  ) {
    if (_instance.parentId) {
      _writer.writeInt64String(1, _instance.parentId);
    }
    if (_instance.parent) {
      _writer.writeMessage(
        2,
        _instance.parent as any,
        ItemListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.itemParentParentByChild) {
      _writer.writeMessage(
        3,
        _instance.itemParentParentByChild as any,
        ItemParentListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.itemId) {
      _writer.writeInt64String(4, _instance.itemId);
    }
    if (_instance.type) {
      _writer.writeEnum(5, _instance.type);
    }
    if (_instance.strictType) {
      _writer.writeBool(9, _instance.strictType);
    }
    if (_instance.item) {
      _writer.writeMessage(
        6,
        _instance.item as any,
        ItemListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.itemParentCacheItemByChild) {
      _writer.writeMessage(
        7,
        _instance.itemParentCacheItemByChild as any,
        ItemParentCacheListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.catname) {
      _writer.writeString(8, _instance.catname);
    }
  }

  private _parentId: string;
  private _parent?: ItemListOptions;
  private _itemParentParentByChild?: ItemParentListOptions;
  private _itemId: string;
  private _type: ItemParentType;
  private _strictType: boolean;
  private _item?: ItemListOptions;
  private _itemParentCacheItemByChild?: ItemParentCacheListOptions;
  private _catname: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemParentListOptions to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemParentListOptions.AsObject>) {
    _value = _value || {};
    this.parentId = _value.parentId;
    this.parent = _value.parent
      ? new ItemListOptions(_value.parent)
      : undefined;
    this.itemParentParentByChild = _value.itemParentParentByChild
      ? new ItemParentListOptions(_value.itemParentParentByChild)
      : undefined;
    this.itemId = _value.itemId;
    this.type = _value.type;
    this.strictType = _value.strictType;
    this.item = _value.item ? new ItemListOptions(_value.item) : undefined;
    this.itemParentCacheItemByChild = _value.itemParentCacheItemByChild
      ? new ItemParentCacheListOptions(_value.itemParentCacheItemByChild)
      : undefined;
    this.catname = _value.catname;
    ItemParentListOptions.refineValues(this);
  }
  get parentId(): string {
    return this._parentId;
  }
  set parentId(value: string) {
    this._parentId = value;
  }
  get parent(): ItemListOptions | undefined {
    return this._parent;
  }
  set parent(value: ItemListOptions | undefined) {
    this._parent = value;
  }
  get itemParentParentByChild(): ItemParentListOptions | undefined {
    return this._itemParentParentByChild;
  }
  set itemParentParentByChild(value: ItemParentListOptions | undefined) {
    this._itemParentParentByChild = value;
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get type(): ItemParentType {
    return this._type;
  }
  set type(value: ItemParentType) {
    this._type = value;
  }
  get strictType(): boolean {
    return this._strictType;
  }
  set strictType(value: boolean) {
    this._strictType = value;
  }
  get item(): ItemListOptions | undefined {
    return this._item;
  }
  set item(value: ItemListOptions | undefined) {
    this._item = value;
  }
  get itemParentCacheItemByChild(): ItemParentCacheListOptions | undefined {
    return this._itemParentCacheItemByChild;
  }
  set itemParentCacheItemByChild(
    value: ItemParentCacheListOptions | undefined
  ) {
    this._itemParentCacheItemByChild = value;
  }
  get catname(): string {
    return this._catname;
  }
  set catname(value: string) {
    this._catname = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemParentListOptions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemParentListOptions.AsObject {
    return {
      parentId: this.parentId,
      parent: this.parent ? this.parent.toObject() : undefined,
      itemParentParentByChild: this.itemParentParentByChild
        ? this.itemParentParentByChild.toObject()
        : undefined,
      itemId: this.itemId,
      type: this.type,
      strictType: this.strictType,
      item: this.item ? this.item.toObject() : undefined,
      itemParentCacheItemByChild: this.itemParentCacheItemByChild
        ? this.itemParentCacheItemByChild.toObject()
        : undefined,
      catname: this.catname
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemParentListOptions.AsProtobufJSON {
    return {
      parentId: this.parentId,
      parent: this.parent ? this.parent.toProtobufJSON(options) : null,
      itemParentParentByChild: this.itemParentParentByChild
        ? this.itemParentParentByChild.toProtobufJSON(options)
        : null,
      itemId: this.itemId,
      type:
        ItemParentType[
          this.type === null || this.type === undefined ? 0 : this.type
        ],
      strictType: this.strictType,
      item: this.item ? this.item.toProtobufJSON(options) : null,
      itemParentCacheItemByChild: this.itemParentCacheItemByChild
        ? this.itemParentCacheItemByChild.toProtobufJSON(options)
        : null,
      catname: this.catname
    };
  }
}
export module ItemParentListOptions {
  /**
   * Standard JavaScript object representation for ItemParentListOptions
   */
  export interface AsObject {
    parentId: string;
    parent?: ItemListOptions.AsObject;
    itemParentParentByChild?: ItemParentListOptions.AsObject;
    itemId: string;
    type: ItemParentType;
    strictType: boolean;
    item?: ItemListOptions.AsObject;
    itemParentCacheItemByChild?: ItemParentCacheListOptions.AsObject;
    catname: string;
  }

  /**
   * Protobuf JSON representation for ItemParentListOptions
   */
  export interface AsProtobufJSON {
    parentId: string;
    parent: ItemListOptions.AsProtobufJSON | null;
    itemParentParentByChild: ItemParentListOptions.AsProtobufJSON | null;
    itemId: string;
    type: string;
    strictType: boolean;
    item: ItemListOptions.AsProtobufJSON | null;
    itemParentCacheItemByChild: ItemParentCacheListOptions.AsProtobufJSON | null;
    catname: string;
  }
}

/**
 * Message implementation for goautowp.ItemParentCacheListOptions
 */
export class ItemParentCacheListOptions implements GrpcMessage {
  static id = 'goautowp.ItemParentCacheListOptions';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemParentCacheListOptions();
    ItemParentCacheListOptions.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemParentCacheListOptions) {
    _instance.itemId = _instance.itemId || '0';
    _instance.parentId = _instance.parentId || '0';
    _instance.itemsByItemId = _instance.itemsByItemId || undefined;
    _instance.itemsByParentId = _instance.itemsByParentId || undefined;
    _instance.pictureItemsByItemId =
      _instance.pictureItemsByItemId || undefined;
    _instance.pictureItemsByParentId =
      _instance.pictureItemsByParentId || undefined;
    _instance.itemParentByItemId = _instance.itemParentByItemId || undefined;
    _instance.itemParentCacheAncestorByItemId =
      _instance.itemParentCacheAncestorByItemId || undefined;
    _instance.itemVehicleTypeByItemId =
      _instance.itemVehicleTypeByItemId || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemParentCacheListOptions,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.itemId = _reader.readInt64String();
          break;
        case 2:
          _instance.parentId = _reader.readInt64String();
          break;
        case 3:
          _instance.itemsByItemId = new ItemListOptions();
          _reader.readMessage(
            _instance.itemsByItemId,
            ItemListOptions.deserializeBinaryFromReader
          );
          break;
        case 6:
          _instance.itemsByParentId = new ItemListOptions();
          _reader.readMessage(
            _instance.itemsByParentId,
            ItemListOptions.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.pictureItemsByItemId = new PictureItemListOptions();
          _reader.readMessage(
            _instance.pictureItemsByItemId,
            PictureItemListOptions.deserializeBinaryFromReader
          );
          break;
        case 8:
          _instance.pictureItemsByParentId = new PictureItemListOptions();
          _reader.readMessage(
            _instance.pictureItemsByParentId,
            PictureItemListOptions.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.itemParentByItemId = new ItemParentListOptions();
          _reader.readMessage(
            _instance.itemParentByItemId,
            ItemParentListOptions.deserializeBinaryFromReader
          );
          break;
        case 7:
          _instance.itemParentCacheAncestorByItemId = new ItemParentCacheListOptions();
          _reader.readMessage(
            _instance.itemParentCacheAncestorByItemId,
            ItemParentCacheListOptions.deserializeBinaryFromReader
          );
          break;
        case 9:
          _instance.itemVehicleTypeByItemId = new ItemVehicleTypeListOptions();
          _reader.readMessage(
            _instance.itemVehicleTypeByItemId,
            ItemVehicleTypeListOptions.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    ItemParentCacheListOptions.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItemParentCacheListOptions,
    _writer: BinaryWriter
  ) {
    if (_instance.itemId) {
      _writer.writeInt64String(1, _instance.itemId);
    }
    if (_instance.parentId) {
      _writer.writeInt64String(2, _instance.parentId);
    }
    if (_instance.itemsByItemId) {
      _writer.writeMessage(
        3,
        _instance.itemsByItemId as any,
        ItemListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.itemsByParentId) {
      _writer.writeMessage(
        6,
        _instance.itemsByParentId as any,
        ItemListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.pictureItemsByItemId) {
      _writer.writeMessage(
        4,
        _instance.pictureItemsByItemId as any,
        PictureItemListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.pictureItemsByParentId) {
      _writer.writeMessage(
        8,
        _instance.pictureItemsByParentId as any,
        PictureItemListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.itemParentByItemId) {
      _writer.writeMessage(
        5,
        _instance.itemParentByItemId as any,
        ItemParentListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.itemParentCacheAncestorByItemId) {
      _writer.writeMessage(
        7,
        _instance.itemParentCacheAncestorByItemId as any,
        ItemParentCacheListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.itemVehicleTypeByItemId) {
      _writer.writeMessage(
        9,
        _instance.itemVehicleTypeByItemId as any,
        ItemVehicleTypeListOptions.serializeBinaryToWriter
      );
    }
  }

  private _itemId: string;
  private _parentId: string;
  private _itemsByItemId?: ItemListOptions;
  private _itemsByParentId?: ItemListOptions;
  private _pictureItemsByItemId?: PictureItemListOptions;
  private _pictureItemsByParentId?: PictureItemListOptions;
  private _itemParentByItemId?: ItemParentListOptions;
  private _itemParentCacheAncestorByItemId?: ItemParentCacheListOptions;
  private _itemVehicleTypeByItemId?: ItemVehicleTypeListOptions;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemParentCacheListOptions to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemParentCacheListOptions.AsObject>) {
    _value = _value || {};
    this.itemId = _value.itemId;
    this.parentId = _value.parentId;
    this.itemsByItemId = _value.itemsByItemId
      ? new ItemListOptions(_value.itemsByItemId)
      : undefined;
    this.itemsByParentId = _value.itemsByParentId
      ? new ItemListOptions(_value.itemsByParentId)
      : undefined;
    this.pictureItemsByItemId = _value.pictureItemsByItemId
      ? new PictureItemListOptions(_value.pictureItemsByItemId)
      : undefined;
    this.pictureItemsByParentId = _value.pictureItemsByParentId
      ? new PictureItemListOptions(_value.pictureItemsByParentId)
      : undefined;
    this.itemParentByItemId = _value.itemParentByItemId
      ? new ItemParentListOptions(_value.itemParentByItemId)
      : undefined;
    this.itemParentCacheAncestorByItemId = _value.itemParentCacheAncestorByItemId
      ? new ItemParentCacheListOptions(_value.itemParentCacheAncestorByItemId)
      : undefined;
    this.itemVehicleTypeByItemId = _value.itemVehicleTypeByItemId
      ? new ItemVehicleTypeListOptions(_value.itemVehicleTypeByItemId)
      : undefined;
    ItemParentCacheListOptions.refineValues(this);
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get parentId(): string {
    return this._parentId;
  }
  set parentId(value: string) {
    this._parentId = value;
  }
  get itemsByItemId(): ItemListOptions | undefined {
    return this._itemsByItemId;
  }
  set itemsByItemId(value: ItemListOptions | undefined) {
    this._itemsByItemId = value;
  }
  get itemsByParentId(): ItemListOptions | undefined {
    return this._itemsByParentId;
  }
  set itemsByParentId(value: ItemListOptions | undefined) {
    this._itemsByParentId = value;
  }
  get pictureItemsByItemId(): PictureItemListOptions | undefined {
    return this._pictureItemsByItemId;
  }
  set pictureItemsByItemId(value: PictureItemListOptions | undefined) {
    this._pictureItemsByItemId = value;
  }
  get pictureItemsByParentId(): PictureItemListOptions | undefined {
    return this._pictureItemsByParentId;
  }
  set pictureItemsByParentId(value: PictureItemListOptions | undefined) {
    this._pictureItemsByParentId = value;
  }
  get itemParentByItemId(): ItemParentListOptions | undefined {
    return this._itemParentByItemId;
  }
  set itemParentByItemId(value: ItemParentListOptions | undefined) {
    this._itemParentByItemId = value;
  }
  get itemParentCacheAncestorByItemId():
    | ItemParentCacheListOptions
    | undefined {
    return this._itemParentCacheAncestorByItemId;
  }
  set itemParentCacheAncestorByItemId(
    value: ItemParentCacheListOptions | undefined
  ) {
    this._itemParentCacheAncestorByItemId = value;
  }
  get itemVehicleTypeByItemId(): ItemVehicleTypeListOptions | undefined {
    return this._itemVehicleTypeByItemId;
  }
  set itemVehicleTypeByItemId(value: ItemVehicleTypeListOptions | undefined) {
    this._itemVehicleTypeByItemId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemParentCacheListOptions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemParentCacheListOptions.AsObject {
    return {
      itemId: this.itemId,
      parentId: this.parentId,
      itemsByItemId: this.itemsByItemId
        ? this.itemsByItemId.toObject()
        : undefined,
      itemsByParentId: this.itemsByParentId
        ? this.itemsByParentId.toObject()
        : undefined,
      pictureItemsByItemId: this.pictureItemsByItemId
        ? this.pictureItemsByItemId.toObject()
        : undefined,
      pictureItemsByParentId: this.pictureItemsByParentId
        ? this.pictureItemsByParentId.toObject()
        : undefined,
      itemParentByItemId: this.itemParentByItemId
        ? this.itemParentByItemId.toObject()
        : undefined,
      itemParentCacheAncestorByItemId: this.itemParentCacheAncestorByItemId
        ? this.itemParentCacheAncestorByItemId.toObject()
        : undefined,
      itemVehicleTypeByItemId: this.itemVehicleTypeByItemId
        ? this.itemVehicleTypeByItemId.toObject()
        : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemParentCacheListOptions.AsProtobufJSON {
    return {
      itemId: this.itemId,
      parentId: this.parentId,
      itemsByItemId: this.itemsByItemId
        ? this.itemsByItemId.toProtobufJSON(options)
        : null,
      itemsByParentId: this.itemsByParentId
        ? this.itemsByParentId.toProtobufJSON(options)
        : null,
      pictureItemsByItemId: this.pictureItemsByItemId
        ? this.pictureItemsByItemId.toProtobufJSON(options)
        : null,
      pictureItemsByParentId: this.pictureItemsByParentId
        ? this.pictureItemsByParentId.toProtobufJSON(options)
        : null,
      itemParentByItemId: this.itemParentByItemId
        ? this.itemParentByItemId.toProtobufJSON(options)
        : null,
      itemParentCacheAncestorByItemId: this.itemParentCacheAncestorByItemId
        ? this.itemParentCacheAncestorByItemId.toProtobufJSON(options)
        : null,
      itemVehicleTypeByItemId: this.itemVehicleTypeByItemId
        ? this.itemVehicleTypeByItemId.toProtobufJSON(options)
        : null
    };
  }
}
export module ItemParentCacheListOptions {
  /**
   * Standard JavaScript object representation for ItemParentCacheListOptions
   */
  export interface AsObject {
    itemId: string;
    parentId: string;
    itemsByItemId?: ItemListOptions.AsObject;
    itemsByParentId?: ItemListOptions.AsObject;
    pictureItemsByItemId?: PictureItemListOptions.AsObject;
    pictureItemsByParentId?: PictureItemListOptions.AsObject;
    itemParentByItemId?: ItemParentListOptions.AsObject;
    itemParentCacheAncestorByItemId?: ItemParentCacheListOptions.AsObject;
    itemVehicleTypeByItemId?: ItemVehicleTypeListOptions.AsObject;
  }

  /**
   * Protobuf JSON representation for ItemParentCacheListOptions
   */
  export interface AsProtobufJSON {
    itemId: string;
    parentId: string;
    itemsByItemId: ItemListOptions.AsProtobufJSON | null;
    itemsByParentId: ItemListOptions.AsProtobufJSON | null;
    pictureItemsByItemId: PictureItemListOptions.AsProtobufJSON | null;
    pictureItemsByParentId: PictureItemListOptions.AsProtobufJSON | null;
    itemParentByItemId: ItemParentListOptions.AsProtobufJSON | null;
    itemParentCacheAncestorByItemId: ItemParentCacheListOptions.AsProtobufJSON | null;
    itemVehicleTypeByItemId: ItemVehicleTypeListOptions.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.ItemParentCacheRequest
 */
export class ItemParentCacheRequest implements GrpcMessage {
  static id = 'goautowp.ItemParentCacheRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemParentCacheRequest();
    ItemParentCacheRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemParentCacheRequest) {
    _instance.fields = _instance.fields || undefined;
    _instance.options = _instance.options || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemParentCacheRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.fields = new ItemParentCacheFields();
          _reader.readMessage(
            _instance.fields,
            ItemParentCacheFields.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.options = new ItemParentCacheListOptions();
          _reader.readMessage(
            _instance.options,
            ItemParentCacheListOptions.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    ItemParentCacheRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItemParentCacheRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.fields) {
      _writer.writeMessage(
        1,
        _instance.fields as any,
        ItemParentCacheFields.serializeBinaryToWriter
      );
    }
    if (_instance.options) {
      _writer.writeMessage(
        2,
        _instance.options as any,
        ItemParentCacheListOptions.serializeBinaryToWriter
      );
    }
  }

  private _fields?: ItemParentCacheFields;
  private _options?: ItemParentCacheListOptions;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemParentCacheRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemParentCacheRequest.AsObject>) {
    _value = _value || {};
    this.fields = _value.fields
      ? new ItemParentCacheFields(_value.fields)
      : undefined;
    this.options = _value.options
      ? new ItemParentCacheListOptions(_value.options)
      : undefined;
    ItemParentCacheRequest.refineValues(this);
  }
  get fields(): ItemParentCacheFields | undefined {
    return this._fields;
  }
  set fields(value: ItemParentCacheFields | undefined) {
    this._fields = value;
  }
  get options(): ItemParentCacheListOptions | undefined {
    return this._options;
  }
  set options(value: ItemParentCacheListOptions | undefined) {
    this._options = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemParentCacheRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemParentCacheRequest.AsObject {
    return {
      fields: this.fields ? this.fields.toObject() : undefined,
      options: this.options ? this.options.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemParentCacheRequest.AsProtobufJSON {
    return {
      fields: this.fields ? this.fields.toProtobufJSON(options) : null,
      options: this.options ? this.options.toProtobufJSON(options) : null
    };
  }
}
export module ItemParentCacheRequest {
  /**
   * Standard JavaScript object representation for ItemParentCacheRequest
   */
  export interface AsObject {
    fields?: ItemParentCacheFields.AsObject;
    options?: ItemParentCacheListOptions.AsObject;
  }

  /**
   * Protobuf JSON representation for ItemParentCacheRequest
   */
  export interface AsProtobufJSON {
    fields: ItemParentCacheFields.AsProtobufJSON | null;
    options: ItemParentCacheListOptions.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.ItemParentCacheFields
 */
export class ItemParentCacheFields implements GrpcMessage {
  static id = 'goautowp.ItemParentCacheFields';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemParentCacheFields();
    ItemParentCacheFields.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemParentCacheFields) {
    _instance.parentItem = _instance.parentItem || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemParentCacheFields,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.parentItem = new ItemsRequest();
          _reader.readMessage(
            _instance.parentItem,
            ItemsRequest.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    ItemParentCacheFields.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItemParentCacheFields,
    _writer: BinaryWriter
  ) {
    if (_instance.parentItem) {
      _writer.writeMessage(
        1,
        _instance.parentItem as any,
        ItemsRequest.serializeBinaryToWriter
      );
    }
  }

  private _parentItem?: ItemsRequest;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemParentCacheFields to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemParentCacheFields.AsObject>) {
    _value = _value || {};
    this.parentItem = _value.parentItem
      ? new ItemsRequest(_value.parentItem)
      : undefined;
    ItemParentCacheFields.refineValues(this);
  }
  get parentItem(): ItemsRequest | undefined {
    return this._parentItem;
  }
  set parentItem(value: ItemsRequest | undefined) {
    this._parentItem = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemParentCacheFields.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemParentCacheFields.AsObject {
    return {
      parentItem: this.parentItem ? this.parentItem.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemParentCacheFields.AsProtobufJSON {
    return {
      parentItem: this.parentItem
        ? this.parentItem.toProtobufJSON(options)
        : null
    };
  }
}
export module ItemParentCacheFields {
  /**
   * Standard JavaScript object representation for ItemParentCacheFields
   */
  export interface AsObject {
    parentItem?: ItemsRequest.AsObject;
  }

  /**
   * Protobuf JSON representation for ItemParentCacheFields
   */
  export interface AsProtobufJSON {
    parentItem: ItemsRequest.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.ItemParentCaches
 */
export class ItemParentCaches implements GrpcMessage {
  static id = 'goautowp.ItemParentCaches';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemParentCaches();
    ItemParentCaches.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemParentCaches) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemParentCaches,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new ItemParentCache();
          _reader.readMessage(
            messageInitializer1,
            ItemParentCache.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    ItemParentCaches.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItemParentCaches,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        ItemParentCache.serializeBinaryToWriter
      );
    }
  }

  private _items?: ItemParentCache[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemParentCaches to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemParentCaches.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new ItemParentCache(m));
    ItemParentCaches.refineValues(this);
  }
  get items(): ItemParentCache[] | undefined {
    return this._items;
  }
  set items(value: ItemParentCache[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemParentCaches.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemParentCaches.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemParentCaches.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module ItemParentCaches {
  /**
   * Standard JavaScript object representation for ItemParentCaches
   */
  export interface AsObject {
    items?: ItemParentCache.AsObject[];
  }

  /**
   * Protobuf JSON representation for ItemParentCaches
   */
  export interface AsProtobufJSON {
    items: ItemParentCache.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.ItemParentCache
 */
export class ItemParentCache implements GrpcMessage {
  static id = 'goautowp.ItemParentCache';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemParentCache();
    ItemParentCache.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemParentCache) {
    _instance.itemId = _instance.itemId || '0';
    _instance.parentId = _instance.parentId || '0';
    _instance.parentItem = _instance.parentItem || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemParentCache,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.itemId = _reader.readInt64String();
          break;
        case 2:
          _instance.parentId = _reader.readInt64String();
          break;
        case 3:
          _instance.parentItem = new APIItem();
          _reader.readMessage(
            _instance.parentItem,
            APIItem.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    ItemParentCache.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItemParentCache,
    _writer: BinaryWriter
  ) {
    if (_instance.itemId) {
      _writer.writeInt64String(1, _instance.itemId);
    }
    if (_instance.parentId) {
      _writer.writeInt64String(2, _instance.parentId);
    }
    if (_instance.parentItem) {
      _writer.writeMessage(
        3,
        _instance.parentItem as any,
        APIItem.serializeBinaryToWriter
      );
    }
  }

  private _itemId: string;
  private _parentId: string;
  private _parentItem?: APIItem;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemParentCache to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemParentCache.AsObject>) {
    _value = _value || {};
    this.itemId = _value.itemId;
    this.parentId = _value.parentId;
    this.parentItem = _value.parentItem
      ? new APIItem(_value.parentItem)
      : undefined;
    ItemParentCache.refineValues(this);
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get parentId(): string {
    return this._parentId;
  }
  set parentId(value: string) {
    this._parentId = value;
  }
  get parentItem(): APIItem | undefined {
    return this._parentItem;
  }
  set parentItem(value: APIItem | undefined) {
    this._parentItem = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemParentCache.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemParentCache.AsObject {
    return {
      itemId: this.itemId,
      parentId: this.parentId,
      parentItem: this.parentItem ? this.parentItem.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemParentCache.AsProtobufJSON {
    return {
      itemId: this.itemId,
      parentId: this.parentId,
      parentItem: this.parentItem
        ? this.parentItem.toProtobufJSON(options)
        : null
    };
  }
}
export module ItemParentCache {
  /**
   * Standard JavaScript object representation for ItemParentCache
   */
  export interface AsObject {
    itemId: string;
    parentId: string;
    parentItem?: APIItem.AsObject;
  }

  /**
   * Protobuf JSON representation for ItemParentCache
   */
  export interface AsProtobufJSON {
    itemId: string;
    parentId: string;
    parentItem: APIItem.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.ItemListOptions
 */
export class ItemListOptions implements GrpcMessage {
  static id = 'goautowp.ItemListOptions';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemListOptions();
    ItemListOptions.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemListOptions) {
    _instance.typeId = _instance.typeId || 0;
    _instance.previewPictures = _instance.previewPictures || undefined;
    _instance.noParent = _instance.noParent || false;
    _instance.catname = _instance.catname || '';
    _instance.name = _instance.name || '';
    _instance.id = _instance.id || '0';
    _instance.isConcept = _instance.isConcept || false;
    _instance.isNotConcept = _instance.isNotConcept || false;
    _instance.isNotConceptInherited = _instance.isNotConceptInherited || false;
    _instance.descendant = _instance.descendant || undefined;
    _instance.ancestor = _instance.ancestor || undefined;
    _instance.parent = _instance.parent || undefined;
    _instance.engineId = _instance.engineId || '0';
    _instance.child = _instance.child || undefined;
    _instance.parentTypesOf = _instance.parentTypesOf || 0;
    _instance.isGroup = _instance.isGroup || false;
    _instance.excludeSelfAndChilds = _instance.excludeSelfAndChilds || '0';
    _instance.autocomplete = _instance.autocomplete || '';
    _instance.suggestionsTo = _instance.suggestionsTo || '0';
    _instance.typeIds = _instance.typeIds || [];
    _instance.pictureItems = _instance.pictureItems || undefined;
    _instance.dateless = _instance.dateless || false;
    _instance.dateful = _instance.dateful || false;
    _instance.relatedGroupsOf = _instance.relatedGroupsOf || '0';
    _instance.nameExclude = _instance.nameExclude || '';
    _instance.specId = _instance.specId || '0';
    _instance.beginYear = _instance.beginYear || 0;
    _instance.endYear = _instance.endYear || 0;
    _instance.text = _instance.text || '';
    _instance.noVehicleType = _instance.noVehicleType || false;
    _instance.itemVehicleType = _instance.itemVehicleType || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemListOptions,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 3:
          _instance.typeId = _reader.readEnum();
          break;
        case 5:
          _instance.previewPictures = new PictureItemListOptions();
          _reader.readMessage(
            _instance.previewPictures,
            PictureItemListOptions.deserializeBinaryFromReader
          );
          break;
        case 7:
          _instance.noParent = _reader.readBool();
          break;
        case 8:
          _instance.catname = _reader.readString();
          break;
        case 10:
          _instance.name = _reader.readString();
          break;
        case 12:
          _instance.id = _reader.readInt64String();
          break;
        case 14:
          _instance.isConcept = _reader.readBool();
          break;
        case 24:
          _instance.isNotConcept = _reader.readBool();
          break;
        case 37:
          _instance.isNotConceptInherited = _reader.readBool();
          break;
        case 15:
          _instance.descendant = new ItemParentCacheListOptions();
          _reader.readMessage(
            _instance.descendant,
            ItemParentCacheListOptions.deserializeBinaryFromReader
          );
          break;
        case 13:
          _instance.ancestor = new ItemParentCacheListOptions();
          _reader.readMessage(
            _instance.ancestor,
            ItemParentCacheListOptions.deserializeBinaryFromReader
          );
          break;
        case 16:
          _instance.parent = new ItemParentListOptions();
          _reader.readMessage(
            _instance.parent,
            ItemParentListOptions.deserializeBinaryFromReader
          );
          break;
        case 17:
          _instance.engineId = _reader.readInt64String();
          break;
        case 18:
          _instance.child = new ItemParentListOptions();
          _reader.readMessage(
            _instance.child,
            ItemParentListOptions.deserializeBinaryFromReader
          );
          break;
        case 19:
          _instance.parentTypesOf = _reader.readEnum();
          break;
        case 20:
          _instance.isGroup = _reader.readBool();
          break;
        case 21:
          _instance.excludeSelfAndChilds = _reader.readInt64String();
          break;
        case 22:
          _instance.autocomplete = _reader.readString();
          break;
        case 23:
          _instance.suggestionsTo = _reader.readInt64String();
          break;
        case 25:
          (_instance.typeIds = _instance.typeIds || []).push(
            ...(_reader.readPackedEnum() || [])
          );
          break;
        case 26:
          _instance.pictureItems = new PictureItemListOptions();
          _reader.readMessage(
            _instance.pictureItems,
            PictureItemListOptions.deserializeBinaryFromReader
          );
          break;
        case 27:
          _instance.dateless = _reader.readBool();
          break;
        case 36:
          _instance.dateful = _reader.readBool();
          break;
        case 28:
          _instance.relatedGroupsOf = _reader.readInt64String();
          break;
        case 29:
          _instance.nameExclude = _reader.readString();
          break;
        case 30:
          _instance.specId = _reader.readInt64String();
          break;
        case 31:
          _instance.beginYear = _reader.readInt32();
          break;
        case 32:
          _instance.endYear = _reader.readInt32();
          break;
        case 33:
          _instance.text = _reader.readString();
          break;
        case 34:
          _instance.noVehicleType = _reader.readBool();
          break;
        case 35:
          _instance.itemVehicleType = new ItemVehicleTypeListOptions();
          _reader.readMessage(
            _instance.itemVehicleType,
            ItemVehicleTypeListOptions.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    ItemListOptions.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItemListOptions,
    _writer: BinaryWriter
  ) {
    if (_instance.typeId) {
      _writer.writeEnum(3, _instance.typeId);
    }
    if (_instance.previewPictures) {
      _writer.writeMessage(
        5,
        _instance.previewPictures as any,
        PictureItemListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.noParent) {
      _writer.writeBool(7, _instance.noParent);
    }
    if (_instance.catname) {
      _writer.writeString(8, _instance.catname);
    }
    if (_instance.name) {
      _writer.writeString(10, _instance.name);
    }
    if (_instance.id) {
      _writer.writeInt64String(12, _instance.id);
    }
    if (_instance.isConcept) {
      _writer.writeBool(14, _instance.isConcept);
    }
    if (_instance.isNotConcept) {
      _writer.writeBool(24, _instance.isNotConcept);
    }
    if (_instance.isNotConceptInherited) {
      _writer.writeBool(37, _instance.isNotConceptInherited);
    }
    if (_instance.descendant) {
      _writer.writeMessage(
        15,
        _instance.descendant as any,
        ItemParentCacheListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.ancestor) {
      _writer.writeMessage(
        13,
        _instance.ancestor as any,
        ItemParentCacheListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.parent) {
      _writer.writeMessage(
        16,
        _instance.parent as any,
        ItemParentListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.engineId) {
      _writer.writeInt64String(17, _instance.engineId);
    }
    if (_instance.child) {
      _writer.writeMessage(
        18,
        _instance.child as any,
        ItemParentListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.parentTypesOf) {
      _writer.writeEnum(19, _instance.parentTypesOf);
    }
    if (_instance.isGroup) {
      _writer.writeBool(20, _instance.isGroup);
    }
    if (_instance.excludeSelfAndChilds) {
      _writer.writeInt64String(21, _instance.excludeSelfAndChilds);
    }
    if (_instance.autocomplete) {
      _writer.writeString(22, _instance.autocomplete);
    }
    if (_instance.suggestionsTo) {
      _writer.writeInt64String(23, _instance.suggestionsTo);
    }
    if (_instance.typeIds && _instance.typeIds.length) {
      _writer.writePackedEnum(25, _instance.typeIds);
    }
    if (_instance.pictureItems) {
      _writer.writeMessage(
        26,
        _instance.pictureItems as any,
        PictureItemListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.dateless) {
      _writer.writeBool(27, _instance.dateless);
    }
    if (_instance.dateful) {
      _writer.writeBool(36, _instance.dateful);
    }
    if (_instance.relatedGroupsOf) {
      _writer.writeInt64String(28, _instance.relatedGroupsOf);
    }
    if (_instance.nameExclude) {
      _writer.writeString(29, _instance.nameExclude);
    }
    if (_instance.specId) {
      _writer.writeInt64String(30, _instance.specId);
    }
    if (_instance.beginYear) {
      _writer.writeInt32(31, _instance.beginYear);
    }
    if (_instance.endYear) {
      _writer.writeInt32(32, _instance.endYear);
    }
    if (_instance.text) {
      _writer.writeString(33, _instance.text);
    }
    if (_instance.noVehicleType) {
      _writer.writeBool(34, _instance.noVehicleType);
    }
    if (_instance.itemVehicleType) {
      _writer.writeMessage(
        35,
        _instance.itemVehicleType as any,
        ItemVehicleTypeListOptions.serializeBinaryToWriter
      );
    }
  }

  private _typeId: ItemType;
  private _previewPictures?: PictureItemListOptions;
  private _noParent: boolean;
  private _catname: string;
  private _name: string;
  private _id: string;
  private _isConcept: boolean;
  private _isNotConcept: boolean;
  private _isNotConceptInherited: boolean;
  private _descendant?: ItemParentCacheListOptions;
  private _ancestor?: ItemParentCacheListOptions;
  private _parent?: ItemParentListOptions;
  private _engineId: string;
  private _child?: ItemParentListOptions;
  private _parentTypesOf: ItemType;
  private _isGroup: boolean;
  private _excludeSelfAndChilds: string;
  private _autocomplete: string;
  private _suggestionsTo: string;
  private _typeIds: ItemType[];
  private _pictureItems?: PictureItemListOptions;
  private _dateless: boolean;
  private _dateful: boolean;
  private _relatedGroupsOf: string;
  private _nameExclude: string;
  private _specId: string;
  private _beginYear: number;
  private _endYear: number;
  private _text: string;
  private _noVehicleType: boolean;
  private _itemVehicleType?: ItemVehicleTypeListOptions;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemListOptions to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemListOptions.AsObject>) {
    _value = _value || {};
    this.typeId = _value.typeId;
    this.previewPictures = _value.previewPictures
      ? new PictureItemListOptions(_value.previewPictures)
      : undefined;
    this.noParent = _value.noParent;
    this.catname = _value.catname;
    this.name = _value.name;
    this.id = _value.id;
    this.isConcept = _value.isConcept;
    this.isNotConcept = _value.isNotConcept;
    this.isNotConceptInherited = _value.isNotConceptInherited;
    this.descendant = _value.descendant
      ? new ItemParentCacheListOptions(_value.descendant)
      : undefined;
    this.ancestor = _value.ancestor
      ? new ItemParentCacheListOptions(_value.ancestor)
      : undefined;
    this.parent = _value.parent
      ? new ItemParentListOptions(_value.parent)
      : undefined;
    this.engineId = _value.engineId;
    this.child = _value.child
      ? new ItemParentListOptions(_value.child)
      : undefined;
    this.parentTypesOf = _value.parentTypesOf;
    this.isGroup = _value.isGroup;
    this.excludeSelfAndChilds = _value.excludeSelfAndChilds;
    this.autocomplete = _value.autocomplete;
    this.suggestionsTo = _value.suggestionsTo;
    this.typeIds = (_value.typeIds || []).slice();
    this.pictureItems = _value.pictureItems
      ? new PictureItemListOptions(_value.pictureItems)
      : undefined;
    this.dateless = _value.dateless;
    this.dateful = _value.dateful;
    this.relatedGroupsOf = _value.relatedGroupsOf;
    this.nameExclude = _value.nameExclude;
    this.specId = _value.specId;
    this.beginYear = _value.beginYear;
    this.endYear = _value.endYear;
    this.text = _value.text;
    this.noVehicleType = _value.noVehicleType;
    this.itemVehicleType = _value.itemVehicleType
      ? new ItemVehicleTypeListOptions(_value.itemVehicleType)
      : undefined;
    ItemListOptions.refineValues(this);
  }
  get typeId(): ItemType {
    return this._typeId;
  }
  set typeId(value: ItemType) {
    this._typeId = value;
  }
  get previewPictures(): PictureItemListOptions | undefined {
    return this._previewPictures;
  }
  set previewPictures(value: PictureItemListOptions | undefined) {
    this._previewPictures = value;
  }
  get noParent(): boolean {
    return this._noParent;
  }
  set noParent(value: boolean) {
    this._noParent = value;
  }
  get catname(): string {
    return this._catname;
  }
  set catname(value: string) {
    this._catname = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get isConcept(): boolean {
    return this._isConcept;
  }
  set isConcept(value: boolean) {
    this._isConcept = value;
  }
  get isNotConcept(): boolean {
    return this._isNotConcept;
  }
  set isNotConcept(value: boolean) {
    this._isNotConcept = value;
  }
  get isNotConceptInherited(): boolean {
    return this._isNotConceptInherited;
  }
  set isNotConceptInherited(value: boolean) {
    this._isNotConceptInherited = value;
  }
  get descendant(): ItemParentCacheListOptions | undefined {
    return this._descendant;
  }
  set descendant(value: ItemParentCacheListOptions | undefined) {
    this._descendant = value;
  }
  get ancestor(): ItemParentCacheListOptions | undefined {
    return this._ancestor;
  }
  set ancestor(value: ItemParentCacheListOptions | undefined) {
    this._ancestor = value;
  }
  get parent(): ItemParentListOptions | undefined {
    return this._parent;
  }
  set parent(value: ItemParentListOptions | undefined) {
    this._parent = value;
  }
  get engineId(): string {
    return this._engineId;
  }
  set engineId(value: string) {
    this._engineId = value;
  }
  get child(): ItemParentListOptions | undefined {
    return this._child;
  }
  set child(value: ItemParentListOptions | undefined) {
    this._child = value;
  }
  get parentTypesOf(): ItemType {
    return this._parentTypesOf;
  }
  set parentTypesOf(value: ItemType) {
    this._parentTypesOf = value;
  }
  get isGroup(): boolean {
    return this._isGroup;
  }
  set isGroup(value: boolean) {
    this._isGroup = value;
  }
  get excludeSelfAndChilds(): string {
    return this._excludeSelfAndChilds;
  }
  set excludeSelfAndChilds(value: string) {
    this._excludeSelfAndChilds = value;
  }
  get autocomplete(): string {
    return this._autocomplete;
  }
  set autocomplete(value: string) {
    this._autocomplete = value;
  }
  get suggestionsTo(): string {
    return this._suggestionsTo;
  }
  set suggestionsTo(value: string) {
    this._suggestionsTo = value;
  }
  get typeIds(): ItemType[] {
    return this._typeIds;
  }
  set typeIds(value: ItemType[]) {
    this._typeIds = value;
  }
  get pictureItems(): PictureItemListOptions | undefined {
    return this._pictureItems;
  }
  set pictureItems(value: PictureItemListOptions | undefined) {
    this._pictureItems = value;
  }
  get dateless(): boolean {
    return this._dateless;
  }
  set dateless(value: boolean) {
    this._dateless = value;
  }
  get dateful(): boolean {
    return this._dateful;
  }
  set dateful(value: boolean) {
    this._dateful = value;
  }
  get relatedGroupsOf(): string {
    return this._relatedGroupsOf;
  }
  set relatedGroupsOf(value: string) {
    this._relatedGroupsOf = value;
  }
  get nameExclude(): string {
    return this._nameExclude;
  }
  set nameExclude(value: string) {
    this._nameExclude = value;
  }
  get specId(): string {
    return this._specId;
  }
  set specId(value: string) {
    this._specId = value;
  }
  get beginYear(): number {
    return this._beginYear;
  }
  set beginYear(value: number) {
    this._beginYear = value;
  }
  get endYear(): number {
    return this._endYear;
  }
  set endYear(value: number) {
    this._endYear = value;
  }
  get text(): string {
    return this._text;
  }
  set text(value: string) {
    this._text = value;
  }
  get noVehicleType(): boolean {
    return this._noVehicleType;
  }
  set noVehicleType(value: boolean) {
    this._noVehicleType = value;
  }
  get itemVehicleType(): ItemVehicleTypeListOptions | undefined {
    return this._itemVehicleType;
  }
  set itemVehicleType(value: ItemVehicleTypeListOptions | undefined) {
    this._itemVehicleType = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemListOptions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemListOptions.AsObject {
    return {
      typeId: this.typeId,
      previewPictures: this.previewPictures
        ? this.previewPictures.toObject()
        : undefined,
      noParent: this.noParent,
      catname: this.catname,
      name: this.name,
      id: this.id,
      isConcept: this.isConcept,
      isNotConcept: this.isNotConcept,
      isNotConceptInherited: this.isNotConceptInherited,
      descendant: this.descendant ? this.descendant.toObject() : undefined,
      ancestor: this.ancestor ? this.ancestor.toObject() : undefined,
      parent: this.parent ? this.parent.toObject() : undefined,
      engineId: this.engineId,
      child: this.child ? this.child.toObject() : undefined,
      parentTypesOf: this.parentTypesOf,
      isGroup: this.isGroup,
      excludeSelfAndChilds: this.excludeSelfAndChilds,
      autocomplete: this.autocomplete,
      suggestionsTo: this.suggestionsTo,
      typeIds: (this.typeIds || []).slice(),
      pictureItems: this.pictureItems
        ? this.pictureItems.toObject()
        : undefined,
      dateless: this.dateless,
      dateful: this.dateful,
      relatedGroupsOf: this.relatedGroupsOf,
      nameExclude: this.nameExclude,
      specId: this.specId,
      beginYear: this.beginYear,
      endYear: this.endYear,
      text: this.text,
      noVehicleType: this.noVehicleType,
      itemVehicleType: this.itemVehicleType
        ? this.itemVehicleType.toObject()
        : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemListOptions.AsProtobufJSON {
    return {
      typeId:
        ItemType[
          this.typeId === null || this.typeId === undefined ? 0 : this.typeId
        ],
      previewPictures: this.previewPictures
        ? this.previewPictures.toProtobufJSON(options)
        : null,
      noParent: this.noParent,
      catname: this.catname,
      name: this.name,
      id: this.id,
      isConcept: this.isConcept,
      isNotConcept: this.isNotConcept,
      isNotConceptInherited: this.isNotConceptInherited,
      descendant: this.descendant
        ? this.descendant.toProtobufJSON(options)
        : null,
      ancestor: this.ancestor ? this.ancestor.toProtobufJSON(options) : null,
      parent: this.parent ? this.parent.toProtobufJSON(options) : null,
      engineId: this.engineId,
      child: this.child ? this.child.toProtobufJSON(options) : null,
      parentTypesOf:
        ItemType[
          this.parentTypesOf === null || this.parentTypesOf === undefined
            ? 0
            : this.parentTypesOf
        ],
      isGroup: this.isGroup,
      excludeSelfAndChilds: this.excludeSelfAndChilds,
      autocomplete: this.autocomplete,
      suggestionsTo: this.suggestionsTo,
      typeIds: (this.typeIds || []).map(v => ItemType[v]),
      pictureItems: this.pictureItems
        ? this.pictureItems.toProtobufJSON(options)
        : null,
      dateless: this.dateless,
      dateful: this.dateful,
      relatedGroupsOf: this.relatedGroupsOf,
      nameExclude: this.nameExclude,
      specId: this.specId,
      beginYear: this.beginYear,
      endYear: this.endYear,
      text: this.text,
      noVehicleType: this.noVehicleType,
      itemVehicleType: this.itemVehicleType
        ? this.itemVehicleType.toProtobufJSON(options)
        : null
    };
  }
}
export module ItemListOptions {
  /**
   * Standard JavaScript object representation for ItemListOptions
   */
  export interface AsObject {
    typeId: ItemType;
    previewPictures?: PictureItemListOptions.AsObject;
    noParent: boolean;
    catname: string;
    name: string;
    id: string;
    isConcept: boolean;
    isNotConcept: boolean;
    isNotConceptInherited: boolean;
    descendant?: ItemParentCacheListOptions.AsObject;
    ancestor?: ItemParentCacheListOptions.AsObject;
    parent?: ItemParentListOptions.AsObject;
    engineId: string;
    child?: ItemParentListOptions.AsObject;
    parentTypesOf: ItemType;
    isGroup: boolean;
    excludeSelfAndChilds: string;
    autocomplete: string;
    suggestionsTo: string;
    typeIds: ItemType[];
    pictureItems?: PictureItemListOptions.AsObject;
    dateless: boolean;
    dateful: boolean;
    relatedGroupsOf: string;
    nameExclude: string;
    specId: string;
    beginYear: number;
    endYear: number;
    text: string;
    noVehicleType: boolean;
    itemVehicleType?: ItemVehicleTypeListOptions.AsObject;
  }

  /**
   * Protobuf JSON representation for ItemListOptions
   */
  export interface AsProtobufJSON {
    typeId: string;
    previewPictures: PictureItemListOptions.AsProtobufJSON | null;
    noParent: boolean;
    catname: string;
    name: string;
    id: string;
    isConcept: boolean;
    isNotConcept: boolean;
    isNotConceptInherited: boolean;
    descendant: ItemParentCacheListOptions.AsProtobufJSON | null;
    ancestor: ItemParentCacheListOptions.AsProtobufJSON | null;
    parent: ItemParentListOptions.AsProtobufJSON | null;
    engineId: string;
    child: ItemParentListOptions.AsProtobufJSON | null;
    parentTypesOf: string;
    isGroup: boolean;
    excludeSelfAndChilds: string;
    autocomplete: string;
    suggestionsTo: string;
    typeIds: string[];
    pictureItems: PictureItemListOptions.AsProtobufJSON | null;
    dateless: boolean;
    dateful: boolean;
    relatedGroupsOf: string;
    nameExclude: string;
    specId: string;
    beginYear: number;
    endYear: number;
    text: string;
    noVehicleType: boolean;
    itemVehicleType: ItemVehicleTypeListOptions.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.ItemVehicleTypeListOptions
 */
export class ItemVehicleTypeListOptions implements GrpcMessage {
  static id = 'goautowp.ItemVehicleTypeListOptions';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemVehicleTypeListOptions();
    ItemVehicleTypeListOptions.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemVehicleTypeListOptions) {
    _instance.vehicleTypeId = _instance.vehicleTypeId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemVehicleTypeListOptions,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.vehicleTypeId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    ItemVehicleTypeListOptions.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItemVehicleTypeListOptions,
    _writer: BinaryWriter
  ) {
    if (_instance.vehicleTypeId) {
      _writer.writeInt64String(1, _instance.vehicleTypeId);
    }
  }

  private _vehicleTypeId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemVehicleTypeListOptions to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemVehicleTypeListOptions.AsObject>) {
    _value = _value || {};
    this.vehicleTypeId = _value.vehicleTypeId;
    ItemVehicleTypeListOptions.refineValues(this);
  }
  get vehicleTypeId(): string {
    return this._vehicleTypeId;
  }
  set vehicleTypeId(value: string) {
    this._vehicleTypeId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemVehicleTypeListOptions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemVehicleTypeListOptions.AsObject {
    return {
      vehicleTypeId: this.vehicleTypeId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemVehicleTypeListOptions.AsProtobufJSON {
    return {
      vehicleTypeId: this.vehicleTypeId
    };
  }
}
export module ItemVehicleTypeListOptions {
  /**
   * Standard JavaScript object representation for ItemVehicleTypeListOptions
   */
  export interface AsObject {
    vehicleTypeId: string;
  }

  /**
   * Protobuf JSON representation for ItemVehicleTypeListOptions
   */
  export interface AsProtobufJSON {
    vehicleTypeId: string;
  }
}

/**
 * Message implementation for goautowp.GetTreeRequest
 */
export class GetTreeRequest implements GrpcMessage {
  static id = 'goautowp.GetTreeRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetTreeRequest();
    GetTreeRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetTreeRequest) {
    _instance.id = _instance.id || '0';
    _instance.language = _instance.language || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetTreeRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.language = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    GetTreeRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetTreeRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.language) {
      _writer.writeString(2, _instance.language);
    }
  }

  private _id: string;
  private _language: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetTreeRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetTreeRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.language = _value.language;
    GetTreeRequest.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetTreeRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetTreeRequest.AsObject {
    return {
      id: this.id,
      language: this.language
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetTreeRequest.AsProtobufJSON {
    return {
      id: this.id,
      language: this.language
    };
  }
}
export module GetTreeRequest {
  /**
   * Standard JavaScript object representation for GetTreeRequest
   */
  export interface AsObject {
    id: string;
    language: string;
  }

  /**
   * Protobuf JSON representation for GetTreeRequest
   */
  export interface AsProtobufJSON {
    id: string;
    language: string;
  }
}

/**
 * Message implementation for goautowp.APITreeItem
 */
export class APITreeItem implements GrpcMessage {
  static id = 'goautowp.APITreeItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APITreeItem();
    APITreeItem.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APITreeItem) {
    _instance.id = _instance.id || '0';
    _instance.nameHtml = _instance.nameHtml || '';
    _instance.childs = _instance.childs || [];
    _instance.type = _instance.type || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APITreeItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.nameHtml = _reader.readString();
          break;
        case 3:
          const messageInitializer3 = new APITreeItem();
          _reader.readMessage(
            messageInitializer3,
            APITreeItem.deserializeBinaryFromReader
          );
          (_instance.childs = _instance.childs || []).push(messageInitializer3);
          break;
        case 4:
          _instance.type = _reader.readEnum();
          break;
        default:
          _reader.skipField();
      }
    }

    APITreeItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APITreeItem,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.nameHtml) {
      _writer.writeString(2, _instance.nameHtml);
    }
    if (_instance.childs && _instance.childs.length) {
      _writer.writeRepeatedMessage(
        3,
        _instance.childs as any,
        APITreeItem.serializeBinaryToWriter
      );
    }
    if (_instance.type) {
      _writer.writeEnum(4, _instance.type);
    }
  }

  private _id: string;
  private _nameHtml: string;
  private _childs?: APITreeItem[];
  private _type: ItemParentType;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APITreeItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<APITreeItem.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.nameHtml = _value.nameHtml;
    this.childs = (_value.childs || []).map(m => new APITreeItem(m));
    this.type = _value.type;
    APITreeItem.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get nameHtml(): string {
    return this._nameHtml;
  }
  set nameHtml(value: string) {
    this._nameHtml = value;
  }
  get childs(): APITreeItem[] | undefined {
    return this._childs;
  }
  set childs(value: APITreeItem[] | undefined) {
    this._childs = value;
  }
  get type(): ItemParentType {
    return this._type;
  }
  set type(value: ItemParentType) {
    this._type = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APITreeItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APITreeItem.AsObject {
    return {
      id: this.id,
      nameHtml: this.nameHtml,
      childs: (this.childs || []).map(m => m.toObject()),
      type: this.type
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APITreeItem.AsProtobufJSON {
    return {
      id: this.id,
      nameHtml: this.nameHtml,
      childs: (this.childs || []).map(m => m.toProtobufJSON(options)),
      type:
        ItemParentType[
          this.type === null || this.type === undefined ? 0 : this.type
        ]
    };
  }
}
export module APITreeItem {
  /**
   * Standard JavaScript object representation for APITreeItem
   */
  export interface AsObject {
    id: string;
    nameHtml: string;
    childs?: APITreeItem.AsObject[];
    type: ItemParentType;
  }

  /**
   * Protobuf JSON representation for APITreeItem
   */
  export interface AsProtobufJSON {
    id: string;
    nameHtml: string;
    childs: APITreeItem.AsProtobufJSON[] | null;
    type: string;
  }
}

/**
 * Message implementation for goautowp.APIItem
 */
export class APIItem implements GrpcMessage {
  static id = 'goautowp.APIItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIItem();
    APIItem.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIItem) {
    _instance.id = _instance.id || '0';
    _instance.catname = _instance.catname || '';
    _instance.nameOnly = _instance.nameOnly || '';
    _instance.nameText = _instance.nameText || '';
    _instance.nameHtml = _instance.nameHtml || '';
    _instance.nameDefault = _instance.nameDefault || '';
    _instance.descendantsCount = _instance.descendantsCount || 0;
    _instance.engineItemId = _instance.engineItemId || '0';
    _instance.itemTypeId = _instance.itemTypeId || 0;
    _instance.description = _instance.description || '';
    _instance.isConcept = _instance.isConcept || false;
    _instance.isConceptInherit = _instance.isConceptInherit || false;
    _instance.specId = _instance.specId || 0;
    _instance.specInherit = _instance.specInherit || false;
    _instance.fullText = _instance.fullText || '';
    _instance.descendantPicturesCount = _instance.descendantPicturesCount || 0;
    _instance.inboxPicturesCount = _instance.inboxPicturesCount || 0;
    _instance.acceptedPicturesCount = _instance.acceptedPicturesCount || 0;
    _instance.exactPicturesCount = _instance.exactPicturesCount || 0;
    _instance.childsCount = _instance.childsCount || 0;
    _instance.parentsCount = _instance.parentsCount || 0;
    _instance.descendantTwinsGroupsCount =
      _instance.descendantTwinsGroupsCount || 0;
    _instance.fullName = _instance.fullName || '';
    _instance.logo = _instance.logo || undefined;
    _instance.logo120 = _instance.logo120 || undefined;
    _instance.mostsActive = _instance.mostsActive || false;
    _instance.commentsAttentionsCount = _instance.commentsAttentionsCount || 0;
    _instance.isCompilesItemOfDay = _instance.isCompilesItemOfDay || false;
    _instance.brandicon = _instance.brandicon || undefined;
    _instance.attrZoneId = _instance.attrZoneId || '0';
    _instance.engineInherit = _instance.engineInherit || false;
    _instance.location = _instance.location || undefined;
    _instance.hasChildSpecs = _instance.hasChildSpecs || false;
    _instance.hasSpecs = _instance.hasSpecs || false;
    _instance.produced = _instance.produced || undefined;
    _instance.producedExactly = _instance.producedExactly || false;
    _instance.otherNames = _instance.otherNames || [];
    _instance.design = _instance.design || undefined;
    _instance.specsRoute = _instance.specsRoute || [];
    _instance.isGroup = _instance.isGroup || false;
    _instance.childsCounts = _instance.childsCounts || [];
    _instance.publicRoutes = _instance.publicRoutes || [];
    _instance.pictureItems = _instance.pictureItems || undefined;
    _instance.altNames = _instance.altNames || [];
    _instance.route = _instance.route || [];
    _instance.links = _instance.links || undefined;
    _instance.hasText = _instance.hasText || false;
    _instance.categories = _instance.categories || [];
    _instance.twins = _instance.twins || [];
    _instance.canEditSpecs = _instance.canEditSpecs || false;
    _instance.itemParentChilds = _instance.itemParentChilds || undefined;
    _instance.commentsCount = _instance.commentsCount || 0;
    _instance.previewPictures = _instance.previewPictures || undefined;
    _instance.engineVehicles = _instance.engineVehicles || [];
    _instance.relatedGroupPictures = _instance.relatedGroupPictures || [];
    _instance.itemOfDayPictures = _instance.itemOfDayPictures || [];
    _instance.beginYear = _instance.beginYear || 0;
    _instance.endYear = _instance.endYear || 0;
    _instance.beginMonth = _instance.beginMonth || 0;
    _instance.endMonth = _instance.endMonth || 0;
    _instance.beginModelYear = _instance.beginModelYear || 0;
    _instance.endModelYear = _instance.endModelYear || 0;
    _instance.beginModelYearFraction = _instance.beginModelYearFraction || '';
    _instance.endModelYearFraction = _instance.endModelYearFraction || '';
    _instance.body = _instance.body || '';
    _instance.name = _instance.name || '';
    _instance.today = _instance.today || undefined;
    _instance.engineVehiclesCount = _instance.engineVehiclesCount || 0;
    _instance.itemLanguageCount = _instance.itemLanguageCount || 0;
    _instance.linksCount = _instance.linksCount || 0;
    _instance.specificationsCount = _instance.specificationsCount || 0;
    _instance.subscription = _instance.subscription || false;
    _instance.specsContributors = _instance.specsContributors || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.catname = _reader.readString();
          break;
        case 3:
          _instance.nameOnly = _reader.readString();
          break;
        case 4:
          _instance.nameText = _reader.readString();
          break;
        case 5:
          _instance.nameHtml = _reader.readString();
          break;
        case 38:
          _instance.nameDefault = _reader.readString();
          break;
        case 6:
          _instance.descendantsCount = _reader.readInt32();
          break;
        case 7:
          _instance.engineItemId = _reader.readInt64String();
          break;
        case 8:
          _instance.itemTypeId = _reader.readEnum();
          break;
        case 9:
          _instance.description = _reader.readString();
          break;
        case 10:
          _instance.isConcept = _reader.readBool();
          break;
        case 11:
          _instance.isConceptInherit = _reader.readBool();
          break;
        case 12:
          _instance.specId = _reader.readInt32();
          break;
        case 72:
          _instance.specInherit = _reader.readBool();
          break;
        case 13:
          _instance.fullText = _reader.readString();
          break;
        case 14:
          _instance.descendantPicturesCount = _reader.readInt32();
          break;
        case 17:
          _instance.inboxPicturesCount = _reader.readInt32();
          break;
        case 27:
          _instance.acceptedPicturesCount = _reader.readInt32();
          break;
        case 69:
          _instance.exactPicturesCount = _reader.readInt32();
          break;
        case 15:
          _instance.childsCount = _reader.readInt32();
          break;
        case 68:
          _instance.parentsCount = _reader.readInt32();
          break;
        case 16:
          _instance.descendantTwinsGroupsCount = _reader.readInt32();
          break;
        case 18:
          _instance.fullName = _reader.readString();
          break;
        case 67:
          _instance.logo = new APIImage();
          _reader.readMessage(
            _instance.logo,
            APIImage.deserializeBinaryFromReader
          );
          break;
        case 19:
          _instance.logo120 = new APIImage();
          _reader.readMessage(
            _instance.logo120,
            APIImage.deserializeBinaryFromReader
          );
          break;
        case 20:
          _instance.mostsActive = _reader.readBool();
          break;
        case 21:
          _instance.commentsAttentionsCount = _reader.readInt32();
          break;
        case 22:
          _instance.isCompilesItemOfDay = _reader.readBool();
          break;
        case 23:
          _instance.brandicon = new APIImage();
          _reader.readMessage(
            _instance.brandicon,
            APIImage.deserializeBinaryFromReader
          );
          break;
        case 24:
          _instance.attrZoneId = _reader.readInt64String();
          break;
        case 25:
          _instance.engineInherit = _reader.readBool();
          break;
        case 26:
          _instance.location = new googleType009.LatLng();
          _reader.readMessage(
            _instance.location,
            googleType009.LatLng.deserializeBinaryFromReader
          );
          break;
        case 28:
          _instance.hasChildSpecs = _reader.readBool();
          break;
        case 29:
          _instance.hasSpecs = _reader.readBool();
          break;
        case 74:
          _instance.produced = new googleProtobuf005.Int32Value();
          _reader.readMessage(
            _instance.produced,
            googleProtobuf005.Int32Value.deserializeBinaryFromReader
          );
          break;
        case 31:
          _instance.producedExactly = _reader.readBool();
          break;
        case 32:
          (_instance.otherNames = _instance.otherNames || []).push(
            _reader.readString()
          );
          break;
        case 33:
          _instance.design = new Design();
          _reader.readMessage(
            _instance.design,
            Design.deserializeBinaryFromReader
          );
          break;
        case 34:
          (_instance.specsRoute = _instance.specsRoute || []).push(
            _reader.readString()
          );
          break;
        case 35:
          _instance.isGroup = _reader.readBool();
          break;
        case 36:
          const messageInitializer36 = new ChildsCount();
          _reader.readMessage(
            messageInitializer36,
            ChildsCount.deserializeBinaryFromReader
          );
          (_instance.childsCounts = _instance.childsCounts || []).push(
            messageInitializer36
          );
          break;
        case 37:
          const messageInitializer37 = new PublicRoute();
          _reader.readMessage(
            messageInitializer37,
            PublicRoute.deserializeBinaryFromReader
          );
          (_instance.publicRoutes = _instance.publicRoutes || []).push(
            messageInitializer37
          );
          break;
        case 39:
          _instance.pictureItems = new PictureItems();
          _reader.readMessage(
            _instance.pictureItems,
            PictureItems.deserializeBinaryFromReader
          );
          break;
        case 40:
          const messageInitializer40 = new AltName();
          _reader.readMessage(
            messageInitializer40,
            AltName.deserializeBinaryFromReader
          );
          (_instance.altNames = _instance.altNames || []).push(
            messageInitializer40
          );
          break;
        case 41:
          (_instance.route = _instance.route || []).push(_reader.readString());
          break;
        case 42:
          _instance.links = new ItemLinks();
          _reader.readMessage(
            _instance.links,
            ItemLinks.deserializeBinaryFromReader
          );
          break;
        case 43:
          _instance.hasText = _reader.readBool();
          break;
        case 44:
          const messageInitializer44 = new APIItem();
          _reader.readMessage(
            messageInitializer44,
            APIItem.deserializeBinaryFromReader
          );
          (_instance.categories = _instance.categories || []).push(
            messageInitializer44
          );
          break;
        case 45:
          const messageInitializer45 = new APIItem();
          _reader.readMessage(
            messageInitializer45,
            APIItem.deserializeBinaryFromReader
          );
          (_instance.twins = _instance.twins || []).push(messageInitializer45);
          break;
        case 46:
          _instance.canEditSpecs = _reader.readBool();
          break;
        case 47:
          _instance.itemParentChilds = new ItemParents();
          _reader.readMessage(
            _instance.itemParentChilds,
            ItemParents.deserializeBinaryFromReader
          );
          break;
        case 48:
          _instance.commentsCount = _reader.readInt32();
          break;
        case 49:
          _instance.previewPictures = new PreviewPictures();
          _reader.readMessage(
            _instance.previewPictures,
            PreviewPictures.deserializeBinaryFromReader
          );
          break;
        case 50:
          const messageInitializer50 = new APIItem();
          _reader.readMessage(
            messageInitializer50,
            APIItem.deserializeBinaryFromReader
          );
          (_instance.engineVehicles = _instance.engineVehicles || []).push(
            messageInitializer50
          );
          break;
        case 51:
          const messageInitializer51 = new RelatedGroupPicture();
          _reader.readMessage(
            messageInitializer51,
            RelatedGroupPicture.deserializeBinaryFromReader
          );
          (_instance.relatedGroupPictures =
            _instance.relatedGroupPictures || []).push(messageInitializer51);
          break;
        case 52:
          const messageInitializer52 = new ItemOfDayPicture();
          _reader.readMessage(
            messageInitializer52,
            ItemOfDayPicture.deserializeBinaryFromReader
          );
          (_instance.itemOfDayPictures =
            _instance.itemOfDayPictures || []).push(messageInitializer52);
          break;
        case 53:
          _instance.beginYear = _reader.readInt32();
          break;
        case 54:
          _instance.endYear = _reader.readInt32();
          break;
        case 55:
          _instance.beginMonth = _reader.readInt32();
          break;
        case 56:
          _instance.endMonth = _reader.readInt32();
          break;
        case 57:
          _instance.beginModelYear = _reader.readInt32();
          break;
        case 58:
          _instance.endModelYear = _reader.readInt32();
          break;
        case 59:
          _instance.beginModelYearFraction = _reader.readString();
          break;
        case 60:
          _instance.endModelYearFraction = _reader.readString();
          break;
        case 61:
          _instance.body = _reader.readString();
          break;
        case 62:
          _instance.name = _reader.readString();
          break;
        case 63:
          _instance.today = new googleProtobuf005.BoolValue();
          _reader.readMessage(
            _instance.today,
            googleProtobuf005.BoolValue.deserializeBinaryFromReader
          );
          break;
        case 64:
          _instance.engineVehiclesCount = _reader.readInt32();
          break;
        case 65:
          _instance.itemLanguageCount = _reader.readInt32();
          break;
        case 66:
          _instance.linksCount = _reader.readInt32();
          break;
        case 70:
          _instance.specificationsCount = _reader.readInt32();
          break;
        case 71:
          _instance.subscription = _reader.readBool();
          break;
        case 73:
          const messageInitializer73 = new SpecsContributor();
          _reader.readMessage(
            messageInitializer73,
            SpecsContributor.deserializeBinaryFromReader
          );
          (_instance.specsContributors =
            _instance.specsContributors || []).push(messageInitializer73);
          break;
        default:
          _reader.skipField();
      }
    }

    APIItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: APIItem, _writer: BinaryWriter) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.catname) {
      _writer.writeString(2, _instance.catname);
    }
    if (_instance.nameOnly) {
      _writer.writeString(3, _instance.nameOnly);
    }
    if (_instance.nameText) {
      _writer.writeString(4, _instance.nameText);
    }
    if (_instance.nameHtml) {
      _writer.writeString(5, _instance.nameHtml);
    }
    if (_instance.nameDefault) {
      _writer.writeString(38, _instance.nameDefault);
    }
    if (_instance.descendantsCount) {
      _writer.writeInt32(6, _instance.descendantsCount);
    }
    if (_instance.engineItemId) {
      _writer.writeInt64String(7, _instance.engineItemId);
    }
    if (_instance.itemTypeId) {
      _writer.writeEnum(8, _instance.itemTypeId);
    }
    if (_instance.description) {
      _writer.writeString(9, _instance.description);
    }
    if (_instance.isConcept) {
      _writer.writeBool(10, _instance.isConcept);
    }
    if (_instance.isConceptInherit) {
      _writer.writeBool(11, _instance.isConceptInherit);
    }
    if (_instance.specId) {
      _writer.writeInt32(12, _instance.specId);
    }
    if (_instance.specInherit) {
      _writer.writeBool(72, _instance.specInherit);
    }
    if (_instance.fullText) {
      _writer.writeString(13, _instance.fullText);
    }
    if (_instance.descendantPicturesCount) {
      _writer.writeInt32(14, _instance.descendantPicturesCount);
    }
    if (_instance.inboxPicturesCount) {
      _writer.writeInt32(17, _instance.inboxPicturesCount);
    }
    if (_instance.acceptedPicturesCount) {
      _writer.writeInt32(27, _instance.acceptedPicturesCount);
    }
    if (_instance.exactPicturesCount) {
      _writer.writeInt32(69, _instance.exactPicturesCount);
    }
    if (_instance.childsCount) {
      _writer.writeInt32(15, _instance.childsCount);
    }
    if (_instance.parentsCount) {
      _writer.writeInt32(68, _instance.parentsCount);
    }
    if (_instance.descendantTwinsGroupsCount) {
      _writer.writeInt32(16, _instance.descendantTwinsGroupsCount);
    }
    if (_instance.fullName) {
      _writer.writeString(18, _instance.fullName);
    }
    if (_instance.logo) {
      _writer.writeMessage(
        67,
        _instance.logo as any,
        APIImage.serializeBinaryToWriter
      );
    }
    if (_instance.logo120) {
      _writer.writeMessage(
        19,
        _instance.logo120 as any,
        APIImage.serializeBinaryToWriter
      );
    }
    if (_instance.mostsActive) {
      _writer.writeBool(20, _instance.mostsActive);
    }
    if (_instance.commentsAttentionsCount) {
      _writer.writeInt32(21, _instance.commentsAttentionsCount);
    }
    if (_instance.isCompilesItemOfDay) {
      _writer.writeBool(22, _instance.isCompilesItemOfDay);
    }
    if (_instance.brandicon) {
      _writer.writeMessage(
        23,
        _instance.brandicon as any,
        APIImage.serializeBinaryToWriter
      );
    }
    if (_instance.attrZoneId) {
      _writer.writeInt64String(24, _instance.attrZoneId);
    }
    if (_instance.engineInherit) {
      _writer.writeBool(25, _instance.engineInherit);
    }
    if (_instance.location) {
      _writer.writeMessage(
        26,
        _instance.location as any,
        googleType009.LatLng.serializeBinaryToWriter
      );
    }
    if (_instance.hasChildSpecs) {
      _writer.writeBool(28, _instance.hasChildSpecs);
    }
    if (_instance.hasSpecs) {
      _writer.writeBool(29, _instance.hasSpecs);
    }
    if (_instance.produced) {
      _writer.writeMessage(
        74,
        _instance.produced as any,
        googleProtobuf005.Int32Value.serializeBinaryToWriter
      );
    }
    if (_instance.producedExactly) {
      _writer.writeBool(31, _instance.producedExactly);
    }
    if (_instance.otherNames && _instance.otherNames.length) {
      _writer.writeRepeatedString(32, _instance.otherNames);
    }
    if (_instance.design) {
      _writer.writeMessage(
        33,
        _instance.design as any,
        Design.serializeBinaryToWriter
      );
    }
    if (_instance.specsRoute && _instance.specsRoute.length) {
      _writer.writeRepeatedString(34, _instance.specsRoute);
    }
    if (_instance.isGroup) {
      _writer.writeBool(35, _instance.isGroup);
    }
    if (_instance.childsCounts && _instance.childsCounts.length) {
      _writer.writeRepeatedMessage(
        36,
        _instance.childsCounts as any,
        ChildsCount.serializeBinaryToWriter
      );
    }
    if (_instance.publicRoutes && _instance.publicRoutes.length) {
      _writer.writeRepeatedMessage(
        37,
        _instance.publicRoutes as any,
        PublicRoute.serializeBinaryToWriter
      );
    }
    if (_instance.pictureItems) {
      _writer.writeMessage(
        39,
        _instance.pictureItems as any,
        PictureItems.serializeBinaryToWriter
      );
    }
    if (_instance.altNames && _instance.altNames.length) {
      _writer.writeRepeatedMessage(
        40,
        _instance.altNames as any,
        AltName.serializeBinaryToWriter
      );
    }
    if (_instance.route && _instance.route.length) {
      _writer.writeRepeatedString(41, _instance.route);
    }
    if (_instance.links) {
      _writer.writeMessage(
        42,
        _instance.links as any,
        ItemLinks.serializeBinaryToWriter
      );
    }
    if (_instance.hasText) {
      _writer.writeBool(43, _instance.hasText);
    }
    if (_instance.categories && _instance.categories.length) {
      _writer.writeRepeatedMessage(
        44,
        _instance.categories as any,
        APIItem.serializeBinaryToWriter
      );
    }
    if (_instance.twins && _instance.twins.length) {
      _writer.writeRepeatedMessage(
        45,
        _instance.twins as any,
        APIItem.serializeBinaryToWriter
      );
    }
    if (_instance.canEditSpecs) {
      _writer.writeBool(46, _instance.canEditSpecs);
    }
    if (_instance.itemParentChilds) {
      _writer.writeMessage(
        47,
        _instance.itemParentChilds as any,
        ItemParents.serializeBinaryToWriter
      );
    }
    if (_instance.commentsCount) {
      _writer.writeInt32(48, _instance.commentsCount);
    }
    if (_instance.previewPictures) {
      _writer.writeMessage(
        49,
        _instance.previewPictures as any,
        PreviewPictures.serializeBinaryToWriter
      );
    }
    if (_instance.engineVehicles && _instance.engineVehicles.length) {
      _writer.writeRepeatedMessage(
        50,
        _instance.engineVehicles as any,
        APIItem.serializeBinaryToWriter
      );
    }
    if (
      _instance.relatedGroupPictures &&
      _instance.relatedGroupPictures.length
    ) {
      _writer.writeRepeatedMessage(
        51,
        _instance.relatedGroupPictures as any,
        RelatedGroupPicture.serializeBinaryToWriter
      );
    }
    if (_instance.itemOfDayPictures && _instance.itemOfDayPictures.length) {
      _writer.writeRepeatedMessage(
        52,
        _instance.itemOfDayPictures as any,
        ItemOfDayPicture.serializeBinaryToWriter
      );
    }
    if (_instance.beginYear) {
      _writer.writeInt32(53, _instance.beginYear);
    }
    if (_instance.endYear) {
      _writer.writeInt32(54, _instance.endYear);
    }
    if (_instance.beginMonth) {
      _writer.writeInt32(55, _instance.beginMonth);
    }
    if (_instance.endMonth) {
      _writer.writeInt32(56, _instance.endMonth);
    }
    if (_instance.beginModelYear) {
      _writer.writeInt32(57, _instance.beginModelYear);
    }
    if (_instance.endModelYear) {
      _writer.writeInt32(58, _instance.endModelYear);
    }
    if (_instance.beginModelYearFraction) {
      _writer.writeString(59, _instance.beginModelYearFraction);
    }
    if (_instance.endModelYearFraction) {
      _writer.writeString(60, _instance.endModelYearFraction);
    }
    if (_instance.body) {
      _writer.writeString(61, _instance.body);
    }
    if (_instance.name) {
      _writer.writeString(62, _instance.name);
    }
    if (_instance.today) {
      _writer.writeMessage(
        63,
        _instance.today as any,
        googleProtobuf005.BoolValue.serializeBinaryToWriter
      );
    }
    if (_instance.engineVehiclesCount) {
      _writer.writeInt32(64, _instance.engineVehiclesCount);
    }
    if (_instance.itemLanguageCount) {
      _writer.writeInt32(65, _instance.itemLanguageCount);
    }
    if (_instance.linksCount) {
      _writer.writeInt32(66, _instance.linksCount);
    }
    if (_instance.specificationsCount) {
      _writer.writeInt32(70, _instance.specificationsCount);
    }
    if (_instance.subscription) {
      _writer.writeBool(71, _instance.subscription);
    }
    if (_instance.specsContributors && _instance.specsContributors.length) {
      _writer.writeRepeatedMessage(
        73,
        _instance.specsContributors as any,
        SpecsContributor.serializeBinaryToWriter
      );
    }
  }

  private _id: string;
  private _catname: string;
  private _nameOnly: string;
  private _nameText: string;
  private _nameHtml: string;
  private _nameDefault: string;
  private _descendantsCount: number;
  private _engineItemId: string;
  private _itemTypeId: ItemType;
  private _description: string;
  private _isConcept: boolean;
  private _isConceptInherit: boolean;
  private _specId: number;
  private _specInherit: boolean;
  private _fullText: string;
  private _descendantPicturesCount: number;
  private _inboxPicturesCount: number;
  private _acceptedPicturesCount: number;
  private _exactPicturesCount: number;
  private _childsCount: number;
  private _parentsCount: number;
  private _descendantTwinsGroupsCount: number;
  private _fullName: string;
  private _logo?: APIImage;
  private _logo120?: APIImage;
  private _mostsActive: boolean;
  private _commentsAttentionsCount: number;
  private _isCompilesItemOfDay: boolean;
  private _brandicon?: APIImage;
  private _attrZoneId: string;
  private _engineInherit: boolean;
  private _location?: googleType009.LatLng;
  private _hasChildSpecs: boolean;
  private _hasSpecs: boolean;
  private _produced?: googleProtobuf005.Int32Value;
  private _producedExactly: boolean;
  private _otherNames: string[];
  private _design?: Design;
  private _specsRoute: string[];
  private _isGroup: boolean;
  private _childsCounts?: ChildsCount[];
  private _publicRoutes?: PublicRoute[];
  private _pictureItems?: PictureItems;
  private _altNames?: AltName[];
  private _route: string[];
  private _links?: ItemLinks;
  private _hasText: boolean;
  private _categories?: APIItem[];
  private _twins?: APIItem[];
  private _canEditSpecs: boolean;
  private _itemParentChilds?: ItemParents;
  private _commentsCount: number;
  private _previewPictures?: PreviewPictures;
  private _engineVehicles?: APIItem[];
  private _relatedGroupPictures?: RelatedGroupPicture[];
  private _itemOfDayPictures?: ItemOfDayPicture[];
  private _beginYear: number;
  private _endYear: number;
  private _beginMonth: number;
  private _endMonth: number;
  private _beginModelYear: number;
  private _endModelYear: number;
  private _beginModelYearFraction: string;
  private _endModelYearFraction: string;
  private _body: string;
  private _name: string;
  private _today?: googleProtobuf005.BoolValue;
  private _engineVehiclesCount: number;
  private _itemLanguageCount: number;
  private _linksCount: number;
  private _specificationsCount: number;
  private _subscription: boolean;
  private _specsContributors?: SpecsContributor[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIItem.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.catname = _value.catname;
    this.nameOnly = _value.nameOnly;
    this.nameText = _value.nameText;
    this.nameHtml = _value.nameHtml;
    this.nameDefault = _value.nameDefault;
    this.descendantsCount = _value.descendantsCount;
    this.engineItemId = _value.engineItemId;
    this.itemTypeId = _value.itemTypeId;
    this.description = _value.description;
    this.isConcept = _value.isConcept;
    this.isConceptInherit = _value.isConceptInherit;
    this.specId = _value.specId;
    this.specInherit = _value.specInherit;
    this.fullText = _value.fullText;
    this.descendantPicturesCount = _value.descendantPicturesCount;
    this.inboxPicturesCount = _value.inboxPicturesCount;
    this.acceptedPicturesCount = _value.acceptedPicturesCount;
    this.exactPicturesCount = _value.exactPicturesCount;
    this.childsCount = _value.childsCount;
    this.parentsCount = _value.parentsCount;
    this.descendantTwinsGroupsCount = _value.descendantTwinsGroupsCount;
    this.fullName = _value.fullName;
    this.logo = _value.logo ? new APIImage(_value.logo) : undefined;
    this.logo120 = _value.logo120 ? new APIImage(_value.logo120) : undefined;
    this.mostsActive = _value.mostsActive;
    this.commentsAttentionsCount = _value.commentsAttentionsCount;
    this.isCompilesItemOfDay = _value.isCompilesItemOfDay;
    this.brandicon = _value.brandicon
      ? new APIImage(_value.brandicon)
      : undefined;
    this.attrZoneId = _value.attrZoneId;
    this.engineInherit = _value.engineInherit;
    this.location = _value.location
      ? new googleType009.LatLng(_value.location)
      : undefined;
    this.hasChildSpecs = _value.hasChildSpecs;
    this.hasSpecs = _value.hasSpecs;
    this.produced = _value.produced
      ? new googleProtobuf005.Int32Value(_value.produced)
      : undefined;
    this.producedExactly = _value.producedExactly;
    this.otherNames = (_value.otherNames || []).slice();
    this.design = _value.design ? new Design(_value.design) : undefined;
    this.specsRoute = (_value.specsRoute || []).slice();
    this.isGroup = _value.isGroup;
    this.childsCounts = (_value.childsCounts || []).map(
      m => new ChildsCount(m)
    );
    this.publicRoutes = (_value.publicRoutes || []).map(
      m => new PublicRoute(m)
    );
    this.pictureItems = _value.pictureItems
      ? new PictureItems(_value.pictureItems)
      : undefined;
    this.altNames = (_value.altNames || []).map(m => new AltName(m));
    this.route = (_value.route || []).slice();
    this.links = _value.links ? new ItemLinks(_value.links) : undefined;
    this.hasText = _value.hasText;
    this.categories = (_value.categories || []).map(m => new APIItem(m));
    this.twins = (_value.twins || []).map(m => new APIItem(m));
    this.canEditSpecs = _value.canEditSpecs;
    this.itemParentChilds = _value.itemParentChilds
      ? new ItemParents(_value.itemParentChilds)
      : undefined;
    this.commentsCount = _value.commentsCount;
    this.previewPictures = _value.previewPictures
      ? new PreviewPictures(_value.previewPictures)
      : undefined;
    this.engineVehicles = (_value.engineVehicles || []).map(
      m => new APIItem(m)
    );
    this.relatedGroupPictures = (_value.relatedGroupPictures || []).map(
      m => new RelatedGroupPicture(m)
    );
    this.itemOfDayPictures = (_value.itemOfDayPictures || []).map(
      m => new ItemOfDayPicture(m)
    );
    this.beginYear = _value.beginYear;
    this.endYear = _value.endYear;
    this.beginMonth = _value.beginMonth;
    this.endMonth = _value.endMonth;
    this.beginModelYear = _value.beginModelYear;
    this.endModelYear = _value.endModelYear;
    this.beginModelYearFraction = _value.beginModelYearFraction;
    this.endModelYearFraction = _value.endModelYearFraction;
    this.body = _value.body;
    this.name = _value.name;
    this.today = _value.today
      ? new googleProtobuf005.BoolValue(_value.today)
      : undefined;
    this.engineVehiclesCount = _value.engineVehiclesCount;
    this.itemLanguageCount = _value.itemLanguageCount;
    this.linksCount = _value.linksCount;
    this.specificationsCount = _value.specificationsCount;
    this.subscription = _value.subscription;
    this.specsContributors = (_value.specsContributors || []).map(
      m => new SpecsContributor(m)
    );
    APIItem.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get catname(): string {
    return this._catname;
  }
  set catname(value: string) {
    this._catname = value;
  }
  get nameOnly(): string {
    return this._nameOnly;
  }
  set nameOnly(value: string) {
    this._nameOnly = value;
  }
  get nameText(): string {
    return this._nameText;
  }
  set nameText(value: string) {
    this._nameText = value;
  }
  get nameHtml(): string {
    return this._nameHtml;
  }
  set nameHtml(value: string) {
    this._nameHtml = value;
  }
  get nameDefault(): string {
    return this._nameDefault;
  }
  set nameDefault(value: string) {
    this._nameDefault = value;
  }
  get descendantsCount(): number {
    return this._descendantsCount;
  }
  set descendantsCount(value: number) {
    this._descendantsCount = value;
  }
  get engineItemId(): string {
    return this._engineItemId;
  }
  set engineItemId(value: string) {
    this._engineItemId = value;
  }
  get itemTypeId(): ItemType {
    return this._itemTypeId;
  }
  set itemTypeId(value: ItemType) {
    this._itemTypeId = value;
  }
  get description(): string {
    return this._description;
  }
  set description(value: string) {
    this._description = value;
  }
  get isConcept(): boolean {
    return this._isConcept;
  }
  set isConcept(value: boolean) {
    this._isConcept = value;
  }
  get isConceptInherit(): boolean {
    return this._isConceptInherit;
  }
  set isConceptInherit(value: boolean) {
    this._isConceptInherit = value;
  }
  get specId(): number {
    return this._specId;
  }
  set specId(value: number) {
    this._specId = value;
  }
  get specInherit(): boolean {
    return this._specInherit;
  }
  set specInherit(value: boolean) {
    this._specInherit = value;
  }
  get fullText(): string {
    return this._fullText;
  }
  set fullText(value: string) {
    this._fullText = value;
  }
  get descendantPicturesCount(): number {
    return this._descendantPicturesCount;
  }
  set descendantPicturesCount(value: number) {
    this._descendantPicturesCount = value;
  }
  get inboxPicturesCount(): number {
    return this._inboxPicturesCount;
  }
  set inboxPicturesCount(value: number) {
    this._inboxPicturesCount = value;
  }
  get acceptedPicturesCount(): number {
    return this._acceptedPicturesCount;
  }
  set acceptedPicturesCount(value: number) {
    this._acceptedPicturesCount = value;
  }
  get exactPicturesCount(): number {
    return this._exactPicturesCount;
  }
  set exactPicturesCount(value: number) {
    this._exactPicturesCount = value;
  }
  get childsCount(): number {
    return this._childsCount;
  }
  set childsCount(value: number) {
    this._childsCount = value;
  }
  get parentsCount(): number {
    return this._parentsCount;
  }
  set parentsCount(value: number) {
    this._parentsCount = value;
  }
  get descendantTwinsGroupsCount(): number {
    return this._descendantTwinsGroupsCount;
  }
  set descendantTwinsGroupsCount(value: number) {
    this._descendantTwinsGroupsCount = value;
  }
  get fullName(): string {
    return this._fullName;
  }
  set fullName(value: string) {
    this._fullName = value;
  }
  get logo(): APIImage | undefined {
    return this._logo;
  }
  set logo(value: APIImage | undefined) {
    this._logo = value;
  }
  get logo120(): APIImage | undefined {
    return this._logo120;
  }
  set logo120(value: APIImage | undefined) {
    this._logo120 = value;
  }
  get mostsActive(): boolean {
    return this._mostsActive;
  }
  set mostsActive(value: boolean) {
    this._mostsActive = value;
  }
  get commentsAttentionsCount(): number {
    return this._commentsAttentionsCount;
  }
  set commentsAttentionsCount(value: number) {
    this._commentsAttentionsCount = value;
  }
  get isCompilesItemOfDay(): boolean {
    return this._isCompilesItemOfDay;
  }
  set isCompilesItemOfDay(value: boolean) {
    this._isCompilesItemOfDay = value;
  }
  get brandicon(): APIImage | undefined {
    return this._brandicon;
  }
  set brandicon(value: APIImage | undefined) {
    this._brandicon = value;
  }
  get attrZoneId(): string {
    return this._attrZoneId;
  }
  set attrZoneId(value: string) {
    this._attrZoneId = value;
  }
  get engineInherit(): boolean {
    return this._engineInherit;
  }
  set engineInherit(value: boolean) {
    this._engineInherit = value;
  }
  get location(): googleType009.LatLng | undefined {
    return this._location;
  }
  set location(value: googleType009.LatLng | undefined) {
    this._location = value;
  }
  get hasChildSpecs(): boolean {
    return this._hasChildSpecs;
  }
  set hasChildSpecs(value: boolean) {
    this._hasChildSpecs = value;
  }
  get hasSpecs(): boolean {
    return this._hasSpecs;
  }
  set hasSpecs(value: boolean) {
    this._hasSpecs = value;
  }
  get produced(): googleProtobuf005.Int32Value | undefined {
    return this._produced;
  }
  set produced(value: googleProtobuf005.Int32Value | undefined) {
    this._produced = value;
  }
  get producedExactly(): boolean {
    return this._producedExactly;
  }
  set producedExactly(value: boolean) {
    this._producedExactly = value;
  }
  get otherNames(): string[] {
    return this._otherNames;
  }
  set otherNames(value: string[]) {
    this._otherNames = value;
  }
  get design(): Design | undefined {
    return this._design;
  }
  set design(value: Design | undefined) {
    this._design = value;
  }
  get specsRoute(): string[] {
    return this._specsRoute;
  }
  set specsRoute(value: string[]) {
    this._specsRoute = value;
  }
  get isGroup(): boolean {
    return this._isGroup;
  }
  set isGroup(value: boolean) {
    this._isGroup = value;
  }
  get childsCounts(): ChildsCount[] | undefined {
    return this._childsCounts;
  }
  set childsCounts(value: ChildsCount[] | undefined) {
    this._childsCounts = value;
  }
  get publicRoutes(): PublicRoute[] | undefined {
    return this._publicRoutes;
  }
  set publicRoutes(value: PublicRoute[] | undefined) {
    this._publicRoutes = value;
  }
  get pictureItems(): PictureItems | undefined {
    return this._pictureItems;
  }
  set pictureItems(value: PictureItems | undefined) {
    this._pictureItems = value;
  }
  get altNames(): AltName[] | undefined {
    return this._altNames;
  }
  set altNames(value: AltName[] | undefined) {
    this._altNames = value;
  }
  get route(): string[] {
    return this._route;
  }
  set route(value: string[]) {
    this._route = value;
  }
  get links(): ItemLinks | undefined {
    return this._links;
  }
  set links(value: ItemLinks | undefined) {
    this._links = value;
  }
  get hasText(): boolean {
    return this._hasText;
  }
  set hasText(value: boolean) {
    this._hasText = value;
  }
  get categories(): APIItem[] | undefined {
    return this._categories;
  }
  set categories(value: APIItem[] | undefined) {
    this._categories = value;
  }
  get twins(): APIItem[] | undefined {
    return this._twins;
  }
  set twins(value: APIItem[] | undefined) {
    this._twins = value;
  }
  get canEditSpecs(): boolean {
    return this._canEditSpecs;
  }
  set canEditSpecs(value: boolean) {
    this._canEditSpecs = value;
  }
  get itemParentChilds(): ItemParents | undefined {
    return this._itemParentChilds;
  }
  set itemParentChilds(value: ItemParents | undefined) {
    this._itemParentChilds = value;
  }
  get commentsCount(): number {
    return this._commentsCount;
  }
  set commentsCount(value: number) {
    this._commentsCount = value;
  }
  get previewPictures(): PreviewPictures | undefined {
    return this._previewPictures;
  }
  set previewPictures(value: PreviewPictures | undefined) {
    this._previewPictures = value;
  }
  get engineVehicles(): APIItem[] | undefined {
    return this._engineVehicles;
  }
  set engineVehicles(value: APIItem[] | undefined) {
    this._engineVehicles = value;
  }
  get relatedGroupPictures(): RelatedGroupPicture[] | undefined {
    return this._relatedGroupPictures;
  }
  set relatedGroupPictures(value: RelatedGroupPicture[] | undefined) {
    this._relatedGroupPictures = value;
  }
  get itemOfDayPictures(): ItemOfDayPicture[] | undefined {
    return this._itemOfDayPictures;
  }
  set itemOfDayPictures(value: ItemOfDayPicture[] | undefined) {
    this._itemOfDayPictures = value;
  }
  get beginYear(): number {
    return this._beginYear;
  }
  set beginYear(value: number) {
    this._beginYear = value;
  }
  get endYear(): number {
    return this._endYear;
  }
  set endYear(value: number) {
    this._endYear = value;
  }
  get beginMonth(): number {
    return this._beginMonth;
  }
  set beginMonth(value: number) {
    this._beginMonth = value;
  }
  get endMonth(): number {
    return this._endMonth;
  }
  set endMonth(value: number) {
    this._endMonth = value;
  }
  get beginModelYear(): number {
    return this._beginModelYear;
  }
  set beginModelYear(value: number) {
    this._beginModelYear = value;
  }
  get endModelYear(): number {
    return this._endModelYear;
  }
  set endModelYear(value: number) {
    this._endModelYear = value;
  }
  get beginModelYearFraction(): string {
    return this._beginModelYearFraction;
  }
  set beginModelYearFraction(value: string) {
    this._beginModelYearFraction = value;
  }
  get endModelYearFraction(): string {
    return this._endModelYearFraction;
  }
  set endModelYearFraction(value: string) {
    this._endModelYearFraction = value;
  }
  get body(): string {
    return this._body;
  }
  set body(value: string) {
    this._body = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get today(): googleProtobuf005.BoolValue | undefined {
    return this._today;
  }
  set today(value: googleProtobuf005.BoolValue | undefined) {
    this._today = value;
  }
  get engineVehiclesCount(): number {
    return this._engineVehiclesCount;
  }
  set engineVehiclesCount(value: number) {
    this._engineVehiclesCount = value;
  }
  get itemLanguageCount(): number {
    return this._itemLanguageCount;
  }
  set itemLanguageCount(value: number) {
    this._itemLanguageCount = value;
  }
  get linksCount(): number {
    return this._linksCount;
  }
  set linksCount(value: number) {
    this._linksCount = value;
  }
  get specificationsCount(): number {
    return this._specificationsCount;
  }
  set specificationsCount(value: number) {
    this._specificationsCount = value;
  }
  get subscription(): boolean {
    return this._subscription;
  }
  set subscription(value: boolean) {
    this._subscription = value;
  }
  get specsContributors(): SpecsContributor[] | undefined {
    return this._specsContributors;
  }
  set specsContributors(value: SpecsContributor[] | undefined) {
    this._specsContributors = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIItem.AsObject {
    return {
      id: this.id,
      catname: this.catname,
      nameOnly: this.nameOnly,
      nameText: this.nameText,
      nameHtml: this.nameHtml,
      nameDefault: this.nameDefault,
      descendantsCount: this.descendantsCount,
      engineItemId: this.engineItemId,
      itemTypeId: this.itemTypeId,
      description: this.description,
      isConcept: this.isConcept,
      isConceptInherit: this.isConceptInherit,
      specId: this.specId,
      specInherit: this.specInherit,
      fullText: this.fullText,
      descendantPicturesCount: this.descendantPicturesCount,
      inboxPicturesCount: this.inboxPicturesCount,
      acceptedPicturesCount: this.acceptedPicturesCount,
      exactPicturesCount: this.exactPicturesCount,
      childsCount: this.childsCount,
      parentsCount: this.parentsCount,
      descendantTwinsGroupsCount: this.descendantTwinsGroupsCount,
      fullName: this.fullName,
      logo: this.logo ? this.logo.toObject() : undefined,
      logo120: this.logo120 ? this.logo120.toObject() : undefined,
      mostsActive: this.mostsActive,
      commentsAttentionsCount: this.commentsAttentionsCount,
      isCompilesItemOfDay: this.isCompilesItemOfDay,
      brandicon: this.brandicon ? this.brandicon.toObject() : undefined,
      attrZoneId: this.attrZoneId,
      engineInherit: this.engineInherit,
      location: this.location ? this.location.toObject() : undefined,
      hasChildSpecs: this.hasChildSpecs,
      hasSpecs: this.hasSpecs,
      produced: this.produced ? this.produced.toObject() : undefined,
      producedExactly: this.producedExactly,
      otherNames: (this.otherNames || []).slice(),
      design: this.design ? this.design.toObject() : undefined,
      specsRoute: (this.specsRoute || []).slice(),
      isGroup: this.isGroup,
      childsCounts: (this.childsCounts || []).map(m => m.toObject()),
      publicRoutes: (this.publicRoutes || []).map(m => m.toObject()),
      pictureItems: this.pictureItems
        ? this.pictureItems.toObject()
        : undefined,
      altNames: (this.altNames || []).map(m => m.toObject()),
      route: (this.route || []).slice(),
      links: this.links ? this.links.toObject() : undefined,
      hasText: this.hasText,
      categories: (this.categories || []).map(m => m.toObject()),
      twins: (this.twins || []).map(m => m.toObject()),
      canEditSpecs: this.canEditSpecs,
      itemParentChilds: this.itemParentChilds
        ? this.itemParentChilds.toObject()
        : undefined,
      commentsCount: this.commentsCount,
      previewPictures: this.previewPictures
        ? this.previewPictures.toObject()
        : undefined,
      engineVehicles: (this.engineVehicles || []).map(m => m.toObject()),
      relatedGroupPictures: (this.relatedGroupPictures || []).map(m =>
        m.toObject()
      ),
      itemOfDayPictures: (this.itemOfDayPictures || []).map(m => m.toObject()),
      beginYear: this.beginYear,
      endYear: this.endYear,
      beginMonth: this.beginMonth,
      endMonth: this.endMonth,
      beginModelYear: this.beginModelYear,
      endModelYear: this.endModelYear,
      beginModelYearFraction: this.beginModelYearFraction,
      endModelYearFraction: this.endModelYearFraction,
      body: this.body,
      name: this.name,
      today: this.today ? this.today.toObject() : undefined,
      engineVehiclesCount: this.engineVehiclesCount,
      itemLanguageCount: this.itemLanguageCount,
      linksCount: this.linksCount,
      specificationsCount: this.specificationsCount,
      subscription: this.subscription,
      specsContributors: (this.specsContributors || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIItem.AsProtobufJSON {
    return {
      id: this.id,
      catname: this.catname,
      nameOnly: this.nameOnly,
      nameText: this.nameText,
      nameHtml: this.nameHtml,
      nameDefault: this.nameDefault,
      descendantsCount: this.descendantsCount,
      engineItemId: this.engineItemId,
      itemTypeId:
        ItemType[
          this.itemTypeId === null || this.itemTypeId === undefined
            ? 0
            : this.itemTypeId
        ],
      description: this.description,
      isConcept: this.isConcept,
      isConceptInherit: this.isConceptInherit,
      specId: this.specId,
      specInherit: this.specInherit,
      fullText: this.fullText,
      descendantPicturesCount: this.descendantPicturesCount,
      inboxPicturesCount: this.inboxPicturesCount,
      acceptedPicturesCount: this.acceptedPicturesCount,
      exactPicturesCount: this.exactPicturesCount,
      childsCount: this.childsCount,
      parentsCount: this.parentsCount,
      descendantTwinsGroupsCount: this.descendantTwinsGroupsCount,
      fullName: this.fullName,
      logo: this.logo ? this.logo.toProtobufJSON(options) : null,
      logo120: this.logo120 ? this.logo120.toProtobufJSON(options) : null,
      mostsActive: this.mostsActive,
      commentsAttentionsCount: this.commentsAttentionsCount,
      isCompilesItemOfDay: this.isCompilesItemOfDay,
      brandicon: this.brandicon ? this.brandicon.toProtobufJSON(options) : null,
      attrZoneId: this.attrZoneId,
      engineInherit: this.engineInherit,
      location: this.location ? this.location.toProtobufJSON(options) : null,
      hasChildSpecs: this.hasChildSpecs,
      hasSpecs: this.hasSpecs,
      produced: this.produced ? this.produced.toProtobufJSON(options) : null,
      producedExactly: this.producedExactly,
      otherNames: (this.otherNames || []).slice(),
      design: this.design ? this.design.toProtobufJSON(options) : null,
      specsRoute: (this.specsRoute || []).slice(),
      isGroup: this.isGroup,
      childsCounts: (this.childsCounts || []).map(m =>
        m.toProtobufJSON(options)
      ),
      publicRoutes: (this.publicRoutes || []).map(m =>
        m.toProtobufJSON(options)
      ),
      pictureItems: this.pictureItems
        ? this.pictureItems.toProtobufJSON(options)
        : null,
      altNames: (this.altNames || []).map(m => m.toProtobufJSON(options)),
      route: (this.route || []).slice(),
      links: this.links ? this.links.toProtobufJSON(options) : null,
      hasText: this.hasText,
      categories: (this.categories || []).map(m => m.toProtobufJSON(options)),
      twins: (this.twins || []).map(m => m.toProtobufJSON(options)),
      canEditSpecs: this.canEditSpecs,
      itemParentChilds: this.itemParentChilds
        ? this.itemParentChilds.toProtobufJSON(options)
        : null,
      commentsCount: this.commentsCount,
      previewPictures: this.previewPictures
        ? this.previewPictures.toProtobufJSON(options)
        : null,
      engineVehicles: (this.engineVehicles || []).map(m =>
        m.toProtobufJSON(options)
      ),
      relatedGroupPictures: (this.relatedGroupPictures || []).map(m =>
        m.toProtobufJSON(options)
      ),
      itemOfDayPictures: (this.itemOfDayPictures || []).map(m =>
        m.toProtobufJSON(options)
      ),
      beginYear: this.beginYear,
      endYear: this.endYear,
      beginMonth: this.beginMonth,
      endMonth: this.endMonth,
      beginModelYear: this.beginModelYear,
      endModelYear: this.endModelYear,
      beginModelYearFraction: this.beginModelYearFraction,
      endModelYearFraction: this.endModelYearFraction,
      body: this.body,
      name: this.name,
      today: this.today ? this.today.toProtobufJSON(options) : null,
      engineVehiclesCount: this.engineVehiclesCount,
      itemLanguageCount: this.itemLanguageCount,
      linksCount: this.linksCount,
      specificationsCount: this.specificationsCount,
      subscription: this.subscription,
      specsContributors: (this.specsContributors || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module APIItem {
  /**
   * Standard JavaScript object representation for APIItem
   */
  export interface AsObject {
    id: string;
    catname: string;
    nameOnly: string;
    nameText: string;
    nameHtml: string;
    nameDefault: string;
    descendantsCount: number;
    engineItemId: string;
    itemTypeId: ItemType;
    description: string;
    isConcept: boolean;
    isConceptInherit: boolean;
    specId: number;
    specInherit: boolean;
    fullText: string;
    descendantPicturesCount: number;
    inboxPicturesCount: number;
    acceptedPicturesCount: number;
    exactPicturesCount: number;
    childsCount: number;
    parentsCount: number;
    descendantTwinsGroupsCount: number;
    fullName: string;
    logo?: APIImage.AsObject;
    logo120?: APIImage.AsObject;
    mostsActive: boolean;
    commentsAttentionsCount: number;
    isCompilesItemOfDay: boolean;
    brandicon?: APIImage.AsObject;
    attrZoneId: string;
    engineInherit: boolean;
    location?: googleType009.LatLng.AsObject;
    hasChildSpecs: boolean;
    hasSpecs: boolean;
    produced?: googleProtobuf005.Int32Value.AsObject;
    producedExactly: boolean;
    otherNames: string[];
    design?: Design.AsObject;
    specsRoute: string[];
    isGroup: boolean;
    childsCounts?: ChildsCount.AsObject[];
    publicRoutes?: PublicRoute.AsObject[];
    pictureItems?: PictureItems.AsObject;
    altNames?: AltName.AsObject[];
    route: string[];
    links?: ItemLinks.AsObject;
    hasText: boolean;
    categories?: APIItem.AsObject[];
    twins?: APIItem.AsObject[];
    canEditSpecs: boolean;
    itemParentChilds?: ItemParents.AsObject;
    commentsCount: number;
    previewPictures?: PreviewPictures.AsObject;
    engineVehicles?: APIItem.AsObject[];
    relatedGroupPictures?: RelatedGroupPicture.AsObject[];
    itemOfDayPictures?: ItemOfDayPicture.AsObject[];
    beginYear: number;
    endYear: number;
    beginMonth: number;
    endMonth: number;
    beginModelYear: number;
    endModelYear: number;
    beginModelYearFraction: string;
    endModelYearFraction: string;
    body: string;
    name: string;
    today?: googleProtobuf005.BoolValue.AsObject;
    engineVehiclesCount: number;
    itemLanguageCount: number;
    linksCount: number;
    specificationsCount: number;
    subscription: boolean;
    specsContributors?: SpecsContributor.AsObject[];
  }

  /**
   * Protobuf JSON representation for APIItem
   */
  export interface AsProtobufJSON {
    id: string;
    catname: string;
    nameOnly: string;
    nameText: string;
    nameHtml: string;
    nameDefault: string;
    descendantsCount: number;
    engineItemId: string;
    itemTypeId: string;
    description: string;
    isConcept: boolean;
    isConceptInherit: boolean;
    specId: number;
    specInherit: boolean;
    fullText: string;
    descendantPicturesCount: number;
    inboxPicturesCount: number;
    acceptedPicturesCount: number;
    exactPicturesCount: number;
    childsCount: number;
    parentsCount: number;
    descendantTwinsGroupsCount: number;
    fullName: string;
    logo: APIImage.AsProtobufJSON | null;
    logo120: APIImage.AsProtobufJSON | null;
    mostsActive: boolean;
    commentsAttentionsCount: number;
    isCompilesItemOfDay: boolean;
    brandicon: APIImage.AsProtobufJSON | null;
    attrZoneId: string;
    engineInherit: boolean;
    location: googleType009.LatLng.AsProtobufJSON | null;
    hasChildSpecs: boolean;
    hasSpecs: boolean;
    produced: googleProtobuf005.Int32Value.AsProtobufJSON | null;
    producedExactly: boolean;
    otherNames: string[];
    design: Design.AsProtobufJSON | null;
    specsRoute: string[];
    isGroup: boolean;
    childsCounts: ChildsCount.AsProtobufJSON[] | null;
    publicRoutes: PublicRoute.AsProtobufJSON[] | null;
    pictureItems: PictureItems.AsProtobufJSON | null;
    altNames: AltName.AsProtobufJSON[] | null;
    route: string[];
    links: ItemLinks.AsProtobufJSON | null;
    hasText: boolean;
    categories: APIItem.AsProtobufJSON[] | null;
    twins: APIItem.AsProtobufJSON[] | null;
    canEditSpecs: boolean;
    itemParentChilds: ItemParents.AsProtobufJSON | null;
    commentsCount: number;
    previewPictures: PreviewPictures.AsProtobufJSON | null;
    engineVehicles: APIItem.AsProtobufJSON[] | null;
    relatedGroupPictures: RelatedGroupPicture.AsProtobufJSON[] | null;
    itemOfDayPictures: ItemOfDayPicture.AsProtobufJSON[] | null;
    beginYear: number;
    endYear: number;
    beginMonth: number;
    endMonth: number;
    beginModelYear: number;
    endModelYear: number;
    beginModelYearFraction: string;
    endModelYearFraction: string;
    body: string;
    name: string;
    today: googleProtobuf005.BoolValue.AsProtobufJSON | null;
    engineVehiclesCount: number;
    itemLanguageCount: number;
    linksCount: number;
    specificationsCount: number;
    subscription: boolean;
    specsContributors: SpecsContributor.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.SpecsContributor
 */
export class SpecsContributor implements GrpcMessage {
  static id = 'goautowp.SpecsContributor';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SpecsContributor();
    SpecsContributor.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SpecsContributor) {
    _instance.userId = _instance.userId || '0';
    _instance.count = _instance.count || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SpecsContributor,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.userId = _reader.readInt64String();
          break;
        case 2:
          _instance.count = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    SpecsContributor.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SpecsContributor,
    _writer: BinaryWriter
  ) {
    if (_instance.userId) {
      _writer.writeInt64String(1, _instance.userId);
    }
    if (_instance.count) {
      _writer.writeInt32(2, _instance.count);
    }
  }

  private _userId: string;
  private _count: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SpecsContributor to deeply clone from
   */
  constructor(_value?: RecursivePartial<SpecsContributor.AsObject>) {
    _value = _value || {};
    this.userId = _value.userId;
    this.count = _value.count;
    SpecsContributor.refineValues(this);
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }
  get count(): number {
    return this._count;
  }
  set count(value: number) {
    this._count = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SpecsContributor.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SpecsContributor.AsObject {
    return {
      userId: this.userId,
      count: this.count
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SpecsContributor.AsProtobufJSON {
    return {
      userId: this.userId,
      count: this.count
    };
  }
}
export module SpecsContributor {
  /**
   * Standard JavaScript object representation for SpecsContributor
   */
  export interface AsObject {
    userId: string;
    count: number;
  }

  /**
   * Protobuf JSON representation for SpecsContributor
   */
  export interface AsProtobufJSON {
    userId: string;
    count: number;
  }
}

/**
 * Message implementation for goautowp.ItemOfDayPicture
 */
export class ItemOfDayPicture implements GrpcMessage {
  static id = 'goautowp.ItemOfDayPicture';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemOfDayPicture();
    ItemOfDayPicture.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemOfDayPicture) {
    _instance.name = _instance.name || '';
    _instance.thumb = _instance.thumb || undefined;
    _instance.route = _instance.route || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemOfDayPicture,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.name = _reader.readString();
          break;
        case 2:
          _instance.thumb = new APIImage();
          _reader.readMessage(
            _instance.thumb,
            APIImage.deserializeBinaryFromReader
          );
          break;
        case 3:
          (_instance.route = _instance.route || []).push(_reader.readString());
          break;
        default:
          _reader.skipField();
      }
    }

    ItemOfDayPicture.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItemOfDayPicture,
    _writer: BinaryWriter
  ) {
    if (_instance.name) {
      _writer.writeString(1, _instance.name);
    }
    if (_instance.thumb) {
      _writer.writeMessage(
        2,
        _instance.thumb as any,
        APIImage.serializeBinaryToWriter
      );
    }
    if (_instance.route && _instance.route.length) {
      _writer.writeRepeatedString(3, _instance.route);
    }
  }

  private _name: string;
  private _thumb?: APIImage;
  private _route: string[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemOfDayPicture to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemOfDayPicture.AsObject>) {
    _value = _value || {};
    this.name = _value.name;
    this.thumb = _value.thumb ? new APIImage(_value.thumb) : undefined;
    this.route = (_value.route || []).slice();
    ItemOfDayPicture.refineValues(this);
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get thumb(): APIImage | undefined {
    return this._thumb;
  }
  set thumb(value: APIImage | undefined) {
    this._thumb = value;
  }
  get route(): string[] {
    return this._route;
  }
  set route(value: string[]) {
    this._route = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemOfDayPicture.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemOfDayPicture.AsObject {
    return {
      name: this.name,
      thumb: this.thumb ? this.thumb.toObject() : undefined,
      route: (this.route || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemOfDayPicture.AsProtobufJSON {
    return {
      name: this.name,
      thumb: this.thumb ? this.thumb.toProtobufJSON(options) : null,
      route: (this.route || []).slice()
    };
  }
}
export module ItemOfDayPicture {
  /**
   * Standard JavaScript object representation for ItemOfDayPicture
   */
  export interface AsObject {
    name: string;
    thumb?: APIImage.AsObject;
    route: string[];
  }

  /**
   * Protobuf JSON representation for ItemOfDayPicture
   */
  export interface AsProtobufJSON {
    name: string;
    thumb: APIImage.AsProtobufJSON | null;
    route: string[];
  }
}

/**
 * Message implementation for goautowp.ItemOfDayRequest
 */
export class ItemOfDayRequest implements GrpcMessage {
  static id = 'goautowp.ItemOfDayRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemOfDayRequest();
    ItemOfDayRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemOfDayRequest) {
    _instance.language = _instance.language || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemOfDayRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.language = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    ItemOfDayRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItemOfDayRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.language) {
      _writer.writeString(1, _instance.language);
    }
  }

  private _language: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemOfDayRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemOfDayRequest.AsObject>) {
    _value = _value || {};
    this.language = _value.language;
    ItemOfDayRequest.refineValues(this);
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemOfDayRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemOfDayRequest.AsObject {
    return {
      language: this.language
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemOfDayRequest.AsProtobufJSON {
    return {
      language: this.language
    };
  }
}
export module ItemOfDayRequest {
  /**
   * Standard JavaScript object representation for ItemOfDayRequest
   */
  export interface AsObject {
    language: string;
  }

  /**
   * Protobuf JSON representation for ItemOfDayRequest
   */
  export interface AsProtobufJSON {
    language: string;
  }
}

/**
 * Message implementation for goautowp.ItemOfDay
 */
export class ItemOfDay implements GrpcMessage {
  static id = 'goautowp.ItemOfDay';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemOfDay();
    ItemOfDay.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemOfDay) {
    _instance.item = _instance.item || undefined;
    _instance.userId = _instance.userId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemOfDay,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.item = new APIItem();
          _reader.readMessage(
            _instance.item,
            APIItem.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.userId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    ItemOfDay.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: ItemOfDay, _writer: BinaryWriter) {
    if (_instance.item) {
      _writer.writeMessage(
        1,
        _instance.item as any,
        APIItem.serializeBinaryToWriter
      );
    }
    if (_instance.userId) {
      _writer.writeInt64String(2, _instance.userId);
    }
  }

  private _item?: APIItem;
  private _userId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemOfDay to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemOfDay.AsObject>) {
    _value = _value || {};
    this.item = _value.item ? new APIItem(_value.item) : undefined;
    this.userId = _value.userId;
    ItemOfDay.refineValues(this);
  }
  get item(): APIItem | undefined {
    return this._item;
  }
  set item(value: APIItem | undefined) {
    this._item = value;
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemOfDay.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemOfDay.AsObject {
    return {
      item: this.item ? this.item.toObject() : undefined,
      userId: this.userId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemOfDay.AsProtobufJSON {
    return {
      item: this.item ? this.item.toProtobufJSON(options) : null,
      userId: this.userId
    };
  }
}
export module ItemOfDay {
  /**
   * Standard JavaScript object representation for ItemOfDay
   */
  export interface AsObject {
    item?: APIItem.AsObject;
    userId: string;
  }

  /**
   * Protobuf JSON representation for ItemOfDay
   */
  export interface AsProtobufJSON {
    item: APIItem.AsProtobufJSON | null;
    userId: string;
  }
}

/**
 * Message implementation for goautowp.RelatedGroupPicture
 */
export class RelatedGroupPicture implements GrpcMessage {
  static id = 'goautowp.RelatedGroupPicture';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new RelatedGroupPicture();
    RelatedGroupPicture.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: RelatedGroupPicture) {
    _instance.nameHtml = _instance.nameHtml || '';
    _instance.src = _instance.src || '';
    _instance.route = _instance.route || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: RelatedGroupPicture,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.nameHtml = _reader.readString();
          break;
        case 2:
          _instance.src = _reader.readString();
          break;
        case 3:
          (_instance.route = _instance.route || []).push(_reader.readString());
          break;
        default:
          _reader.skipField();
      }
    }

    RelatedGroupPicture.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: RelatedGroupPicture,
    _writer: BinaryWriter
  ) {
    if (_instance.nameHtml) {
      _writer.writeString(1, _instance.nameHtml);
    }
    if (_instance.src) {
      _writer.writeString(2, _instance.src);
    }
    if (_instance.route && _instance.route.length) {
      _writer.writeRepeatedString(3, _instance.route);
    }
  }

  private _nameHtml: string;
  private _src: string;
  private _route: string[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of RelatedGroupPicture to deeply clone from
   */
  constructor(_value?: RecursivePartial<RelatedGroupPicture.AsObject>) {
    _value = _value || {};
    this.nameHtml = _value.nameHtml;
    this.src = _value.src;
    this.route = (_value.route || []).slice();
    RelatedGroupPicture.refineValues(this);
  }
  get nameHtml(): string {
    return this._nameHtml;
  }
  set nameHtml(value: string) {
    this._nameHtml = value;
  }
  get src(): string {
    return this._src;
  }
  set src(value: string) {
    this._src = value;
  }
  get route(): string[] {
    return this._route;
  }
  set route(value: string[]) {
    this._route = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    RelatedGroupPicture.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): RelatedGroupPicture.AsObject {
    return {
      nameHtml: this.nameHtml,
      src: this.src,
      route: (this.route || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): RelatedGroupPicture.AsProtobufJSON {
    return {
      nameHtml: this.nameHtml,
      src: this.src,
      route: (this.route || []).slice()
    };
  }
}
export module RelatedGroupPicture {
  /**
   * Standard JavaScript object representation for RelatedGroupPicture
   */
  export interface AsObject {
    nameHtml: string;
    src: string;
    route: string[];
  }

  /**
   * Protobuf JSON representation for RelatedGroupPicture
   */
  export interface AsProtobufJSON {
    nameHtml: string;
    src: string;
    route: string[];
  }
}

/**
 * Message implementation for goautowp.NullPicture
 */
export class NullPicture implements GrpcMessage {
  static id = 'goautowp.NullPicture';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new NullPicture();
    NullPicture.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: NullPicture) {}

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: NullPicture,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.null = _reader.readEnum();
          break;
        case 2:
          _instance.picture = new Picture();
          _reader.readMessage(
            _instance.picture,
            Picture.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    NullPicture.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: NullPicture,
    _writer: BinaryWriter
  ) {
    if (_instance.null || _instance.null === 0) {
      _writer.writeEnum(1, _instance.null);
    }
    if (_instance.picture) {
      _writer.writeMessage(
        2,
        _instance.picture as any,
        Picture.serializeBinaryToWriter
      );
    }
  }

  private _null: googleProtobuf007.NullValue;
  private _picture?: Picture;

  private _kind: NullPicture.KindCase = NullPicture.KindCase.none;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of NullPicture to deeply clone from
   */
  constructor(_value?: RecursivePartial<NullPicture.AsObject>) {
    _value = _value || {};
    this.null = _value.null;
    this.picture = _value.picture ? new Picture(_value.picture) : undefined;
    NullPicture.refineValues(this);
  }
  get null(): googleProtobuf007.NullValue {
    return this._null;
  }
  set null(value: googleProtobuf007.NullValue) {
    if (value !== undefined && value !== null) {
      this._picture = undefined;
      this._kind = NullPicture.KindCase.null;
    }
    this._null = value;
  }
  get picture(): Picture | undefined {
    return this._picture;
  }
  set picture(value: Picture | undefined) {
    if (value !== undefined && value !== null) {
      this._null = undefined;
      this._kind = NullPicture.KindCase.picture;
    }
    this._picture = value;
  }
  get kind() {
    return this._kind;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    NullPicture.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): NullPicture.AsObject {
    return {
      null: this.null,
      picture: this.picture ? this.picture.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): NullPicture.AsProtobufJSON {
    return {
      null:
        this.null === undefined
          ? null
          : googleProtobuf007.NullValue[
              this.null === null || this.null === undefined ? 0 : this.null
            ],
      picture: this.picture ? this.picture.toProtobufJSON(options) : null
    };
  }
}
export module NullPicture {
  /**
   * Standard JavaScript object representation for NullPicture
   */
  export interface AsObject {
    null: googleProtobuf007.NullValue;
    picture?: Picture.AsObject;
  }

  /**
   * Protobuf JSON representation for NullPicture
   */
  export interface AsProtobufJSON {
    null: string | null;
    picture: Picture.AsProtobufJSON | null;
  }
  export enum KindCase {
    none = 0,
    null = 1,
    picture = 2
  }
}

/**
 * Message implementation for goautowp.PreviewPictures
 */
export class PreviewPictures implements GrpcMessage {
  static id = 'goautowp.PreviewPictures';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PreviewPictures();
    PreviewPictures.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PreviewPictures) {
    _instance.largeFormat = _instance.largeFormat || false;
    _instance.pictures = _instance.pictures || [];
    _instance.totalPictures = _instance.totalPictures || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PreviewPictures,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.largeFormat = _reader.readBool();
          break;
        case 2:
          const messageInitializer2 = new NullPicture();
          _reader.readMessage(
            messageInitializer2,
            NullPicture.deserializeBinaryFromReader
          );
          (_instance.pictures = _instance.pictures || []).push(
            messageInitializer2
          );
          break;
        case 3:
          _instance.totalPictures = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    PreviewPictures.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PreviewPictures,
    _writer: BinaryWriter
  ) {
    if (_instance.largeFormat) {
      _writer.writeBool(1, _instance.largeFormat);
    }
    if (_instance.pictures && _instance.pictures.length) {
      _writer.writeRepeatedMessage(
        2,
        _instance.pictures as any,
        NullPicture.serializeBinaryToWriter
      );
    }
    if (_instance.totalPictures) {
      _writer.writeInt32(3, _instance.totalPictures);
    }
  }

  private _largeFormat: boolean;
  private _pictures?: NullPicture[];
  private _totalPictures: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PreviewPictures to deeply clone from
   */
  constructor(_value?: RecursivePartial<PreviewPictures.AsObject>) {
    _value = _value || {};
    this.largeFormat = _value.largeFormat;
    this.pictures = (_value.pictures || []).map(m => new NullPicture(m));
    this.totalPictures = _value.totalPictures;
    PreviewPictures.refineValues(this);
  }
  get largeFormat(): boolean {
    return this._largeFormat;
  }
  set largeFormat(value: boolean) {
    this._largeFormat = value;
  }
  get pictures(): NullPicture[] | undefined {
    return this._pictures;
  }
  set pictures(value: NullPicture[] | undefined) {
    this._pictures = value;
  }
  get totalPictures(): number {
    return this._totalPictures;
  }
  set totalPictures(value: number) {
    this._totalPictures = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PreviewPictures.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PreviewPictures.AsObject {
    return {
      largeFormat: this.largeFormat,
      pictures: (this.pictures || []).map(m => m.toObject()),
      totalPictures: this.totalPictures
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PreviewPictures.AsProtobufJSON {
    return {
      largeFormat: this.largeFormat,
      pictures: (this.pictures || []).map(m => m.toProtobufJSON(options)),
      totalPictures: this.totalPictures
    };
  }
}
export module PreviewPictures {
  /**
   * Standard JavaScript object representation for PreviewPictures
   */
  export interface AsObject {
    largeFormat: boolean;
    pictures?: NullPicture.AsObject[];
    totalPictures: number;
  }

  /**
   * Protobuf JSON representation for PreviewPictures
   */
  export interface AsProtobufJSON {
    largeFormat: boolean;
    pictures: NullPicture.AsProtobufJSON[] | null;
    totalPictures: number;
  }
}

/**
 * Message implementation for goautowp.PublicRoute
 */
export class PublicRoute implements GrpcMessage {
  static id = 'goautowp.PublicRoute';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PublicRoute();
    PublicRoute.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PublicRoute) {
    _instance.route = _instance.route || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PublicRoute,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          (_instance.route = _instance.route || []).push(_reader.readString());
          break;
        default:
          _reader.skipField();
      }
    }

    PublicRoute.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PublicRoute,
    _writer: BinaryWriter
  ) {
    if (_instance.route && _instance.route.length) {
      _writer.writeRepeatedString(1, _instance.route);
    }
  }

  private _route: string[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PublicRoute to deeply clone from
   */
  constructor(_value?: RecursivePartial<PublicRoute.AsObject>) {
    _value = _value || {};
    this.route = (_value.route || []).slice();
    PublicRoute.refineValues(this);
  }
  get route(): string[] {
    return this._route;
  }
  set route(value: string[]) {
    this._route = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PublicRoute.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PublicRoute.AsObject {
    return {
      route: (this.route || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PublicRoute.AsProtobufJSON {
    return {
      route: (this.route || []).slice()
    };
  }
}
export module PublicRoute {
  /**
   * Standard JavaScript object representation for PublicRoute
   */
  export interface AsObject {
    route: string[];
  }

  /**
   * Protobuf JSON representation for PublicRoute
   */
  export interface AsProtobufJSON {
    route: string[];
  }
}

/**
 * Message implementation for goautowp.ChildsCount
 */
export class ChildsCount implements GrpcMessage {
  static id = 'goautowp.ChildsCount';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ChildsCount();
    ChildsCount.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ChildsCount) {
    _instance.type = _instance.type || 0;
    _instance.count = _instance.count || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ChildsCount,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.type = _reader.readEnum();
          break;
        case 2:
          _instance.count = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    ChildsCount.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ChildsCount,
    _writer: BinaryWriter
  ) {
    if (_instance.type) {
      _writer.writeEnum(1, _instance.type);
    }
    if (_instance.count) {
      _writer.writeInt32(2, _instance.count);
    }
  }

  private _type: ItemParentType;
  private _count: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ChildsCount to deeply clone from
   */
  constructor(_value?: RecursivePartial<ChildsCount.AsObject>) {
    _value = _value || {};
    this.type = _value.type;
    this.count = _value.count;
    ChildsCount.refineValues(this);
  }
  get type(): ItemParentType {
    return this._type;
  }
  set type(value: ItemParentType) {
    this._type = value;
  }
  get count(): number {
    return this._count;
  }
  set count(value: number) {
    this._count = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ChildsCount.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ChildsCount.AsObject {
    return {
      type: this.type,
      count: this.count
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ChildsCount.AsProtobufJSON {
    return {
      type:
        ItemParentType[
          this.type === null || this.type === undefined ? 0 : this.type
        ],
      count: this.count
    };
  }
}
export module ChildsCount {
  /**
   * Standard JavaScript object representation for ChildsCount
   */
  export interface AsObject {
    type: ItemParentType;
    count: number;
  }

  /**
   * Protobuf JSON representation for ChildsCount
   */
  export interface AsProtobufJSON {
    type: string;
    count: number;
  }
}

/**
 * Message implementation for goautowp.Design
 */
export class Design implements GrpcMessage {
  static id = 'goautowp.Design';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Design();
    Design.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Design) {
    _instance.name = _instance.name || '';
    _instance.route = _instance.route || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(_instance: Design, _reader: BinaryReader) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.name = _reader.readString();
          break;
        case 2:
          (_instance.route = _instance.route || []).push(_reader.readString());
          break;
        default:
          _reader.skipField();
      }
    }

    Design.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Design, _writer: BinaryWriter) {
    if (_instance.name) {
      _writer.writeString(1, _instance.name);
    }
    if (_instance.route && _instance.route.length) {
      _writer.writeRepeatedString(2, _instance.route);
    }
  }

  private _name: string;
  private _route: string[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Design to deeply clone from
   */
  constructor(_value?: RecursivePartial<Design.AsObject>) {
    _value = _value || {};
    this.name = _value.name;
    this.route = (_value.route || []).slice();
    Design.refineValues(this);
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get route(): string[] {
    return this._route;
  }
  set route(value: string[]) {
    this._route = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Design.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Design.AsObject {
    return {
      name: this.name,
      route: (this.route || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Design.AsProtobufJSON {
    return {
      name: this.name,
      route: (this.route || []).slice()
    };
  }
}
export module Design {
  /**
   * Standard JavaScript object representation for Design
   */
  export interface AsObject {
    name: string;
    route: string[];
  }

  /**
   * Protobuf JSON representation for Design
   */
  export interface AsProtobufJSON {
    name: string;
    route: string[];
  }
}

/**
 * Message implementation for goautowp.APIItemList
 */
export class APIItemList implements GrpcMessage {
  static id = 'goautowp.APIItemList';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIItemList();
    APIItemList.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIItemList) {
    _instance.items = _instance.items || [];
    _instance.paginator = _instance.paginator || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIItemList,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new APIItem();
          _reader.readMessage(
            messageInitializer1,
            APIItem.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        case 2:
          _instance.paginator = new Pages();
          _reader.readMessage(
            _instance.paginator,
            Pages.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    APIItemList.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIItemList,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        APIItem.serializeBinaryToWriter
      );
    }
    if (_instance.paginator) {
      _writer.writeMessage(
        2,
        _instance.paginator as any,
        Pages.serializeBinaryToWriter
      );
    }
  }

  private _items?: APIItem[];
  private _paginator?: Pages;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIItemList to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIItemList.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new APIItem(m));
    this.paginator = _value.paginator ? new Pages(_value.paginator) : undefined;
    APIItemList.refineValues(this);
  }
  get items(): APIItem[] | undefined {
    return this._items;
  }
  set items(value: APIItem[] | undefined) {
    this._items = value;
  }
  get paginator(): Pages | undefined {
    return this._paginator;
  }
  set paginator(value: Pages | undefined) {
    this._paginator = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIItemList.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIItemList.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject()),
      paginator: this.paginator ? this.paginator.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIItemList.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options)),
      paginator: this.paginator ? this.paginator.toProtobufJSON(options) : null
    };
  }
}
export module APIItemList {
  /**
   * Standard JavaScript object representation for APIItemList
   */
  export interface AsObject {
    items?: APIItem.AsObject[];
    paginator?: Pages.AsObject;
  }

  /**
   * Protobuf JSON representation for APIItemList
   */
  export interface AsProtobufJSON {
    items: APIItem.AsProtobufJSON[] | null;
    paginator: Pages.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.CommentsSubscribeRequest
 */
export class CommentsSubscribeRequest implements GrpcMessage {
  static id = 'goautowp.CommentsSubscribeRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CommentsSubscribeRequest();
    CommentsSubscribeRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CommentsSubscribeRequest) {
    _instance.itemId = _instance.itemId || '0';
    _instance.typeId = _instance.typeId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CommentsSubscribeRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.itemId = _reader.readInt64String();
          break;
        case 2:
          _instance.typeId = _reader.readEnum();
          break;
        default:
          _reader.skipField();
      }
    }

    CommentsSubscribeRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CommentsSubscribeRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.itemId) {
      _writer.writeInt64String(1, _instance.itemId);
    }
    if (_instance.typeId) {
      _writer.writeEnum(2, _instance.typeId);
    }
  }

  private _itemId: string;
  private _typeId: CommentsType;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CommentsSubscribeRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<CommentsSubscribeRequest.AsObject>) {
    _value = _value || {};
    this.itemId = _value.itemId;
    this.typeId = _value.typeId;
    CommentsSubscribeRequest.refineValues(this);
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get typeId(): CommentsType {
    return this._typeId;
  }
  set typeId(value: CommentsType) {
    this._typeId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CommentsSubscribeRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CommentsSubscribeRequest.AsObject {
    return {
      itemId: this.itemId,
      typeId: this.typeId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CommentsSubscribeRequest.AsProtobufJSON {
    return {
      itemId: this.itemId,
      typeId:
        CommentsType[
          this.typeId === null || this.typeId === undefined ? 0 : this.typeId
        ]
    };
  }
}
export module CommentsSubscribeRequest {
  /**
   * Standard JavaScript object representation for CommentsSubscribeRequest
   */
  export interface AsObject {
    itemId: string;
    typeId: CommentsType;
  }

  /**
   * Protobuf JSON representation for CommentsSubscribeRequest
   */
  export interface AsProtobufJSON {
    itemId: string;
    typeId: string;
  }
}

/**
 * Message implementation for goautowp.CommentsUnSubscribeRequest
 */
export class CommentsUnSubscribeRequest implements GrpcMessage {
  static id = 'goautowp.CommentsUnSubscribeRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CommentsUnSubscribeRequest();
    CommentsUnSubscribeRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CommentsUnSubscribeRequest) {
    _instance.itemId = _instance.itemId || '0';
    _instance.typeId = _instance.typeId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CommentsUnSubscribeRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.itemId = _reader.readInt64String();
          break;
        case 2:
          _instance.typeId = _reader.readEnum();
          break;
        default:
          _reader.skipField();
      }
    }

    CommentsUnSubscribeRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CommentsUnSubscribeRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.itemId) {
      _writer.writeInt64String(1, _instance.itemId);
    }
    if (_instance.typeId) {
      _writer.writeEnum(2, _instance.typeId);
    }
  }

  private _itemId: string;
  private _typeId: CommentsType;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CommentsUnSubscribeRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<CommentsUnSubscribeRequest.AsObject>) {
    _value = _value || {};
    this.itemId = _value.itemId;
    this.typeId = _value.typeId;
    CommentsUnSubscribeRequest.refineValues(this);
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get typeId(): CommentsType {
    return this._typeId;
  }
  set typeId(value: CommentsType) {
    this._typeId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CommentsUnSubscribeRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CommentsUnSubscribeRequest.AsObject {
    return {
      itemId: this.itemId,
      typeId: this.typeId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CommentsUnSubscribeRequest.AsProtobufJSON {
    return {
      itemId: this.itemId,
      typeId:
        CommentsType[
          this.typeId === null || this.typeId === undefined ? 0 : this.typeId
        ]
    };
  }
}
export module CommentsUnSubscribeRequest {
  /**
   * Standard JavaScript object representation for CommentsUnSubscribeRequest
   */
  export interface AsObject {
    itemId: string;
    typeId: CommentsType;
  }

  /**
   * Protobuf JSON representation for CommentsUnSubscribeRequest
   */
  export interface AsProtobufJSON {
    itemId: string;
    typeId: string;
  }
}

/**
 * Message implementation for goautowp.GetCommentVotesRequest
 */
export class GetCommentVotesRequest implements GrpcMessage {
  static id = 'goautowp.GetCommentVotesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetCommentVotesRequest();
    GetCommentVotesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetCommentVotesRequest) {
    _instance.commentId = _instance.commentId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetCommentVotesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.commentId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    GetCommentVotesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetCommentVotesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.commentId) {
      _writer.writeInt64String(1, _instance.commentId);
    }
  }

  private _commentId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetCommentVotesRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetCommentVotesRequest.AsObject>) {
    _value = _value || {};
    this.commentId = _value.commentId;
    GetCommentVotesRequest.refineValues(this);
  }
  get commentId(): string {
    return this._commentId;
  }
  set commentId(value: string) {
    this._commentId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetCommentVotesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetCommentVotesRequest.AsObject {
    return {
      commentId: this.commentId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetCommentVotesRequest.AsProtobufJSON {
    return {
      commentId: this.commentId
    };
  }
}
export module GetCommentVotesRequest {
  /**
   * Standard JavaScript object representation for GetCommentVotesRequest
   */
  export interface AsObject {
    commentId: string;
  }

  /**
   * Protobuf JSON representation for GetCommentVotesRequest
   */
  export interface AsProtobufJSON {
    commentId: string;
  }
}

/**
 * Message implementation for goautowp.CommentsViewRequest
 */
export class CommentsViewRequest implements GrpcMessage {
  static id = 'goautowp.CommentsViewRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CommentsViewRequest();
    CommentsViewRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CommentsViewRequest) {
    _instance.itemId = _instance.itemId || '0';
    _instance.typeId = _instance.typeId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CommentsViewRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.itemId = _reader.readInt64String();
          break;
        case 2:
          _instance.typeId = _reader.readEnum();
          break;
        default:
          _reader.skipField();
      }
    }

    CommentsViewRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CommentsViewRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.itemId) {
      _writer.writeInt64String(1, _instance.itemId);
    }
    if (_instance.typeId) {
      _writer.writeEnum(2, _instance.typeId);
    }
  }

  private _itemId: string;
  private _typeId: CommentsType;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CommentsViewRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<CommentsViewRequest.AsObject>) {
    _value = _value || {};
    this.itemId = _value.itemId;
    this.typeId = _value.typeId;
    CommentsViewRequest.refineValues(this);
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get typeId(): CommentsType {
    return this._typeId;
  }
  set typeId(value: CommentsType) {
    this._typeId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CommentsViewRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CommentsViewRequest.AsObject {
    return {
      itemId: this.itemId,
      typeId: this.typeId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CommentsViewRequest.AsProtobufJSON {
    return {
      itemId: this.itemId,
      typeId:
        CommentsType[
          this.typeId === null || this.typeId === undefined ? 0 : this.typeId
        ]
    };
  }
}
export module CommentsViewRequest {
  /**
   * Standard JavaScript object representation for CommentsViewRequest
   */
  export interface AsObject {
    itemId: string;
    typeId: CommentsType;
  }

  /**
   * Protobuf JSON representation for CommentsViewRequest
   */
  export interface AsProtobufJSON {
    itemId: string;
    typeId: string;
  }
}

/**
 * Message implementation for goautowp.CommentsSetDeletedRequest
 */
export class CommentsSetDeletedRequest implements GrpcMessage {
  static id = 'goautowp.CommentsSetDeletedRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CommentsSetDeletedRequest();
    CommentsSetDeletedRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CommentsSetDeletedRequest) {
    _instance.commentId = _instance.commentId || '0';
    _instance.deleted = _instance.deleted || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CommentsSetDeletedRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.commentId = _reader.readInt64String();
          break;
        case 2:
          _instance.deleted = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    CommentsSetDeletedRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CommentsSetDeletedRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.commentId) {
      _writer.writeInt64String(1, _instance.commentId);
    }
    if (_instance.deleted) {
      _writer.writeBool(2, _instance.deleted);
    }
  }

  private _commentId: string;
  private _deleted: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CommentsSetDeletedRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<CommentsSetDeletedRequest.AsObject>) {
    _value = _value || {};
    this.commentId = _value.commentId;
    this.deleted = _value.deleted;
    CommentsSetDeletedRequest.refineValues(this);
  }
  get commentId(): string {
    return this._commentId;
  }
  set commentId(value: string) {
    this._commentId = value;
  }
  get deleted(): boolean {
    return this._deleted;
  }
  set deleted(value: boolean) {
    this._deleted = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CommentsSetDeletedRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CommentsSetDeletedRequest.AsObject {
    return {
      commentId: this.commentId,
      deleted: this.deleted
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CommentsSetDeletedRequest.AsProtobufJSON {
    return {
      commentId: this.commentId,
      deleted: this.deleted
    };
  }
}
export module CommentsSetDeletedRequest {
  /**
   * Standard JavaScript object representation for CommentsSetDeletedRequest
   */
  export interface AsObject {
    commentId: string;
    deleted: boolean;
  }

  /**
   * Protobuf JSON representation for CommentsSetDeletedRequest
   */
  export interface AsProtobufJSON {
    commentId: string;
    deleted: boolean;
  }
}

/**
 * Message implementation for goautowp.CommentsMoveCommentRequest
 */
export class CommentsMoveCommentRequest implements GrpcMessage {
  static id = 'goautowp.CommentsMoveCommentRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CommentsMoveCommentRequest();
    CommentsMoveCommentRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CommentsMoveCommentRequest) {
    _instance.commentId = _instance.commentId || '0';
    _instance.itemId = _instance.itemId || '0';
    _instance.typeId = _instance.typeId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CommentsMoveCommentRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.commentId = _reader.readInt64String();
          break;
        case 2:
          _instance.itemId = _reader.readInt64String();
          break;
        case 3:
          _instance.typeId = _reader.readEnum();
          break;
        default:
          _reader.skipField();
      }
    }

    CommentsMoveCommentRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CommentsMoveCommentRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.commentId) {
      _writer.writeInt64String(1, _instance.commentId);
    }
    if (_instance.itemId) {
      _writer.writeInt64String(2, _instance.itemId);
    }
    if (_instance.typeId) {
      _writer.writeEnum(3, _instance.typeId);
    }
  }

  private _commentId: string;
  private _itemId: string;
  private _typeId: CommentsType;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CommentsMoveCommentRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<CommentsMoveCommentRequest.AsObject>) {
    _value = _value || {};
    this.commentId = _value.commentId;
    this.itemId = _value.itemId;
    this.typeId = _value.typeId;
    CommentsMoveCommentRequest.refineValues(this);
  }
  get commentId(): string {
    return this._commentId;
  }
  set commentId(value: string) {
    this._commentId = value;
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get typeId(): CommentsType {
    return this._typeId;
  }
  set typeId(value: CommentsType) {
    this._typeId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CommentsMoveCommentRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CommentsMoveCommentRequest.AsObject {
    return {
      commentId: this.commentId,
      itemId: this.itemId,
      typeId: this.typeId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CommentsMoveCommentRequest.AsProtobufJSON {
    return {
      commentId: this.commentId,
      itemId: this.itemId,
      typeId:
        CommentsType[
          this.typeId === null || this.typeId === undefined ? 0 : this.typeId
        ]
    };
  }
}
export module CommentsMoveCommentRequest {
  /**
   * Standard JavaScript object representation for CommentsMoveCommentRequest
   */
  export interface AsObject {
    commentId: string;
    itemId: string;
    typeId: CommentsType;
  }

  /**
   * Protobuf JSON representation for CommentsMoveCommentRequest
   */
  export interface AsProtobufJSON {
    commentId: string;
    itemId: string;
    typeId: string;
  }
}

/**
 * Message implementation for goautowp.CommentsVoteCommentRequest
 */
export class CommentsVoteCommentRequest implements GrpcMessage {
  static id = 'goautowp.CommentsVoteCommentRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CommentsVoteCommentRequest();
    CommentsVoteCommentRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CommentsVoteCommentRequest) {
    _instance.commentId = _instance.commentId || '0';
    _instance.vote = _instance.vote || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CommentsVoteCommentRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.commentId = _reader.readInt64String();
          break;
        case 2:
          _instance.vote = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    CommentsVoteCommentRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CommentsVoteCommentRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.commentId) {
      _writer.writeInt64String(1, _instance.commentId);
    }
    if (_instance.vote) {
      _writer.writeInt32(2, _instance.vote);
    }
  }

  private _commentId: string;
  private _vote: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CommentsVoteCommentRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<CommentsVoteCommentRequest.AsObject>) {
    _value = _value || {};
    this.commentId = _value.commentId;
    this.vote = _value.vote;
    CommentsVoteCommentRequest.refineValues(this);
  }
  get commentId(): string {
    return this._commentId;
  }
  set commentId(value: string) {
    this._commentId = value;
  }
  get vote(): number {
    return this._vote;
  }
  set vote(value: number) {
    this._vote = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CommentsVoteCommentRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CommentsVoteCommentRequest.AsObject {
    return {
      commentId: this.commentId,
      vote: this.vote
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CommentsVoteCommentRequest.AsProtobufJSON {
    return {
      commentId: this.commentId,
      vote: this.vote
    };
  }
}
export module CommentsVoteCommentRequest {
  /**
   * Standard JavaScript object representation for CommentsVoteCommentRequest
   */
  export interface AsObject {
    commentId: string;
    vote: number;
  }

  /**
   * Protobuf JSON representation for CommentsVoteCommentRequest
   */
  export interface AsProtobufJSON {
    commentId: string;
    vote: number;
  }
}

/**
 * Message implementation for goautowp.CommentsVoteCommentResponse
 */
export class CommentsVoteCommentResponse implements GrpcMessage {
  static id = 'goautowp.CommentsVoteCommentResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CommentsVoteCommentResponse();
    CommentsVoteCommentResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CommentsVoteCommentResponse) {
    _instance.votes = _instance.votes || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CommentsVoteCommentResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.votes = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    CommentsVoteCommentResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CommentsVoteCommentResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.votes) {
      _writer.writeInt32(1, _instance.votes);
    }
  }

  private _votes: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CommentsVoteCommentResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<CommentsVoteCommentResponse.AsObject>) {
    _value = _value || {};
    this.votes = _value.votes;
    CommentsVoteCommentResponse.refineValues(this);
  }
  get votes(): number {
    return this._votes;
  }
  set votes(value: number) {
    this._votes = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CommentsVoteCommentResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CommentsVoteCommentResponse.AsObject {
    return {
      votes: this.votes
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CommentsVoteCommentResponse.AsProtobufJSON {
    return {
      votes: this.votes
    };
  }
}
export module CommentsVoteCommentResponse {
  /**
   * Standard JavaScript object representation for CommentsVoteCommentResponse
   */
  export interface AsObject {
    votes: number;
  }

  /**
   * Protobuf JSON representation for CommentsVoteCommentResponse
   */
  export interface AsProtobufJSON {
    votes: number;
  }
}

/**
 * Message implementation for goautowp.LogEventsRequest
 */
export class LogEventsRequest implements GrpcMessage {
  static id = 'goautowp.LogEventsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new LogEventsRequest();
    LogEventsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: LogEventsRequest) {
    _instance.articleId = _instance.articleId || '0';
    _instance.itemId = _instance.itemId || '0';
    _instance.pictureId = _instance.pictureId || '0';
    _instance.userId = _instance.userId || '0';
    _instance.page = _instance.page || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: LogEventsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.articleId = _reader.readInt64String();
          break;
        case 2:
          _instance.itemId = _reader.readInt64String();
          break;
        case 3:
          _instance.pictureId = _reader.readInt64String();
          break;
        case 4:
          _instance.userId = _reader.readInt64String();
          break;
        case 5:
          _instance.page = _reader.readUint32();
          break;
        default:
          _reader.skipField();
      }
    }

    LogEventsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: LogEventsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.articleId) {
      _writer.writeInt64String(1, _instance.articleId);
    }
    if (_instance.itemId) {
      _writer.writeInt64String(2, _instance.itemId);
    }
    if (_instance.pictureId) {
      _writer.writeInt64String(3, _instance.pictureId);
    }
    if (_instance.userId) {
      _writer.writeInt64String(4, _instance.userId);
    }
    if (_instance.page) {
      _writer.writeUint32(5, _instance.page);
    }
  }

  private _articleId: string;
  private _itemId: string;
  private _pictureId: string;
  private _userId: string;
  private _page: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of LogEventsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<LogEventsRequest.AsObject>) {
    _value = _value || {};
    this.articleId = _value.articleId;
    this.itemId = _value.itemId;
    this.pictureId = _value.pictureId;
    this.userId = _value.userId;
    this.page = _value.page;
    LogEventsRequest.refineValues(this);
  }
  get articleId(): string {
    return this._articleId;
  }
  set articleId(value: string) {
    this._articleId = value;
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get pictureId(): string {
    return this._pictureId;
  }
  set pictureId(value: string) {
    this._pictureId = value;
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }
  get page(): number {
    return this._page;
  }
  set page(value: number) {
    this._page = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    LogEventsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): LogEventsRequest.AsObject {
    return {
      articleId: this.articleId,
      itemId: this.itemId,
      pictureId: this.pictureId,
      userId: this.userId,
      page: this.page
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): LogEventsRequest.AsProtobufJSON {
    return {
      articleId: this.articleId,
      itemId: this.itemId,
      pictureId: this.pictureId,
      userId: this.userId,
      page: this.page
    };
  }
}
export module LogEventsRequest {
  /**
   * Standard JavaScript object representation for LogEventsRequest
   */
  export interface AsObject {
    articleId: string;
    itemId: string;
    pictureId: string;
    userId: string;
    page: number;
  }

  /**
   * Protobuf JSON representation for LogEventsRequest
   */
  export interface AsProtobufJSON {
    articleId: string;
    itemId: string;
    pictureId: string;
    userId: string;
    page: number;
  }
}

/**
 * Message implementation for goautowp.LogEvents
 */
export class LogEvents implements GrpcMessage {
  static id = 'goautowp.LogEvents';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new LogEvents();
    LogEvents.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: LogEvents) {
    _instance.items = _instance.items || [];
    _instance.paginator = _instance.paginator || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: LogEvents,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new LogEvent();
          _reader.readMessage(
            messageInitializer1,
            LogEvent.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        case 2:
          _instance.paginator = new Pages();
          _reader.readMessage(
            _instance.paginator,
            Pages.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    LogEvents.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: LogEvents, _writer: BinaryWriter) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        LogEvent.serializeBinaryToWriter
      );
    }
    if (_instance.paginator) {
      _writer.writeMessage(
        2,
        _instance.paginator as any,
        Pages.serializeBinaryToWriter
      );
    }
  }

  private _items?: LogEvent[];
  private _paginator?: Pages;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of LogEvents to deeply clone from
   */
  constructor(_value?: RecursivePartial<LogEvents.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new LogEvent(m));
    this.paginator = _value.paginator ? new Pages(_value.paginator) : undefined;
    LogEvents.refineValues(this);
  }
  get items(): LogEvent[] | undefined {
    return this._items;
  }
  set items(value: LogEvent[] | undefined) {
    this._items = value;
  }
  get paginator(): Pages | undefined {
    return this._paginator;
  }
  set paginator(value: Pages | undefined) {
    this._paginator = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    LogEvents.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): LogEvents.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject()),
      paginator: this.paginator ? this.paginator.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): LogEvents.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options)),
      paginator: this.paginator ? this.paginator.toProtobufJSON(options) : null
    };
  }
}
export module LogEvents {
  /**
   * Standard JavaScript object representation for LogEvents
   */
  export interface AsObject {
    items?: LogEvent.AsObject[];
    paginator?: Pages.AsObject;
  }

  /**
   * Protobuf JSON representation for LogEvents
   */
  export interface AsProtobufJSON {
    items: LogEvent.AsProtobufJSON[] | null;
    paginator: Pages.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.LogEvent
 */
export class LogEvent implements GrpcMessage {
  static id = 'goautowp.LogEvent';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new LogEvent();
    LogEvent.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: LogEvent) {
    _instance.createdAt = _instance.createdAt || undefined;
    _instance.description = _instance.description || '';
    _instance.userId = _instance.userId || '0';
    _instance.pictures = _instance.pictures || [];
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: LogEvent,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.createdAt = new googleProtobuf006.Timestamp();
          _reader.readMessage(
            _instance.createdAt,
            googleProtobuf006.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.description = _reader.readString();
          break;
        case 3:
          _instance.userId = _reader.readInt64String();
          break;
        case 4:
          (_instance.pictures = _instance.pictures || []).push(
            ...(_reader.readPackedInt64String() || [])
          );
          break;
        case 5:
          (_instance.items = _instance.items || []).push(
            ...(_reader.readPackedInt64String() || [])
          );
          break;
        default:
          _reader.skipField();
      }
    }

    LogEvent.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: LogEvent, _writer: BinaryWriter) {
    if (_instance.createdAt) {
      _writer.writeMessage(
        1,
        _instance.createdAt as any,
        googleProtobuf006.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.description) {
      _writer.writeString(2, _instance.description);
    }
    if (_instance.userId) {
      _writer.writeInt64String(3, _instance.userId);
    }
    if (_instance.pictures && _instance.pictures.length) {
      _writer.writePackedInt64String(4, _instance.pictures);
    }
    if (_instance.items && _instance.items.length) {
      _writer.writePackedInt64String(5, _instance.items);
    }
  }

  private _createdAt?: googleProtobuf006.Timestamp;
  private _description: string;
  private _userId: string;
  private _pictures: string[];
  private _items: string[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of LogEvent to deeply clone from
   */
  constructor(_value?: RecursivePartial<LogEvent.AsObject>) {
    _value = _value || {};
    this.createdAt = _value.createdAt
      ? new googleProtobuf006.Timestamp(_value.createdAt)
      : undefined;
    this.description = _value.description;
    this.userId = _value.userId;
    this.pictures = (_value.pictures || []).slice();
    this.items = (_value.items || []).slice();
    LogEvent.refineValues(this);
  }
  get createdAt(): googleProtobuf006.Timestamp | undefined {
    return this._createdAt;
  }
  set createdAt(value: googleProtobuf006.Timestamp | undefined) {
    this._createdAt = value;
  }
  get description(): string {
    return this._description;
  }
  set description(value: string) {
    this._description = value;
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }
  get pictures(): string[] {
    return this._pictures;
  }
  set pictures(value: string[]) {
    this._pictures = value;
  }
  get items(): string[] {
    return this._items;
  }
  set items(value: string[]) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    LogEvent.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): LogEvent.AsObject {
    return {
      createdAt: this.createdAt ? this.createdAt.toObject() : undefined,
      description: this.description,
      userId: this.userId,
      pictures: (this.pictures || []).slice(),
      items: (this.items || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): LogEvent.AsProtobufJSON {
    return {
      createdAt: this.createdAt ? this.createdAt.toProtobufJSON(options) : null,
      description: this.description,
      userId: this.userId,
      pictures: (this.pictures || []).slice(),
      items: (this.items || []).slice()
    };
  }
}
export module LogEvent {
  /**
   * Standard JavaScript object representation for LogEvent
   */
  export interface AsObject {
    createdAt?: googleProtobuf006.Timestamp.AsObject;
    description: string;
    userId: string;
    pictures: string[];
    items: string[];
  }

  /**
   * Protobuf JSON representation for LogEvent
   */
  export interface AsProtobufJSON {
    createdAt: googleProtobuf006.Timestamp.AsProtobufJSON | null;
    description: string;
    userId: string;
    pictures: string[];
    items: string[];
  }
}

/**
 * Message implementation for goautowp.MapGetPointsRequest
 */
export class MapGetPointsRequest implements GrpcMessage {
  static id = 'goautowp.MapGetPointsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new MapGetPointsRequest();
    MapGetPointsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: MapGetPointsRequest) {
    _instance.pointsOnly = _instance.pointsOnly || false;
    _instance.bounds = _instance.bounds || '';
    _instance.language = _instance.language || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: MapGetPointsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.pointsOnly = _reader.readBool();
          break;
        case 2:
          _instance.bounds = _reader.readString();
          break;
        case 3:
          _instance.language = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    MapGetPointsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: MapGetPointsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.pointsOnly) {
      _writer.writeBool(1, _instance.pointsOnly);
    }
    if (_instance.bounds) {
      _writer.writeString(2, _instance.bounds);
    }
    if (_instance.language) {
      _writer.writeString(3, _instance.language);
    }
  }

  private _pointsOnly: boolean;
  private _bounds: string;
  private _language: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of MapGetPointsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<MapGetPointsRequest.AsObject>) {
    _value = _value || {};
    this.pointsOnly = _value.pointsOnly;
    this.bounds = _value.bounds;
    this.language = _value.language;
    MapGetPointsRequest.refineValues(this);
  }
  get pointsOnly(): boolean {
    return this._pointsOnly;
  }
  set pointsOnly(value: boolean) {
    this._pointsOnly = value;
  }
  get bounds(): string {
    return this._bounds;
  }
  set bounds(value: string) {
    this._bounds = value;
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    MapGetPointsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): MapGetPointsRequest.AsObject {
    return {
      pointsOnly: this.pointsOnly,
      bounds: this.bounds,
      language: this.language
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): MapGetPointsRequest.AsProtobufJSON {
    return {
      pointsOnly: this.pointsOnly,
      bounds: this.bounds,
      language: this.language
    };
  }
}
export module MapGetPointsRequest {
  /**
   * Standard JavaScript object representation for MapGetPointsRequest
   */
  export interface AsObject {
    pointsOnly: boolean;
    bounds: string;
    language: string;
  }

  /**
   * Protobuf JSON representation for MapGetPointsRequest
   */
  export interface AsProtobufJSON {
    pointsOnly: boolean;
    bounds: string;
    language: string;
  }
}

/**
 * Message implementation for goautowp.MapPoints
 */
export class MapPoints implements GrpcMessage {
  static id = 'goautowp.MapPoints';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new MapPoints();
    MapPoints.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: MapPoints) {
    _instance.points = _instance.points || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: MapPoints,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new MapPoint();
          _reader.readMessage(
            messageInitializer1,
            MapPoint.deserializeBinaryFromReader
          );
          (_instance.points = _instance.points || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    MapPoints.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: MapPoints, _writer: BinaryWriter) {
    if (_instance.points && _instance.points.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.points as any,
        MapPoint.serializeBinaryToWriter
      );
    }
  }

  private _points?: MapPoint[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of MapPoints to deeply clone from
   */
  constructor(_value?: RecursivePartial<MapPoints.AsObject>) {
    _value = _value || {};
    this.points = (_value.points || []).map(m => new MapPoint(m));
    MapPoints.refineValues(this);
  }
  get points(): MapPoint[] | undefined {
    return this._points;
  }
  set points(value: MapPoint[] | undefined) {
    this._points = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    MapPoints.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): MapPoints.AsObject {
    return {
      points: (this.points || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): MapPoints.AsProtobufJSON {
    return {
      points: (this.points || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module MapPoints {
  /**
   * Standard JavaScript object representation for MapPoints
   */
  export interface AsObject {
    points?: MapPoint.AsObject[];
  }

  /**
   * Protobuf JSON representation for MapPoints
   */
  export interface AsProtobufJSON {
    points: MapPoint.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.MapPoint
 */
export class MapPoint implements GrpcMessage {
  static id = 'goautowp.MapPoint';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new MapPoint();
    MapPoint.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: MapPoint) {
    _instance.location = _instance.location || undefined;
    _instance.id = _instance.id || '';
    _instance.name = _instance.name || '';
    _instance.url = _instance.url || [];
    _instance.image = _instance.image || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: MapPoint,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.location = new googleType009.LatLng();
          _reader.readMessage(
            _instance.location,
            googleType009.LatLng.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.id = _reader.readString();
          break;
        case 3:
          _instance.name = _reader.readString();
          break;
        case 4:
          (_instance.url = _instance.url || []).push(_reader.readString());
          break;
        case 5:
          _instance.image = new APIImage();
          _reader.readMessage(
            _instance.image,
            APIImage.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    MapPoint.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: MapPoint, _writer: BinaryWriter) {
    if (_instance.location) {
      _writer.writeMessage(
        1,
        _instance.location as any,
        googleType009.LatLng.serializeBinaryToWriter
      );
    }
    if (_instance.id) {
      _writer.writeString(2, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(3, _instance.name);
    }
    if (_instance.url && _instance.url.length) {
      _writer.writeRepeatedString(4, _instance.url);
    }
    if (_instance.image) {
      _writer.writeMessage(
        5,
        _instance.image as any,
        APIImage.serializeBinaryToWriter
      );
    }
  }

  private _location?: googleType009.LatLng;
  private _id: string;
  private _name: string;
  private _url: string[];
  private _image?: APIImage;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of MapPoint to deeply clone from
   */
  constructor(_value?: RecursivePartial<MapPoint.AsObject>) {
    _value = _value || {};
    this.location = _value.location
      ? new googleType009.LatLng(_value.location)
      : undefined;
    this.id = _value.id;
    this.name = _value.name;
    this.url = (_value.url || []).slice();
    this.image = _value.image ? new APIImage(_value.image) : undefined;
    MapPoint.refineValues(this);
  }
  get location(): googleType009.LatLng | undefined {
    return this._location;
  }
  set location(value: googleType009.LatLng | undefined) {
    this._location = value;
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get url(): string[] {
    return this._url;
  }
  set url(value: string[]) {
    this._url = value;
  }
  get image(): APIImage | undefined {
    return this._image;
  }
  set image(value: APIImage | undefined) {
    this._image = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    MapPoint.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): MapPoint.AsObject {
    return {
      location: this.location ? this.location.toObject() : undefined,
      id: this.id,
      name: this.name,
      url: (this.url || []).slice(),
      image: this.image ? this.image.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): MapPoint.AsProtobufJSON {
    return {
      location: this.location ? this.location.toProtobufJSON(options) : null,
      id: this.id,
      name: this.name,
      url: (this.url || []).slice(),
      image: this.image ? this.image.toProtobufJSON(options) : null
    };
  }
}
export module MapPoint {
  /**
   * Standard JavaScript object representation for MapPoint
   */
  export interface AsObject {
    location?: googleType009.LatLng.AsObject;
    id: string;
    name: string;
    url: string[];
    image?: APIImage.AsObject;
  }

  /**
   * Protobuf JSON representation for MapPoint
   */
  export interface AsProtobufJSON {
    location: googleType009.LatLng.AsProtobufJSON | null;
    id: string;
    name: string;
    url: string[];
    image: APIImage.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.PicturesViewRequest
 */
export class PicturesViewRequest implements GrpcMessage {
  static id = 'goautowp.PicturesViewRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PicturesViewRequest();
    PicturesViewRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PicturesViewRequest) {
    _instance.pictureId = _instance.pictureId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PicturesViewRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.pictureId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    PicturesViewRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PicturesViewRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.pictureId) {
      _writer.writeInt64String(1, _instance.pictureId);
    }
  }

  private _pictureId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PicturesViewRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<PicturesViewRequest.AsObject>) {
    _value = _value || {};
    this.pictureId = _value.pictureId;
    PicturesViewRequest.refineValues(this);
  }
  get pictureId(): string {
    return this._pictureId;
  }
  set pictureId(value: string) {
    this._pictureId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PicturesViewRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PicturesViewRequest.AsObject {
    return {
      pictureId: this.pictureId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PicturesViewRequest.AsProtobufJSON {
    return {
      pictureId: this.pictureId
    };
  }
}
export module PicturesViewRequest {
  /**
   * Standard JavaScript object representation for PicturesViewRequest
   */
  export interface AsObject {
    pictureId: string;
  }

  /**
   * Protobuf JSON representation for PicturesViewRequest
   */
  export interface AsProtobufJSON {
    pictureId: string;
  }
}

/**
 * Message implementation for goautowp.PicturesVoteRequest
 */
export class PicturesVoteRequest implements GrpcMessage {
  static id = 'goautowp.PicturesVoteRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PicturesVoteRequest();
    PicturesVoteRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PicturesVoteRequest) {
    _instance.pictureId = _instance.pictureId || '0';
    _instance.value = _instance.value || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PicturesVoteRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.pictureId = _reader.readInt64String();
          break;
        case 2:
          _instance.value = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    PicturesVoteRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PicturesVoteRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.pictureId) {
      _writer.writeInt64String(1, _instance.pictureId);
    }
    if (_instance.value) {
      _writer.writeInt32(2, _instance.value);
    }
  }

  private _pictureId: string;
  private _value: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PicturesVoteRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<PicturesVoteRequest.AsObject>) {
    _value = _value || {};
    this.pictureId = _value.pictureId;
    this.value = _value.value;
    PicturesVoteRequest.refineValues(this);
  }
  get pictureId(): string {
    return this._pictureId;
  }
  set pictureId(value: string) {
    this._pictureId = value;
  }
  get value(): number {
    return this._value;
  }
  set value(value: number) {
    this._value = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PicturesVoteRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PicturesVoteRequest.AsObject {
    return {
      pictureId: this.pictureId,
      value: this.value
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PicturesVoteRequest.AsProtobufJSON {
    return {
      pictureId: this.pictureId,
      value: this.value
    };
  }
}
export module PicturesVoteRequest {
  /**
   * Standard JavaScript object representation for PicturesVoteRequest
   */
  export interface AsObject {
    pictureId: string;
    value: number;
  }

  /**
   * Protobuf JSON representation for PicturesVoteRequest
   */
  export interface AsProtobufJSON {
    pictureId: string;
    value: number;
  }
}

/**
 * Message implementation for goautowp.PicturesVoteSummary
 */
export class PicturesVoteSummary implements GrpcMessage {
  static id = 'goautowp.PicturesVoteSummary';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PicturesVoteSummary();
    PicturesVoteSummary.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PicturesVoteSummary) {
    _instance.value = _instance.value || 0;
    _instance.positive = _instance.positive || 0;
    _instance.negative = _instance.negative || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PicturesVoteSummary,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.value = _reader.readInt32();
          break;
        case 2:
          _instance.positive = _reader.readInt32();
          break;
        case 3:
          _instance.negative = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    PicturesVoteSummary.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PicturesVoteSummary,
    _writer: BinaryWriter
  ) {
    if (_instance.value) {
      _writer.writeInt32(1, _instance.value);
    }
    if (_instance.positive) {
      _writer.writeInt32(2, _instance.positive);
    }
    if (_instance.negative) {
      _writer.writeInt32(3, _instance.negative);
    }
  }

  private _value: number;
  private _positive: number;
  private _negative: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PicturesVoteSummary to deeply clone from
   */
  constructor(_value?: RecursivePartial<PicturesVoteSummary.AsObject>) {
    _value = _value || {};
    this.value = _value.value;
    this.positive = _value.positive;
    this.negative = _value.negative;
    PicturesVoteSummary.refineValues(this);
  }
  get value(): number {
    return this._value;
  }
  set value(value: number) {
    this._value = value;
  }
  get positive(): number {
    return this._positive;
  }
  set positive(value: number) {
    this._positive = value;
  }
  get negative(): number {
    return this._negative;
  }
  set negative(value: number) {
    this._negative = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PicturesVoteSummary.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PicturesVoteSummary.AsObject {
    return {
      value: this.value,
      positive: this.positive,
      negative: this.negative
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PicturesVoteSummary.AsProtobufJSON {
    return {
      value: this.value,
      positive: this.positive,
      negative: this.negative
    };
  }
}
export module PicturesVoteSummary {
  /**
   * Standard JavaScript object representation for PicturesVoteSummary
   */
  export interface AsObject {
    value: number;
    positive: number;
    negative: number;
  }

  /**
   * Protobuf JSON representation for PicturesVoteSummary
   */
  export interface AsProtobufJSON {
    value: number;
    positive: number;
    negative: number;
  }
}

/**
 * Message implementation for goautowp.ModerVoteTemplate
 */
export class ModerVoteTemplate implements GrpcMessage {
  static id = 'goautowp.ModerVoteTemplate';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ModerVoteTemplate();
    ModerVoteTemplate.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ModerVoteTemplate) {
    _instance.id = _instance.id || '0';
    _instance.userId = _instance.userId || '0';
    _instance.message = _instance.message || '';
    _instance.vote = _instance.vote || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ModerVoteTemplate,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.userId = _reader.readInt64String();
          break;
        case 3:
          _instance.message = _reader.readString();
          break;
        case 4:
          _instance.vote = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    ModerVoteTemplate.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ModerVoteTemplate,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.userId) {
      _writer.writeInt64String(2, _instance.userId);
    }
    if (_instance.message) {
      _writer.writeString(3, _instance.message);
    }
    if (_instance.vote) {
      _writer.writeInt32(4, _instance.vote);
    }
  }

  private _id: string;
  private _userId: string;
  private _message: string;
  private _vote: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ModerVoteTemplate to deeply clone from
   */
  constructor(_value?: RecursivePartial<ModerVoteTemplate.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.userId = _value.userId;
    this.message = _value.message;
    this.vote = _value.vote;
    ModerVoteTemplate.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }
  get message(): string {
    return this._message;
  }
  set message(value: string) {
    this._message = value;
  }
  get vote(): number {
    return this._vote;
  }
  set vote(value: number) {
    this._vote = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ModerVoteTemplate.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ModerVoteTemplate.AsObject {
    return {
      id: this.id,
      userId: this.userId,
      message: this.message,
      vote: this.vote
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ModerVoteTemplate.AsProtobufJSON {
    return {
      id: this.id,
      userId: this.userId,
      message: this.message,
      vote: this.vote
    };
  }
}
export module ModerVoteTemplate {
  /**
   * Standard JavaScript object representation for ModerVoteTemplate
   */
  export interface AsObject {
    id: string;
    userId: string;
    message: string;
    vote: number;
  }

  /**
   * Protobuf JSON representation for ModerVoteTemplate
   */
  export interface AsProtobufJSON {
    id: string;
    userId: string;
    message: string;
    vote: number;
  }
}

/**
 * Message implementation for goautowp.ModerVoteTemplates
 */
export class ModerVoteTemplates implements GrpcMessage {
  static id = 'goautowp.ModerVoteTemplates';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ModerVoteTemplates();
    ModerVoteTemplates.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ModerVoteTemplates) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ModerVoteTemplates,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new ModerVoteTemplate();
          _reader.readMessage(
            messageInitializer1,
            ModerVoteTemplate.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    ModerVoteTemplates.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ModerVoteTemplates,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        ModerVoteTemplate.serializeBinaryToWriter
      );
    }
  }

  private _items?: ModerVoteTemplate[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ModerVoteTemplates to deeply clone from
   */
  constructor(_value?: RecursivePartial<ModerVoteTemplates.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new ModerVoteTemplate(m));
    ModerVoteTemplates.refineValues(this);
  }
  get items(): ModerVoteTemplate[] | undefined {
    return this._items;
  }
  set items(value: ModerVoteTemplate[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ModerVoteTemplates.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ModerVoteTemplates.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ModerVoteTemplates.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module ModerVoteTemplates {
  /**
   * Standard JavaScript object representation for ModerVoteTemplates
   */
  export interface AsObject {
    items?: ModerVoteTemplate.AsObject[];
  }

  /**
   * Protobuf JSON representation for ModerVoteTemplates
   */
  export interface AsProtobufJSON {
    items: ModerVoteTemplate.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.DeleteModerVoteTemplateRequest
 */
export class DeleteModerVoteTemplateRequest implements GrpcMessage {
  static id = 'goautowp.DeleteModerVoteTemplateRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new DeleteModerVoteTemplateRequest();
    DeleteModerVoteTemplateRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: DeleteModerVoteTemplateRequest) {
    _instance.id = _instance.id || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: DeleteModerVoteTemplateRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    DeleteModerVoteTemplateRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: DeleteModerVoteTemplateRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
  }

  private _id: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of DeleteModerVoteTemplateRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<DeleteModerVoteTemplateRequest.AsObject>
  ) {
    _value = _value || {};
    this.id = _value.id;
    DeleteModerVoteTemplateRequest.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    DeleteModerVoteTemplateRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): DeleteModerVoteTemplateRequest.AsObject {
    return {
      id: this.id
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): DeleteModerVoteTemplateRequest.AsProtobufJSON {
    return {
      id: this.id
    };
  }
}
export module DeleteModerVoteTemplateRequest {
  /**
   * Standard JavaScript object representation for DeleteModerVoteTemplateRequest
   */
  export interface AsObject {
    id: string;
  }

  /**
   * Protobuf JSON representation for DeleteModerVoteTemplateRequest
   */
  export interface AsProtobufJSON {
    id: string;
  }
}

/**
 * Message implementation for goautowp.UpdateModerVoteRequest
 */
export class UpdateModerVoteRequest implements GrpcMessage {
  static id = 'goautowp.UpdateModerVoteRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UpdateModerVoteRequest();
    UpdateModerVoteRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UpdateModerVoteRequest) {
    _instance.pictureId = _instance.pictureId || '0';
    _instance.reason = _instance.reason || '';
    _instance.vote = _instance.vote || 0;
    _instance.save = _instance.save || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UpdateModerVoteRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.pictureId = _reader.readInt64String();
          break;
        case 2:
          _instance.reason = _reader.readString();
          break;
        case 3:
          _instance.vote = _reader.readInt32();
          break;
        case 4:
          _instance.save = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    UpdateModerVoteRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: UpdateModerVoteRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.pictureId) {
      _writer.writeInt64String(1, _instance.pictureId);
    }
    if (_instance.reason) {
      _writer.writeString(2, _instance.reason);
    }
    if (_instance.vote) {
      _writer.writeInt32(3, _instance.vote);
    }
    if (_instance.save) {
      _writer.writeBool(4, _instance.save);
    }
  }

  private _pictureId: string;
  private _reason: string;
  private _vote: number;
  private _save: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UpdateModerVoteRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<UpdateModerVoteRequest.AsObject>) {
    _value = _value || {};
    this.pictureId = _value.pictureId;
    this.reason = _value.reason;
    this.vote = _value.vote;
    this.save = _value.save;
    UpdateModerVoteRequest.refineValues(this);
  }
  get pictureId(): string {
    return this._pictureId;
  }
  set pictureId(value: string) {
    this._pictureId = value;
  }
  get reason(): string {
    return this._reason;
  }
  set reason(value: string) {
    this._reason = value;
  }
  get vote(): number {
    return this._vote;
  }
  set vote(value: number) {
    this._vote = value;
  }
  get save(): boolean {
    return this._save;
  }
  set save(value: boolean) {
    this._save = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UpdateModerVoteRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UpdateModerVoteRequest.AsObject {
    return {
      pictureId: this.pictureId,
      reason: this.reason,
      vote: this.vote,
      save: this.save
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UpdateModerVoteRequest.AsProtobufJSON {
    return {
      pictureId: this.pictureId,
      reason: this.reason,
      vote: this.vote,
      save: this.save
    };
  }
}
export module UpdateModerVoteRequest {
  /**
   * Standard JavaScript object representation for UpdateModerVoteRequest
   */
  export interface AsObject {
    pictureId: string;
    reason: string;
    vote: number;
    save: boolean;
  }

  /**
   * Protobuf JSON representation for UpdateModerVoteRequest
   */
  export interface AsProtobufJSON {
    pictureId: string;
    reason: string;
    vote: number;
    save: boolean;
  }
}

/**
 * Message implementation for goautowp.PicturesUserSummary
 */
export class PicturesUserSummary implements GrpcMessage {
  static id = 'goautowp.PicturesUserSummary';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PicturesUserSummary();
    PicturesUserSummary.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PicturesUserSummary) {
    _instance.inboxCount = _instance.inboxCount || 0;
    _instance.acceptedCount = _instance.acceptedCount || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PicturesUserSummary,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.inboxCount = _reader.readInt32();
          break;
        case 2:
          _instance.acceptedCount = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    PicturesUserSummary.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PicturesUserSummary,
    _writer: BinaryWriter
  ) {
    if (_instance.inboxCount) {
      _writer.writeInt32(1, _instance.inboxCount);
    }
    if (_instance.acceptedCount) {
      _writer.writeInt32(2, _instance.acceptedCount);
    }
  }

  private _inboxCount: number;
  private _acceptedCount: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PicturesUserSummary to deeply clone from
   */
  constructor(_value?: RecursivePartial<PicturesUserSummary.AsObject>) {
    _value = _value || {};
    this.inboxCount = _value.inboxCount;
    this.acceptedCount = _value.acceptedCount;
    PicturesUserSummary.refineValues(this);
  }
  get inboxCount(): number {
    return this._inboxCount;
  }
  set inboxCount(value: number) {
    this._inboxCount = value;
  }
  get acceptedCount(): number {
    return this._acceptedCount;
  }
  set acceptedCount(value: number) {
    this._acceptedCount = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PicturesUserSummary.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PicturesUserSummary.AsObject {
    return {
      inboxCount: this.inboxCount,
      acceptedCount: this.acceptedCount
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PicturesUserSummary.AsProtobufJSON {
    return {
      inboxCount: this.inboxCount,
      acceptedCount: this.acceptedCount
    };
  }
}
export module PicturesUserSummary {
  /**
   * Standard JavaScript object representation for PicturesUserSummary
   */
  export interface AsObject {
    inboxCount: number;
    acceptedCount: number;
  }

  /**
   * Protobuf JSON representation for PicturesUserSummary
   */
  export interface AsProtobufJSON {
    inboxCount: number;
    acceptedCount: number;
  }
}

/**
 * Message implementation for goautowp.PictureIDRequest
 */
export class PictureIDRequest implements GrpcMessage {
  static id = 'goautowp.PictureIDRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PictureIDRequest();
    PictureIDRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PictureIDRequest) {
    _instance.id = _instance.id || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PictureIDRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    PictureIDRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PictureIDRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
  }

  private _id: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PictureIDRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<PictureIDRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    PictureIDRequest.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PictureIDRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PictureIDRequest.AsObject {
    return {
      id: this.id
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PictureIDRequest.AsProtobufJSON {
    return {
      id: this.id
    };
  }
}
export module PictureIDRequest {
  /**
   * Standard JavaScript object representation for PictureIDRequest
   */
  export interface AsObject {
    id: string;
  }

  /**
   * Protobuf JSON representation for PictureIDRequest
   */
  export interface AsProtobufJSON {
    id: string;
  }
}

/**
 * Message implementation for goautowp.PicturesRequest
 */
export class PicturesRequest implements GrpcMessage {
  static id = 'goautowp.PicturesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PicturesRequest();
    PicturesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PicturesRequest) {
    _instance.options = _instance.options || undefined;
    _instance.limit = _instance.limit || 0;
    _instance.page = _instance.page || 0;
    _instance.paginator = _instance.paginator || false;
    _instance.fields = _instance.fields || undefined;
    _instance.language = _instance.language || '';
    _instance.order = _instance.order || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PicturesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.options = new PictureListOptions();
          _reader.readMessage(
            _instance.options,
            PictureListOptions.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.limit = _reader.readUint32();
          break;
        case 3:
          _instance.page = _reader.readUint32();
          break;
        case 4:
          _instance.paginator = _reader.readBool();
          break;
        case 5:
          _instance.fields = new PictureFields();
          _reader.readMessage(
            _instance.fields,
            PictureFields.deserializeBinaryFromReader
          );
          break;
        case 6:
          _instance.language = _reader.readString();
          break;
        case 7:
          _instance.order = _reader.readEnum();
          break;
        default:
          _reader.skipField();
      }
    }

    PicturesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PicturesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.options) {
      _writer.writeMessage(
        1,
        _instance.options as any,
        PictureListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.limit) {
      _writer.writeUint32(2, _instance.limit);
    }
    if (_instance.page) {
      _writer.writeUint32(3, _instance.page);
    }
    if (_instance.paginator) {
      _writer.writeBool(4, _instance.paginator);
    }
    if (_instance.fields) {
      _writer.writeMessage(
        5,
        _instance.fields as any,
        PictureFields.serializeBinaryToWriter
      );
    }
    if (_instance.language) {
      _writer.writeString(6, _instance.language);
    }
    if (_instance.order) {
      _writer.writeEnum(7, _instance.order);
    }
  }

  private _options?: PictureListOptions;
  private _limit: number;
  private _page: number;
  private _paginator: boolean;
  private _fields?: PictureFields;
  private _language: string;
  private _order: PicturesRequest.Order;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PicturesRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<PicturesRequest.AsObject>) {
    _value = _value || {};
    this.options = _value.options
      ? new PictureListOptions(_value.options)
      : undefined;
    this.limit = _value.limit;
    this.page = _value.page;
    this.paginator = _value.paginator;
    this.fields = _value.fields ? new PictureFields(_value.fields) : undefined;
    this.language = _value.language;
    this.order = _value.order;
    PicturesRequest.refineValues(this);
  }
  get options(): PictureListOptions | undefined {
    return this._options;
  }
  set options(value: PictureListOptions | undefined) {
    this._options = value;
  }
  get limit(): number {
    return this._limit;
  }
  set limit(value: number) {
    this._limit = value;
  }
  get page(): number {
    return this._page;
  }
  set page(value: number) {
    this._page = value;
  }
  get paginator(): boolean {
    return this._paginator;
  }
  set paginator(value: boolean) {
    this._paginator = value;
  }
  get fields(): PictureFields | undefined {
    return this._fields;
  }
  set fields(value: PictureFields | undefined) {
    this._fields = value;
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }
  get order(): PicturesRequest.Order {
    return this._order;
  }
  set order(value: PicturesRequest.Order) {
    this._order = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PicturesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PicturesRequest.AsObject {
    return {
      options: this.options ? this.options.toObject() : undefined,
      limit: this.limit,
      page: this.page,
      paginator: this.paginator,
      fields: this.fields ? this.fields.toObject() : undefined,
      language: this.language,
      order: this.order
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PicturesRequest.AsProtobufJSON {
    return {
      options: this.options ? this.options.toProtobufJSON(options) : null,
      limit: this.limit,
      page: this.page,
      paginator: this.paginator,
      fields: this.fields ? this.fields.toProtobufJSON(options) : null,
      language: this.language,
      order:
        PicturesRequest.Order[
          this.order === null || this.order === undefined ? 0 : this.order
        ]
    };
  }
}
export module PicturesRequest {
  /**
   * Standard JavaScript object representation for PicturesRequest
   */
  export interface AsObject {
    options?: PictureListOptions.AsObject;
    limit: number;
    page: number;
    paginator: boolean;
    fields?: PictureFields.AsObject;
    language: string;
    order: PicturesRequest.Order;
  }

  /**
   * Protobuf JSON representation for PicturesRequest
   */
  export interface AsProtobufJSON {
    options: PictureListOptions.AsProtobufJSON | null;
    limit: number;
    page: number;
    paginator: boolean;
    fields: PictureFields.AsProtobufJSON | null;
    language: string;
    order: string;
  }
  export enum Order {
    ORDER_NONE = 0,
    ORDER_ADD_DATE_DESC = 1,
    ORDER_ADD_DATE_ASC = 2,
    ORDER_RESOLUTION_DESC = 3,
    ORDER_RESOLUTION_ASC = 4,
    ORDER_FILESIZE_DESC = 5,
    ORDER_FILESIZE_ASC = 6,
    ORDER_COMMENTS = 7,
    ORDER_VIEWS = 8,
    ORDER_MODER_VOTES = 9,
    ORDER_DF_DISTANCE_SIMILARITY = 10,
    ORDER_REMOVING_DATE = 11,
    ORDER_LIKES = 12,
    ORDER_DISLIKES = 13,
    ORDER_STATUS = 14,
    ORDER_ACCEPT_DATETIME_DESC = 15,
    ORDER_PERSPECTIVES = 16,
    ORDER_FRONT_PERSPECTIVES = 17
  }
}

/**
 * Message implementation for goautowp.Picture
 */
export class Picture implements GrpcMessage {
  static id = 'goautowp.Picture';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Picture();
    Picture.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Picture) {
    _instance.id = _instance.id || '0';
    _instance.identity = _instance.identity || '';
    _instance.width = _instance.width || 0;
    _instance.height = _instance.height || 0;
    _instance.image = _instance.image || undefined;
    _instance.point = _instance.point || undefined;
    _instance.copyrightsTextId = _instance.copyrightsTextId || 0;
    _instance.thumbMedium = _instance.thumbMedium || undefined;
    _instance.thumbLarge = _instance.thumbLarge || undefined;
    _instance.nameText = _instance.nameText || '';
    _instance.nameHtml = _instance.nameHtml || '';
    _instance.ownerId = _instance.ownerId || '0';
    _instance.status = _instance.status || 0;
    _instance.cropped = _instance.cropped || false;
    _instance.cropResolution = _instance.cropResolution || '';
    _instance.resolution = _instance.resolution || '';
    _instance.views = _instance.views || 0;
    _instance.votes = _instance.votes || undefined;
    _instance.commentsCountTotal = _instance.commentsCountTotal || 0;
    _instance.commentsCountNew = _instance.commentsCountNew || 0;
    _instance.moderVoteVote = _instance.moderVoteVote || 0;
    _instance.moderVoteCount = _instance.moderVoteCount || 0;
    _instance.path = _instance.path || [];
    _instance.pictureItems = _instance.pictureItems || undefined;
    _instance.imageGallery = _instance.imageGallery || undefined;
    _instance.imageGalleryFull = _instance.imageGalleryFull || undefined;
    _instance.dfDistances = _instance.dfDistances || undefined;
    _instance.acceptedCount = _instance.acceptedCount || 0;
    _instance.addDate = _instance.addDate || undefined;
    _instance.copyrights = _instance.copyrights || '';
    _instance.exif = _instance.exif || '';
    _instance.isLast = _instance.isLast || false;
    _instance.moderVoted = _instance.moderVoted || false;
    _instance.pictureModerVotes = _instance.pictureModerVotes || undefined;
    _instance.replaceable = _instance.replaceable || undefined;
    _instance.rights = _instance.rights || undefined;
    _instance.siblings = _instance.siblings || undefined;
    _instance.specialName = _instance.specialName || '';
    _instance.takenDate = _instance.takenDate || undefined;
    _instance.changeStatusUserId = _instance.changeStatusUserId || '0';
    _instance.ip = _instance.ip || '';
    _instance.dpiX = _instance.dpiX || 0;
    _instance.dpiY = _instance.dpiY || 0;
    _instance.previewLarge = _instance.previewLarge || undefined;
    _instance.subscribed = _instance.subscribed || false;
    _instance.paginator = _instance.paginator || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: Picture,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 8:
          _instance.identity = _reader.readString();
          break;
        case 2:
          _instance.width = _reader.readUint32();
          break;
        case 3:
          _instance.height = _reader.readUint32();
          break;
        case 4:
          _instance.image = new APIImage();
          _reader.readMessage(
            _instance.image,
            APIImage.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.point = new googleType009.LatLng();
          _reader.readMessage(
            _instance.point,
            googleType009.LatLng.deserializeBinaryFromReader
          );
          break;
        case 6:
          _instance.copyrightsTextId = _reader.readInt32();
          break;
        case 7:
          _instance.thumbMedium = new APIImage();
          _reader.readMessage(
            _instance.thumbMedium,
            APIImage.deserializeBinaryFromReader
          );
          break;
        case 46:
          _instance.thumbLarge = new APIImage();
          _reader.readMessage(
            _instance.thumbLarge,
            APIImage.deserializeBinaryFromReader
          );
          break;
        case 9:
          _instance.nameText = _reader.readString();
          break;
        case 10:
          _instance.nameHtml = _reader.readString();
          break;
        case 11:
          _instance.ownerId = _reader.readInt64String();
          break;
        case 12:
          _instance.status = _reader.readEnum();
          break;
        case 13:
          _instance.cropped = _reader.readBool();
          break;
        case 14:
          _instance.cropResolution = _reader.readString();
          break;
        case 15:
          _instance.resolution = _reader.readString();
          break;
        case 16:
          _instance.views = _reader.readInt32();
          break;
        case 17:
          _instance.votes = new PicturesVoteSummary();
          _reader.readMessage(
            _instance.votes,
            PicturesVoteSummary.deserializeBinaryFromReader
          );
          break;
        case 18:
          _instance.commentsCountTotal = _reader.readInt32();
          break;
        case 19:
          _instance.commentsCountNew = _reader.readInt32();
          break;
        case 20:
          _instance.moderVoteVote = _reader.readInt32();
          break;
        case 21:
          _instance.moderVoteCount = _reader.readInt32();
          break;
        case 23:
          const messageInitializer23 = new PathTreePictureItem();
          _reader.readMessage(
            messageInitializer23,
            PathTreePictureItem.deserializeBinaryFromReader
          );
          (_instance.path = _instance.path || []).push(messageInitializer23);
          break;
        case 24:
          _instance.pictureItems = new PictureItems();
          _reader.readMessage(
            _instance.pictureItems,
            PictureItems.deserializeBinaryFromReader
          );
          break;
        case 47:
          _instance.imageGallery = new APIImage();
          _reader.readMessage(
            _instance.imageGallery,
            APIImage.deserializeBinaryFromReader
          );
          break;
        case 25:
          _instance.imageGalleryFull = new APIImage();
          _reader.readMessage(
            _instance.imageGalleryFull,
            APIImage.deserializeBinaryFromReader
          );
          break;
        case 26:
          _instance.dfDistances = new DfDistances();
          _reader.readMessage(
            _instance.dfDistances,
            DfDistances.deserializeBinaryFromReader
          );
          break;
        case 27:
          _instance.acceptedCount = _reader.readInt32();
          break;
        case 28:
          _instance.addDate = new googleProtobuf006.Timestamp();
          _reader.readMessage(
            _instance.addDate,
            googleProtobuf006.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 29:
          _instance.copyrights = _reader.readString();
          break;
        case 30:
          _instance.exif = _reader.readString();
          break;
        case 31:
          _instance.isLast = _reader.readBool();
          break;
        case 32:
          _instance.moderVoted = _reader.readBool();
          break;
        case 33:
          _instance.pictureModerVotes = new PictureModerVotes();
          _reader.readMessage(
            _instance.pictureModerVotes,
            PictureModerVotes.deserializeBinaryFromReader
          );
          break;
        case 34:
          _instance.replaceable = new Picture();
          _reader.readMessage(
            _instance.replaceable,
            Picture.deserializeBinaryFromReader
          );
          break;
        case 35:
          _instance.rights = new PictureRights();
          _reader.readMessage(
            _instance.rights,
            PictureRights.deserializeBinaryFromReader
          );
          break;
        case 36:
          _instance.siblings = new PictureSiblings();
          _reader.readMessage(
            _instance.siblings,
            PictureSiblings.deserializeBinaryFromReader
          );
          break;
        case 37:
          _instance.specialName = _reader.readString();
          break;
        case 38:
          _instance.takenDate = new googleType010.Date();
          _reader.readMessage(
            _instance.takenDate,
            googleType010.Date.deserializeBinaryFromReader
          );
          break;
        case 39:
          _instance.changeStatusUserId = _reader.readInt64String();
          break;
        case 40:
          _instance.ip = _reader.readString();
          break;
        case 41:
          _instance.dpiX = _reader.readInt32();
          break;
        case 42:
          _instance.dpiY = _reader.readInt32();
          break;
        case 43:
          _instance.previewLarge = new APIImage();
          _reader.readMessage(
            _instance.previewLarge,
            APIImage.deserializeBinaryFromReader
          );
          break;
        case 44:
          _instance.subscribed = _reader.readBool();
          break;
        case 45:
          _instance.paginator = new PicturesPages();
          _reader.readMessage(
            _instance.paginator,
            PicturesPages.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    Picture.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Picture, _writer: BinaryWriter) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.identity) {
      _writer.writeString(8, _instance.identity);
    }
    if (_instance.width) {
      _writer.writeUint32(2, _instance.width);
    }
    if (_instance.height) {
      _writer.writeUint32(3, _instance.height);
    }
    if (_instance.image) {
      _writer.writeMessage(
        4,
        _instance.image as any,
        APIImage.serializeBinaryToWriter
      );
    }
    if (_instance.point) {
      _writer.writeMessage(
        5,
        _instance.point as any,
        googleType009.LatLng.serializeBinaryToWriter
      );
    }
    if (_instance.copyrightsTextId) {
      _writer.writeInt32(6, _instance.copyrightsTextId);
    }
    if (_instance.thumbMedium) {
      _writer.writeMessage(
        7,
        _instance.thumbMedium as any,
        APIImage.serializeBinaryToWriter
      );
    }
    if (_instance.thumbLarge) {
      _writer.writeMessage(
        46,
        _instance.thumbLarge as any,
        APIImage.serializeBinaryToWriter
      );
    }
    if (_instance.nameText) {
      _writer.writeString(9, _instance.nameText);
    }
    if (_instance.nameHtml) {
      _writer.writeString(10, _instance.nameHtml);
    }
    if (_instance.ownerId) {
      _writer.writeInt64String(11, _instance.ownerId);
    }
    if (_instance.status) {
      _writer.writeEnum(12, _instance.status);
    }
    if (_instance.cropped) {
      _writer.writeBool(13, _instance.cropped);
    }
    if (_instance.cropResolution) {
      _writer.writeString(14, _instance.cropResolution);
    }
    if (_instance.resolution) {
      _writer.writeString(15, _instance.resolution);
    }
    if (_instance.views) {
      _writer.writeInt32(16, _instance.views);
    }
    if (_instance.votes) {
      _writer.writeMessage(
        17,
        _instance.votes as any,
        PicturesVoteSummary.serializeBinaryToWriter
      );
    }
    if (_instance.commentsCountTotal) {
      _writer.writeInt32(18, _instance.commentsCountTotal);
    }
    if (_instance.commentsCountNew) {
      _writer.writeInt32(19, _instance.commentsCountNew);
    }
    if (_instance.moderVoteVote) {
      _writer.writeInt32(20, _instance.moderVoteVote);
    }
    if (_instance.moderVoteCount) {
      _writer.writeInt32(21, _instance.moderVoteCount);
    }
    if (_instance.path && _instance.path.length) {
      _writer.writeRepeatedMessage(
        23,
        _instance.path as any,
        PathTreePictureItem.serializeBinaryToWriter
      );
    }
    if (_instance.pictureItems) {
      _writer.writeMessage(
        24,
        _instance.pictureItems as any,
        PictureItems.serializeBinaryToWriter
      );
    }
    if (_instance.imageGallery) {
      _writer.writeMessage(
        47,
        _instance.imageGallery as any,
        APIImage.serializeBinaryToWriter
      );
    }
    if (_instance.imageGalleryFull) {
      _writer.writeMessage(
        25,
        _instance.imageGalleryFull as any,
        APIImage.serializeBinaryToWriter
      );
    }
    if (_instance.dfDistances) {
      _writer.writeMessage(
        26,
        _instance.dfDistances as any,
        DfDistances.serializeBinaryToWriter
      );
    }
    if (_instance.acceptedCount) {
      _writer.writeInt32(27, _instance.acceptedCount);
    }
    if (_instance.addDate) {
      _writer.writeMessage(
        28,
        _instance.addDate as any,
        googleProtobuf006.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.copyrights) {
      _writer.writeString(29, _instance.copyrights);
    }
    if (_instance.exif) {
      _writer.writeString(30, _instance.exif);
    }
    if (_instance.isLast) {
      _writer.writeBool(31, _instance.isLast);
    }
    if (_instance.moderVoted) {
      _writer.writeBool(32, _instance.moderVoted);
    }
    if (_instance.pictureModerVotes) {
      _writer.writeMessage(
        33,
        _instance.pictureModerVotes as any,
        PictureModerVotes.serializeBinaryToWriter
      );
    }
    if (_instance.replaceable) {
      _writer.writeMessage(
        34,
        _instance.replaceable as any,
        Picture.serializeBinaryToWriter
      );
    }
    if (_instance.rights) {
      _writer.writeMessage(
        35,
        _instance.rights as any,
        PictureRights.serializeBinaryToWriter
      );
    }
    if (_instance.siblings) {
      _writer.writeMessage(
        36,
        _instance.siblings as any,
        PictureSiblings.serializeBinaryToWriter
      );
    }
    if (_instance.specialName) {
      _writer.writeString(37, _instance.specialName);
    }
    if (_instance.takenDate) {
      _writer.writeMessage(
        38,
        _instance.takenDate as any,
        googleType010.Date.serializeBinaryToWriter
      );
    }
    if (_instance.changeStatusUserId) {
      _writer.writeInt64String(39, _instance.changeStatusUserId);
    }
    if (_instance.ip) {
      _writer.writeString(40, _instance.ip);
    }
    if (_instance.dpiX) {
      _writer.writeInt32(41, _instance.dpiX);
    }
    if (_instance.dpiY) {
      _writer.writeInt32(42, _instance.dpiY);
    }
    if (_instance.previewLarge) {
      _writer.writeMessage(
        43,
        _instance.previewLarge as any,
        APIImage.serializeBinaryToWriter
      );
    }
    if (_instance.subscribed) {
      _writer.writeBool(44, _instance.subscribed);
    }
    if (_instance.paginator) {
      _writer.writeMessage(
        45,
        _instance.paginator as any,
        PicturesPages.serializeBinaryToWriter
      );
    }
  }

  private _id: string;
  private _identity: string;
  private _width: number;
  private _height: number;
  private _image?: APIImage;
  private _point?: googleType009.LatLng;
  private _copyrightsTextId: number;
  private _thumbMedium?: APIImage;
  private _thumbLarge?: APIImage;
  private _nameText: string;
  private _nameHtml: string;
  private _ownerId: string;
  private _status: PictureStatus;
  private _cropped: boolean;
  private _cropResolution: string;
  private _resolution: string;
  private _views: number;
  private _votes?: PicturesVoteSummary;
  private _commentsCountTotal: number;
  private _commentsCountNew: number;
  private _moderVoteVote: number;
  private _moderVoteCount: number;
  private _path?: PathTreePictureItem[];
  private _pictureItems?: PictureItems;
  private _imageGallery?: APIImage;
  private _imageGalleryFull?: APIImage;
  private _dfDistances?: DfDistances;
  private _acceptedCount: number;
  private _addDate?: googleProtobuf006.Timestamp;
  private _copyrights: string;
  private _exif: string;
  private _isLast: boolean;
  private _moderVoted: boolean;
  private _pictureModerVotes?: PictureModerVotes;
  private _replaceable?: Picture;
  private _rights?: PictureRights;
  private _siblings?: PictureSiblings;
  private _specialName: string;
  private _takenDate?: googleType010.Date;
  private _changeStatusUserId: string;
  private _ip: string;
  private _dpiX: number;
  private _dpiY: number;
  private _previewLarge?: APIImage;
  private _subscribed: boolean;
  private _paginator?: PicturesPages;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Picture to deeply clone from
   */
  constructor(_value?: RecursivePartial<Picture.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.identity = _value.identity;
    this.width = _value.width;
    this.height = _value.height;
    this.image = _value.image ? new APIImage(_value.image) : undefined;
    this.point = _value.point
      ? new googleType009.LatLng(_value.point)
      : undefined;
    this.copyrightsTextId = _value.copyrightsTextId;
    this.thumbMedium = _value.thumbMedium
      ? new APIImage(_value.thumbMedium)
      : undefined;
    this.thumbLarge = _value.thumbLarge
      ? new APIImage(_value.thumbLarge)
      : undefined;
    this.nameText = _value.nameText;
    this.nameHtml = _value.nameHtml;
    this.ownerId = _value.ownerId;
    this.status = _value.status;
    this.cropped = _value.cropped;
    this.cropResolution = _value.cropResolution;
    this.resolution = _value.resolution;
    this.views = _value.views;
    this.votes = _value.votes
      ? new PicturesVoteSummary(_value.votes)
      : undefined;
    this.commentsCountTotal = _value.commentsCountTotal;
    this.commentsCountNew = _value.commentsCountNew;
    this.moderVoteVote = _value.moderVoteVote;
    this.moderVoteCount = _value.moderVoteCount;
    this.path = (_value.path || []).map(m => new PathTreePictureItem(m));
    this.pictureItems = _value.pictureItems
      ? new PictureItems(_value.pictureItems)
      : undefined;
    this.imageGallery = _value.imageGallery
      ? new APIImage(_value.imageGallery)
      : undefined;
    this.imageGalleryFull = _value.imageGalleryFull
      ? new APIImage(_value.imageGalleryFull)
      : undefined;
    this.dfDistances = _value.dfDistances
      ? new DfDistances(_value.dfDistances)
      : undefined;
    this.acceptedCount = _value.acceptedCount;
    this.addDate = _value.addDate
      ? new googleProtobuf006.Timestamp(_value.addDate)
      : undefined;
    this.copyrights = _value.copyrights;
    this.exif = _value.exif;
    this.isLast = _value.isLast;
    this.moderVoted = _value.moderVoted;
    this.pictureModerVotes = _value.pictureModerVotes
      ? new PictureModerVotes(_value.pictureModerVotes)
      : undefined;
    this.replaceable = _value.replaceable
      ? new Picture(_value.replaceable)
      : undefined;
    this.rights = _value.rights ? new PictureRights(_value.rights) : undefined;
    this.siblings = _value.siblings
      ? new PictureSiblings(_value.siblings)
      : undefined;
    this.specialName = _value.specialName;
    this.takenDate = _value.takenDate
      ? new googleType010.Date(_value.takenDate)
      : undefined;
    this.changeStatusUserId = _value.changeStatusUserId;
    this.ip = _value.ip;
    this.dpiX = _value.dpiX;
    this.dpiY = _value.dpiY;
    this.previewLarge = _value.previewLarge
      ? new APIImage(_value.previewLarge)
      : undefined;
    this.subscribed = _value.subscribed;
    this.paginator = _value.paginator
      ? new PicturesPages(_value.paginator)
      : undefined;
    Picture.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get identity(): string {
    return this._identity;
  }
  set identity(value: string) {
    this._identity = value;
  }
  get width(): number {
    return this._width;
  }
  set width(value: number) {
    this._width = value;
  }
  get height(): number {
    return this._height;
  }
  set height(value: number) {
    this._height = value;
  }
  get image(): APIImage | undefined {
    return this._image;
  }
  set image(value: APIImage | undefined) {
    this._image = value;
  }
  get point(): googleType009.LatLng | undefined {
    return this._point;
  }
  set point(value: googleType009.LatLng | undefined) {
    this._point = value;
  }
  get copyrightsTextId(): number {
    return this._copyrightsTextId;
  }
  set copyrightsTextId(value: number) {
    this._copyrightsTextId = value;
  }
  get thumbMedium(): APIImage | undefined {
    return this._thumbMedium;
  }
  set thumbMedium(value: APIImage | undefined) {
    this._thumbMedium = value;
  }
  get thumbLarge(): APIImage | undefined {
    return this._thumbLarge;
  }
  set thumbLarge(value: APIImage | undefined) {
    this._thumbLarge = value;
  }
  get nameText(): string {
    return this._nameText;
  }
  set nameText(value: string) {
    this._nameText = value;
  }
  get nameHtml(): string {
    return this._nameHtml;
  }
  set nameHtml(value: string) {
    this._nameHtml = value;
  }
  get ownerId(): string {
    return this._ownerId;
  }
  set ownerId(value: string) {
    this._ownerId = value;
  }
  get status(): PictureStatus {
    return this._status;
  }
  set status(value: PictureStatus) {
    this._status = value;
  }
  get cropped(): boolean {
    return this._cropped;
  }
  set cropped(value: boolean) {
    this._cropped = value;
  }
  get cropResolution(): string {
    return this._cropResolution;
  }
  set cropResolution(value: string) {
    this._cropResolution = value;
  }
  get resolution(): string {
    return this._resolution;
  }
  set resolution(value: string) {
    this._resolution = value;
  }
  get views(): number {
    return this._views;
  }
  set views(value: number) {
    this._views = value;
  }
  get votes(): PicturesVoteSummary | undefined {
    return this._votes;
  }
  set votes(value: PicturesVoteSummary | undefined) {
    this._votes = value;
  }
  get commentsCountTotal(): number {
    return this._commentsCountTotal;
  }
  set commentsCountTotal(value: number) {
    this._commentsCountTotal = value;
  }
  get commentsCountNew(): number {
    return this._commentsCountNew;
  }
  set commentsCountNew(value: number) {
    this._commentsCountNew = value;
  }
  get moderVoteVote(): number {
    return this._moderVoteVote;
  }
  set moderVoteVote(value: number) {
    this._moderVoteVote = value;
  }
  get moderVoteCount(): number {
    return this._moderVoteCount;
  }
  set moderVoteCount(value: number) {
    this._moderVoteCount = value;
  }
  get path(): PathTreePictureItem[] | undefined {
    return this._path;
  }
  set path(value: PathTreePictureItem[] | undefined) {
    this._path = value;
  }
  get pictureItems(): PictureItems | undefined {
    return this._pictureItems;
  }
  set pictureItems(value: PictureItems | undefined) {
    this._pictureItems = value;
  }
  get imageGallery(): APIImage | undefined {
    return this._imageGallery;
  }
  set imageGallery(value: APIImage | undefined) {
    this._imageGallery = value;
  }
  get imageGalleryFull(): APIImage | undefined {
    return this._imageGalleryFull;
  }
  set imageGalleryFull(value: APIImage | undefined) {
    this._imageGalleryFull = value;
  }
  get dfDistances(): DfDistances | undefined {
    return this._dfDistances;
  }
  set dfDistances(value: DfDistances | undefined) {
    this._dfDistances = value;
  }
  get acceptedCount(): number {
    return this._acceptedCount;
  }
  set acceptedCount(value: number) {
    this._acceptedCount = value;
  }
  get addDate(): googleProtobuf006.Timestamp | undefined {
    return this._addDate;
  }
  set addDate(value: googleProtobuf006.Timestamp | undefined) {
    this._addDate = value;
  }
  get copyrights(): string {
    return this._copyrights;
  }
  set copyrights(value: string) {
    this._copyrights = value;
  }
  get exif(): string {
    return this._exif;
  }
  set exif(value: string) {
    this._exif = value;
  }
  get isLast(): boolean {
    return this._isLast;
  }
  set isLast(value: boolean) {
    this._isLast = value;
  }
  get moderVoted(): boolean {
    return this._moderVoted;
  }
  set moderVoted(value: boolean) {
    this._moderVoted = value;
  }
  get pictureModerVotes(): PictureModerVotes | undefined {
    return this._pictureModerVotes;
  }
  set pictureModerVotes(value: PictureModerVotes | undefined) {
    this._pictureModerVotes = value;
  }
  get replaceable(): Picture | undefined {
    return this._replaceable;
  }
  set replaceable(value: Picture | undefined) {
    this._replaceable = value;
  }
  get rights(): PictureRights | undefined {
    return this._rights;
  }
  set rights(value: PictureRights | undefined) {
    this._rights = value;
  }
  get siblings(): PictureSiblings | undefined {
    return this._siblings;
  }
  set siblings(value: PictureSiblings | undefined) {
    this._siblings = value;
  }
  get specialName(): string {
    return this._specialName;
  }
  set specialName(value: string) {
    this._specialName = value;
  }
  get takenDate(): googleType010.Date | undefined {
    return this._takenDate;
  }
  set takenDate(value: googleType010.Date | undefined) {
    this._takenDate = value;
  }
  get changeStatusUserId(): string {
    return this._changeStatusUserId;
  }
  set changeStatusUserId(value: string) {
    this._changeStatusUserId = value;
  }
  get ip(): string {
    return this._ip;
  }
  set ip(value: string) {
    this._ip = value;
  }
  get dpiX(): number {
    return this._dpiX;
  }
  set dpiX(value: number) {
    this._dpiX = value;
  }
  get dpiY(): number {
    return this._dpiY;
  }
  set dpiY(value: number) {
    this._dpiY = value;
  }
  get previewLarge(): APIImage | undefined {
    return this._previewLarge;
  }
  set previewLarge(value: APIImage | undefined) {
    this._previewLarge = value;
  }
  get subscribed(): boolean {
    return this._subscribed;
  }
  set subscribed(value: boolean) {
    this._subscribed = value;
  }
  get paginator(): PicturesPages | undefined {
    return this._paginator;
  }
  set paginator(value: PicturesPages | undefined) {
    this._paginator = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Picture.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Picture.AsObject {
    return {
      id: this.id,
      identity: this.identity,
      width: this.width,
      height: this.height,
      image: this.image ? this.image.toObject() : undefined,
      point: this.point ? this.point.toObject() : undefined,
      copyrightsTextId: this.copyrightsTextId,
      thumbMedium: this.thumbMedium ? this.thumbMedium.toObject() : undefined,
      thumbLarge: this.thumbLarge ? this.thumbLarge.toObject() : undefined,
      nameText: this.nameText,
      nameHtml: this.nameHtml,
      ownerId: this.ownerId,
      status: this.status,
      cropped: this.cropped,
      cropResolution: this.cropResolution,
      resolution: this.resolution,
      views: this.views,
      votes: this.votes ? this.votes.toObject() : undefined,
      commentsCountTotal: this.commentsCountTotal,
      commentsCountNew: this.commentsCountNew,
      moderVoteVote: this.moderVoteVote,
      moderVoteCount: this.moderVoteCount,
      path: (this.path || []).map(m => m.toObject()),
      pictureItems: this.pictureItems
        ? this.pictureItems.toObject()
        : undefined,
      imageGallery: this.imageGallery
        ? this.imageGallery.toObject()
        : undefined,
      imageGalleryFull: this.imageGalleryFull
        ? this.imageGalleryFull.toObject()
        : undefined,
      dfDistances: this.dfDistances ? this.dfDistances.toObject() : undefined,
      acceptedCount: this.acceptedCount,
      addDate: this.addDate ? this.addDate.toObject() : undefined,
      copyrights: this.copyrights,
      exif: this.exif,
      isLast: this.isLast,
      moderVoted: this.moderVoted,
      pictureModerVotes: this.pictureModerVotes
        ? this.pictureModerVotes.toObject()
        : undefined,
      replaceable: this.replaceable ? this.replaceable.toObject() : undefined,
      rights: this.rights ? this.rights.toObject() : undefined,
      siblings: this.siblings ? this.siblings.toObject() : undefined,
      specialName: this.specialName,
      takenDate: this.takenDate ? this.takenDate.toObject() : undefined,
      changeStatusUserId: this.changeStatusUserId,
      ip: this.ip,
      dpiX: this.dpiX,
      dpiY: this.dpiY,
      previewLarge: this.previewLarge
        ? this.previewLarge.toObject()
        : undefined,
      subscribed: this.subscribed,
      paginator: this.paginator ? this.paginator.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Picture.AsProtobufJSON {
    return {
      id: this.id,
      identity: this.identity,
      width: this.width,
      height: this.height,
      image: this.image ? this.image.toProtobufJSON(options) : null,
      point: this.point ? this.point.toProtobufJSON(options) : null,
      copyrightsTextId: this.copyrightsTextId,
      thumbMedium: this.thumbMedium
        ? this.thumbMedium.toProtobufJSON(options)
        : null,
      thumbLarge: this.thumbLarge
        ? this.thumbLarge.toProtobufJSON(options)
        : null,
      nameText: this.nameText,
      nameHtml: this.nameHtml,
      ownerId: this.ownerId,
      status:
        PictureStatus[
          this.status === null || this.status === undefined ? 0 : this.status
        ],
      cropped: this.cropped,
      cropResolution: this.cropResolution,
      resolution: this.resolution,
      views: this.views,
      votes: this.votes ? this.votes.toProtobufJSON(options) : null,
      commentsCountTotal: this.commentsCountTotal,
      commentsCountNew: this.commentsCountNew,
      moderVoteVote: this.moderVoteVote,
      moderVoteCount: this.moderVoteCount,
      path: (this.path || []).map(m => m.toProtobufJSON(options)),
      pictureItems: this.pictureItems
        ? this.pictureItems.toProtobufJSON(options)
        : null,
      imageGallery: this.imageGallery
        ? this.imageGallery.toProtobufJSON(options)
        : null,
      imageGalleryFull: this.imageGalleryFull
        ? this.imageGalleryFull.toProtobufJSON(options)
        : null,
      dfDistances: this.dfDistances
        ? this.dfDistances.toProtobufJSON(options)
        : null,
      acceptedCount: this.acceptedCount,
      addDate: this.addDate ? this.addDate.toProtobufJSON(options) : null,
      copyrights: this.copyrights,
      exif: this.exif,
      isLast: this.isLast,
      moderVoted: this.moderVoted,
      pictureModerVotes: this.pictureModerVotes
        ? this.pictureModerVotes.toProtobufJSON(options)
        : null,
      replaceable: this.replaceable
        ? this.replaceable.toProtobufJSON(options)
        : null,
      rights: this.rights ? this.rights.toProtobufJSON(options) : null,
      siblings: this.siblings ? this.siblings.toProtobufJSON(options) : null,
      specialName: this.specialName,
      takenDate: this.takenDate ? this.takenDate.toProtobufJSON(options) : null,
      changeStatusUserId: this.changeStatusUserId,
      ip: this.ip,
      dpiX: this.dpiX,
      dpiY: this.dpiY,
      previewLarge: this.previewLarge
        ? this.previewLarge.toProtobufJSON(options)
        : null,
      subscribed: this.subscribed,
      paginator: this.paginator ? this.paginator.toProtobufJSON(options) : null
    };
  }
}
export module Picture {
  /**
   * Standard JavaScript object representation for Picture
   */
  export interface AsObject {
    id: string;
    identity: string;
    width: number;
    height: number;
    image?: APIImage.AsObject;
    point?: googleType009.LatLng.AsObject;
    copyrightsTextId: number;
    thumbMedium?: APIImage.AsObject;
    thumbLarge?: APIImage.AsObject;
    nameText: string;
    nameHtml: string;
    ownerId: string;
    status: PictureStatus;
    cropped: boolean;
    cropResolution: string;
    resolution: string;
    views: number;
    votes?: PicturesVoteSummary.AsObject;
    commentsCountTotal: number;
    commentsCountNew: number;
    moderVoteVote: number;
    moderVoteCount: number;
    path?: PathTreePictureItem.AsObject[];
    pictureItems?: PictureItems.AsObject;
    imageGallery?: APIImage.AsObject;
    imageGalleryFull?: APIImage.AsObject;
    dfDistances?: DfDistances.AsObject;
    acceptedCount: number;
    addDate?: googleProtobuf006.Timestamp.AsObject;
    copyrights: string;
    exif: string;
    isLast: boolean;
    moderVoted: boolean;
    pictureModerVotes?: PictureModerVotes.AsObject;
    replaceable?: Picture.AsObject;
    rights?: PictureRights.AsObject;
    siblings?: PictureSiblings.AsObject;
    specialName: string;
    takenDate?: googleType010.Date.AsObject;
    changeStatusUserId: string;
    ip: string;
    dpiX: number;
    dpiY: number;
    previewLarge?: APIImage.AsObject;
    subscribed: boolean;
    paginator?: PicturesPages.AsObject;
  }

  /**
   * Protobuf JSON representation for Picture
   */
  export interface AsProtobufJSON {
    id: string;
    identity: string;
    width: number;
    height: number;
    image: APIImage.AsProtobufJSON | null;
    point: googleType009.LatLng.AsProtobufJSON | null;
    copyrightsTextId: number;
    thumbMedium: APIImage.AsProtobufJSON | null;
    thumbLarge: APIImage.AsProtobufJSON | null;
    nameText: string;
    nameHtml: string;
    ownerId: string;
    status: string;
    cropped: boolean;
    cropResolution: string;
    resolution: string;
    views: number;
    votes: PicturesVoteSummary.AsProtobufJSON | null;
    commentsCountTotal: number;
    commentsCountNew: number;
    moderVoteVote: number;
    moderVoteCount: number;
    path: PathTreePictureItem.AsProtobufJSON[] | null;
    pictureItems: PictureItems.AsProtobufJSON | null;
    imageGallery: APIImage.AsProtobufJSON | null;
    imageGalleryFull: APIImage.AsProtobufJSON | null;
    dfDistances: DfDistances.AsProtobufJSON | null;
    acceptedCount: number;
    addDate: googleProtobuf006.Timestamp.AsProtobufJSON | null;
    copyrights: string;
    exif: string;
    isLast: boolean;
    moderVoted: boolean;
    pictureModerVotes: PictureModerVotes.AsProtobufJSON | null;
    replaceable: Picture.AsProtobufJSON | null;
    rights: PictureRights.AsProtobufJSON | null;
    siblings: PictureSiblings.AsProtobufJSON | null;
    specialName: string;
    takenDate: googleType010.Date.AsProtobufJSON | null;
    changeStatusUserId: string;
    ip: string;
    dpiX: number;
    dpiY: number;
    previewLarge: APIImage.AsProtobufJSON | null;
    subscribed: boolean;
    paginator: PicturesPages.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.PicturesPages
 */
export class PicturesPages implements GrpcMessage {
  static id = 'goautowp.PicturesPages';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PicturesPages();
    PicturesPages.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PicturesPages) {
    _instance.pageCount = _instance.pageCount || 0;
    _instance.first = _instance.first || '';
    _instance.current = _instance.current || '';
    _instance.next = _instance.next || '';
    _instance.previous = _instance.previous || '';
    _instance.pagesInRange = _instance.pagesInRange || [];
    _instance.totalItemCount = _instance.totalItemCount || 0;
    _instance.last = _instance.last || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PicturesPages,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.pageCount = _reader.readInt32();
          break;
        case 2:
          _instance.first = _reader.readString();
          break;
        case 3:
          _instance.current = _reader.readString();
          break;
        case 5:
          _instance.next = _reader.readString();
          break;
        case 6:
          _instance.previous = _reader.readString();
          break;
        case 9:
          const messageInitializer9 = new PicturesPagesPage();
          _reader.readMessage(
            messageInitializer9,
            PicturesPagesPage.deserializeBinaryFromReader
          );
          (_instance.pagesInRange = _instance.pagesInRange || []).push(
            messageInitializer9
          );
          break;
        case 10:
          _instance.totalItemCount = _reader.readInt32();
          break;
        case 11:
          _instance.last = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    PicturesPages.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PicturesPages,
    _writer: BinaryWriter
  ) {
    if (_instance.pageCount) {
      _writer.writeInt32(1, _instance.pageCount);
    }
    if (_instance.first) {
      _writer.writeString(2, _instance.first);
    }
    if (_instance.current) {
      _writer.writeString(3, _instance.current);
    }
    if (_instance.next) {
      _writer.writeString(5, _instance.next);
    }
    if (_instance.previous) {
      _writer.writeString(6, _instance.previous);
    }
    if (_instance.pagesInRange && _instance.pagesInRange.length) {
      _writer.writeRepeatedMessage(
        9,
        _instance.pagesInRange as any,
        PicturesPagesPage.serializeBinaryToWriter
      );
    }
    if (_instance.totalItemCount) {
      _writer.writeInt32(10, _instance.totalItemCount);
    }
    if (_instance.last) {
      _writer.writeString(11, _instance.last);
    }
  }

  private _pageCount: number;
  private _first: string;
  private _current: string;
  private _next: string;
  private _previous: string;
  private _pagesInRange?: PicturesPagesPage[];
  private _totalItemCount: number;
  private _last: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PicturesPages to deeply clone from
   */
  constructor(_value?: RecursivePartial<PicturesPages.AsObject>) {
    _value = _value || {};
    this.pageCount = _value.pageCount;
    this.first = _value.first;
    this.current = _value.current;
    this.next = _value.next;
    this.previous = _value.previous;
    this.pagesInRange = (_value.pagesInRange || []).map(
      m => new PicturesPagesPage(m)
    );
    this.totalItemCount = _value.totalItemCount;
    this.last = _value.last;
    PicturesPages.refineValues(this);
  }
  get pageCount(): number {
    return this._pageCount;
  }
  set pageCount(value: number) {
    this._pageCount = value;
  }
  get first(): string {
    return this._first;
  }
  set first(value: string) {
    this._first = value;
  }
  get current(): string {
    return this._current;
  }
  set current(value: string) {
    this._current = value;
  }
  get next(): string {
    return this._next;
  }
  set next(value: string) {
    this._next = value;
  }
  get previous(): string {
    return this._previous;
  }
  set previous(value: string) {
    this._previous = value;
  }
  get pagesInRange(): PicturesPagesPage[] | undefined {
    return this._pagesInRange;
  }
  set pagesInRange(value: PicturesPagesPage[] | undefined) {
    this._pagesInRange = value;
  }
  get totalItemCount(): number {
    return this._totalItemCount;
  }
  set totalItemCount(value: number) {
    this._totalItemCount = value;
  }
  get last(): string {
    return this._last;
  }
  set last(value: string) {
    this._last = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PicturesPages.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PicturesPages.AsObject {
    return {
      pageCount: this.pageCount,
      first: this.first,
      current: this.current,
      next: this.next,
      previous: this.previous,
      pagesInRange: (this.pagesInRange || []).map(m => m.toObject()),
      totalItemCount: this.totalItemCount,
      last: this.last
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PicturesPages.AsProtobufJSON {
    return {
      pageCount: this.pageCount,
      first: this.first,
      current: this.current,
      next: this.next,
      previous: this.previous,
      pagesInRange: (this.pagesInRange || []).map(m =>
        m.toProtobufJSON(options)
      ),
      totalItemCount: this.totalItemCount,
      last: this.last
    };
  }
}
export module PicturesPages {
  /**
   * Standard JavaScript object representation for PicturesPages
   */
  export interface AsObject {
    pageCount: number;
    first: string;
    current: string;
    next: string;
    previous: string;
    pagesInRange?: PicturesPagesPage.AsObject[];
    totalItemCount: number;
    last: string;
  }

  /**
   * Protobuf JSON representation for PicturesPages
   */
  export interface AsProtobufJSON {
    pageCount: number;
    first: string;
    current: string;
    next: string;
    previous: string;
    pagesInRange: PicturesPagesPage.AsProtobufJSON[] | null;
    totalItemCount: number;
    last: string;
  }
}

/**
 * Message implementation for goautowp.PicturesPagesPage
 */
export class PicturesPagesPage implements GrpcMessage {
  static id = 'goautowp.PicturesPagesPage';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PicturesPagesPage();
    PicturesPagesPage.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PicturesPagesPage) {
    _instance.page = _instance.page || 0;
    _instance.identity = _instance.identity || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PicturesPagesPage,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.page = _reader.readInt32();
          break;
        case 2:
          _instance.identity = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    PicturesPagesPage.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PicturesPagesPage,
    _writer: BinaryWriter
  ) {
    if (_instance.page) {
      _writer.writeInt32(1, _instance.page);
    }
    if (_instance.identity) {
      _writer.writeString(2, _instance.identity);
    }
  }

  private _page: number;
  private _identity: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PicturesPagesPage to deeply clone from
   */
  constructor(_value?: RecursivePartial<PicturesPagesPage.AsObject>) {
    _value = _value || {};
    this.page = _value.page;
    this.identity = _value.identity;
    PicturesPagesPage.refineValues(this);
  }
  get page(): number {
    return this._page;
  }
  set page(value: number) {
    this._page = value;
  }
  get identity(): string {
    return this._identity;
  }
  set identity(value: string) {
    this._identity = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PicturesPagesPage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PicturesPagesPage.AsObject {
    return {
      page: this.page,
      identity: this.identity
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PicturesPagesPage.AsProtobufJSON {
    return {
      page: this.page,
      identity: this.identity
    };
  }
}
export module PicturesPagesPage {
  /**
   * Standard JavaScript object representation for PicturesPagesPage
   */
  export interface AsObject {
    page: number;
    identity: string;
  }

  /**
   * Protobuf JSON representation for PicturesPagesPage
   */
  export interface AsProtobufJSON {
    page: number;
    identity: string;
  }
}

/**
 * Message implementation for goautowp.PictureRights
 */
export class PictureRights implements GrpcMessage {
  static id = 'goautowp.PictureRights';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PictureRights();
    PictureRights.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PictureRights) {
    _instance.move = _instance.move || false;
    _instance.accept = _instance.accept || false;
    _instance.unaccept = _instance.unaccept || false;
    _instance.restore = _instance.restore || false;
    _instance.normalize = _instance.normalize || false;
    _instance.flop = _instance.flop || false;
    _instance.crop = _instance.crop || false;
    _instance.delete = _instance.delete || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PictureRights,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.move = _reader.readBool();
          break;
        case 2:
          _instance.accept = _reader.readBool();
          break;
        case 3:
          _instance.unaccept = _reader.readBool();
          break;
        case 4:
          _instance.restore = _reader.readBool();
          break;
        case 5:
          _instance.normalize = _reader.readBool();
          break;
        case 6:
          _instance.flop = _reader.readBool();
          break;
        case 7:
          _instance.crop = _reader.readBool();
          break;
        case 8:
          _instance.delete = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    PictureRights.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PictureRights,
    _writer: BinaryWriter
  ) {
    if (_instance.move) {
      _writer.writeBool(1, _instance.move);
    }
    if (_instance.accept) {
      _writer.writeBool(2, _instance.accept);
    }
    if (_instance.unaccept) {
      _writer.writeBool(3, _instance.unaccept);
    }
    if (_instance.restore) {
      _writer.writeBool(4, _instance.restore);
    }
    if (_instance.normalize) {
      _writer.writeBool(5, _instance.normalize);
    }
    if (_instance.flop) {
      _writer.writeBool(6, _instance.flop);
    }
    if (_instance.crop) {
      _writer.writeBool(7, _instance.crop);
    }
    if (_instance.delete) {
      _writer.writeBool(8, _instance.delete);
    }
  }

  private _move: boolean;
  private _accept: boolean;
  private _unaccept: boolean;
  private _restore: boolean;
  private _normalize: boolean;
  private _flop: boolean;
  private _crop: boolean;
  private _delete: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PictureRights to deeply clone from
   */
  constructor(_value?: RecursivePartial<PictureRights.AsObject>) {
    _value = _value || {};
    this.move = _value.move;
    this.accept = _value.accept;
    this.unaccept = _value.unaccept;
    this.restore = _value.restore;
    this.normalize = _value.normalize;
    this.flop = _value.flop;
    this.crop = _value.crop;
    this.delete = _value.delete;
    PictureRights.refineValues(this);
  }
  get move(): boolean {
    return this._move;
  }
  set move(value: boolean) {
    this._move = value;
  }
  get accept(): boolean {
    return this._accept;
  }
  set accept(value: boolean) {
    this._accept = value;
  }
  get unaccept(): boolean {
    return this._unaccept;
  }
  set unaccept(value: boolean) {
    this._unaccept = value;
  }
  get restore(): boolean {
    return this._restore;
  }
  set restore(value: boolean) {
    this._restore = value;
  }
  get normalize(): boolean {
    return this._normalize;
  }
  set normalize(value: boolean) {
    this._normalize = value;
  }
  get flop(): boolean {
    return this._flop;
  }
  set flop(value: boolean) {
    this._flop = value;
  }
  get crop(): boolean {
    return this._crop;
  }
  set crop(value: boolean) {
    this._crop = value;
  }
  get delete(): boolean {
    return this._delete;
  }
  set delete(value: boolean) {
    this._delete = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PictureRights.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PictureRights.AsObject {
    return {
      move: this.move,
      accept: this.accept,
      unaccept: this.unaccept,
      restore: this.restore,
      normalize: this.normalize,
      flop: this.flop,
      crop: this.crop,
      delete: this.delete
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PictureRights.AsProtobufJSON {
    return {
      move: this.move,
      accept: this.accept,
      unaccept: this.unaccept,
      restore: this.restore,
      normalize: this.normalize,
      flop: this.flop,
      crop: this.crop,
      delete: this.delete
    };
  }
}
export module PictureRights {
  /**
   * Standard JavaScript object representation for PictureRights
   */
  export interface AsObject {
    move: boolean;
    accept: boolean;
    unaccept: boolean;
    restore: boolean;
    normalize: boolean;
    flop: boolean;
    crop: boolean;
    delete: boolean;
  }

  /**
   * Protobuf JSON representation for PictureRights
   */
  export interface AsProtobufJSON {
    move: boolean;
    accept: boolean;
    unaccept: boolean;
    restore: boolean;
    normalize: boolean;
    flop: boolean;
    crop: boolean;
    delete: boolean;
  }
}

/**
 * Message implementation for goautowp.DfDistances
 */
export class DfDistances implements GrpcMessage {
  static id = 'goautowp.DfDistances';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new DfDistances();
    DfDistances.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: DfDistances) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: DfDistances,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new DfDistance();
          _reader.readMessage(
            messageInitializer1,
            DfDistance.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    DfDistances.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: DfDistances,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        DfDistance.serializeBinaryToWriter
      );
    }
  }

  private _items?: DfDistance[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of DfDistances to deeply clone from
   */
  constructor(_value?: RecursivePartial<DfDistances.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new DfDistance(m));
    DfDistances.refineValues(this);
  }
  get items(): DfDistance[] | undefined {
    return this._items;
  }
  set items(value: DfDistance[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    DfDistances.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): DfDistances.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): DfDistances.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module DfDistances {
  /**
   * Standard JavaScript object representation for DfDistances
   */
  export interface AsObject {
    items?: DfDistance.AsObject[];
  }

  /**
   * Protobuf JSON representation for DfDistances
   */
  export interface AsProtobufJSON {
    items: DfDistance.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.DfDistance
 */
export class DfDistance implements GrpcMessage {
  static id = 'goautowp.DfDistance';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new DfDistance();
    DfDistance.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: DfDistance) {
    _instance.srcPictureId = _instance.srcPictureId || '0';
    _instance.dstPictureId = _instance.dstPictureId || '0';
    _instance.distance = _instance.distance || 0;
    _instance.dstPicture = _instance.dstPicture || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: DfDistance,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.srcPictureId = _reader.readInt64String();
          break;
        case 2:
          _instance.dstPictureId = _reader.readInt64String();
          break;
        case 3:
          _instance.distance = _reader.readInt32();
          break;
        case 4:
          _instance.dstPicture = new Picture();
          _reader.readMessage(
            _instance.dstPicture,
            Picture.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    DfDistance.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: DfDistance, _writer: BinaryWriter) {
    if (_instance.srcPictureId) {
      _writer.writeInt64String(1, _instance.srcPictureId);
    }
    if (_instance.dstPictureId) {
      _writer.writeInt64String(2, _instance.dstPictureId);
    }
    if (_instance.distance) {
      _writer.writeInt32(3, _instance.distance);
    }
    if (_instance.dstPicture) {
      _writer.writeMessage(
        4,
        _instance.dstPicture as any,
        Picture.serializeBinaryToWriter
      );
    }
  }

  private _srcPictureId: string;
  private _dstPictureId: string;
  private _distance: number;
  private _dstPicture?: Picture;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of DfDistance to deeply clone from
   */
  constructor(_value?: RecursivePartial<DfDistance.AsObject>) {
    _value = _value || {};
    this.srcPictureId = _value.srcPictureId;
    this.dstPictureId = _value.dstPictureId;
    this.distance = _value.distance;
    this.dstPicture = _value.dstPicture
      ? new Picture(_value.dstPicture)
      : undefined;
    DfDistance.refineValues(this);
  }
  get srcPictureId(): string {
    return this._srcPictureId;
  }
  set srcPictureId(value: string) {
    this._srcPictureId = value;
  }
  get dstPictureId(): string {
    return this._dstPictureId;
  }
  set dstPictureId(value: string) {
    this._dstPictureId = value;
  }
  get distance(): number {
    return this._distance;
  }
  set distance(value: number) {
    this._distance = value;
  }
  get dstPicture(): Picture | undefined {
    return this._dstPicture;
  }
  set dstPicture(value: Picture | undefined) {
    this._dstPicture = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    DfDistance.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): DfDistance.AsObject {
    return {
      srcPictureId: this.srcPictureId,
      dstPictureId: this.dstPictureId,
      distance: this.distance,
      dstPicture: this.dstPicture ? this.dstPicture.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): DfDistance.AsProtobufJSON {
    return {
      srcPictureId: this.srcPictureId,
      dstPictureId: this.dstPictureId,
      distance: this.distance,
      dstPicture: this.dstPicture
        ? this.dstPicture.toProtobufJSON(options)
        : null
    };
  }
}
export module DfDistance {
  /**
   * Standard JavaScript object representation for DfDistance
   */
  export interface AsObject {
    srcPictureId: string;
    dstPictureId: string;
    distance: number;
    dstPicture?: Picture.AsObject;
  }

  /**
   * Protobuf JSON representation for DfDistance
   */
  export interface AsProtobufJSON {
    srcPictureId: string;
    dstPictureId: string;
    distance: number;
    dstPicture: Picture.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.PicturesList
 */
export class PicturesList implements GrpcMessage {
  static id = 'goautowp.PicturesList';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PicturesList();
    PicturesList.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PicturesList) {
    _instance.items = _instance.items || [];
    _instance.paginator = _instance.paginator || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PicturesList,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new Picture();
          _reader.readMessage(
            messageInitializer1,
            Picture.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        case 2:
          _instance.paginator = new Pages();
          _reader.readMessage(
            _instance.paginator,
            Pages.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    PicturesList.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PicturesList,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        Picture.serializeBinaryToWriter
      );
    }
    if (_instance.paginator) {
      _writer.writeMessage(
        2,
        _instance.paginator as any,
        Pages.serializeBinaryToWriter
      );
    }
  }

  private _items?: Picture[];
  private _paginator?: Pages;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PicturesList to deeply clone from
   */
  constructor(_value?: RecursivePartial<PicturesList.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new Picture(m));
    this.paginator = _value.paginator ? new Pages(_value.paginator) : undefined;
    PicturesList.refineValues(this);
  }
  get items(): Picture[] | undefined {
    return this._items;
  }
  set items(value: Picture[] | undefined) {
    this._items = value;
  }
  get paginator(): Pages | undefined {
    return this._paginator;
  }
  set paginator(value: Pages | undefined) {
    this._paginator = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PicturesList.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PicturesList.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject()),
      paginator: this.paginator ? this.paginator.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PicturesList.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options)),
      paginator: this.paginator ? this.paginator.toProtobufJSON(options) : null
    };
  }
}
export module PicturesList {
  /**
   * Standard JavaScript object representation for PicturesList
   */
  export interface AsObject {
    items?: Picture.AsObject[];
    paginator?: Pages.AsObject;
  }

  /**
   * Protobuf JSON representation for PicturesList
   */
  export interface AsProtobufJSON {
    items: Picture.AsProtobufJSON[] | null;
    paginator: Pages.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.PictureItemsRequest
 */
export class PictureItemsRequest implements GrpcMessage {
  static id = 'goautowp.PictureItemsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PictureItemsRequest();
    PictureItemsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PictureItemsRequest) {
    _instance.options = _instance.options || undefined;
    _instance.fields = _instance.fields || undefined;
    _instance.language = _instance.language || '';
    _instance.limit = _instance.limit || 0;
    _instance.order = _instance.order || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PictureItemsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.options = new PictureItemListOptions();
          _reader.readMessage(
            _instance.options,
            PictureItemListOptions.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.fields = new PictureItemFields();
          _reader.readMessage(
            _instance.fields,
            PictureItemFields.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.language = _reader.readString();
          break;
        case 4:
          _instance.limit = _reader.readUint32();
          break;
        case 5:
          _instance.order = _reader.readEnum();
          break;
        default:
          _reader.skipField();
      }
    }

    PictureItemsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PictureItemsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.options) {
      _writer.writeMessage(
        1,
        _instance.options as any,
        PictureItemListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.fields) {
      _writer.writeMessage(
        2,
        _instance.fields as any,
        PictureItemFields.serializeBinaryToWriter
      );
    }
    if (_instance.language) {
      _writer.writeString(3, _instance.language);
    }
    if (_instance.limit) {
      _writer.writeUint32(4, _instance.limit);
    }
    if (_instance.order) {
      _writer.writeEnum(5, _instance.order);
    }
  }

  private _options?: PictureItemListOptions;
  private _fields?: PictureItemFields;
  private _language: string;
  private _limit: number;
  private _order: PictureItemsRequest.Order;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PictureItemsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<PictureItemsRequest.AsObject>) {
    _value = _value || {};
    this.options = _value.options
      ? new PictureItemListOptions(_value.options)
      : undefined;
    this.fields = _value.fields
      ? new PictureItemFields(_value.fields)
      : undefined;
    this.language = _value.language;
    this.limit = _value.limit;
    this.order = _value.order;
    PictureItemsRequest.refineValues(this);
  }
  get options(): PictureItemListOptions | undefined {
    return this._options;
  }
  set options(value: PictureItemListOptions | undefined) {
    this._options = value;
  }
  get fields(): PictureItemFields | undefined {
    return this._fields;
  }
  set fields(value: PictureItemFields | undefined) {
    this._fields = value;
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }
  get limit(): number {
    return this._limit;
  }
  set limit(value: number) {
    this._limit = value;
  }
  get order(): PictureItemsRequest.Order {
    return this._order;
  }
  set order(value: PictureItemsRequest.Order) {
    this._order = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PictureItemsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PictureItemsRequest.AsObject {
    return {
      options: this.options ? this.options.toObject() : undefined,
      fields: this.fields ? this.fields.toObject() : undefined,
      language: this.language,
      limit: this.limit,
      order: this.order
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PictureItemsRequest.AsProtobufJSON {
    return {
      options: this.options ? this.options.toProtobufJSON(options) : null,
      fields: this.fields ? this.fields.toProtobufJSON(options) : null,
      language: this.language,
      limit: this.limit,
      order:
        PictureItemsRequest.Order[
          this.order === null || this.order === undefined ? 0 : this.order
        ]
    };
  }
}
export module PictureItemsRequest {
  /**
   * Standard JavaScript object representation for PictureItemsRequest
   */
  export interface AsObject {
    options?: PictureItemListOptions.AsObject;
    fields?: PictureItemFields.AsObject;
    language: string;
    limit: number;
    order: PictureItemsRequest.Order;
  }

  /**
   * Protobuf JSON representation for PictureItemsRequest
   */
  export interface AsProtobufJSON {
    options: PictureItemListOptions.AsProtobufJSON | null;
    fields: PictureItemFields.AsProtobufJSON | null;
    language: string;
    limit: number;
    order: string;
  }
  export enum Order {
    NONE = 0,
    FRONT_PERSPECTIVES_FIRST = 1
  }
}

/**
 * Message implementation for goautowp.PictureItemFields
 */
export class PictureItemFields implements GrpcMessage {
  static id = 'goautowp.PictureItemFields';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PictureItemFields();
    PictureItemFields.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PictureItemFields) {
    _instance.item = _instance.item || undefined;
    _instance.itemParentCacheAncestor =
      _instance.itemParentCacheAncestor || undefined;
    _instance.picture = _instance.picture || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PictureItemFields,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.item = new ItemsRequest();
          _reader.readMessage(
            _instance.item,
            ItemsRequest.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.itemParentCacheAncestor = new ItemParentCacheRequest();
          _reader.readMessage(
            _instance.itemParentCacheAncestor,
            ItemParentCacheRequest.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.picture = new PicturesRequest();
          _reader.readMessage(
            _instance.picture,
            PicturesRequest.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    PictureItemFields.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PictureItemFields,
    _writer: BinaryWriter
  ) {
    if (_instance.item) {
      _writer.writeMessage(
        1,
        _instance.item as any,
        ItemsRequest.serializeBinaryToWriter
      );
    }
    if (_instance.itemParentCacheAncestor) {
      _writer.writeMessage(
        2,
        _instance.itemParentCacheAncestor as any,
        ItemParentCacheRequest.serializeBinaryToWriter
      );
    }
    if (_instance.picture) {
      _writer.writeMessage(
        3,
        _instance.picture as any,
        PicturesRequest.serializeBinaryToWriter
      );
    }
  }

  private _item?: ItemsRequest;
  private _itemParentCacheAncestor?: ItemParentCacheRequest;
  private _picture?: PicturesRequest;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PictureItemFields to deeply clone from
   */
  constructor(_value?: RecursivePartial<PictureItemFields.AsObject>) {
    _value = _value || {};
    this.item = _value.item ? new ItemsRequest(_value.item) : undefined;
    this.itemParentCacheAncestor = _value.itemParentCacheAncestor
      ? new ItemParentCacheRequest(_value.itemParentCacheAncestor)
      : undefined;
    this.picture = _value.picture
      ? new PicturesRequest(_value.picture)
      : undefined;
    PictureItemFields.refineValues(this);
  }
  get item(): ItemsRequest | undefined {
    return this._item;
  }
  set item(value: ItemsRequest | undefined) {
    this._item = value;
  }
  get itemParentCacheAncestor(): ItemParentCacheRequest | undefined {
    return this._itemParentCacheAncestor;
  }
  set itemParentCacheAncestor(value: ItemParentCacheRequest | undefined) {
    this._itemParentCacheAncestor = value;
  }
  get picture(): PicturesRequest | undefined {
    return this._picture;
  }
  set picture(value: PicturesRequest | undefined) {
    this._picture = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PictureItemFields.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PictureItemFields.AsObject {
    return {
      item: this.item ? this.item.toObject() : undefined,
      itemParentCacheAncestor: this.itemParentCacheAncestor
        ? this.itemParentCacheAncestor.toObject()
        : undefined,
      picture: this.picture ? this.picture.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PictureItemFields.AsProtobufJSON {
    return {
      item: this.item ? this.item.toProtobufJSON(options) : null,
      itemParentCacheAncestor: this.itemParentCacheAncestor
        ? this.itemParentCacheAncestor.toProtobufJSON(options)
        : null,
      picture: this.picture ? this.picture.toProtobufJSON(options) : null
    };
  }
}
export module PictureItemFields {
  /**
   * Standard JavaScript object representation for PictureItemFields
   */
  export interface AsObject {
    item?: ItemsRequest.AsObject;
    itemParentCacheAncestor?: ItemParentCacheRequest.AsObject;
    picture?: PicturesRequest.AsObject;
  }

  /**
   * Protobuf JSON representation for PictureItemFields
   */
  export interface AsProtobufJSON {
    item: ItemsRequest.AsProtobufJSON | null;
    itemParentCacheAncestor: ItemParentCacheRequest.AsProtobufJSON | null;
    picture: PicturesRequest.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.PictureItems
 */
export class PictureItems implements GrpcMessage {
  static id = 'goautowp.PictureItems';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PictureItems();
    PictureItems.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PictureItems) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PictureItems,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new PictureItem();
          _reader.readMessage(
            messageInitializer1,
            PictureItem.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    PictureItems.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PictureItems,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        PictureItem.serializeBinaryToWriter
      );
    }
  }

  private _items?: PictureItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PictureItems to deeply clone from
   */
  constructor(_value?: RecursivePartial<PictureItems.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new PictureItem(m));
    PictureItems.refineValues(this);
  }
  get items(): PictureItem[] | undefined {
    return this._items;
  }
  set items(value: PictureItem[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PictureItems.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PictureItems.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PictureItems.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module PictureItems {
  /**
   * Standard JavaScript object representation for PictureItems
   */
  export interface AsObject {
    items?: PictureItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for PictureItems
   */
  export interface AsProtobufJSON {
    items: PictureItem.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.PictureItem
 */
export class PictureItem implements GrpcMessage {
  static id = 'goautowp.PictureItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PictureItem();
    PictureItem.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PictureItem) {
    _instance.pictureId = _instance.pictureId || '0';
    _instance.itemId = _instance.itemId || '0';
    _instance.type = _instance.type || 0;
    _instance.cropLeft = _instance.cropLeft || 0;
    _instance.cropTop = _instance.cropTop || 0;
    _instance.cropWidth = _instance.cropWidth || 0;
    _instance.cropHeight = _instance.cropHeight || 0;
    _instance.perspectiveId = _instance.perspectiveId || 0;
    _instance.item = _instance.item || undefined;
    _instance.itemParentCacheAncestors =
      _instance.itemParentCacheAncestors || undefined;
    _instance.picture = _instance.picture || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PictureItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.pictureId = _reader.readInt64String();
          break;
        case 2:
          _instance.itemId = _reader.readInt64String();
          break;
        case 3:
          _instance.type = _reader.readEnum();
          break;
        case 4:
          _instance.cropLeft = _reader.readUint32();
          break;
        case 5:
          _instance.cropTop = _reader.readUint32();
          break;
        case 6:
          _instance.cropWidth = _reader.readUint32();
          break;
        case 7:
          _instance.cropHeight = _reader.readUint32();
          break;
        case 8:
          _instance.perspectiveId = _reader.readInt32();
          break;
        case 9:
          _instance.item = new APIItem();
          _reader.readMessage(
            _instance.item,
            APIItem.deserializeBinaryFromReader
          );
          break;
        case 10:
          _instance.itemParentCacheAncestors = new ItemParentCaches();
          _reader.readMessage(
            _instance.itemParentCacheAncestors,
            ItemParentCaches.deserializeBinaryFromReader
          );
          break;
        case 11:
          _instance.picture = new Picture();
          _reader.readMessage(
            _instance.picture,
            Picture.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    PictureItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PictureItem,
    _writer: BinaryWriter
  ) {
    if (_instance.pictureId) {
      _writer.writeInt64String(1, _instance.pictureId);
    }
    if (_instance.itemId) {
      _writer.writeInt64String(2, _instance.itemId);
    }
    if (_instance.type) {
      _writer.writeEnum(3, _instance.type);
    }
    if (_instance.cropLeft) {
      _writer.writeUint32(4, _instance.cropLeft);
    }
    if (_instance.cropTop) {
      _writer.writeUint32(5, _instance.cropTop);
    }
    if (_instance.cropWidth) {
      _writer.writeUint32(6, _instance.cropWidth);
    }
    if (_instance.cropHeight) {
      _writer.writeUint32(7, _instance.cropHeight);
    }
    if (_instance.perspectiveId) {
      _writer.writeInt32(8, _instance.perspectiveId);
    }
    if (_instance.item) {
      _writer.writeMessage(
        9,
        _instance.item as any,
        APIItem.serializeBinaryToWriter
      );
    }
    if (_instance.itemParentCacheAncestors) {
      _writer.writeMessage(
        10,
        _instance.itemParentCacheAncestors as any,
        ItemParentCaches.serializeBinaryToWriter
      );
    }
    if (_instance.picture) {
      _writer.writeMessage(
        11,
        _instance.picture as any,
        Picture.serializeBinaryToWriter
      );
    }
  }

  private _pictureId: string;
  private _itemId: string;
  private _type: PictureItemType;
  private _cropLeft: number;
  private _cropTop: number;
  private _cropWidth: number;
  private _cropHeight: number;
  private _perspectiveId: number;
  private _item?: APIItem;
  private _itemParentCacheAncestors?: ItemParentCaches;
  private _picture?: Picture;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PictureItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<PictureItem.AsObject>) {
    _value = _value || {};
    this.pictureId = _value.pictureId;
    this.itemId = _value.itemId;
    this.type = _value.type;
    this.cropLeft = _value.cropLeft;
    this.cropTop = _value.cropTop;
    this.cropWidth = _value.cropWidth;
    this.cropHeight = _value.cropHeight;
    this.perspectiveId = _value.perspectiveId;
    this.item = _value.item ? new APIItem(_value.item) : undefined;
    this.itemParentCacheAncestors = _value.itemParentCacheAncestors
      ? new ItemParentCaches(_value.itemParentCacheAncestors)
      : undefined;
    this.picture = _value.picture ? new Picture(_value.picture) : undefined;
    PictureItem.refineValues(this);
  }
  get pictureId(): string {
    return this._pictureId;
  }
  set pictureId(value: string) {
    this._pictureId = value;
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get type(): PictureItemType {
    return this._type;
  }
  set type(value: PictureItemType) {
    this._type = value;
  }
  get cropLeft(): number {
    return this._cropLeft;
  }
  set cropLeft(value: number) {
    this._cropLeft = value;
  }
  get cropTop(): number {
    return this._cropTop;
  }
  set cropTop(value: number) {
    this._cropTop = value;
  }
  get cropWidth(): number {
    return this._cropWidth;
  }
  set cropWidth(value: number) {
    this._cropWidth = value;
  }
  get cropHeight(): number {
    return this._cropHeight;
  }
  set cropHeight(value: number) {
    this._cropHeight = value;
  }
  get perspectiveId(): number {
    return this._perspectiveId;
  }
  set perspectiveId(value: number) {
    this._perspectiveId = value;
  }
  get item(): APIItem | undefined {
    return this._item;
  }
  set item(value: APIItem | undefined) {
    this._item = value;
  }
  get itemParentCacheAncestors(): ItemParentCaches | undefined {
    return this._itemParentCacheAncestors;
  }
  set itemParentCacheAncestors(value: ItemParentCaches | undefined) {
    this._itemParentCacheAncestors = value;
  }
  get picture(): Picture | undefined {
    return this._picture;
  }
  set picture(value: Picture | undefined) {
    this._picture = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PictureItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PictureItem.AsObject {
    return {
      pictureId: this.pictureId,
      itemId: this.itemId,
      type: this.type,
      cropLeft: this.cropLeft,
      cropTop: this.cropTop,
      cropWidth: this.cropWidth,
      cropHeight: this.cropHeight,
      perspectiveId: this.perspectiveId,
      item: this.item ? this.item.toObject() : undefined,
      itemParentCacheAncestors: this.itemParentCacheAncestors
        ? this.itemParentCacheAncestors.toObject()
        : undefined,
      picture: this.picture ? this.picture.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PictureItem.AsProtobufJSON {
    return {
      pictureId: this.pictureId,
      itemId: this.itemId,
      type:
        PictureItemType[
          this.type === null || this.type === undefined ? 0 : this.type
        ],
      cropLeft: this.cropLeft,
      cropTop: this.cropTop,
      cropWidth: this.cropWidth,
      cropHeight: this.cropHeight,
      perspectiveId: this.perspectiveId,
      item: this.item ? this.item.toProtobufJSON(options) : null,
      itemParentCacheAncestors: this.itemParentCacheAncestors
        ? this.itemParentCacheAncestors.toProtobufJSON(options)
        : null,
      picture: this.picture ? this.picture.toProtobufJSON(options) : null
    };
  }
}
export module PictureItem {
  /**
   * Standard JavaScript object representation for PictureItem
   */
  export interface AsObject {
    pictureId: string;
    itemId: string;
    type: PictureItemType;
    cropLeft: number;
    cropTop: number;
    cropWidth: number;
    cropHeight: number;
    perspectiveId: number;
    item?: APIItem.AsObject;
    itemParentCacheAncestors?: ItemParentCaches.AsObject;
    picture?: Picture.AsObject;
  }

  /**
   * Protobuf JSON representation for PictureItem
   */
  export interface AsProtobufJSON {
    pictureId: string;
    itemId: string;
    type: string;
    cropLeft: number;
    cropTop: number;
    cropWidth: number;
    cropHeight: number;
    perspectiveId: number;
    item: APIItem.AsProtobufJSON | null;
    itemParentCacheAncestors: ItemParentCaches.AsProtobufJSON | null;
    picture: Picture.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.SetPictureItemAreaRequest
 */
export class SetPictureItemAreaRequest implements GrpcMessage {
  static id = 'goautowp.SetPictureItemAreaRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SetPictureItemAreaRequest();
    SetPictureItemAreaRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SetPictureItemAreaRequest) {
    _instance.pictureId = _instance.pictureId || '0';
    _instance.itemId = _instance.itemId || '0';
    _instance.type = _instance.type || 0;
    _instance.cropLeft = _instance.cropLeft || 0;
    _instance.cropTop = _instance.cropTop || 0;
    _instance.cropWidth = _instance.cropWidth || 0;
    _instance.cropHeight = _instance.cropHeight || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SetPictureItemAreaRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.pictureId = _reader.readInt64String();
          break;
        case 2:
          _instance.itemId = _reader.readInt64String();
          break;
        case 3:
          _instance.type = _reader.readEnum();
          break;
        case 4:
          _instance.cropLeft = _reader.readUint32();
          break;
        case 5:
          _instance.cropTop = _reader.readUint32();
          break;
        case 6:
          _instance.cropWidth = _reader.readUint32();
          break;
        case 7:
          _instance.cropHeight = _reader.readUint32();
          break;
        default:
          _reader.skipField();
      }
    }

    SetPictureItemAreaRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SetPictureItemAreaRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.pictureId) {
      _writer.writeInt64String(1, _instance.pictureId);
    }
    if (_instance.itemId) {
      _writer.writeInt64String(2, _instance.itemId);
    }
    if (_instance.type) {
      _writer.writeEnum(3, _instance.type);
    }
    if (_instance.cropLeft) {
      _writer.writeUint32(4, _instance.cropLeft);
    }
    if (_instance.cropTop) {
      _writer.writeUint32(5, _instance.cropTop);
    }
    if (_instance.cropWidth) {
      _writer.writeUint32(6, _instance.cropWidth);
    }
    if (_instance.cropHeight) {
      _writer.writeUint32(7, _instance.cropHeight);
    }
  }

  private _pictureId: string;
  private _itemId: string;
  private _type: PictureItemType;
  private _cropLeft: number;
  private _cropTop: number;
  private _cropWidth: number;
  private _cropHeight: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SetPictureItemAreaRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<SetPictureItemAreaRequest.AsObject>) {
    _value = _value || {};
    this.pictureId = _value.pictureId;
    this.itemId = _value.itemId;
    this.type = _value.type;
    this.cropLeft = _value.cropLeft;
    this.cropTop = _value.cropTop;
    this.cropWidth = _value.cropWidth;
    this.cropHeight = _value.cropHeight;
    SetPictureItemAreaRequest.refineValues(this);
  }
  get pictureId(): string {
    return this._pictureId;
  }
  set pictureId(value: string) {
    this._pictureId = value;
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get type(): PictureItemType {
    return this._type;
  }
  set type(value: PictureItemType) {
    this._type = value;
  }
  get cropLeft(): number {
    return this._cropLeft;
  }
  set cropLeft(value: number) {
    this._cropLeft = value;
  }
  get cropTop(): number {
    return this._cropTop;
  }
  set cropTop(value: number) {
    this._cropTop = value;
  }
  get cropWidth(): number {
    return this._cropWidth;
  }
  set cropWidth(value: number) {
    this._cropWidth = value;
  }
  get cropHeight(): number {
    return this._cropHeight;
  }
  set cropHeight(value: number) {
    this._cropHeight = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SetPictureItemAreaRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SetPictureItemAreaRequest.AsObject {
    return {
      pictureId: this.pictureId,
      itemId: this.itemId,
      type: this.type,
      cropLeft: this.cropLeft,
      cropTop: this.cropTop,
      cropWidth: this.cropWidth,
      cropHeight: this.cropHeight
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SetPictureItemAreaRequest.AsProtobufJSON {
    return {
      pictureId: this.pictureId,
      itemId: this.itemId,
      type:
        PictureItemType[
          this.type === null || this.type === undefined ? 0 : this.type
        ],
      cropLeft: this.cropLeft,
      cropTop: this.cropTop,
      cropWidth: this.cropWidth,
      cropHeight: this.cropHeight
    };
  }
}
export module SetPictureItemAreaRequest {
  /**
   * Standard JavaScript object representation for SetPictureItemAreaRequest
   */
  export interface AsObject {
    pictureId: string;
    itemId: string;
    type: PictureItemType;
    cropLeft: number;
    cropTop: number;
    cropWidth: number;
    cropHeight: number;
  }

  /**
   * Protobuf JSON representation for SetPictureItemAreaRequest
   */
  export interface AsProtobufJSON {
    pictureId: string;
    itemId: string;
    type: string;
    cropLeft: number;
    cropTop: number;
    cropWidth: number;
    cropHeight: number;
  }
}

/**
 * Message implementation for goautowp.SetPictureItemPerspectiveRequest
 */
export class SetPictureItemPerspectiveRequest implements GrpcMessage {
  static id = 'goautowp.SetPictureItemPerspectiveRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SetPictureItemPerspectiveRequest();
    SetPictureItemPerspectiveRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SetPictureItemPerspectiveRequest) {
    _instance.pictureId = _instance.pictureId || '0';
    _instance.itemId = _instance.itemId || '0';
    _instance.type = _instance.type || 0;
    _instance.perspectiveId = _instance.perspectiveId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SetPictureItemPerspectiveRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.pictureId = _reader.readInt64String();
          break;
        case 2:
          _instance.itemId = _reader.readInt64String();
          break;
        case 3:
          _instance.type = _reader.readEnum();
          break;
        case 4:
          _instance.perspectiveId = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    SetPictureItemPerspectiveRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SetPictureItemPerspectiveRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.pictureId) {
      _writer.writeInt64String(1, _instance.pictureId);
    }
    if (_instance.itemId) {
      _writer.writeInt64String(2, _instance.itemId);
    }
    if (_instance.type) {
      _writer.writeEnum(3, _instance.type);
    }
    if (_instance.perspectiveId) {
      _writer.writeInt32(4, _instance.perspectiveId);
    }
  }

  private _pictureId: string;
  private _itemId: string;
  private _type: PictureItemType;
  private _perspectiveId: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SetPictureItemPerspectiveRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<SetPictureItemPerspectiveRequest.AsObject>
  ) {
    _value = _value || {};
    this.pictureId = _value.pictureId;
    this.itemId = _value.itemId;
    this.type = _value.type;
    this.perspectiveId = _value.perspectiveId;
    SetPictureItemPerspectiveRequest.refineValues(this);
  }
  get pictureId(): string {
    return this._pictureId;
  }
  set pictureId(value: string) {
    this._pictureId = value;
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get type(): PictureItemType {
    return this._type;
  }
  set type(value: PictureItemType) {
    this._type = value;
  }
  get perspectiveId(): number {
    return this._perspectiveId;
  }
  set perspectiveId(value: number) {
    this._perspectiveId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SetPictureItemPerspectiveRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SetPictureItemPerspectiveRequest.AsObject {
    return {
      pictureId: this.pictureId,
      itemId: this.itemId,
      type: this.type,
      perspectiveId: this.perspectiveId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SetPictureItemPerspectiveRequest.AsProtobufJSON {
    return {
      pictureId: this.pictureId,
      itemId: this.itemId,
      type:
        PictureItemType[
          this.type === null || this.type === undefined ? 0 : this.type
        ],
      perspectiveId: this.perspectiveId
    };
  }
}
export module SetPictureItemPerspectiveRequest {
  /**
   * Standard JavaScript object representation for SetPictureItemPerspectiveRequest
   */
  export interface AsObject {
    pictureId: string;
    itemId: string;
    type: PictureItemType;
    perspectiveId: number;
  }

  /**
   * Protobuf JSON representation for SetPictureItemPerspectiveRequest
   */
  export interface AsProtobufJSON {
    pictureId: string;
    itemId: string;
    type: string;
    perspectiveId: number;
  }
}

/**
 * Message implementation for goautowp.SetPictureItemItemIDRequest
 */
export class SetPictureItemItemIDRequest implements GrpcMessage {
  static id = 'goautowp.SetPictureItemItemIDRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SetPictureItemItemIDRequest();
    SetPictureItemItemIDRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SetPictureItemItemIDRequest) {
    _instance.pictureId = _instance.pictureId || '0';
    _instance.itemId = _instance.itemId || '0';
    _instance.type = _instance.type || 0;
    _instance.newItemId = _instance.newItemId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SetPictureItemItemIDRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.pictureId = _reader.readInt64String();
          break;
        case 2:
          _instance.itemId = _reader.readInt64String();
          break;
        case 3:
          _instance.type = _reader.readEnum();
          break;
        case 4:
          _instance.newItemId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    SetPictureItemItemIDRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SetPictureItemItemIDRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.pictureId) {
      _writer.writeInt64String(1, _instance.pictureId);
    }
    if (_instance.itemId) {
      _writer.writeInt64String(2, _instance.itemId);
    }
    if (_instance.type) {
      _writer.writeEnum(3, _instance.type);
    }
    if (_instance.newItemId) {
      _writer.writeInt64String(4, _instance.newItemId);
    }
  }

  private _pictureId: string;
  private _itemId: string;
  private _type: PictureItemType;
  private _newItemId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SetPictureItemItemIDRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<SetPictureItemItemIDRequest.AsObject>) {
    _value = _value || {};
    this.pictureId = _value.pictureId;
    this.itemId = _value.itemId;
    this.type = _value.type;
    this.newItemId = _value.newItemId;
    SetPictureItemItemIDRequest.refineValues(this);
  }
  get pictureId(): string {
    return this._pictureId;
  }
  set pictureId(value: string) {
    this._pictureId = value;
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get type(): PictureItemType {
    return this._type;
  }
  set type(value: PictureItemType) {
    this._type = value;
  }
  get newItemId(): string {
    return this._newItemId;
  }
  set newItemId(value: string) {
    this._newItemId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SetPictureItemItemIDRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SetPictureItemItemIDRequest.AsObject {
    return {
      pictureId: this.pictureId,
      itemId: this.itemId,
      type: this.type,
      newItemId: this.newItemId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SetPictureItemItemIDRequest.AsProtobufJSON {
    return {
      pictureId: this.pictureId,
      itemId: this.itemId,
      type:
        PictureItemType[
          this.type === null || this.type === undefined ? 0 : this.type
        ],
      newItemId: this.newItemId
    };
  }
}
export module SetPictureItemItemIDRequest {
  /**
   * Standard JavaScript object representation for SetPictureItemItemIDRequest
   */
  export interface AsObject {
    pictureId: string;
    itemId: string;
    type: PictureItemType;
    newItemId: string;
  }

  /**
   * Protobuf JSON representation for SetPictureItemItemIDRequest
   */
  export interface AsProtobufJSON {
    pictureId: string;
    itemId: string;
    type: string;
    newItemId: string;
  }
}

/**
 * Message implementation for goautowp.DeletePictureItemRequest
 */
export class DeletePictureItemRequest implements GrpcMessage {
  static id = 'goautowp.DeletePictureItemRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new DeletePictureItemRequest();
    DeletePictureItemRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: DeletePictureItemRequest) {
    _instance.pictureId = _instance.pictureId || '0';
    _instance.itemId = _instance.itemId || '0';
    _instance.type = _instance.type || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: DeletePictureItemRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.pictureId = _reader.readInt64String();
          break;
        case 2:
          _instance.itemId = _reader.readInt64String();
          break;
        case 3:
          _instance.type = _reader.readEnum();
          break;
        default:
          _reader.skipField();
      }
    }

    DeletePictureItemRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: DeletePictureItemRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.pictureId) {
      _writer.writeInt64String(1, _instance.pictureId);
    }
    if (_instance.itemId) {
      _writer.writeInt64String(2, _instance.itemId);
    }
    if (_instance.type) {
      _writer.writeEnum(3, _instance.type);
    }
  }

  private _pictureId: string;
  private _itemId: string;
  private _type: PictureItemType;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of DeletePictureItemRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<DeletePictureItemRequest.AsObject>) {
    _value = _value || {};
    this.pictureId = _value.pictureId;
    this.itemId = _value.itemId;
    this.type = _value.type;
    DeletePictureItemRequest.refineValues(this);
  }
  get pictureId(): string {
    return this._pictureId;
  }
  set pictureId(value: string) {
    this._pictureId = value;
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get type(): PictureItemType {
    return this._type;
  }
  set type(value: PictureItemType) {
    this._type = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    DeletePictureItemRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): DeletePictureItemRequest.AsObject {
    return {
      pictureId: this.pictureId,
      itemId: this.itemId,
      type: this.type
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): DeletePictureItemRequest.AsProtobufJSON {
    return {
      pictureId: this.pictureId,
      itemId: this.itemId,
      type:
        PictureItemType[
          this.type === null || this.type === undefined ? 0 : this.type
        ]
    };
  }
}
export module DeletePictureItemRequest {
  /**
   * Standard JavaScript object representation for DeletePictureItemRequest
   */
  export interface AsObject {
    pictureId: string;
    itemId: string;
    type: PictureItemType;
  }

  /**
   * Protobuf JSON representation for DeletePictureItemRequest
   */
  export interface AsProtobufJSON {
    pictureId: string;
    itemId: string;
    type: string;
  }
}

/**
 * Message implementation for goautowp.CreatePictureItemRequest
 */
export class CreatePictureItemRequest implements GrpcMessage {
  static id = 'goautowp.CreatePictureItemRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CreatePictureItemRequest();
    CreatePictureItemRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CreatePictureItemRequest) {
    _instance.pictureId = _instance.pictureId || '0';
    _instance.itemId = _instance.itemId || '0';
    _instance.type = _instance.type || 0;
    _instance.perspectiveId = _instance.perspectiveId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CreatePictureItemRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.pictureId = _reader.readInt64String();
          break;
        case 2:
          _instance.itemId = _reader.readInt64String();
          break;
        case 3:
          _instance.type = _reader.readEnum();
          break;
        case 4:
          _instance.perspectiveId = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    CreatePictureItemRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CreatePictureItemRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.pictureId) {
      _writer.writeInt64String(1, _instance.pictureId);
    }
    if (_instance.itemId) {
      _writer.writeInt64String(2, _instance.itemId);
    }
    if (_instance.type) {
      _writer.writeEnum(3, _instance.type);
    }
    if (_instance.perspectiveId) {
      _writer.writeInt32(4, _instance.perspectiveId);
    }
  }

  private _pictureId: string;
  private _itemId: string;
  private _type: PictureItemType;
  private _perspectiveId: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CreatePictureItemRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<CreatePictureItemRequest.AsObject>) {
    _value = _value || {};
    this.pictureId = _value.pictureId;
    this.itemId = _value.itemId;
    this.type = _value.type;
    this.perspectiveId = _value.perspectiveId;
    CreatePictureItemRequest.refineValues(this);
  }
  get pictureId(): string {
    return this._pictureId;
  }
  set pictureId(value: string) {
    this._pictureId = value;
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get type(): PictureItemType {
    return this._type;
  }
  set type(value: PictureItemType) {
    this._type = value;
  }
  get perspectiveId(): number {
    return this._perspectiveId;
  }
  set perspectiveId(value: number) {
    this._perspectiveId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CreatePictureItemRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CreatePictureItemRequest.AsObject {
    return {
      pictureId: this.pictureId,
      itemId: this.itemId,
      type: this.type,
      perspectiveId: this.perspectiveId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CreatePictureItemRequest.AsProtobufJSON {
    return {
      pictureId: this.pictureId,
      itemId: this.itemId,
      type:
        PictureItemType[
          this.type === null || this.type === undefined ? 0 : this.type
        ],
      perspectiveId: this.perspectiveId
    };
  }
}
export module CreatePictureItemRequest {
  /**
   * Standard JavaScript object representation for CreatePictureItemRequest
   */
  export interface AsObject {
    pictureId: string;
    itemId: string;
    type: PictureItemType;
    perspectiveId: number;
  }

  /**
   * Protobuf JSON representation for CreatePictureItemRequest
   */
  export interface AsProtobufJSON {
    pictureId: string;
    itemId: string;
    type: string;
    perspectiveId: number;
  }
}

/**
 * Message implementation for goautowp.SetPictureCropRequest
 */
export class SetPictureCropRequest implements GrpcMessage {
  static id = 'goautowp.SetPictureCropRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SetPictureCropRequest();
    SetPictureCropRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SetPictureCropRequest) {
    _instance.pictureId = _instance.pictureId || '0';
    _instance.cropLeft = _instance.cropLeft || 0;
    _instance.cropTop = _instance.cropTop || 0;
    _instance.cropWidth = _instance.cropWidth || 0;
    _instance.cropHeight = _instance.cropHeight || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SetPictureCropRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.pictureId = _reader.readInt64String();
          break;
        case 4:
          _instance.cropLeft = _reader.readUint32();
          break;
        case 5:
          _instance.cropTop = _reader.readUint32();
          break;
        case 6:
          _instance.cropWidth = _reader.readUint32();
          break;
        case 7:
          _instance.cropHeight = _reader.readUint32();
          break;
        default:
          _reader.skipField();
      }
    }

    SetPictureCropRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SetPictureCropRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.pictureId) {
      _writer.writeInt64String(1, _instance.pictureId);
    }
    if (_instance.cropLeft) {
      _writer.writeUint32(4, _instance.cropLeft);
    }
    if (_instance.cropTop) {
      _writer.writeUint32(5, _instance.cropTop);
    }
    if (_instance.cropWidth) {
      _writer.writeUint32(6, _instance.cropWidth);
    }
    if (_instance.cropHeight) {
      _writer.writeUint32(7, _instance.cropHeight);
    }
  }

  private _pictureId: string;
  private _cropLeft: number;
  private _cropTop: number;
  private _cropWidth: number;
  private _cropHeight: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SetPictureCropRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<SetPictureCropRequest.AsObject>) {
    _value = _value || {};
    this.pictureId = _value.pictureId;
    this.cropLeft = _value.cropLeft;
    this.cropTop = _value.cropTop;
    this.cropWidth = _value.cropWidth;
    this.cropHeight = _value.cropHeight;
    SetPictureCropRequest.refineValues(this);
  }
  get pictureId(): string {
    return this._pictureId;
  }
  set pictureId(value: string) {
    this._pictureId = value;
  }
  get cropLeft(): number {
    return this._cropLeft;
  }
  set cropLeft(value: number) {
    this._cropLeft = value;
  }
  get cropTop(): number {
    return this._cropTop;
  }
  set cropTop(value: number) {
    this._cropTop = value;
  }
  get cropWidth(): number {
    return this._cropWidth;
  }
  set cropWidth(value: number) {
    this._cropWidth = value;
  }
  get cropHeight(): number {
    return this._cropHeight;
  }
  set cropHeight(value: number) {
    this._cropHeight = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SetPictureCropRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SetPictureCropRequest.AsObject {
    return {
      pictureId: this.pictureId,
      cropLeft: this.cropLeft,
      cropTop: this.cropTop,
      cropWidth: this.cropWidth,
      cropHeight: this.cropHeight
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SetPictureCropRequest.AsProtobufJSON {
    return {
      pictureId: this.pictureId,
      cropLeft: this.cropLeft,
      cropTop: this.cropTop,
      cropWidth: this.cropWidth,
      cropHeight: this.cropHeight
    };
  }
}
export module SetPictureCropRequest {
  /**
   * Standard JavaScript object representation for SetPictureCropRequest
   */
  export interface AsObject {
    pictureId: string;
    cropLeft: number;
    cropTop: number;
    cropWidth: number;
    cropHeight: number;
  }

  /**
   * Protobuf JSON representation for SetPictureCropRequest
   */
  export interface AsProtobufJSON {
    pictureId: string;
    cropLeft: number;
    cropTop: number;
    cropWidth: number;
    cropHeight: number;
  }
}

/**
 * Message implementation for goautowp.SetPicturePointRequest
 */
export class SetPicturePointRequest implements GrpcMessage {
  static id = 'goautowp.SetPicturePointRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SetPicturePointRequest();
    SetPicturePointRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SetPicturePointRequest) {
    _instance.pictureId = _instance.pictureId || '0';
    _instance.point = _instance.point || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SetPicturePointRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.pictureId = _reader.readInt64String();
          break;
        case 2:
          _instance.point = new googleType009.LatLng();
          _reader.readMessage(
            _instance.point,
            googleType009.LatLng.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    SetPicturePointRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SetPicturePointRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.pictureId) {
      _writer.writeInt64String(1, _instance.pictureId);
    }
    if (_instance.point) {
      _writer.writeMessage(
        2,
        _instance.point as any,
        googleType009.LatLng.serializeBinaryToWriter
      );
    }
  }

  private _pictureId: string;
  private _point?: googleType009.LatLng;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SetPicturePointRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<SetPicturePointRequest.AsObject>) {
    _value = _value || {};
    this.pictureId = _value.pictureId;
    this.point = _value.point
      ? new googleType009.LatLng(_value.point)
      : undefined;
    SetPicturePointRequest.refineValues(this);
  }
  get pictureId(): string {
    return this._pictureId;
  }
  set pictureId(value: string) {
    this._pictureId = value;
  }
  get point(): googleType009.LatLng | undefined {
    return this._point;
  }
  set point(value: googleType009.LatLng | undefined) {
    this._point = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SetPicturePointRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SetPicturePointRequest.AsObject {
    return {
      pictureId: this.pictureId,
      point: this.point ? this.point.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SetPicturePointRequest.AsProtobufJSON {
    return {
      pictureId: this.pictureId,
      point: this.point ? this.point.toProtobufJSON(options) : null
    };
  }
}
export module SetPicturePointRequest {
  /**
   * Standard JavaScript object representation for SetPicturePointRequest
   */
  export interface AsObject {
    pictureId: string;
    point?: googleType009.LatLng.AsObject;
  }

  /**
   * Protobuf JSON representation for SetPicturePointRequest
   */
  export interface AsProtobufJSON {
    pictureId: string;
    point: googleType009.LatLng.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.UpdatePictureRequest
 */
export class UpdatePictureRequest implements GrpcMessage {
  static id = 'goautowp.UpdatePictureRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UpdatePictureRequest();
    UpdatePictureRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UpdatePictureRequest) {
    _instance.id = _instance.id || '0';
    _instance.takenDate = _instance.takenDate || undefined;
    _instance.name = _instance.name || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UpdatePictureRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.takenDate = new googleType010.Date();
          _reader.readMessage(
            _instance.takenDate,
            googleType010.Date.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.name = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    UpdatePictureRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: UpdatePictureRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.takenDate) {
      _writer.writeMessage(
        2,
        _instance.takenDate as any,
        googleType010.Date.serializeBinaryToWriter
      );
    }
    if (_instance.name) {
      _writer.writeString(3, _instance.name);
    }
  }

  private _id: string;
  private _takenDate?: googleType010.Date;
  private _name: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UpdatePictureRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<UpdatePictureRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.takenDate = _value.takenDate
      ? new googleType010.Date(_value.takenDate)
      : undefined;
    this.name = _value.name;
    UpdatePictureRequest.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get takenDate(): googleType010.Date | undefined {
    return this._takenDate;
  }
  set takenDate(value: googleType010.Date | undefined) {
    this._takenDate = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UpdatePictureRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UpdatePictureRequest.AsObject {
    return {
      id: this.id,
      takenDate: this.takenDate ? this.takenDate.toObject() : undefined,
      name: this.name
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UpdatePictureRequest.AsProtobufJSON {
    return {
      id: this.id,
      takenDate: this.takenDate ? this.takenDate.toProtobufJSON(options) : null,
      name: this.name
    };
  }
}
export module UpdatePictureRequest {
  /**
   * Standard JavaScript object representation for UpdatePictureRequest
   */
  export interface AsObject {
    id: string;
    takenDate?: googleType010.Date.AsObject;
    name: string;
  }

  /**
   * Protobuf JSON representation for UpdatePictureRequest
   */
  export interface AsProtobufJSON {
    id: string;
    takenDate: googleType010.Date.AsProtobufJSON | null;
    name: string;
  }
}

/**
 * Message implementation for goautowp.SetPictureCopyrightsRequest
 */
export class SetPictureCopyrightsRequest implements GrpcMessage {
  static id = 'goautowp.SetPictureCopyrightsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SetPictureCopyrightsRequest();
    SetPictureCopyrightsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SetPictureCopyrightsRequest) {
    _instance.id = _instance.id || '0';
    _instance.copyrights = _instance.copyrights || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SetPictureCopyrightsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.copyrights = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    SetPictureCopyrightsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SetPictureCopyrightsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.copyrights) {
      _writer.writeString(2, _instance.copyrights);
    }
  }

  private _id: string;
  private _copyrights: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SetPictureCopyrightsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<SetPictureCopyrightsRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.copyrights = _value.copyrights;
    SetPictureCopyrightsRequest.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get copyrights(): string {
    return this._copyrights;
  }
  set copyrights(value: string) {
    this._copyrights = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SetPictureCopyrightsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SetPictureCopyrightsRequest.AsObject {
    return {
      id: this.id,
      copyrights: this.copyrights
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SetPictureCopyrightsRequest.AsProtobufJSON {
    return {
      id: this.id,
      copyrights: this.copyrights
    };
  }
}
export module SetPictureCopyrightsRequest {
  /**
   * Standard JavaScript object representation for SetPictureCopyrightsRequest
   */
  export interface AsObject {
    id: string;
    copyrights: string;
  }

  /**
   * Protobuf JSON representation for SetPictureCopyrightsRequest
   */
  export interface AsProtobufJSON {
    id: string;
    copyrights: string;
  }
}

/**
 * Message implementation for goautowp.SetPictureStatusRequest
 */
export class SetPictureStatusRequest implements GrpcMessage {
  static id = 'goautowp.SetPictureStatusRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SetPictureStatusRequest();
    SetPictureStatusRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SetPictureStatusRequest) {
    _instance.id = _instance.id || '0';
    _instance.status = _instance.status || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SetPictureStatusRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.status = _reader.readEnum();
          break;
        default:
          _reader.skipField();
      }
    }

    SetPictureStatusRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SetPictureStatusRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.status) {
      _writer.writeEnum(2, _instance.status);
    }
  }

  private _id: string;
  private _status: PictureStatus;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SetPictureStatusRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<SetPictureStatusRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.status = _value.status;
    SetPictureStatusRequest.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get status(): PictureStatus {
    return this._status;
  }
  set status(value: PictureStatus) {
    this._status = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SetPictureStatusRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SetPictureStatusRequest.AsObject {
    return {
      id: this.id,
      status: this.status
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SetPictureStatusRequest.AsProtobufJSON {
    return {
      id: this.id,
      status:
        PictureStatus[
          this.status === null || this.status === undefined ? 0 : this.status
        ]
    };
  }
}
export module SetPictureStatusRequest {
  /**
   * Standard JavaScript object representation for SetPictureStatusRequest
   */
  export interface AsObject {
    id: string;
    status: PictureStatus;
  }

  /**
   * Protobuf JSON representation for SetPictureStatusRequest
   */
  export interface AsProtobufJSON {
    id: string;
    status: string;
  }
}

/**
 * Message implementation for goautowp.NewboxRequest
 */
export class NewboxRequest implements GrpcMessage {
  static id = 'goautowp.NewboxRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new NewboxRequest();
    NewboxRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: NewboxRequest) {
    _instance.date = _instance.date || undefined;
    _instance.language = _instance.language || '';
    _instance.page = _instance.page || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: NewboxRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.date = new googleType010.Date();
          _reader.readMessage(
            _instance.date,
            googleType010.Date.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.language = _reader.readString();
          break;
        case 3:
          _instance.page = _reader.readUint32();
          break;
        default:
          _reader.skipField();
      }
    }

    NewboxRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: NewboxRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.date) {
      _writer.writeMessage(
        1,
        _instance.date as any,
        googleType010.Date.serializeBinaryToWriter
      );
    }
    if (_instance.language) {
      _writer.writeString(2, _instance.language);
    }
    if (_instance.page) {
      _writer.writeUint32(3, _instance.page);
    }
  }

  private _date?: googleType010.Date;
  private _language: string;
  private _page: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of NewboxRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<NewboxRequest.AsObject>) {
    _value = _value || {};
    this.date = _value.date ? new googleType010.Date(_value.date) : undefined;
    this.language = _value.language;
    this.page = _value.page;
    NewboxRequest.refineValues(this);
  }
  get date(): googleType010.Date | undefined {
    return this._date;
  }
  set date(value: googleType010.Date | undefined) {
    this._date = value;
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }
  get page(): number {
    return this._page;
  }
  set page(value: number) {
    this._page = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    NewboxRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): NewboxRequest.AsObject {
    return {
      date: this.date ? this.date.toObject() : undefined,
      language: this.language,
      page: this.page
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): NewboxRequest.AsProtobufJSON {
    return {
      date: this.date ? this.date.toProtobufJSON(options) : null,
      language: this.language,
      page: this.page
    };
  }
}
export module NewboxRequest {
  /**
   * Standard JavaScript object representation for NewboxRequest
   */
  export interface AsObject {
    date?: googleType010.Date.AsObject;
    language: string;
    page: number;
  }

  /**
   * Protobuf JSON representation for NewboxRequest
   */
  export interface AsProtobufJSON {
    date: googleType010.Date.AsProtobufJSON | null;
    language: string;
    page: number;
  }
}

/**
 * Message implementation for goautowp.NewboxGroup
 */
export class NewboxGroup implements GrpcMessage {
  static id = 'goautowp.NewboxGroup';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new NewboxGroup();
    NewboxGroup.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: NewboxGroup) {
    _instance.item = _instance.item || undefined;
    _instance.pictures = _instance.pictures || [];
    _instance.totalPictures = _instance.totalPictures || 0;
    _instance.type = _instance.type || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: NewboxGroup,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.item = new APIItem();
          _reader.readMessage(
            _instance.item,
            APIItem.deserializeBinaryFromReader
          );
          break;
        case 2:
          const messageInitializer2 = new Picture();
          _reader.readMessage(
            messageInitializer2,
            Picture.deserializeBinaryFromReader
          );
          (_instance.pictures = _instance.pictures || []).push(
            messageInitializer2
          );
          break;
        case 3:
          _instance.totalPictures = _reader.readInt32();
          break;
        case 4:
          _instance.type = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    NewboxGroup.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: NewboxGroup,
    _writer: BinaryWriter
  ) {
    if (_instance.item) {
      _writer.writeMessage(
        1,
        _instance.item as any,
        APIItem.serializeBinaryToWriter
      );
    }
    if (_instance.pictures && _instance.pictures.length) {
      _writer.writeRepeatedMessage(
        2,
        _instance.pictures as any,
        Picture.serializeBinaryToWriter
      );
    }
    if (_instance.totalPictures) {
      _writer.writeInt32(3, _instance.totalPictures);
    }
    if (_instance.type) {
      _writer.writeString(4, _instance.type);
    }
  }

  private _item?: APIItem;
  private _pictures?: Picture[];
  private _totalPictures: number;
  private _type: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of NewboxGroup to deeply clone from
   */
  constructor(_value?: RecursivePartial<NewboxGroup.AsObject>) {
    _value = _value || {};
    this.item = _value.item ? new APIItem(_value.item) : undefined;
    this.pictures = (_value.pictures || []).map(m => new Picture(m));
    this.totalPictures = _value.totalPictures;
    this.type = _value.type;
    NewboxGroup.refineValues(this);
  }
  get item(): APIItem | undefined {
    return this._item;
  }
  set item(value: APIItem | undefined) {
    this._item = value;
  }
  get pictures(): Picture[] | undefined {
    return this._pictures;
  }
  set pictures(value: Picture[] | undefined) {
    this._pictures = value;
  }
  get totalPictures(): number {
    return this._totalPictures;
  }
  set totalPictures(value: number) {
    this._totalPictures = value;
  }
  get type(): string {
    return this._type;
  }
  set type(value: string) {
    this._type = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    NewboxGroup.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): NewboxGroup.AsObject {
    return {
      item: this.item ? this.item.toObject() : undefined,
      pictures: (this.pictures || []).map(m => m.toObject()),
      totalPictures: this.totalPictures,
      type: this.type
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): NewboxGroup.AsProtobufJSON {
    return {
      item: this.item ? this.item.toProtobufJSON(options) : null,
      pictures: (this.pictures || []).map(m => m.toProtobufJSON(options)),
      totalPictures: this.totalPictures,
      type: this.type
    };
  }
}
export module NewboxGroup {
  /**
   * Standard JavaScript object representation for NewboxGroup
   */
  export interface AsObject {
    item?: APIItem.AsObject;
    pictures?: Picture.AsObject[];
    totalPictures: number;
    type: string;
  }

  /**
   * Protobuf JSON representation for NewboxGroup
   */
  export interface AsProtobufJSON {
    item: APIItem.AsProtobufJSON | null;
    pictures: Picture.AsProtobufJSON[] | null;
    totalPictures: number;
    type: string;
  }
}

/**
 * Message implementation for goautowp.Newbox
 */
export class Newbox implements GrpcMessage {
  static id = 'goautowp.Newbox';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Newbox();
    Newbox.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Newbox) {
    _instance.groups = _instance.groups || [];
    _instance.prevDate = _instance.prevDate || undefined;
    _instance.prevCount = _instance.prevCount || 0;
    _instance.currentDate = _instance.currentDate || undefined;
    _instance.currentCount = _instance.currentCount || 0;
    _instance.nextDate = _instance.nextDate || undefined;
    _instance.nextCount = _instance.nextCount || 0;
    _instance.paginator = _instance.paginator || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(_instance: Newbox, _reader: BinaryReader) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new NewboxGroup();
          _reader.readMessage(
            messageInitializer1,
            NewboxGroup.deserializeBinaryFromReader
          );
          (_instance.groups = _instance.groups || []).push(messageInitializer1);
          break;
        case 2:
          _instance.prevDate = new googleType010.Date();
          _reader.readMessage(
            _instance.prevDate,
            googleType010.Date.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.prevCount = _reader.readInt32();
          break;
        case 4:
          _instance.currentDate = new googleType010.Date();
          _reader.readMessage(
            _instance.currentDate,
            googleType010.Date.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.currentCount = _reader.readInt32();
          break;
        case 6:
          _instance.nextDate = new googleType010.Date();
          _reader.readMessage(
            _instance.nextDate,
            googleType010.Date.deserializeBinaryFromReader
          );
          break;
        case 7:
          _instance.nextCount = _reader.readInt32();
          break;
        case 8:
          _instance.paginator = new Pages();
          _reader.readMessage(
            _instance.paginator,
            Pages.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    Newbox.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Newbox, _writer: BinaryWriter) {
    if (_instance.groups && _instance.groups.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.groups as any,
        NewboxGroup.serializeBinaryToWriter
      );
    }
    if (_instance.prevDate) {
      _writer.writeMessage(
        2,
        _instance.prevDate as any,
        googleType010.Date.serializeBinaryToWriter
      );
    }
    if (_instance.prevCount) {
      _writer.writeInt32(3, _instance.prevCount);
    }
    if (_instance.currentDate) {
      _writer.writeMessage(
        4,
        _instance.currentDate as any,
        googleType010.Date.serializeBinaryToWriter
      );
    }
    if (_instance.currentCount) {
      _writer.writeInt32(5, _instance.currentCount);
    }
    if (_instance.nextDate) {
      _writer.writeMessage(
        6,
        _instance.nextDate as any,
        googleType010.Date.serializeBinaryToWriter
      );
    }
    if (_instance.nextCount) {
      _writer.writeInt32(7, _instance.nextCount);
    }
    if (_instance.paginator) {
      _writer.writeMessage(
        8,
        _instance.paginator as any,
        Pages.serializeBinaryToWriter
      );
    }
  }

  private _groups?: NewboxGroup[];
  private _prevDate?: googleType010.Date;
  private _prevCount: number;
  private _currentDate?: googleType010.Date;
  private _currentCount: number;
  private _nextDate?: googleType010.Date;
  private _nextCount: number;
  private _paginator?: Pages;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Newbox to deeply clone from
   */
  constructor(_value?: RecursivePartial<Newbox.AsObject>) {
    _value = _value || {};
    this.groups = (_value.groups || []).map(m => new NewboxGroup(m));
    this.prevDate = _value.prevDate
      ? new googleType010.Date(_value.prevDate)
      : undefined;
    this.prevCount = _value.prevCount;
    this.currentDate = _value.currentDate
      ? new googleType010.Date(_value.currentDate)
      : undefined;
    this.currentCount = _value.currentCount;
    this.nextDate = _value.nextDate
      ? new googleType010.Date(_value.nextDate)
      : undefined;
    this.nextCount = _value.nextCount;
    this.paginator = _value.paginator ? new Pages(_value.paginator) : undefined;
    Newbox.refineValues(this);
  }
  get groups(): NewboxGroup[] | undefined {
    return this._groups;
  }
  set groups(value: NewboxGroup[] | undefined) {
    this._groups = value;
  }
  get prevDate(): googleType010.Date | undefined {
    return this._prevDate;
  }
  set prevDate(value: googleType010.Date | undefined) {
    this._prevDate = value;
  }
  get prevCount(): number {
    return this._prevCount;
  }
  set prevCount(value: number) {
    this._prevCount = value;
  }
  get currentDate(): googleType010.Date | undefined {
    return this._currentDate;
  }
  set currentDate(value: googleType010.Date | undefined) {
    this._currentDate = value;
  }
  get currentCount(): number {
    return this._currentCount;
  }
  set currentCount(value: number) {
    this._currentCount = value;
  }
  get nextDate(): googleType010.Date | undefined {
    return this._nextDate;
  }
  set nextDate(value: googleType010.Date | undefined) {
    this._nextDate = value;
  }
  get nextCount(): number {
    return this._nextCount;
  }
  set nextCount(value: number) {
    this._nextCount = value;
  }
  get paginator(): Pages | undefined {
    return this._paginator;
  }
  set paginator(value: Pages | undefined) {
    this._paginator = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Newbox.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Newbox.AsObject {
    return {
      groups: (this.groups || []).map(m => m.toObject()),
      prevDate: this.prevDate ? this.prevDate.toObject() : undefined,
      prevCount: this.prevCount,
      currentDate: this.currentDate ? this.currentDate.toObject() : undefined,
      currentCount: this.currentCount,
      nextDate: this.nextDate ? this.nextDate.toObject() : undefined,
      nextCount: this.nextCount,
      paginator: this.paginator ? this.paginator.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Newbox.AsProtobufJSON {
    return {
      groups: (this.groups || []).map(m => m.toProtobufJSON(options)),
      prevDate: this.prevDate ? this.prevDate.toProtobufJSON(options) : null,
      prevCount: this.prevCount,
      currentDate: this.currentDate
        ? this.currentDate.toProtobufJSON(options)
        : null,
      currentCount: this.currentCount,
      nextDate: this.nextDate ? this.nextDate.toProtobufJSON(options) : null,
      nextCount: this.nextCount,
      paginator: this.paginator ? this.paginator.toProtobufJSON(options) : null
    };
  }
}
export module Newbox {
  /**
   * Standard JavaScript object representation for Newbox
   */
  export interface AsObject {
    groups?: NewboxGroup.AsObject[];
    prevDate?: googleType010.Date.AsObject;
    prevCount: number;
    currentDate?: googleType010.Date.AsObject;
    currentCount: number;
    nextDate?: googleType010.Date.AsObject;
    nextCount: number;
    paginator?: Pages.AsObject;
  }

  /**
   * Protobuf JSON representation for Newbox
   */
  export interface AsProtobufJSON {
    groups: NewboxGroup.AsProtobufJSON[] | null;
    prevDate: googleType010.Date.AsProtobufJSON | null;
    prevCount: number;
    currentDate: googleType010.Date.AsProtobufJSON | null;
    currentCount: number;
    nextDate: googleType010.Date.AsProtobufJSON | null;
    nextCount: number;
    paginator: Pages.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.InboxRequest
 */
export class InboxRequest implements GrpcMessage {
  static id = 'goautowp.InboxRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new InboxRequest();
    InboxRequest.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: InboxRequest) {
    _instance.brandId = _instance.brandId || '0';
    _instance.date = _instance.date || undefined;
    _instance.language = _instance.language || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: InboxRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.brandId = _reader.readInt64String();
          break;
        case 2:
          _instance.date = new googleType010.Date();
          _reader.readMessage(
            _instance.date,
            googleType010.Date.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.language = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    InboxRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: InboxRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.brandId) {
      _writer.writeInt64String(1, _instance.brandId);
    }
    if (_instance.date) {
      _writer.writeMessage(
        2,
        _instance.date as any,
        googleType010.Date.serializeBinaryToWriter
      );
    }
    if (_instance.language) {
      _writer.writeString(3, _instance.language);
    }
  }

  private _brandId: string;
  private _date?: googleType010.Date;
  private _language: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of InboxRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<InboxRequest.AsObject>) {
    _value = _value || {};
    this.brandId = _value.brandId;
    this.date = _value.date ? new googleType010.Date(_value.date) : undefined;
    this.language = _value.language;
    InboxRequest.refineValues(this);
  }
  get brandId(): string {
    return this._brandId;
  }
  set brandId(value: string) {
    this._brandId = value;
  }
  get date(): googleType010.Date | undefined {
    return this._date;
  }
  set date(value: googleType010.Date | undefined) {
    this._date = value;
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    InboxRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): InboxRequest.AsObject {
    return {
      brandId: this.brandId,
      date: this.date ? this.date.toObject() : undefined,
      language: this.language
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): InboxRequest.AsProtobufJSON {
    return {
      brandId: this.brandId,
      date: this.date ? this.date.toProtobufJSON(options) : null,
      language: this.language
    };
  }
}
export module InboxRequest {
  /**
   * Standard JavaScript object representation for InboxRequest
   */
  export interface AsObject {
    brandId: string;
    date?: googleType010.Date.AsObject;
    language: string;
  }

  /**
   * Protobuf JSON representation for InboxRequest
   */
  export interface AsProtobufJSON {
    brandId: string;
    date: googleType010.Date.AsProtobufJSON | null;
    language: string;
  }
}

/**
 * Message implementation for goautowp.InboxBrand
 */
export class InboxBrand implements GrpcMessage {
  static id = 'goautowp.InboxBrand';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new InboxBrand();
    InboxBrand.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: InboxBrand) {
    _instance.id = _instance.id || '0';
    _instance.name = _instance.name || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: InboxBrand,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    InboxBrand.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: InboxBrand, _writer: BinaryWriter) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
  }

  private _id: string;
  private _name: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of InboxBrand to deeply clone from
   */
  constructor(_value?: RecursivePartial<InboxBrand.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.name = _value.name;
    InboxBrand.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    InboxBrand.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): InboxBrand.AsObject {
    return {
      id: this.id,
      name: this.name
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): InboxBrand.AsProtobufJSON {
    return {
      id: this.id,
      name: this.name
    };
  }
}
export module InboxBrand {
  /**
   * Standard JavaScript object representation for InboxBrand
   */
  export interface AsObject {
    id: string;
    name: string;
  }

  /**
   * Protobuf JSON representation for InboxBrand
   */
  export interface AsProtobufJSON {
    id: string;
    name: string;
  }
}

/**
 * Message implementation for goautowp.Inbox
 */
export class Inbox implements GrpcMessage {
  static id = 'goautowp.Inbox';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Inbox();
    Inbox.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Inbox) {
    _instance.brands = _instance.brands || [];
    _instance.prevDate = _instance.prevDate || undefined;
    _instance.prevCount = _instance.prevCount || 0;
    _instance.currentDate = _instance.currentDate || undefined;
    _instance.currentCount = _instance.currentCount || 0;
    _instance.nextDate = _instance.nextDate || undefined;
    _instance.nextCount = _instance.nextCount || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(_instance: Inbox, _reader: BinaryReader) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new InboxBrand();
          _reader.readMessage(
            messageInitializer1,
            InboxBrand.deserializeBinaryFromReader
          );
          (_instance.brands = _instance.brands || []).push(messageInitializer1);
          break;
        case 2:
          _instance.prevDate = new googleType010.Date();
          _reader.readMessage(
            _instance.prevDate,
            googleType010.Date.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.prevCount = _reader.readInt32();
          break;
        case 4:
          _instance.currentDate = new googleType010.Date();
          _reader.readMessage(
            _instance.currentDate,
            googleType010.Date.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.currentCount = _reader.readInt32();
          break;
        case 6:
          _instance.nextDate = new googleType010.Date();
          _reader.readMessage(
            _instance.nextDate,
            googleType010.Date.deserializeBinaryFromReader
          );
          break;
        case 7:
          _instance.nextCount = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    Inbox.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Inbox, _writer: BinaryWriter) {
    if (_instance.brands && _instance.brands.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.brands as any,
        InboxBrand.serializeBinaryToWriter
      );
    }
    if (_instance.prevDate) {
      _writer.writeMessage(
        2,
        _instance.prevDate as any,
        googleType010.Date.serializeBinaryToWriter
      );
    }
    if (_instance.prevCount) {
      _writer.writeInt32(3, _instance.prevCount);
    }
    if (_instance.currentDate) {
      _writer.writeMessage(
        4,
        _instance.currentDate as any,
        googleType010.Date.serializeBinaryToWriter
      );
    }
    if (_instance.currentCount) {
      _writer.writeInt32(5, _instance.currentCount);
    }
    if (_instance.nextDate) {
      _writer.writeMessage(
        6,
        _instance.nextDate as any,
        googleType010.Date.serializeBinaryToWriter
      );
    }
    if (_instance.nextCount) {
      _writer.writeInt32(7, _instance.nextCount);
    }
  }

  private _brands?: InboxBrand[];
  private _prevDate?: googleType010.Date;
  private _prevCount: number;
  private _currentDate?: googleType010.Date;
  private _currentCount: number;
  private _nextDate?: googleType010.Date;
  private _nextCount: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Inbox to deeply clone from
   */
  constructor(_value?: RecursivePartial<Inbox.AsObject>) {
    _value = _value || {};
    this.brands = (_value.brands || []).map(m => new InboxBrand(m));
    this.prevDate = _value.prevDate
      ? new googleType010.Date(_value.prevDate)
      : undefined;
    this.prevCount = _value.prevCount;
    this.currentDate = _value.currentDate
      ? new googleType010.Date(_value.currentDate)
      : undefined;
    this.currentCount = _value.currentCount;
    this.nextDate = _value.nextDate
      ? new googleType010.Date(_value.nextDate)
      : undefined;
    this.nextCount = _value.nextCount;
    Inbox.refineValues(this);
  }
  get brands(): InboxBrand[] | undefined {
    return this._brands;
  }
  set brands(value: InboxBrand[] | undefined) {
    this._brands = value;
  }
  get prevDate(): googleType010.Date | undefined {
    return this._prevDate;
  }
  set prevDate(value: googleType010.Date | undefined) {
    this._prevDate = value;
  }
  get prevCount(): number {
    return this._prevCount;
  }
  set prevCount(value: number) {
    this._prevCount = value;
  }
  get currentDate(): googleType010.Date | undefined {
    return this._currentDate;
  }
  set currentDate(value: googleType010.Date | undefined) {
    this._currentDate = value;
  }
  get currentCount(): number {
    return this._currentCount;
  }
  set currentCount(value: number) {
    this._currentCount = value;
  }
  get nextDate(): googleType010.Date | undefined {
    return this._nextDate;
  }
  set nextDate(value: googleType010.Date | undefined) {
    this._nextDate = value;
  }
  get nextCount(): number {
    return this._nextCount;
  }
  set nextCount(value: number) {
    this._nextCount = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Inbox.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Inbox.AsObject {
    return {
      brands: (this.brands || []).map(m => m.toObject()),
      prevDate: this.prevDate ? this.prevDate.toObject() : undefined,
      prevCount: this.prevCount,
      currentDate: this.currentDate ? this.currentDate.toObject() : undefined,
      currentCount: this.currentCount,
      nextDate: this.nextDate ? this.nextDate.toObject() : undefined,
      nextCount: this.nextCount
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Inbox.AsProtobufJSON {
    return {
      brands: (this.brands || []).map(m => m.toProtobufJSON(options)),
      prevDate: this.prevDate ? this.prevDate.toProtobufJSON(options) : null,
      prevCount: this.prevCount,
      currentDate: this.currentDate
        ? this.currentDate.toProtobufJSON(options)
        : null,
      currentCount: this.currentCount,
      nextDate: this.nextDate ? this.nextDate.toProtobufJSON(options) : null,
      nextCount: this.nextCount
    };
  }
}
export module Inbox {
  /**
   * Standard JavaScript object representation for Inbox
   */
  export interface AsObject {
    brands?: InboxBrand.AsObject[];
    prevDate?: googleType010.Date.AsObject;
    prevCount: number;
    currentDate?: googleType010.Date.AsObject;
    currentCount: number;
    nextDate?: googleType010.Date.AsObject;
    nextCount: number;
  }

  /**
   * Protobuf JSON representation for Inbox
   */
  export interface AsProtobufJSON {
    brands: InboxBrand.AsProtobufJSON[] | null;
    prevDate: googleType010.Date.AsProtobufJSON | null;
    prevCount: number;
    currentDate: googleType010.Date.AsProtobufJSON | null;
    currentCount: number;
    nextDate: googleType010.Date.AsProtobufJSON | null;
    nextCount: number;
  }
}

/**
 * Message implementation for goautowp.CanonicalRouteRequest
 */
export class CanonicalRouteRequest implements GrpcMessage {
  static id = 'goautowp.CanonicalRouteRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CanonicalRouteRequest();
    CanonicalRouteRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CanonicalRouteRequest) {
    _instance.identity = _instance.identity || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CanonicalRouteRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.identity = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    CanonicalRouteRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CanonicalRouteRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.identity) {
      _writer.writeString(1, _instance.identity);
    }
  }

  private _identity: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CanonicalRouteRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<CanonicalRouteRequest.AsObject>) {
    _value = _value || {};
    this.identity = _value.identity;
    CanonicalRouteRequest.refineValues(this);
  }
  get identity(): string {
    return this._identity;
  }
  set identity(value: string) {
    this._identity = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CanonicalRouteRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CanonicalRouteRequest.AsObject {
    return {
      identity: this.identity
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CanonicalRouteRequest.AsProtobufJSON {
    return {
      identity: this.identity
    };
  }
}
export module CanonicalRouteRequest {
  /**
   * Standard JavaScript object representation for CanonicalRouteRequest
   */
  export interface AsObject {
    identity: string;
  }

  /**
   * Protobuf JSON representation for CanonicalRouteRequest
   */
  export interface AsProtobufJSON {
    identity: string;
  }
}

/**
 * Message implementation for goautowp.CanonicalRoute
 */
export class CanonicalRoute implements GrpcMessage {
  static id = 'goautowp.CanonicalRoute';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CanonicalRoute();
    CanonicalRoute.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CanonicalRoute) {
    _instance.route = _instance.route || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CanonicalRoute,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          (_instance.route = _instance.route || []).push(_reader.readString());
          break;
        default:
          _reader.skipField();
      }
    }

    CanonicalRoute.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CanonicalRoute,
    _writer: BinaryWriter
  ) {
    if (_instance.route && _instance.route.length) {
      _writer.writeRepeatedString(1, _instance.route);
    }
  }

  private _route: string[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CanonicalRoute to deeply clone from
   */
  constructor(_value?: RecursivePartial<CanonicalRoute.AsObject>) {
    _value = _value || {};
    this.route = (_value.route || []).slice();
    CanonicalRoute.refineValues(this);
  }
  get route(): string[] {
    return this._route;
  }
  set route(value: string[]) {
    this._route = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CanonicalRoute.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CanonicalRoute.AsObject {
    return {
      route: (this.route || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CanonicalRoute.AsProtobufJSON {
    return {
      route: (this.route || []).slice()
    };
  }
}
export module CanonicalRoute {
  /**
   * Standard JavaScript object representation for CanonicalRoute
   */
  export interface AsObject {
    route: string[];
  }

  /**
   * Protobuf JSON representation for CanonicalRoute
   */
  export interface AsProtobufJSON {
    route: string[];
  }
}

/**
 * Message implementation for goautowp.GalleryRequest
 */
export class GalleryRequest implements GrpcMessage {
  static id = 'goautowp.GalleryRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GalleryRequest();
    GalleryRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GalleryRequest) {
    _instance.request = _instance.request || undefined;
    _instance.pictureIdentity = _instance.pictureIdentity || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GalleryRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.request = new PicturesRequest();
          _reader.readMessage(
            _instance.request,
            PicturesRequest.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.pictureIdentity = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    GalleryRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GalleryRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.request) {
      _writer.writeMessage(
        1,
        _instance.request as any,
        PicturesRequest.serializeBinaryToWriter
      );
    }
    if (_instance.pictureIdentity) {
      _writer.writeString(2, _instance.pictureIdentity);
    }
  }

  private _request?: PicturesRequest;
  private _pictureIdentity: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GalleryRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GalleryRequest.AsObject>) {
    _value = _value || {};
    this.request = _value.request
      ? new PicturesRequest(_value.request)
      : undefined;
    this.pictureIdentity = _value.pictureIdentity;
    GalleryRequest.refineValues(this);
  }
  get request(): PicturesRequest | undefined {
    return this._request;
  }
  set request(value: PicturesRequest | undefined) {
    this._request = value;
  }
  get pictureIdentity(): string {
    return this._pictureIdentity;
  }
  set pictureIdentity(value: string) {
    this._pictureIdentity = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GalleryRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GalleryRequest.AsObject {
    return {
      request: this.request ? this.request.toObject() : undefined,
      pictureIdentity: this.pictureIdentity
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GalleryRequest.AsProtobufJSON {
    return {
      request: this.request ? this.request.toProtobufJSON(options) : null,
      pictureIdentity: this.pictureIdentity
    };
  }
}
export module GalleryRequest {
  /**
   * Standard JavaScript object representation for GalleryRequest
   */
  export interface AsObject {
    request?: PicturesRequest.AsObject;
    pictureIdentity: string;
  }

  /**
   * Protobuf JSON representation for GalleryRequest
   */
  export interface AsProtobufJSON {
    request: PicturesRequest.AsProtobufJSON | null;
    pictureIdentity: string;
  }
}

/**
 * Message implementation for goautowp.GalleryResponse
 */
export class GalleryResponse implements GrpcMessage {
  static id = 'goautowp.GalleryResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GalleryResponse();
    GalleryResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GalleryResponse) {
    _instance.count = _instance.count || 0;
    _instance.items = _instance.items || [];
    _instance.page = _instance.page || 0;
    _instance.pages = _instance.pages || 0;
    _instance.status = _instance.status || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GalleryResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.count = _reader.readInt32();
          break;
        case 2:
          const messageInitializer2 = new Picture();
          _reader.readMessage(
            messageInitializer2,
            Picture.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer2);
          break;
        case 3:
          _instance.page = _reader.readInt32();
          break;
        case 4:
          _instance.pages = _reader.readInt32();
          break;
        case 5:
          _instance.status = _reader.readEnum();
          break;
        default:
          _reader.skipField();
      }
    }

    GalleryResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GalleryResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.count) {
      _writer.writeInt32(1, _instance.count);
    }
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        2,
        _instance.items as any,
        Picture.serializeBinaryToWriter
      );
    }
    if (_instance.page) {
      _writer.writeInt32(3, _instance.page);
    }
    if (_instance.pages) {
      _writer.writeInt32(4, _instance.pages);
    }
    if (_instance.status) {
      _writer.writeEnum(5, _instance.status);
    }
  }

  private _count: number;
  private _items?: Picture[];
  private _page: number;
  private _pages: number;
  private _status: PictureStatus;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GalleryResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<GalleryResponse.AsObject>) {
    _value = _value || {};
    this.count = _value.count;
    this.items = (_value.items || []).map(m => new Picture(m));
    this.page = _value.page;
    this.pages = _value.pages;
    this.status = _value.status;
    GalleryResponse.refineValues(this);
  }
  get count(): number {
    return this._count;
  }
  set count(value: number) {
    this._count = value;
  }
  get items(): Picture[] | undefined {
    return this._items;
  }
  set items(value: Picture[] | undefined) {
    this._items = value;
  }
  get page(): number {
    return this._page;
  }
  set page(value: number) {
    this._page = value;
  }
  get pages(): number {
    return this._pages;
  }
  set pages(value: number) {
    this._pages = value;
  }
  get status(): PictureStatus {
    return this._status;
  }
  set status(value: PictureStatus) {
    this._status = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GalleryResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GalleryResponse.AsObject {
    return {
      count: this.count,
      items: (this.items || []).map(m => m.toObject()),
      page: this.page,
      pages: this.pages,
      status: this.status
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GalleryResponse.AsProtobufJSON {
    return {
      count: this.count,
      items: (this.items || []).map(m => m.toProtobufJSON(options)),
      page: this.page,
      pages: this.pages,
      status:
        PictureStatus[
          this.status === null || this.status === undefined ? 0 : this.status
        ]
    };
  }
}
export module GalleryResponse {
  /**
   * Standard JavaScript object representation for GalleryResponse
   */
  export interface AsObject {
    count: number;
    items?: Picture.AsObject[];
    page: number;
    pages: number;
    status: PictureStatus;
  }

  /**
   * Protobuf JSON representation for GalleryResponse
   */
  export interface AsProtobufJSON {
    count: number;
    items: Picture.AsProtobufJSON[] | null;
    page: number;
    pages: number;
    status: string;
  }
}

/**
 * Message implementation for goautowp.Rectangle
 */
export class Rectangle implements GrpcMessage {
  static id = 'goautowp.Rectangle';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Rectangle();
    Rectangle.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Rectangle) {
    _instance.left = _instance.left || 0;
    _instance.top = _instance.top || 0;
    _instance.width = _instance.width || 0;
    _instance.height = _instance.height || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: Rectangle,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.left = _reader.readInt32();
          break;
        case 2:
          _instance.top = _reader.readInt32();
          break;
        case 3:
          _instance.width = _reader.readInt32();
          break;
        case 4:
          _instance.height = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    Rectangle.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Rectangle, _writer: BinaryWriter) {
    if (_instance.left) {
      _writer.writeInt32(1, _instance.left);
    }
    if (_instance.top) {
      _writer.writeInt32(2, _instance.top);
    }
    if (_instance.width) {
      _writer.writeInt32(3, _instance.width);
    }
    if (_instance.height) {
      _writer.writeInt32(4, _instance.height);
    }
  }

  private _left: number;
  private _top: number;
  private _width: number;
  private _height: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Rectangle to deeply clone from
   */
  constructor(_value?: RecursivePartial<Rectangle.AsObject>) {
    _value = _value || {};
    this.left = _value.left;
    this.top = _value.top;
    this.width = _value.width;
    this.height = _value.height;
    Rectangle.refineValues(this);
  }
  get left(): number {
    return this._left;
  }
  set left(value: number) {
    this._left = value;
  }
  get top(): number {
    return this._top;
  }
  set top(value: number) {
    this._top = value;
  }
  get width(): number {
    return this._width;
  }
  set width(value: number) {
    this._width = value;
  }
  get height(): number {
    return this._height;
  }
  set height(value: number) {
    this._height = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Rectangle.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Rectangle.AsObject {
    return {
      left: this.left,
      top: this.top,
      width: this.width,
      height: this.height
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Rectangle.AsProtobufJSON {
    return {
      left: this.left,
      top: this.top,
      width: this.width,
      height: this.height
    };
  }
}
export module Rectangle {
  /**
   * Standard JavaScript object representation for Rectangle
   */
  export interface AsObject {
    left: number;
    top: number;
    width: number;
    height: number;
  }

  /**
   * Protobuf JSON representation for Rectangle
   */
  export interface AsProtobufJSON {
    left: number;
    top: number;
    width: number;
    height: number;
  }
}

/**
 * Message implementation for goautowp.DeleteSimilarRequest
 */
export class DeleteSimilarRequest implements GrpcMessage {
  static id = 'goautowp.DeleteSimilarRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new DeleteSimilarRequest();
    DeleteSimilarRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: DeleteSimilarRequest) {
    _instance.id = _instance.id || '0';
    _instance.similarPictureId = _instance.similarPictureId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: DeleteSimilarRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.similarPictureId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    DeleteSimilarRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: DeleteSimilarRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.similarPictureId) {
      _writer.writeInt64String(2, _instance.similarPictureId);
    }
  }

  private _id: string;
  private _similarPictureId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of DeleteSimilarRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<DeleteSimilarRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.similarPictureId = _value.similarPictureId;
    DeleteSimilarRequest.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get similarPictureId(): string {
    return this._similarPictureId;
  }
  set similarPictureId(value: string) {
    this._similarPictureId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    DeleteSimilarRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): DeleteSimilarRequest.AsObject {
    return {
      id: this.id,
      similarPictureId: this.similarPictureId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): DeleteSimilarRequest.AsProtobufJSON {
    return {
      id: this.id,
      similarPictureId: this.similarPictureId
    };
  }
}
export module DeleteSimilarRequest {
  /**
   * Standard JavaScript object representation for DeleteSimilarRequest
   */
  export interface AsObject {
    id: string;
    similarPictureId: string;
  }

  /**
   * Protobuf JSON representation for DeleteSimilarRequest
   */
  export interface AsProtobufJSON {
    id: string;
    similarPictureId: string;
  }
}

/**
 * Message implementation for goautowp.DeleteModerVoteRequest
 */
export class DeleteModerVoteRequest implements GrpcMessage {
  static id = 'goautowp.DeleteModerVoteRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new DeleteModerVoteRequest();
    DeleteModerVoteRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: DeleteModerVoteRequest) {
    _instance.pictureId = _instance.pictureId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: DeleteModerVoteRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.pictureId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    DeleteModerVoteRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: DeleteModerVoteRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.pictureId) {
      _writer.writeInt64String(1, _instance.pictureId);
    }
  }

  private _pictureId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of DeleteModerVoteRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<DeleteModerVoteRequest.AsObject>) {
    _value = _value || {};
    this.pictureId = _value.pictureId;
    DeleteModerVoteRequest.refineValues(this);
  }
  get pictureId(): string {
    return this._pictureId;
  }
  set pictureId(value: string) {
    this._pictureId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    DeleteModerVoteRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): DeleteModerVoteRequest.AsObject {
    return {
      pictureId: this.pictureId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): DeleteModerVoteRequest.AsProtobufJSON {
    return {
      pictureId: this.pictureId
    };
  }
}
export module DeleteModerVoteRequest {
  /**
   * Standard JavaScript object representation for DeleteModerVoteRequest
   */
  export interface AsObject {
    pictureId: string;
  }

  /**
   * Protobuf JSON representation for DeleteModerVoteRequest
   */
  export interface AsProtobufJSON {
    pictureId: string;
  }
}

/**
 * Message implementation for goautowp.MessagingDeleteMessage
 */
export class MessagingDeleteMessage implements GrpcMessage {
  static id = 'goautowp.MessagingDeleteMessage';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new MessagingDeleteMessage();
    MessagingDeleteMessage.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: MessagingDeleteMessage) {
    _instance.messageId = _instance.messageId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: MessagingDeleteMessage,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.messageId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    MessagingDeleteMessage.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: MessagingDeleteMessage,
    _writer: BinaryWriter
  ) {
    if (_instance.messageId) {
      _writer.writeInt64String(1, _instance.messageId);
    }
  }

  private _messageId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of MessagingDeleteMessage to deeply clone from
   */
  constructor(_value?: RecursivePartial<MessagingDeleteMessage.AsObject>) {
    _value = _value || {};
    this.messageId = _value.messageId;
    MessagingDeleteMessage.refineValues(this);
  }
  get messageId(): string {
    return this._messageId;
  }
  set messageId(value: string) {
    this._messageId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    MessagingDeleteMessage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): MessagingDeleteMessage.AsObject {
    return {
      messageId: this.messageId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): MessagingDeleteMessage.AsProtobufJSON {
    return {
      messageId: this.messageId
    };
  }
}
export module MessagingDeleteMessage {
  /**
   * Standard JavaScript object representation for MessagingDeleteMessage
   */
  export interface AsObject {
    messageId: string;
  }

  /**
   * Protobuf JSON representation for MessagingDeleteMessage
   */
  export interface AsProtobufJSON {
    messageId: string;
  }
}

/**
 * Message implementation for goautowp.MessagingClearFolder
 */
export class MessagingClearFolder implements GrpcMessage {
  static id = 'goautowp.MessagingClearFolder';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new MessagingClearFolder();
    MessagingClearFolder.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: MessagingClearFolder) {
    _instance.folder = _instance.folder || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: MessagingClearFolder,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.folder = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    MessagingClearFolder.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: MessagingClearFolder,
    _writer: BinaryWriter
  ) {
    if (_instance.folder) {
      _writer.writeString(1, _instance.folder);
    }
  }

  private _folder: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of MessagingClearFolder to deeply clone from
   */
  constructor(_value?: RecursivePartial<MessagingClearFolder.AsObject>) {
    _value = _value || {};
    this.folder = _value.folder;
    MessagingClearFolder.refineValues(this);
  }
  get folder(): string {
    return this._folder;
  }
  set folder(value: string) {
    this._folder = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    MessagingClearFolder.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): MessagingClearFolder.AsObject {
    return {
      folder: this.folder
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): MessagingClearFolder.AsProtobufJSON {
    return {
      folder: this.folder
    };
  }
}
export module MessagingClearFolder {
  /**
   * Standard JavaScript object representation for MessagingClearFolder
   */
  export interface AsObject {
    folder: string;
  }

  /**
   * Protobuf JSON representation for MessagingClearFolder
   */
  export interface AsProtobufJSON {
    folder: string;
  }
}

/**
 * Message implementation for goautowp.MessagingCreateMessage
 */
export class MessagingCreateMessage implements GrpcMessage {
  static id = 'goautowp.MessagingCreateMessage';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new MessagingCreateMessage();
    MessagingCreateMessage.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: MessagingCreateMessage) {
    _instance.userId = _instance.userId || '0';
    _instance.text = _instance.text || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: MessagingCreateMessage,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.userId = _reader.readInt64String();
          break;
        case 2:
          _instance.text = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    MessagingCreateMessage.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: MessagingCreateMessage,
    _writer: BinaryWriter
  ) {
    if (_instance.userId) {
      _writer.writeInt64String(1, _instance.userId);
    }
    if (_instance.text) {
      _writer.writeString(2, _instance.text);
    }
  }

  private _userId: string;
  private _text: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of MessagingCreateMessage to deeply clone from
   */
  constructor(_value?: RecursivePartial<MessagingCreateMessage.AsObject>) {
    _value = _value || {};
    this.userId = _value.userId;
    this.text = _value.text;
    MessagingCreateMessage.refineValues(this);
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }
  get text(): string {
    return this._text;
  }
  set text(value: string) {
    this._text = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    MessagingCreateMessage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): MessagingCreateMessage.AsObject {
    return {
      userId: this.userId,
      text: this.text
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): MessagingCreateMessage.AsProtobufJSON {
    return {
      userId: this.userId,
      text: this.text
    };
  }
}
export module MessagingCreateMessage {
  /**
   * Standard JavaScript object representation for MessagingCreateMessage
   */
  export interface AsObject {
    userId: string;
    text: string;
  }

  /**
   * Protobuf JSON representation for MessagingCreateMessage
   */
  export interface AsProtobufJSON {
    userId: string;
    text: string;
  }
}

/**
 * Message implementation for goautowp.APIMessage
 */
export class APIMessage implements GrpcMessage {
  static id = 'goautowp.APIMessage';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIMessage();
    APIMessage.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIMessage) {
    _instance.id = _instance.id || '0';
    _instance.text = _instance.text || '';
    _instance.isNew = _instance.isNew || false;
    _instance.canDelete = _instance.canDelete || false;
    _instance.canReply = _instance.canReply || false;
    _instance.date = _instance.date || undefined;
    _instance.allMessagesLink = _instance.allMessagesLink || false;
    _instance.dialogCount = _instance.dialogCount || 0;
    _instance.authorId = _instance.authorId || '0';
    _instance.toUserId = _instance.toUserId || '0';
    _instance.dialogWithUserId = _instance.dialogWithUserId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIMessage,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.text = _reader.readString();
          break;
        case 3:
          _instance.isNew = _reader.readBool();
          break;
        case 4:
          _instance.canDelete = _reader.readBool();
          break;
        case 5:
          _instance.canReply = _reader.readBool();
          break;
        case 6:
          _instance.date = new googleProtobuf006.Timestamp();
          _reader.readMessage(
            _instance.date,
            googleProtobuf006.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 7:
          _instance.allMessagesLink = _reader.readBool();
          break;
        case 8:
          _instance.dialogCount = _reader.readInt32();
          break;
        case 9:
          _instance.authorId = _reader.readInt64String();
          break;
        case 10:
          _instance.toUserId = _reader.readInt64String();
          break;
        case 11:
          _instance.dialogWithUserId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    APIMessage.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: APIMessage, _writer: BinaryWriter) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.text) {
      _writer.writeString(2, _instance.text);
    }
    if (_instance.isNew) {
      _writer.writeBool(3, _instance.isNew);
    }
    if (_instance.canDelete) {
      _writer.writeBool(4, _instance.canDelete);
    }
    if (_instance.canReply) {
      _writer.writeBool(5, _instance.canReply);
    }
    if (_instance.date) {
      _writer.writeMessage(
        6,
        _instance.date as any,
        googleProtobuf006.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.allMessagesLink) {
      _writer.writeBool(7, _instance.allMessagesLink);
    }
    if (_instance.dialogCount) {
      _writer.writeInt32(8, _instance.dialogCount);
    }
    if (_instance.authorId) {
      _writer.writeInt64String(9, _instance.authorId);
    }
    if (_instance.toUserId) {
      _writer.writeInt64String(10, _instance.toUserId);
    }
    if (_instance.dialogWithUserId) {
      _writer.writeInt64String(11, _instance.dialogWithUserId);
    }
  }

  private _id: string;
  private _text: string;
  private _isNew: boolean;
  private _canDelete: boolean;
  private _canReply: boolean;
  private _date?: googleProtobuf006.Timestamp;
  private _allMessagesLink: boolean;
  private _dialogCount: number;
  private _authorId: string;
  private _toUserId: string;
  private _dialogWithUserId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIMessage to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIMessage.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.text = _value.text;
    this.isNew = _value.isNew;
    this.canDelete = _value.canDelete;
    this.canReply = _value.canReply;
    this.date = _value.date
      ? new googleProtobuf006.Timestamp(_value.date)
      : undefined;
    this.allMessagesLink = _value.allMessagesLink;
    this.dialogCount = _value.dialogCount;
    this.authorId = _value.authorId;
    this.toUserId = _value.toUserId;
    this.dialogWithUserId = _value.dialogWithUserId;
    APIMessage.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get text(): string {
    return this._text;
  }
  set text(value: string) {
    this._text = value;
  }
  get isNew(): boolean {
    return this._isNew;
  }
  set isNew(value: boolean) {
    this._isNew = value;
  }
  get canDelete(): boolean {
    return this._canDelete;
  }
  set canDelete(value: boolean) {
    this._canDelete = value;
  }
  get canReply(): boolean {
    return this._canReply;
  }
  set canReply(value: boolean) {
    this._canReply = value;
  }
  get date(): googleProtobuf006.Timestamp | undefined {
    return this._date;
  }
  set date(value: googleProtobuf006.Timestamp | undefined) {
    this._date = value;
  }
  get allMessagesLink(): boolean {
    return this._allMessagesLink;
  }
  set allMessagesLink(value: boolean) {
    this._allMessagesLink = value;
  }
  get dialogCount(): number {
    return this._dialogCount;
  }
  set dialogCount(value: number) {
    this._dialogCount = value;
  }
  get authorId(): string {
    return this._authorId;
  }
  set authorId(value: string) {
    this._authorId = value;
  }
  get toUserId(): string {
    return this._toUserId;
  }
  set toUserId(value: string) {
    this._toUserId = value;
  }
  get dialogWithUserId(): string {
    return this._dialogWithUserId;
  }
  set dialogWithUserId(value: string) {
    this._dialogWithUserId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIMessage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIMessage.AsObject {
    return {
      id: this.id,
      text: this.text,
      isNew: this.isNew,
      canDelete: this.canDelete,
      canReply: this.canReply,
      date: this.date ? this.date.toObject() : undefined,
      allMessagesLink: this.allMessagesLink,
      dialogCount: this.dialogCount,
      authorId: this.authorId,
      toUserId: this.toUserId,
      dialogWithUserId: this.dialogWithUserId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIMessage.AsProtobufJSON {
    return {
      id: this.id,
      text: this.text,
      isNew: this.isNew,
      canDelete: this.canDelete,
      canReply: this.canReply,
      date: this.date ? this.date.toProtobufJSON(options) : null,
      allMessagesLink: this.allMessagesLink,
      dialogCount: this.dialogCount,
      authorId: this.authorId,
      toUserId: this.toUserId,
      dialogWithUserId: this.dialogWithUserId
    };
  }
}
export module APIMessage {
  /**
   * Standard JavaScript object representation for APIMessage
   */
  export interface AsObject {
    id: string;
    text: string;
    isNew: boolean;
    canDelete: boolean;
    canReply: boolean;
    date?: googleProtobuf006.Timestamp.AsObject;
    allMessagesLink: boolean;
    dialogCount: number;
    authorId: string;
    toUserId: string;
    dialogWithUserId: string;
  }

  /**
   * Protobuf JSON representation for APIMessage
   */
  export interface AsProtobufJSON {
    id: string;
    text: string;
    isNew: boolean;
    canDelete: boolean;
    canReply: boolean;
    date: googleProtobuf006.Timestamp.AsProtobufJSON | null;
    allMessagesLink: boolean;
    dialogCount: number;
    authorId: string;
    toUserId: string;
    dialogWithUserId: string;
  }
}

/**
 * Message implementation for goautowp.MessagingGetMessagesRequest
 */
export class MessagingGetMessagesRequest implements GrpcMessage {
  static id = 'goautowp.MessagingGetMessagesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new MessagingGetMessagesRequest();
    MessagingGetMessagesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: MessagingGetMessagesRequest) {
    _instance.userId = _instance.userId || '0';
    _instance.folder = _instance.folder || '';
    _instance.page = _instance.page || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: MessagingGetMessagesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.userId = _reader.readInt64String();
          break;
        case 2:
          _instance.folder = _reader.readString();
          break;
        case 3:
          _instance.page = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    MessagingGetMessagesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: MessagingGetMessagesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.userId) {
      _writer.writeInt64String(1, _instance.userId);
    }
    if (_instance.folder) {
      _writer.writeString(2, _instance.folder);
    }
    if (_instance.page) {
      _writer.writeInt32(3, _instance.page);
    }
  }

  private _userId: string;
  private _folder: string;
  private _page: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of MessagingGetMessagesRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<MessagingGetMessagesRequest.AsObject>) {
    _value = _value || {};
    this.userId = _value.userId;
    this.folder = _value.folder;
    this.page = _value.page;
    MessagingGetMessagesRequest.refineValues(this);
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }
  get folder(): string {
    return this._folder;
  }
  set folder(value: string) {
    this._folder = value;
  }
  get page(): number {
    return this._page;
  }
  set page(value: number) {
    this._page = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    MessagingGetMessagesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): MessagingGetMessagesRequest.AsObject {
    return {
      userId: this.userId,
      folder: this.folder,
      page: this.page
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): MessagingGetMessagesRequest.AsProtobufJSON {
    return {
      userId: this.userId,
      folder: this.folder,
      page: this.page
    };
  }
}
export module MessagingGetMessagesRequest {
  /**
   * Standard JavaScript object representation for MessagingGetMessagesRequest
   */
  export interface AsObject {
    userId: string;
    folder: string;
    page: number;
  }

  /**
   * Protobuf JSON representation for MessagingGetMessagesRequest
   */
  export interface AsProtobufJSON {
    userId: string;
    folder: string;
    page: number;
  }
}

/**
 * Message implementation for goautowp.MessagingGetMessagesResponse
 */
export class MessagingGetMessagesResponse implements GrpcMessage {
  static id = 'goautowp.MessagingGetMessagesResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new MessagingGetMessagesResponse();
    MessagingGetMessagesResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: MessagingGetMessagesResponse) {
    _instance.items = _instance.items || [];
    _instance.paginator = _instance.paginator || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: MessagingGetMessagesResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new APIMessage();
          _reader.readMessage(
            messageInitializer1,
            APIMessage.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        case 2:
          _instance.paginator = new Pages();
          _reader.readMessage(
            _instance.paginator,
            Pages.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    MessagingGetMessagesResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: MessagingGetMessagesResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        APIMessage.serializeBinaryToWriter
      );
    }
    if (_instance.paginator) {
      _writer.writeMessage(
        2,
        _instance.paginator as any,
        Pages.serializeBinaryToWriter
      );
    }
  }

  private _items?: APIMessage[];
  private _paginator?: Pages;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of MessagingGetMessagesResponse to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<MessagingGetMessagesResponse.AsObject>
  ) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new APIMessage(m));
    this.paginator = _value.paginator ? new Pages(_value.paginator) : undefined;
    MessagingGetMessagesResponse.refineValues(this);
  }
  get items(): APIMessage[] | undefined {
    return this._items;
  }
  set items(value: APIMessage[] | undefined) {
    this._items = value;
  }
  get paginator(): Pages | undefined {
    return this._paginator;
  }
  set paginator(value: Pages | undefined) {
    this._paginator = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    MessagingGetMessagesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): MessagingGetMessagesResponse.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject()),
      paginator: this.paginator ? this.paginator.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): MessagingGetMessagesResponse.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options)),
      paginator: this.paginator ? this.paginator.toProtobufJSON(options) : null
    };
  }
}
export module MessagingGetMessagesResponse {
  /**
   * Standard JavaScript object representation for MessagingGetMessagesResponse
   */
  export interface AsObject {
    items?: APIMessage.AsObject[];
    paginator?: Pages.AsObject;
  }

  /**
   * Protobuf JSON representation for MessagingGetMessagesResponse
   */
  export interface AsProtobufJSON {
    items: APIMessage.AsProtobufJSON[] | null;
    paginator: Pages.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.Pages
 */
export class Pages implements GrpcMessage {
  static id = 'goautowp.Pages';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Pages();
    Pages.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Pages) {
    _instance.pageCount = _instance.pageCount || 0;
    _instance.first = _instance.first || 0;
    _instance.current = _instance.current || 0;
    _instance.next = _instance.next || 0;
    _instance.previous = _instance.previous || 0;
    _instance.firstPageInRange = _instance.firstPageInRange || 0;
    _instance.lastPageInRange = _instance.lastPageInRange || 0;
    _instance.pagesInRange = _instance.pagesInRange || [];
    _instance.totalItemCount = _instance.totalItemCount || 0;
    _instance.last = _instance.last || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(_instance: Pages, _reader: BinaryReader) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.pageCount = _reader.readInt32();
          break;
        case 2:
          _instance.first = _reader.readInt32();
          break;
        case 3:
          _instance.current = _reader.readInt32();
          break;
        case 5:
          _instance.next = _reader.readInt32();
          break;
        case 6:
          _instance.previous = _reader.readInt32();
          break;
        case 7:
          _instance.firstPageInRange = _reader.readInt32();
          break;
        case 8:
          _instance.lastPageInRange = _reader.readInt32();
          break;
        case 9:
          (_instance.pagesInRange = _instance.pagesInRange || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        case 10:
          _instance.totalItemCount = _reader.readInt32();
          break;
        case 11:
          _instance.last = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    Pages.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Pages, _writer: BinaryWriter) {
    if (_instance.pageCount) {
      _writer.writeInt32(1, _instance.pageCount);
    }
    if (_instance.first) {
      _writer.writeInt32(2, _instance.first);
    }
    if (_instance.current) {
      _writer.writeInt32(3, _instance.current);
    }
    if (_instance.next) {
      _writer.writeInt32(5, _instance.next);
    }
    if (_instance.previous) {
      _writer.writeInt32(6, _instance.previous);
    }
    if (_instance.firstPageInRange) {
      _writer.writeInt32(7, _instance.firstPageInRange);
    }
    if (_instance.lastPageInRange) {
      _writer.writeInt32(8, _instance.lastPageInRange);
    }
    if (_instance.pagesInRange && _instance.pagesInRange.length) {
      _writer.writePackedInt32(9, _instance.pagesInRange);
    }
    if (_instance.totalItemCount) {
      _writer.writeInt32(10, _instance.totalItemCount);
    }
    if (_instance.last) {
      _writer.writeInt32(11, _instance.last);
    }
  }

  private _pageCount: number;
  private _first: number;
  private _current: number;
  private _next: number;
  private _previous: number;
  private _firstPageInRange: number;
  private _lastPageInRange: number;
  private _pagesInRange: number[];
  private _totalItemCount: number;
  private _last: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Pages to deeply clone from
   */
  constructor(_value?: RecursivePartial<Pages.AsObject>) {
    _value = _value || {};
    this.pageCount = _value.pageCount;
    this.first = _value.first;
    this.current = _value.current;
    this.next = _value.next;
    this.previous = _value.previous;
    this.firstPageInRange = _value.firstPageInRange;
    this.lastPageInRange = _value.lastPageInRange;
    this.pagesInRange = (_value.pagesInRange || []).slice();
    this.totalItemCount = _value.totalItemCount;
    this.last = _value.last;
    Pages.refineValues(this);
  }
  get pageCount(): number {
    return this._pageCount;
  }
  set pageCount(value: number) {
    this._pageCount = value;
  }
  get first(): number {
    return this._first;
  }
  set first(value: number) {
    this._first = value;
  }
  get current(): number {
    return this._current;
  }
  set current(value: number) {
    this._current = value;
  }
  get next(): number {
    return this._next;
  }
  set next(value: number) {
    this._next = value;
  }
  get previous(): number {
    return this._previous;
  }
  set previous(value: number) {
    this._previous = value;
  }
  get firstPageInRange(): number {
    return this._firstPageInRange;
  }
  set firstPageInRange(value: number) {
    this._firstPageInRange = value;
  }
  get lastPageInRange(): number {
    return this._lastPageInRange;
  }
  set lastPageInRange(value: number) {
    this._lastPageInRange = value;
  }
  get pagesInRange(): number[] {
    return this._pagesInRange;
  }
  set pagesInRange(value: number[]) {
    this._pagesInRange = value;
  }
  get totalItemCount(): number {
    return this._totalItemCount;
  }
  set totalItemCount(value: number) {
    this._totalItemCount = value;
  }
  get last(): number {
    return this._last;
  }
  set last(value: number) {
    this._last = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Pages.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Pages.AsObject {
    return {
      pageCount: this.pageCount,
      first: this.first,
      current: this.current,
      next: this.next,
      previous: this.previous,
      firstPageInRange: this.firstPageInRange,
      lastPageInRange: this.lastPageInRange,
      pagesInRange: (this.pagesInRange || []).slice(),
      totalItemCount: this.totalItemCount,
      last: this.last
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Pages.AsProtobufJSON {
    return {
      pageCount: this.pageCount,
      first: this.first,
      current: this.current,
      next: this.next,
      previous: this.previous,
      firstPageInRange: this.firstPageInRange,
      lastPageInRange: this.lastPageInRange,
      pagesInRange: (this.pagesInRange || []).slice(),
      totalItemCount: this.totalItemCount,
      last: this.last
    };
  }
}
export module Pages {
  /**
   * Standard JavaScript object representation for Pages
   */
  export interface AsObject {
    pageCount: number;
    first: number;
    current: number;
    next: number;
    previous: number;
    firstPageInRange: number;
    lastPageInRange: number;
    pagesInRange: number[];
    totalItemCount: number;
    last: number;
  }

  /**
   * Protobuf JSON representation for Pages
   */
  export interface AsProtobufJSON {
    pageCount: number;
    first: number;
    current: number;
    next: number;
    previous: number;
    firstPageInRange: number;
    lastPageInRange: number;
    pagesInRange: number[];
    totalItemCount: number;
    last: number;
  }
}

/**
 * Message implementation for goautowp.DonationsTransaction
 */
export class DonationsTransaction implements GrpcMessage {
  static id = 'goautowp.DonationsTransaction';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new DonationsTransaction();
    DonationsTransaction.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: DonationsTransaction) {
    _instance.sum = _instance.sum || 0;
    _instance.currency = _instance.currency || '';
    _instance.date = _instance.date || undefined;
    _instance.contributor = _instance.contributor || '';
    _instance.purpose = _instance.purpose || '';
    _instance.userId = _instance.userId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: DonationsTransaction,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.sum = _reader.readInt32();
          break;
        case 2:
          _instance.currency = _reader.readString();
          break;
        case 3:
          _instance.date = new googleProtobuf006.Timestamp();
          _reader.readMessage(
            _instance.date,
            googleProtobuf006.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.contributor = _reader.readString();
          break;
        case 5:
          _instance.purpose = _reader.readString();
          break;
        case 6:
          _instance.userId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    DonationsTransaction.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: DonationsTransaction,
    _writer: BinaryWriter
  ) {
    if (_instance.sum) {
      _writer.writeInt32(1, _instance.sum);
    }
    if (_instance.currency) {
      _writer.writeString(2, _instance.currency);
    }
    if (_instance.date) {
      _writer.writeMessage(
        3,
        _instance.date as any,
        googleProtobuf006.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.contributor) {
      _writer.writeString(4, _instance.contributor);
    }
    if (_instance.purpose) {
      _writer.writeString(5, _instance.purpose);
    }
    if (_instance.userId) {
      _writer.writeInt64String(6, _instance.userId);
    }
  }

  private _sum: number;
  private _currency: string;
  private _date?: googleProtobuf006.Timestamp;
  private _contributor: string;
  private _purpose: string;
  private _userId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of DonationsTransaction to deeply clone from
   */
  constructor(_value?: RecursivePartial<DonationsTransaction.AsObject>) {
    _value = _value || {};
    this.sum = _value.sum;
    this.currency = _value.currency;
    this.date = _value.date
      ? new googleProtobuf006.Timestamp(_value.date)
      : undefined;
    this.contributor = _value.contributor;
    this.purpose = _value.purpose;
    this.userId = _value.userId;
    DonationsTransaction.refineValues(this);
  }
  get sum(): number {
    return this._sum;
  }
  set sum(value: number) {
    this._sum = value;
  }
  get currency(): string {
    return this._currency;
  }
  set currency(value: string) {
    this._currency = value;
  }
  get date(): googleProtobuf006.Timestamp | undefined {
    return this._date;
  }
  set date(value: googleProtobuf006.Timestamp | undefined) {
    this._date = value;
  }
  get contributor(): string {
    return this._contributor;
  }
  set contributor(value: string) {
    this._contributor = value;
  }
  get purpose(): string {
    return this._purpose;
  }
  set purpose(value: string) {
    this._purpose = value;
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    DonationsTransaction.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): DonationsTransaction.AsObject {
    return {
      sum: this.sum,
      currency: this.currency,
      date: this.date ? this.date.toObject() : undefined,
      contributor: this.contributor,
      purpose: this.purpose,
      userId: this.userId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): DonationsTransaction.AsProtobufJSON {
    return {
      sum: this.sum,
      currency: this.currency,
      date: this.date ? this.date.toProtobufJSON(options) : null,
      contributor: this.contributor,
      purpose: this.purpose,
      userId: this.userId
    };
  }
}
export module DonationsTransaction {
  /**
   * Standard JavaScript object representation for DonationsTransaction
   */
  export interface AsObject {
    sum: number;
    currency: string;
    date?: googleProtobuf006.Timestamp.AsObject;
    contributor: string;
    purpose: string;
    userId: string;
  }

  /**
   * Protobuf JSON representation for DonationsTransaction
   */
  export interface AsProtobufJSON {
    sum: number;
    currency: string;
    date: googleProtobuf006.Timestamp.AsProtobufJSON | null;
    contributor: string;
    purpose: string;
    userId: string;
  }
}

/**
 * Message implementation for goautowp.DonationsTransactionsResponse
 */
export class DonationsTransactionsResponse implements GrpcMessage {
  static id = 'goautowp.DonationsTransactionsResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new DonationsTransactionsResponse();
    DonationsTransactionsResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: DonationsTransactionsResponse) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: DonationsTransactionsResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new DonationsTransaction();
          _reader.readMessage(
            messageInitializer1,
            DonationsTransaction.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    DonationsTransactionsResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: DonationsTransactionsResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        DonationsTransaction.serializeBinaryToWriter
      );
    }
  }

  private _items?: DonationsTransaction[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of DonationsTransactionsResponse to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<DonationsTransactionsResponse.AsObject>
  ) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new DonationsTransaction(m));
    DonationsTransactionsResponse.refineValues(this);
  }
  get items(): DonationsTransaction[] | undefined {
    return this._items;
  }
  set items(value: DonationsTransaction[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    DonationsTransactionsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): DonationsTransactionsResponse.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): DonationsTransactionsResponse.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module DonationsTransactionsResponse {
  /**
   * Standard JavaScript object representation for DonationsTransactionsResponse
   */
  export interface AsObject {
    items?: DonationsTransaction.AsObject[];
  }

  /**
   * Protobuf JSON representation for DonationsTransactionsResponse
   */
  export interface AsProtobufJSON {
    items: DonationsTransaction.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.VODDataResponse
 */
export class VODDataResponse implements GrpcMessage {
  static id = 'goautowp.VODDataResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new VODDataResponse();
    VODDataResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: VODDataResponse) {
    _instance.dates = _instance.dates || [];
    _instance.sum = _instance.sum || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: VODDataResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new VODDataDate();
          _reader.readMessage(
            messageInitializer1,
            VODDataDate.deserializeBinaryFromReader
          );
          (_instance.dates = _instance.dates || []).push(messageInitializer1);
          break;
        case 2:
          _instance.sum = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    VODDataResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: VODDataResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.dates && _instance.dates.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.dates as any,
        VODDataDate.serializeBinaryToWriter
      );
    }
    if (_instance.sum) {
      _writer.writeInt32(2, _instance.sum);
    }
  }

  private _dates?: VODDataDate[];
  private _sum: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of VODDataResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<VODDataResponse.AsObject>) {
    _value = _value || {};
    this.dates = (_value.dates || []).map(m => new VODDataDate(m));
    this.sum = _value.sum;
    VODDataResponse.refineValues(this);
  }
  get dates(): VODDataDate[] | undefined {
    return this._dates;
  }
  set dates(value: VODDataDate[] | undefined) {
    this._dates = value;
  }
  get sum(): number {
    return this._sum;
  }
  set sum(value: number) {
    this._sum = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    VODDataResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): VODDataResponse.AsObject {
    return {
      dates: (this.dates || []).map(m => m.toObject()),
      sum: this.sum
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): VODDataResponse.AsProtobufJSON {
    return {
      dates: (this.dates || []).map(m => m.toProtobufJSON(options)),
      sum: this.sum
    };
  }
}
export module VODDataResponse {
  /**
   * Standard JavaScript object representation for VODDataResponse
   */
  export interface AsObject {
    dates?: VODDataDate.AsObject[];
    sum: number;
  }

  /**
   * Protobuf JSON representation for VODDataResponse
   */
  export interface AsProtobufJSON {
    dates: VODDataDate.AsProtobufJSON[] | null;
    sum: number;
  }
}

/**
 * Message implementation for goautowp.VODDataDate
 */
export class VODDataDate implements GrpcMessage {
  static id = 'goautowp.VODDataDate';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new VODDataDate();
    VODDataDate.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: VODDataDate) {
    _instance.date = _instance.date || undefined;
    _instance.free = _instance.free || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: VODDataDate,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.date = new googleProtobuf006.Timestamp();
          _reader.readMessage(
            _instance.date,
            googleProtobuf006.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.free = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    VODDataDate.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: VODDataDate,
    _writer: BinaryWriter
  ) {
    if (_instance.date) {
      _writer.writeMessage(
        1,
        _instance.date as any,
        googleProtobuf006.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.free) {
      _writer.writeBool(2, _instance.free);
    }
  }

  private _date?: googleProtobuf006.Timestamp;
  private _free: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of VODDataDate to deeply clone from
   */
  constructor(_value?: RecursivePartial<VODDataDate.AsObject>) {
    _value = _value || {};
    this.date = _value.date
      ? new googleProtobuf006.Timestamp(_value.date)
      : undefined;
    this.free = _value.free;
    VODDataDate.refineValues(this);
  }
  get date(): googleProtobuf006.Timestamp | undefined {
    return this._date;
  }
  set date(value: googleProtobuf006.Timestamp | undefined) {
    this._date = value;
  }
  get free(): boolean {
    return this._free;
  }
  set free(value: boolean) {
    this._free = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    VODDataDate.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): VODDataDate.AsObject {
    return {
      date: this.date ? this.date.toObject() : undefined,
      free: this.free
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): VODDataDate.AsProtobufJSON {
    return {
      date: this.date ? this.date.toProtobufJSON(options) : null,
      free: this.free
    };
  }
}
export module VODDataDate {
  /**
   * Standard JavaScript object representation for VODDataDate
   */
  export interface AsObject {
    date?: googleProtobuf006.Timestamp.AsObject;
    free: boolean;
  }

  /**
   * Protobuf JSON representation for VODDataDate
   */
  export interface AsProtobufJSON {
    date: googleProtobuf006.Timestamp.AsProtobufJSON | null;
    free: boolean;
  }
}

/**
 * Message implementation for goautowp.AboutDataResponse
 */
export class AboutDataResponse implements GrpcMessage {
  static id = 'goautowp.AboutDataResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AboutDataResponse();
    AboutDataResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AboutDataResponse) {
    _instance.developer = _instance.developer || '';
    _instance.frTranslator = _instance.frTranslator || '';
    _instance.zhTranslator = _instance.zhTranslator || '';
    _instance.beTranslator = _instance.beTranslator || '';
    _instance.ptBrTranslator = _instance.ptBrTranslator || '';
    _instance.contributors = _instance.contributors || [];
    _instance.totalPictures = _instance.totalPictures || 0;
    _instance.picturesSize = _instance.picturesSize || 0;
    _instance.totalUsers = _instance.totalUsers || 0;
    _instance.totalItems = _instance.totalItems || 0;
    _instance.totalComments = _instance.totalComments || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AboutDataResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.developer = _reader.readString();
          break;
        case 2:
          _instance.frTranslator = _reader.readString();
          break;
        case 3:
          _instance.zhTranslator = _reader.readString();
          break;
        case 4:
          _instance.beTranslator = _reader.readString();
          break;
        case 5:
          _instance.ptBrTranslator = _reader.readString();
          break;
        case 6:
          (_instance.contributors = _instance.contributors || []).push(
            _reader.readString()
          );
          break;
        case 7:
          _instance.totalPictures = _reader.readInt32();
          break;
        case 8:
          _instance.picturesSize = _reader.readInt32();
          break;
        case 9:
          _instance.totalUsers = _reader.readInt32();
          break;
        case 10:
          _instance.totalItems = _reader.readInt32();
          break;
        case 11:
          _instance.totalComments = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    AboutDataResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AboutDataResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.developer) {
      _writer.writeString(1, _instance.developer);
    }
    if (_instance.frTranslator) {
      _writer.writeString(2, _instance.frTranslator);
    }
    if (_instance.zhTranslator) {
      _writer.writeString(3, _instance.zhTranslator);
    }
    if (_instance.beTranslator) {
      _writer.writeString(4, _instance.beTranslator);
    }
    if (_instance.ptBrTranslator) {
      _writer.writeString(5, _instance.ptBrTranslator);
    }
    if (_instance.contributors && _instance.contributors.length) {
      _writer.writeRepeatedString(6, _instance.contributors);
    }
    if (_instance.totalPictures) {
      _writer.writeInt32(7, _instance.totalPictures);
    }
    if (_instance.picturesSize) {
      _writer.writeInt32(8, _instance.picturesSize);
    }
    if (_instance.totalUsers) {
      _writer.writeInt32(9, _instance.totalUsers);
    }
    if (_instance.totalItems) {
      _writer.writeInt32(10, _instance.totalItems);
    }
    if (_instance.totalComments) {
      _writer.writeInt32(11, _instance.totalComments);
    }
  }

  private _developer: string;
  private _frTranslator: string;
  private _zhTranslator: string;
  private _beTranslator: string;
  private _ptBrTranslator: string;
  private _contributors: string[];
  private _totalPictures: number;
  private _picturesSize: number;
  private _totalUsers: number;
  private _totalItems: number;
  private _totalComments: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AboutDataResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<AboutDataResponse.AsObject>) {
    _value = _value || {};
    this.developer = _value.developer;
    this.frTranslator = _value.frTranslator;
    this.zhTranslator = _value.zhTranslator;
    this.beTranslator = _value.beTranslator;
    this.ptBrTranslator = _value.ptBrTranslator;
    this.contributors = (_value.contributors || []).slice();
    this.totalPictures = _value.totalPictures;
    this.picturesSize = _value.picturesSize;
    this.totalUsers = _value.totalUsers;
    this.totalItems = _value.totalItems;
    this.totalComments = _value.totalComments;
    AboutDataResponse.refineValues(this);
  }
  get developer(): string {
    return this._developer;
  }
  set developer(value: string) {
    this._developer = value;
  }
  get frTranslator(): string {
    return this._frTranslator;
  }
  set frTranslator(value: string) {
    this._frTranslator = value;
  }
  get zhTranslator(): string {
    return this._zhTranslator;
  }
  set zhTranslator(value: string) {
    this._zhTranslator = value;
  }
  get beTranslator(): string {
    return this._beTranslator;
  }
  set beTranslator(value: string) {
    this._beTranslator = value;
  }
  get ptBrTranslator(): string {
    return this._ptBrTranslator;
  }
  set ptBrTranslator(value: string) {
    this._ptBrTranslator = value;
  }
  get contributors(): string[] {
    return this._contributors;
  }
  set contributors(value: string[]) {
    this._contributors = value;
  }
  get totalPictures(): number {
    return this._totalPictures;
  }
  set totalPictures(value: number) {
    this._totalPictures = value;
  }
  get picturesSize(): number {
    return this._picturesSize;
  }
  set picturesSize(value: number) {
    this._picturesSize = value;
  }
  get totalUsers(): number {
    return this._totalUsers;
  }
  set totalUsers(value: number) {
    this._totalUsers = value;
  }
  get totalItems(): number {
    return this._totalItems;
  }
  set totalItems(value: number) {
    this._totalItems = value;
  }
  get totalComments(): number {
    return this._totalComments;
  }
  set totalComments(value: number) {
    this._totalComments = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AboutDataResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AboutDataResponse.AsObject {
    return {
      developer: this.developer,
      frTranslator: this.frTranslator,
      zhTranslator: this.zhTranslator,
      beTranslator: this.beTranslator,
      ptBrTranslator: this.ptBrTranslator,
      contributors: (this.contributors || []).slice(),
      totalPictures: this.totalPictures,
      picturesSize: this.picturesSize,
      totalUsers: this.totalUsers,
      totalItems: this.totalItems,
      totalComments: this.totalComments
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AboutDataResponse.AsProtobufJSON {
    return {
      developer: this.developer,
      frTranslator: this.frTranslator,
      zhTranslator: this.zhTranslator,
      beTranslator: this.beTranslator,
      ptBrTranslator: this.ptBrTranslator,
      contributors: (this.contributors || []).slice(),
      totalPictures: this.totalPictures,
      picturesSize: this.picturesSize,
      totalUsers: this.totalUsers,
      totalItems: this.totalItems,
      totalComments: this.totalComments
    };
  }
}
export module AboutDataResponse {
  /**
   * Standard JavaScript object representation for AboutDataResponse
   */
  export interface AsObject {
    developer: string;
    frTranslator: string;
    zhTranslator: string;
    beTranslator: string;
    ptBrTranslator: string;
    contributors: string[];
    totalPictures: number;
    picturesSize: number;
    totalUsers: number;
    totalItems: number;
    totalComments: number;
  }

  /**
   * Protobuf JSON representation for AboutDataResponse
   */
  export interface AsProtobufJSON {
    developer: string;
    frTranslator: string;
    zhTranslator: string;
    beTranslator: string;
    ptBrTranslator: string;
    contributors: string[];
    totalPictures: number;
    picturesSize: number;
    totalUsers: number;
    totalItems: number;
    totalComments: number;
  }
}

/**
 * Message implementation for goautowp.APIUserPreferencesRequest
 */
export class APIUserPreferencesRequest implements GrpcMessage {
  static id = 'goautowp.APIUserPreferencesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIUserPreferencesRequest();
    APIUserPreferencesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIUserPreferencesRequest) {
    _instance.userId = _instance.userId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIUserPreferencesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.userId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    APIUserPreferencesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIUserPreferencesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.userId) {
      _writer.writeInt64String(1, _instance.userId);
    }
  }

  private _userId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIUserPreferencesRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIUserPreferencesRequest.AsObject>) {
    _value = _value || {};
    this.userId = _value.userId;
    APIUserPreferencesRequest.refineValues(this);
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIUserPreferencesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIUserPreferencesRequest.AsObject {
    return {
      userId: this.userId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIUserPreferencesRequest.AsProtobufJSON {
    return {
      userId: this.userId
    };
  }
}
export module APIUserPreferencesRequest {
  /**
   * Standard JavaScript object representation for APIUserPreferencesRequest
   */
  export interface AsObject {
    userId: string;
  }

  /**
   * Protobuf JSON representation for APIUserPreferencesRequest
   */
  export interface AsProtobufJSON {
    userId: string;
  }
}

/**
 * Message implementation for goautowp.APIUserPreferencesResponse
 */
export class APIUserPreferencesResponse implements GrpcMessage {
  static id = 'goautowp.APIUserPreferencesResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIUserPreferencesResponse();
    APIUserPreferencesResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIUserPreferencesResponse) {
    _instance.disableCommentsNotifications =
      _instance.disableCommentsNotifications || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIUserPreferencesResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.disableCommentsNotifications = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    APIUserPreferencesResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIUserPreferencesResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.disableCommentsNotifications) {
      _writer.writeBool(1, _instance.disableCommentsNotifications);
    }
  }

  private _disableCommentsNotifications: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIUserPreferencesResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIUserPreferencesResponse.AsObject>) {
    _value = _value || {};
    this.disableCommentsNotifications = _value.disableCommentsNotifications;
    APIUserPreferencesResponse.refineValues(this);
  }
  get disableCommentsNotifications(): boolean {
    return this._disableCommentsNotifications;
  }
  set disableCommentsNotifications(value: boolean) {
    this._disableCommentsNotifications = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIUserPreferencesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIUserPreferencesResponse.AsObject {
    return {
      disableCommentsNotifications: this.disableCommentsNotifications
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIUserPreferencesResponse.AsProtobufJSON {
    return {
      disableCommentsNotifications: this.disableCommentsNotifications
    };
  }
}
export module APIUserPreferencesResponse {
  /**
   * Standard JavaScript object representation for APIUserPreferencesResponse
   */
  export interface AsObject {
    disableCommentsNotifications: boolean;
  }

  /**
   * Protobuf JSON representation for APIUserPreferencesResponse
   */
  export interface AsProtobufJSON {
    disableCommentsNotifications: boolean;
  }
}

/**
 * Message implementation for goautowp.APIUsersRequest
 */
export class APIUsersRequest implements GrpcMessage {
  static id = 'goautowp.APIUsersRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIUsersRequest();
    APIUsersRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIUsersRequest) {
    _instance.isOnline = _instance.isOnline || false;
    _instance.limit = _instance.limit || '0';
    _instance.page = _instance.page || '0';
    _instance.fields = _instance.fields || undefined;
    _instance.search = _instance.search || '';
    _instance.id = _instance.id || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIUsersRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 2:
          _instance.isOnline = _reader.readBool();
          break;
        case 3:
          _instance.limit = _reader.readUint64String();
          break;
        case 4:
          _instance.page = _reader.readUint64String();
          break;
        case 5:
          _instance.fields = new UserFields();
          _reader.readMessage(
            _instance.fields,
            UserFields.deserializeBinaryFromReader
          );
          break;
        case 6:
          _instance.search = _reader.readString();
          break;
        case 7:
          (_instance.id = _instance.id || []).push(
            ...(_reader.readPackedInt64String() || [])
          );
          break;
        default:
          _reader.skipField();
      }
    }

    APIUsersRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIUsersRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.isOnline) {
      _writer.writeBool(2, _instance.isOnline);
    }
    if (_instance.limit) {
      _writer.writeUint64String(3, _instance.limit);
    }
    if (_instance.page) {
      _writer.writeUint64String(4, _instance.page);
    }
    if (_instance.fields) {
      _writer.writeMessage(
        5,
        _instance.fields as any,
        UserFields.serializeBinaryToWriter
      );
    }
    if (_instance.search) {
      _writer.writeString(6, _instance.search);
    }
    if (_instance.id && _instance.id.length) {
      _writer.writePackedInt64String(7, _instance.id);
    }
  }

  private _isOnline: boolean;
  private _limit: string;
  private _page: string;
  private _fields?: UserFields;
  private _search: string;
  private _id: string[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIUsersRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIUsersRequest.AsObject>) {
    _value = _value || {};
    this.isOnline = _value.isOnline;
    this.limit = _value.limit;
    this.page = _value.page;
    this.fields = _value.fields ? new UserFields(_value.fields) : undefined;
    this.search = _value.search;
    this.id = (_value.id || []).slice();
    APIUsersRequest.refineValues(this);
  }
  get isOnline(): boolean {
    return this._isOnline;
  }
  set isOnline(value: boolean) {
    this._isOnline = value;
  }
  get limit(): string {
    return this._limit;
  }
  set limit(value: string) {
    this._limit = value;
  }
  get page(): string {
    return this._page;
  }
  set page(value: string) {
    this._page = value;
  }
  get fields(): UserFields | undefined {
    return this._fields;
  }
  set fields(value: UserFields | undefined) {
    this._fields = value;
  }
  get search(): string {
    return this._search;
  }
  set search(value: string) {
    this._search = value;
  }
  get id(): string[] {
    return this._id;
  }
  set id(value: string[]) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIUsersRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIUsersRequest.AsObject {
    return {
      isOnline: this.isOnline,
      limit: this.limit,
      page: this.page,
      fields: this.fields ? this.fields.toObject() : undefined,
      search: this.search,
      id: (this.id || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIUsersRequest.AsProtobufJSON {
    return {
      isOnline: this.isOnline,
      limit: this.limit,
      page: this.page,
      fields: this.fields ? this.fields.toProtobufJSON(options) : null,
      search: this.search,
      id: (this.id || []).slice()
    };
  }
}
export module APIUsersRequest {
  /**
   * Standard JavaScript object representation for APIUsersRequest
   */
  export interface AsObject {
    isOnline: boolean;
    limit: string;
    page: string;
    fields?: UserFields.AsObject;
    search: string;
    id: string[];
  }

  /**
   * Protobuf JSON representation for APIUsersRequest
   */
  export interface AsProtobufJSON {
    isOnline: boolean;
    limit: string;
    page: string;
    fields: UserFields.AsProtobufJSON | null;
    search: string;
    id: string[];
  }
}

/**
 * Message implementation for goautowp.APIUsersResponse
 */
export class APIUsersResponse implements GrpcMessage {
  static id = 'goautowp.APIUsersResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIUsersResponse();
    APIUsersResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIUsersResponse) {
    _instance.items = _instance.items || [];
    _instance.paginator = _instance.paginator || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIUsersResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new APIUser();
          _reader.readMessage(
            messageInitializer1,
            APIUser.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        case 2:
          _instance.paginator = new Pages();
          _reader.readMessage(
            _instance.paginator,
            Pages.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    APIUsersResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIUsersResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        APIUser.serializeBinaryToWriter
      );
    }
    if (_instance.paginator) {
      _writer.writeMessage(
        2,
        _instance.paginator as any,
        Pages.serializeBinaryToWriter
      );
    }
  }

  private _items?: APIUser[];
  private _paginator?: Pages;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIUsersResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIUsersResponse.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new APIUser(m));
    this.paginator = _value.paginator ? new Pages(_value.paginator) : undefined;
    APIUsersResponse.refineValues(this);
  }
  get items(): APIUser[] | undefined {
    return this._items;
  }
  set items(value: APIUser[] | undefined) {
    this._items = value;
  }
  get paginator(): Pages | undefined {
    return this._paginator;
  }
  set paginator(value: Pages | undefined) {
    this._paginator = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIUsersResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIUsersResponse.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject()),
      paginator: this.paginator ? this.paginator.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIUsersResponse.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options)),
      paginator: this.paginator ? this.paginator.toProtobufJSON(options) : null
    };
  }
}
export module APIUsersResponse {
  /**
   * Standard JavaScript object representation for APIUsersResponse
   */
  export interface AsObject {
    items?: APIUser.AsObject[];
    paginator?: Pages.AsObject;
  }

  /**
   * Protobuf JSON representation for APIUsersResponse
   */
  export interface AsProtobufJSON {
    items: APIUser.AsProtobufJSON[] | null;
    paginator: Pages.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.APIAccountsResponse
 */
export class APIAccountsResponse implements GrpcMessage {
  static id = 'goautowp.APIAccountsResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIAccountsResponse();
    APIAccountsResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIAccountsResponse) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIAccountsResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new APIAccountsAccount();
          _reader.readMessage(
            messageInitializer1,
            APIAccountsAccount.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    APIAccountsResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIAccountsResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        APIAccountsAccount.serializeBinaryToWriter
      );
    }
  }

  private _items?: APIAccountsAccount[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIAccountsResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIAccountsResponse.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new APIAccountsAccount(m));
    APIAccountsResponse.refineValues(this);
  }
  get items(): APIAccountsAccount[] | undefined {
    return this._items;
  }
  set items(value: APIAccountsAccount[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIAccountsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIAccountsResponse.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIAccountsResponse.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module APIAccountsResponse {
  /**
   * Standard JavaScript object representation for APIAccountsResponse
   */
  export interface AsObject {
    items?: APIAccountsAccount.AsObject[];
  }

  /**
   * Protobuf JSON representation for APIAccountsResponse
   */
  export interface AsProtobufJSON {
    items: APIAccountsAccount.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.APIAccountsAccount
 */
export class APIAccountsAccount implements GrpcMessage {
  static id = 'goautowp.APIAccountsAccount';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIAccountsAccount();
    APIAccountsAccount.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIAccountsAccount) {
    _instance.canRemove = _instance.canRemove || false;
    _instance.icon = _instance.icon || '';
    _instance.id = _instance.id || '0';
    _instance.link = _instance.link || '';
    _instance.name = _instance.name || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIAccountsAccount,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.canRemove = _reader.readBool();
          break;
        case 2:
          _instance.icon = _reader.readString();
          break;
        case 3:
          _instance.id = _reader.readInt64String();
          break;
        case 4:
          _instance.link = _reader.readString();
          break;
        case 5:
          _instance.name = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    APIAccountsAccount.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIAccountsAccount,
    _writer: BinaryWriter
  ) {
    if (_instance.canRemove) {
      _writer.writeBool(1, _instance.canRemove);
    }
    if (_instance.icon) {
      _writer.writeString(2, _instance.icon);
    }
    if (_instance.id) {
      _writer.writeInt64String(3, _instance.id);
    }
    if (_instance.link) {
      _writer.writeString(4, _instance.link);
    }
    if (_instance.name) {
      _writer.writeString(5, _instance.name);
    }
  }

  private _canRemove: boolean;
  private _icon: string;
  private _id: string;
  private _link: string;
  private _name: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIAccountsAccount to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIAccountsAccount.AsObject>) {
    _value = _value || {};
    this.canRemove = _value.canRemove;
    this.icon = _value.icon;
    this.id = _value.id;
    this.link = _value.link;
    this.name = _value.name;
    APIAccountsAccount.refineValues(this);
  }
  get canRemove(): boolean {
    return this._canRemove;
  }
  set canRemove(value: boolean) {
    this._canRemove = value;
  }
  get icon(): string {
    return this._icon;
  }
  set icon(value: string) {
    this._icon = value;
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get link(): string {
    return this._link;
  }
  set link(value: string) {
    this._link = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIAccountsAccount.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIAccountsAccount.AsObject {
    return {
      canRemove: this.canRemove,
      icon: this.icon,
      id: this.id,
      link: this.link,
      name: this.name
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIAccountsAccount.AsProtobufJSON {
    return {
      canRemove: this.canRemove,
      icon: this.icon,
      id: this.id,
      link: this.link,
      name: this.name
    };
  }
}
export module APIAccountsAccount {
  /**
   * Standard JavaScript object representation for APIAccountsAccount
   */
  export interface AsObject {
    canRemove: boolean;
    icon: string;
    id: string;
    link: string;
    name: string;
  }

  /**
   * Protobuf JSON representation for APIAccountsAccount
   */
  export interface AsProtobufJSON {
    canRemove: boolean;
    icon: string;
    id: string;
    link: string;
    name: string;
  }
}

/**
 * Message implementation for goautowp.DeleteUserAccountRequest
 */
export class DeleteUserAccountRequest implements GrpcMessage {
  static id = 'goautowp.DeleteUserAccountRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new DeleteUserAccountRequest();
    DeleteUserAccountRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: DeleteUserAccountRequest) {
    _instance.id = _instance.id || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: DeleteUserAccountRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    DeleteUserAccountRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: DeleteUserAccountRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
  }

  private _id: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of DeleteUserAccountRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<DeleteUserAccountRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    DeleteUserAccountRequest.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    DeleteUserAccountRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): DeleteUserAccountRequest.AsObject {
    return {
      id: this.id
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): DeleteUserAccountRequest.AsProtobufJSON {
    return {
      id: this.id
    };
  }
}
export module DeleteUserAccountRequest {
  /**
   * Standard JavaScript object representation for DeleteUserAccountRequest
   */
  export interface AsObject {
    id: string;
  }

  /**
   * Protobuf JSON representation for DeleteUserAccountRequest
   */
  export interface AsProtobufJSON {
    id: string;
  }
}

/**
 * Message implementation for goautowp.DeleteUserPhotoRequest
 */
export class DeleteUserPhotoRequest implements GrpcMessage {
  static id = 'goautowp.DeleteUserPhotoRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new DeleteUserPhotoRequest();
    DeleteUserPhotoRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: DeleteUserPhotoRequest) {
    _instance.id = _instance.id || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: DeleteUserPhotoRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    DeleteUserPhotoRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: DeleteUserPhotoRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
  }

  private _id: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of DeleteUserPhotoRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<DeleteUserPhotoRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    DeleteUserPhotoRequest.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    DeleteUserPhotoRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): DeleteUserPhotoRequest.AsObject {
    return {
      id: this.id
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): DeleteUserPhotoRequest.AsProtobufJSON {
    return {
      id: this.id
    };
  }
}
export module DeleteUserPhotoRequest {
  /**
   * Standard JavaScript object representation for DeleteUserPhotoRequest
   */
  export interface AsObject {
    id: string;
  }

  /**
   * Protobuf JSON representation for DeleteUserPhotoRequest
   */
  export interface AsProtobufJSON {
    id: string;
  }
}

/**
 * Message implementation for goautowp.APIUsersRatingUserBrand
 */
export class APIUsersRatingUserBrand implements GrpcMessage {
  static id = 'goautowp.APIUsersRatingUserBrand';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIUsersRatingUserBrand();
    APIUsersRatingUserBrand.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIUsersRatingUserBrand) {
    _instance.name = _instance.name || '';
    _instance.route = _instance.route || [];
    _instance.volume = _instance.volume || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIUsersRatingUserBrand,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.name = _reader.readString();
          break;
        case 2:
          (_instance.route = _instance.route || []).push(_reader.readString());
          break;
        case 3:
          _instance.volume = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    APIUsersRatingUserBrand.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIUsersRatingUserBrand,
    _writer: BinaryWriter
  ) {
    if (_instance.name) {
      _writer.writeString(1, _instance.name);
    }
    if (_instance.route && _instance.route.length) {
      _writer.writeRepeatedString(2, _instance.route);
    }
    if (_instance.volume) {
      _writer.writeInt64String(3, _instance.volume);
    }
  }

  private _name: string;
  private _route: string[];
  private _volume: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIUsersRatingUserBrand to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIUsersRatingUserBrand.AsObject>) {
    _value = _value || {};
    this.name = _value.name;
    this.route = (_value.route || []).slice();
    this.volume = _value.volume;
    APIUsersRatingUserBrand.refineValues(this);
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get route(): string[] {
    return this._route;
  }
  set route(value: string[]) {
    this._route = value;
  }
  get volume(): string {
    return this._volume;
  }
  set volume(value: string) {
    this._volume = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIUsersRatingUserBrand.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIUsersRatingUserBrand.AsObject {
    return {
      name: this.name,
      route: (this.route || []).slice(),
      volume: this.volume
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIUsersRatingUserBrand.AsProtobufJSON {
    return {
      name: this.name,
      route: (this.route || []).slice(),
      volume: this.volume
    };
  }
}
export module APIUsersRatingUserBrand {
  /**
   * Standard JavaScript object representation for APIUsersRatingUserBrand
   */
  export interface AsObject {
    name: string;
    route: string[];
    volume: string;
  }

  /**
   * Protobuf JSON representation for APIUsersRatingUserBrand
   */
  export interface AsProtobufJSON {
    name: string;
    route: string[];
    volume: string;
  }
}

/**
 * Message implementation for goautowp.APIUsersRatingUserFan
 */
export class APIUsersRatingUserFan implements GrpcMessage {
  static id = 'goautowp.APIUsersRatingUserFan';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIUsersRatingUserFan();
    APIUsersRatingUserFan.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIUsersRatingUserFan) {
    _instance.userId = _instance.userId || '0';
    _instance.volume = _instance.volume || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIUsersRatingUserFan,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.userId = _reader.readInt64String();
          break;
        case 2:
          _instance.volume = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    APIUsersRatingUserFan.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIUsersRatingUserFan,
    _writer: BinaryWriter
  ) {
    if (_instance.userId) {
      _writer.writeInt64String(1, _instance.userId);
    }
    if (_instance.volume) {
      _writer.writeInt64String(2, _instance.volume);
    }
  }

  private _userId: string;
  private _volume: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIUsersRatingUserFan to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIUsersRatingUserFan.AsObject>) {
    _value = _value || {};
    this.userId = _value.userId;
    this.volume = _value.volume;
    APIUsersRatingUserFan.refineValues(this);
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }
  get volume(): string {
    return this._volume;
  }
  set volume(value: string) {
    this._volume = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIUsersRatingUserFan.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIUsersRatingUserFan.AsObject {
    return {
      userId: this.userId,
      volume: this.volume
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIUsersRatingUserFan.AsProtobufJSON {
    return {
      userId: this.userId,
      volume: this.volume
    };
  }
}
export module APIUsersRatingUserFan {
  /**
   * Standard JavaScript object representation for APIUsersRatingUserFan
   */
  export interface AsObject {
    userId: string;
    volume: string;
  }

  /**
   * Protobuf JSON representation for APIUsersRatingUserFan
   */
  export interface AsProtobufJSON {
    userId: string;
    volume: string;
  }
}

/**
 * Message implementation for goautowp.APIUsersRatingUser
 */
export class APIUsersRatingUser implements GrpcMessage {
  static id = 'goautowp.APIUsersRatingUser';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIUsersRatingUser();
    APIUsersRatingUser.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIUsersRatingUser) {
    _instance.userId = _instance.userId || '0';
    _instance.volume = _instance.volume || '0';
    _instance.weight = _instance.weight || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIUsersRatingUser,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.userId = _reader.readInt64String();
          break;
        case 2:
          _instance.volume = _reader.readInt64String();
          break;
        case 3:
          _instance.weight = _reader.readDouble();
          break;
        default:
          _reader.skipField();
      }
    }

    APIUsersRatingUser.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIUsersRatingUser,
    _writer: BinaryWriter
  ) {
    if (_instance.userId) {
      _writer.writeInt64String(1, _instance.userId);
    }
    if (_instance.volume) {
      _writer.writeInt64String(2, _instance.volume);
    }
    if (_instance.weight) {
      _writer.writeDouble(3, _instance.weight);
    }
  }

  private _userId: string;
  private _volume: string;
  private _weight: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIUsersRatingUser to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIUsersRatingUser.AsObject>) {
    _value = _value || {};
    this.userId = _value.userId;
    this.volume = _value.volume;
    this.weight = _value.weight;
    APIUsersRatingUser.refineValues(this);
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }
  get volume(): string {
    return this._volume;
  }
  set volume(value: string) {
    this._volume = value;
  }
  get weight(): number {
    return this._weight;
  }
  set weight(value: number) {
    this._weight = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIUsersRatingUser.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIUsersRatingUser.AsObject {
    return {
      userId: this.userId,
      volume: this.volume,
      weight: this.weight
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIUsersRatingUser.AsProtobufJSON {
    return {
      userId: this.userId,
      volume: this.volume,
      weight: this.weight
    };
  }
}
export module APIUsersRatingUser {
  /**
   * Standard JavaScript object representation for APIUsersRatingUser
   */
  export interface AsObject {
    userId: string;
    volume: string;
    weight: number;
  }

  /**
   * Protobuf JSON representation for APIUsersRatingUser
   */
  export interface AsProtobufJSON {
    userId: string;
    volume: string;
    weight: number;
  }
}

/**
 * Message implementation for goautowp.APIUsersRatingResponse
 */
export class APIUsersRatingResponse implements GrpcMessage {
  static id = 'goautowp.APIUsersRatingResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIUsersRatingResponse();
    APIUsersRatingResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIUsersRatingResponse) {
    _instance.users = _instance.users || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIUsersRatingResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new APIUsersRatingUser();
          _reader.readMessage(
            messageInitializer1,
            APIUsersRatingUser.deserializeBinaryFromReader
          );
          (_instance.users = _instance.users || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    APIUsersRatingResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIUsersRatingResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.users && _instance.users.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.users as any,
        APIUsersRatingUser.serializeBinaryToWriter
      );
    }
  }

  private _users?: APIUsersRatingUser[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIUsersRatingResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIUsersRatingResponse.AsObject>) {
    _value = _value || {};
    this.users = (_value.users || []).map(m => new APIUsersRatingUser(m));
    APIUsersRatingResponse.refineValues(this);
  }
  get users(): APIUsersRatingUser[] | undefined {
    return this._users;
  }
  set users(value: APIUsersRatingUser[] | undefined) {
    this._users = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIUsersRatingResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIUsersRatingResponse.AsObject {
    return {
      users: (this.users || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIUsersRatingResponse.AsProtobufJSON {
    return {
      users: (this.users || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module APIUsersRatingResponse {
  /**
   * Standard JavaScript object representation for APIUsersRatingResponse
   */
  export interface AsObject {
    users?: APIUsersRatingUser.AsObject[];
  }

  /**
   * Protobuf JSON representation for APIUsersRatingResponse
   */
  export interface AsProtobufJSON {
    users: APIUsersRatingUser.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.UserRatingDetailsRequest
 */
export class UserRatingDetailsRequest implements GrpcMessage {
  static id = 'goautowp.UserRatingDetailsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UserRatingDetailsRequest();
    UserRatingDetailsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UserRatingDetailsRequest) {
    _instance.userId = _instance.userId || '0';
    _instance.language = _instance.language || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UserRatingDetailsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.userId = _reader.readInt64String();
          break;
        case 2:
          _instance.language = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    UserRatingDetailsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: UserRatingDetailsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.userId) {
      _writer.writeInt64String(1, _instance.userId);
    }
    if (_instance.language) {
      _writer.writeString(2, _instance.language);
    }
  }

  private _userId: string;
  private _language: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UserRatingDetailsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<UserRatingDetailsRequest.AsObject>) {
    _value = _value || {};
    this.userId = _value.userId;
    this.language = _value.language;
    UserRatingDetailsRequest.refineValues(this);
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UserRatingDetailsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UserRatingDetailsRequest.AsObject {
    return {
      userId: this.userId,
      language: this.language
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UserRatingDetailsRequest.AsProtobufJSON {
    return {
      userId: this.userId,
      language: this.language
    };
  }
}
export module UserRatingDetailsRequest {
  /**
   * Standard JavaScript object representation for UserRatingDetailsRequest
   */
  export interface AsObject {
    userId: string;
    language: string;
  }

  /**
   * Protobuf JSON representation for UserRatingDetailsRequest
   */
  export interface AsProtobufJSON {
    userId: string;
    language: string;
  }
}

/**
 * Message implementation for goautowp.UserRatingBrandsResponse
 */
export class UserRatingBrandsResponse implements GrpcMessage {
  static id = 'goautowp.UserRatingBrandsResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new UserRatingBrandsResponse();
    UserRatingBrandsResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: UserRatingBrandsResponse) {
    _instance.brands = _instance.brands || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: UserRatingBrandsResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new APIUsersRatingUserBrand();
          _reader.readMessage(
            messageInitializer1,
            APIUsersRatingUserBrand.deserializeBinaryFromReader
          );
          (_instance.brands = _instance.brands || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    UserRatingBrandsResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: UserRatingBrandsResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.brands && _instance.brands.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.brands as any,
        APIUsersRatingUserBrand.serializeBinaryToWriter
      );
    }
  }

  private _brands?: APIUsersRatingUserBrand[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of UserRatingBrandsResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<UserRatingBrandsResponse.AsObject>) {
    _value = _value || {};
    this.brands = (_value.brands || []).map(
      m => new APIUsersRatingUserBrand(m)
    );
    UserRatingBrandsResponse.refineValues(this);
  }
  get brands(): APIUsersRatingUserBrand[] | undefined {
    return this._brands;
  }
  set brands(value: APIUsersRatingUserBrand[] | undefined) {
    this._brands = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    UserRatingBrandsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): UserRatingBrandsResponse.AsObject {
    return {
      brands: (this.brands || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): UserRatingBrandsResponse.AsProtobufJSON {
    return {
      brands: (this.brands || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module UserRatingBrandsResponse {
  /**
   * Standard JavaScript object representation for UserRatingBrandsResponse
   */
  export interface AsObject {
    brands?: APIUsersRatingUserBrand.AsObject[];
  }

  /**
   * Protobuf JSON representation for UserRatingBrandsResponse
   */
  export interface AsProtobufJSON {
    brands: APIUsersRatingUserBrand.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.GetUserRatingFansResponse
 */
export class GetUserRatingFansResponse implements GrpcMessage {
  static id = 'goautowp.GetUserRatingFansResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetUserRatingFansResponse();
    GetUserRatingFansResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetUserRatingFansResponse) {
    _instance.fans = _instance.fans || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetUserRatingFansResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new APIUsersRatingUserFan();
          _reader.readMessage(
            messageInitializer1,
            APIUsersRatingUserFan.deserializeBinaryFromReader
          );
          (_instance.fans = _instance.fans || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    GetUserRatingFansResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetUserRatingFansResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.fans && _instance.fans.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.fans as any,
        APIUsersRatingUserFan.serializeBinaryToWriter
      );
    }
  }

  private _fans?: APIUsersRatingUserFan[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetUserRatingFansResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetUserRatingFansResponse.AsObject>) {
    _value = _value || {};
    this.fans = (_value.fans || []).map(m => new APIUsersRatingUserFan(m));
    GetUserRatingFansResponse.refineValues(this);
  }
  get fans(): APIUsersRatingUserFan[] | undefined {
    return this._fans;
  }
  set fans(value: APIUsersRatingUserFan[] | undefined) {
    this._fans = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetUserRatingFansResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetUserRatingFansResponse.AsObject {
    return {
      fans: (this.fans || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetUserRatingFansResponse.AsProtobufJSON {
    return {
      fans: (this.fans || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module GetUserRatingFansResponse {
  /**
   * Standard JavaScript object representation for GetUserRatingFansResponse
   */
  export interface AsObject {
    fans?: APIUsersRatingUserFan.AsObject[];
  }

  /**
   * Protobuf JSON representation for GetUserRatingFansResponse
   */
  export interface AsProtobufJSON {
    fans: APIUsersRatingUserFan.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.ArticlesRequest
 */
export class ArticlesRequest implements GrpcMessage {
  static id = 'goautowp.ArticlesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ArticlesRequest();
    ArticlesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ArticlesRequest) {
    _instance.limit = _instance.limit || '0';
    _instance.page = _instance.page || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ArticlesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.limit = _reader.readUint64String();
          break;
        case 2:
          _instance.page = _reader.readUint64String();
          break;
        default:
          _reader.skipField();
      }
    }

    ArticlesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ArticlesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.limit) {
      _writer.writeUint64String(1, _instance.limit);
    }
    if (_instance.page) {
      _writer.writeUint64String(2, _instance.page);
    }
  }

  private _limit: string;
  private _page: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ArticlesRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<ArticlesRequest.AsObject>) {
    _value = _value || {};
    this.limit = _value.limit;
    this.page = _value.page;
    ArticlesRequest.refineValues(this);
  }
  get limit(): string {
    return this._limit;
  }
  set limit(value: string) {
    this._limit = value;
  }
  get page(): string {
    return this._page;
  }
  set page(value: string) {
    this._page = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ArticlesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ArticlesRequest.AsObject {
    return {
      limit: this.limit,
      page: this.page
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ArticlesRequest.AsProtobufJSON {
    return {
      limit: this.limit,
      page: this.page
    };
  }
}
export module ArticlesRequest {
  /**
   * Standard JavaScript object representation for ArticlesRequest
   */
  export interface AsObject {
    limit: string;
    page: string;
  }

  /**
   * Protobuf JSON representation for ArticlesRequest
   */
  export interface AsProtobufJSON {
    limit: string;
    page: string;
  }
}

/**
 * Message implementation for goautowp.ArticlesResponse
 */
export class ArticlesResponse implements GrpcMessage {
  static id = 'goautowp.ArticlesResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ArticlesResponse();
    ArticlesResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ArticlesResponse) {
    _instance.items = _instance.items || [];
    _instance.paginator = _instance.paginator || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ArticlesResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new Article();
          _reader.readMessage(
            messageInitializer1,
            Article.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        case 2:
          _instance.paginator = new Pages();
          _reader.readMessage(
            _instance.paginator,
            Pages.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    ArticlesResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ArticlesResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        Article.serializeBinaryToWriter
      );
    }
    if (_instance.paginator) {
      _writer.writeMessage(
        2,
        _instance.paginator as any,
        Pages.serializeBinaryToWriter
      );
    }
  }

  private _items?: Article[];
  private _paginator?: Pages;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ArticlesResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<ArticlesResponse.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new Article(m));
    this.paginator = _value.paginator ? new Pages(_value.paginator) : undefined;
    ArticlesResponse.refineValues(this);
  }
  get items(): Article[] | undefined {
    return this._items;
  }
  set items(value: Article[] | undefined) {
    this._items = value;
  }
  get paginator(): Pages | undefined {
    return this._paginator;
  }
  set paginator(value: Pages | undefined) {
    this._paginator = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ArticlesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ArticlesResponse.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject()),
      paginator: this.paginator ? this.paginator.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ArticlesResponse.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options)),
      paginator: this.paginator ? this.paginator.toProtobufJSON(options) : null
    };
  }
}
export module ArticlesResponse {
  /**
   * Standard JavaScript object representation for ArticlesResponse
   */
  export interface AsObject {
    items?: Article.AsObject[];
    paginator?: Pages.AsObject;
  }

  /**
   * Protobuf JSON representation for ArticlesResponse
   */
  export interface AsProtobufJSON {
    items: Article.AsProtobufJSON[] | null;
    paginator: Pages.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.Article
 */
export class Article implements GrpcMessage {
  static id = 'goautowp.Article';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Article();
    Article.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Article) {
    _instance.id = _instance.id || '0';
    _instance.name = _instance.name || '';
    _instance.authorId = _instance.authorId || '0';
    _instance.catname = _instance.catname || '';
    _instance.date = _instance.date || undefined;
    _instance.html = _instance.html || '';
    _instance.previewUrl = _instance.previewUrl || '';
    _instance.description = _instance.description || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: Article,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        case 3:
          _instance.authorId = _reader.readInt64String();
          break;
        case 4:
          _instance.catname = _reader.readString();
          break;
        case 5:
          _instance.date = new googleProtobuf006.Timestamp();
          _reader.readMessage(
            _instance.date,
            googleProtobuf006.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 6:
          _instance.html = _reader.readString();
          break;
        case 7:
          _instance.previewUrl = _reader.readString();
          break;
        case 8:
          _instance.description = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    Article.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Article, _writer: BinaryWriter) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
    if (_instance.authorId) {
      _writer.writeInt64String(3, _instance.authorId);
    }
    if (_instance.catname) {
      _writer.writeString(4, _instance.catname);
    }
    if (_instance.date) {
      _writer.writeMessage(
        5,
        _instance.date as any,
        googleProtobuf006.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.html) {
      _writer.writeString(6, _instance.html);
    }
    if (_instance.previewUrl) {
      _writer.writeString(7, _instance.previewUrl);
    }
    if (_instance.description) {
      _writer.writeString(8, _instance.description);
    }
  }

  private _id: string;
  private _name: string;
  private _authorId: string;
  private _catname: string;
  private _date?: googleProtobuf006.Timestamp;
  private _html: string;
  private _previewUrl: string;
  private _description: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Article to deeply clone from
   */
  constructor(_value?: RecursivePartial<Article.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.name = _value.name;
    this.authorId = _value.authorId;
    this.catname = _value.catname;
    this.date = _value.date
      ? new googleProtobuf006.Timestamp(_value.date)
      : undefined;
    this.html = _value.html;
    this.previewUrl = _value.previewUrl;
    this.description = _value.description;
    Article.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get authorId(): string {
    return this._authorId;
  }
  set authorId(value: string) {
    this._authorId = value;
  }
  get catname(): string {
    return this._catname;
  }
  set catname(value: string) {
    this._catname = value;
  }
  get date(): googleProtobuf006.Timestamp | undefined {
    return this._date;
  }
  set date(value: googleProtobuf006.Timestamp | undefined) {
    this._date = value;
  }
  get html(): string {
    return this._html;
  }
  set html(value: string) {
    this._html = value;
  }
  get previewUrl(): string {
    return this._previewUrl;
  }
  set previewUrl(value: string) {
    this._previewUrl = value;
  }
  get description(): string {
    return this._description;
  }
  set description(value: string) {
    this._description = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Article.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Article.AsObject {
    return {
      id: this.id,
      name: this.name,
      authorId: this.authorId,
      catname: this.catname,
      date: this.date ? this.date.toObject() : undefined,
      html: this.html,
      previewUrl: this.previewUrl,
      description: this.description
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Article.AsProtobufJSON {
    return {
      id: this.id,
      name: this.name,
      authorId: this.authorId,
      catname: this.catname,
      date: this.date ? this.date.toProtobufJSON(options) : null,
      html: this.html,
      previewUrl: this.previewUrl,
      description: this.description
    };
  }
}
export module Article {
  /**
   * Standard JavaScript object representation for Article
   */
  export interface AsObject {
    id: string;
    name: string;
    authorId: string;
    catname: string;
    date?: googleProtobuf006.Timestamp.AsObject;
    html: string;
    previewUrl: string;
    description: string;
  }

  /**
   * Protobuf JSON representation for Article
   */
  export interface AsProtobufJSON {
    id: string;
    name: string;
    authorId: string;
    catname: string;
    date: googleProtobuf006.Timestamp.AsProtobufJSON | null;
    html: string;
    previewUrl: string;
    description: string;
  }
}

/**
 * Message implementation for goautowp.ArticleByCatnameRequest
 */
export class ArticleByCatnameRequest implements GrpcMessage {
  static id = 'goautowp.ArticleByCatnameRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ArticleByCatnameRequest();
    ArticleByCatnameRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ArticleByCatnameRequest) {
    _instance.catname = _instance.catname || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ArticleByCatnameRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.catname = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    ArticleByCatnameRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ArticleByCatnameRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.catname) {
      _writer.writeString(1, _instance.catname);
    }
  }

  private _catname: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ArticleByCatnameRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<ArticleByCatnameRequest.AsObject>) {
    _value = _value || {};
    this.catname = _value.catname;
    ArticleByCatnameRequest.refineValues(this);
  }
  get catname(): string {
    return this._catname;
  }
  set catname(value: string) {
    this._catname = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ArticleByCatnameRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ArticleByCatnameRequest.AsObject {
    return {
      catname: this.catname
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ArticleByCatnameRequest.AsProtobufJSON {
    return {
      catname: this.catname
    };
  }
}
export module ArticleByCatnameRequest {
  /**
   * Standard JavaScript object representation for ArticleByCatnameRequest
   */
  export interface AsObject {
    catname: string;
  }

  /**
   * Protobuf JSON representation for ArticleByCatnameRequest
   */
  export interface AsProtobufJSON {
    catname: string;
  }
}

/**
 * Message implementation for goautowp.APIContentLanguages
 */
export class APIContentLanguages implements GrpcMessage {
  static id = 'goautowp.APIContentLanguages';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIContentLanguages();
    APIContentLanguages.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIContentLanguages) {
    _instance.languages = _instance.languages || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIContentLanguages,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          (_instance.languages = _instance.languages || []).push(
            _reader.readString()
          );
          break;
        default:
          _reader.skipField();
      }
    }

    APIContentLanguages.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIContentLanguages,
    _writer: BinaryWriter
  ) {
    if (_instance.languages && _instance.languages.length) {
      _writer.writeRepeatedString(1, _instance.languages);
    }
  }

  private _languages: string[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIContentLanguages to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIContentLanguages.AsObject>) {
    _value = _value || {};
    this.languages = (_value.languages || []).slice();
    APIContentLanguages.refineValues(this);
  }
  get languages(): string[] {
    return this._languages;
  }
  set languages(value: string[]) {
    this._languages = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIContentLanguages.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIContentLanguages.AsObject {
    return {
      languages: (this.languages || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIContentLanguages.AsProtobufJSON {
    return {
      languages: (this.languages || []).slice()
    };
  }
}
export module APIContentLanguages {
  /**
   * Standard JavaScript object representation for APIContentLanguages
   */
  export interface AsObject {
    languages: string[];
  }

  /**
   * Protobuf JSON representation for APIContentLanguages
   */
  export interface AsProtobufJSON {
    languages: string[];
  }
}

/**
 * Message implementation for goautowp.APIItemLinkRequest
 */
export class APIItemLinkRequest implements GrpcMessage {
  static id = 'goautowp.APIItemLinkRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIItemLinkRequest();
    APIItemLinkRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIItemLinkRequest) {
    _instance.id = _instance.id || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIItemLinkRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    APIItemLinkRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIItemLinkRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
  }

  private _id: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIItemLinkRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIItemLinkRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    APIItemLinkRequest.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIItemLinkRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIItemLinkRequest.AsObject {
    return {
      id: this.id
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIItemLinkRequest.AsProtobufJSON {
    return {
      id: this.id
    };
  }
}
export module APIItemLinkRequest {
  /**
   * Standard JavaScript object representation for APIItemLinkRequest
   */
  export interface AsObject {
    id: string;
  }

  /**
   * Protobuf JSON representation for APIItemLinkRequest
   */
  export interface AsProtobufJSON {
    id: string;
  }
}

/**
 * Message implementation for goautowp.ItemLinkListOptions
 */
export class ItemLinkListOptions implements GrpcMessage {
  static id = 'goautowp.ItemLinkListOptions';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemLinkListOptions();
    ItemLinkListOptions.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemLinkListOptions) {
    _instance.id = _instance.id || '0';
    _instance.itemId = _instance.itemId || '0';
    _instance.type = _instance.type || '';
    _instance.itemParentCacheDescendant =
      _instance.itemParentCacheDescendant || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemLinkListOptions,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.itemId = _reader.readInt64String();
          break;
        case 3:
          _instance.type = _reader.readString();
          break;
        case 4:
          _instance.itemParentCacheDescendant = new ItemParentCacheListOptions();
          _reader.readMessage(
            _instance.itemParentCacheDescendant,
            ItemParentCacheListOptions.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    ItemLinkListOptions.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItemLinkListOptions,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.itemId) {
      _writer.writeInt64String(2, _instance.itemId);
    }
    if (_instance.type) {
      _writer.writeString(3, _instance.type);
    }
    if (_instance.itemParentCacheDescendant) {
      _writer.writeMessage(
        4,
        _instance.itemParentCacheDescendant as any,
        ItemParentCacheListOptions.serializeBinaryToWriter
      );
    }
  }

  private _id: string;
  private _itemId: string;
  private _type: string;
  private _itemParentCacheDescendant?: ItemParentCacheListOptions;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemLinkListOptions to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemLinkListOptions.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.itemId = _value.itemId;
    this.type = _value.type;
    this.itemParentCacheDescendant = _value.itemParentCacheDescendant
      ? new ItemParentCacheListOptions(_value.itemParentCacheDescendant)
      : undefined;
    ItemLinkListOptions.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get type(): string {
    return this._type;
  }
  set type(value: string) {
    this._type = value;
  }
  get itemParentCacheDescendant(): ItemParentCacheListOptions | undefined {
    return this._itemParentCacheDescendant;
  }
  set itemParentCacheDescendant(value: ItemParentCacheListOptions | undefined) {
    this._itemParentCacheDescendant = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemLinkListOptions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemLinkListOptions.AsObject {
    return {
      id: this.id,
      itemId: this.itemId,
      type: this.type,
      itemParentCacheDescendant: this.itemParentCacheDescendant
        ? this.itemParentCacheDescendant.toObject()
        : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemLinkListOptions.AsProtobufJSON {
    return {
      id: this.id,
      itemId: this.itemId,
      type: this.type,
      itemParentCacheDescendant: this.itemParentCacheDescendant
        ? this.itemParentCacheDescendant.toProtobufJSON(options)
        : null
    };
  }
}
export module ItemLinkListOptions {
  /**
   * Standard JavaScript object representation for ItemLinkListOptions
   */
  export interface AsObject {
    id: string;
    itemId: string;
    type: string;
    itemParentCacheDescendant?: ItemParentCacheListOptions.AsObject;
  }

  /**
   * Protobuf JSON representation for ItemLinkListOptions
   */
  export interface AsProtobufJSON {
    id: string;
    itemId: string;
    type: string;
    itemParentCacheDescendant: ItemParentCacheListOptions.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.ItemLinksRequest
 */
export class ItemLinksRequest implements GrpcMessage {
  static id = 'goautowp.ItemLinksRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemLinksRequest();
    ItemLinksRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemLinksRequest) {
    _instance.options = _instance.options || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemLinksRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.options = new ItemLinkListOptions();
          _reader.readMessage(
            _instance.options,
            ItemLinkListOptions.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    ItemLinksRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItemLinksRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.options) {
      _writer.writeMessage(
        1,
        _instance.options as any,
        ItemLinkListOptions.serializeBinaryToWriter
      );
    }
  }

  private _options?: ItemLinkListOptions;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemLinksRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemLinksRequest.AsObject>) {
    _value = _value || {};
    this.options = _value.options
      ? new ItemLinkListOptions(_value.options)
      : undefined;
    ItemLinksRequest.refineValues(this);
  }
  get options(): ItemLinkListOptions | undefined {
    return this._options;
  }
  set options(value: ItemLinkListOptions | undefined) {
    this._options = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemLinksRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemLinksRequest.AsObject {
    return {
      options: this.options ? this.options.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemLinksRequest.AsProtobufJSON {
    return {
      options: this.options ? this.options.toProtobufJSON(options) : null
    };
  }
}
export module ItemLinksRequest {
  /**
   * Standard JavaScript object representation for ItemLinksRequest
   */
  export interface AsObject {
    options?: ItemLinkListOptions.AsObject;
  }

  /**
   * Protobuf JSON representation for ItemLinksRequest
   */
  export interface AsProtobufJSON {
    options: ItemLinkListOptions.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.ItemLinks
 */
export class ItemLinks implements GrpcMessage {
  static id = 'goautowp.ItemLinks';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemLinks();
    ItemLinks.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemLinks) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemLinks,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new APIItemLink();
          _reader.readMessage(
            messageInitializer1,
            APIItemLink.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    ItemLinks.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: ItemLinks, _writer: BinaryWriter) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        APIItemLink.serializeBinaryToWriter
      );
    }
  }

  private _items?: APIItemLink[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemLinks to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemLinks.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new APIItemLink(m));
    ItemLinks.refineValues(this);
  }
  get items(): APIItemLink[] | undefined {
    return this._items;
  }
  set items(value: APIItemLink[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemLinks.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemLinks.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemLinks.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module ItemLinks {
  /**
   * Standard JavaScript object representation for ItemLinks
   */
  export interface AsObject {
    items?: APIItemLink.AsObject[];
  }

  /**
   * Protobuf JSON representation for ItemLinks
   */
  export interface AsProtobufJSON {
    items: APIItemLink.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.APIItemLink
 */
export class APIItemLink implements GrpcMessage {
  static id = 'goautowp.APIItemLink';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIItemLink();
    APIItemLink.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIItemLink) {
    _instance.id = _instance.id || '0';
    _instance.name = _instance.name || '';
    _instance.url = _instance.url || '';
    _instance.type = _instance.type || '';
    _instance.itemId = _instance.itemId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIItemLink,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        case 3:
          _instance.url = _reader.readString();
          break;
        case 4:
          _instance.type = _reader.readString();
          break;
        case 5:
          _instance.itemId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    APIItemLink.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIItemLink,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
    if (_instance.url) {
      _writer.writeString(3, _instance.url);
    }
    if (_instance.type) {
      _writer.writeString(4, _instance.type);
    }
    if (_instance.itemId) {
      _writer.writeInt64String(5, _instance.itemId);
    }
  }

  private _id: string;
  private _name: string;
  private _url: string;
  private _type: string;
  private _itemId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIItemLink to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIItemLink.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.name = _value.name;
    this.url = _value.url;
    this.type = _value.type;
    this.itemId = _value.itemId;
    APIItemLink.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get url(): string {
    return this._url;
  }
  set url(value: string) {
    this._url = value;
  }
  get type(): string {
    return this._type;
  }
  set type(value: string) {
    this._type = value;
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIItemLink.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIItemLink.AsObject {
    return {
      id: this.id,
      name: this.name,
      url: this.url,
      type: this.type,
      itemId: this.itemId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIItemLink.AsProtobufJSON {
    return {
      id: this.id,
      name: this.name,
      url: this.url,
      type: this.type,
      itemId: this.itemId
    };
  }
}
export module APIItemLink {
  /**
   * Standard JavaScript object representation for APIItemLink
   */
  export interface AsObject {
    id: string;
    name: string;
    url: string;
    type: string;
    itemId: string;
  }

  /**
   * Protobuf JSON representation for APIItemLink
   */
  export interface AsProtobufJSON {
    id: string;
    name: string;
    url: string;
    type: string;
    itemId: string;
  }
}

/**
 * Message implementation for goautowp.APICreateItemLinkResponse
 */
export class APICreateItemLinkResponse implements GrpcMessage {
  static id = 'goautowp.APICreateItemLinkResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APICreateItemLinkResponse();
    APICreateItemLinkResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APICreateItemLinkResponse) {
    _instance.id = _instance.id || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APICreateItemLinkResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    APICreateItemLinkResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APICreateItemLinkResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
  }

  private _id: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APICreateItemLinkResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<APICreateItemLinkResponse.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    APICreateItemLinkResponse.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APICreateItemLinkResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APICreateItemLinkResponse.AsObject {
    return {
      id: this.id
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APICreateItemLinkResponse.AsProtobufJSON {
    return {
      id: this.id
    };
  }
}
export module APICreateItemLinkResponse {
  /**
   * Standard JavaScript object representation for APICreateItemLinkResponse
   */
  export interface AsObject {
    id: string;
  }

  /**
   * Protobuf JSON representation for APICreateItemLinkResponse
   */
  export interface AsProtobufJSON {
    id: string;
  }
}

/**
 * Message implementation for goautowp.APIGetItemVehicleTypesRequest
 */
export class APIGetItemVehicleTypesRequest implements GrpcMessage {
  static id = 'goautowp.APIGetItemVehicleTypesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIGetItemVehicleTypesRequest();
    APIGetItemVehicleTypesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIGetItemVehicleTypesRequest) {
    _instance.itemId = _instance.itemId || '0';
    _instance.vehicleTypeId = _instance.vehicleTypeId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIGetItemVehicleTypesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.itemId = _reader.readInt64String();
          break;
        case 2:
          _instance.vehicleTypeId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    APIGetItemVehicleTypesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIGetItemVehicleTypesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.itemId) {
      _writer.writeInt64String(1, _instance.itemId);
    }
    if (_instance.vehicleTypeId) {
      _writer.writeInt64String(2, _instance.vehicleTypeId);
    }
  }

  private _itemId: string;
  private _vehicleTypeId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIGetItemVehicleTypesRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<APIGetItemVehicleTypesRequest.AsObject>
  ) {
    _value = _value || {};
    this.itemId = _value.itemId;
    this.vehicleTypeId = _value.vehicleTypeId;
    APIGetItemVehicleTypesRequest.refineValues(this);
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get vehicleTypeId(): string {
    return this._vehicleTypeId;
  }
  set vehicleTypeId(value: string) {
    this._vehicleTypeId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIGetItemVehicleTypesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIGetItemVehicleTypesRequest.AsObject {
    return {
      itemId: this.itemId,
      vehicleTypeId: this.vehicleTypeId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIGetItemVehicleTypesRequest.AsProtobufJSON {
    return {
      itemId: this.itemId,
      vehicleTypeId: this.vehicleTypeId
    };
  }
}
export module APIGetItemVehicleTypesRequest {
  /**
   * Standard JavaScript object representation for APIGetItemVehicleTypesRequest
   */
  export interface AsObject {
    itemId: string;
    vehicleTypeId: string;
  }

  /**
   * Protobuf JSON representation for APIGetItemVehicleTypesRequest
   */
  export interface AsProtobufJSON {
    itemId: string;
    vehicleTypeId: string;
  }
}

/**
 * Message implementation for goautowp.APIItemVehicleType
 */
export class APIItemVehicleType implements GrpcMessage {
  static id = 'goautowp.APIItemVehicleType';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIItemVehicleType();
    APIItemVehicleType.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIItemVehicleType) {
    _instance.itemId = _instance.itemId || '0';
    _instance.vehicleTypeId = _instance.vehicleTypeId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIItemVehicleType,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.itemId = _reader.readInt64String();
          break;
        case 2:
          _instance.vehicleTypeId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    APIItemVehicleType.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIItemVehicleType,
    _writer: BinaryWriter
  ) {
    if (_instance.itemId) {
      _writer.writeInt64String(1, _instance.itemId);
    }
    if (_instance.vehicleTypeId) {
      _writer.writeInt64String(2, _instance.vehicleTypeId);
    }
  }

  private _itemId: string;
  private _vehicleTypeId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIItemVehicleType to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIItemVehicleType.AsObject>) {
    _value = _value || {};
    this.itemId = _value.itemId;
    this.vehicleTypeId = _value.vehicleTypeId;
    APIItemVehicleType.refineValues(this);
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get vehicleTypeId(): string {
    return this._vehicleTypeId;
  }
  set vehicleTypeId(value: string) {
    this._vehicleTypeId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIItemVehicleType.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIItemVehicleType.AsObject {
    return {
      itemId: this.itemId,
      vehicleTypeId: this.vehicleTypeId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIItemVehicleType.AsProtobufJSON {
    return {
      itemId: this.itemId,
      vehicleTypeId: this.vehicleTypeId
    };
  }
}
export module APIItemVehicleType {
  /**
   * Standard JavaScript object representation for APIItemVehicleType
   */
  export interface AsObject {
    itemId: string;
    vehicleTypeId: string;
  }

  /**
   * Protobuf JSON representation for APIItemVehicleType
   */
  export interface AsProtobufJSON {
    itemId: string;
    vehicleTypeId: string;
  }
}

/**
 * Message implementation for goautowp.APIGetItemVehicleTypesResponse
 */
export class APIGetItemVehicleTypesResponse implements GrpcMessage {
  static id = 'goautowp.APIGetItemVehicleTypesResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIGetItemVehicleTypesResponse();
    APIGetItemVehicleTypesResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIGetItemVehicleTypesResponse) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIGetItemVehicleTypesResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new APIItemVehicleType();
          _reader.readMessage(
            messageInitializer1,
            APIItemVehicleType.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    APIGetItemVehicleTypesResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIGetItemVehicleTypesResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        APIItemVehicleType.serializeBinaryToWriter
      );
    }
  }

  private _items?: APIItemVehicleType[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIGetItemVehicleTypesResponse to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<APIGetItemVehicleTypesResponse.AsObject>
  ) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new APIItemVehicleType(m));
    APIGetItemVehicleTypesResponse.refineValues(this);
  }
  get items(): APIItemVehicleType[] | undefined {
    return this._items;
  }
  set items(value: APIItemVehicleType[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIGetItemVehicleTypesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIGetItemVehicleTypesResponse.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIGetItemVehicleTypesResponse.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module APIGetItemVehicleTypesResponse {
  /**
   * Standard JavaScript object representation for APIGetItemVehicleTypesResponse
   */
  export interface AsObject {
    items?: APIItemVehicleType.AsObject[];
  }

  /**
   * Protobuf JSON representation for APIGetItemVehicleTypesResponse
   */
  export interface AsProtobufJSON {
    items: APIItemVehicleType.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.APIItemVehicleTypeRequest
 */
export class APIItemVehicleTypeRequest implements GrpcMessage {
  static id = 'goautowp.APIItemVehicleTypeRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIItemVehicleTypeRequest();
    APIItemVehicleTypeRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIItemVehicleTypeRequest) {
    _instance.itemId = _instance.itemId || '0';
    _instance.vehicleTypeId = _instance.vehicleTypeId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIItemVehicleTypeRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.itemId = _reader.readInt64String();
          break;
        case 2:
          _instance.vehicleTypeId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    APIItemVehicleTypeRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIItemVehicleTypeRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.itemId) {
      _writer.writeInt64String(1, _instance.itemId);
    }
    if (_instance.vehicleTypeId) {
      _writer.writeInt64String(2, _instance.vehicleTypeId);
    }
  }

  private _itemId: string;
  private _vehicleTypeId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIItemVehicleTypeRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIItemVehicleTypeRequest.AsObject>) {
    _value = _value || {};
    this.itemId = _value.itemId;
    this.vehicleTypeId = _value.vehicleTypeId;
    APIItemVehicleTypeRequest.refineValues(this);
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get vehicleTypeId(): string {
    return this._vehicleTypeId;
  }
  set vehicleTypeId(value: string) {
    this._vehicleTypeId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIItemVehicleTypeRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIItemVehicleTypeRequest.AsObject {
    return {
      itemId: this.itemId,
      vehicleTypeId: this.vehicleTypeId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIItemVehicleTypeRequest.AsProtobufJSON {
    return {
      itemId: this.itemId,
      vehicleTypeId: this.vehicleTypeId
    };
  }
}
export module APIItemVehicleTypeRequest {
  /**
   * Standard JavaScript object representation for APIItemVehicleTypeRequest
   */
  export interface AsObject {
    itemId: string;
    vehicleTypeId: string;
  }

  /**
   * Protobuf JSON representation for APIItemVehicleTypeRequest
   */
  export interface AsProtobufJSON {
    itemId: string;
    vehicleTypeId: string;
  }
}

/**
 * Message implementation for goautowp.APIGetItemLanguagesRequest
 */
export class APIGetItemLanguagesRequest implements GrpcMessage {
  static id = 'goautowp.APIGetItemLanguagesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIGetItemLanguagesRequest();
    APIGetItemLanguagesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIGetItemLanguagesRequest) {
    _instance.itemId = _instance.itemId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIGetItemLanguagesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.itemId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    APIGetItemLanguagesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIGetItemLanguagesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.itemId) {
      _writer.writeInt64String(1, _instance.itemId);
    }
  }

  private _itemId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIGetItemLanguagesRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIGetItemLanguagesRequest.AsObject>) {
    _value = _value || {};
    this.itemId = _value.itemId;
    APIGetItemLanguagesRequest.refineValues(this);
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIGetItemLanguagesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIGetItemLanguagesRequest.AsObject {
    return {
      itemId: this.itemId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIGetItemLanguagesRequest.AsProtobufJSON {
    return {
      itemId: this.itemId
    };
  }
}
export module APIGetItemLanguagesRequest {
  /**
   * Standard JavaScript object representation for APIGetItemLanguagesRequest
   */
  export interface AsObject {
    itemId: string;
  }

  /**
   * Protobuf JSON representation for APIGetItemLanguagesRequest
   */
  export interface AsProtobufJSON {
    itemId: string;
  }
}

/**
 * Message implementation for goautowp.ItemLanguages
 */
export class ItemLanguages implements GrpcMessage {
  static id = 'goautowp.ItemLanguages';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemLanguages();
    ItemLanguages.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemLanguages) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemLanguages,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new ItemLanguage();
          _reader.readMessage(
            messageInitializer1,
            ItemLanguage.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    ItemLanguages.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItemLanguages,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        ItemLanguage.serializeBinaryToWriter
      );
    }
  }

  private _items?: ItemLanguage[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemLanguages to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemLanguages.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new ItemLanguage(m));
    ItemLanguages.refineValues(this);
  }
  get items(): ItemLanguage[] | undefined {
    return this._items;
  }
  set items(value: ItemLanguage[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemLanguages.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemLanguages.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemLanguages.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module ItemLanguages {
  /**
   * Standard JavaScript object representation for ItemLanguages
   */
  export interface AsObject {
    items?: ItemLanguage.AsObject[];
  }

  /**
   * Protobuf JSON representation for ItemLanguages
   */
  export interface AsProtobufJSON {
    items: ItemLanguage.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.ItemLanguage
 */
export class ItemLanguage implements GrpcMessage {
  static id = 'goautowp.ItemLanguage';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemLanguage();
    ItemLanguage.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemLanguage) {
    _instance.itemId = _instance.itemId || '0';
    _instance.language = _instance.language || '';
    _instance.name = _instance.name || '';
    _instance.textId = _instance.textId || 0;
    _instance.text = _instance.text || '';
    _instance.fullTextId = _instance.fullTextId || 0;
    _instance.fullText = _instance.fullText || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemLanguage,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.itemId = _reader.readInt64String();
          break;
        case 2:
          _instance.language = _reader.readString();
          break;
        case 3:
          _instance.name = _reader.readString();
          break;
        case 4:
          _instance.textId = _reader.readInt32();
          break;
        case 5:
          _instance.text = _reader.readString();
          break;
        case 6:
          _instance.fullTextId = _reader.readInt32();
          break;
        case 7:
          _instance.fullText = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    ItemLanguage.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItemLanguage,
    _writer: BinaryWriter
  ) {
    if (_instance.itemId) {
      _writer.writeInt64String(1, _instance.itemId);
    }
    if (_instance.language) {
      _writer.writeString(2, _instance.language);
    }
    if (_instance.name) {
      _writer.writeString(3, _instance.name);
    }
    if (_instance.textId) {
      _writer.writeInt32(4, _instance.textId);
    }
    if (_instance.text) {
      _writer.writeString(5, _instance.text);
    }
    if (_instance.fullTextId) {
      _writer.writeInt32(6, _instance.fullTextId);
    }
    if (_instance.fullText) {
      _writer.writeString(7, _instance.fullText);
    }
  }

  private _itemId: string;
  private _language: string;
  private _name: string;
  private _textId: number;
  private _text: string;
  private _fullTextId: number;
  private _fullText: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemLanguage to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemLanguage.AsObject>) {
    _value = _value || {};
    this.itemId = _value.itemId;
    this.language = _value.language;
    this.name = _value.name;
    this.textId = _value.textId;
    this.text = _value.text;
    this.fullTextId = _value.fullTextId;
    this.fullText = _value.fullText;
    ItemLanguage.refineValues(this);
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get textId(): number {
    return this._textId;
  }
  set textId(value: number) {
    this._textId = value;
  }
  get text(): string {
    return this._text;
  }
  set text(value: string) {
    this._text = value;
  }
  get fullTextId(): number {
    return this._fullTextId;
  }
  set fullTextId(value: number) {
    this._fullTextId = value;
  }
  get fullText(): string {
    return this._fullText;
  }
  set fullText(value: string) {
    this._fullText = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemLanguage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemLanguage.AsObject {
    return {
      itemId: this.itemId,
      language: this.language,
      name: this.name,
      textId: this.textId,
      text: this.text,
      fullTextId: this.fullTextId,
      fullText: this.fullText
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemLanguage.AsProtobufJSON {
    return {
      itemId: this.itemId,
      language: this.language,
      name: this.name,
      textId: this.textId,
      text: this.text,
      fullTextId: this.fullTextId,
      fullText: this.fullText
    };
  }
}
export module ItemLanguage {
  /**
   * Standard JavaScript object representation for ItemLanguage
   */
  export interface AsObject {
    itemId: string;
    language: string;
    name: string;
    textId: number;
    text: string;
    fullTextId: number;
    fullText: string;
  }

  /**
   * Protobuf JSON representation for ItemLanguage
   */
  export interface AsProtobufJSON {
    itemId: string;
    language: string;
    name: string;
    textId: number;
    text: string;
    fullTextId: number;
    fullText: string;
  }
}

/**
 * Message implementation for goautowp.APIGetItemParentLanguagesRequest
 */
export class APIGetItemParentLanguagesRequest implements GrpcMessage {
  static id = 'goautowp.APIGetItemParentLanguagesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIGetItemParentLanguagesRequest();
    APIGetItemParentLanguagesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIGetItemParentLanguagesRequest) {
    _instance.itemId = _instance.itemId || '0';
    _instance.parentId = _instance.parentId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIGetItemParentLanguagesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.itemId = _reader.readInt64String();
          break;
        case 2:
          _instance.parentId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    APIGetItemParentLanguagesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIGetItemParentLanguagesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.itemId) {
      _writer.writeInt64String(1, _instance.itemId);
    }
    if (_instance.parentId) {
      _writer.writeInt64String(2, _instance.parentId);
    }
  }

  private _itemId: string;
  private _parentId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIGetItemParentLanguagesRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<APIGetItemParentLanguagesRequest.AsObject>
  ) {
    _value = _value || {};
    this.itemId = _value.itemId;
    this.parentId = _value.parentId;
    APIGetItemParentLanguagesRequest.refineValues(this);
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get parentId(): string {
    return this._parentId;
  }
  set parentId(value: string) {
    this._parentId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIGetItemParentLanguagesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIGetItemParentLanguagesRequest.AsObject {
    return {
      itemId: this.itemId,
      parentId: this.parentId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIGetItemParentLanguagesRequest.AsProtobufJSON {
    return {
      itemId: this.itemId,
      parentId: this.parentId
    };
  }
}
export module APIGetItemParentLanguagesRequest {
  /**
   * Standard JavaScript object representation for APIGetItemParentLanguagesRequest
   */
  export interface AsObject {
    itemId: string;
    parentId: string;
  }

  /**
   * Protobuf JSON representation for APIGetItemParentLanguagesRequest
   */
  export interface AsProtobufJSON {
    itemId: string;
    parentId: string;
  }
}

/**
 * Message implementation for goautowp.ItemParentLanguages
 */
export class ItemParentLanguages implements GrpcMessage {
  static id = 'goautowp.ItemParentLanguages';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemParentLanguages();
    ItemParentLanguages.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemParentLanguages) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemParentLanguages,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new ItemParentLanguage();
          _reader.readMessage(
            messageInitializer1,
            ItemParentLanguage.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    ItemParentLanguages.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItemParentLanguages,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        ItemParentLanguage.serializeBinaryToWriter
      );
    }
  }

  private _items?: ItemParentLanguage[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemParentLanguages to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemParentLanguages.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new ItemParentLanguage(m));
    ItemParentLanguages.refineValues(this);
  }
  get items(): ItemParentLanguage[] | undefined {
    return this._items;
  }
  set items(value: ItemParentLanguage[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemParentLanguages.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemParentLanguages.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemParentLanguages.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module ItemParentLanguages {
  /**
   * Standard JavaScript object representation for ItemParentLanguages
   */
  export interface AsObject {
    items?: ItemParentLanguage.AsObject[];
  }

  /**
   * Protobuf JSON representation for ItemParentLanguages
   */
  export interface AsProtobufJSON {
    items: ItemParentLanguage.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.ItemParentLanguage
 */
export class ItemParentLanguage implements GrpcMessage {
  static id = 'goautowp.ItemParentLanguage';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemParentLanguage();
    ItemParentLanguage.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemParentLanguage) {
    _instance.itemId = _instance.itemId || '0';
    _instance.parentId = _instance.parentId || '0';
    _instance.name = _instance.name || '';
    _instance.language = _instance.language || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemParentLanguage,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.itemId = _reader.readInt64String();
          break;
        case 2:
          _instance.parentId = _reader.readInt64String();
          break;
        case 3:
          _instance.name = _reader.readString();
          break;
        case 4:
          _instance.language = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    ItemParentLanguage.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItemParentLanguage,
    _writer: BinaryWriter
  ) {
    if (_instance.itemId) {
      _writer.writeInt64String(1, _instance.itemId);
    }
    if (_instance.parentId) {
      _writer.writeInt64String(2, _instance.parentId);
    }
    if (_instance.name) {
      _writer.writeString(3, _instance.name);
    }
    if (_instance.language) {
      _writer.writeString(4, _instance.language);
    }
  }

  private _itemId: string;
  private _parentId: string;
  private _name: string;
  private _language: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemParentLanguage to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemParentLanguage.AsObject>) {
    _value = _value || {};
    this.itemId = _value.itemId;
    this.parentId = _value.parentId;
    this.name = _value.name;
    this.language = _value.language;
    ItemParentLanguage.refineValues(this);
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get parentId(): string {
    return this._parentId;
  }
  set parentId(value: string) {
    this._parentId = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemParentLanguage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemParentLanguage.AsObject {
    return {
      itemId: this.itemId,
      parentId: this.parentId,
      name: this.name,
      language: this.language
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemParentLanguage.AsProtobufJSON {
    return {
      itemId: this.itemId,
      parentId: this.parentId,
      name: this.name,
      language: this.language
    };
  }
}
export module ItemParentLanguage {
  /**
   * Standard JavaScript object representation for ItemParentLanguage
   */
  export interface AsObject {
    itemId: string;
    parentId: string;
    name: string;
    language: string;
  }

  /**
   * Protobuf JSON representation for ItemParentLanguage
   */
  export interface AsProtobufJSON {
    itemId: string;
    parentId: string;
    name: string;
    language: string;
  }
}

/**
 * Message implementation for goautowp.StatsResponse
 */
export class StatsResponse implements GrpcMessage {
  static id = 'goautowp.StatsResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new StatsResponse();
    StatsResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: StatsResponse) {
    _instance.values = _instance.values || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: StatsResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new StatsValue();
          _reader.readMessage(
            messageInitializer1,
            StatsValue.deserializeBinaryFromReader
          );
          (_instance.values = _instance.values || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    StatsResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: StatsResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.values && _instance.values.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.values as any,
        StatsValue.serializeBinaryToWriter
      );
    }
  }

  private _values?: StatsValue[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of StatsResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<StatsResponse.AsObject>) {
    _value = _value || {};
    this.values = (_value.values || []).map(m => new StatsValue(m));
    StatsResponse.refineValues(this);
  }
  get values(): StatsValue[] | undefined {
    return this._values;
  }
  set values(value: StatsValue[] | undefined) {
    this._values = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    StatsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): StatsResponse.AsObject {
    return {
      values: (this.values || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): StatsResponse.AsProtobufJSON {
    return {
      values: (this.values || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module StatsResponse {
  /**
   * Standard JavaScript object representation for StatsResponse
   */
  export interface AsObject {
    values?: StatsValue.AsObject[];
  }

  /**
   * Protobuf JSON representation for StatsResponse
   */
  export interface AsProtobufJSON {
    values: StatsValue.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.StatsValue
 */
export class StatsValue implements GrpcMessage {
  static id = 'goautowp.StatsValue';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new StatsValue();
    StatsValue.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: StatsValue) {
    _instance.name = _instance.name || '';
    _instance.total = _instance.total || 0;
    _instance.value = _instance.value || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: StatsValue,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.name = _reader.readString();
          break;
        case 2:
          _instance.total = _reader.readInt32();
          break;
        case 3:
          _instance.value = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    StatsValue.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: StatsValue, _writer: BinaryWriter) {
    if (_instance.name) {
      _writer.writeString(1, _instance.name);
    }
    if (_instance.total) {
      _writer.writeInt32(2, _instance.total);
    }
    if (_instance.value) {
      _writer.writeInt32(3, _instance.value);
    }
  }

  private _name: string;
  private _total: number;
  private _value: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of StatsValue to deeply clone from
   */
  constructor(_value?: RecursivePartial<StatsValue.AsObject>) {
    _value = _value || {};
    this.name = _value.name;
    this.total = _value.total;
    this.value = _value.value;
    StatsValue.refineValues(this);
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get total(): number {
    return this._total;
  }
  set total(value: number) {
    this._total = value;
  }
  get value(): number {
    return this._value;
  }
  set value(value: number) {
    this._value = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    StatsValue.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): StatsValue.AsObject {
    return {
      name: this.name,
      total: this.total,
      value: this.value
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): StatsValue.AsProtobufJSON {
    return {
      name: this.name,
      total: this.total,
      value: this.value
    };
  }
}
export module StatsValue {
  /**
   * Standard JavaScript object representation for StatsValue
   */
  export interface AsObject {
    name: string;
    total: number;
    value: number;
  }

  /**
   * Protobuf JSON representation for StatsValue
   */
  export interface AsProtobufJSON {
    name: string;
    total: number;
    value: number;
  }
}

/**
 * Message implementation for goautowp.NewItemsRequest
 */
export class NewItemsRequest implements GrpcMessage {
  static id = 'goautowp.NewItemsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new NewItemsRequest();
    NewItemsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: NewItemsRequest) {
    _instance.itemId = _instance.itemId || '0';
    _instance.language = _instance.language || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: NewItemsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.itemId = _reader.readInt64String();
          break;
        case 2:
          _instance.language = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    NewItemsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: NewItemsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.itemId) {
      _writer.writeInt64String(1, _instance.itemId);
    }
    if (_instance.language) {
      _writer.writeString(2, _instance.language);
    }
  }

  private _itemId: string;
  private _language: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of NewItemsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<NewItemsRequest.AsObject>) {
    _value = _value || {};
    this.itemId = _value.itemId;
    this.language = _value.language;
    NewItemsRequest.refineValues(this);
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    NewItemsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): NewItemsRequest.AsObject {
    return {
      itemId: this.itemId,
      language: this.language
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): NewItemsRequest.AsProtobufJSON {
    return {
      itemId: this.itemId,
      language: this.language
    };
  }
}
export module NewItemsRequest {
  /**
   * Standard JavaScript object representation for NewItemsRequest
   */
  export interface AsObject {
    itemId: string;
    language: string;
  }

  /**
   * Protobuf JSON representation for NewItemsRequest
   */
  export interface AsProtobufJSON {
    itemId: string;
    language: string;
  }
}

/**
 * Message implementation for goautowp.NewItemsResponse
 */
export class NewItemsResponse implements GrpcMessage {
  static id = 'goautowp.NewItemsResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new NewItemsResponse();
    NewItemsResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: NewItemsResponse) {
    _instance.brand = _instance.brand || undefined;
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: NewItemsResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.brand = new APIItem();
          _reader.readMessage(
            _instance.brand,
            APIItem.deserializeBinaryFromReader
          );
          break;
        case 2:
          const messageInitializer2 = new APIItem();
          _reader.readMessage(
            messageInitializer2,
            APIItem.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer2);
          break;
        default:
          _reader.skipField();
      }
    }

    NewItemsResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: NewItemsResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.brand) {
      _writer.writeMessage(
        1,
        _instance.brand as any,
        APIItem.serializeBinaryToWriter
      );
    }
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        2,
        _instance.items as any,
        APIItem.serializeBinaryToWriter
      );
    }
  }

  private _brand?: APIItem;
  private _items?: APIItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of NewItemsResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<NewItemsResponse.AsObject>) {
    _value = _value || {};
    this.brand = _value.brand ? new APIItem(_value.brand) : undefined;
    this.items = (_value.items || []).map(m => new APIItem(m));
    NewItemsResponse.refineValues(this);
  }
  get brand(): APIItem | undefined {
    return this._brand;
  }
  set brand(value: APIItem | undefined) {
    this._brand = value;
  }
  get items(): APIItem[] | undefined {
    return this._items;
  }
  set items(value: APIItem[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    NewItemsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): NewItemsResponse.AsObject {
    return {
      brand: this.brand ? this.brand.toObject() : undefined,
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): NewItemsResponse.AsProtobufJSON {
    return {
      brand: this.brand ? this.brand.toProtobufJSON(options) : null,
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module NewItemsResponse {
  /**
   * Standard JavaScript object representation for NewItemsResponse
   */
  export interface AsObject {
    brand?: APIItem.AsObject;
    items?: APIItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for NewItemsResponse
   */
  export interface AsProtobufJSON {
    brand: APIItem.AsProtobufJSON | null;
    items: APIItem.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.ItemParentFields
 */
export class ItemParentFields implements GrpcMessage {
  static id = 'goautowp.ItemParentFields';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemParentFields();
    ItemParentFields.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemParentFields) {
    _instance.item = _instance.item || undefined;
    _instance.parent = _instance.parent || undefined;
    _instance.duplicateParent = _instance.duplicateParent || undefined;
    _instance.duplicateChild = _instance.duplicateChild || undefined;
    _instance.childDescendantPictures =
      _instance.childDescendantPictures || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemParentFields,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.item = new ItemFields();
          _reader.readMessage(
            _instance.item,
            ItemFields.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.parent = new ItemFields();
          _reader.readMessage(
            _instance.parent,
            ItemFields.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.duplicateParent = new ItemFields();
          _reader.readMessage(
            _instance.duplicateParent,
            ItemFields.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.duplicateChild = new ItemFields();
          _reader.readMessage(
            _instance.duplicateChild,
            ItemFields.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.childDescendantPictures = new PicturesRequest();
          _reader.readMessage(
            _instance.childDescendantPictures,
            PicturesRequest.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    ItemParentFields.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItemParentFields,
    _writer: BinaryWriter
  ) {
    if (_instance.item) {
      _writer.writeMessage(
        1,
        _instance.item as any,
        ItemFields.serializeBinaryToWriter
      );
    }
    if (_instance.parent) {
      _writer.writeMessage(
        2,
        _instance.parent as any,
        ItemFields.serializeBinaryToWriter
      );
    }
    if (_instance.duplicateParent) {
      _writer.writeMessage(
        3,
        _instance.duplicateParent as any,
        ItemFields.serializeBinaryToWriter
      );
    }
    if (_instance.duplicateChild) {
      _writer.writeMessage(
        4,
        _instance.duplicateChild as any,
        ItemFields.serializeBinaryToWriter
      );
    }
    if (_instance.childDescendantPictures) {
      _writer.writeMessage(
        5,
        _instance.childDescendantPictures as any,
        PicturesRequest.serializeBinaryToWriter
      );
    }
  }

  private _item?: ItemFields;
  private _parent?: ItemFields;
  private _duplicateParent?: ItemFields;
  private _duplicateChild?: ItemFields;
  private _childDescendantPictures?: PicturesRequest;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemParentFields to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemParentFields.AsObject>) {
    _value = _value || {};
    this.item = _value.item ? new ItemFields(_value.item) : undefined;
    this.parent = _value.parent ? new ItemFields(_value.parent) : undefined;
    this.duplicateParent = _value.duplicateParent
      ? new ItemFields(_value.duplicateParent)
      : undefined;
    this.duplicateChild = _value.duplicateChild
      ? new ItemFields(_value.duplicateChild)
      : undefined;
    this.childDescendantPictures = _value.childDescendantPictures
      ? new PicturesRequest(_value.childDescendantPictures)
      : undefined;
    ItemParentFields.refineValues(this);
  }
  get item(): ItemFields | undefined {
    return this._item;
  }
  set item(value: ItemFields | undefined) {
    this._item = value;
  }
  get parent(): ItemFields | undefined {
    return this._parent;
  }
  set parent(value: ItemFields | undefined) {
    this._parent = value;
  }
  get duplicateParent(): ItemFields | undefined {
    return this._duplicateParent;
  }
  set duplicateParent(value: ItemFields | undefined) {
    this._duplicateParent = value;
  }
  get duplicateChild(): ItemFields | undefined {
    return this._duplicateChild;
  }
  set duplicateChild(value: ItemFields | undefined) {
    this._duplicateChild = value;
  }
  get childDescendantPictures(): PicturesRequest | undefined {
    return this._childDescendantPictures;
  }
  set childDescendantPictures(value: PicturesRequest | undefined) {
    this._childDescendantPictures = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemParentFields.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemParentFields.AsObject {
    return {
      item: this.item ? this.item.toObject() : undefined,
      parent: this.parent ? this.parent.toObject() : undefined,
      duplicateParent: this.duplicateParent
        ? this.duplicateParent.toObject()
        : undefined,
      duplicateChild: this.duplicateChild
        ? this.duplicateChild.toObject()
        : undefined,
      childDescendantPictures: this.childDescendantPictures
        ? this.childDescendantPictures.toObject()
        : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemParentFields.AsProtobufJSON {
    return {
      item: this.item ? this.item.toProtobufJSON(options) : null,
      parent: this.parent ? this.parent.toProtobufJSON(options) : null,
      duplicateParent: this.duplicateParent
        ? this.duplicateParent.toProtobufJSON(options)
        : null,
      duplicateChild: this.duplicateChild
        ? this.duplicateChild.toProtobufJSON(options)
        : null,
      childDescendantPictures: this.childDescendantPictures
        ? this.childDescendantPictures.toProtobufJSON(options)
        : null
    };
  }
}
export module ItemParentFields {
  /**
   * Standard JavaScript object representation for ItemParentFields
   */
  export interface AsObject {
    item?: ItemFields.AsObject;
    parent?: ItemFields.AsObject;
    duplicateParent?: ItemFields.AsObject;
    duplicateChild?: ItemFields.AsObject;
    childDescendantPictures?: PicturesRequest.AsObject;
  }

  /**
   * Protobuf JSON representation for ItemParentFields
   */
  export interface AsProtobufJSON {
    item: ItemFields.AsProtobufJSON | null;
    parent: ItemFields.AsProtobufJSON | null;
    duplicateParent: ItemFields.AsProtobufJSON | null;
    duplicateChild: ItemFields.AsProtobufJSON | null;
    childDescendantPictures: PicturesRequest.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.ItemParentsRequest
 */
export class ItemParentsRequest implements GrpcMessage {
  static id = 'goautowp.ItemParentsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemParentsRequest();
    ItemParentsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemParentsRequest) {
    _instance.options = _instance.options || undefined;
    _instance.order = _instance.order || 0;
    _instance.limit = _instance.limit || 0;
    _instance.page = _instance.page || 0;
    _instance.fields = _instance.fields || undefined;
    _instance.language = _instance.language || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemParentsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.options = new ItemParentListOptions();
          _reader.readMessage(
            _instance.options,
            ItemParentListOptions.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.order = _reader.readEnum();
          break;
        case 3:
          _instance.limit = _reader.readUint32();
          break;
        case 4:
          _instance.page = _reader.readUint32();
          break;
        case 5:
          _instance.fields = new ItemParentFields();
          _reader.readMessage(
            _instance.fields,
            ItemParentFields.deserializeBinaryFromReader
          );
          break;
        case 6:
          _instance.language = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    ItemParentsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItemParentsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.options) {
      _writer.writeMessage(
        1,
        _instance.options as any,
        ItemParentListOptions.serializeBinaryToWriter
      );
    }
    if (_instance.order) {
      _writer.writeEnum(2, _instance.order);
    }
    if (_instance.limit) {
      _writer.writeUint32(3, _instance.limit);
    }
    if (_instance.page) {
      _writer.writeUint32(4, _instance.page);
    }
    if (_instance.fields) {
      _writer.writeMessage(
        5,
        _instance.fields as any,
        ItemParentFields.serializeBinaryToWriter
      );
    }
    if (_instance.language) {
      _writer.writeString(6, _instance.language);
    }
  }

  private _options?: ItemParentListOptions;
  private _order: ItemParentsRequest.Order;
  private _limit: number;
  private _page: number;
  private _fields?: ItemParentFields;
  private _language: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemParentsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemParentsRequest.AsObject>) {
    _value = _value || {};
    this.options = _value.options
      ? new ItemParentListOptions(_value.options)
      : undefined;
    this.order = _value.order;
    this.limit = _value.limit;
    this.page = _value.page;
    this.fields = _value.fields
      ? new ItemParentFields(_value.fields)
      : undefined;
    this.language = _value.language;
    ItemParentsRequest.refineValues(this);
  }
  get options(): ItemParentListOptions | undefined {
    return this._options;
  }
  set options(value: ItemParentListOptions | undefined) {
    this._options = value;
  }
  get order(): ItemParentsRequest.Order {
    return this._order;
  }
  set order(value: ItemParentsRequest.Order) {
    this._order = value;
  }
  get limit(): number {
    return this._limit;
  }
  set limit(value: number) {
    this._limit = value;
  }
  get page(): number {
    return this._page;
  }
  set page(value: number) {
    this._page = value;
  }
  get fields(): ItemParentFields | undefined {
    return this._fields;
  }
  set fields(value: ItemParentFields | undefined) {
    this._fields = value;
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemParentsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemParentsRequest.AsObject {
    return {
      options: this.options ? this.options.toObject() : undefined,
      order: this.order,
      limit: this.limit,
      page: this.page,
      fields: this.fields ? this.fields.toObject() : undefined,
      language: this.language
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemParentsRequest.AsProtobufJSON {
    return {
      options: this.options ? this.options.toProtobufJSON(options) : null,
      order:
        ItemParentsRequest.Order[
          this.order === null || this.order === undefined ? 0 : this.order
        ],
      limit: this.limit,
      page: this.page,
      fields: this.fields ? this.fields.toProtobufJSON(options) : null,
      language: this.language
    };
  }
}
export module ItemParentsRequest {
  /**
   * Standard JavaScript object representation for ItemParentsRequest
   */
  export interface AsObject {
    options?: ItemParentListOptions.AsObject;
    order: ItemParentsRequest.Order;
    limit: number;
    page: number;
    fields?: ItemParentFields.AsObject;
    language: string;
  }

  /**
   * Protobuf JSON representation for ItemParentsRequest
   */
  export interface AsProtobufJSON {
    options: ItemParentListOptions.AsProtobufJSON | null;
    order: string;
    limit: number;
    page: number;
    fields: ItemParentFields.AsProtobufJSON | null;
    language: string;
  }
  export enum Order {
    NONE = 0,
    AUTO = 1,
    CATEGORIES_FIRST = 2
  }
}

/**
 * Message implementation for goautowp.ItemParents
 */
export class ItemParents implements GrpcMessage {
  static id = 'goautowp.ItemParents';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemParents();
    ItemParents.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemParents) {
    _instance.items = _instance.items || [];
    _instance.paginator = _instance.paginator || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemParents,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new ItemParent();
          _reader.readMessage(
            messageInitializer1,
            ItemParent.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        case 2:
          _instance.paginator = new Pages();
          _reader.readMessage(
            _instance.paginator,
            Pages.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    ItemParents.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItemParents,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        ItemParent.serializeBinaryToWriter
      );
    }
    if (_instance.paginator) {
      _writer.writeMessage(
        2,
        _instance.paginator as any,
        Pages.serializeBinaryToWriter
      );
    }
  }

  private _items?: ItemParent[];
  private _paginator?: Pages;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemParents to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemParents.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new ItemParent(m));
    this.paginator = _value.paginator ? new Pages(_value.paginator) : undefined;
    ItemParents.refineValues(this);
  }
  get items(): ItemParent[] | undefined {
    return this._items;
  }
  set items(value: ItemParent[] | undefined) {
    this._items = value;
  }
  get paginator(): Pages | undefined {
    return this._paginator;
  }
  set paginator(value: Pages | undefined) {
    this._paginator = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemParents.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemParents.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject()),
      paginator: this.paginator ? this.paginator.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemParents.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options)),
      paginator: this.paginator ? this.paginator.toProtobufJSON(options) : null
    };
  }
}
export module ItemParents {
  /**
   * Standard JavaScript object representation for ItemParents
   */
  export interface AsObject {
    items?: ItemParent.AsObject[];
    paginator?: Pages.AsObject;
  }

  /**
   * Protobuf JSON representation for ItemParents
   */
  export interface AsProtobufJSON {
    items: ItemParent.AsProtobufJSON[] | null;
    paginator: Pages.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.ItemParent
 */
export class ItemParent implements GrpcMessage {
  static id = 'goautowp.ItemParent';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemParent();
    ItemParent.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemParent) {
    _instance.itemId = _instance.itemId || '0';
    _instance.parentId = _instance.parentId || '0';
    _instance.type = _instance.type || 0;
    _instance.catname = _instance.catname || '';
    _instance.item = _instance.item || undefined;
    _instance.parent = _instance.parent || undefined;
    _instance.duplicateParent = _instance.duplicateParent || undefined;
    _instance.duplicateChild = _instance.duplicateChild || undefined;
    _instance.childDescendantPictures =
      _instance.childDescendantPictures || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemParent,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.itemId = _reader.readInt64String();
          break;
        case 2:
          _instance.parentId = _reader.readInt64String();
          break;
        case 3:
          _instance.type = _reader.readEnum();
          break;
        case 4:
          _instance.catname = _reader.readString();
          break;
        case 5:
          _instance.item = new APIItem();
          _reader.readMessage(
            _instance.item,
            APIItem.deserializeBinaryFromReader
          );
          break;
        case 8:
          _instance.parent = new APIItem();
          _reader.readMessage(
            _instance.parent,
            APIItem.deserializeBinaryFromReader
          );
          break;
        case 6:
          _instance.duplicateParent = new APIItem();
          _reader.readMessage(
            _instance.duplicateParent,
            APIItem.deserializeBinaryFromReader
          );
          break;
        case 7:
          _instance.duplicateChild = new APIItem();
          _reader.readMessage(
            _instance.duplicateChild,
            APIItem.deserializeBinaryFromReader
          );
          break;
        case 9:
          _instance.childDescendantPictures = new PicturesList();
          _reader.readMessage(
            _instance.childDescendantPictures,
            PicturesList.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    ItemParent.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: ItemParent, _writer: BinaryWriter) {
    if (_instance.itemId) {
      _writer.writeInt64String(1, _instance.itemId);
    }
    if (_instance.parentId) {
      _writer.writeInt64String(2, _instance.parentId);
    }
    if (_instance.type) {
      _writer.writeEnum(3, _instance.type);
    }
    if (_instance.catname) {
      _writer.writeString(4, _instance.catname);
    }
    if (_instance.item) {
      _writer.writeMessage(
        5,
        _instance.item as any,
        APIItem.serializeBinaryToWriter
      );
    }
    if (_instance.parent) {
      _writer.writeMessage(
        8,
        _instance.parent as any,
        APIItem.serializeBinaryToWriter
      );
    }
    if (_instance.duplicateParent) {
      _writer.writeMessage(
        6,
        _instance.duplicateParent as any,
        APIItem.serializeBinaryToWriter
      );
    }
    if (_instance.duplicateChild) {
      _writer.writeMessage(
        7,
        _instance.duplicateChild as any,
        APIItem.serializeBinaryToWriter
      );
    }
    if (_instance.childDescendantPictures) {
      _writer.writeMessage(
        9,
        _instance.childDescendantPictures as any,
        PicturesList.serializeBinaryToWriter
      );
    }
  }

  private _itemId: string;
  private _parentId: string;
  private _type: ItemParentType;
  private _catname: string;
  private _item?: APIItem;
  private _parent?: APIItem;
  private _duplicateParent?: APIItem;
  private _duplicateChild?: APIItem;
  private _childDescendantPictures?: PicturesList;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemParent to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemParent.AsObject>) {
    _value = _value || {};
    this.itemId = _value.itemId;
    this.parentId = _value.parentId;
    this.type = _value.type;
    this.catname = _value.catname;
    this.item = _value.item ? new APIItem(_value.item) : undefined;
    this.parent = _value.parent ? new APIItem(_value.parent) : undefined;
    this.duplicateParent = _value.duplicateParent
      ? new APIItem(_value.duplicateParent)
      : undefined;
    this.duplicateChild = _value.duplicateChild
      ? new APIItem(_value.duplicateChild)
      : undefined;
    this.childDescendantPictures = _value.childDescendantPictures
      ? new PicturesList(_value.childDescendantPictures)
      : undefined;
    ItemParent.refineValues(this);
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get parentId(): string {
    return this._parentId;
  }
  set parentId(value: string) {
    this._parentId = value;
  }
  get type(): ItemParentType {
    return this._type;
  }
  set type(value: ItemParentType) {
    this._type = value;
  }
  get catname(): string {
    return this._catname;
  }
  set catname(value: string) {
    this._catname = value;
  }
  get item(): APIItem | undefined {
    return this._item;
  }
  set item(value: APIItem | undefined) {
    this._item = value;
  }
  get parent(): APIItem | undefined {
    return this._parent;
  }
  set parent(value: APIItem | undefined) {
    this._parent = value;
  }
  get duplicateParent(): APIItem | undefined {
    return this._duplicateParent;
  }
  set duplicateParent(value: APIItem | undefined) {
    this._duplicateParent = value;
  }
  get duplicateChild(): APIItem | undefined {
    return this._duplicateChild;
  }
  set duplicateChild(value: APIItem | undefined) {
    this._duplicateChild = value;
  }
  get childDescendantPictures(): PicturesList | undefined {
    return this._childDescendantPictures;
  }
  set childDescendantPictures(value: PicturesList | undefined) {
    this._childDescendantPictures = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemParent.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemParent.AsObject {
    return {
      itemId: this.itemId,
      parentId: this.parentId,
      type: this.type,
      catname: this.catname,
      item: this.item ? this.item.toObject() : undefined,
      parent: this.parent ? this.parent.toObject() : undefined,
      duplicateParent: this.duplicateParent
        ? this.duplicateParent.toObject()
        : undefined,
      duplicateChild: this.duplicateChild
        ? this.duplicateChild.toObject()
        : undefined,
      childDescendantPictures: this.childDescendantPictures
        ? this.childDescendantPictures.toObject()
        : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemParent.AsProtobufJSON {
    return {
      itemId: this.itemId,
      parentId: this.parentId,
      type:
        ItemParentType[
          this.type === null || this.type === undefined ? 0 : this.type
        ],
      catname: this.catname,
      item: this.item ? this.item.toProtobufJSON(options) : null,
      parent: this.parent ? this.parent.toProtobufJSON(options) : null,
      duplicateParent: this.duplicateParent
        ? this.duplicateParent.toProtobufJSON(options)
        : null,
      duplicateChild: this.duplicateChild
        ? this.duplicateChild.toProtobufJSON(options)
        : null,
      childDescendantPictures: this.childDescendantPictures
        ? this.childDescendantPictures.toProtobufJSON(options)
        : null
    };
  }
}
export module ItemParent {
  /**
   * Standard JavaScript object representation for ItemParent
   */
  export interface AsObject {
    itemId: string;
    parentId: string;
    type: ItemParentType;
    catname: string;
    item?: APIItem.AsObject;
    parent?: APIItem.AsObject;
    duplicateParent?: APIItem.AsObject;
    duplicateChild?: APIItem.AsObject;
    childDescendantPictures?: PicturesList.AsObject;
  }

  /**
   * Protobuf JSON representation for ItemParent
   */
  export interface AsProtobufJSON {
    itemId: string;
    parentId: string;
    type: string;
    catname: string;
    item: APIItem.AsProtobufJSON | null;
    parent: APIItem.AsProtobufJSON | null;
    duplicateParent: APIItem.AsProtobufJSON | null;
    duplicateChild: APIItem.AsProtobufJSON | null;
    childDescendantPictures: PicturesList.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.DeleteItemParentRequest
 */
export class DeleteItemParentRequest implements GrpcMessage {
  static id = 'goautowp.DeleteItemParentRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new DeleteItemParentRequest();
    DeleteItemParentRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: DeleteItemParentRequest) {
    _instance.itemId = _instance.itemId || '0';
    _instance.parentId = _instance.parentId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: DeleteItemParentRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.itemId = _reader.readInt64String();
          break;
        case 2:
          _instance.parentId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    DeleteItemParentRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: DeleteItemParentRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.itemId) {
      _writer.writeInt64String(1, _instance.itemId);
    }
    if (_instance.parentId) {
      _writer.writeInt64String(2, _instance.parentId);
    }
  }

  private _itemId: string;
  private _parentId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of DeleteItemParentRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<DeleteItemParentRequest.AsObject>) {
    _value = _value || {};
    this.itemId = _value.itemId;
    this.parentId = _value.parentId;
    DeleteItemParentRequest.refineValues(this);
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get parentId(): string {
    return this._parentId;
  }
  set parentId(value: string) {
    this._parentId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    DeleteItemParentRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): DeleteItemParentRequest.AsObject {
    return {
      itemId: this.itemId,
      parentId: this.parentId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): DeleteItemParentRequest.AsProtobufJSON {
    return {
      itemId: this.itemId,
      parentId: this.parentId
    };
  }
}
export module DeleteItemParentRequest {
  /**
   * Standard JavaScript object representation for DeleteItemParentRequest
   */
  export interface AsObject {
    itemId: string;
    parentId: string;
  }

  /**
   * Protobuf JSON representation for DeleteItemParentRequest
   */
  export interface AsProtobufJSON {
    itemId: string;
    parentId: string;
  }
}

/**
 * Message implementation for goautowp.MoveItemParentRequest
 */
export class MoveItemParentRequest implements GrpcMessage {
  static id = 'goautowp.MoveItemParentRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new MoveItemParentRequest();
    MoveItemParentRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: MoveItemParentRequest) {
    _instance.itemId = _instance.itemId || '0';
    _instance.parentId = _instance.parentId || '0';
    _instance.destParentId = _instance.destParentId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: MoveItemParentRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.itemId = _reader.readInt64String();
          break;
        case 2:
          _instance.parentId = _reader.readInt64String();
          break;
        case 3:
          _instance.destParentId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    MoveItemParentRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: MoveItemParentRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.itemId) {
      _writer.writeInt64String(1, _instance.itemId);
    }
    if (_instance.parentId) {
      _writer.writeInt64String(2, _instance.parentId);
    }
    if (_instance.destParentId) {
      _writer.writeInt64String(3, _instance.destParentId);
    }
  }

  private _itemId: string;
  private _parentId: string;
  private _destParentId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of MoveItemParentRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<MoveItemParentRequest.AsObject>) {
    _value = _value || {};
    this.itemId = _value.itemId;
    this.parentId = _value.parentId;
    this.destParentId = _value.destParentId;
    MoveItemParentRequest.refineValues(this);
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get parentId(): string {
    return this._parentId;
  }
  set parentId(value: string) {
    this._parentId = value;
  }
  get destParentId(): string {
    return this._destParentId;
  }
  set destParentId(value: string) {
    this._destParentId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    MoveItemParentRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): MoveItemParentRequest.AsObject {
    return {
      itemId: this.itemId,
      parentId: this.parentId,
      destParentId: this.destParentId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): MoveItemParentRequest.AsProtobufJSON {
    return {
      itemId: this.itemId,
      parentId: this.parentId,
      destParentId: this.destParentId
    };
  }
}
export module MoveItemParentRequest {
  /**
   * Standard JavaScript object representation for MoveItemParentRequest
   */
  export interface AsObject {
    itemId: string;
    parentId: string;
    destParentId: string;
  }

  /**
   * Protobuf JSON representation for MoveItemParentRequest
   */
  export interface AsProtobufJSON {
    itemId: string;
    parentId: string;
    destParentId: string;
  }
}

/**
 * Message implementation for goautowp.RefreshInheritanceRequest
 */
export class RefreshInheritanceRequest implements GrpcMessage {
  static id = 'goautowp.RefreshInheritanceRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new RefreshInheritanceRequest();
    RefreshInheritanceRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: RefreshInheritanceRequest) {
    _instance.itemId = _instance.itemId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: RefreshInheritanceRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.itemId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    RefreshInheritanceRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: RefreshInheritanceRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.itemId) {
      _writer.writeInt64String(1, _instance.itemId);
    }
  }

  private _itemId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of RefreshInheritanceRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<RefreshInheritanceRequest.AsObject>) {
    _value = _value || {};
    this.itemId = _value.itemId;
    RefreshInheritanceRequest.refineValues(this);
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    RefreshInheritanceRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): RefreshInheritanceRequest.AsObject {
    return {
      itemId: this.itemId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): RefreshInheritanceRequest.AsProtobufJSON {
    return {
      itemId: this.itemId
    };
  }
}
export module RefreshInheritanceRequest {
  /**
   * Standard JavaScript object representation for RefreshInheritanceRequest
   */
  export interface AsObject {
    itemId: string;
  }

  /**
   * Protobuf JSON representation for RefreshInheritanceRequest
   */
  export interface AsProtobufJSON {
    itemId: string;
  }
}

/**
 * Message implementation for goautowp.SetUserItemSubscriptionRequest
 */
export class SetUserItemSubscriptionRequest implements GrpcMessage {
  static id = 'goautowp.SetUserItemSubscriptionRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SetUserItemSubscriptionRequest();
    SetUserItemSubscriptionRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SetUserItemSubscriptionRequest) {
    _instance.itemId = _instance.itemId || '0';
    _instance.subscribed = _instance.subscribed || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SetUserItemSubscriptionRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.itemId = _reader.readInt64String();
          break;
        case 2:
          _instance.subscribed = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    SetUserItemSubscriptionRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SetUserItemSubscriptionRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.itemId) {
      _writer.writeInt64String(1, _instance.itemId);
    }
    if (_instance.subscribed) {
      _writer.writeBool(2, _instance.subscribed);
    }
  }

  private _itemId: string;
  private _subscribed: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SetUserItemSubscriptionRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<SetUserItemSubscriptionRequest.AsObject>
  ) {
    _value = _value || {};
    this.itemId = _value.itemId;
    this.subscribed = _value.subscribed;
    SetUserItemSubscriptionRequest.refineValues(this);
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get subscribed(): boolean {
    return this._subscribed;
  }
  set subscribed(value: boolean) {
    this._subscribed = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SetUserItemSubscriptionRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SetUserItemSubscriptionRequest.AsObject {
    return {
      itemId: this.itemId,
      subscribed: this.subscribed
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SetUserItemSubscriptionRequest.AsProtobufJSON {
    return {
      itemId: this.itemId,
      subscribed: this.subscribed
    };
  }
}
export module SetUserItemSubscriptionRequest {
  /**
   * Standard JavaScript object representation for SetUserItemSubscriptionRequest
   */
  export interface AsObject {
    itemId: string;
    subscribed: boolean;
  }

  /**
   * Protobuf JSON representation for SetUserItemSubscriptionRequest
   */
  export interface AsProtobufJSON {
    itemId: string;
    subscribed: boolean;
  }
}

/**
 * Message implementation for goautowp.PathRequest
 */
export class PathRequest implements GrpcMessage {
  static id = 'goautowp.PathRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PathRequest();
    PathRequest.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PathRequest) {
    _instance.catname = _instance.catname || '';
    _instance.path = _instance.path || '';
    _instance.language = _instance.language || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PathRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.catname = _reader.readString();
          break;
        case 2:
          _instance.path = _reader.readString();
          break;
        case 3:
          _instance.language = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    PathRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PathRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.catname) {
      _writer.writeString(1, _instance.catname);
    }
    if (_instance.path) {
      _writer.writeString(2, _instance.path);
    }
    if (_instance.language) {
      _writer.writeString(3, _instance.language);
    }
  }

  private _catname: string;
  private _path: string;
  private _language: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PathRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<PathRequest.AsObject>) {
    _value = _value || {};
    this.catname = _value.catname;
    this.path = _value.path;
    this.language = _value.language;
    PathRequest.refineValues(this);
  }
  get catname(): string {
    return this._catname;
  }
  set catname(value: string) {
    this._catname = value;
  }
  get path(): string {
    return this._path;
  }
  set path(value: string) {
    this._path = value;
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PathRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PathRequest.AsObject {
    return {
      catname: this.catname,
      path: this.path,
      language: this.language
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PathRequest.AsProtobufJSON {
    return {
      catname: this.catname,
      path: this.path,
      language: this.language
    };
  }
}
export module PathRequest {
  /**
   * Standard JavaScript object representation for PathRequest
   */
  export interface AsObject {
    catname: string;
    path: string;
    language: string;
  }

  /**
   * Protobuf JSON representation for PathRequest
   */
  export interface AsProtobufJSON {
    catname: string;
    path: string;
    language: string;
  }
}

/**
 * Message implementation for goautowp.PathResponse
 */
export class PathResponse implements GrpcMessage {
  static id = 'goautowp.PathResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PathResponse();
    PathResponse.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PathResponse) {
    _instance.path = _instance.path || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PathResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new PathItem();
          _reader.readMessage(
            messageInitializer1,
            PathItem.deserializeBinaryFromReader
          );
          (_instance.path = _instance.path || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    PathResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PathResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.path && _instance.path.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.path as any,
        PathItem.serializeBinaryToWriter
      );
    }
  }

  private _path?: PathItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PathResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<PathResponse.AsObject>) {
    _value = _value || {};
    this.path = (_value.path || []).map(m => new PathItem(m));
    PathResponse.refineValues(this);
  }
  get path(): PathItem[] | undefined {
    return this._path;
  }
  set path(value: PathItem[] | undefined) {
    this._path = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PathResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PathResponse.AsObject {
    return {
      path: (this.path || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PathResponse.AsProtobufJSON {
    return {
      path: (this.path || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module PathResponse {
  /**
   * Standard JavaScript object representation for PathResponse
   */
  export interface AsObject {
    path?: PathItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for PathResponse
   */
  export interface AsProtobufJSON {
    path: PathItem.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.AlphaResponse
 */
export class AlphaResponse implements GrpcMessage {
  static id = 'goautowp.AlphaResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AlphaResponse();
    AlphaResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AlphaResponse) {
    _instance.numbers = _instance.numbers || [];
    _instance.latin = _instance.latin || [];
    _instance.cyrillic = _instance.cyrillic || [];
    _instance.han = _instance.han || [];
    _instance.other = _instance.other || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AlphaResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          (_instance.numbers = _instance.numbers || []).push(
            _reader.readString()
          );
          break;
        case 2:
          (_instance.latin = _instance.latin || []).push(_reader.readString());
          break;
        case 3:
          (_instance.cyrillic = _instance.cyrillic || []).push(
            _reader.readString()
          );
          break;
        case 4:
          (_instance.han = _instance.han || []).push(_reader.readString());
          break;
        case 5:
          (_instance.other = _instance.other || []).push(_reader.readString());
          break;
        default:
          _reader.skipField();
      }
    }

    AlphaResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AlphaResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.numbers && _instance.numbers.length) {
      _writer.writeRepeatedString(1, _instance.numbers);
    }
    if (_instance.latin && _instance.latin.length) {
      _writer.writeRepeatedString(2, _instance.latin);
    }
    if (_instance.cyrillic && _instance.cyrillic.length) {
      _writer.writeRepeatedString(3, _instance.cyrillic);
    }
    if (_instance.han && _instance.han.length) {
      _writer.writeRepeatedString(4, _instance.han);
    }
    if (_instance.other && _instance.other.length) {
      _writer.writeRepeatedString(5, _instance.other);
    }
  }

  private _numbers: string[];
  private _latin: string[];
  private _cyrillic: string[];
  private _han: string[];
  private _other: string[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AlphaResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<AlphaResponse.AsObject>) {
    _value = _value || {};
    this.numbers = (_value.numbers || []).slice();
    this.latin = (_value.latin || []).slice();
    this.cyrillic = (_value.cyrillic || []).slice();
    this.han = (_value.han || []).slice();
    this.other = (_value.other || []).slice();
    AlphaResponse.refineValues(this);
  }
  get numbers(): string[] {
    return this._numbers;
  }
  set numbers(value: string[]) {
    this._numbers = value;
  }
  get latin(): string[] {
    return this._latin;
  }
  set latin(value: string[]) {
    this._latin = value;
  }
  get cyrillic(): string[] {
    return this._cyrillic;
  }
  set cyrillic(value: string[]) {
    this._cyrillic = value;
  }
  get han(): string[] {
    return this._han;
  }
  set han(value: string[]) {
    this._han = value;
  }
  get other(): string[] {
    return this._other;
  }
  set other(value: string[]) {
    this._other = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AlphaResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AlphaResponse.AsObject {
    return {
      numbers: (this.numbers || []).slice(),
      latin: (this.latin || []).slice(),
      cyrillic: (this.cyrillic || []).slice(),
      han: (this.han || []).slice(),
      other: (this.other || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AlphaResponse.AsProtobufJSON {
    return {
      numbers: (this.numbers || []).slice(),
      latin: (this.latin || []).slice(),
      cyrillic: (this.cyrillic || []).slice(),
      han: (this.han || []).slice(),
      other: (this.other || []).slice()
    };
  }
}
export module AlphaResponse {
  /**
   * Standard JavaScript object representation for AlphaResponse
   */
  export interface AsObject {
    numbers: string[];
    latin: string[];
    cyrillic: string[];
    han: string[];
    other: string[];
  }

  /**
   * Protobuf JSON representation for AlphaResponse
   */
  export interface AsProtobufJSON {
    numbers: string[];
    latin: string[];
    cyrillic: string[];
    han: string[];
    other: string[];
  }
}

/**
 * Message implementation for goautowp.PathItem
 */
export class PathItem implements GrpcMessage {
  static id = 'goautowp.PathItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PathItem();
    PathItem.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PathItem) {
    _instance.catname = _instance.catname || '';
    _instance.item = _instance.item || undefined;
    _instance.parentId = _instance.parentId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PathItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.catname = _reader.readString();
          break;
        case 2:
          _instance.item = new APIItem();
          _reader.readMessage(
            _instance.item,
            APIItem.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.parentId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    PathItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: PathItem, _writer: BinaryWriter) {
    if (_instance.catname) {
      _writer.writeString(1, _instance.catname);
    }
    if (_instance.item) {
      _writer.writeMessage(
        2,
        _instance.item as any,
        APIItem.serializeBinaryToWriter
      );
    }
    if (_instance.parentId) {
      _writer.writeInt64String(3, _instance.parentId);
    }
  }

  private _catname: string;
  private _item?: APIItem;
  private _parentId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PathItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<PathItem.AsObject>) {
    _value = _value || {};
    this.catname = _value.catname;
    this.item = _value.item ? new APIItem(_value.item) : undefined;
    this.parentId = _value.parentId;
    PathItem.refineValues(this);
  }
  get catname(): string {
    return this._catname;
  }
  set catname(value: string) {
    this._catname = value;
  }
  get item(): APIItem | undefined {
    return this._item;
  }
  set item(value: APIItem | undefined) {
    this._item = value;
  }
  get parentId(): string {
    return this._parentId;
  }
  set parentId(value: string) {
    this._parentId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PathItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PathItem.AsObject {
    return {
      catname: this.catname,
      item: this.item ? this.item.toObject() : undefined,
      parentId: this.parentId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PathItem.AsProtobufJSON {
    return {
      catname: this.catname,
      item: this.item ? this.item.toProtobufJSON(options) : null,
      parentId: this.parentId
    };
  }
}
export module PathItem {
  /**
   * Standard JavaScript object representation for PathItem
   */
  export interface AsObject {
    catname: string;
    item?: APIItem.AsObject;
    parentId: string;
  }

  /**
   * Protobuf JSON representation for PathItem
   */
  export interface AsProtobufJSON {
    catname: string;
    item: APIItem.AsProtobufJSON | null;
    parentId: string;
  }
}

/**
 * Message implementation for goautowp.MostsMenuRequest
 */
export class MostsMenuRequest implements GrpcMessage {
  static id = 'goautowp.MostsMenuRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new MostsMenuRequest();
    MostsMenuRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: MostsMenuRequest) {
    _instance.brandId = _instance.brandId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: MostsMenuRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.brandId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    MostsMenuRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: MostsMenuRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.brandId) {
      _writer.writeInt64String(1, _instance.brandId);
    }
  }

  private _brandId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of MostsMenuRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<MostsMenuRequest.AsObject>) {
    _value = _value || {};
    this.brandId = _value.brandId;
    MostsMenuRequest.refineValues(this);
  }
  get brandId(): string {
    return this._brandId;
  }
  set brandId(value: string) {
    this._brandId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    MostsMenuRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): MostsMenuRequest.AsObject {
    return {
      brandId: this.brandId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): MostsMenuRequest.AsProtobufJSON {
    return {
      brandId: this.brandId
    };
  }
}
export module MostsMenuRequest {
  /**
   * Standard JavaScript object representation for MostsMenuRequest
   */
  export interface AsObject {
    brandId: string;
  }

  /**
   * Protobuf JSON representation for MostsMenuRequest
   */
  export interface AsProtobufJSON {
    brandId: string;
  }
}

/**
 * Message implementation for goautowp.YearsRange
 */
export class YearsRange implements GrpcMessage {
  static id = 'goautowp.YearsRange';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new YearsRange();
    YearsRange.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: YearsRange) {
    _instance.name = _instance.name || '';
    _instance.catname = _instance.catname || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: YearsRange,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.name = _reader.readString();
          break;
        case 2:
          _instance.catname = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    YearsRange.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: YearsRange, _writer: BinaryWriter) {
    if (_instance.name) {
      _writer.writeString(1, _instance.name);
    }
    if (_instance.catname) {
      _writer.writeString(2, _instance.catname);
    }
  }

  private _name: string;
  private _catname: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of YearsRange to deeply clone from
   */
  constructor(_value?: RecursivePartial<YearsRange.AsObject>) {
    _value = _value || {};
    this.name = _value.name;
    this.catname = _value.catname;
    YearsRange.refineValues(this);
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get catname(): string {
    return this._catname;
  }
  set catname(value: string) {
    this._catname = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    YearsRange.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): YearsRange.AsObject {
    return {
      name: this.name,
      catname: this.catname
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): YearsRange.AsProtobufJSON {
    return {
      name: this.name,
      catname: this.catname
    };
  }
}
export module YearsRange {
  /**
   * Standard JavaScript object representation for YearsRange
   */
  export interface AsObject {
    name: string;
    catname: string;
  }

  /**
   * Protobuf JSON representation for YearsRange
   */
  export interface AsProtobufJSON {
    name: string;
    catname: string;
  }
}

/**
 * Message implementation for goautowp.MostsRating
 */
export class MostsRating implements GrpcMessage {
  static id = 'goautowp.MostsRating';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new MostsRating();
    MostsRating.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: MostsRating) {
    _instance.name = _instance.name || '';
    _instance.catname = _instance.catname || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: MostsRating,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.name = _reader.readString();
          break;
        case 2:
          _instance.catname = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    MostsRating.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: MostsRating,
    _writer: BinaryWriter
  ) {
    if (_instance.name) {
      _writer.writeString(1, _instance.name);
    }
    if (_instance.catname) {
      _writer.writeString(2, _instance.catname);
    }
  }

  private _name: string;
  private _catname: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of MostsRating to deeply clone from
   */
  constructor(_value?: RecursivePartial<MostsRating.AsObject>) {
    _value = _value || {};
    this.name = _value.name;
    this.catname = _value.catname;
    MostsRating.refineValues(this);
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get catname(): string {
    return this._catname;
  }
  set catname(value: string) {
    this._catname = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    MostsRating.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): MostsRating.AsObject {
    return {
      name: this.name,
      catname: this.catname
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): MostsRating.AsProtobufJSON {
    return {
      name: this.name,
      catname: this.catname
    };
  }
}
export module MostsRating {
  /**
   * Standard JavaScript object representation for MostsRating
   */
  export interface AsObject {
    name: string;
    catname: string;
  }

  /**
   * Protobuf JSON representation for MostsRating
   */
  export interface AsProtobufJSON {
    name: string;
    catname: string;
  }
}

/**
 * Message implementation for goautowp.MostsVehicleType
 */
export class MostsVehicleType implements GrpcMessage {
  static id = 'goautowp.MostsVehicleType';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new MostsVehicleType();
    MostsVehicleType.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: MostsVehicleType) {
    _instance.nameRp = _instance.nameRp || '';
    _instance.catname = _instance.catname || '';
    _instance.childs = _instance.childs || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: MostsVehicleType,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.nameRp = _reader.readString();
          break;
        case 2:
          _instance.catname = _reader.readString();
          break;
        case 3:
          const messageInitializer3 = new MostsVehicleType();
          _reader.readMessage(
            messageInitializer3,
            MostsVehicleType.deserializeBinaryFromReader
          );
          (_instance.childs = _instance.childs || []).push(messageInitializer3);
          break;
        default:
          _reader.skipField();
      }
    }

    MostsVehicleType.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: MostsVehicleType,
    _writer: BinaryWriter
  ) {
    if (_instance.nameRp) {
      _writer.writeString(1, _instance.nameRp);
    }
    if (_instance.catname) {
      _writer.writeString(2, _instance.catname);
    }
    if (_instance.childs && _instance.childs.length) {
      _writer.writeRepeatedMessage(
        3,
        _instance.childs as any,
        MostsVehicleType.serializeBinaryToWriter
      );
    }
  }

  private _nameRp: string;
  private _catname: string;
  private _childs?: MostsVehicleType[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of MostsVehicleType to deeply clone from
   */
  constructor(_value?: RecursivePartial<MostsVehicleType.AsObject>) {
    _value = _value || {};
    this.nameRp = _value.nameRp;
    this.catname = _value.catname;
    this.childs = (_value.childs || []).map(m => new MostsVehicleType(m));
    MostsVehicleType.refineValues(this);
  }
  get nameRp(): string {
    return this._nameRp;
  }
  set nameRp(value: string) {
    this._nameRp = value;
  }
  get catname(): string {
    return this._catname;
  }
  set catname(value: string) {
    this._catname = value;
  }
  get childs(): MostsVehicleType[] | undefined {
    return this._childs;
  }
  set childs(value: MostsVehicleType[] | undefined) {
    this._childs = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    MostsVehicleType.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): MostsVehicleType.AsObject {
    return {
      nameRp: this.nameRp,
      catname: this.catname,
      childs: (this.childs || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): MostsVehicleType.AsProtobufJSON {
    return {
      nameRp: this.nameRp,
      catname: this.catname,
      childs: (this.childs || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module MostsVehicleType {
  /**
   * Standard JavaScript object representation for MostsVehicleType
   */
  export interface AsObject {
    nameRp: string;
    catname: string;
    childs?: MostsVehicleType.AsObject[];
  }

  /**
   * Protobuf JSON representation for MostsVehicleType
   */
  export interface AsProtobufJSON {
    nameRp: string;
    catname: string;
    childs: MostsVehicleType.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.MostsMenu
 */
export class MostsMenu implements GrpcMessage {
  static id = 'goautowp.MostsMenu';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new MostsMenu();
    MostsMenu.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: MostsMenu) {
    _instance.years = _instance.years || [];
    _instance.ratings = _instance.ratings || [];
    _instance.vehicleTypes = _instance.vehicleTypes || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: MostsMenu,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new YearsRange();
          _reader.readMessage(
            messageInitializer1,
            YearsRange.deserializeBinaryFromReader
          );
          (_instance.years = _instance.years || []).push(messageInitializer1);
          break;
        case 2:
          const messageInitializer2 = new MostsRating();
          _reader.readMessage(
            messageInitializer2,
            MostsRating.deserializeBinaryFromReader
          );
          (_instance.ratings = _instance.ratings || []).push(
            messageInitializer2
          );
          break;
        case 3:
          const messageInitializer3 = new MostsVehicleType();
          _reader.readMessage(
            messageInitializer3,
            MostsVehicleType.deserializeBinaryFromReader
          );
          (_instance.vehicleTypes = _instance.vehicleTypes || []).push(
            messageInitializer3
          );
          break;
        default:
          _reader.skipField();
      }
    }

    MostsMenu.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: MostsMenu, _writer: BinaryWriter) {
    if (_instance.years && _instance.years.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.years as any,
        YearsRange.serializeBinaryToWriter
      );
    }
    if (_instance.ratings && _instance.ratings.length) {
      _writer.writeRepeatedMessage(
        2,
        _instance.ratings as any,
        MostsRating.serializeBinaryToWriter
      );
    }
    if (_instance.vehicleTypes && _instance.vehicleTypes.length) {
      _writer.writeRepeatedMessage(
        3,
        _instance.vehicleTypes as any,
        MostsVehicleType.serializeBinaryToWriter
      );
    }
  }

  private _years?: YearsRange[];
  private _ratings?: MostsRating[];
  private _vehicleTypes?: MostsVehicleType[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of MostsMenu to deeply clone from
   */
  constructor(_value?: RecursivePartial<MostsMenu.AsObject>) {
    _value = _value || {};
    this.years = (_value.years || []).map(m => new YearsRange(m));
    this.ratings = (_value.ratings || []).map(m => new MostsRating(m));
    this.vehicleTypes = (_value.vehicleTypes || []).map(
      m => new MostsVehicleType(m)
    );
    MostsMenu.refineValues(this);
  }
  get years(): YearsRange[] | undefined {
    return this._years;
  }
  set years(value: YearsRange[] | undefined) {
    this._years = value;
  }
  get ratings(): MostsRating[] | undefined {
    return this._ratings;
  }
  set ratings(value: MostsRating[] | undefined) {
    this._ratings = value;
  }
  get vehicleTypes(): MostsVehicleType[] | undefined {
    return this._vehicleTypes;
  }
  set vehicleTypes(value: MostsVehicleType[] | undefined) {
    this._vehicleTypes = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    MostsMenu.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): MostsMenu.AsObject {
    return {
      years: (this.years || []).map(m => m.toObject()),
      ratings: (this.ratings || []).map(m => m.toObject()),
      vehicleTypes: (this.vehicleTypes || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): MostsMenu.AsProtobufJSON {
    return {
      years: (this.years || []).map(m => m.toProtobufJSON(options)),
      ratings: (this.ratings || []).map(m => m.toProtobufJSON(options)),
      vehicleTypes: (this.vehicleTypes || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module MostsMenu {
  /**
   * Standard JavaScript object representation for MostsMenu
   */
  export interface AsObject {
    years?: YearsRange.AsObject[];
    ratings?: MostsRating.AsObject[];
    vehicleTypes?: MostsVehicleType.AsObject[];
  }

  /**
   * Protobuf JSON representation for MostsMenu
   */
  export interface AsProtobufJSON {
    years: YearsRange.AsProtobufJSON[] | null;
    ratings: MostsRating.AsProtobufJSON[] | null;
    vehicleTypes: MostsVehicleType.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.MostsItemsRequest
 */
export class MostsItemsRequest implements GrpcMessage {
  static id = 'goautowp.MostsItemsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new MostsItemsRequest();
    MostsItemsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: MostsItemsRequest) {
    _instance.language = _instance.language || '';
    _instance.yearsCatname = _instance.yearsCatname || '';
    _instance.typeCatname = _instance.typeCatname || '';
    _instance.ratingCatname = _instance.ratingCatname || '';
    _instance.brandId = _instance.brandId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: MostsItemsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.language = _reader.readString();
          break;
        case 2:
          _instance.yearsCatname = _reader.readString();
          break;
        case 3:
          _instance.typeCatname = _reader.readString();
          break;
        case 4:
          _instance.ratingCatname = _reader.readString();
          break;
        case 5:
          _instance.brandId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    MostsItemsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: MostsItemsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.language) {
      _writer.writeString(1, _instance.language);
    }
    if (_instance.yearsCatname) {
      _writer.writeString(2, _instance.yearsCatname);
    }
    if (_instance.typeCatname) {
      _writer.writeString(3, _instance.typeCatname);
    }
    if (_instance.ratingCatname) {
      _writer.writeString(4, _instance.ratingCatname);
    }
    if (_instance.brandId) {
      _writer.writeInt64String(5, _instance.brandId);
    }
  }

  private _language: string;
  private _yearsCatname: string;
  private _typeCatname: string;
  private _ratingCatname: string;
  private _brandId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of MostsItemsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<MostsItemsRequest.AsObject>) {
    _value = _value || {};
    this.language = _value.language;
    this.yearsCatname = _value.yearsCatname;
    this.typeCatname = _value.typeCatname;
    this.ratingCatname = _value.ratingCatname;
    this.brandId = _value.brandId;
    MostsItemsRequest.refineValues(this);
  }
  get language(): string {
    return this._language;
  }
  set language(value: string) {
    this._language = value;
  }
  get yearsCatname(): string {
    return this._yearsCatname;
  }
  set yearsCatname(value: string) {
    this._yearsCatname = value;
  }
  get typeCatname(): string {
    return this._typeCatname;
  }
  set typeCatname(value: string) {
    this._typeCatname = value;
  }
  get ratingCatname(): string {
    return this._ratingCatname;
  }
  set ratingCatname(value: string) {
    this._ratingCatname = value;
  }
  get brandId(): string {
    return this._brandId;
  }
  set brandId(value: string) {
    this._brandId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    MostsItemsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): MostsItemsRequest.AsObject {
    return {
      language: this.language,
      yearsCatname: this.yearsCatname,
      typeCatname: this.typeCatname,
      ratingCatname: this.ratingCatname,
      brandId: this.brandId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): MostsItemsRequest.AsProtobufJSON {
    return {
      language: this.language,
      yearsCatname: this.yearsCatname,
      typeCatname: this.typeCatname,
      ratingCatname: this.ratingCatname,
      brandId: this.brandId
    };
  }
}
export module MostsItemsRequest {
  /**
   * Standard JavaScript object representation for MostsItemsRequest
   */
  export interface AsObject {
    language: string;
    yearsCatname: string;
    typeCatname: string;
    ratingCatname: string;
    brandId: string;
  }

  /**
   * Protobuf JSON representation for MostsItemsRequest
   */
  export interface AsProtobufJSON {
    language: string;
    yearsCatname: string;
    typeCatname: string;
    ratingCatname: string;
    brandId: string;
  }
}

/**
 * Message implementation for goautowp.MostsItem
 */
export class MostsItem implements GrpcMessage {
  static id = 'goautowp.MostsItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new MostsItem();
    MostsItem.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: MostsItem) {
    _instance.item = _instance.item || undefined;
    _instance.valueHtml = _instance.valueHtml || '';
    _instance.unitId = _instance.unitId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: MostsItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.item = new APIItem();
          _reader.readMessage(
            _instance.item,
            APIItem.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.valueHtml = _reader.readString();
          break;
        case 3:
          _instance.unitId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    MostsItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: MostsItem, _writer: BinaryWriter) {
    if (_instance.item) {
      _writer.writeMessage(
        1,
        _instance.item as any,
        APIItem.serializeBinaryToWriter
      );
    }
    if (_instance.valueHtml) {
      _writer.writeString(2, _instance.valueHtml);
    }
    if (_instance.unitId) {
      _writer.writeInt64String(3, _instance.unitId);
    }
  }

  private _item?: APIItem;
  private _valueHtml: string;
  private _unitId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of MostsItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<MostsItem.AsObject>) {
    _value = _value || {};
    this.item = _value.item ? new APIItem(_value.item) : undefined;
    this.valueHtml = _value.valueHtml;
    this.unitId = _value.unitId;
    MostsItem.refineValues(this);
  }
  get item(): APIItem | undefined {
    return this._item;
  }
  set item(value: APIItem | undefined) {
    this._item = value;
  }
  get valueHtml(): string {
    return this._valueHtml;
  }
  set valueHtml(value: string) {
    this._valueHtml = value;
  }
  get unitId(): string {
    return this._unitId;
  }
  set unitId(value: string) {
    this._unitId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    MostsItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): MostsItem.AsObject {
    return {
      item: this.item ? this.item.toObject() : undefined,
      valueHtml: this.valueHtml,
      unitId: this.unitId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): MostsItem.AsProtobufJSON {
    return {
      item: this.item ? this.item.toProtobufJSON(options) : null,
      valueHtml: this.valueHtml,
      unitId: this.unitId
    };
  }
}
export module MostsItem {
  /**
   * Standard JavaScript object representation for MostsItem
   */
  export interface AsObject {
    item?: APIItem.AsObject;
    valueHtml: string;
    unitId: string;
  }

  /**
   * Protobuf JSON representation for MostsItem
   */
  export interface AsProtobufJSON {
    item: APIItem.AsProtobufJSON | null;
    valueHtml: string;
    unitId: string;
  }
}

/**
 * Message implementation for goautowp.MostsItems
 */
export class MostsItems implements GrpcMessage {
  static id = 'goautowp.MostsItems';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new MostsItems();
    MostsItems.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: MostsItems) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: MostsItems,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new MostsItem();
          _reader.readMessage(
            messageInitializer1,
            MostsItem.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    MostsItems.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: MostsItems, _writer: BinaryWriter) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        MostsItem.serializeBinaryToWriter
      );
    }
  }

  private _items?: MostsItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of MostsItems to deeply clone from
   */
  constructor(_value?: RecursivePartial<MostsItems.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new MostsItem(m));
    MostsItems.refineValues(this);
  }
  get items(): MostsItem[] | undefined {
    return this._items;
  }
  set items(value: MostsItem[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    MostsItems.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): MostsItems.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): MostsItems.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module MostsItems {
  /**
   * Standard JavaScript object representation for MostsItems
   */
  export interface AsObject {
    items?: MostsItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for MostsItems
   */
  export interface AsProtobufJSON {
    items: MostsItem.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for goautowp.AddCommentRequest
 */
export class AddCommentRequest implements GrpcMessage {
  static id = 'goautowp.AddCommentRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AddCommentRequest();
    AddCommentRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AddCommentRequest) {
    _instance.itemId = _instance.itemId || '0';
    _instance.typeId = _instance.typeId || 0;
    _instance.message = _instance.message || '';
    _instance.moderatorAttention = _instance.moderatorAttention || false;
    _instance.parentId = _instance.parentId || '0';
    _instance.resolve = _instance.resolve || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AddCommentRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.itemId = _reader.readInt64String();
          break;
        case 2:
          _instance.typeId = _reader.readEnum();
          break;
        case 3:
          _instance.message = _reader.readString();
          break;
        case 4:
          _instance.moderatorAttention = _reader.readBool();
          break;
        case 5:
          _instance.parentId = _reader.readInt64String();
          break;
        case 6:
          _instance.resolve = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    AddCommentRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AddCommentRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.itemId) {
      _writer.writeInt64String(1, _instance.itemId);
    }
    if (_instance.typeId) {
      _writer.writeEnum(2, _instance.typeId);
    }
    if (_instance.message) {
      _writer.writeString(3, _instance.message);
    }
    if (_instance.moderatorAttention) {
      _writer.writeBool(4, _instance.moderatorAttention);
    }
    if (_instance.parentId) {
      _writer.writeInt64String(5, _instance.parentId);
    }
    if (_instance.resolve) {
      _writer.writeBool(6, _instance.resolve);
    }
  }

  private _itemId: string;
  private _typeId: CommentsType;
  private _message: string;
  private _moderatorAttention: boolean;
  private _parentId: string;
  private _resolve: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AddCommentRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<AddCommentRequest.AsObject>) {
    _value = _value || {};
    this.itemId = _value.itemId;
    this.typeId = _value.typeId;
    this.message = _value.message;
    this.moderatorAttention = _value.moderatorAttention;
    this.parentId = _value.parentId;
    this.resolve = _value.resolve;
    AddCommentRequest.refineValues(this);
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get typeId(): CommentsType {
    return this._typeId;
  }
  set typeId(value: CommentsType) {
    this._typeId = value;
  }
  get message(): string {
    return this._message;
  }
  set message(value: string) {
    this._message = value;
  }
  get moderatorAttention(): boolean {
    return this._moderatorAttention;
  }
  set moderatorAttention(value: boolean) {
    this._moderatorAttention = value;
  }
  get parentId(): string {
    return this._parentId;
  }
  set parentId(value: string) {
    this._parentId = value;
  }
  get resolve(): boolean {
    return this._resolve;
  }
  set resolve(value: boolean) {
    this._resolve = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AddCommentRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AddCommentRequest.AsObject {
    return {
      itemId: this.itemId,
      typeId: this.typeId,
      message: this.message,
      moderatorAttention: this.moderatorAttention,
      parentId: this.parentId,
      resolve: this.resolve
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AddCommentRequest.AsProtobufJSON {
    return {
      itemId: this.itemId,
      typeId:
        CommentsType[
          this.typeId === null || this.typeId === undefined ? 0 : this.typeId
        ],
      message: this.message,
      moderatorAttention: this.moderatorAttention,
      parentId: this.parentId,
      resolve: this.resolve
    };
  }
}
export module AddCommentRequest {
  /**
   * Standard JavaScript object representation for AddCommentRequest
   */
  export interface AsObject {
    itemId: string;
    typeId: CommentsType;
    message: string;
    moderatorAttention: boolean;
    parentId: string;
    resolve: boolean;
  }

  /**
   * Protobuf JSON representation for AddCommentRequest
   */
  export interface AsProtobufJSON {
    itemId: string;
    typeId: string;
    message: string;
    moderatorAttention: boolean;
    parentId: string;
    resolve: boolean;
  }
}

/**
 * Message implementation for goautowp.GetMessagePageRequest
 */
export class GetMessagePageRequest implements GrpcMessage {
  static id = 'goautowp.GetMessagePageRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetMessagePageRequest();
    GetMessagePageRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetMessagePageRequest) {
    _instance.messageId = _instance.messageId || '0';
    _instance.perPage = _instance.perPage || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetMessagePageRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.messageId = _reader.readInt64String();
          break;
        case 2:
          _instance.perPage = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    GetMessagePageRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetMessagePageRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.messageId) {
      _writer.writeInt64String(1, _instance.messageId);
    }
    if (_instance.perPage) {
      _writer.writeInt32(2, _instance.perPage);
    }
  }

  private _messageId: string;
  private _perPage: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetMessagePageRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetMessagePageRequest.AsObject>) {
    _value = _value || {};
    this.messageId = _value.messageId;
    this.perPage = _value.perPage;
    GetMessagePageRequest.refineValues(this);
  }
  get messageId(): string {
    return this._messageId;
  }
  set messageId(value: string) {
    this._messageId = value;
  }
  get perPage(): number {
    return this._perPage;
  }
  set perPage(value: number) {
    this._perPage = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetMessagePageRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetMessagePageRequest.AsObject {
    return {
      messageId: this.messageId,
      perPage: this.perPage
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetMessagePageRequest.AsProtobufJSON {
    return {
      messageId: this.messageId,
      perPage: this.perPage
    };
  }
}
export module GetMessagePageRequest {
  /**
   * Standard JavaScript object representation for GetMessagePageRequest
   */
  export interface AsObject {
    messageId: string;
    perPage: number;
  }

  /**
   * Protobuf JSON representation for GetMessagePageRequest
   */
  export interface AsProtobufJSON {
    messageId: string;
    perPage: number;
  }
}

/**
 * Message implementation for goautowp.CommentMessageFields
 */
export class CommentMessageFields implements GrpcMessage {
  static id = 'goautowp.CommentMessageFields';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CommentMessageFields();
    CommentMessageFields.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CommentMessageFields) {
    _instance.preview = _instance.preview || false;
    _instance.route = _instance.route || false;
    _instance.text = _instance.text || false;
    _instance.vote = _instance.vote || false;
    _instance.userVote = _instance.userVote || false;
    _instance.replies = _instance.replies || false;
    _instance.status = _instance.status || false;
    _instance.isNew = _instance.isNew || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CommentMessageFields,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.preview = _reader.readBool();
          break;
        case 2:
          _instance.route = _reader.readBool();
          break;
        case 3:
          _instance.text = _reader.readBool();
          break;
        case 4:
          _instance.vote = _reader.readBool();
          break;
        case 5:
          _instance.userVote = _reader.readBool();
          break;
        case 6:
          _instance.replies = _reader.readBool();
          break;
        case 7:
          _instance.status = _reader.readBool();
          break;
        case 8:
          _instance.isNew = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    CommentMessageFields.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CommentMessageFields,
    _writer: BinaryWriter
  ) {
    if (_instance.preview) {
      _writer.writeBool(1, _instance.preview);
    }
    if (_instance.route) {
      _writer.writeBool(2, _instance.route);
    }
    if (_instance.text) {
      _writer.writeBool(3, _instance.text);
    }
    if (_instance.vote) {
      _writer.writeBool(4, _instance.vote);
    }
    if (_instance.userVote) {
      _writer.writeBool(5, _instance.userVote);
    }
    if (_instance.replies) {
      _writer.writeBool(6, _instance.replies);
    }
    if (_instance.status) {
      _writer.writeBool(7, _instance.status);
    }
    if (_instance.isNew) {
      _writer.writeBool(8, _instance.isNew);
    }
  }

  private _preview: boolean;
  private _route: boolean;
  private _text: boolean;
  private _vote: boolean;
  private _userVote: boolean;
  private _replies: boolean;
  private _status: boolean;
  private _isNew: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CommentMessageFields to deeply clone from
   */
  constructor(_value?: RecursivePartial<CommentMessageFields.AsObject>) {
    _value = _value || {};
    this.preview = _value.preview;
    this.route = _value.route;
    this.text = _value.text;
    this.vote = _value.vote;
    this.userVote = _value.userVote;
    this.replies = _value.replies;
    this.status = _value.status;
    this.isNew = _value.isNew;
    CommentMessageFields.refineValues(this);
  }
  get preview(): boolean {
    return this._preview;
  }
  set preview(value: boolean) {
    this._preview = value;
  }
  get route(): boolean {
    return this._route;
  }
  set route(value: boolean) {
    this._route = value;
  }
  get text(): boolean {
    return this._text;
  }
  set text(value: boolean) {
    this._text = value;
  }
  get vote(): boolean {
    return this._vote;
  }
  set vote(value: boolean) {
    this._vote = value;
  }
  get userVote(): boolean {
    return this._userVote;
  }
  set userVote(value: boolean) {
    this._userVote = value;
  }
  get replies(): boolean {
    return this._replies;
  }
  set replies(value: boolean) {
    this._replies = value;
  }
  get status(): boolean {
    return this._status;
  }
  set status(value: boolean) {
    this._status = value;
  }
  get isNew(): boolean {
    return this._isNew;
  }
  set isNew(value: boolean) {
    this._isNew = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CommentMessageFields.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CommentMessageFields.AsObject {
    return {
      preview: this.preview,
      route: this.route,
      text: this.text,
      vote: this.vote,
      userVote: this.userVote,
      replies: this.replies,
      status: this.status,
      isNew: this.isNew
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CommentMessageFields.AsProtobufJSON {
    return {
      preview: this.preview,
      route: this.route,
      text: this.text,
      vote: this.vote,
      userVote: this.userVote,
      replies: this.replies,
      status: this.status,
      isNew: this.isNew
    };
  }
}
export module CommentMessageFields {
  /**
   * Standard JavaScript object representation for CommentMessageFields
   */
  export interface AsObject {
    preview: boolean;
    route: boolean;
    text: boolean;
    vote: boolean;
    userVote: boolean;
    replies: boolean;
    status: boolean;
    isNew: boolean;
  }

  /**
   * Protobuf JSON representation for CommentMessageFields
   */
  export interface AsProtobufJSON {
    preview: boolean;
    route: boolean;
    text: boolean;
    vote: boolean;
    userVote: boolean;
    replies: boolean;
    status: boolean;
    isNew: boolean;
  }
}

/**
 * Message implementation for goautowp.GetMessageRequest
 */
export class GetMessageRequest implements GrpcMessage {
  static id = 'goautowp.GetMessageRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetMessageRequest();
    GetMessageRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetMessageRequest) {
    _instance.id = _instance.id || '0';
    _instance.fields = _instance.fields || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetMessageRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.fields = new CommentMessageFields();
          _reader.readMessage(
            _instance.fields,
            CommentMessageFields.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    GetMessageRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetMessageRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.fields) {
      _writer.writeMessage(
        2,
        _instance.fields as any,
        CommentMessageFields.serializeBinaryToWriter
      );
    }
  }

  private _id: string;
  private _fields?: CommentMessageFields;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetMessageRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetMessageRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.fields = _value.fields
      ? new CommentMessageFields(_value.fields)
      : undefined;
    GetMessageRequest.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get fields(): CommentMessageFields | undefined {
    return this._fields;
  }
  set fields(value: CommentMessageFields | undefined) {
    this._fields = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetMessageRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetMessageRequest.AsObject {
    return {
      id: this.id,
      fields: this.fields ? this.fields.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetMessageRequest.AsProtobufJSON {
    return {
      id: this.id,
      fields: this.fields ? this.fields.toProtobufJSON(options) : null
    };
  }
}
export module GetMessageRequest {
  /**
   * Standard JavaScript object representation for GetMessageRequest
   */
  export interface AsObject {
    id: string;
    fields?: CommentMessageFields.AsObject;
  }

  /**
   * Protobuf JSON representation for GetMessageRequest
   */
  export interface AsProtobufJSON {
    id: string;
    fields: CommentMessageFields.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.GetMessagesRequest
 */
export class GetMessagesRequest implements GrpcMessage {
  static id = 'goautowp.GetMessagesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetMessagesRequest();
    GetMessagesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetMessagesRequest) {
    _instance.fields = _instance.fields || undefined;
    _instance.itemId = _instance.itemId || '0';
    _instance.typeId = _instance.typeId || 0;
    _instance.parentId = _instance.parentId || '0';
    _instance.noParents = _instance.noParents || false;
    _instance.userId = _instance.userId || '0';
    _instance.order = _instance.order || 0;
    _instance.userIdentity = _instance.userIdentity || '';
    _instance.moderatorAttention = _instance.moderatorAttention || 0;
    _instance.picturesOfItemId = _instance.picturesOfItemId || '0';
    _instance.limit = _instance.limit || 0;
    _instance.page = _instance.page || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetMessagesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.fields = new CommentMessageFields();
          _reader.readMessage(
            _instance.fields,
            CommentMessageFields.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.itemId = _reader.readInt64String();
          break;
        case 3:
          _instance.typeId = _reader.readEnum();
          break;
        case 4:
          _instance.parentId = _reader.readInt64String();
          break;
        case 5:
          _instance.noParents = _reader.readBool();
          break;
        case 6:
          _instance.userId = _reader.readInt64String();
          break;
        case 7:
          _instance.order = _reader.readEnum();
          break;
        case 8:
          _instance.userIdentity = _reader.readString();
          break;
        case 9:
          _instance.moderatorAttention = _reader.readEnum();
          break;
        case 10:
          _instance.picturesOfItemId = _reader.readInt64String();
          break;
        case 11:
          _instance.limit = _reader.readInt32();
          break;
        case 12:
          _instance.page = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    GetMessagesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetMessagesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.fields) {
      _writer.writeMessage(
        1,
        _instance.fields as any,
        CommentMessageFields.serializeBinaryToWriter
      );
    }
    if (_instance.itemId) {
      _writer.writeInt64String(2, _instance.itemId);
    }
    if (_instance.typeId) {
      _writer.writeEnum(3, _instance.typeId);
    }
    if (_instance.parentId) {
      _writer.writeInt64String(4, _instance.parentId);
    }
    if (_instance.noParents) {
      _writer.writeBool(5, _instance.noParents);
    }
    if (_instance.userId) {
      _writer.writeInt64String(6, _instance.userId);
    }
    if (_instance.order) {
      _writer.writeEnum(7, _instance.order);
    }
    if (_instance.userIdentity) {
      _writer.writeString(8, _instance.userIdentity);
    }
    if (_instance.moderatorAttention) {
      _writer.writeEnum(9, _instance.moderatorAttention);
    }
    if (_instance.picturesOfItemId) {
      _writer.writeInt64String(10, _instance.picturesOfItemId);
    }
    if (_instance.limit) {
      _writer.writeInt32(11, _instance.limit);
    }
    if (_instance.page) {
      _writer.writeInt32(12, _instance.page);
    }
  }

  private _fields?: CommentMessageFields;
  private _itemId: string;
  private _typeId: CommentsType;
  private _parentId: string;
  private _noParents: boolean;
  private _userId: string;
  private _order: GetMessagesRequest.Order;
  private _userIdentity: string;
  private _moderatorAttention: ModeratorAttention;
  private _picturesOfItemId: string;
  private _limit: number;
  private _page: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetMessagesRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetMessagesRequest.AsObject>) {
    _value = _value || {};
    this.fields = _value.fields
      ? new CommentMessageFields(_value.fields)
      : undefined;
    this.itemId = _value.itemId;
    this.typeId = _value.typeId;
    this.parentId = _value.parentId;
    this.noParents = _value.noParents;
    this.userId = _value.userId;
    this.order = _value.order;
    this.userIdentity = _value.userIdentity;
    this.moderatorAttention = _value.moderatorAttention;
    this.picturesOfItemId = _value.picturesOfItemId;
    this.limit = _value.limit;
    this.page = _value.page;
    GetMessagesRequest.refineValues(this);
  }
  get fields(): CommentMessageFields | undefined {
    return this._fields;
  }
  set fields(value: CommentMessageFields | undefined) {
    this._fields = value;
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get typeId(): CommentsType {
    return this._typeId;
  }
  set typeId(value: CommentsType) {
    this._typeId = value;
  }
  get parentId(): string {
    return this._parentId;
  }
  set parentId(value: string) {
    this._parentId = value;
  }
  get noParents(): boolean {
    return this._noParents;
  }
  set noParents(value: boolean) {
    this._noParents = value;
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }
  get order(): GetMessagesRequest.Order {
    return this._order;
  }
  set order(value: GetMessagesRequest.Order) {
    this._order = value;
  }
  get userIdentity(): string {
    return this._userIdentity;
  }
  set userIdentity(value: string) {
    this._userIdentity = value;
  }
  get moderatorAttention(): ModeratorAttention {
    return this._moderatorAttention;
  }
  set moderatorAttention(value: ModeratorAttention) {
    this._moderatorAttention = value;
  }
  get picturesOfItemId(): string {
    return this._picturesOfItemId;
  }
  set picturesOfItemId(value: string) {
    this._picturesOfItemId = value;
  }
  get limit(): number {
    return this._limit;
  }
  set limit(value: number) {
    this._limit = value;
  }
  get page(): number {
    return this._page;
  }
  set page(value: number) {
    this._page = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetMessagesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetMessagesRequest.AsObject {
    return {
      fields: this.fields ? this.fields.toObject() : undefined,
      itemId: this.itemId,
      typeId: this.typeId,
      parentId: this.parentId,
      noParents: this.noParents,
      userId: this.userId,
      order: this.order,
      userIdentity: this.userIdentity,
      moderatorAttention: this.moderatorAttention,
      picturesOfItemId: this.picturesOfItemId,
      limit: this.limit,
      page: this.page
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetMessagesRequest.AsProtobufJSON {
    return {
      fields: this.fields ? this.fields.toProtobufJSON(options) : null,
      itemId: this.itemId,
      typeId:
        CommentsType[
          this.typeId === null || this.typeId === undefined ? 0 : this.typeId
        ],
      parentId: this.parentId,
      noParents: this.noParents,
      userId: this.userId,
      order:
        GetMessagesRequest.Order[
          this.order === null || this.order === undefined ? 0 : this.order
        ],
      userIdentity: this.userIdentity,
      moderatorAttention:
        ModeratorAttention[
          this.moderatorAttention === null ||
          this.moderatorAttention === undefined
            ? 0
            : this.moderatorAttention
        ],
      picturesOfItemId: this.picturesOfItemId,
      limit: this.limit,
      page: this.page
    };
  }
}
export module GetMessagesRequest {
  /**
   * Standard JavaScript object representation for GetMessagesRequest
   */
  export interface AsObject {
    fields?: CommentMessageFields.AsObject;
    itemId: string;
    typeId: CommentsType;
    parentId: string;
    noParents: boolean;
    userId: string;
    order: GetMessagesRequest.Order;
    userIdentity: string;
    moderatorAttention: ModeratorAttention;
    picturesOfItemId: string;
    limit: number;
    page: number;
  }

  /**
   * Protobuf JSON representation for GetMessagesRequest
   */
  export interface AsProtobufJSON {
    fields: CommentMessageFields.AsProtobufJSON | null;
    itemId: string;
    typeId: string;
    parentId: string;
    noParents: boolean;
    userId: string;
    order: string;
    userIdentity: string;
    moderatorAttention: string;
    picturesOfItemId: string;
    limit: number;
    page: number;
  }
  export enum Order {
    DEFAULT = 0,
    VOTE_DESC = 1,
    VOTE_ASC = 2,
    DATE_DESC = 3,
    DATE_ASC = 4
  }
}

/**
 * Message implementation for goautowp.APICommentsMessagePage
 */
export class APICommentsMessagePage implements GrpcMessage {
  static id = 'goautowp.APICommentsMessagePage';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APICommentsMessagePage();
    APICommentsMessagePage.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APICommentsMessagePage) {
    _instance.typeId = _instance.typeId || 0;
    _instance.itemId = _instance.itemId || '0';
    _instance.page = _instance.page || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APICommentsMessagePage,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.typeId = _reader.readEnum();
          break;
        case 2:
          _instance.itemId = _reader.readInt64String();
          break;
        case 3:
          _instance.page = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    APICommentsMessagePage.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APICommentsMessagePage,
    _writer: BinaryWriter
  ) {
    if (_instance.typeId) {
      _writer.writeEnum(1, _instance.typeId);
    }
    if (_instance.itemId) {
      _writer.writeInt64String(2, _instance.itemId);
    }
    if (_instance.page) {
      _writer.writeInt32(3, _instance.page);
    }
  }

  private _typeId: CommentsType;
  private _itemId: string;
  private _page: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APICommentsMessagePage to deeply clone from
   */
  constructor(_value?: RecursivePartial<APICommentsMessagePage.AsObject>) {
    _value = _value || {};
    this.typeId = _value.typeId;
    this.itemId = _value.itemId;
    this.page = _value.page;
    APICommentsMessagePage.refineValues(this);
  }
  get typeId(): CommentsType {
    return this._typeId;
  }
  set typeId(value: CommentsType) {
    this._typeId = value;
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get page(): number {
    return this._page;
  }
  set page(value: number) {
    this._page = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APICommentsMessagePage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APICommentsMessagePage.AsObject {
    return {
      typeId: this.typeId,
      itemId: this.itemId,
      page: this.page
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APICommentsMessagePage.AsProtobufJSON {
    return {
      typeId:
        CommentsType[
          this.typeId === null || this.typeId === undefined ? 0 : this.typeId
        ],
      itemId: this.itemId,
      page: this.page
    };
  }
}
export module APICommentsMessagePage {
  /**
   * Standard JavaScript object representation for APICommentsMessagePage
   */
  export interface AsObject {
    typeId: CommentsType;
    itemId: string;
    page: number;
  }

  /**
   * Protobuf JSON representation for APICommentsMessagePage
   */
  export interface AsProtobufJSON {
    typeId: string;
    itemId: string;
    page: number;
  }
}

/**
 * Message implementation for goautowp.APICommentsMessages
 */
export class APICommentsMessages implements GrpcMessage {
  static id = 'goautowp.APICommentsMessages';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APICommentsMessages();
    APICommentsMessages.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APICommentsMessages) {
    _instance.items = _instance.items || [];
    _instance.paginator = _instance.paginator || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APICommentsMessages,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new APICommentsMessage();
          _reader.readMessage(
            messageInitializer1,
            APICommentsMessage.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        case 2:
          _instance.paginator = new Pages();
          _reader.readMessage(
            _instance.paginator,
            Pages.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    APICommentsMessages.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APICommentsMessages,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        APICommentsMessage.serializeBinaryToWriter
      );
    }
    if (_instance.paginator) {
      _writer.writeMessage(
        2,
        _instance.paginator as any,
        Pages.serializeBinaryToWriter
      );
    }
  }

  private _items?: APICommentsMessage[];
  private _paginator?: Pages;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APICommentsMessages to deeply clone from
   */
  constructor(_value?: RecursivePartial<APICommentsMessages.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(m => new APICommentsMessage(m));
    this.paginator = _value.paginator ? new Pages(_value.paginator) : undefined;
    APICommentsMessages.refineValues(this);
  }
  get items(): APICommentsMessage[] | undefined {
    return this._items;
  }
  set items(value: APICommentsMessage[] | undefined) {
    this._items = value;
  }
  get paginator(): Pages | undefined {
    return this._paginator;
  }
  set paginator(value: Pages | undefined) {
    this._paginator = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APICommentsMessages.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APICommentsMessages.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject()),
      paginator: this.paginator ? this.paginator.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APICommentsMessages.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options)),
      paginator: this.paginator ? this.paginator.toProtobufJSON(options) : null
    };
  }
}
export module APICommentsMessages {
  /**
   * Standard JavaScript object representation for APICommentsMessages
   */
  export interface AsObject {
    items?: APICommentsMessage.AsObject[];
    paginator?: Pages.AsObject;
  }

  /**
   * Protobuf JSON representation for APICommentsMessages
   */
  export interface AsProtobufJSON {
    items: APICommentsMessage.AsProtobufJSON[] | null;
    paginator: Pages.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for goautowp.APICommentsMessage
 */
export class APICommentsMessage implements GrpcMessage {
  static id = 'goautowp.APICommentsMessage';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APICommentsMessage();
    APICommentsMessage.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APICommentsMessage) {
    _instance.id = _instance.id || '0';
    _instance.typeId = _instance.typeId || 0;
    _instance.itemId = _instance.itemId || '0';
    _instance.parentId = _instance.parentId || '0';
    _instance.createdAt = _instance.createdAt || undefined;
    _instance.deleted = _instance.deleted || false;
    _instance.moderatorAttention = _instance.moderatorAttention || 0;
    _instance.isNew = _instance.isNew || false;
    _instance.authorId = _instance.authorId || '0';
    _instance.ip = _instance.ip || '';
    _instance.text = _instance.text || '';
    _instance.vote = _instance.vote || 0;
    _instance.preview = _instance.preview || '';
    _instance.route = _instance.route || [];
    _instance.userVote = _instance.userVote || 0;
    _instance.replies = _instance.replies || [];
    _instance.pictureStatus = _instance.pictureStatus || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APICommentsMessage,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.typeId = _reader.readEnum();
          break;
        case 3:
          _instance.itemId = _reader.readInt64String();
          break;
        case 4:
          _instance.parentId = _reader.readInt64String();
          break;
        case 5:
          _instance.createdAt = new googleProtobuf006.Timestamp();
          _reader.readMessage(
            _instance.createdAt,
            googleProtobuf006.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 6:
          _instance.deleted = _reader.readBool();
          break;
        case 7:
          _instance.moderatorAttention = _reader.readEnum();
          break;
        case 8:
          _instance.isNew = _reader.readBool();
          break;
        case 9:
          _instance.authorId = _reader.readInt64String();
          break;
        case 10:
          _instance.ip = _reader.readString();
          break;
        case 11:
          _instance.text = _reader.readString();
          break;
        case 12:
          _instance.vote = _reader.readInt32();
          break;
        case 13:
          _instance.preview = _reader.readString();
          break;
        case 14:
          (_instance.route = _instance.route || []).push(_reader.readString());
          break;
        case 15:
          _instance.userVote = _reader.readInt32();
          break;
        case 16:
          const messageInitializer16 = new APICommentsMessage();
          _reader.readMessage(
            messageInitializer16,
            APICommentsMessage.deserializeBinaryFromReader
          );
          (_instance.replies = _instance.replies || []).push(
            messageInitializer16
          );
          break;
        case 17:
          _instance.pictureStatus = _reader.readEnum();
          break;
        default:
          _reader.skipField();
      }
    }

    APICommentsMessage.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APICommentsMessage,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.typeId) {
      _writer.writeEnum(2, _instance.typeId);
    }
    if (_instance.itemId) {
      _writer.writeInt64String(3, _instance.itemId);
    }
    if (_instance.parentId) {
      _writer.writeInt64String(4, _instance.parentId);
    }
    if (_instance.createdAt) {
      _writer.writeMessage(
        5,
        _instance.createdAt as any,
        googleProtobuf006.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.deleted) {
      _writer.writeBool(6, _instance.deleted);
    }
    if (_instance.moderatorAttention) {
      _writer.writeEnum(7, _instance.moderatorAttention);
    }
    if (_instance.isNew) {
      _writer.writeBool(8, _instance.isNew);
    }
    if (_instance.authorId) {
      _writer.writeInt64String(9, _instance.authorId);
    }
    if (_instance.ip) {
      _writer.writeString(10, _instance.ip);
    }
    if (_instance.text) {
      _writer.writeString(11, _instance.text);
    }
    if (_instance.vote) {
      _writer.writeInt32(12, _instance.vote);
    }
    if (_instance.preview) {
      _writer.writeString(13, _instance.preview);
    }
    if (_instance.route && _instance.route.length) {
      _writer.writeRepeatedString(14, _instance.route);
    }
    if (_instance.userVote) {
      _writer.writeInt32(15, _instance.userVote);
    }
    if (_instance.replies && _instance.replies.length) {
      _writer.writeRepeatedMessage(
        16,
        _instance.replies as any,
        APICommentsMessage.serializeBinaryToWriter
      );
    }
    if (_instance.pictureStatus) {
      _writer.writeEnum(17, _instance.pictureStatus);
    }
  }

  private _id: string;
  private _typeId: CommentsType;
  private _itemId: string;
  private _parentId: string;
  private _createdAt?: googleProtobuf006.Timestamp;
  private _deleted: boolean;
  private _moderatorAttention: ModeratorAttention;
  private _isNew: boolean;
  private _authorId: string;
  private _ip: string;
  private _text: string;
  private _vote: number;
  private _preview: string;
  private _route: string[];
  private _userVote: number;
  private _replies?: APICommentsMessage[];
  private _pictureStatus: PictureStatus;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APICommentsMessage to deeply clone from
   */
  constructor(_value?: RecursivePartial<APICommentsMessage.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.typeId = _value.typeId;
    this.itemId = _value.itemId;
    this.parentId = _value.parentId;
    this.createdAt = _value.createdAt
      ? new googleProtobuf006.Timestamp(_value.createdAt)
      : undefined;
    this.deleted = _value.deleted;
    this.moderatorAttention = _value.moderatorAttention;
    this.isNew = _value.isNew;
    this.authorId = _value.authorId;
    this.ip = _value.ip;
    this.text = _value.text;
    this.vote = _value.vote;
    this.preview = _value.preview;
    this.route = (_value.route || []).slice();
    this.userVote = _value.userVote;
    this.replies = (_value.replies || []).map(m => new APICommentsMessage(m));
    this.pictureStatus = _value.pictureStatus;
    APICommentsMessage.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get typeId(): CommentsType {
    return this._typeId;
  }
  set typeId(value: CommentsType) {
    this._typeId = value;
  }
  get itemId(): string {
    return this._itemId;
  }
  set itemId(value: string) {
    this._itemId = value;
  }
  get parentId(): string {
    return this._parentId;
  }
  set parentId(value: string) {
    this._parentId = value;
  }
  get createdAt(): googleProtobuf006.Timestamp | undefined {
    return this._createdAt;
  }
  set createdAt(value: googleProtobuf006.Timestamp | undefined) {
    this._createdAt = value;
  }
  get deleted(): boolean {
    return this._deleted;
  }
  set deleted(value: boolean) {
    this._deleted = value;
  }
  get moderatorAttention(): ModeratorAttention {
    return this._moderatorAttention;
  }
  set moderatorAttention(value: ModeratorAttention) {
    this._moderatorAttention = value;
  }
  get isNew(): boolean {
    return this._isNew;
  }
  set isNew(value: boolean) {
    this._isNew = value;
  }
  get authorId(): string {
    return this._authorId;
  }
  set authorId(value: string) {
    this._authorId = value;
  }
  get ip(): string {
    return this._ip;
  }
  set ip(value: string) {
    this._ip = value;
  }
  get text(): string {
    return this._text;
  }
  set text(value: string) {
    this._text = value;
  }
  get vote(): number {
    return this._vote;
  }
  set vote(value: number) {
    this._vote = value;
  }
  get preview(): string {
    return this._preview;
  }
  set preview(value: string) {
    this._preview = value;
  }
  get route(): string[] {
    return this._route;
  }
  set route(value: string[]) {
    this._route = value;
  }
  get userVote(): number {
    return this._userVote;
  }
  set userVote(value: number) {
    this._userVote = value;
  }
  get replies(): APICommentsMessage[] | undefined {
    return this._replies;
  }
  set replies(value: APICommentsMessage[] | undefined) {
    this._replies = value;
  }
  get pictureStatus(): PictureStatus {
    return this._pictureStatus;
  }
  set pictureStatus(value: PictureStatus) {
    this._pictureStatus = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APICommentsMessage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APICommentsMessage.AsObject {
    return {
      id: this.id,
      typeId: this.typeId,
      itemId: this.itemId,
      parentId: this.parentId,
      createdAt: this.createdAt ? this.createdAt.toObject() : undefined,
      deleted: this.deleted,
      moderatorAttention: this.moderatorAttention,
      isNew: this.isNew,
      authorId: this.authorId,
      ip: this.ip,
      text: this.text,
      vote: this.vote,
      preview: this.preview,
      route: (this.route || []).slice(),
      userVote: this.userVote,
      replies: (this.replies || []).map(m => m.toObject()),
      pictureStatus: this.pictureStatus
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APICommentsMessage.AsProtobufJSON {
    return {
      id: this.id,
      typeId:
        CommentsType[
          this.typeId === null || this.typeId === undefined ? 0 : this.typeId
        ],
      itemId: this.itemId,
      parentId: this.parentId,
      createdAt: this.createdAt ? this.createdAt.toProtobufJSON(options) : null,
      deleted: this.deleted,
      moderatorAttention:
        ModeratorAttention[
          this.moderatorAttention === null ||
          this.moderatorAttention === undefined
            ? 0
            : this.moderatorAttention
        ],
      isNew: this.isNew,
      authorId: this.authorId,
      ip: this.ip,
      text: this.text,
      vote: this.vote,
      preview: this.preview,
      route: (this.route || []).slice(),
      userVote: this.userVote,
      replies: (this.replies || []).map(m => m.toProtobufJSON(options)),
      pictureStatus:
        PictureStatus[
          this.pictureStatus === null || this.pictureStatus === undefined
            ? 0
            : this.pictureStatus
        ]
    };
  }
}
export module APICommentsMessage {
  /**
   * Standard JavaScript object representation for APICommentsMessage
   */
  export interface AsObject {
    id: string;
    typeId: CommentsType;
    itemId: string;
    parentId: string;
    createdAt?: googleProtobuf006.Timestamp.AsObject;
    deleted: boolean;
    moderatorAttention: ModeratorAttention;
    isNew: boolean;
    authorId: string;
    ip: string;
    text: string;
    vote: number;
    preview: string;
    route: string[];
    userVote: number;
    replies?: APICommentsMessage.AsObject[];
    pictureStatus: PictureStatus;
  }

  /**
   * Protobuf JSON representation for APICommentsMessage
   */
  export interface AsProtobufJSON {
    id: string;
    typeId: string;
    itemId: string;
    parentId: string;
    createdAt: googleProtobuf006.Timestamp.AsProtobufJSON | null;
    deleted: boolean;
    moderatorAttention: string;
    isNew: boolean;
    authorId: string;
    ip: string;
    text: string;
    vote: number;
    preview: string;
    route: string[];
    userVote: number;
    replies: APICommentsMessage.AsProtobufJSON[] | null;
    pictureStatus: string;
  }
}

/**
 * Message implementation for goautowp.AddCommentResponse
 */
export class AddCommentResponse implements GrpcMessage {
  static id = 'goautowp.AddCommentResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AddCommentResponse();
    AddCommentResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AddCommentResponse) {
    _instance.id = _instance.id || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AddCommentResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    AddCommentResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AddCommentResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
  }

  private _id: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AddCommentResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<AddCommentResponse.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    AddCommentResponse.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AddCommentResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AddCommentResponse.AsObject {
    return {
      id: this.id
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AddCommentResponse.AsProtobufJSON {
    return {
      id: this.id
    };
  }
}
export module AddCommentResponse {
  /**
   * Standard JavaScript object representation for AddCommentResponse
   */
  export interface AsObject {
    id: string;
  }

  /**
   * Protobuf JSON representation for AddCommentResponse
   */
  export interface AsProtobufJSON {
    id: string;
  }
}

/**
 * Message implementation for goautowp.APIGetTextRequest
 */
export class APIGetTextRequest implements GrpcMessage {
  static id = 'goautowp.APIGetTextRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIGetTextRequest();
    APIGetTextRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIGetTextRequest) {
    _instance.id = _instance.id || '0';
    _instance.revision = _instance.revision || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIGetTextRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt64String();
          break;
        case 2:
          _instance.revision = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    APIGetTextRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIGetTextRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt64String(1, _instance.id);
    }
    if (_instance.revision) {
      _writer.writeInt64String(2, _instance.revision);
    }
  }

  private _id: string;
  private _revision: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIGetTextRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIGetTextRequest.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.revision = _value.revision;
    APIGetTextRequest.refineValues(this);
  }
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
  }
  get revision(): string {
    return this._revision;
  }
  set revision(value: string) {
    this._revision = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIGetTextRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIGetTextRequest.AsObject {
    return {
      id: this.id,
      revision: this.revision
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIGetTextRequest.AsProtobufJSON {
    return {
      id: this.id,
      revision: this.revision
    };
  }
}
export module APIGetTextRequest {
  /**
   * Standard JavaScript object representation for APIGetTextRequest
   */
  export interface AsObject {
    id: string;
    revision: string;
  }

  /**
   * Protobuf JSON representation for APIGetTextRequest
   */
  export interface AsProtobufJSON {
    id: string;
    revision: string;
  }
}

/**
 * Message implementation for goautowp.TextRevision
 */
export class TextRevision implements GrpcMessage {
  static id = 'goautowp.TextRevision';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new TextRevision();
    TextRevision.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: TextRevision) {
    _instance.text = _instance.text || '';
    _instance.revision = _instance.revision || '0';
    _instance.userId = _instance.userId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: TextRevision,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.text = _reader.readString();
          break;
        case 2:
          _instance.revision = _reader.readInt64String();
          break;
        case 3:
          _instance.userId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    TextRevision.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: TextRevision,
    _writer: BinaryWriter
  ) {
    if (_instance.text) {
      _writer.writeString(1, _instance.text);
    }
    if (_instance.revision) {
      _writer.writeInt64String(2, _instance.revision);
    }
    if (_instance.userId) {
      _writer.writeInt64String(3, _instance.userId);
    }
  }

  private _text: string;
  private _revision: string;
  private _userId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of TextRevision to deeply clone from
   */
  constructor(_value?: RecursivePartial<TextRevision.AsObject>) {
    _value = _value || {};
    this.text = _value.text;
    this.revision = _value.revision;
    this.userId = _value.userId;
    TextRevision.refineValues(this);
  }
  get text(): string {
    return this._text;
  }
  set text(value: string) {
    this._text = value;
  }
  get revision(): string {
    return this._revision;
  }
  set revision(value: string) {
    this._revision = value;
  }
  get userId(): string {
    return this._userId;
  }
  set userId(value: string) {
    this._userId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    TextRevision.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): TextRevision.AsObject {
    return {
      text: this.text,
      revision: this.revision,
      userId: this.userId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): TextRevision.AsProtobufJSON {
    return {
      text: this.text,
      revision: this.revision,
      userId: this.userId
    };
  }
}
export module TextRevision {
  /**
   * Standard JavaScript object representation for TextRevision
   */
  export interface AsObject {
    text: string;
    revision: string;
    userId: string;
  }

  /**
   * Protobuf JSON representation for TextRevision
   */
  export interface AsProtobufJSON {
    text: string;
    revision: string;
    userId: string;
  }
}

/**
 * Message implementation for goautowp.APIGetTextResponse
 */
export class APIGetTextResponse implements GrpcMessage {
  static id = 'goautowp.APIGetTextResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new APIGetTextResponse();
    APIGetTextResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: APIGetTextResponse) {
    _instance.current = _instance.current || undefined;
    _instance.prev = _instance.prev || undefined;
    _instance.next = _instance.next || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: APIGetTextResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.current = new TextRevision();
          _reader.readMessage(
            _instance.current,
            TextRevision.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.prev = new TextRevision();
          _reader.readMessage(
            _instance.prev,
            TextRevision.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.next = new TextRevision();
          _reader.readMessage(
            _instance.next,
            TextRevision.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    APIGetTextResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: APIGetTextResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.current) {
      _writer.writeMessage(
        1,
        _instance.current as any,
        TextRevision.serializeBinaryToWriter
      );
    }
    if (_instance.prev) {
      _writer.writeMessage(
        2,
        _instance.prev as any,
        TextRevision.serializeBinaryToWriter
      );
    }
    if (_instance.next) {
      _writer.writeMessage(
        3,
        _instance.next as any,
        TextRevision.serializeBinaryToWriter
      );
    }
  }

  private _current?: TextRevision;
  private _prev?: TextRevision;
  private _next?: TextRevision;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of APIGetTextResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<APIGetTextResponse.AsObject>) {
    _value = _value || {};
    this.current = _value.current
      ? new TextRevision(_value.current)
      : undefined;
    this.prev = _value.prev ? new TextRevision(_value.prev) : undefined;
    this.next = _value.next ? new TextRevision(_value.next) : undefined;
    APIGetTextResponse.refineValues(this);
  }
  get current(): TextRevision | undefined {
    return this._current;
  }
  set current(value: TextRevision | undefined) {
    this._current = value;
  }
  get prev(): TextRevision | undefined {
    return this._prev;
  }
  set prev(value: TextRevision | undefined) {
    this._prev = value;
  }
  get next(): TextRevision | undefined {
    return this._next;
  }
  set next(value: TextRevision | undefined) {
    this._next = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    APIGetTextResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): APIGetTextResponse.AsObject {
    return {
      current: this.current ? this.current.toObject() : undefined,
      prev: this.prev ? this.prev.toObject() : undefined,
      next: this.next ? this.next.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): APIGetTextResponse.AsProtobufJSON {
    return {
      current: this.current ? this.current.toProtobufJSON(options) : null,
      prev: this.prev ? this.prev.toProtobufJSON(options) : null,
      next: this.next ? this.next.toProtobufJSON(options) : null
    };
  }
}
export module APIGetTextResponse {
  /**
   * Standard JavaScript object representation for APIGetTextResponse
   */
  export interface AsObject {
    current?: TextRevision.AsObject;
    prev?: TextRevision.AsObject;
    next?: TextRevision.AsObject;
  }

  /**
   * Protobuf JSON representation for APIGetTextResponse
   */
  export interface AsProtobufJSON {
    current: TextRevision.AsProtobufJSON | null;
    prev: TextRevision.AsProtobufJSON | null;
    next: TextRevision.AsProtobufJSON | null;
  }
}
